(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './androidx-collection-collection.js', './kotlinx-atomicfu.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./androidx-collection-collection.js'), require('./kotlinx-atomicfu.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-compose-runtime-runtime'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'androidx-compose-runtime-runtime'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'androidx-compose-runtime-runtime'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'androidx-compose-runtime-runtime'.");
    }
    globalThis['androidx-compose-runtime-runtime'] = factory(typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined' ? {} : globalThis['androidx-compose-runtime-runtime'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core'], globalThis['androidx-collection-collection'], globalThis['kotlinx-atomicfu']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_androidx_collection_collection, kotlin_org_jetbrains_kotlinx_atomicfu) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var clz32 = Math.clz32;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var Companion_instance = kotlin_kotlin.$_$.j3;
  var createFailure = kotlin_kotlin.$_$.ko;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var intercepted = kotlin_kotlin.$_$.jd;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q2;
  var get = kotlin_kotlin.$_$.td;
  var fold = kotlin_kotlin.$_$.sd;
  var minusKey = kotlin_kotlin.$_$.ud;
  var plus = kotlin_kotlin.$_$.wd;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var IllegalStateException = kotlin_kotlin.$_$.in;
  var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.t5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var defineProp = kotlin_kotlin.$_$.pf;
  var Enum = kotlin_kotlin.$_$.en;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var emptyList = kotlin_kotlin.$_$.c9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var invert = kotlin_kotlin.$_$.qe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var Long = kotlin_kotlin.$_$.kn;
  var compare = kotlin_kotlin.$_$.je;
  var to = kotlin_kotlin.$_$.ip;
  var MutableScatterSet = kotlin_androidx_collection_collection.$_$.o;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var plus_0 = kotlin_kotlin.$_$.ib;
  var plus_1 = kotlin_kotlin.$_$.jb;
  var isArray = kotlin_kotlin.$_$.jg;
  var KtSet = kotlin_kotlin.$_$.n7;
  var emptySet = kotlin_kotlin.$_$.e9;
  var plus_2 = kotlin_kotlin.$_$.db;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var KtMap = kotlin_kotlin.$_$.g7;
  var emptyObjectIntMap = kotlin_androidx_collection_collection.$_$.s;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var MutableObjectIntMap = kotlin_androidx_collection_collection.$_$.l;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l3;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f;
  var Element = kotlin_kotlin.$_$.vd;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c3;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var Key_instance_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var AbstractCoroutineContextElement = kotlin_kotlin.$_$.md;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var cancel_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j3;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var fromInt = kotlin_kotlin.$_$.pe;
  var MutableIntObjectMap = kotlin_androidx_collection_collection.$_$.g;
  var rotateLeft = kotlin_kotlin.$_$.xo;
  var bitwiseXor = kotlin_kotlin.$_$.ie;
  var mutableScatterSetOf = kotlin_androidx_collection_collection.$_$.l1;
  var fill = kotlin_kotlin.$_$.f9;
  var MutableIntIntMap = kotlin_androidx_collection_collection.$_$.e;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.g4;
  var get_lastIndex = kotlin_kotlin.$_$.fa;
  var sortWith = kotlin_kotlin.$_$.wb;
  var lazy = kotlin_kotlin.$_$.to;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var mutableScatterSetOf_0 = kotlin_androidx_collection_collection.$_$.k1;
  var MutableScatterMap = kotlin_androidx_collection_collection.$_$.n;
  var compareTo = kotlin_kotlin.$_$.nf;
  var Comparator = kotlin_kotlin.$_$.bn;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.n1;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.o1;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var MutableCollection = kotlin_kotlin.$_$.h7;
  var ScatterSet = kotlin_androidx_collection_collection.$_$.q;
  var divide = kotlin_kotlin.$_$.ne;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var emptyScatterSet = kotlin_androidx_collection_collection.$_$.v;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var Exception = kotlin_kotlin.$_$.gn;
  var MutableIntList = kotlin_androidx_collection_collection.$_$.f;
  var MutableObjectList = kotlin_androidx_collection_collection.$_$.m;
  var sequence = kotlin_kotlin.$_$.hj;
  var SequenceScope = kotlin_kotlin.$_$.aj;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var RuntimeException = kotlin_kotlin.$_$.rn;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.f6;
  var toList = kotlin_kotlin.$_$.ij;
  var takeLast = kotlin_kotlin.$_$.cc;
  var joinToString = kotlin_kotlin.$_$.aa;
  var trimMargin = kotlin_kotlin.$_$.lm;
  var fill_0 = kotlin_kotlin.$_$.i9;
  var get_ONE = kotlin_kotlin.$_$.ee;
  var add = kotlin_kotlin.$_$.fe;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.s4;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.b4;
  var withContext = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a1;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.c4;
  var addAll = kotlin_kotlin.$_$.o7;
  var toList_0 = kotlin_kotlin.$_$.kc;
  var emptyObjectList = kotlin_androidx_collection_collection.$_$.t;
  var MutableStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s1;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var addSuppressed = kotlin_kotlin.$_$.eo;
  var get_job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p3;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var returnIfSuspended = kotlin_kotlin.$_$.w3;
  var mutableScatterMapOf = kotlin_androidx_collection_collection.$_$.j1;
  var flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d2;
  var contains = kotlin_kotlin.$_$.c8;
  var ChannelResult = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g1;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var Channel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var toList_1 = kotlin_kotlin.$_$.lc;
  var copyOf = kotlin_kotlin.$_$.w8;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.d6;
  var compareValues = kotlin_kotlin.$_$.ad;
  var KtMutableList = kotlin_kotlin.$_$.i7;
  var mutableObjectListOf = kotlin_androidx_collection_collection.$_$.h1;
  var objectListOf = kotlin_androidx_collection_collection.$_$.m1;
  var ObjectList = kotlin_androidx_collection_collection.$_$.p;
  var until = kotlin_kotlin.$_$.mi;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var checkIndexOverflow = kotlin_kotlin.$_$.a8;
  var sortWith_0 = kotlin_kotlin.$_$.xb;
  var RandomAccess = kotlin_kotlin.$_$.m7;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var numberRangeToNumber = kotlin_kotlin.$_$.yg;
  var iterator = kotlin_kotlin.$_$.ej;
  var Collection = kotlin_kotlin.$_$.y6;
  var anyToString = kotlin_kotlin.$_$.df;
  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.d4;
  var emptyScatterMap = kotlin_androidx_collection_collection.$_$.u;
  var countOneBits = kotlin_kotlin.$_$.io;
  var mutableIntSetOf = kotlin_androidx_collection_collection.$_$.c1;
  var copyOf_0 = kotlin_kotlin.$_$.p8;
  var shiftRightUnsigned = kotlin_kotlin.$_$.ye;
  var countTrailingZeroBits = kotlin_kotlin.$_$.jo;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var MutableIntSet = kotlin_androidx_collection_collection.$_$.h;
  var ConcurrentModificationException_init_$Create$ = kotlin_kotlin.$_$.a5;
  var longArray = kotlin_kotlin.$_$.wg;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var lastOrNull = kotlin_kotlin.$_$.ka;
  var first = kotlin_kotlin.$_$.o9;
  var drop = kotlin_kotlin.$_$.b9;
  var listOf = kotlin_kotlin.$_$.sa;
  var coerceAtMost = kotlin_kotlin.$_$.bi;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var convertToInt = kotlin_kotlin.$_$.le;
  var mutableIntIntMapOf = kotlin_androidx_collection_collection.$_$.y;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var getProgressionLastElement = kotlin_kotlin.$_$.be;
  var mutableIntObjectMapOf = kotlin_androidx_collection_collection.$_$.b1;
  var AbstractList = kotlin_kotlin.$_$.q6;
  var KtList = kotlin_kotlin.$_$.e7;
  var NoSuchElementException_init_$Create$_0 = kotlin_kotlin.$_$.b6;
  var copyOf_1 = kotlin_kotlin.$_$.v8;
  var arrayIterator = kotlin_kotlin.$_$.ef;
  var AbstractMutableList = kotlin_kotlin.$_$.t6;
  var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$_$.u5;
  var indexOf = kotlin_kotlin.$_$.v9;
  var AbstractMap = kotlin_kotlin.$_$.r6;
  var AbstractMutableMap = kotlin_kotlin.$_$.u6;
  var KtMutableMap = kotlin_kotlin.$_$.k7;
  var MutableEntry = kotlin_kotlin.$_$.j7;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.n6;
  var AbstractMutableSet = kotlin_kotlin.$_$.v6;
  var KtMutableSet = kotlin_kotlin.$_$.l7;
  var AbstractMutableCollection = kotlin_kotlin.$_$.s6;
  var Entry = kotlin_kotlin.$_$.f7;
  var AbstractSet = kotlin_kotlin.$_$.w6;
  var AbstractCollection = kotlin_kotlin.$_$.p6;
  var step = kotlin_kotlin.$_$.li;
  var takeLowestOneBit = kotlin_kotlin.$_$.ap;
  var ConcurrentModificationException_init_$Create$_0 = kotlin_kotlin.$_$.b5;
  var toString_1 = kotlin_kotlin.$_$.cm;
  var subtract = kotlin_kotlin.$_$.af;
  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.f4;
  var Char = kotlin_kotlin.$_$.ym;
  var isCharSequence = kotlin_kotlin.$_$.ng;
  var minus = kotlin_kotlin.$_$.za;
  var toNumber = kotlin_kotlin.$_$.bf;
  var primitiveArrayConcat = kotlin_kotlin.$_$.c;
  var doubleArrayIterator = kotlin_kotlin.$_$.qf;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var listOf_0 = kotlin_kotlin.$_$.ta;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var get_suppressedExceptions = kotlin_kotlin.$_$.zo;
  var asReversed = kotlin_kotlin.$_$.u7;
  var removeLastOrNull = kotlin_kotlin.$_$.nb;
  var contains_0 = kotlin_kotlin.$_$.d8;
  var startsWith = kotlin_kotlin.$_$.dl;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var toString_2 = kotlin_kotlin.$_$.y;
  var substring = kotlin_kotlin.$_$.pl;
  var substring_0 = kotlin_kotlin.$_$.ol;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var toIntOrNull = kotlin_kotlin.$_$.xl;
  var contains_1 = kotlin_kotlin.$_$.oj;
  var toInt = kotlin_kotlin.$_$.yl;
  var isLetter = kotlin_kotlin.$_$.gk;
  var replaceFirst = kotlin_kotlin.$_$.vk;
  var MutableDoubleList = kotlin_androidx_collection_collection.$_$.d;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var atomic$int$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.e;
  var CancellationException_init_$Init$ = kotlin_kotlin.$_$.p4;
  var println = kotlin_kotlin.$_$.de;
  var stackTraceToString = kotlin_kotlin.$_$.yo;
  var RuntimeException_init_$Init$_0 = kotlin_kotlin.$_$.h6;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(Anchor, 'Anchor');
  function onBeginChanges() {
  }
  function onEndChanges() {
  }
  function apply(block, value) {
    block(this.e2y(), value);
  }
  function reuse() {
    var tmp = this.e2y();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, ComposeNodeLifecycleCallback) : false) ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p2y();
    }
  }
  initMetadataForInterface(Applier, 'Applier');
  initMetadataForClass(AbstractApplier, 'AbstractApplier', VOID, VOID, [Applier]);
  initMetadataForObject(ThrowingApplierStub, 'ThrowingApplierStub', VOID, VOID, [Applier]);
  initMetadataForClass(OffsetApplier, 'OffsetApplier', VOID, VOID, [Applier]);
  initMetadataForClass(Awaiter, 'Awaiter');
  initMetadataForClass(FrameAwaiter, 'FrameAwaiter', VOID, Awaiter);
  function get_key() {
    return Key_instance_2;
  }
  initMetadataForInterface(MonotonicFrameClock, 'MonotonicFrameClock', VOID, VOID, [Element], [1]);
  initMetadataForClass(BroadcastFrameClock, 'BroadcastFrameClock', BroadcastFrameClock, VOID, [MonotonicFrameClock], [1]);
  initMetadataForInterface(CancellationHandle, 'CancellationHandle');
  initMetadataForClass(sam$androidx_compose_runtime_CancellationHandle$0, 'sam$androidx_compose_runtime_CancellationHandle$0', VOID, VOID, [CancellationHandle, FunctionAdapter]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(OneShotCancellationHandle, 'OneShotCancellationHandle', VOID, VOID, [CancellationHandle]);
  initMetadataForInterface(ComposeNodeLifecycleCallback, 'ComposeNodeLifecycleCallback');
  initMetadataForObject(ComposeRuntimeFlags, 'ComposeRuntimeFlags');
  initMetadataForClass(Composer$Companion$Empty$1);
  initMetadataForCompanion(Companion_0);
  function changed(value) {
    return this.l31(value);
  }
  function changed_0(value) {
    return this.m31(value);
  }
  function changed_1(value) {
    return this.n31(value);
  }
  function changed_2(value) {
    return this.o31(value);
  }
  function changed_3(value) {
    return this.p31(value);
  }
  function changedInstance(value) {
    return this.k31(value);
  }
  initMetadataForInterface(Composer, 'Composer');
  initMetadataForClass(ProvidedValue, 'ProvidedValue');
  initMetadataForClass(ComposeRuntimeError, 'ComposeRuntimeError', VOID, IllegalStateException);
  initMetadataForClass(InternalComposer, 'InternalComposer', VOID, VOID, [Composer]);
  initMetadataForInterface(RememberObserverHolder, 'RememberObserverHolder');
  initMetadataForClass(InvalidationResult, 'InvalidationResult', VOID, Enum);
  initMetadataForInterface(ReusableRememberObserverHolder, 'ReusableRememberObserverHolder', VOID, VOID, [RememberObserverHolder]);
  initMetadataForInterface(RecomposeScopeOwner, 'RecomposeScopeOwner');
  initMetadataForClass(extractMovableContentAtCurrent$movableContentRecomposeScopeOwner$1, VOID, VOID, VOID, [RecomposeScopeOwner]);
  initMetadataForInterface(PausableComposition, 'PausableComposition');
  initMetadataForInterface(ObservableComposition, 'ObservableComposition');
  initMetadataForClass(CompositionImpl, 'CompositionImpl', VOID, VOID, [RecomposeScopeOwner, PausableComposition, ObservableComposition]);
  initMetadataForClass(SlotStorage, 'SlotStorage');
  initMetadataForClass(DebugStringFormattable, 'DebugStringFormattable');
  initMetadataForClass(Changes, 'Changes', VOID, DebugStringFormattable);
  initMetadataForClass(CompositionObserverHolder, 'CompositionObserverHolder');
  initMetadataForObject(ComposableSingletons$CompositionKt, 'ComposableSingletons$CompositionKt');
  initMetadataForObject(ScopeInvalidated, 'ScopeInvalidated');
  initMetadataForClass(ObservableCompositionServiceKey$1);
  initMetadataForClass(CompositionContext, 'CompositionContext');
  initMetadataForClass(CompositionLocal, 'CompositionLocal');
  initMetadataForClass(ProvidableCompositionLocal, 'ProvidableCompositionLocal', VOID, CompositionLocal);
  initMetadataForClass(CompositionLocalContext, 'CompositionLocalContext');
  initMetadataForClass(DynamicProvidableCompositionLocal, 'DynamicProvidableCompositionLocal', VOID, ProvidableCompositionLocal);
  initMetadataForClass(StaticProvidableCompositionLocal, 'StaticProvidableCompositionLocal', VOID, ProvidableCompositionLocal);
  initMetadataForClass(ComputedProvidableCompositionLocal, 'ComputedProvidableCompositionLocal', VOID, ProvidableCompositionLocal);
  initMetadataForCompanion(Companion_1);
  function get_currentValue(_this__u8e3s4) {
    return read(this, _this__u8e3s4);
  }
  initMetadataForInterface(PersistentCompositionLocalMap, 'PersistentCompositionLocalMap', VOID, VOID, [KtMap]);
  initMetadataForInterface(DerivedState, 'DerivedState');
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(StateRecord, 'StateRecord');
  initMetadataForClass(ResultRecord, 'ResultRecord', VOID, StateRecord);
  function mergeRecords(previous, current, applied) {
    return null;
  }
  initMetadataForInterface(StateObject, 'StateObject');
  initMetadataForClass(StateObjectImpl, 'StateObjectImpl', VOID, VOID, [StateObject]);
  initMetadataForClass(DerivedSnapshotState, 'DerivedSnapshotState', VOID, StateObjectImpl, [DerivedState]);
  initMetadataForClass(DisposableEffectScope, 'DisposableEffectScope', DisposableEffectScope);
  initMetadataForInterface(RememberObserver, 'RememberObserver');
  initMetadataForClass(LaunchedEffectImpl, 'LaunchedEffectImpl', VOID, VOID, [RememberObserver, Element]);
  initMetadataForClass(DisposableEffectImpl, 'DisposableEffectImpl', VOID, VOID, [RememberObserver]);
  initMetadataForClass(TracingContext, 'TracingContext', VOID, VOID, [Element]);
  initMetadataForObject(LaunchedEffectTracingContext, 'LaunchedEffectTracingContext', VOID, TracingContext);
  initMetadataForClass(PlatformOptimizedCancellationException, 'PlatformOptimizedCancellationException', VOID, CancellationException);
  initMetadataForClass(LeftCompositionCancellationException, 'LeftCompositionCancellationException', LeftCompositionCancellationException, PlatformOptimizedCancellationException);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(RememberedCoroutineScope$coroutineContext$$inlined$CoroutineExceptionHandler$1, VOID, VOID, AbstractCoroutineContextElement, [Element]);
  initMetadataForClass(RememberedCoroutineScope, 'RememberedCoroutineScope', VOID, VOID, [CoroutineScope_0, RememberObserver]);
  initMetadataForClass(ForgottenCoroutineScopeException, 'ForgottenCoroutineScopeException', ForgottenCoroutineScopeException, PlatformOptimizedCancellationException);
  initMetadataForObject(RememberedCoroutineScopeTracingContext, 'RememberedCoroutineScopeTracingContext', VOID, TracingContext);
  initMetadataForObject(Key, 'Key');
  initMetadataForClass(CancelledCoroutineContext, 'CancelledCoroutineContext', CancelledCoroutineContext, VOID, [Element]);
  initMetadataForClass(CompositionContextHolder, 'CompositionContextHolder', VOID, VOID, [RememberObserver]);
  initMetadataForClass(CompositionContextImpl, 'CompositionContextImpl', VOID, CompositionContext);
  initMetadataForClass(GapComposer$derivedStateObserver$1);
  initMetadataForClass(GapComposer, 'GapComposer', VOID, InternalComposer);
  initMetadataForClass(Invalidation, 'Invalidation');
  initMetadataForClass(GapPending, 'GapPending');
  initMetadataForClass(GapRememberObserverHolder, 'GapRememberObserverHolder', VOID, VOID, [RememberObserverHolder]);
  initMetadataForClass(GapCompositionDataImpl, 'GapCompositionDataImpl');
  initMetadataForClass(ReusableGapRememberObserverHolder, 'ReusableGapRememberObserverHolder', VOID, GapRememberObserverHolder, [ReusableRememberObserverHolder]);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(JoinedKey, 'JoinedKey');
  initMetadataForClass(CompositionContextImpl_0, 'CompositionContextImpl', VOID, CompositionContext);
  initMetadataForClass(CompositionContextHolder_0, 'CompositionContextHolder', VOID, VOID, [RememberObserver]);
  initMetadataForClass(LinkComposer$derivedStateObserver$1);
  initMetadataForClass(LinkComposer, 'LinkComposer', VOID, InternalComposer);
  initMetadataForClass(LinkPending, 'LinkPending');
  initMetadataForClass(LinkRememberObserverHolder, 'LinkRememberObserverHolder', VOID, VOID, [RememberObserverHolder]);
  initMetadataForClass(ReusableLinkRememberObserverHolder, 'ReusableLinkRememberObserverHolder', VOID, LinkRememberObserverHolder, [ReusableRememberObserverHolder]);
  initMetadataForClass(LinkCompositionDataImpl, 'LinkCompositionDataImpl');
  initMetadataForObject(Key_0, 'Key');
  initMetadataForCoroutine($withFrameMillisCOROUTINE$, CoroutineImpl);
  initMetadataForClass(MovableContent, 'MovableContent');
  initMetadataForClass(MovableContentStateReference, 'MovableContentStateReference');
  initMetadataForClass(MovableContentState, 'MovableContentState');
  initMetadataForClass(NextFrameEndCallbackQueue, 'NextFrameEndCallbackQueue');
  initMetadataForClass(OpaqueKey, 'OpaqueKey');
  initMetadataForInterface(ShouldPauseCallback, 'ShouldPauseCallback');
  initMetadataForClass(PausedCompositionImpl, 'PausedCompositionImpl');
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(RecordingApplier, 'RecordingApplier', VOID, VOID, [Applier]);
  initMetadataForClass(PausedCompositionState, 'PausedCompositionState', VOID, Enum);
  initMetadataForLambda(ComposePausableCompositionException$operationsSequence$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ComposePausableCompositionException, 'ComposePausableCompositionException', VOID, RuntimeException);
  initMetadataForInterface(MutableState, 'MutableState');
  initMetadataForInterface(ProduceStateScope, 'ProduceStateScope', VOID, VOID, [MutableState, CoroutineScope_0], [1]);
  initMetadataForClass(ProduceStateScopeImpl, 'ProduceStateScopeImpl', VOID, VOID, [ProduceStateScope, MutableState], [1]);
  initMetadataForLambda(produceState$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(produceState$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForInterface(RecomposeScope, 'RecomposeScope');
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(RecomposeScopeImpl, 'RecomposeScopeImpl', VOID, VOID, [RecomposeScope]);
  initMetadataForLambda(Recomposer$recompositionRunner$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(State, 'State', VOID, Enum);
  initMetadataForClass(RecomposerInfoImpl, 'RecomposerInfoImpl');
  initMetadataForClass(RecomposerErrorState, 'RecomposerErrorState');
  initMetadataForCompanion(Companion_6);
  initMetadataForLambda(Recomposer$runRecomposeAndApplyChanges$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(Recomposer$recompositionRunner$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($awaitWorkAvailableCOROUTINE$, CoroutineImpl);
  initMetadataForClass(Recomposer, 'Recomposer', VOID, CompositionContext, VOID, [0, 1]);
  initMetadataForClass(NestedContentMap, 'NestedContentMap', NestedContentMap);
  initMetadataForClass(NestedMovableContent, 'NestedMovableContent');
  function set_value(value) {
    this.i45(value);
  }
  function get_value() {
    return this.j45();
  }
  initMetadataForInterface(MutableFloatState, 'MutableFloatState', VOID, VOID, [MutableState]);
  initMetadataForClass(FloatStateStateRecord, 'FloatStateStateRecord', VOID, StateRecord);
  initMetadataForInterface(SnapshotMutableState, 'SnapshotMutableState', VOID, VOID, [MutableState]);
  initMetadataForClass(SnapshotMutableFloatStateImpl, 'SnapshotMutableFloatStateImpl', VOID, StateObjectImpl, [MutableFloatState, SnapshotMutableState]);
  initMetadataForClass(SnapshotFlowManager, 'SnapshotFlowManager', SnapshotFlowManager);
  initMetadataForClass(SnapshotFlowManagerImpl, 'SnapshotFlowManagerImpl');
  initMetadataForClass(SingleSubscriptionSnapshotFlowManager, 'SingleSubscriptionSnapshotFlowManager', SingleSubscriptionSnapshotFlowManager, SnapshotFlowManagerImpl);
  initMetadataForClass(Add, 'Add');
  initMetadataForClass(RemoveScope, 'RemoveScope');
  initMetadataForClass(MultiSubscriptionSnapshotFlowManager, 'MultiSubscriptionSnapshotFlowManager', MultiSubscriptionSnapshotFlowManager, SnapshotFlowManagerImpl);
  initMetadataForLambda(snapshotFlowImpl$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(collectAsState$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(collectAsState$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(collectAsState$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(collectAsState$slambda, CoroutineImpl, VOID, [1]);
  function set_value_0(value) {
    this.a49(value);
  }
  function get_value_0() {
    return this.b49();
  }
  initMetadataForInterface(MutableIntState, 'MutableIntState', VOID, VOID, [MutableState]);
  initMetadataForClass(IntStateStateRecord, 'IntStateStateRecord', VOID, StateRecord);
  initMetadataForClass(SnapshotMutableIntStateImpl, 'SnapshotMutableIntStateImpl', VOID, StateObjectImpl, [MutableIntState, SnapshotMutableState]);
  function set_value_1(value) {
    this.i49(value);
  }
  function get_value_1() {
    return this.j49();
  }
  initMetadataForInterface(MutableLongState, 'MutableLongState', VOID, VOID, [MutableState]);
  initMetadataForClass(LongStateStateRecord, 'LongStateStateRecord', VOID, StateRecord);
  initMetadataForClass(SnapshotMutableLongStateImpl, 'SnapshotMutableLongStateImpl', VOID, StateObjectImpl, [MutableLongState, SnapshotMutableState]);
  function merge(previous, current, applied) {
    return null;
  }
  initMetadataForInterface(SnapshotMutationPolicy, 'SnapshotMutationPolicy');
  initMetadataForObject(StructuralEqualityPolicy, 'StructuralEqualityPolicy', VOID, VOID, [SnapshotMutationPolicy]);
  initMetadataForObject(NeverEqualPolicy, 'NeverEqualPolicy', VOID, VOID, [SnapshotMutationPolicy]);
  initMetadataForObject(ReferentialEqualityPolicy, 'ReferentialEqualityPolicy', VOID, VOID, [SnapshotMutationPolicy]);
  initMetadataForClass(StateStateRecord, 'StateStateRecord', VOID, StateRecord);
  initMetadataForClass(SnapshotMutableStateImpl, 'SnapshotMutableStateImpl', VOID, StateObjectImpl, [SnapshotMutableState]);
  initMetadataForClass(Stack, 'Stack');
  initMetadataForClass(IntStack, 'IntStack', IntStack);
  initMetadataForInterface(ValueHolder, 'ValueHolder');
  initMetadataForClass(DynamicValueHolder, 'DynamicValueHolder', VOID, VOID, [ValueHolder]);
  initMetadataForClass(StaticValueHolder, 'StaticValueHolder', VOID, VOID, [ValueHolder]);
  initMetadataForClass(ComputedValueHolder, 'ComputedValueHolder', VOID, VOID, [ValueHolder]);
  initMetadataForClass(LazyValueHolder, 'LazyValueHolder', VOID, VOID, [ValueHolder]);
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(MultiValueMap, 'MultiValueMap');
  initMetadataForClass(VectorListIterator, 'VectorListIterator');
  initMetadataForClass(MutableVectorList, 'MutableVectorList', VOID, VOID, [KtMutableList]);
  initMetadataForClass(SubList, 'SubList', VOID, VOID, [KtMutableList]);
  initMetadataForClass(MutableVector, 'MutableVector', VOID, VOID, [RandomAccess]);
  initMetadataForLambda(ScatterSetWrapper$iterator$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ScatterSetWrapper, 'ScatterSetWrapper', VOID, VOID, [KtSet]);
  initMetadataForClass(GroupInfo, 'GroupInfo');
  initMetadataForCompanion(Companion_7);
  initMetadataForInterface(GroupSourceInformation, 'GroupSourceInformation');
  initMetadataForObject(ThrowingRememberManagerStub, 'ThrowingRememberManagerStub');
  initMetadataForClass(GapAnchor, 'GapAnchor', VOID, VOID, [Anchor]);
  initMetadataForClass(SlotTable, 'SlotTable', SlotTable, SlotStorage);
  initMetadataForClass(SlotReader, 'SlotReader');
  initMetadataForCompanion(Companion_8);
  initMetadataForClass(SlotWriter, 'SlotWriter');
  initMetadataForClass(KeyInfo, 'KeyInfo');
  initMetadataForClass(BitVector, 'BitVector', BitVector);
  initMetadataForClass(GapGroupSourceInformation, 'GapGroupSourceInformation', VOID, VOID, [GroupSourceInformation]);
  initMetadataForClass(GroupIterator, 'GroupIterator');
  initMetadataForClass(SlotTableGroup, 'SlotTableGroup');
  initMetadataForClass(PrioritySet, 'PrioritySet');
  initMetadataForClass(SourceInformationGroupIterator, 'SourceInformationGroupIterator');
  initMetadataForClass(SourceInformationGroupPath, 'SourceInformationGroupPath');
  initMetadataForClass(AnchoredGroupPath, 'AnchoredGroupPath', VOID, SourceInformationGroupPath);
  initMetadataForClass(SourceInformationSlotTableGroup, 'SourceInformationSlotTableGroup');
  initMetadataForClass(RelativeGroupPath, 'RelativeGroupPath', VOID, SourceInformationGroupPath);
  initMetadataForClass(ChangeList, 'ChangeList', ChangeList, Changes);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(ComposerChangeListWriter, 'ComposerChangeListWriter');
  initMetadataForClass(OperationsDebugStringFormattable, 'OperationsDebugStringFormattable');
  initMetadataForClass(FixupList, 'FixupList', FixupList, OperationsDebugStringFormattable);
  initMetadataForClass(Operation, 'Operation');
  initMetadataForObject(Ups, 'Ups', VOID, Operation);
  initMetadataForObject(Downs, 'Downs', VOID, Operation);
  initMetadataForObject(AdvanceSlotsBy, 'AdvanceSlotsBy', VOID, Operation);
  initMetadataForObject(SideEffect_0, 'SideEffect', VOID, Operation);
  initMetadataForObject(Remember, 'Remember', VOID, Operation);
  initMetadataForObject(RememberPausingScope, 'RememberPausingScope', VOID, Operation);
  initMetadataForObject(StartResumingScope, 'StartResumingScope', VOID, Operation);
  initMetadataForObject(EndResumingScope, 'EndResumingScope', VOID, Operation);
  initMetadataForObject(AppendValue, 'AppendValue', VOID, Operation);
  initMetadataForObject(TrimParentValues, 'TrimParentValues', VOID, Operation);
  initMetadataForObject(UpdateValue, 'UpdateValue', VOID, Operation);
  initMetadataForObject(UpdateAnchoredValue, 'UpdateAnchoredValue', VOID, Operation);
  initMetadataForObject(UpdateAuxData, 'UpdateAuxData', VOID, Operation);
  initMetadataForObject(EnsureRootGroupStarted, 'EnsureRootGroupStarted', VOID, Operation);
  initMetadataForObject(EnsureGroupStarted, 'EnsureGroupStarted', VOID, Operation);
  initMetadataForObject(RemoveCurrentGroup, 'RemoveCurrentGroup', VOID, Operation);
  initMetadataForObject(MoveCurrentGroup, 'MoveCurrentGroup', VOID, Operation);
  initMetadataForObject(EndCurrentGroup, 'EndCurrentGroup', VOID, Operation);
  initMetadataForObject(SkipToEndOfCurrentGroup, 'SkipToEndOfCurrentGroup', VOID, Operation);
  initMetadataForObject(EndCompositionScope, 'EndCompositionScope', VOID, Operation);
  initMetadataForObject(UseCurrentNode, 'UseCurrentNode', VOID, Operation);
  initMetadataForObject(UpdateNode, 'UpdateNode', VOID, Operation);
  initMetadataForObject(RemoveNode, 'RemoveNode', VOID, Operation);
  initMetadataForObject(MoveNode, 'MoveNode', VOID, Operation);
  initMetadataForObject(InsertSlots, 'InsertSlots', VOID, Operation);
  initMetadataForObject(InsertSlotsWithFixups, 'InsertSlotsWithFixups', VOID, Operation);
  initMetadataForObject(InsertNodeFixup, 'InsertNodeFixup', VOID, Operation);
  initMetadataForObject(PostInsertNodeFixup, 'PostInsertNodeFixup', VOID, Operation);
  initMetadataForObject(DeactivateCurrentGroup, 'DeactivateCurrentGroup', VOID, Operation);
  initMetadataForObject(ResetSlots, 'ResetSlots', VOID, Operation);
  initMetadataForObject(DetermineMovableContentNodeIndex, 'DetermineMovableContentNodeIndex', VOID, Operation);
  initMetadataForObject(CopyNodesToNewAnchorLocation, 'CopyNodesToNewAnchorLocation', VOID, Operation);
  initMetadataForObject(CopySlotTableToAnchorLocation, 'CopySlotTableToAnchorLocation', VOID, Operation);
  initMetadataForObject(EndMovableContentPlacement, 'EndMovableContentPlacement', VOID, Operation);
  initMetadataForObject(ReleaseMovableGroupAtCurrent, 'ReleaseMovableGroupAtCurrent', VOID, Operation);
  initMetadataForObject(ApplyChangeList, 'ApplyChangeList', VOID, Operation);
  initMetadataForClass(withCurrentStackTrace$1);
  initMetadataForClass(OpIterator, 'OpIterator');
  initMetadataForClass(Operations, 'Operations', Operations, OperationsDebugStringFormattable);
  initMetadataForClass(KeyInfo_0, 'KeyInfo');
  initMetadataForClass(LinkAnchor, 'LinkAnchor', VOID, VOID, [Anchor]);
  initMetadataForClass(AnchorHandle, 'AnchorHandle');
  initMetadataForClass(LinkGroupSourceInformation, 'LinkGroupSourceInformation', VOID, VOID, [GroupSourceInformation]);
  initMetadataForCompanion(Companion_10);
  initMetadataForClass(SlotTable_0, 'SlotTable', SlotTable_0, SlotStorage);
  initMetadataForClass(SlotTableGroup_0, 'SlotTableGroup');
  initMetadataForClass(GroupIterator_0, 'GroupIterator');
  initMetadataForClass(SourceInformationGroupIterator_0, 'SourceInformationGroupIterator');
  initMetadataForClass(SourceInformationGroupPath_0, 'SourceInformationGroupPath');
  initMetadataForClass(AnchoredGroupPath_0, 'AnchoredGroupPath', VOID, SourceInformationGroupPath_0);
  initMetadataForClass(SourceInformationSlotTableGroup_0, 'SourceInformationSlotTableGroup');
  initMetadataForClass(RelativeGroupPath_0, 'RelativeGroupPath', VOID, SourceInformationGroupPath_0);
  initMetadataForInterface(VisitSlotsInRememberOrderCallback, 'VisitSlotsInRememberOrderCallback');
  initMetadataForClass(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0, 'sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0', VOID, VOID, [VisitSlotsInRememberOrderCallback, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_0, 'sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0', VOID, VOID, [VisitSlotsInRememberOrderCallback, FunctionAdapter]);
  initMetadataForClass(extractMovableContentAtCurrent$1, VOID, VOID, VOID, [RecomposeScopeOwner]);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(SlotTableAddressSpace, 'SlotTableAddressSpace', SlotTableAddressSpace_init_$Create$);
  initMetadataForClass(SlotMoveManager, 'SlotMoveManager');
  initMetadataForClass(Unallocated$1);
  initMetadataForClass(SlotTableBuilder, 'SlotTableBuilder');
  initMetadataForClass(ComposeStackTraceBuilder, 'ComposeStackTraceBuilder');
  initMetadataForClass(BuilderTraceBuilder, 'BuilderTraceBuilder', VOID, ComposeStackTraceBuilder);
  initMetadataForClass(SlotTableEditor, 'SlotTableEditor');
  initMetadataForClass(EditorTraceBuilder, 'EditorTraceBuilder', VOID, ComposeStackTraceBuilder);
  initMetadataForClass(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_1, 'sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0', VOID, VOID, [VisitSlotsInRememberOrderCallback, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_2, 'sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0', VOID, VOID, [VisitSlotsInRememberOrderCallback, FunctionAdapter]);
  initMetadataForClass(SlotTableReader, 'SlotTableReader');
  initMetadataForClass(ReaderTraceBuilder, 'ReaderTraceBuilder', VOID, ComposeStackTraceBuilder);
  initMetadataForClass(ChangeList_0, 'ChangeList', ChangeList_0, Changes);
  initMetadataForClass(ComposerChangeListWriter_0, 'ComposerChangeListWriter');
  initMetadataForClass(ComposerChangeListWriterAddressMode, 'ComposerChangeListWriterAddressMode', VOID, Enum);
  initMetadataForClass(FixupList_0, 'FixupList', FixupList_0, DebugStringFormattable);
  initMetadataForClass(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_3, 'sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0', VOID, VOID, [VisitSlotsInRememberOrderCallback, FunctionAdapter]);
  initMetadataForClass(Operation_0, 'Operation');
  initMetadataForObject(Ups_0, 'Ups', VOID, Operation_0);
  initMetadataForObject(Downs_0, 'Downs', VOID, Operation_0);
  initMetadataForObject(SeekToAnchor, 'SeekToAnchor', VOID, Operation_0);
  initMetadataForObject(SeekToGroupHandle, 'SeekToGroupHandle', VOID, Operation_0);
  initMetadataForObject(StartGroup, 'StartGroup', VOID, Operation_0);
  initMetadataForObject(SkipGroup, 'SkipGroup', VOID, Operation_0);
  initMetadataForObject(SideEffect_1, 'SideEffect', VOID, Operation_0);
  initMetadataForObject(Remember_0, 'Remember', VOID, Operation_0);
  initMetadataForObject(RememberPausingScope_0, 'RememberPausingScope', VOID, Operation_0);
  initMetadataForObject(StartResumingScope_0, 'StartResumingScope', VOID, Operation_0);
  initMetadataForObject(EndResumingScope_0, 'EndResumingScope', VOID, Operation_0);
  initMetadataForObject(AppendValue_0, 'AppendValue', VOID, Operation_0);
  initMetadataForObject(RemoveTailGroupsAndValues, 'RemoveTailGroupsAndValues', VOID, Operation_0);
  initMetadataForObject(UpdateRememberObserverHolderOrdering, 'UpdateRememberObserverHolderOrdering', VOID, Operation_0);
  initMetadataForObject(UpdateValueRelative, 'UpdateValueRelative', VOID, Operation_0);
  initMetadataForObject(UpdateAuxData_0, 'UpdateAuxData', VOID, Operation_0);
  initMetadataForObject(RemoveGroup, 'RemoveGroup', VOID, Operation_0);
  initMetadataForObject(MoveGroup, 'MoveGroup', VOID, Operation_0);
  initMetadataForObject(ClearAllRecompositionRequired, 'ClearAllRecompositionRequired', VOID, Operation_0);
  initMetadataForObject(EndCompositionScope_0, 'EndCompositionScope', VOID, Operation_0);
  initMetadataForObject(UseCurrentNode_0, 'UseCurrentNode', VOID, Operation_0);
  initMetadataForObject(UpdateNode_0, 'UpdateNode', VOID, Operation_0);
  initMetadataForObject(RemoveNode_0, 'RemoveNode', VOID, Operation_0);
  initMetadataForObject(MoveNode_0, 'MoveNode', VOID, Operation_0);
  initMetadataForObject(InsertSlots_0, 'InsertSlots', VOID, Operation_0);
  initMetadataForObject(InsertSlotsWithFixups_0, 'InsertSlotsWithFixups', VOID, Operation_0);
  initMetadataForObject(InsertNodeFixup_0, 'InsertNodeFixup', VOID, Operation_0);
  initMetadataForObject(InsertNodeFixupByAnchor, 'InsertNodeFixupByAnchor', VOID, Operation_0);
  initMetadataForObject(PostInsertNodeFixup_0, 'PostInsertNodeFixup', VOID, Operation_0);
  initMetadataForObject(PostInsertNodeFixupByAnchor, 'PostInsertNodeFixupByAnchor', VOID, Operation_0);
  initMetadataForObject(DeactivateGroup, 'DeactivateGroup', VOID, Operation_0);
  initMetadataForObject(ResetSlots_0, 'ResetSlots', VOID, Operation_0);
  initMetadataForObject(DetermineMovableContentNodeIndex_0, 'DetermineMovableContentNodeIndex', VOID, Operation_0);
  initMetadataForObject(CopyNodesToNewAnchorLocation_0, 'CopyNodesToNewAnchorLocation', VOID, Operation_0);
  initMetadataForObject(EndMovableContentPlacement_0, 'EndMovableContentPlacement', VOID, Operation_0);
  initMetadataForObject(CopySlotTableToHandleLocation, 'CopySlotTableToHandleLocation', VOID, Operation_0);
  initMetadataForObject(ReleaseMovableGroup, 'ReleaseMovableGroup', VOID, Operation_0);
  initMetadataForObject(DisposeMovableContentState, 'DisposeMovableContentState', VOID, Operation_0);
  initMetadataForObject(ApplyChangeList_0, 'ApplyChangeList', VOID, Operation_0);
  initMetadataForClass(withCurrentStackTrace$1_0);
  initMetadataForClass(releaseMovableGroup$movableContentRecomposeScopeOwner$1, VOID, VOID, VOID, [RecomposeScopeOwner]);
  initMetadataForClass(OpIterator_0, 'OpIterator');
  initMetadataForClass(Operations_0, 'Operations', Operations_0, DebugStringFormattable);
  function subList(fromIndex, toIndex) {
    return new SubList_0(this, fromIndex, toIndex);
  }
  initMetadataForInterface(ImmutableList, 'ImmutableList', VOID, VOID, [KtList, Collection]);
  initMetadataForClass(SubList_0, 'SubList', VOID, AbstractList, [ImmutableList]);
  initMetadataForClass(AbstractListIterator, 'AbstractListIterator');
  initMetadataForClass(SingleElementListIterator, 'SingleElementListIterator', VOID, AbstractListIterator);
  initMetadataForClass(AbstractPersistentList, 'AbstractPersistentList', VOID, AbstractList, [Collection, ImmutableList]);
  initMetadataForClass(BufferIterator, 'BufferIterator', VOID, AbstractListIterator);
  initMetadataForClass(PersistentVector, 'PersistentVector', VOID, AbstractPersistentList, [Collection, ImmutableList]);
  initMetadataForClass(PersistentVectorBuilder, 'PersistentVectorBuilder', VOID, AbstractMutableList, [KtMutableList, MutableCollection]);
  initMetadataForClass(PersistentVectorIterator, 'PersistentVectorIterator', VOID, AbstractListIterator);
  initMetadataForClass(PersistentVectorMutableIterator, 'PersistentVectorMutableIterator', VOID, AbstractListIterator);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(SmallPersistentVector, 'SmallPersistentVector', VOID, AbstractPersistentList, [ImmutableList]);
  initMetadataForClass(TrieIterator, 'TrieIterator', VOID, AbstractListIterator);
  initMetadataForClass(ObjectRef, 'ObjectRef');
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(PersistentHashMap, 'PersistentHashMap', VOID, AbstractMap, [KtMap]);
  initMetadataForClass(PersistentHashMapBuilder, 'PersistentHashMapBuilder', VOID, AbstractMutableMap, [KtMutableMap]);
  initMetadataForClass(PersistentHashMapBuilderEntriesIterator, 'PersistentHashMapBuilderEntriesIterator');
  initMetadataForClass(PersistentHashMapBaseIterator, 'PersistentHashMapBaseIterator');
  initMetadataForClass(PersistentHashMapBuilderBaseIterator, 'PersistentHashMapBuilderBaseIterator', VOID, PersistentHashMapBaseIterator);
  initMetadataForClass(PersistentHashMapBuilderKeysIterator, 'PersistentHashMapBuilderKeysIterator', VOID, PersistentHashMapBuilderBaseIterator);
  initMetadataForClass(PersistentHashMapBuilderValuesIterator, 'PersistentHashMapBuilderValuesIterator', VOID, PersistentHashMapBuilderBaseIterator);
  initMetadataForClass(TrieNodeBaseIterator, 'TrieNodeBaseIterator');
  initMetadataForClass(TrieNodeMutableEntriesIterator, 'TrieNodeMutableEntriesIterator', VOID, TrieNodeBaseIterator);
  initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
  initMetadataForClass(MutableMapEntry, 'MutableMapEntry', VOID, MapEntry, [MutableEntry]);
  initMetadataForClass(AbstractMapBuilderEntries, 'AbstractMapBuilderEntries', VOID, AbstractMutableSet);
  initMetadataForClass(PersistentHashMapBuilderEntries, 'PersistentHashMapBuilderEntries', VOID, AbstractMapBuilderEntries);
  initMetadataForClass(PersistentHashMapBuilderKeys, 'PersistentHashMapBuilderKeys', VOID, AbstractMutableSet, [KtMutableSet]);
  initMetadataForClass(PersistentHashMapBuilderValues, 'PersistentHashMapBuilderValues', VOID, AbstractMutableCollection, [MutableCollection]);
  initMetadataForClass(PersistentHashMapKeysIterator, 'PersistentHashMapKeysIterator', VOID, PersistentHashMapBaseIterator);
  initMetadataForClass(PersistentHashMapValuesIterator, 'PersistentHashMapValuesIterator', VOID, PersistentHashMapBaseIterator);
  initMetadataForClass(PersistentHashMapEntriesIterator, 'PersistentHashMapEntriesIterator', VOID, PersistentHashMapBaseIterator);
  initMetadataForClass(TrieNodeKeysIterator, 'TrieNodeKeysIterator', TrieNodeKeysIterator, TrieNodeBaseIterator);
  initMetadataForClass(TrieNodeValuesIterator, 'TrieNodeValuesIterator', TrieNodeValuesIterator, TrieNodeBaseIterator);
  initMetadataForClass(TrieNodeEntriesIterator, 'TrieNodeEntriesIterator', TrieNodeEntriesIterator, TrieNodeBaseIterator);
  initMetadataForClass(PersistentHashMapKeys, 'PersistentHashMapKeys', VOID, AbstractSet, [Collection, KtSet]);
  initMetadataForClass(PersistentHashMapValues, 'PersistentHashMapValues', VOID, AbstractCollection, [Collection]);
  initMetadataForClass(PersistentHashMapEntries, 'PersistentHashMapEntries', VOID, AbstractSet, [Collection, KtSet]);
  initMetadataForClass(ModificationResult, 'ModificationResult');
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(TrieNode, 'TrieNode');
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(PersistentOrderedSet, 'PersistentOrderedSet', VOID, AbstractSet, [Collection, KtSet]);
  initMetadataForClass(Links, 'Links', Links_init_$Create$);
  initMetadataForClass(PersistentOrderedSetIterator, 'PersistentOrderedSetIterator');
  initMetadataForObject(EndOfChain, 'EndOfChain');
  initMetadataForObject(ListImplementation, 'ListImplementation');
  initMetadataForClass(MutabilityOwnership, 'MutabilityOwnership', MutabilityOwnership);
  initMetadataForClass(DeltaCounter, 'DeltaCounter', DeltaCounter);
  initMetadataForClass(AwaiterQueue, 'AwaiterQueue', AwaiterQueue);
  initMetadataForClass(ComposableLambdaImpl, 'ComposableLambdaImpl');
  initMetadataForClass(IntRef, 'IntRef', IntRef);
  initMetadataForClass(Builder, 'Builder', VOID, PersistentHashMapBuilder, [KtMutableMap]);
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(PersistentCompositionLocalHashMap, 'PersistentCompositionLocalHashMap', VOID, PersistentHashMap, [PersistentCompositionLocalMap]);
  initMetadataForClass(RememberEventDispatcher, 'RememberEventDispatcher', RememberEventDispatcher);
  initMetadataForClass(PausedCompositionRemembers, 'PausedCompositionRemembers', VOID, VOID, [RememberObserver]);
  initMetadataForClass(SnapshotThreadLocal, 'SnapshotThreadLocal', SnapshotThreadLocal);
  initMetadataForClass(ThreadMap, 'ThreadMap');
  initMetadataForInterface(ObserverHandle, 'ObserverHandle');
  initMetadataForClass(sam$androidx_compose_runtime_snapshots_ObserverHandle$0, 'sam$androidx_compose_runtime_snapshots_ObserverHandle$0', VOID, VOID, [ObserverHandle, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_runtime_snapshots_ObserverHandle$0_0, 'sam$androidx_compose_runtime_snapshots_ObserverHandle$0', VOID, VOID, [ObserverHandle, FunctionAdapter]);
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(Snapshot, 'Snapshot');
  initMetadataForCompanion(Companion_18);
  initMetadataForClass(MutableSnapshot, 'MutableSnapshot', VOID, Snapshot);
  initMetadataForClass(TransparentObserverMutableSnapshot, 'TransparentObserverMutableSnapshot', VOID, MutableSnapshot);
  initMetadataForClass(TransparentObserverSnapshot, 'TransparentObserverSnapshot', VOID, Snapshot);
  initMetadataForClass(SnapshotApplyResult, 'SnapshotApplyResult');
  initMetadataForObject(Success, 'Success', VOID, SnapshotApplyResult);
  initMetadataForClass(Failure, 'Failure', VOID, SnapshotApplyResult);
  initMetadataForClass(GlobalSnapshot, 'GlobalSnapshot', VOID, MutableSnapshot);
  initMetadataForClass(NestedMutableSnapshot, 'NestedMutableSnapshot', VOID, MutableSnapshot);
  initMetadataForClass(NestedReadonlySnapshot, 'NestedReadonlySnapshot', VOID, Snapshot);
  initMetadataForClass(ReadonlySnapshot, 'ReadonlySnapshot', VOID, Snapshot);
  initMetadataForClass(SnapshotDoubleIndexHeap, 'SnapshotDoubleIndexHeap', SnapshotDoubleIndexHeap);
  initMetadataForCompanion(Companion_19);
  initMetadataForLambda(SnapshotIdSet$iterator$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SnapshotIdSet, 'SnapshotIdSet');
  initMetadataForClass(StateListStateRecord, 'StateListStateRecord', VOID, StateRecord);
  initMetadataForClass(StateListIterator, 'StateListIterator');
  initMetadataForClass(SubList$listIterator$1);
  initMetadataForClass(SubList_1, 'SubList', VOID, VOID, [KtMutableList]);
  initMetadataForClass(StateMapStateRecord, 'StateMapStateRecord', VOID, StateRecord);
  initMetadataForClass(SnapshotStateMap, 'SnapshotStateMap', SnapshotStateMap, VOID, [StateObject, KtMutableMap]);
  initMetadataForClass(SnapshotMapSet, 'SnapshotMapSet', VOID, VOID, [KtMutableSet]);
  initMetadataForClass(SnapshotMapEntrySet, 'SnapshotMapEntrySet', VOID, SnapshotMapSet);
  initMetadataForClass(SnapshotMapKeySet, 'SnapshotMapKeySet', VOID, SnapshotMapSet);
  initMetadataForClass(SnapshotMapValueSet, 'SnapshotMapValueSet', VOID, SnapshotMapSet);
  initMetadataForClass(StateMapMutableEntriesIterator$next$1, VOID, VOID, VOID, [MutableEntry]);
  initMetadataForClass(StateMapMutableIterator, 'StateMapMutableIterator');
  initMetadataForClass(StateMapMutableEntriesIterator, 'StateMapMutableEntriesIterator', VOID, StateMapMutableIterator);
  initMetadataForClass(StateMapMutableKeysIterator, 'StateMapMutableKeysIterator', VOID, StateMapMutableIterator);
  initMetadataForClass(StateMapMutableValuesIterator, 'StateMapMutableValuesIterator', VOID, StateMapMutableIterator);
  initMetadataForClass(SnapshotStateObserver$ObservedScopeMap$derivedStateObserver$1);
  initMetadataForClass(ObservedScopeMap, 'ObservedScopeMap');
  initMetadataForClass(SnapshotStateObserver, 'SnapshotStateObserver');
  initMetadataForClass(SnapshotWeakSet, 'SnapshotWeakSet', SnapshotWeakSet);
  initMetadataForCompanion(Companion_20);
  function onPreCreate(parent, readonly) {
    return null;
  }
  function onCreated(snapshot, parent, observers) {
  }
  function onPreDispose(snapshot) {
  }
  function onApplied(snapshot, changed) {
  }
  initMetadataForInterface(SnapshotObserver, 'SnapshotObserver');
  initMetadataForClass(SnapshotInstanceObservers, 'SnapshotInstanceObservers', SnapshotInstanceObservers);
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(ComposeStackTrace, 'ComposeStackTrace');
  initMetadataForClass(ComposeStackTraceFrame, 'ComposeStackTraceFrame');
  initMetadataForClass(ObjectLocation, 'ObjectLocation');
  initMetadataForClass(WriterTraceBuilder, 'WriterTraceBuilder', VOID, ComposeStackTraceBuilder);
  initMetadataForClass(ReaderTraceBuilder_0, 'ReaderTraceBuilder', VOID, ComposeStackTraceBuilder);
  initMetadataForObject(ComposeToolingFlags, 'ComposeToolingFlags');
  initMetadataForObject(Key_1, 'Key');
  initMetadataForClass(CompositionErrorContextImpl, 'CompositionErrorContextImpl', VOID, VOID, [Element]);
  initMetadataForClass(SourceInformation, 'SourceInformation');
  initMetadataForClass(ParameterSourceInformation, 'ParameterSourceInformation');
  initMetadataForClass(LocationSourceInformation, 'LocationSourceInformation');
  initMetadataForClass(ParseException, 'ParseException', VOID, Exception);
  initMetadataForClass(SourceInfoParserState, 'SourceInfoParserState');
  initMetadataForClass(WeakReference, 'WeakReference');
  initMetadataForClass(SnapshotIdArrayBuilder, 'SnapshotIdArrayBuilder');
  initMetadataForObject(Trace, 'Trace');
  initMetadataForClass(SnapshotStateList, 'SnapshotStateList', SnapshotStateList_init_$Create$, VOID, [StateObject, KtMutableList, RandomAccess]);
  initMetadataForObject(Key_2, 'Key');
  initMetadataForClass(AtomicReference, 'AtomicReference');
  initMetadataForClass(AtomicInt, 'AtomicInt');
  initMetadataForClass(DiagnosticComposeException, 'DiagnosticComposeException', VOID, RuntimeException);
  //endregion
  function Anchor() {
  }
  var androidx_compose_runtime_AbstractApplier$stable;
  var androidx_compose_runtime_OffsetApplier$stable;
  var androidx_compose_runtime_ThrowingApplierStub$stable;
  function Applier() {
  }
  function AbstractApplier(root) {
    this.q2y_1 = root;
    this.r2y_1 = _Stack___init__impl__tvpfn5();
    this.s2y_1 = this.q2y_1;
  }
  protoOf(AbstractApplier).t2y = function (_set____db54di) {
    this.s2y_1 = _set____db54di;
  };
  protoOf(AbstractApplier).e2y = function () {
    return this.s2y_1;
  };
  protoOf(AbstractApplier).u2y = function (node) {
    Stack__push_impl_s8r905(this.r2y_1, this.e2y());
    this.t2y(node);
  };
  protoOf(AbstractApplier).h2y = function (node) {
    return this.u2y(node);
  };
  protoOf(AbstractApplier).i2y = function () {
    this.t2y(Stack__pop_impl_8s4za4(this.r2y_1));
  };
  protoOf(AbstractApplier).c3 = function () {
    Stack__clear_impl_qoqv3c(this.r2y_1);
    this.t2y(this.q2y_1);
    this.v2y();
  };
  function throwIllegalOperationException($this) {
    composeImmediateRuntimeError('ChangeList cannot call the Applier when executing pending changes outside of the applier phase.');
  }
  function ThrowingApplierStub() {
  }
  protoOf(ThrowingApplierStub).e2y = function () {
    throwIllegalOperationException(this);
    return Unit_instance;
  };
  protoOf(ThrowingApplierStub).i2y = function () {
    return throwIllegalOperationException(this);
  };
  protoOf(ThrowingApplierStub).l2y = function (index, count) {
    return throwIllegalOperationException(this);
  };
  protoOf(ThrowingApplierStub).m2y = function (from, to, count) {
    return throwIllegalOperationException(this);
  };
  protoOf(ThrowingApplierStub).c3 = function () {
    return throwIllegalOperationException(this);
  };
  protoOf(ThrowingApplierStub).w2y = function (index, instance) {
    return throwIllegalOperationException(this);
  };
  protoOf(ThrowingApplierStub).k2y = function (index, instance) {
    return this.w2y(index, instance);
  };
  protoOf(ThrowingApplierStub).x2y = function (index, instance) {
    return throwIllegalOperationException(this);
  };
  protoOf(ThrowingApplierStub).j2y = function (index, instance) {
    return this.x2y(index, instance);
  };
  protoOf(ThrowingApplierStub).y2y = function (node) {
    return throwIllegalOperationException(this);
  };
  protoOf(ThrowingApplierStub).h2y = function (node) {
    return this.y2y(node);
  };
  var ThrowingApplierStub_instance;
  function ThrowingApplierStub_getInstance() {
    return ThrowingApplierStub_instance;
  }
  function OffsetApplier(applier, offset) {
    this.z2y_1 = applier;
    this.a2z_1 = offset;
    this.b2z_1 = 0;
  }
  protoOf(OffsetApplier).e2y = function () {
    return this.z2y_1.e2y();
  };
  protoOf(OffsetApplier).h2y = function (node) {
    this.b2z_1 = this.b2z_1 + 1 | 0;
    this.z2y_1.h2y(node);
  };
  protoOf(OffsetApplier).i2y = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.b2z_1 > 0)) {
      var tmp$ret$1 = 'OffsetApplier up called with no corresponding down';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.b2z_1 = this.b2z_1 - 1 | 0;
    this.z2y_1.i2y();
  };
  protoOf(OffsetApplier).j2y = function (index, instance) {
    this.z2y_1.j2y(index + (this.b2z_1 === 0 ? this.a2z_1 : 0) | 0, instance);
  };
  protoOf(OffsetApplier).k2y = function (index, instance) {
    this.z2y_1.k2y(index + (this.b2z_1 === 0 ? this.a2z_1 : 0) | 0, instance);
  };
  protoOf(OffsetApplier).l2y = function (index, count) {
    this.z2y_1.l2y(index + (this.b2z_1 === 0 ? this.a2z_1 : 0) | 0, count);
  };
  protoOf(OffsetApplier).m2y = function (from, to, count) {
    var effectiveOffset = this.b2z_1 === 0 ? this.a2z_1 : 0;
    this.z2y_1.m2y(from + effectiveOffset | 0, to + effectiveOffset | 0, count);
  };
  protoOf(OffsetApplier).c3 = function () {
    composeImmediateRuntimeError('Clear is not valid on OffsetApplier');
  };
  protoOf(OffsetApplier).n2y = function (block, value) {
    this.z2y_1.n2y(block, value);
  };
  protoOf(OffsetApplier).o2y = function () {
    this.z2y_1.o2y();
  };
  var androidx_compose_runtime_BroadcastFrameClock$stable;
  function FrameAwaiter(onFrame, continuation) {
    Awaiter.call(this);
    this.c2z_1 = continuation;
    this.d2z_1 = onFrame;
  }
  protoOf(FrameAwaiter).e2z = function () {
    this.d2z_1 = null;
    this.c2z_1 = null;
  };
  protoOf(FrameAwaiter).f2z = function (exception) {
    var tmp0_safe_receiver = this.c2z_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0_safe_receiver.y9(tmp$ret$1);
    }
  };
  protoOf(FrameAwaiter).g2z = function (timeNanos) {
    var tmp0_elvis_lhs = this.d2z_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var onFrame = tmp;
    var tmp1_safe_receiver = this.c2z_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.runCatching' call
      var tmp_0;
      try {
        // Inline function 'kotlin.Companion.success' call
        var value = onFrame(timeNanos);
        tmp_0 = _Result___init__impl__xyqfz8(value);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$0 = tmp_0;
      tmp1_safe_receiver.y9(tmp$ret$0);
    }
  };
  function BroadcastFrameClock$sendFrame$lambda($timeNanos) {
    return function (awaiter) {
      awaiter.g2z($timeNanos);
      return Unit_instance;
    };
  }
  function BroadcastFrameClock$withFrameNanos$lambda($cancellationHandle) {
    return function (it) {
      $cancellationHandle.e2z();
      return Unit_instance;
    };
  }
  function BroadcastFrameClock(onNewAwaiters) {
    onNewAwaiters = onNewAwaiters === VOID ? null : onNewAwaiters;
    this.h2z_1 = onNewAwaiters;
    this.i2z_1 = new AwaiterQueue();
  }
  protoOf(BroadcastFrameClock).j2z = function () {
    return this.i2z_1.j2z();
  };
  protoOf(BroadcastFrameClock).p2z = function (timeNanos) {
    this.i2z_1.q2z(BroadcastFrameClock$sendFrame$lambda(timeNanos));
  };
  protoOf(BroadcastFrameClock).r2z = function (onFrame, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    var cancellationHandle = this.i2z_1.s2z(new FrameAwaiter(onFrame, cancellable), this.h2z_1);
    cancellable.f1d(BroadcastFrameClock$withFrameNanos$lambda(cancellationHandle));
    return cancellable.x1b();
  };
  var androidx_compose_runtime_OneShotCancellationHandle$stable;
  function sam$androidx_compose_runtime_CancellationHandle$0(function_0) {
    this.t2z_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_CancellationHandle$0).e2z = function () {
    return this.t2z_1();
  };
  protoOf(sam$androidx_compose_runtime_CancellationHandle$0).q3 = function () {
    return this.t2z_1;
  };
  protoOf(sam$androidx_compose_runtime_CancellationHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, CancellationHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_CancellationHandle$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function CancellationHandle$Companion$Empty$lambda() {
    return Unit_instance;
  }
  function Companion() {
    Companion_instance_0 = this;
    var tmp = this;
    var tmp_0 = CancellationHandle$Companion$Empty$lambda;
    tmp.u2z_1 = new sam$androidx_compose_runtime_CancellationHandle$0(tmp_0);
  }
  var Companion_instance_0;
  function Companion_getInstance() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function CancellationHandle() {
  }
  function OneShotCancellationHandle(action) {
    this.v2z_1 = action;
    this.w2z_1 = _AtomicBoolean___init__impl__fuqz3w_0(false);
  }
  protoOf(OneShotCancellationHandle).e2z = function () {
    if (!AtomicBoolean__getAndSet_impl_r4bp2h(this.w2z_1, true)) {
      this.v2z_1();
    }
  };
  function get_currentRecomposeScope($composer, $changed) {
    var $composer_0 = $composer;
    var tmp0_elvis_lhs = $composer_0.x2z();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'no recompose scope found';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var scope = tmp;
    $composer_0.y2z(scope);
    return scope;
  }
  function get_currentCompositeKeyHashCode($composer, $changed) {
    var $composer_0 = $composer;
    return $composer_0.z2z();
  }
  function rememberCompositionContext($composer, $changed) {
    var $composer_0 = $composer;
    return $composer_0.a30();
  }
  function get_currentCompositionLocalContext($composer, $changed) {
    var $composer_0 = $composer;
    return new CompositionLocalContext($composer_0.a30().b30());
  }
  function invalidApplier() {
    // Inline function 'kotlin.error' call
    var message = 'Invalid applier';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function ComposeNodeLifecycleCallback() {
  }
  var androidx_compose_runtime_ComposeRuntimeFlags$stable;
  function ComposeRuntimeFlags() {
    this.e30_1 = false;
  }
  var ComposeRuntimeFlags_instance;
  function ComposeRuntimeFlags_getInstance() {
    return ComposeRuntimeFlags_instance;
  }
  var androidx_compose_runtime_ComposeVersion$stable;
  function get_compositionTracer() {
    _init_properties_Composer_kt__bmp4g0();
    return compositionTracer;
  }
  var compositionTracer;
  function get_composeStackTraceMode() {
    _init_properties_Composer_kt__bmp4g0();
    return composeStackTraceMode;
  }
  var composeStackTraceMode;
  function get_invocation() {
    _init_properties_Composer_kt__bmp4g0();
    return invocation;
  }
  var invocation;
  function get_provider() {
    _init_properties_Composer_kt__bmp4g0();
    return provider;
  }
  var provider;
  function get_compositionLocalMap() {
    _init_properties_Composer_kt__bmp4g0();
    return compositionLocalMap;
  }
  var compositionLocalMap;
  var providerValues;
  function get_providerMaps() {
    _init_properties_Composer_kt__bmp4g0();
    return providerMaps;
  }
  var providerMaps;
  function get_reference() {
    _init_properties_Composer_kt__bmp4g0();
    return reference;
  }
  var reference;
  var androidx_compose_runtime_ProvidedValue$stable;
  var androidx_compose_runtime_InternalComposer$stable;
  var androidx_compose_runtime_ComposeRuntimeError$stable;
  function Composer$Companion$Empty$1() {
  }
  protoOf(Composer$Companion$Empty$1).toString = function () {
    return 'Empty';
  };
  function Companion_0() {
    Companion_instance_1 = this;
    var tmp = this;
    tmp.f30_1 = new Composer$Companion$Empty$1();
  }
  var Companion_instance_1;
  function Companion_getInstance_0() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  function Composer() {
  }
  function sourceInformation(composer, sourceInformation) {
    _init_properties_Composer_kt__bmp4g0();
    composer.w30(sourceInformation);
  }
  function isTraceInProgress() {
    _init_properties_Composer_kt__bmp4g0();
    // Inline function 'kotlin.let' call
    var it = get_compositionTracer();
    return !(it == null) && it.a32();
  }
  function traceEventStart(key, dirty1, dirty2, info) {
    _init_properties_Composer_kt__bmp4g0();
    var tmp0_safe_receiver = get_compositionTracer();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b32(key, dirty1, dirty2, info);
    }
  }
  function sourceInformationMarkerStart(composer, key, sourceInformation) {
    _init_properties_Composer_kt__bmp4g0();
    composer.x30(key, sourceInformation);
  }
  function sourceInformationMarkerEnd(composer) {
    _init_properties_Composer_kt__bmp4g0();
    composer.y30();
  }
  function traceEventEnd() {
    _init_properties_Composer_kt__bmp4g0();
    var tmp0_safe_receiver = get_compositionTracer();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c32();
    }
  }
  function ProvidedValue(compositionLocal, value, explicitNull, mutationPolicy, state, compute, isDynamic) {
    this.d32_1 = compositionLocal;
    this.e32_1 = explicitNull;
    this.f32_1 = mutationPolicy;
    this.g32_1 = state;
    this.h32_1 = compute;
    this.i32_1 = isDynamic;
    this.j32_1 = value;
    this.k32_1 = true;
  }
  protoOf(ProvidedValue).u1 = function () {
    return this.j32_1;
  };
  protoOf(ProvidedValue).l32 = function () {
    var tmp;
    if (this.e32_1) {
      tmp = null;
    } else if (!(this.g32_1 == null)) {
      tmp = this.g32_1.u1();
    } else if (!(this.j32_1 == null)) {
      tmp = this.j32_1;
    } else {
      composeRuntimeError('Unexpected form of a provided value');
    }
    return tmp;
  };
  protoOf(ProvidedValue).m32 = function () {
    return (this.e32_1 || !(this.u1() == null)) && !this.i32_1;
  };
  protoOf(ProvidedValue).n32 = function () {
    // Inline function 'kotlin.also' call
    this.k32_1 = false;
    return this;
  };
  function androidx_compose_runtime_ProvidedValue$stableprop_getter() {
    return androidx_compose_runtime_ProvidedValue$stable;
  }
  function _Updater___init__impl__rbfxm8(composer) {
    return composer;
  }
  function _Updater___get_composer__impl__9ty7av($this) {
    return $this;
  }
  function Updater__set_impl_v7kwss($this, value, block) {
    // Inline function 'kotlin.with' call
    var $this$with = _Updater___get_composer__impl__9ty7av($this);
    if ($this$with.h30() || !equals($this$with.i31(), value)) {
      $this$with.j31(value);
      _Updater___get_composer__impl__9ty7av($this).h31(value, block);
    }
    return Unit_instance;
  }
  function Updater__reconcile_impl_1mfi6g($this, block) {
    var tmp = _Updater___get_composer__impl__9ty7av($this);
    tmp.h31(Unit_instance, Updater$reconcile$lambda(block));
  }
  function Updater$reconcile$lambda($block) {
    return function ($this$apply, it) {
      $block($this$apply);
      return Unit_instance;
    };
  }
  function composeRuntimeError(message) {
    _init_properties_Composer_kt__bmp4g0();
    throw new ComposeRuntimeError('Compose Runtime internal error. Unexpected or incorrect use of the Compose ' + ('internal runtime API (' + message + '). Please report to Google or use ') + 'https://goo.gle/compose-feedback');
  }
  function ComposeRuntimeError(message) {
    IllegalStateException_init_$Init$(this);
    captureStack(this, ComposeRuntimeError);
    this.o32_1 = message;
    delete this.message;
  }
  protoOf(ComposeRuntimeError).e = function () {
    return this.o32_1;
  };
  function InternalComposer() {
  }
  function RememberObserverHolder() {
  }
  var InvalidationResult_IGNORED_instance;
  var InvalidationResult_SCHEDULED_instance;
  var InvalidationResult_DEFERRED_instance;
  var InvalidationResult_IMMINENT_instance;
  var InvalidationResult_entriesInitialized;
  function InvalidationResult_initEntries() {
    if (InvalidationResult_entriesInitialized)
      return Unit_instance;
    InvalidationResult_entriesInitialized = true;
    InvalidationResult_IGNORED_instance = new InvalidationResult('IGNORED', 0);
    InvalidationResult_SCHEDULED_instance = new InvalidationResult('SCHEDULED', 1);
    InvalidationResult_DEFERRED_instance = new InvalidationResult('DEFERRED', 2);
    InvalidationResult_IMMINENT_instance = new InvalidationResult('IMMINENT', 3);
  }
  function InvalidationResult(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function composeImmediateRuntimeError(message) {
    _init_properties_Composer_kt__bmp4g0();
    throw new ComposeRuntimeError('Compose Runtime internal error. Unexpected or incorrect use of the Compose ' + ('internal runtime API (' + message + '). Please report to Google or use ') + 'https://goo.gle/compose-feedback');
  }
  function ReusableRememberObserverHolder() {
  }
  function removeCurrentGroup(_this__u8e3s4, rememberManager) {
    _init_properties_Composer_kt__bmp4g0();
    var tmp = _this__u8e3s4.b34_1;
    _this__u8e3s4.g34(tmp, removeCurrentGroup$lambda(rememberManager));
    _this__u8e3s4.h34();
  }
  function extractMovableContentAtCurrent(composition, reference, slots, applier) {
    _init_properties_Composer_kt__bmp4g0();
    var slotTable = new SlotTable();
    if (slots.u34()) {
      slotTable.t34();
    }
    if (slots.w34()) {
      slotTable.v34();
    }
    var currentGroup = slots.b34_1;
    if (!(applier == null) && slots.b35(currentGroup) > 0) {
      if (!isInterface(applier, Applier))
        THROW_CCE();
      var parentNodeGroup = slots.d34_1;
      while (parentNodeGroup > 0 && !slots.x34(parentNodeGroup)) {
        parentNodeGroup = slots.y34(parentNodeGroup);
      }
      if (parentNodeGroup >= 0 && slots.x34(parentNodeGroup)) {
        var node = slots.z34(parentNodeGroup);
        var currentChild = parentNodeGroup + 1 | 0;
        var end = parentNodeGroup + slots.a35(parentNodeGroup) | 0;
        var nodeIndex = 0;
        $l$loop: while (currentChild < end) {
          var size = slots.a35(currentChild);
          if ((currentChild + size | 0) > currentGroup) {
            break $l$loop;
          }
          nodeIndex = nodeIndex + (slots.x34(currentChild) ? 1 : slots.b35(currentChild)) | 0;
          currentChild = currentChild + size | 0;
        }
        var count = slots.x34(currentGroup) ? 1 : slots.b35(currentGroup);
        applier.h2y(node);
        applier.l2y(nodeIndex, count);
        applier.i2y();
      }
    }
    var anchor = reference.g35_1;
    if (anchor.d2y()) {
      // Inline function 'androidx.compose.runtime.CompositionImpl.extractInvalidationsOfGroup' call
      var this_0 = composition instanceof CompositionImpl ? composition : THROW_CCE();
      var tmp;
      if (_ScopeMap___get_size__impl__f25bvl(access$_get_invalidations__kity90(this_0)) > 0) {
        // Inline function 'kotlin.collections.mutableListOf' call
        var result = ArrayList_init_$Create$();
        // Inline function 'androidx.compose.runtime.collection.ScopeMap.removeIf' call
        var this_1 = access$_get_invalidations__kity90(this_0);
        // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
        var this_2 = _ScopeMap___get_map__impl__vxhazm(this_1);
        $l$block_0: {
          // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
          var m = this_2.w12_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_3 = slot;
              var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var tmp0 = this_2.x12_1[index];
                      var scopes = this_2.y12_1[index];
                      if (tmp0 == null)
                        THROW_CCE();
                      var tmp_0;
                      if (scopes instanceof MutableScatterSet) {
                        if (!(scopes instanceof MutableScatterSet))
                          THROW_CCE();
                        // Inline function 'androidx.collection.MutableScatterSet.removeIf' call
                        var elements = scopes.k16_1;
                        $l$block: {
                          // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                          // Inline function 'kotlin.contracts.contract' call
                          var m_0 = scopes.j16_1;
                          var lastIndex_0 = m_0.length - 2 | 0;
                          var inductionVariable_1 = 0;
                          if (inductionVariable_1 <= lastIndex_0)
                            do {
                              var i_0 = inductionVariable_1;
                              inductionVariable_1 = inductionVariable_1 + 1 | 0;
                              var slot_0 = m_0[i_0];
                              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                              var this_4 = slot_0;
                              var tmp$ret$12 = bitwiseAnd(bitwiseAnd(this_4, shiftLeft(invert(this_4), 7)), new Long(-2139062144, -2139062144));
                              if (!equalsLong(tmp$ret$12, new Long(-2139062144, -2139062144))) {
                                var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                                var inductionVariable_2 = 0;
                                if (inductionVariable_2 < bitCount_0)
                                  do {
                                    var j_0 = inductionVariable_2;
                                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                    // Inline function 'androidx.collection.isFull' call
                                    var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                                    if (compare(value_0, new Long(128, 0)) < 0) {
                                      var index_0 = (i_0 << 3) + j_0 | 0;
                                      var value_1 = elements[index_0];
                                      var scopeAnchor = tmp0.m35_1;
                                      var tmp_1;
                                      var tmp_2;
                                      if (!(scopeAnchor == null)) {
                                        tmp_2 = slots.r35(asGapAnchor(anchor), asGapAnchor(scopeAnchor));
                                      } else {
                                        tmp_2 = false;
                                      }
                                      if (tmp_2) {
                                        result.j1(to(tmp0, value_1));
                                        tmp_1 = true;
                                      } else {
                                        tmp_1 = false;
                                      }
                                      if (tmp_1) {
                                        scopes.j11(index_0);
                                      }
                                    }
                                    slot_0 = shiftRight(slot_0, 8);
                                  }
                                   while (inductionVariable_2 < bitCount_0);
                                if (!(bitCount_0 === 8)) {
                                  break $l$block;
                                }
                              }
                            }
                             while (!(i_0 === lastIndex_0));
                        }
                        tmp_0 = scopes.r();
                      } else {
                        var value_2 = !(scopes == null) ? scopes : THROW_CCE();
                        var scopeAnchor_0 = tmp0.m35_1;
                        var tmp_3;
                        var tmp_4;
                        if (!(scopeAnchor_0 == null)) {
                          tmp_4 = slots.r35(asGapAnchor(anchor), asGapAnchor(scopeAnchor_0));
                        } else {
                          tmp_4 = false;
                        }
                        if (tmp_4) {
                          result.j1(to(tmp0, value_2));
                          tmp_3 = true;
                        } else {
                          tmp_3 = false;
                        }
                        tmp_0 = tmp_3;
                      }
                      if (tmp_0) {
                        this_2.hw(index);
                      }
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block_0;
                }
              }
            }
             while (!(i === lastIndex));
        }
        tmp = result;
      } else {
        tmp = emptyList();
      }
      var extracted = tmp;
      reference.h35_1 = plus_0(reference.h35_1, extracted);
    }
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = slotTable.s35();
    var normalClose = false;
    var tmp_5;
    try {
      writer.t35();
      writer.u35(126665345, reference.c35_1);
      writer.v35();
      writer.w35(reference.d35_1);
      var anchors = slots.x35(asGapAnchor(reference.g35_1), 1, writer);
      writer.y35();
      writer.z35();
      writer.a36();
      // Inline function 'kotlin.also' call
      normalClose = true;
      tmp_5 = anchors;
    }finally {
      writer.b36(normalClose);
    }
    var anchors_0 = tmp_5;
    var state = new MovableContentState(slotTable);
    if (Companion_instance_6.d36(slotTable, anchors_0)) {
      var movableContentRecomposeScopeOwner = new extractMovableContentAtCurrent$movableContentRecomposeScopeOwner$1(composition, reference);
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
      // Inline function 'kotlin.let' call
      var writer_0 = slotTable.s35();
      var normalClose_0 = false;
      var tmp_6;
      try {
        Companion_instance_6.c36(writer_0, anchors_0, movableContentRecomposeScopeOwner);
        // Inline function 'kotlin.also' call
        normalClose_0 = true;
        tmp_6 = Unit_instance;
      }finally {
        writer_0.b36(normalClose_0);
      }
    }
    return state;
  }
  function removeCurrentGroup$lambda($rememberManager) {
    return function (_unused_var__etf5q3, slot) {
      var tmp;
      if (!(slot == null) ? isInterface(slot, ComposeNodeLifecycleCallback) : false) {
        $rememberManager.e36(slot);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (!(slot == null) ? isInterface(slot, RememberObserverHolder) : false) {
        $rememberManager.f36(slot);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if (slot instanceof RecomposeScopeImpl) {
        slot.r2v();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function extractMovableContentAtCurrent$movableContentRecomposeScopeOwner$1($composition, $reference) {
    this.g36_1 = $composition;
    this.h36_1 = $reference;
  }
  protoOf(extractMovableContentAtCurrent$movableContentRecomposeScopeOwner$1).i36 = function (scope, instance) {
    var tmp = this.g36_1;
    var tmp0_safe_receiver = isInterface(tmp, RecomposeScopeOwner) ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i36(scope, instance);
    var result = tmp1_elvis_lhs == null ? InvalidationResult_IGNORED_getInstance() : tmp1_elvis_lhs;
    if (result.equals(InvalidationResult_IGNORED_getInstance())) {
      var _receiver__tnumb7 = this.h36_1;
      _receiver__tnumb7.h35_1 = plus_1(_receiver__tnumb7.h35_1, to(scope, instance));
      return InvalidationResult_SCHEDULED_getInstance();
    }
    return result;
  };
  protoOf(extractMovableContentAtCurrent$movableContentRecomposeScopeOwner$1).j36 = function (scope) {
  };
  protoOf(extractMovableContentAtCurrent$movableContentRecomposeScopeOwner$1).k36 = function (value) {
  };
  function InvalidationResult_IGNORED_getInstance() {
    InvalidationResult_initEntries();
    return InvalidationResult_IGNORED_instance;
  }
  function InvalidationResult_SCHEDULED_getInstance() {
    InvalidationResult_initEntries();
    return InvalidationResult_SCHEDULED_instance;
  }
  function InvalidationResult_DEFERRED_getInstance() {
    InvalidationResult_initEntries();
    return InvalidationResult_DEFERRED_instance;
  }
  function InvalidationResult_IMMINENT_getInstance() {
    InvalidationResult_initEntries();
    return InvalidationResult_IMMINENT_instance;
  }
  var properties_initialized_Composer_kt_89qzc2;
  function _init_properties_Composer_kt__bmp4g0() {
    if (!properties_initialized_Composer_kt_89qzc2) {
      properties_initialized_Composer_kt_89qzc2 = true;
      compositionTracer = null;
      composeStackTraceMode = Companion_getInstance_21().l36_1;
      invocation = new OpaqueKey('provider');
      provider = new OpaqueKey('provider');
      compositionLocalMap = new OpaqueKey('compositionLocalMap');
      providerValues = new OpaqueKey('providerValues');
      providerMaps = new OpaqueKey('providers');
      reference = new OpaqueKey('reference');
      androidx_compose_runtime_ProvidedValue$stable = 8;
      androidx_compose_runtime_InternalComposer$stable = 0;
      androidx_compose_runtime_ComposeRuntimeError$stable = 8;
    }
  }
  function get_PendingApplyNoModifications() {
    _init_properties_Composition_kt__t5pjw8();
    return PendingApplyNoModifications;
  }
  var PendingApplyNoModifications;
  var ObservableCompositionServiceKey;
  var androidx_compose_runtime_SlotStorage$stable;
  var androidx_compose_runtime_Changes$stable;
  var androidx_compose_runtime_CompositionImpl$stable;
  var androidx_compose_runtime_ScopeInvalidated$stable;
  var androidx_compose_runtime_CompositionObserverHolder$stable;
  function ReusableComposition(applier, parent) {
    _init_properties_Composition_kt__t5pjw8();
    return new CompositionImpl(parent, applier);
  }
  function createSlotStorage($this) {
    var tmp;
    if (ComposeRuntimeFlags_instance.e30_1) {
      tmp = new SlotTable_0();
    } else {
      tmp = new SlotTable();
    }
    return tmp;
  }
  function createComposer($this) {
    var tmp;
    if (ComposeRuntimeFlags_instance.e30_1) {
      var tmp0_applier = $this.q36_1;
      var tmp1_parentContext = $this.p36_1;
      var tmp2_slotTable = asLinkBufferSlotTable($this.u36_1);
      var tmp3_abandonSet = $this.t36_1;
      var tmp4_changes = $this.z36_1;
      var tmp5_lateChanges = $this.a37_1;
      var tmp6_observerHolder = $this.i37_1;
      tmp = new LinkComposer(tmp0_applier, tmp1_parentContext, tmp3_abandonSet, tmp2_slotTable, tmp4_changes, tmp5_lateChanges, tmp6_observerHolder, $this);
    } else {
      var tmp7_applier = $this.q36_1;
      var tmp8_parentContext = $this.p36_1;
      var tmp9_slotTable = asGapBufferSlotTable($this.u36_1);
      var tmp10_abandonSet = $this.t36_1;
      var tmp11_changes = $this.z36_1;
      var tmp12_lateChanges = $this.a37_1;
      var tmp13_observerHolder = $this.i37_1;
      tmp = new GapComposer(tmp7_applier, tmp8_parentContext, tmp9_slotTable, tmp10_abandonSet, tmp11_changes, tmp12_lateChanges, tmp13_observerHolder, $this);
    }
    return tmp;
  }
  function createChangeList($this) {
    var tmp;
    if (ComposeRuntimeFlags_instance.e30_1) {
      tmp = new ChangeList_0();
    } else {
      tmp = new ChangeList();
    }
    return tmp;
  }
  function _get_areChildrenComposing__c1uwup($this) {
    return $this.k37_1.p32();
  }
  function composeInitial($this, content) {
    $this.n37_1 = content;
    $this.p36_1.o37($this, $this.n37_1);
  }
  function composeInitialPaused($this, reusable, content) {
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!($this.f37_1 == null)) {
      var tmp$ret$1 = 'A pausable composition is in progress';
      throwIllegalStateException(tmp$ret$1);
    }
    var tmp0_context = $this.p36_1;
    var tmp1_composer = $this.k37_1;
    var tmp2_abandonSet = $this.t36_1;
    var tmp3_applier = $this.q36_1;
    var tmp4_lock = $this.s36_1;
    var pausedComposition = new PausedCompositionImpl($this, tmp0_context, tmp1_composer, tmp2_abandonSet, content, reusable, tmp3_applier, tmp4_lock);
    $this.f37_1 = pausedComposition;
    return pausedComposition;
  }
  function composeInitialWithReuse($this, content) {
    $this.k37_1.v32();
    composeInitial($this, content);
    $this.k37_1.w32();
  }
  function ensureRunning($this) {
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!($this.m37_1 === 0)) {
      switch ($this.m37_1) {
        case 2:
          var tmp$ret$1 = 'A previous pausable composition for this composition was cancelled. This composition must be disposed.';
          break;
        case 3:
          tmp$ret$1 = 'The composition is disposed';
          break;
        case 1:
          tmp$ret$1 = 'The composition should be activated before setting content.';
          break;
        default:
          tmp$ret$1 = '';
          break;
      }
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!($this.f37_1 == null)) {
      var tmp$ret$3 = 'A pausable composition is in progress';
      throwIllegalStateException(tmp$ret$3);
    }
  }
  function clearDeactivated($this) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.s36_1;
    var isDeactivated = $this.m37_1 === 1;
    if (isDeactivated) {
      $this.m37_1 = 0;
    }
    return isDeactivated;
  }
  function drainPendingModificationsForCompositionLocked($this) {
    var toRecord = $this.r36_1.x21(get_PendingApplyNoModifications());
    if (toRecord != null) {
      if (equals(toRecord, get_PendingApplyNoModifications())) {
        composeRuntimeError('pending composition has not been applied');
      } else {
        if (isInterface(toRecord, KtSet)) {
          addPendingInvalidationsLocked_0($this, isInterface(toRecord, KtSet) ? toRecord : THROW_CCE(), true);
        } else {
          if (isArray(toRecord)) {
            var indexedObject = isArray(toRecord) ? toRecord : THROW_CCE();
            var inductionVariable = 0;
            var last = indexedObject.length;
            while (inductionVariable < last) {
              var changed = indexedObject[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              addPendingInvalidationsLocked_0($this, changed, true);
            }
          } else {
            composeRuntimeError('corrupt pendingModifications drain: ' + toString($this.r36_1));
          }
        }
      }
    }
  }
  function drainPendingModificationsLocked($this) {
    var toRecord = $this.r36_1.x21(null);
    if (!equals(toRecord, get_PendingApplyNoModifications())) {
      if (!(toRecord == null) ? isInterface(toRecord, KtSet) : false) {
        addPendingInvalidationsLocked_0($this, isInterface(toRecord, KtSet) ? toRecord : THROW_CCE(), false);
      } else {
        if (!(toRecord == null) ? isArray(toRecord) : false) {
          var indexedObject = isArray(toRecord) ? toRecord : THROW_CCE();
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var changed = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            addPendingInvalidationsLocked_0($this, changed, false);
          }
        } else {
          if (toRecord == null) {
            if ($this.f37_1 == null) {
              composeImmediateRuntimeError('calling recordModificationsOf and applyChanges concurrently is not supported');
            }
          } else {
            composeRuntimeError('corrupt pendingModifications drain: ' + toString($this.r36_1));
          }
        }
      }
    }
  }
  function drainPendingModificationsOutOfBandLocked($this) {
    var toRecord = $this.r36_1.x21(emptySet());
    if (!equals(toRecord, get_PendingApplyNoModifications()) && toRecord != null) {
      if (isInterface(toRecord, KtSet)) {
        addPendingInvalidationsLocked_0($this, isInterface(toRecord, KtSet) ? toRecord : THROW_CCE(), false);
      } else {
        if (isArray(toRecord)) {
          var indexedObject = isArray(toRecord) ? toRecord : THROW_CCE();
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var changed = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            addPendingInvalidationsLocked_0($this, changed, false);
          }
        } else {
          composeRuntimeError('corrupt pendingModifications drain: ' + toString($this.r36_1));
        }
      }
    }
  }
  function addPendingInvalidationsLocked($this, value, forgetConditionalScopes) {
    // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
    var this_0 = $this.v36_1;
    var value_0 = _ScopeMap___get_map__impl__vxhazm(this_0).w2(value);
    if (value_0 != null) {
      if (value_0 instanceof MutableScatterSet) {
        // Inline function 'androidx.collection.ScatterSet.forEach' call
        var this_1 = value_0 instanceof MutableScatterSet ? value_0 : THROW_CCE();
        // Inline function 'kotlin.contracts.contract' call
        var elements = this_1.k16_1;
        $l$block: {
          // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
          // Inline function 'kotlin.contracts.contract' call
          var m = this_1.j16_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_2 = slot;
              var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value_1 = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value_1, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var scope = elements[index];
                      if (!ScopeMap__remove_impl_ocu4rj_0($this.b37_1, value, scope) && !scope.r37(value).equals(InvalidationResult_IGNORED_getInstance())) {
                        if (scope.q37() && !forgetConditionalScopes) {
                          $this.x36_1.j1(scope);
                        } else {
                          $this.w36_1.j1(scope);
                        }
                      }
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
      } else {
        var scope_0 = !(value_0 == null) ? value_0 : THROW_CCE();
        if (!ScopeMap__remove_impl_ocu4rj_0($this.b37_1, value, scope_0) && !scope_0.r37(value).equals(InvalidationResult_IGNORED_getInstance())) {
          if (scope_0.q37() && !forgetConditionalScopes) {
            $this.x36_1.j1(scope_0);
          } else {
            $this.w36_1.j1(scope_0);
          }
        }
      }
    }
  }
  function addPendingInvalidationsLocked_0($this, values, forgetConditionalScopes) {
    // Inline function 'androidx.compose.runtime.collection.fastForEach' call
    var tmp;
    if (values instanceof ScatterSetWrapper) {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      var this_0 = values.s37_1;
      // Inline function 'kotlin.contracts.contract' call
      var elements = this_0.k16_1;
      $l$block_0: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = this_0.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var value_0 = elements[index];
                    if (value_0 instanceof RecomposeScopeImpl) {
                      value_0.r37(null);
                    } else {
                      addPendingInvalidationsLocked($this, value_0, forgetConditionalScopes);
                      // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
                      var this_2 = $this.y36_1;
                      var value_1 = _ScopeMap___get_map__impl__vxhazm(this_2).w2(value_0);
                      if (value_1 != null) {
                        if (value_1 instanceof MutableScatterSet) {
                          // Inline function 'androidx.collection.ScatterSet.forEach' call
                          var this_3 = value_1 instanceof MutableScatterSet ? value_1 : THROW_CCE();
                          // Inline function 'kotlin.contracts.contract' call
                          var elements_0 = this_3.k16_1;
                          $l$block: {
                            // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                            // Inline function 'kotlin.contracts.contract' call
                            var m_0 = this_3.j16_1;
                            var lastIndex_0 = m_0.length - 2 | 0;
                            var inductionVariable_1 = 0;
                            if (inductionVariable_1 <= lastIndex_0)
                              do {
                                var i_0 = inductionVariable_1;
                                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                                var slot_0 = m_0[i_0];
                                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                                var this_4 = slot_0;
                                var tmp$ret$14 = bitwiseAnd(bitwiseAnd(this_4, shiftLeft(invert(this_4), 7)), new Long(-2139062144, -2139062144));
                                if (!equalsLong(tmp$ret$14, new Long(-2139062144, -2139062144))) {
                                  var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                                  var inductionVariable_2 = 0;
                                  if (inductionVariable_2 < bitCount_0)
                                    do {
                                      var j_0 = inductionVariable_2;
                                      inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                      // Inline function 'androidx.collection.isFull' call
                                      var value_2 = bitwiseAnd(slot_0, new Long(255, 0));
                                      if (compare(value_2, new Long(128, 0)) < 0) {
                                        var index_0 = (i_0 << 3) + j_0 | 0;
                                        var it = elements_0[index_0];
                                        addPendingInvalidationsLocked($this, it, forgetConditionalScopes);
                                      }
                                      slot_0 = shiftRight(slot_0, 8);
                                    }
                                     while (inductionVariable_2 < bitCount_0);
                                  if (!(bitCount_0 === 8)) {
                                    break $l$block;
                                  }
                                }
                              }
                               while (!(i_0 === lastIndex_0));
                          }
                        } else {
                          var it_0 = !(value_1 == null) ? value_1 : THROW_CCE();
                          addPendingInvalidationsLocked($this, it_0, forgetConditionalScopes);
                        }
                      }
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i === lastIndex));
      }
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = values.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element instanceof RecomposeScopeImpl) {
          element.r37(null);
        } else {
          addPendingInvalidationsLocked($this, element, forgetConditionalScopes);
          // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
          var this_5 = $this.y36_1;
          var value_3 = _ScopeMap___get_map__impl__vxhazm(this_5).w2(element);
          if (value_3 != null) {
            if (value_3 instanceof MutableScatterSet) {
              // Inline function 'androidx.collection.ScatterSet.forEach' call
              var this_6 = value_3 instanceof MutableScatterSet ? value_3 : THROW_CCE();
              // Inline function 'kotlin.contracts.contract' call
              var elements_1 = this_6.k16_1;
              $l$block_1: {
                // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                // Inline function 'kotlin.contracts.contract' call
                var m_1 = this_6.j16_1;
                var lastIndex_1 = m_1.length - 2 | 0;
                var inductionVariable_3 = 0;
                if (inductionVariable_3 <= lastIndex_1)
                  do {
                    var i_1 = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var slot_1 = m_1[i_1];
                    // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                    var this_7 = slot_1;
                    var tmp$ret$26 = bitwiseAnd(bitwiseAnd(this_7, shiftLeft(invert(this_7), 7)), new Long(-2139062144, -2139062144));
                    if (!equalsLong(tmp$ret$26, new Long(-2139062144, -2139062144))) {
                      var bitCount_1 = 8 - (~(i_1 - lastIndex_1 | 0) >>> 31 | 0) | 0;
                      var inductionVariable_4 = 0;
                      if (inductionVariable_4 < bitCount_1)
                        do {
                          var j_1 = inductionVariable_4;
                          inductionVariable_4 = inductionVariable_4 + 1 | 0;
                          // Inline function 'androidx.collection.isFull' call
                          var value_4 = bitwiseAnd(slot_1, new Long(255, 0));
                          if (compare(value_4, new Long(128, 0)) < 0) {
                            var index_1 = (i_1 << 3) + j_1 | 0;
                            var it_1 = elements_1[index_1];
                            addPendingInvalidationsLocked($this, it_1, forgetConditionalScopes);
                          }
                          slot_1 = shiftRight(slot_1, 8);
                        }
                         while (inductionVariable_4 < bitCount_1);
                      if (!(bitCount_1 === 8)) {
                        break $l$block_1;
                      }
                    }
                  }
                   while (!(i_1 === lastIndex_1));
              }
            } else {
              var it_2 = !(value_3 == null) ? value_3 : THROW_CCE();
              addPendingInvalidationsLocked($this, it_2, forgetConditionalScopes);
            }
          }
        }
      }
      tmp = Unit_instance;
    }
    var conditionallyInvalidatedScopes = $this.x36_1;
    var invalidatedScopes = $this.w36_1;
    if (forgetConditionalScopes && conditionallyInvalidatedScopes.fv()) {
      // Inline function 'androidx.compose.runtime.collection.ScopeMap.removeScopeIf' call
      var this_8 = $this.v36_1;
      // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
      var this_9 = _ScopeMap___get_map__impl__vxhazm(this_8);
      $l$block_3: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m_2 = this_9.w12_1;
        var lastIndex_2 = m_2.length - 2 | 0;
        var inductionVariable_5 = 0;
        if (inductionVariable_5 <= lastIndex_2)
          do {
            var i_2 = inductionVariable_5;
            inductionVariable_5 = inductionVariable_5 + 1 | 0;
            var slot_2 = m_2[i_2];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_10 = slot_2;
            var tmp$ret$34 = bitwiseAnd(bitwiseAnd(this_10, shiftLeft(invert(this_10), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$34, new Long(-2139062144, -2139062144))) {
              var bitCount_2 = 8 - (~(i_2 - lastIndex_2 | 0) >>> 31 | 0) | 0;
              var inductionVariable_6 = 0;
              if (inductionVariable_6 < bitCount_2)
                do {
                  var j_2 = inductionVariable_6;
                  inductionVariable_6 = inductionVariable_6 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_5 = bitwiseAnd(slot_2, new Long(255, 0));
                  if (compare(value_5, new Long(128, 0)) < 0) {
                    var index_2 = (i_2 << 3) + j_2 | 0;
                    this_9.x12_1[index_2];
                    var value_6 = this_9.y12_1[index_2];
                    var tmp_0;
                    if (value_6 instanceof MutableScatterSet) {
                      var set = value_6 instanceof MutableScatterSet ? value_6 : THROW_CCE();
                      // Inline function 'androidx.collection.MutableScatterSet.removeIf' call
                      var elements_2 = set.k16_1;
                      $l$block_2: {
                        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                        // Inline function 'kotlin.contracts.contract' call
                        var m_3 = set.j16_1;
                        var lastIndex_3 = m_3.length - 2 | 0;
                        var inductionVariable_7 = 0;
                        if (inductionVariable_7 <= lastIndex_3)
                          do {
                            var i_3 = inductionVariable_7;
                            inductionVariable_7 = inductionVariable_7 + 1 | 0;
                            var slot_3 = m_3[i_3];
                            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                            var this_11 = slot_3;
                            var tmp$ret$41 = bitwiseAnd(bitwiseAnd(this_11, shiftLeft(invert(this_11), 7)), new Long(-2139062144, -2139062144));
                            if (!equalsLong(tmp$ret$41, new Long(-2139062144, -2139062144))) {
                              var bitCount_3 = 8 - (~(i_3 - lastIndex_3 | 0) >>> 31 | 0) | 0;
                              var inductionVariable_8 = 0;
                              if (inductionVariable_8 < bitCount_3)
                                do {
                                  var j_3 = inductionVariable_8;
                                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                                  // Inline function 'androidx.collection.isFull' call
                                  var value_7 = bitwiseAnd(slot_3, new Long(255, 0));
                                  if (compare(value_7, new Long(128, 0)) < 0) {
                                    var index_3 = (i_3 << 3) + j_3 | 0;
                                    var scope = elements_2[index_3];
                                    if (conditionallyInvalidatedScopes.m1(scope) || invalidatedScopes.m1(scope)) {
                                      set.j11(index_3);
                                    }
                                  }
                                  slot_3 = shiftRight(slot_3, 8);
                                }
                                 while (inductionVariable_8 < bitCount_3);
                              if (!(bitCount_3 === 8)) {
                                break $l$block_2;
                              }
                            }
                          }
                           while (!(i_3 === lastIndex_3));
                      }
                      tmp_0 = set.r();
                    } else {
                      var scope_0 = !(value_6 == null) ? value_6 : THROW_CCE();
                      tmp_0 = conditionallyInvalidatedScopes.m1(scope_0) || invalidatedScopes.m1(scope_0);
                    }
                    if (tmp_0) {
                      this_9.hw(index_2);
                    }
                  }
                  slot_2 = shiftRight(slot_2, 8);
                }
                 while (inductionVariable_6 < bitCount_2);
              if (!(bitCount_2 === 8)) {
                break $l$block_3;
              }
            }
          }
           while (!(i_2 === lastIndex_2));
      }
      conditionallyInvalidatedScopes.c3();
      cleanUpDerivedStateObservations($this);
    } else if (invalidatedScopes.fv()) {
      // Inline function 'androidx.compose.runtime.collection.ScopeMap.removeScopeIf' call
      var this_12 = $this.v36_1;
      // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
      var this_13 = _ScopeMap___get_map__impl__vxhazm(this_12);
      $l$block_5: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m_4 = this_13.w12_1;
        var lastIndex_4 = m_4.length - 2 | 0;
        var inductionVariable_9 = 0;
        if (inductionVariable_9 <= lastIndex_4)
          do {
            var i_4 = inductionVariable_9;
            inductionVariable_9 = inductionVariable_9 + 1 | 0;
            var slot_4 = m_4[i_4];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_14 = slot_4;
            var tmp$ret$49 = bitwiseAnd(bitwiseAnd(this_14, shiftLeft(invert(this_14), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$49, new Long(-2139062144, -2139062144))) {
              var bitCount_4 = 8 - (~(i_4 - lastIndex_4 | 0) >>> 31 | 0) | 0;
              var inductionVariable_10 = 0;
              if (inductionVariable_10 < bitCount_4)
                do {
                  var j_4 = inductionVariable_10;
                  inductionVariable_10 = inductionVariable_10 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_8 = bitwiseAnd(slot_4, new Long(255, 0));
                  if (compare(value_8, new Long(128, 0)) < 0) {
                    var index_4 = (i_4 << 3) + j_4 | 0;
                    this_13.x12_1[index_4];
                    var value_9 = this_13.y12_1[index_4];
                    var tmp_1;
                    if (value_9 instanceof MutableScatterSet) {
                      var set_0 = value_9 instanceof MutableScatterSet ? value_9 : THROW_CCE();
                      // Inline function 'androidx.collection.MutableScatterSet.removeIf' call
                      var elements_3 = set_0.k16_1;
                      $l$block_4: {
                        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                        // Inline function 'kotlin.contracts.contract' call
                        var m_5 = set_0.j16_1;
                        var lastIndex_5 = m_5.length - 2 | 0;
                        var inductionVariable_11 = 0;
                        if (inductionVariable_11 <= lastIndex_5)
                          do {
                            var i_5 = inductionVariable_11;
                            inductionVariable_11 = inductionVariable_11 + 1 | 0;
                            var slot_5 = m_5[i_5];
                            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                            var this_15 = slot_5;
                            var tmp$ret$56 = bitwiseAnd(bitwiseAnd(this_15, shiftLeft(invert(this_15), 7)), new Long(-2139062144, -2139062144));
                            if (!equalsLong(tmp$ret$56, new Long(-2139062144, -2139062144))) {
                              var bitCount_5 = 8 - (~(i_5 - lastIndex_5 | 0) >>> 31 | 0) | 0;
                              var inductionVariable_12 = 0;
                              if (inductionVariable_12 < bitCount_5)
                                do {
                                  var j_5 = inductionVariable_12;
                                  inductionVariable_12 = inductionVariable_12 + 1 | 0;
                                  // Inline function 'androidx.collection.isFull' call
                                  var value_10 = bitwiseAnd(slot_5, new Long(255, 0));
                                  if (compare(value_10, new Long(128, 0)) < 0) {
                                    var index_5 = (i_5 << 3) + j_5 | 0;
                                    var scope_1 = elements_3[index_5];
                                    if (invalidatedScopes.m1(scope_1)) {
                                      set_0.j11(index_5);
                                    }
                                  }
                                  slot_5 = shiftRight(slot_5, 8);
                                }
                                 while (inductionVariable_12 < bitCount_5);
                              if (!(bitCount_5 === 8)) {
                                break $l$block_4;
                              }
                            }
                          }
                           while (!(i_5 === lastIndex_5));
                      }
                      tmp_1 = set_0.r();
                    } else {
                      var scope_2 = !(value_9 == null) ? value_9 : THROW_CCE();
                      tmp_1 = invalidatedScopes.m1(scope_2);
                    }
                    if (tmp_1) {
                      this_13.hw(index_4);
                    }
                  }
                  slot_4 = shiftRight(slot_4, 8);
                }
                 while (inductionVariable_10 < bitCount_4);
              if (!(bitCount_4 === 8)) {
                break $l$block_5;
              }
            }
          }
           while (!(i_4 === lastIndex_4));
      }
      cleanUpDerivedStateObservations($this);
      invalidatedScopes.c3();
    }
  }
  function cleanUpDerivedStateObservations($this) {
    // Inline function 'androidx.compose.runtime.collection.ScopeMap.removeScopeIf' call
    var this_0 = $this.y36_1;
    // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
    var this_1 = _ScopeMap___get_map__impl__vxhazm(this_0);
    $l$block_0: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_1.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_2 = slot;
          var tmp$ret$3 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$3, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  this_1.x12_1[index];
                  var value_0 = this_1.y12_1[index];
                  var tmp;
                  if (value_0 instanceof MutableScatterSet) {
                    var set = value_0 instanceof MutableScatterSet ? value_0 : THROW_CCE();
                    // Inline function 'androidx.collection.MutableScatterSet.removeIf' call
                    var elements = set.k16_1;
                    $l$block: {
                      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                      // Inline function 'kotlin.contracts.contract' call
                      var m_0 = set.j16_1;
                      var lastIndex_0 = m_0.length - 2 | 0;
                      var inductionVariable_1 = 0;
                      if (inductionVariable_1 <= lastIndex_0)
                        do {
                          var i_0 = inductionVariable_1;
                          inductionVariable_1 = inductionVariable_1 + 1 | 0;
                          var slot_0 = m_0[i_0];
                          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                          var this_3 = slot_0;
                          var tmp$ret$10 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
                          if (!equalsLong(tmp$ret$10, new Long(-2139062144, -2139062144))) {
                            var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                            var inductionVariable_2 = 0;
                            if (inductionVariable_2 < bitCount_0)
                              do {
                                var j_0 = inductionVariable_2;
                                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                // Inline function 'androidx.collection.isFull' call
                                var value_1 = bitwiseAnd(slot_0, new Long(255, 0));
                                if (compare(value_1, new Long(128, 0)) < 0) {
                                  var index_0 = (i_0 << 3) + j_0 | 0;
                                  var derivedState = elements[index_0];
                                  if (!ScopeMap__contains_impl_6qp7s6($this.v36_1, derivedState)) {
                                    set.j11(index_0);
                                  }
                                }
                                slot_0 = shiftRight(slot_0, 8);
                              }
                               while (inductionVariable_2 < bitCount_0);
                            if (!(bitCount_0 === 8)) {
                              break $l$block;
                            }
                          }
                        }
                         while (!(i_0 === lastIndex_0));
                    }
                    tmp = set.r();
                  } else {
                    var derivedState_0 = !(value_0 == null) ? value_0 : THROW_CCE();
                    tmp = !ScopeMap__contains_impl_6qp7s6($this.v36_1, derivedState_0);
                  }
                  if (tmp) {
                    this_1.hw(index);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i === lastIndex));
    }
    if ($this.x36_1.fv()) {
      // Inline function 'androidx.collection.MutableScatterSet.removeIf' call
      var this_4 = $this.x36_1;
      var elements_0 = this_4.k16_1;
      $l$block_1: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m_1 = this_4.j16_1;
        var lastIndex_1 = m_1.length - 2 | 0;
        var inductionVariable_3 = 0;
        if (inductionVariable_3 <= lastIndex_1)
          do {
            var i_1 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var slot_1 = m_1[i_1];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_5 = slot_1;
            var tmp$ret$18 = bitwiseAnd(bitwiseAnd(this_5, shiftLeft(invert(this_5), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$18, new Long(-2139062144, -2139062144))) {
              var bitCount_1 = 8 - (~(i_1 - lastIndex_1 | 0) >>> 31 | 0) | 0;
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < bitCount_1)
                do {
                  var j_1 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_2 = bitwiseAnd(slot_1, new Long(255, 0));
                  if (compare(value_2, new Long(128, 0)) < 0) {
                    var index_1 = (i_1 << 3) + j_1 | 0;
                    if (!elements_0[index_1].q37()) {
                      this_4.j11(index_1);
                    }
                  }
                  slot_1 = shiftRight(slot_1, 8);
                }
                 while (inductionVariable_4 < bitCount_1);
              if (!(bitCount_1 === 8)) {
                break $l$block_1;
              }
            }
          }
           while (!(i_1 === lastIndex_1));
      }
    }
  }
  function invalidateScopeOfLocked($this, value) {
    // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
    var this_0 = $this.v36_1;
    var value_0 = _ScopeMap___get_map__impl__vxhazm(this_0).w2(value);
    if (value_0 != null) {
      if (value_0 instanceof MutableScatterSet) {
        // Inline function 'androidx.collection.ScatterSet.forEach' call
        var this_1 = value_0 instanceof MutableScatterSet ? value_0 : THROW_CCE();
        // Inline function 'kotlin.contracts.contract' call
        var elements = this_1.k16_1;
        $l$block: {
          // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
          // Inline function 'kotlin.contracts.contract' call
          var m = this_1.j16_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_2 = slot;
              var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value_1 = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value_1, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var scope = elements[index];
                      if (scope.r37(value).equals(InvalidationResult_IMMINENT_getInstance())) {
                        ScopeMap__add_impl_n8b3uc($this.b37_1, value, scope);
                      }
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
      } else {
        var scope_0 = !(value_0 == null) ? value_0 : THROW_CCE();
        if (scope_0.r37(value).equals(InvalidationResult_IMMINENT_getInstance())) {
          ScopeMap__add_impl_n8b3uc($this.b37_1, value, scope_0);
        }
      }
    }
  }
  function applyChangesInLocked($this, changes) {
    $this.j37_1.e38($this.t36_1, $this.k37_1.s32());
    try {
      if (changes.r())
        return Unit_instance;
      var tmp0_safe_receiver = $this.f37_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q38_1;
      var applier = tmp1_elvis_lhs == null ? $this.q36_1 : tmp1_elvis_lhs;
      var tmp;
      var tmp2_safe_receiver = $this.f37_1;
      if (equals(applier, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.q38_1)) {
        tmp = 'Compose:recordChanges';
      } else {
        tmp = 'Compose:applyChanges';
      }
      var traceName = tmp;
      $l$block: {
        // Inline function 'androidx.compose.runtime.internal.trace' call
        var token = Trace_instance.r38(traceName);
        try {
          var tmp0_safe_receiver_0 = $this.f37_1;
          var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.p38_1;
          var rememberManager = tmp1_elvis_lhs_0 == null ? $this.j37_1 : tmp1_elvis_lhs_0;
          applier.f2y();
          changes.s38($this.u36_1, applier, rememberManager, $this.k37_1.s32());
          applier.g2y();
          break $l$block;
        }finally {
          Trace_instance.t38(token);
        }
      }
      $this.j37_1.u38();
      $this.j37_1.v38();
      if ($this.d37_1) {
        var tmp0 = 'Compose:unobserve';
        $l$block_2: {
          // Inline function 'androidx.compose.runtime.internal.trace' call
          var token_0 = Trace_instance.r38(tmp0);
          try {
            $this.d37_1 = false;
            // Inline function 'androidx.compose.runtime.collection.ScopeMap.removeScopeIf' call
            var this_0 = $this.v36_1;
            // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
            var this_1 = _ScopeMap___get_map__impl__vxhazm(this_0);
            $l$block_1: {
              // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
              var m = this_1.w12_1;
              var lastIndex = m.length - 2 | 0;
              var inductionVariable = 0;
              if (inductionVariable <= lastIndex)
                do {
                  var i = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var slot = m[i];
                  // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                  var this_2 = slot;
                  var tmp$ret$7 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
                  if (!equalsLong(tmp$ret$7, new Long(-2139062144, -2139062144))) {
                    var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < bitCount)
                      do {
                        var j = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'androidx.collection.isFull' call
                        var value = bitwiseAnd(slot, new Long(255, 0));
                        if (compare(value, new Long(128, 0)) < 0) {
                          var index = (i << 3) + j | 0;
                          this_1.x12_1[index];
                          var value_0 = this_1.y12_1[index];
                          var tmp_0;
                          if (value_0 instanceof MutableScatterSet) {
                            var set = value_0 instanceof MutableScatterSet ? value_0 : THROW_CCE();
                            // Inline function 'androidx.collection.MutableScatterSet.removeIf' call
                            var elements = set.k16_1;
                            $l$block_0: {
                              // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                              // Inline function 'kotlin.contracts.contract' call
                              var m_0 = set.j16_1;
                              var lastIndex_0 = m_0.length - 2 | 0;
                              var inductionVariable_1 = 0;
                              if (inductionVariable_1 <= lastIndex_0)
                                do {
                                  var i_0 = inductionVariable_1;
                                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                                  var slot_0 = m_0[i_0];
                                  // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                                  var this_3 = slot_0;
                                  var tmp$ret$14 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
                                  if (!equalsLong(tmp$ret$14, new Long(-2139062144, -2139062144))) {
                                    var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                                    var inductionVariable_2 = 0;
                                    if (inductionVariable_2 < bitCount_0)
                                      do {
                                        var j_0 = inductionVariable_2;
                                        inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                        // Inline function 'androidx.collection.isFull' call
                                        var value_1 = bitwiseAnd(slot_0, new Long(255, 0));
                                        if (compare(value_1, new Long(128, 0)) < 0) {
                                          var index_0 = (i_0 << 3) + j_0 | 0;
                                          if (!elements[index_0].d2y()) {
                                            set.j11(index_0);
                                          }
                                        }
                                        slot_0 = shiftRight(slot_0, 8);
                                      }
                                       while (inductionVariable_2 < bitCount_0);
                                    if (!(bitCount_0 === 8)) {
                                      break $l$block_0;
                                    }
                                  }
                                }
                                 while (!(i_0 === lastIndex_0));
                            }
                            tmp_0 = set.r();
                          } else {
                            tmp_0 = !(!(value_0 == null) ? value_0 : THROW_CCE()).d2y();
                          }
                          if (tmp_0) {
                            this_1.hw(index);
                          }
                        }
                        slot = shiftRight(slot, 8);
                      }
                       while (inductionVariable_0 < bitCount);
                    if (!(bitCount === 8)) {
                      break $l$block_1;
                    }
                  }
                }
                 while (!(i === lastIndex));
            }
            cleanUpDerivedStateObservations($this);
            break $l$block_2;
          }finally {
            Trace_instance.t38(token_0);
          }
        }
      }
    }finally {
      try {
        if ($this.a37_1.r() && $this.f37_1 == null) {
          $this.j37_1.w38();
        }
      }finally {
        $this.j37_1.c3();
      }
    }
  }
  function tryImminentInvalidation($this, scope, instance) {
    return $this.x38() && $this.k37_1.f33(scope, instance);
  }
  function invalidateChecked($this, scope, anchor, instance) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.s36_1;
    var tmp0_safe_receiver = $this.g37_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      if ($this.u36_1.y38($this.h37_1, anchor)) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var delegate = tmp;
    if (delegate == null) {
      if (tryImminentInvalidation($this, scope, instance)) {
        return InvalidationResult_IMMINENT_getInstance();
      }
      if (instance == null) {
        ScopeMap__set_impl_3y8kbx($this.c37_1, scope, ScopeInvalidated_instance);
      } else {
        if (!isInterface(instance, DerivedState)) {
          ScopeMap__set_impl_3y8kbx($this.c37_1, scope, ScopeInvalidated_instance);
        } else {
          var tmp0 = $this.c37_1;
          var tmp$ret$4;
          $l$block_1: {
            // Inline function 'androidx.compose.runtime.collection.ScopeMap.anyScopeOf' call
            // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
            var value = _ScopeMap___get_map__impl__vxhazm(tmp0).w2(scope);
            if (value != null) {
              if (value instanceof MutableScatterSet) {
                // Inline function 'androidx.collection.ScatterSet.forEach' call
                var this_0 = value instanceof MutableScatterSet ? value : THROW_CCE();
                // Inline function 'kotlin.contracts.contract' call
                var elements = this_0.k16_1;
                $l$block_0: {
                  // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                  // Inline function 'kotlin.contracts.contract' call
                  var m = this_0.j16_1;
                  var lastIndex = m.length - 2 | 0;
                  var inductionVariable = 0;
                  if (inductionVariable <= lastIndex)
                    do {
                      var i = inductionVariable;
                      inductionVariable = inductionVariable + 1 | 0;
                      var slot = m[i];
                      // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                      var this_1 = slot;
                      var tmp$ret$10 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
                      if (!equalsLong(tmp$ret$10, new Long(-2139062144, -2139062144))) {
                        var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                        var inductionVariable_0 = 0;
                        if (inductionVariable_0 < bitCount)
                          do {
                            var j = inductionVariable_0;
                            inductionVariable_0 = inductionVariable_0 + 1 | 0;
                            // Inline function 'androidx.collection.isFull' call
                            var value_0 = bitwiseAnd(slot, new Long(255, 0));
                            if (compare(value_0, new Long(128, 0)) < 0) {
                              var index = (i << 3) + j | 0;
                              if (elements[index] === ScopeInvalidated_instance) {
                                tmp$ret$4 = true;
                                break $l$block_1;
                              }
                            }
                            slot = shiftRight(slot, 8);
                          }
                           while (inductionVariable_0 < bitCount);
                        if (!(bitCount === 8)) {
                          break $l$block_0;
                        }
                      }
                    }
                     while (!(i === lastIndex));
                }
              } else {
                if ((!(value == null) ? value : THROW_CCE()) === ScopeInvalidated_instance) {
                  tmp$ret$4 = true;
                  break $l$block_1;
                }
              }
            }
            tmp$ret$4 = false;
          }
          if (!tmp$ret$4) {
            ScopeMap__add_impl_n8b3uc($this.c37_1, scope, instance);
          }
        }
      }
    }
    var delegate_0 = delegate;
    if (!(delegate_0 == null)) {
      return invalidateChecked(delegate_0, scope, anchor, instance);
    }
    $this.p36_1.z38($this);
    return $this.x38() ? InvalidationResult_DEFERRED_getInstance() : InvalidationResult_SCHEDULED_getInstance();
  }
  function takeInvalidations($this) {
    var invalidations = $this.c37_1;
    $this.c37_1 = _ScopeMap___init__impl__52wntz();
    return invalidations;
  }
  function observer($this) {
    return $this.i37_1.d39();
  }
  function access$_get_invalidations__kity90($this) {
    return $this.c37_1;
  }
  function CompositionImpl(parent, applier) {
    this.p36_1 = parent;
    this.q36_1 = applier;
    this.r36_1 = new AtomicReference(null);
    var tmp = this;
    // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
    tmp.s36_1 = null == null ? new Object() : null;
    this.t36_1 = (new MutableScatterSet()).k11();
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    var this_0 = createSlotStorage(this);
    if (this.p36_1.e39()) {
      this_0.v34();
    }
    if (this.p36_1.f39()) {
      this_0.t34();
    }
    tmp_0.u36_1 = this_0;
    this.v36_1 = _ScopeMap___init__impl__52wntz();
    this.w36_1 = new MutableScatterSet();
    this.x36_1 = new MutableScatterSet();
    this.y36_1 = _ScopeMap___init__impl__52wntz();
    this.z36_1 = createChangeList(this);
    this.a37_1 = createChangeList(this);
    this.b37_1 = _ScopeMap___init__impl__52wntz();
    this.c37_1 = _ScopeMap___init__impl__52wntz();
    this.d37_1 = false;
    this.e37_1 = null;
    this.f37_1 = null;
    this.g37_1 = null;
    this.h37_1 = 0;
    this.i37_1 = new CompositionObserverHolder(VOID, VOID, this.p36_1);
    this.j37_1 = new RememberEventDispatcher();
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var this_1 = createComposer(this);
    this.p36_1.g39(this_1);
    tmp_1.k37_1 = this_1;
    var tmp_2 = this;
    var tmp_3 = this.p36_1;
    tmp_2.l37_1 = tmp_3 instanceof Recomposer;
    this.m37_1 = 0;
    this.n37_1 = ComposableSingletons$CompositionKt_getInstance().h39_1;
  }
  protoOf(CompositionImpl).x38 = function () {
    return this.k37_1.q32();
  };
  protoOf(CompositionImpl).j39 = function () {
    return this.m37_1 === 3;
  };
  protoOf(CompositionImpl).k39 = function (content) {
    var wasDeactivated = clearDeactivated(this);
    ensureRunning(this);
    if (wasDeactivated) {
      composeInitialWithReuse(this, content);
    } else {
      composeInitial(this, content);
    }
  };
  protoOf(CompositionImpl).l39 = function (content) {
    clearDeactivated(this);
    ensureRunning(this);
    composeInitialWithReuse(this, content);
  };
  protoOf(CompositionImpl).m39 = function (content) {
    var wasDeactivated = clearDeactivated(this);
    return composeInitialPaused(this, wasDeactivated, content);
  };
  protoOf(CompositionImpl).n39 = function (content) {
    clearDeactivated(this);
    ensureRunning(this);
    return composeInitialPaused(this, true, content);
  };
  protoOf(CompositionImpl).o39 = function (ignoreSet) {
    this.f37_1 = null;
    if (!(ignoreSet == null)) {
      this.j37_1.p39(ignoreSet);
      this.m37_1 = 2;
    }
  };
  protoOf(CompositionImpl).q39 = function (content) {
    // Inline function 'androidx.compose.runtime.CompositionImpl.guardChanges' call
    try {
      // Inline function 'androidx.compose.runtime.CompositionImpl.trackAbandonedValues' call
      var success = false;
      var tmp;
      try {
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        this.s36_1;
        drainPendingModificationsForCompositionLocked(this);
        // Inline function 'androidx.compose.runtime.CompositionImpl.guardInvalidationsLocked' call
        var invalidations = takeInvalidations(this);
        try {
          this.k37_1.d33(invalidations, content, this.e37_1);
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            this.c37_1 = invalidations;
            throw e;
          } else {
            throw $p;
          }
        }
        // Inline function 'kotlin.also' call
        success = true;
        tmp = Unit_instance;
      }finally {
        var tmp_0;
        if (!success) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !this.t36_1.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp0 = this.j37_1;
          var tmp2 = this.t36_1;
          // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
          var traceContext = this.k37_1.s32();
          try {
            tmp0.e38(tmp2, traceContext);
            tmp0.w38();
          }finally {
            tmp0.c3();
          }
        }
      }
    } catch ($p_0) {
      if ($p_0 instanceof Error) {
        var e_0 = $p_0;
        this.r39();
        throw e_0;
      } else {
        throw $p_0;
      }
    }
  };
  protoOf(CompositionImpl).s39 = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    drainPendingModificationsOutOfBandLocked(this);
    // Inline function 'androidx.compose.runtime.CompositionImpl.guardInvalidationsLocked' call
    var invalidations = takeInvalidations(this);
    try {
      this.k37_1.g33(invalidations);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this.c37_1 = invalidations;
        throw e;
      } else {
        throw $p;
      }
    }
  };
  protoOf(CompositionImpl).s1d = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!!this.k37_1.q32()) {
      var tmp$ret$3 = 'Composition is disposed while composing. If dispose is triggered by a call in @Composable function, consider wrapping it with SideEffect block.';
      throwIllegalStateException(tmp$ret$3);
    }
    if (!(this.m37_1 === 3)) {
      this.m37_1 = 3;
      this.n37_1 = ComposableSingletons$CompositionKt_getInstance().i39_1;
      var deferredChanges = this.k37_1.t32();
      if (!(deferredChanges == null)) {
        applyChangesInLocked(this, deferredChanges);
      }
      var nonEmptySlotTable = !this.u36_1.oy();
      var tmp;
      if (nonEmptySlotTable) {
        tmp = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !this.t36_1.r();
      }
      if (tmp) {
        var tmp0 = this.j37_1;
        var tmp2 = this.t36_1;
        // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
        var traceContext = this.k37_1.s32();
        try {
          tmp0.e38(tmp2, traceContext);
          if (nonEmptySlotTable) {
            this.q36_1.f2y();
            this.u36_1.t39(this.j37_1);
            this.q36_1.c3();
            this.q36_1.g2y();
            tmp0.u38();
          }
          tmp0.w38();
        }finally {
          tmp0.c3();
        }
      }
      this.k37_1.y32();
    }
    this.p36_1.u39(this);
  };
  protoOf(CompositionImpl).v39 = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    return _ScopeMap___get_size__impl__f25bvl(this.c37_1) > 0;
  };
  protoOf(CompositionImpl).w39 = function (values) {
    $l$loop: while (true) {
      var old = this.r36_1.f1i();
      var tmp;
      if (old == null || equals(old, get_PendingApplyNoModifications())) {
        tmp = values;
      } else {
        if (isInterface(old, KtSet)) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = [old, values];
        } else {
          if (isArray(old)) {
            tmp = plus_2(isArray(old) ? old : THROW_CCE(), values);
          } else {
            // Inline function 'kotlin.error' call
            var message = 'corrupt pendingModifications: ' + toString(this.r36_1);
            throw IllegalStateException_init_$Create$(toString(message));
          }
        }
      }
      var new_0 = tmp;
      if (this.r36_1.w21(old, new_0)) {
        if (old == null) {
          // Inline function 'androidx.compose.runtime.platform.synchronized' call
          this.s36_1;
          drainPendingModificationsLocked(this);
        }
        break $l$loop;
      }
    }
  };
  protoOf(CompositionImpl).x39 = function (values) {
    // Inline function 'androidx.compose.runtime.collection.fastForEach' call
    var tmp;
    if (values instanceof ScatterSetWrapper) {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      var this_0 = values.s37_1;
      // Inline function 'kotlin.contracts.contract' call
      var elements = this_0.k16_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = this_0.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var value_0 = elements[index];
                    if (ScopeMap__contains_impl_6qp7s6(this.v36_1, value_0) || ScopeMap__contains_impl_6qp7s6(this.y36_1, value_0))
                      return true;
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = values.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (ScopeMap__contains_impl_6qp7s6(this.v36_1, element) || ScopeMap__contains_impl_6qp7s6(this.y36_1, element))
          return true;
      }
      tmp = Unit_instance;
    }
    return false;
  };
  protoOf(CompositionImpl).y39 = function (block) {
    return this.k37_1.c33(block);
  };
  protoOf(CompositionImpl).z39 = function (anchor) {
    var tmp;
    if (_ScopeMap___get_size__impl__f25bvl(this.c37_1) > 0) {
      // Inline function 'kotlin.collections.mutableListOf' call
      var result = ArrayList_init_$Create$();
      var slotStorage = this.u36_1;
      // Inline function 'androidx.compose.runtime.collection.ScopeMap.removeIf' call
      var this_0 = this.c37_1;
      // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
      var this_1 = _ScopeMap___get_map__impl__vxhazm(this_0);
      $l$block_0: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = this_1.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_2 = slot;
            var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var tmp0 = this_1.x12_1[index];
                    var scopes = this_1.y12_1[index];
                    if (tmp0 == null)
                      THROW_CCE();
                    var tmp_0;
                    if (scopes instanceof MutableScatterSet) {
                      if (!(scopes instanceof MutableScatterSet))
                        THROW_CCE();
                      // Inline function 'androidx.collection.MutableScatterSet.removeIf' call
                      var elements = scopes.k16_1;
                      $l$block: {
                        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                        // Inline function 'kotlin.contracts.contract' call
                        var m_0 = scopes.j16_1;
                        var lastIndex_0 = m_0.length - 2 | 0;
                        var inductionVariable_1 = 0;
                        if (inductionVariable_1 <= lastIndex_0)
                          do {
                            var i_0 = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            var slot_0 = m_0[i_0];
                            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                            var this_3 = slot_0;
                            var tmp$ret$11 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
                            if (!equalsLong(tmp$ret$11, new Long(-2139062144, -2139062144))) {
                              var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                              var inductionVariable_2 = 0;
                              if (inductionVariable_2 < bitCount_0)
                                do {
                                  var j_0 = inductionVariable_2;
                                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                  // Inline function 'androidx.collection.isFull' call
                                  var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                                  if (compare(value_0, new Long(128, 0)) < 0) {
                                    var index_0 = (i_0 << 3) + j_0 | 0;
                                    var value_1 = elements[index_0];
                                    var scopeAnchor = tmp0.m35_1;
                                    var tmp_1;
                                    if (!(scopeAnchor == null) && slotStorage.a3a(anchor, scopeAnchor)) {
                                      result.j1(to(tmp0, value_1));
                                      tmp_1 = true;
                                    } else {
                                      tmp_1 = false;
                                    }
                                    if (tmp_1) {
                                      scopes.j11(index_0);
                                    }
                                  }
                                  slot_0 = shiftRight(slot_0, 8);
                                }
                                 while (inductionVariable_2 < bitCount_0);
                              if (!(bitCount_0 === 8)) {
                                break $l$block;
                              }
                            }
                          }
                           while (!(i_0 === lastIndex_0));
                      }
                      tmp_0 = scopes.r();
                    } else {
                      var value_2 = !(scopes == null) ? scopes : THROW_CCE();
                      var scopeAnchor_0 = tmp0.m35_1;
                      var tmp_2;
                      if (!(scopeAnchor_0 == null) && slotStorage.a3a(anchor, scopeAnchor_0)) {
                        result.j1(to(tmp0, value_2));
                        tmp_2 = true;
                      } else {
                        tmp_2 = false;
                      }
                      tmp_0 = tmp_2;
                    }
                    if (tmp_0) {
                      this_1.hw(index);
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i === lastIndex));
      }
      tmp = result;
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  protoOf(CompositionImpl).k36 = function (value) {
    if (!_get_areChildrenComposing__c1uwup(this)) {
      var tmp0_safe_receiver = this.k37_1.r32();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp0_safe_receiver.b3a(true);
        var alreadyRead = tmp0_safe_receiver.c3a(value);
        var tmp0_safe_receiver_0 = observer(this);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.d3a(tmp0_safe_receiver, value);
        }
        if (!alreadyRead) {
          if (value instanceof StateObjectImpl) {
            // Inline function 'androidx.compose.runtime.snapshots.Companion.Composition' call
            var tmp$ret$2 = _ReaderKind___init__impl__jqeebu(1);
            value.f3a(tmp$ret$2);
          }
          ScopeMap__add_impl_n8b3uc(this.v36_1, value, tmp0_safe_receiver);
          if (isInterface(value, DerivedState)) {
            var record = value.g3a();
            ScopeMap__removeScope_impl_8k6ux1(this.y36_1, value);
            // Inline function 'androidx.collection.ObjectIntMap.forEachKey' call
            var this_0 = record.h3a();
            var k = this_0.ez_1;
            $l$block: {
              // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
              var m = this_0.dz_1;
              var lastIndex = m.length - 2 | 0;
              var inductionVariable = 0;
              if (inductionVariable <= lastIndex)
                do {
                  var i = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var slot = m[i];
                  // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                  var this_1 = slot;
                  var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
                  if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
                    var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < bitCount)
                      do {
                        var j = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'androidx.collection.isFull' call
                        var value_0 = bitwiseAnd(slot, new Long(255, 0));
                        if (compare(value_0, new Long(128, 0)) < 0) {
                          var index = (i << 3) + j | 0;
                          var dependency = k[index];
                          if (dependency instanceof StateObjectImpl) {
                            // Inline function 'androidx.compose.runtime.snapshots.Companion.Composition' call
                            var tmp$ret$9 = _ReaderKind___init__impl__jqeebu(1);
                            dependency.f3a(tmp$ret$9);
                          }
                          ScopeMap__add_impl_n8b3uc(this.y36_1, dependency, value);
                        }
                        slot = shiftRight(slot, 8);
                      }
                       while (inductionVariable_0 < bitCount);
                    if (!(bitCount === 8)) {
                      break $l$block;
                    }
                  }
                }
                 while (!(i === lastIndex));
            }
            tmp0_safe_receiver.j3a(value, record.i3a());
          }
        }
      }
    }
  };
  protoOf(CompositionImpl).k3a = function (value) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    invalidateScopeOfLocked(this, value);
    // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
    var this_0 = this.y36_1;
    var value_0 = _ScopeMap___get_map__impl__vxhazm(this_0).w2(value);
    if (value_0 != null) {
      if (value_0 instanceof MutableScatterSet) {
        // Inline function 'androidx.collection.ScatterSet.forEach' call
        var this_1 = value_0 instanceof MutableScatterSet ? value_0 : THROW_CCE();
        // Inline function 'kotlin.contracts.contract' call
        var elements = this_1.k16_1;
        $l$block: {
          // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
          // Inline function 'kotlin.contracts.contract' call
          var m = this_1.j16_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_2 = slot;
              var tmp$ret$7 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$7, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value_1 = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value_1, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var it = elements[index];
                      invalidateScopeOfLocked(this, it);
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
      } else {
        var it_0 = !(value_0 == null) ? value_0 : THROW_CCE();
        invalidateScopeOfLocked(this, it_0);
      }
    }
    return Unit_instance;
  };
  protoOf(CompositionImpl).l3a = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    var pendingPausedComposition = this.f37_1;
    if (!(pendingPausedComposition == null) && !pendingPausedComposition.r3a()) {
      pendingPausedComposition.m3a();
      pendingPausedComposition.q38_1.q3a();
      return false;
    }
    drainPendingModificationsForCompositionLocked(this);
    // Inline function 'androidx.compose.runtime.CompositionImpl.guardChanges' call
    var tmp;
    try {
      // Inline function 'androidx.compose.runtime.CompositionImpl.trackAbandonedValues' call
      var success = false;
      var tmp_0;
      try {
        // Inline function 'androidx.compose.runtime.CompositionImpl.guardInvalidationsLocked' call
        var invalidations = takeInvalidations(this);
        var tmp_1;
        try {
          // Inline function 'kotlin.also' call
          var this_0 = this.k37_1.e33(invalidations, this.e37_1);
          if (!this_0) {
            drainPendingModificationsLocked(this);
          }
          tmp_1 = this_0;
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var e = $p;
            this.c37_1 = invalidations;
            throw e;
          } else {
            throw $p;
          }
        }
        // Inline function 'kotlin.also' call
        success = true;
        tmp_0 = tmp_1;
      }finally {
        var tmp_3;
        if (!success) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_3 = !this.t36_1.r();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          var tmp0 = this.j37_1;
          var tmp2 = this.t36_1;
          // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
          var traceContext = this.k37_1.s32();
          try {
            tmp0.e38(tmp2, traceContext);
            tmp0.w38();
          }finally {
            tmp0.c3();
          }
        }
      }
      tmp = tmp_0;
    } catch ($p_0) {
      var tmp_4;
      if ($p_0 instanceof Error) {
        var e_0 = $p_0;
        this.r39();
        throw e_0;
      } else {
        throw $p_0;
      }
    }
    return tmp;
  };
  protoOf(CompositionImpl).s3a = function (references) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.fastAll' call
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = references.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = references.l1(index);
          if (!equals(item.xh_1.e35_1, this)) {
            tmp$ret$0 = false;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = true;
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!tmp$ret$0) {
      var tmp$ret$6 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$6);
    }
    // Inline function 'androidx.compose.runtime.CompositionImpl.guardChanges' call
    try {
      // Inline function 'androidx.compose.runtime.CompositionImpl.trackAbandonedValues' call
      var success = false;
      var tmp;
      try {
        this.k37_1.v30(references);
        // Inline function 'kotlin.also' call
        success = true;
        tmp = Unit_instance;
      }finally {
        var tmp_0;
        if (!success) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !this.t36_1.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp0 = this.j37_1;
          var tmp2 = this.t36_1;
          // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
          var traceContext = this.k37_1.s32();
          try {
            tmp0.e38(tmp2, traceContext);
            tmp0.w38();
          }finally {
            tmp0.c3();
          }
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this.r39();
        throw e;
      } else {
        throw $p;
      }
    }
  };
  protoOf(CompositionImpl).t3a = function (state) {
    var tmp0 = this.j37_1;
    var tmp2 = this.t36_1;
    // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
    var traceContext = this.k37_1.s32();
    try {
      tmp0.e38(tmp2, traceContext);
      state.u3a_1.v3a(this.j37_1, state);
      tmp0.u38();
    }finally {
      tmp0.c3();
    }
  };
  protoOf(CompositionImpl).w3a = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    // Inline function 'androidx.compose.runtime.CompositionImpl.guardChanges' call
    try {
      // Inline function 'androidx.compose.runtime.CompositionImpl.trackAbandonedValues' call
      var success = false;
      var tmp;
      try {
        applyChangesInLocked(this, this.z36_1);
        drainPendingModificationsLocked(this);
        // Inline function 'kotlin.also' call
        success = true;
        tmp = Unit_instance;
      }finally {
        var tmp_0;
        if (!success) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !this.t36_1.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp0 = this.j37_1;
          var tmp2 = this.t36_1;
          // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
          var traceContext = this.k37_1.s32();
          try {
            tmp0.e38(tmp2, traceContext);
            tmp0.w38();
          }finally {
            tmp0.c3();
          }
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this.r39();
        throw e;
      } else {
        throw $p;
      }
    }
  };
  protoOf(CompositionImpl).x3a = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    // Inline function 'androidx.compose.runtime.CompositionImpl.guardChanges' call
    try {
      // Inline function 'androidx.compose.runtime.CompositionImpl.trackAbandonedValues' call
      var success = false;
      var tmp;
      try {
        if (this.a37_1.fv()) {
          applyChangesInLocked(this, this.a37_1);
        }
        // Inline function 'kotlin.also' call
        success = true;
        tmp = Unit_instance;
      }finally {
        var tmp_0;
        if (!success) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !this.t36_1.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp0 = this.j37_1;
          var tmp2 = this.t36_1;
          // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
          var traceContext = this.k37_1.s32();
          try {
            tmp0.e38(tmp2, traceContext);
            tmp0.w38();
          }finally {
            tmp0.c3();
          }
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this.r39();
        throw e;
      } else {
        throw $p;
      }
    }
  };
  protoOf(CompositionImpl).y3a = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    // Inline function 'androidx.compose.runtime.CompositionImpl.guardChanges' call
    try {
      // Inline function 'androidx.compose.runtime.CompositionImpl.trackAbandonedValues' call
      var success = false;
      var tmp;
      try {
        this.k37_1.x32();
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.t36_1.r()) {
          var tmp0 = this.j37_1;
          var tmp2 = this.t36_1;
          // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
          var traceContext = this.k37_1.s32();
          try {
            tmp0.e38(tmp2, traceContext);
            tmp0.w38();
          }finally {
            tmp0.c3();
          }
        }
        // Inline function 'kotlin.also' call
        success = true;
        tmp = Unit_instance;
      }finally {
        var tmp_0;
        if (!success) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !this.t36_1.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp0_0 = this.j37_1;
          var tmp2_0 = this.t36_1;
          // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
          var traceContext_0 = this.k37_1.s32();
          try {
            tmp0_0.e38(tmp2_0, traceContext_0);
            tmp0_0.w38();
          }finally {
            tmp0_0.c3();
          }
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this.r39();
        throw e;
      } else {
        throw $p;
      }
    }
  };
  protoOf(CompositionImpl).r39 = function () {
    this.r36_1.k2p(null);
    this.z36_1.c3();
    this.a37_1.c3();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.t36_1.r()) {
      var tmp0 = this.j37_1;
      var tmp2 = this.t36_1;
      // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
      var traceContext = this.k37_1.s32();
      try {
        tmp0.e38(tmp2, traceContext);
        tmp0.w38();
      }finally {
        tmp0.c3();
      }
    }
  };
  protoOf(CompositionImpl).z3a = function () {
    this.u36_1.z3a();
  };
  protoOf(CompositionImpl).a3b = function (to, groupIndex, block) {
    var tmp;
    if (!(to == null) && !equals(to, this) && groupIndex >= 0) {
      var tmp_0 = this;
      tmp_0.g37_1 = to instanceof CompositionImpl ? to : THROW_CCE();
      this.h37_1 = groupIndex;
      var tmp_1;
      try {
        tmp_1 = block();
      }finally {
        this.g37_1 = null;
        this.h37_1 = 0;
      }
      tmp = tmp_1;
    } else {
      tmp = block();
    }
    return tmp;
  };
  protoOf(CompositionImpl).b3b = function (shouldPause) {
    var previous = this.e37_1;
    this.e37_1 = shouldPause;
    return previous;
  };
  protoOf(CompositionImpl).i36 = function (scope, instance) {
    if (scope.d3b()) {
      scope.c3b(true);
    }
    var anchor = scope.m35_1;
    if (anchor == null || !anchor.d2y())
      return InvalidationResult_IGNORED_getInstance();
    if (!this.u36_1.e3b(scope)) {
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this.s36_1;
      var delegate = this.g37_1;
      if ((delegate == null ? null : tryImminentInvalidation(delegate, scope, instance)) === true)
        return InvalidationResult_IMMINENT_getInstance();
      return InvalidationResult_IGNORED_getInstance();
    }
    if (!scope.f3b())
      return InvalidationResult_IGNORED_getInstance();
    // Inline function 'kotlin.also' call
    var this_0 = invalidateChecked(this, scope, anchor, instance);
    if (!this_0.equals(InvalidationResult_IGNORED_getInstance())) {
      var tmp0_safe_receiver = observer(this);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.g3b(scope, instance);
      }
    }
    return this_0;
  };
  protoOf(CompositionImpl).j36 = function (scope) {
    this.d37_1 = true;
    var tmp0_safe_receiver = observer(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.h3b(scope);
    }
  };
  protoOf(CompositionImpl).i3b = function (instance, scope) {
    ScopeMap__remove_impl_ocu4rj_0(this.v36_1, instance, scope);
  };
  protoOf(CompositionImpl).j3b = function (state) {
    if (!ScopeMap__contains_impl_6qp7s6(this.v36_1, state)) {
      ScopeMap__removeScope_impl_8k6ux1(this.y36_1, state);
    }
  };
  protoOf(CompositionImpl).k3b = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.s36_1;
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!(this.f37_1 == null)) {
      var tmp$ret$3 = 'Deactivate is not supported while pausable composition is in progress';
      throwIllegalStateException(tmp$ret$3);
    }
    var nonEmptySlotTable = !this.u36_1.oy();
    var tmp;
    if (nonEmptySlotTable) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !this.t36_1.r();
    }
    if (tmp) {
      var tmp0 = 'Compose:deactivate';
      $l$block: {
        // Inline function 'androidx.compose.runtime.internal.trace' call
        var token = Trace_instance.r38(tmp0);
        try {
          var tmp0_0 = this.j37_1;
          var tmp2 = this.t36_1;
          // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.use' call
          var traceContext = this.k37_1.s32();
          try {
            tmp0_0.e38(tmp2, traceContext);
            if (nonEmptySlotTable) {
              this.q36_1.f2y();
              this.u36_1.l3b(this.j37_1);
              this.q36_1.g2y();
              tmp0_0.u38();
            }
            tmp0_0.w38();
          }finally {
            tmp0_0.c3();
          }
          break $l$block;
        }finally {
          Trace_instance.t38(token);
        }
      }
    }
    ScopeMap__clear_impl_2jofm0(this.v36_1);
    ScopeMap__clear_impl_2jofm0(this.y36_1);
    ScopeMap__clear_impl_2jofm0(this.c37_1);
    this.z36_1.c3();
    this.a37_1.c3();
    this.k37_1.z32();
    this.m37_1 = 1;
  };
  function SlotStorage() {
  }
  function Changes() {
    DebugStringFormattable.call(this);
  }
  protoOf(Changes).fv = function () {
    return !this.r();
  };
  function CompositionObserverHolder(observer, root, parent) {
    observer = observer === VOID ? null : observer;
    root = root === VOID ? false : root;
    this.a39_1 = observer;
    this.b39_1 = root;
    this.c39_1 = parent;
  }
  protoOf(CompositionObserverHolder).d39 = function () {
    var tmp;
    if (this.b39_1) {
      tmp = this.a39_1;
    } else {
      var parentHolder = this.c39_1.n3b();
      var parentObserver = parentHolder == null ? null : parentHolder.a39_1;
      if (!equals(parentObserver, this.a39_1)) {
        this.a39_1 = parentObserver;
      }
      tmp = parentObserver;
    }
    return tmp;
  };
  function ComposableSingletons$CompositionKt$lambda$954879418$lambda($composer, $changed) {
    var $composer_0 = $composer;
    if (!$composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CompositionKt$lambda$1918065384$lambda($composer, $changed) {
    var $composer_0 = $composer;
    if (!$composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CompositionKt() {
    ComposableSingletons$CompositionKt_instance = this;
    var tmp = this;
    tmp.h39_1 = ComposableLambda$invoke$ref(composableLambdaInstance(954879418, false, ComposableSingletons$CompositionKt$lambda$954879418$lambda));
    var tmp_0 = this;
    tmp_0.i39_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1918065384, false, ComposableSingletons$CompositionKt$lambda$1918065384$lambda));
  }
  var ComposableSingletons$CompositionKt_instance;
  function ComposableSingletons$CompositionKt_getInstance() {
    if (ComposableSingletons$CompositionKt_instance == null)
      new ComposableSingletons$CompositionKt();
    return ComposableSingletons$CompositionKt_instance;
  }
  function ScopeInvalidated() {
  }
  var ScopeInvalidated_instance;
  function ScopeInvalidated_getInstance() {
    return ScopeInvalidated_instance;
  }
  function Composition(applier, parent) {
    _init_properties_Composition_kt__t5pjw8();
    return new CompositionImpl(parent, applier);
  }
  function ObservableCompositionServiceKey$1() {
  }
  var properties_initialized_Composition_kt_u7hvq2;
  function _init_properties_Composition_kt__t5pjw8() {
    if (!properties_initialized_Composition_kt_u7hvq2) {
      properties_initialized_Composition_kt_u7hvq2 = true;
      PendingApplyNoModifications = new Object();
      ObservableCompositionServiceKey = new ObservableCompositionServiceKey$1();
      androidx_compose_runtime_SlotStorage$stable = 0;
      androidx_compose_runtime_Changes$stable = 0;
      androidx_compose_runtime_CompositionImpl$stable = 8;
      androidx_compose_runtime_ScopeInvalidated$stable = 0;
      androidx_compose_runtime_CompositionObserverHolder$stable = 8;
    }
  }
  function get_EmptyPersistentCompositionLocalMap() {
    _init_properties_CompositionContext_kt__4g1p1h();
    return EmptyPersistentCompositionLocalMap;
  }
  var EmptyPersistentCompositionLocalMap;
  var androidx_compose_runtime_CompositionContext$stable;
  function CompositionContext() {
  }
  protoOf(CompositionContext).n3b = function () {
    return null;
  };
  protoOf(CompositionContext).w3b = function (table) {
  };
  protoOf(CompositionContext).g39 = function (composer) {
  };
  protoOf(CompositionContext).x3b = function (composer) {
  };
  protoOf(CompositionContext).b30 = function () {
    return get_EmptyPersistentCompositionLocalMap();
  };
  protoOf(CompositionContext).y3b = function () {
  };
  protoOf(CompositionContext).z3b = function () {
  };
  protoOf(CompositionContext).d3c = function (reference) {
    return null;
  };
  var properties_initialized_CompositionContext_kt_mk393b;
  function _init_properties_CompositionContext_kt__4g1p1h() {
    if (!properties_initialized_CompositionContext_kt_mk393b) {
      properties_initialized_CompositionContext_kt_mk393b = true;
      EmptyPersistentCompositionLocalMap = persistentCompositionLocalHashMapOf();
      androidx_compose_runtime_CompositionContext$stable = 0;
    }
  }
  var androidx_compose_runtime_CompositionLocal$stable;
  var androidx_compose_runtime_ProvidableCompositionLocal$stable;
  var androidx_compose_runtime_DynamicProvidableCompositionLocal$stable;
  var androidx_compose_runtime_StaticProvidableCompositionLocal$stable;
  var androidx_compose_runtime_ComputedProvidableCompositionLocal$stable;
  var androidx_compose_runtime_CompositionLocalContext$stable;
  function valueHolderOf($this, value) {
    var tmp;
    if (value.i32_1) {
      var tmp0_elvis_lhs = value.g32_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp_1 = value.u1();
        var tmp1_elvis_lhs = value.f32_1;
        tmp_0 = mutableStateOf(tmp_1, tmp1_elvis_lhs == null ? structuralEqualityPolicy() : tmp1_elvis_lhs);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = new DynamicValueHolder(tmp_0);
    } else if (!(value.h32_1 == null)) {
      tmp = new ComputedValueHolder(value.h32_1);
    } else if (!(value.g32_1 == null)) {
      tmp = new DynamicValueHolder(value.g32_1);
    } else {
      tmp = new StaticValueHolder(value.l32());
    }
    return tmp;
  }
  function ProvidableCompositionLocal(defaultFactory) {
    CompositionLocal.call(this, defaultFactory);
  }
  protoOf(ProvidableCompositionLocal).h3c = function (value) {
    return this.g3c(value);
  };
  protoOf(ProvidableCompositionLocal).i3c = function (value) {
    return this.g3c(value).n32();
  };
  protoOf(ProvidableCompositionLocal).j3c = function (value, previous) {
    var tmp;
    if (previous instanceof DynamicValueHolder) {
      var tmp_0;
      if (value.i32_1) {
        previous.m3c_1.s21(value.l32());
        tmp_0 = previous;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    } else {
      if (previous instanceof StaticValueHolder) {
        tmp = value.m32() && equals(value.l32(), previous.l3c_1) ? previous : null;
      } else {
        if (previous instanceof ComputedValueHolder) {
          tmp = value.h32_1 === previous.k3c_1 ? previous : null;
        } else {
          tmp = null;
        }
      }
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? valueHolderOf(this, value) : tmp1_elvis_lhs;
  };
  function compositionLocalOf(policy, defaultFactory) {
    policy = policy === VOID ? structuralEqualityPolicy() : policy;
    return new DynamicProvidableCompositionLocal(policy, defaultFactory);
  }
  function CompositionLocalProvider(value, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-149765515);
    var $dirty = $changed;
    $composer_0.x31(value);
    content($composer_0, 14 & $dirty >> 3);
    $composer_0.y31();
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CompositionLocalProvider$lambda(value, content, $changed));
    }
  }
  function staticCompositionLocalOf(defaultFactory) {
    return new StaticProvidableCompositionLocal(defaultFactory);
  }
  function CompositionLocalProvider_0(values, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(415205898);
    var $dirty = $changed;
    $composer_0.v31(values);
    content($composer_0, 14 & $dirty >> 3);
    $composer_0.w31();
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CompositionLocalProvider$lambda_0(values, content, $changed));
    }
  }
  function CompositionLocal(defaultFactory) {
    this.n3c_1 = new LazyValueHolder(defaultFactory);
  }
  protoOf(CompositionLocal).o3c = function () {
    return this.n3c_1;
  };
  function compositionLocalWithComputedDefaultOf(defaultComputation) {
    return new ComputedProvidableCompositionLocal(defaultComputation);
  }
  function CompositionLocalContext(compositionLocals) {
    this.q3c_1 = compositionLocals;
  }
  protoOf(CompositionLocalContext).equals = function (other) {
    var tmp;
    if (other instanceof CompositionLocalContext) {
      tmp = equals(other.q3c_1, this.q3c_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CompositionLocalContext).hashCode = function () {
    return hashCode(this.q3c_1);
  };
  function DynamicProvidableCompositionLocal(policy, defaultFactory) {
    ProvidableCompositionLocal.call(this, defaultFactory);
    this.s3c_1 = policy;
  }
  protoOf(DynamicProvidableCompositionLocal).g3c = function (value) {
    return new ProvidedValue(this, value, value === null, this.s3c_1, null, null, true);
  };
  function StaticProvidableCompositionLocal(defaultFactory) {
    ProvidableCompositionLocal.call(this, defaultFactory);
  }
  protoOf(StaticProvidableCompositionLocal).g3c = function (value) {
    return new ProvidedValue(this, value, value === null, null, null, null, false);
  };
  function ComputedProvidableCompositionLocal$_init_$lambda_ey656n() {
    composeRuntimeError('Unexpected call to default provider');
  }
  function ComputedProvidableCompositionLocal(defaultComputation) {
    ProvidableCompositionLocal.call(this, ComputedProvidableCompositionLocal$_init_$lambda_ey656n);
    this.v3c_1 = new ComputedValueHolder(defaultComputation);
  }
  protoOf(ComputedProvidableCompositionLocal).o3c = function () {
    return this.v3c_1;
  };
  protoOf(ComputedProvidableCompositionLocal).g3c = function (value) {
    return new ProvidedValue(this, value, value === null, null, null, null, true);
  };
  function CompositionLocalProvider_1(context, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1162003659);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(context) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = context.q3c_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(this_0.n1());
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = this_0.s1().t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$3 = item.u1().w3c(item.t1());
        destination.j1(tmp$ret$3);
      }
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$4 = copyToArray(destination);
      CompositionLocalProvider_0(tmp$ret$4.slice(), content, $composer_0, 112 & $dirty);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CompositionLocalProvider$lambda_1(context, content, $changed));
    }
  }
  function CompositionLocalProvider$lambda($value, $content, $$changed) {
    return function ($composer, $force) {
      CompositionLocalProvider($value, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function CompositionLocalProvider$lambda_0($values, $content, $$changed) {
    return function ($composer, $force) {
      CompositionLocalProvider_0($values, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function CompositionLocalProvider$lambda_1($context, $content, $$changed) {
    return function ($composer, $force) {
      CompositionLocalProvider_1($context, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function Companion_1() {
    Companion_instance_2 = this;
    this.x3c_1 = persistentCompositionLocalHashMapOf();
  }
  var Companion_instance_2;
  function Companion_getInstance_1() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function PersistentCompositionLocalMap() {
  }
  function read(_this__u8e3s4, key) {
    // Inline function 'kotlin.collections.getOrElse' call
    var key_0 = key instanceof CompositionLocal ? key : THROW_CCE();
    var tmp0_elvis_lhs = _this__u8e3s4.w2(key_0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = key.o3c();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp.b3d(_this__u8e3s4);
  }
  function contains_2(_this__u8e3s4, key) {
    return _this__u8e3s4.u2(key instanceof CompositionLocal ? key : THROW_CCE());
  }
  function updateCompositionMap(values, parentScope, previous) {
    previous = previous === VOID ? persistentCompositionLocalHashMapOf() : previous;
    var builder = persistentCompositionLocalHashMapOf().a3d();
    var map = previous;
    var inductionVariable = 0;
    var last = values.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var provided = values[index];
        var tmp = provided.d32_1;
        var local = tmp instanceof ProvidableCompositionLocal ? tmp : THROW_CCE();
        if (provided.k32_1 || !contains_2(parentScope, local)) {
          var previousState = map.w2(local);
          var newState = local.j3c(provided instanceof ProvidedValue ? provided : THROW_CCE(), previousState);
          // Inline function 'kotlin.collections.set' call
          builder.z2(local, newState);
        }
      }
       while (inductionVariable <= last);
    return builder.g3d();
  }
  function get_calculationBlockNestedLevel() {
    _init_properties_DerivedState_kt__eqt0x8();
    return calculationBlockNestedLevel;
  }
  var calculationBlockNestedLevel;
  function get_derivedStateObservers() {
    _init_properties_DerivedState_kt__eqt0x8();
    return derivedStateObservers;
  }
  var derivedStateObservers;
  var androidx_compose_runtime_DerivedSnapshotState_ResultRecord$stable;
  function derivedStateOf(calculation) {
    _init_properties_DerivedState_kt__eqt0x8();
    return new DerivedSnapshotState(calculation, null);
  }
  function derivedStateOf_0(policy, calculation) {
    _init_properties_DerivedState_kt__eqt0x8();
    return new DerivedSnapshotState(calculation, policy);
  }
  function DerivedState() {
  }
  function Companion_2() {
    Companion_instance_3 = this;
    this.i3d_1 = new Object();
  }
  var Companion_instance_3;
  function Companion_getInstance_2() {
    if (Companion_instance_3 == null)
      new Companion_2();
    return Companion_instance_3;
  }
  function ResultRecord(snapshotId) {
    Companion_getInstance_2();
    StateRecord.call(this, snapshotId);
    this.l3d_1 = 0.0;
    this.m3d_1 = 0;
    this.n3d_1 = emptyObjectIntMap();
    this.o3d_1 = Companion_getInstance_2().i3d_1;
    this.p3d_1 = 0;
  }
  protoOf(ResultRecord).h3a = function () {
    return this.n3d_1;
  };
  protoOf(ResultRecord).q3d = function (value) {
    var other = value instanceof ResultRecord ? value : THROW_CCE();
    this.n3d_1 = other.n3d_1;
    this.o3d_1 = other.o3d_1;
    this.p3d_1 = other.p3d_1;
  };
  protoOf(ResultRecord).r3d = function () {
    return this.x3d(currentSnapshot().w3d());
  };
  protoOf(ResultRecord).x3d = function (snapshotId) {
    return new ResultRecord(snapshotId);
  };
  protoOf(ResultRecord).y3d = function (derivedState, snapshot) {
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    var snapshotChanged = !equals(this.l3d_1, snapshot.w3d()) || !(this.m3d_1 === snapshot.z3d());
    var isValid = !(this.o3d_1 === Companion_getInstance_2().i3d_1) && (!snapshotChanged || this.p3d_1 === this.a3e(derivedState, snapshot));
    if (isValid && snapshotChanged) {
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      this.l3d_1 = snapshot.w3d();
      this.m3d_1 = snapshot.z3d();
    }
    return isValid;
  };
  protoOf(ResultRecord).a3e = function (derivedState, snapshot) {
    var hash = 7;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    var dependencies = this.n3d_1;
    if (dependencies.fv()) {
      // Inline function 'androidx.compose.runtime.notifyObservers' call
      var observers = derivedStateObservers_0();
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var i = 0;
      var tmp = observers.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = observers.d3e_1;
      while (i < size) {
        content[i].e3e(derivedState);
        i = i + 1 | 0;
      }
      try {
        // Inline function 'androidx.collection.ObjectIntMap.forEach' call
        var k = dependencies.ez_1;
        var v = dependencies.fz_1;
        $l$block_1: {
          // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
          var m = dependencies.dz_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i_0 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i_0];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_0 = slot;
              var tmp$ret$9 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$9, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i_0 - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index = (i_0 << 3) + j | 0;
                      var tmp0 = k[index];
                      var tmp2 = v[index];
                      $l$block: {
                        if (!(tmp2 === 1)) {
                          break $l$block;
                        }
                        var tmp_0;
                        if (tmp0 instanceof DerivedSnapshotState) {
                          var record = tmp0.k3e(snapshot);
                          // Inline function 'androidx.collection.ObjectIntMap.forEachKey' call
                          var this_1 = record.n3d_1;
                          var k_0 = this_1.ez_1;
                          $l$block_0: {
                            // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
                            var m_0 = this_1.dz_1;
                            var lastIndex_0 = m_0.length - 2 | 0;
                            var inductionVariable_1 = 0;
                            if (inductionVariable_1 <= lastIndex_0)
                              do {
                                var i_1 = inductionVariable_1;
                                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                                var slot_0 = m_0[i_1];
                                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                                var this_2 = slot_0;
                                var tmp$ret$15 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
                                if (!equalsLong(tmp$ret$15, new Long(-2139062144, -2139062144))) {
                                  var bitCount_0 = 8 - (~(i_1 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                                  var inductionVariable_2 = 0;
                                  if (inductionVariable_2 < bitCount_0)
                                    do {
                                      var j_0 = inductionVariable_2;
                                      inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                      // Inline function 'androidx.collection.isFull' call
                                      var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                                      if (compare(value_0, new Long(128, 0)) < 0) {
                                        var index_0 = (i_1 << 3) + j_0 | 0;
                                        var dependency = k_0[index_0];
                                        hash = imul(31, hash) + identityHashCode_0(dependency) | 0;
                                      }
                                      slot_0 = shiftRight(slot_0, 8);
                                    }
                                     while (inductionVariable_2 < bitCount_0);
                                  if (!(bitCount_0 === 8)) {
                                    break $l$block_0;
                                  }
                                }
                              }
                               while (!(i_1 === lastIndex_0));
                          }
                          tmp_0 = record;
                        } else {
                          tmp_0 = current(tmp0.f3e(), snapshot);
                        }
                        var record_0 = tmp_0;
                        hash = imul(31, hash) + identityHashCode_0(record_0) | 0;
                        hash = imul(31, hash) + getNumberHashCode(record_0.l3e_1) | 0;
                      }
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block_1;
                }
              }
            }
             while (!(i_0 === lastIndex));
        }
      }finally {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var i_2 = 0;
        var tmp_1 = observers.b3e_1;
        var content_0 = isArray(tmp_1) ? tmp_1 : THROW_CCE();
        var size_0 = observers.d3e_1;
        while (i_2 < size_0) {
          content_0[i_2].n3e(derivedState);
          i_2 = i_2 + 1 | 0;
        }
      }
    }
    return hash;
  };
  protoOf(ResultRecord).i3a = function () {
    return this.o3d_1;
  };
  function currentRecord($this, readable, snapshot, forceDependencyReads, calculation) {
    if (readable.y3d($this, snapshot)) {
      if (forceDependencyReads) {
        // Inline function 'androidx.compose.runtime.notifyObservers' call
        var observers = derivedStateObservers_0();
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var i = 0;
        var tmp = observers.b3e_1;
        var content = isArray(tmp) ? tmp : THROW_CCE();
        var size = observers.d3e_1;
        while (i < size) {
          content[i].e3e($this);
          i = i + 1 | 0;
        }
        try {
          var dependencies = readable.n3d_1;
          // Inline function 'androidx.compose.runtime.withCalculationNestedLevel' call
          var tmp0_elvis_lhs = get_calculationBlockNestedLevel().f1i();
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = new IntRef(0);
            get_calculationBlockNestedLevel().r3e(this_0);
            tmp_0 = this_0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var ref = tmp_0;
          var invalidationNestedLevel = ref.s3e_1;
          // Inline function 'androidx.collection.ObjectIntMap.forEach' call
          var k = dependencies.ez_1;
          var v = dependencies.fz_1;
          $l$block: {
            // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
            var m = dependencies.dz_1;
            var lastIndex = m.length - 2 | 0;
            var inductionVariable = 0;
            if (inductionVariable <= lastIndex)
              do {
                var i_0 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var slot = m[i_0];
                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                var this_1 = slot;
                var tmp$ret$10 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
                if (!equalsLong(tmp$ret$10, new Long(-2139062144, -2139062144))) {
                  var bitCount = 8 - (~(i_0 - lastIndex | 0) >>> 31 | 0) | 0;
                  var inductionVariable_0 = 0;
                  if (inductionVariable_0 < bitCount)
                    do {
                      var j = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      // Inline function 'androidx.collection.isFull' call
                      var value = bitwiseAnd(slot, new Long(255, 0));
                      if (compare(value, new Long(128, 0)) < 0) {
                        var index = (i_0 << 3) + j | 0;
                        var tmp0 = k[index];
                        ref.s3e_1 = invalidationNestedLevel + v[index] | 0;
                        var tmp0_safe_receiver = snapshot.t3e();
                        if (tmp0_safe_receiver == null)
                          null;
                        else
                          tmp0_safe_receiver(tmp0);
                      }
                      slot = shiftRight(slot, 8);
                    }
                     while (inductionVariable_0 < bitCount);
                  if (!(bitCount === 8)) {
                    break $l$block;
                  }
                }
              }
               while (!(i_0 === lastIndex));
          }
          ref.s3e_1 = invalidationNestedLevel;
        }finally {
          // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
          var i_1 = 0;
          var tmp_1 = observers.b3e_1;
          var content_0 = isArray(tmp_1) ? tmp_1 : THROW_CCE();
          var size_0 = observers.d3e_1;
          while (i_1 < size_0) {
            content_0[i_1].n3e($this);
            i_1 = i_1 + 1 | 0;
          }
        }
      }
      return readable;
    }
    var newDependencies = new MutableObjectIntMap();
    // Inline function 'androidx.compose.runtime.withCalculationNestedLevel' call
    var tmp0_elvis_lhs_0 = get_calculationBlockNestedLevel().f1i();
    var tmp_2;
    if (tmp0_elvis_lhs_0 == null) {
      // Inline function 'kotlin.also' call
      var this_2 = new IntRef(0);
      get_calculationBlockNestedLevel().r3e(this_2);
      tmp_2 = this_2;
    } else {
      tmp_2 = tmp0_elvis_lhs_0;
    }
    var ref_0 = tmp_2;
    var nestedCalculationLevel = ref_0.s3e_1;
    // Inline function 'androidx.compose.runtime.notifyObservers' call
    var observers_0 = derivedStateObservers_0();
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var i_2 = 0;
    var tmp_3 = observers_0.b3e_1;
    var content_1 = isArray(tmp_3) ? tmp_3 : THROW_CCE();
    var size_1 = observers_0.d3e_1;
    while (i_2 < size_1) {
      content_1[i_2].e3e($this);
      i_2 = i_2 + 1 | 0;
    }
    var tmp_4;
    try {
      ref_0.s3e_1 = nestedCalculationLevel + 1 | 0;
      var tmp_5 = Companion_instance_18;
      var result = tmp_5.v3e(DerivedSnapshotState$currentRecord$lambda($this, ref_0, newDependencies, nestedCalculationLevel), null, calculation);
      ref_0.s3e_1 = nestedCalculationLevel;
      tmp_4 = result;
    }finally {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var i_3 = 0;
      var tmp_6 = observers_0.b3e_1;
      var content_2 = isArray(tmp_6) ? tmp_6 : THROW_CCE();
      var size_2 = observers_0.d3e_1;
      while (i_3 < size_2) {
        content_2[i_3].n3e($this);
        i_3 = i_3 + 1 | 0;
      }
    }
    var result_0 = tmp_4;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    var currentSnapshot = Companion_instance_18.e2y();
    var tmp_7;
    var tmp_8;
    if (!(readable.o3d_1 === Companion_getInstance_2().i3d_1)) {
      var tmp0_safe_receiver_0 = $this.i3e_1;
      tmp_8 = (tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.w3e(result_0, readable.o3d_1)) === true;
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      readable.n3d_1 = newDependencies;
      readable.p3d_1 = readable.a3e($this, currentSnapshot);
      tmp_7 = readable;
    } else {
      var writable = newWritableRecord($this.j3e_1, $this, currentSnapshot);
      writable.n3d_1 = newDependencies;
      writable.p3d_1 = writable.a3e($this, currentSnapshot);
      writable.o3d_1 = result_0;
      tmp_7 = writable;
    }
    var record = tmp_7;
    var tmp0_safe_receiver_1 = get_calculationBlockNestedLevel().f1i();
    if ((tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.s3e_1) === 0) {
      Companion_instance_18.x3e();
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      var currentSnapshot_0 = Companion_instance_18.e2y();
      record.l3d_1 = currentSnapshot_0.w3d();
      record.m3d_1 = currentSnapshot_0.z3d();
    }
    return record;
  }
  function displayValue($this) {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = $this.j3e_1;
    var it = current_0(this_0);
    if (it.y3d($this, Companion_instance_18.e2y())) {
      return toString_0(it.o3d_1);
    }
    return '<Not calculated>';
  }
  function DerivedSnapshotState$currentRecord$lambda(this$0, $calculationLevelRef, $newDependencies, $nestedCalculationLevel) {
    return function (it) {
      var tmp;
      if (it === this$0) {
        // Inline function 'kotlin.error' call
        var message = 'A derived state calculation cannot read itself';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      var tmp_0;
      if (isInterface(it, StateObject)) {
        var readNestedLevel = $calculationLevelRef.s3e_1;
        var tmp0 = readNestedLevel - $nestedCalculationLevel | 0;
        // Inline function 'kotlin.math.min' call
        var b = $newDependencies.rz(it, 2147483647);
        var tmp$ret$1 = Math.min(tmp0, b);
        $newDependencies.oz(it, tmp$ret$1);
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DerivedSnapshotState(calculation, policy) {
    StateObjectImpl.call(this);
    this.h3e_1 = calculation;
    this.i3e_1 = policy;
    this.j3e_1 = new ResultRecord(currentSnapshot().w3d());
  }
  protoOf(DerivedSnapshotState).h3d = function () {
    return this.i3e_1;
  };
  protoOf(DerivedSnapshotState).k3e = function (snapshot) {
    return currentRecord(this, current(this.j3e_1, snapshot), snapshot, false, this.h3e_1);
  };
  protoOf(DerivedSnapshotState).f3e = function () {
    return this.j3e_1;
  };
  protoOf(DerivedSnapshotState).y3e = function (value) {
    var tmp = this;
    tmp.j3e_1 = value instanceof ResultRecord ? value : THROW_CCE();
  };
  protoOf(DerivedSnapshotState).u1 = function () {
    var tmp0_safe_receiver = Companion_instance_18.e2y().t3e();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(this);
    var snapshot = Companion_instance_18.e2y();
    var record = current(this.j3e_1, snapshot);
    return currentRecord(this, record, snapshot, true, this.h3e_1).o3d_1;
  };
  protoOf(DerivedSnapshotState).g3a = function () {
    var snapshot = Companion_instance_18.e2y();
    var record = current(this.j3e_1, snapshot);
    return currentRecord(this, record, snapshot, false, this.h3e_1);
  };
  protoOf(DerivedSnapshotState).toString = function () {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.j3e_1;
    current_0(this_0);
    return 'DerivedState(value=' + displayValue(this) + ')@' + hashCode(this);
  };
  function derivedStateObservers_0() {
    _init_properties_DerivedState_kt__eqt0x8();
    var tmp0_elvis_lhs = get_derivedStateObservers().f1i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp$ret$1 = Array(0);
      // Inline function 'kotlin.also' call
      var this_0 = new MutableVector(tmp$ret$1, 0);
      get_derivedStateObservers().r3e(this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  var properties_initialized_DerivedState_kt_scch8q;
  function _init_properties_DerivedState_kt__eqt0x8() {
    if (!properties_initialized_DerivedState_kt_scch8q) {
      properties_initialized_DerivedState_kt_scch8q = true;
      calculationBlockNestedLevel = new SnapshotThreadLocal();
      derivedStateObservers = new SnapshotThreadLocal();
      androidx_compose_runtime_DerivedSnapshotState_ResultRecord$stable = 8;
    }
  }
  function get_InternalDisposableEffectScope() {
    _init_properties_Effects_kt__be5lps();
    return InternalDisposableEffectScope;
  }
  var InternalDisposableEffectScope;
  var androidx_compose_runtime_DisposableEffectScope$stable;
  var androidx_compose_runtime_LaunchedEffectImpl$stable;
  var androidx_compose_runtime_CompositionScopedCoroutineScopeCanceller$stable;
  var androidx_compose_runtime_RememberedCoroutineScope$stable;
  function LaunchedEffect(key1, block, $composer, $changed) {
    _init_properties_Effects_kt__be5lps();
    var $composer_0 = $composer;
    var applyContext = $composer_0.z31();
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(key1);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_0().f30_1) {
      var value = new LaunchedEffectImpl(applyContext, block);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
  }
  function LaunchedEffect_0(key1, key2, block, $composer, $changed) {
    _init_properties_Effects_kt__be5lps();
    var $composer_0 = $composer;
    var applyContext = $composer_0.z31();
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!($composer_0.k31(key1) | $composer_0.k31(key2));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_0().f30_1) {
      var value = new LaunchedEffectImpl(applyContext, block);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
  }
  function SideEffect(effect, $composer, $changed) {
    _init_properties_Effects_kt__be5lps();
    var $composer_0 = $composer;
    $composer_0.s31(effect);
  }
  function DisposableEffect(key1, key2, effect, $composer, $changed) {
    _init_properties_Effects_kt__be5lps();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!($composer_0.k31(key1) | $composer_0.k31(key2));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_0().f30_1) {
      var value = new DisposableEffectImpl(effect);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
  }
  function DisposableEffectScope() {
  }
  function DisposableEffect_0(key1, effect, $composer, $changed) {
    _init_properties_Effects_kt__be5lps();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(key1);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_0().f30_1) {
      var value = new DisposableEffectImpl(effect);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
  }
  function LaunchedEffectImpl(parentCoroutineContext, task) {
    this.b3f_1 = parentCoroutineContext;
    this.c3f_1 = task;
    this.e3f_1 = null;
    var context = this.b3f_1.xj(this);
    if (ComposeToolingFlags_instance.f3f_1) {
      context = context.xj(LaunchedEffectTracingContext_getInstance());
    }
    this.d3f_1 = CoroutineScope(context);
  }
  protoOf(LaunchedEffectImpl).g3f = function () {
    var tmp0_safe_receiver = this.e3f_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel(tmp0_safe_receiver, 'Old job was still running!');
    }
    this.e3f_1 = launch(this.d3f_1, VOID, VOID, this.c3f_1);
  };
  protoOf(LaunchedEffectImpl).h3f = function () {
    var tmp0_safe_receiver = this.e3f_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a1b(new LeftCompositionCancellationException());
    }
    this.e3f_1 = null;
  };
  protoOf(LaunchedEffectImpl).i3f = function () {
    var tmp0_safe_receiver = this.e3f_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a1b(new LeftCompositionCancellationException());
    }
    this.e3f_1 = null;
  };
  protoOf(LaunchedEffectImpl).t1 = function () {
    return Key_instance;
  };
  protoOf(LaunchedEffectImpl).f1h = function (context, exception) {
    var tmp0_safe_receiver = context.aa(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      tmp0_safe_receiver.k3f(exception, this);
    }
    var tmp1_safe_receiver = this.b3f_1.aa(Key_instance);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      tmp1_safe_receiver.f1h(context, exception);
      tmp = Unit_instance;
    }
    if (tmp == null)
      throw exception;
  };
  function createCompositionCoroutineScope(coroutineContext, composer) {
    _init_properties_Effects_kt__be5lps();
    var tmp;
    if (!(coroutineContext.aa(Key_instance_0) == null)) {
      // Inline function 'kotlin.apply' call
      var this_0 = Job();
      this_0.v1g(IllegalArgumentException_init_$Create$('CoroutineContext supplied to rememberCoroutineScope may not include a parent job'));
      tmp = CoroutineScope(this_0);
    } else {
      var applyContext = composer.z31();
      tmp = new RememberedCoroutineScope(applyContext, coroutineContext);
    }
    return tmp;
  }
  function DisposableEffectImpl(effect) {
    this.l3f_1 = effect;
    this.m3f_1 = null;
  }
  protoOf(DisposableEffectImpl).g3f = function () {
    this.m3f_1 = this.l3f_1(get_InternalDisposableEffectScope());
  };
  protoOf(DisposableEffectImpl).h3f = function () {
    var tmp0_safe_receiver = this.m3f_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s1d();
    }
    this.m3f_1 = null;
  };
  protoOf(DisposableEffectImpl).i3f = function () {
  };
  function LaunchedEffectTracingContext() {
    LaunchedEffectTracingContext_instance = this;
    TracingContext.call(this, 'Compose:LaunchedEffect');
  }
  var LaunchedEffectTracingContext_instance;
  function LaunchedEffectTracingContext_getInstance() {
    if (LaunchedEffectTracingContext_instance == null)
      new LaunchedEffectTracingContext();
    return LaunchedEffectTracingContext_instance;
  }
  function LeftCompositionCancellationException() {
    PlatformOptimizedCancellationException.call(this, 'The coroutine scope left the composition');
    captureStack(this, LeftCompositionCancellationException);
  }
  function Companion_3() {
    Companion_instance_4 = this;
    this.o3f_1 = new CancelledCoroutineContext();
  }
  var Companion_instance_4;
  function Companion_getInstance_3() {
    if (Companion_instance_4 == null)
      new Companion_3();
    return Companion_instance_4;
  }
  function RememberedCoroutineScope$coroutineContext$$inlined$CoroutineExceptionHandler$1($traceContext, this$0) {
    this.q3f_1 = $traceContext;
    this.r3f_1 = this$0;
    AbstractCoroutineContextElement.call(this, Key_instance);
  }
  protoOf(RememberedCoroutineScope$coroutineContext$$inlined$CoroutineExceptionHandler$1).f1h = function (context, exception) {
    // Inline function 'kotlin.apply' call
    this.q3f_1.k3f(exception, this.r3f_1);
    var tmp0_safe_receiver = this.r3f_1.t3f_1.aa(Key_instance);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp0_safe_receiver.f1h(context, exception);
      tmp = Unit_instance;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.r3f_1.s3f_1.aa(Key_instance);
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        tmp2_safe_receiver.f1h(context, exception);
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    if (tmp_0 == null)
      throw exception;
    return Unit_instance;
  };
  function RememberedCoroutineScope(parentContext, overlayContext) {
    Companion_getInstance_3();
    this.s3f_1 = parentContext;
    this.t3f_1 = overlayContext;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
    tmp.u3f_1 = this == null ? new Object() : this;
    this.v3f_1 = null;
  }
  protoOf(RememberedCoroutineScope).q19 = function () {
    var localCoroutineContext = this.v3f_1;
    if (localCoroutineContext == null || localCoroutineContext === Companion_getInstance_3().o3f_1) {
      var traceContext = this.s3f_1.aa(Key_instance_3);
      var tmp;
      if (!(traceContext == null)) {
        // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
        tmp = new RememberedCoroutineScope$coroutineContext$$inlined$CoroutineExceptionHandler$1(traceContext, this);
      } else {
        tmp = EmptyCoroutineContext_getInstance();
      }
      var exceptionHandler = tmp;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this.u3f_1;
      localCoroutineContext = this.v3f_1;
      if (localCoroutineContext == null) {
        var parentContext = this.s3f_1;
        var childJob = Job(parentContext.aa(Key_instance_0));
        localCoroutineContext = parentContext.xj(childJob).xj(this.t3f_1).xj(exceptionHandler);
      } else if (localCoroutineContext === Companion_getInstance_3().o3f_1) {
        var parentContext_0 = this.s3f_1;
        // Inline function 'kotlin.apply' call
        var this_0 = Job(parentContext_0.aa(Key_instance_0));
        this_0.a1b(new ForgottenCoroutineScopeException());
        var cancelledChildJob = this_0;
        localCoroutineContext = parentContext_0.xj(cancelledChildJob).xj(this.t3f_1).xj(exceptionHandler);
        if (ComposeToolingFlags_instance.f3f_1) {
          localCoroutineContext = localCoroutineContext.xj(RememberedCoroutineScopeTracingContext_getInstance());
        }
      }
      this.v3f_1 = localCoroutineContext;
    }
    return ensureNotNull(localCoroutineContext);
  };
  protoOf(RememberedCoroutineScope).w3f = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.u3f_1;
    var context = this.v3f_1;
    if (context == null) {
      this.v3f_1 = Companion_getInstance_3().o3f_1;
    } else {
      cancel_0(context, new ForgottenCoroutineScopeException());
    }
  };
  protoOf(RememberedCoroutineScope).g3f = function () {
  };
  protoOf(RememberedCoroutineScope).h3f = function () {
    this.w3f();
  };
  protoOf(RememberedCoroutineScope).i3f = function () {
    this.w3f();
  };
  function ForgottenCoroutineScopeException() {
    PlatformOptimizedCancellationException.call(this, 'rememberCoroutineScope left the composition');
    captureStack(this, ForgottenCoroutineScopeException);
  }
  function RememberedCoroutineScopeTracingContext() {
    RememberedCoroutineScopeTracingContext_instance = this;
    TracingContext.call(this, 'Compose:coroutineScope');
  }
  var RememberedCoroutineScopeTracingContext_instance;
  function RememberedCoroutineScopeTracingContext_getInstance() {
    if (RememberedCoroutineScopeTracingContext_instance == null)
      new RememberedCoroutineScopeTracingContext();
    return RememberedCoroutineScopeTracingContext_instance;
  }
  function Key() {
  }
  var Key_instance_1;
  function Key_getInstance() {
    return Key_instance_1;
  }
  function CancelledCoroutineContext() {
  }
  protoOf(CancelledCoroutineContext).t1 = function () {
    return Key_instance_1;
  };
  function LaunchedEffect_1(keys, block, $composer, $changed) {
    _init_properties_Effects_kt__be5lps();
    var $composer_0 = $composer;
    var applyContext = $composer_0.z31();
    // Inline function 'androidx.compose.runtime.remember' call
    var $composer_1 = $composer_0;
    var invalid = false;
    var indexedObject = keys.slice();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var key = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      invalid = !!(invalid | $composer_1.k31(key));
    }
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = invalid;
    // Inline function 'kotlin.let' call
    var it = $composer_1.i31();
    var tmp;
    if (invalid_0 || it === Companion_getInstance_0().f30_1) {
      var value = new LaunchedEffectImpl(applyContext, block);
      $composer_1.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
  }
  function DisposableEffect_1(keys, effect, $composer, $changed) {
    _init_properties_Effects_kt__be5lps();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.remember' call
    var $composer_1 = $composer_0;
    var invalid = false;
    var indexedObject = keys.slice();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var key = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      invalid = !!(invalid | $composer_1.k31(key));
    }
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = invalid;
    // Inline function 'kotlin.let' call
    var it = $composer_1.i31();
    var tmp;
    if (invalid_0 || it === Companion_getInstance_0().f30_1) {
      var value = new DisposableEffectImpl(effect);
      $composer_1.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
  }
  var properties_initialized_Effects_kt_cj8kem;
  function _init_properties_Effects_kt__be5lps() {
    if (!properties_initialized_Effects_kt_cj8kem) {
      properties_initialized_Effects_kt_cj8kem = true;
      InternalDisposableEffectScope = new DisposableEffectScope();
      androidx_compose_runtime_DisposableEffectScope$stable = 0;
      androidx_compose_runtime_LaunchedEffectImpl$stable = 8;
      androidx_compose_runtime_CompositionScopedCoroutineScopeCanceller$stable = 8;
      androidx_compose_runtime_RememberedCoroutineScope$stable = 8;
    }
  }
  function get_InvalidationLocationAscending() {
    _init_properties_GapComposer_kt__ele738();
    return InvalidationLocationAscending;
  }
  var InvalidationLocationAscending;
  var androidx_compose_runtime_GapComposer_CompositionContextHolder$stable;
  var androidx_compose_runtime_GapComposer$stable;
  var androidx_compose_runtime_GapRememberObserverHolder$stable;
  var androidx_compose_runtime_ReusableGapRememberObserverHolder$stable;
  var androidx_compose_runtime_GapCompositionDataImpl$stable;
  function _set_compositionLocalScope__ya1b9q($this, _set____db54di) {
    var tmp0 = $this.d3g_1;
    var tmp = KMutableProperty1;
    var tmp_0 = GapComposer$CompositionContextImpl$_get_compositionLocalScope_$ref_yv82h0();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('compositionLocalScope', 1, tmp, tmp_0, GapComposer$CompositionContextImpl$_set_compositionLocalScope_$ref_wmdjio());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_compositionLocalScope__ulge9q($this) {
    var tmp0 = $this.d3g_1;
    var tmp = KMutableProperty1;
    var tmp_0 = GapComposer$CompositionContextImpl$_get_compositionLocalScope_$ref_yv82h0();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('compositionLocalScope', 1, tmp, tmp_0, GapComposer$CompositionContextImpl$_set_compositionLocalScope_$ref_wmdjio());
    return tmp0.u1();
  }
  function GapComposer$CompositionContextImpl$_get_compositionLocalScope_$ref_yv82h0() {
    return constructCallableReference(function (p0) {
      return _get_compositionLocalScope__ulge9q(p0);
    }, 1, 0, 9);
  }
  function GapComposer$CompositionContextImpl$_set_compositionLocalScope_$ref_wmdjio() {
    return constructCallableReference(function (p0, p1) {
      _set_compositionLocalScope__ya1b9q(p0, p1);
      return Unit_instance;
    }, 2, 0, 10);
  }
  function startRoot($this) {
    $this.r3g_1 = 0;
    $this.n3h_1 = $this.h3g_1.d3i();
    startGroup($this, 100);
    $this.g3g_1.y3b();
    var parentProvider = $this.g3g_1.b30();
    $this.d3h_1.g3i(asInt($this.c3h_1));
    $this.c3h_1 = $this.k31(parentProvider);
    $this.r3h_1 = null;
    if (!$this.v3g_1) {
      $this.v3g_1 = $this.g3g_1.p3b();
    }
    if (!$this.i3h_1) {
      $this.i3h_1 = $this.g3g_1.f39();
    }
    var tmp = $this;
    var tmp_0;
    if ($this.i3h_1) {
      var tmp_1 = get_LocalCompositionErrorContext();
      tmp_0 = parentProvider.y3c(tmp_1 instanceof CompositionLocal ? tmp_1 : THROW_CCE(), new StaticValueHolder($this.s32()));
    } else {
      tmp_0 = parentProvider;
    }
    tmp.a3h_1 = tmp_0;
    var tmp0_safe_receiver = read($this.a3h_1, get_LocalInspectionTables());
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.j1($this.h3i());
      $this.g3g_1.w3b(tmp0_safe_receiver);
    }
    startGroup($this, $this.g3g_1.o3b().hashCode());
  }
  function endRoot($this) {
    endGroup($this);
    $this.g3g_1.z3b();
    endGroup($this);
    $this.t3h_1.u3i();
    finalizeCompose($this);
    $this.n3h_1.j4();
    $this.w3g_1 = false;
    $this.c3h_1 = asBool($this.d3h_1.k3j());
  }
  function abortRoot($this) {
    cleanUpCompose($this);
    Stack__clear_impl_qoqv3c($this.n3g_1);
    $this.s3g_1.c3();
    $this.z3g_1.c3();
    $this.d3h_1.c3();
    $this.b3h_1 = null;
    $this.v3h_1.c3();
    var tmp = $this;
    // Inline function 'androidx.compose.runtime.CompositeKeyHashCode' call
    tmp.b3i_1 = fromInt(0);
    $this.g3h_1 = 0;
    $this.x3g_1 = false;
    $this.a3i_1 = false;
    $this.e3h_1 = false;
    $this.l3h_1 = false;
    $this.w3g_1 = false;
    $this.f3h_1 = -1;
    if (!$this.n3h_1.b3j_1) {
      $this.n3h_1.j4();
    }
    if (!$this.p3h_1.e34_1) {
      forceFreshInsertTable($this);
    }
  }
  function startGroup($this, key) {
    return start($this, key, null, Companion_getInstance_7().n3j_1, null);
  }
  function startGroup_0($this, key, dataKey) {
    return start($this, key, dataKey, Companion_getInstance_7().n3j_1, null);
  }
  function endGroup($this) {
    return end($this, false);
  }
  function skipGroup($this) {
    $this.q3g_1 = $this.q3g_1 + $this.n3h_1.y35() | 0;
  }
  function updateSlot($this, value) {
    $this.q3j();
    $this.r3j(value);
  }
  function rememberObserverGroupIndex($this) {
    return $this.r3g_1 - 1 | 0;
  }
  function currentCompositionLocalScope($this) {
    var tmp0_safe_receiver = $this.r3h_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    return currentCompositionLocalScope_0($this, $this.n3h_1.e3j_1);
  }
  function currentCompositionLocalScope_0($this, group) {
    if ($this.a3i_1 && $this.q3h_1) {
      var current = $this.p3h_1.d34_1;
      while (current > 0) {
        if ($this.p3h_1.t3j(current) === 202 && equals($this.p3h_1.u3j(current), get_compositionLocalMap())) {
          var tmp = $this.p3h_1.s3j(current);
          var providers = (!(tmp == null) ? isInterface(tmp, PersistentCompositionLocalMap) : false) ? tmp : THROW_CCE();
          $this.r3h_1 = providers;
          return providers;
        }
        current = $this.p3h_1.y34(current);
      }
    }
    if ($this.n3h_1.n1() > 0) {
      var current_0 = group;
      while (current_0 > 0) {
        if ($this.n3h_1.t3j(current_0) === 202 && equals($this.n3h_1.u3j(current_0), get_compositionLocalMap())) {
          var tmp0_safe_receiver = $this.b3h_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l1(current_0);
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            var tmp_1 = $this.n3h_1.s3j(current_0);
            tmp_0 = (!(tmp_1 == null) ? isInterface(tmp_1, PersistentCompositionLocalMap) : false) ? tmp_1 : THROW_CCE();
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var providers_0 = tmp_0;
          $this.r3h_1 = providers_0;
          return providers_0;
        }
        current_0 = $this.n3h_1.y34(current_0);
      }
    }
    $this.r3h_1 = $this.a3h_1;
    return $this.a3h_1;
  }
  function updateProviderMapGroup($this, parentScope, currentProviders) {
    // Inline function 'androidx.compose.runtime.mutate' call
    // Inline function 'kotlin.apply' call
    var this_0 = parentScope.a3d();
    this_0.b3(currentProviders);
    var providerScope = this_0.g3d();
    startGroup_0($this, 204, get_providerMaps());
    updateSlot($this, providerScope);
    updateSlot($this, currentProviders);
    endGroup($this);
    return providerScope;
  }
  function recordProviderUpdate($this, providers) {
    var tmp0_elvis_lhs = $this.b3h_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var newProviderUpdates = new MutableIntObjectMap();
      $this.b3h_1 = newProviderUpdates;
      tmp = newProviderUpdates;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var providerUpdates = tmp;
    providerUpdates.ew($this.n3h_1.c3j_1, providers);
  }
  function ensureWriter($this) {
    if ($this.p3h_1.e34_1) {
      $this.p3h_1 = $this.o3h_1.s35();
      $this.p3h_1.z30();
      $this.q3h_1 = false;
      $this.r3h_1 = null;
    }
  }
  function createFreshInsertTable($this) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!$this.p3h_1.e34_1) {
      var tmp$ret$2 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    forceFreshInsertTable($this);
  }
  function forceFreshInsertTable($this) {
    var tmp = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = new SlotTable();
    if ($this.i3h_1) {
      this_0.t34();
    }
    if ($this.g3g_1.e39()) {
      this_0.v34();
    }
    tmp.o3h_1 = this_0;
    var tmp_0 = $this;
    // Inline function 'kotlin.also' call
    var this_1 = $this.o3h_1.s35();
    this_1.b36(true);
    tmp_0.p3h_1 = this_1;
  }
  function startReaderGroup($this, isNode, data) {
    if (isNode) {
      $this.n3h_1.y3j();
    } else {
      if (!(data == null) && !($this.n3h_1.w3j() === data)) {
        $this.t3h_1.v3j(data);
      }
      $this.n3h_1.x3j();
    }
  }
  function start($this, key, objectKey, kind, data) {
    validateNodeNotExpected($this);
    // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroup' call
    var rGroupIndex = $this.r3g_1;
    if (objectKey == null)
      if (!(data == null) && key === 207 && !equals(data, Companion_getInstance_0().f30_1)) {
        // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey = hashCode(data);
        var tmp = $this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_0 = $this.b3i_1;
        var tmp$ret$3 = rotateLeft(this_0, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_1 = bitwiseXor(tmp$ret$3, fromInt(groupKey));
        var tmp$ret$5 = rotateLeft(this_1, 3);
        tmp.b3i_1 = bitwiseXor(tmp$ret$5, fromInt(rGroupIndex));
      } else {
        // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var tmp_0 = $this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_2 = $this.b3i_1;
        var tmp$ret$8 = rotateLeft(this_2, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_3 = bitwiseXor(tmp$ret$8, fromInt(key));
        var tmp$ret$10 = rotateLeft(this_3, 3);
        tmp_0.b3i_1 = bitwiseXor(tmp$ret$10, fromInt(rGroupIndex));
      }
     else {
      if (objectKey instanceof Enum) {
        // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey_0 = objectKey.a1_1;
        var tmp_1 = $this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_4 = $this.b3i_1;
        var tmp$ret$13 = rotateLeft(this_4, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_5 = bitwiseXor(tmp$ret$13, fromInt(groupKey_0));
        var tmp$ret$15 = rotateLeft(this_5, 3);
        tmp_1.b3i_1 = bitwiseXor(tmp$ret$15, fromInt(0));
      } else {
        // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey_1 = hashCode(objectKey);
        var tmp_2 = $this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_6 = $this.b3i_1;
        var tmp$ret$18 = rotateLeft(this_6, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_7 = bitwiseXor(tmp$ret$18, fromInt(groupKey_1));
        var tmp$ret$20 = rotateLeft(this_7, 3);
        tmp_2.b3i_1 = bitwiseXor(tmp$ret$20, fromInt(0));
      }
    }
    if (objectKey == null) {
      $this.r3g_1 = $this.r3g_1 + 1 | 0;
    }
    // Inline function 'androidx.compose.runtime.composer.GroupKind.isNode' call
    var isNode = !(_GroupKind___get_value__impl__cf5pqe(kind) === _GroupKind___get_value__impl__cf5pqe(Companion_getInstance_7().n3j_1));
    if ($this.a3i_1) {
      $this.n3h_1.z3j();
      var startIndex = $this.p3h_1.b34_1;
      if (isNode) {
        $this.p3h_1.b3k(key, Companion_getInstance_0().f30_1);
      } else if (!(data == null)) {
        var tmp_3 = $this.p3h_1;
        tmp_3.a3k(key, objectKey == null ? Companion_getInstance_0().f30_1 : objectKey, data);
      } else {
        var tmp_4 = $this.p3h_1;
        tmp_4.u35(key, objectKey == null ? Companion_getInstance_0().f30_1 : objectKey);
      }
      var tmp2_safe_receiver = $this.o3g_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var insertKeyInfo = new KeyInfo(key, -1, insertedGroupVirtualIndex($this, startIndex), -1, 0);
        tmp2_safe_receiver.i3k(insertKeyInfo, $this.p3g_1 - tmp2_safe_receiver.d3k_1 | 0);
        tmp2_safe_receiver.j3k(insertKeyInfo);
      }
      enterGroup($this, isNode, null);
      return Unit_instance;
    }
    var tmp_5;
    // Inline function 'androidx.compose.runtime.composer.GroupKind.isReusable' call
    if (!!(_GroupKind___get_value__impl__cf5pqe(kind) === _GroupKind___get_value__impl__cf5pqe(Companion_getInstance_7().o3j_1))) {
      tmp_5 = $this.e3h_1;
    } else {
      tmp_5 = false;
    }
    var forceReplace = tmp_5;
    if ($this.o3g_1 == null) {
      var slotKey = $this.n3h_1.k3k();
      if (!forceReplace && slotKey === key && equals(objectKey, $this.n3h_1.m3k())) {
        startReaderGroup($this, isNode, data);
      } else {
        $this.o3g_1 = new GapPending($this.n3h_1.l3k(), $this.p3g_1);
      }
    }
    var pending = $this.o3g_1;
    var newPending = null;
    if (!(pending == null)) {
      var keyInfo = pending.n3k(key, objectKey);
      if (!forceReplace && !(keyInfo == null)) {
        pending.j3k(keyInfo);
        var location = keyInfo.r3k_1;
        $this.p3g_1 = pending.u3k(keyInfo) + pending.d3k_1 | 0;
        var relativePosition = pending.v3k(keyInfo);
        var currentRelativePosition = relativePosition - pending.e3k_1 | 0;
        pending.w3k(relativePosition, pending.e3k_1);
        $this.t3h_1.x3k(location);
        $this.n3h_1.y3k(location);
        if (currentRelativePosition > 0) {
          $this.t3h_1.z3k(currentRelativePosition);
        }
        startReaderGroup($this, isNode, data);
      } else {
        $this.n3h_1.z3j();
        $this.a3i_1 = true;
        $this.r3h_1 = null;
        ensureWriter($this);
        $this.p3h_1.t35();
        var startIndex_0 = $this.p3h_1.b34_1;
        if (isNode) {
          $this.p3h_1.b3k(key, Companion_getInstance_0().f30_1);
        } else if (!(data == null)) {
          var tmp_6 = $this.p3h_1;
          tmp_6.a3k(key, objectKey == null ? Companion_getInstance_0().f30_1 : objectKey, data);
        } else {
          var tmp_7 = $this.p3h_1;
          tmp_7.u35(key, objectKey == null ? Companion_getInstance_0().f30_1 : objectKey);
        }
        $this.u3h_1 = $this.p3h_1.o3k(startIndex_0);
        var insertKeyInfo_0 = new KeyInfo(key, -1, insertedGroupVirtualIndex($this, startIndex_0), -1, 0);
        pending.i3k(insertKeyInfo_0, $this.p3g_1 - pending.d3k_1 | 0);
        pending.j3k(insertKeyInfo_0);
        // Inline function 'kotlin.collections.mutableListOf' call
        var tmp$ret$25 = ArrayList_init_$Create$();
        newPending = new GapPending(tmp$ret$25, isNode ? 0 : $this.p3g_1);
      }
    }
    enterGroup($this, isNode, newPending);
  }
  function enterGroup($this, isNode, newPending) {
    Stack__push_impl_s8r905($this.n3g_1, $this.o3g_1);
    $this.o3g_1 = newPending;
    $this.s3g_1.g3i($this.q3g_1);
    $this.s3g_1.g3i($this.r3g_1);
    $this.s3g_1.g3i($this.p3g_1);
    if (isNode)
      $this.p3g_1 = 0;
    $this.q3g_1 = 0;
    $this.r3g_1 = 0;
  }
  function exitGroup($this, expectedNodeCount, inserting) {
    var previousPending = Stack__pop_impl_8s4za4($this.n3g_1);
    if (!(previousPending == null) && !inserting) {
      previousPending.e3k_1 = previousPending.e3k_1 + 1 | 0;
    }
    $this.o3g_1 = previousPending;
    $this.p3g_1 = $this.s3g_1.k3j() + expectedNodeCount | 0;
    $this.r3g_1 = $this.s3g_1.k3j();
    $this.q3g_1 = $this.s3g_1.k3j() + expectedNodeCount | 0;
  }
  function end($this, isNode) {
    var rGroupIndex = $this.s3g_1.a3l() - 1 | 0;
    if ($this.a3i_1) {
      var parent = $this.p3h_1.d34_1;
      var tmp2 = $this.p3h_1.t3j(parent);
      var tmp6 = $this.p3h_1.u3j(parent);
      // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroup' call
      var data = $this.p3h_1.s3j(parent);
      if (tmp6 == null)
        if (!(data == null) && tmp2 === 207 && !equals(data, Companion_getInstance_0().f30_1)) {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey = hashCode(data);
          var tmp = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_0 = $this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_1 = bitwiseXor(this_0, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_2 = rotateLeft(this_1, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_3 = bitwiseXor(this_2, fromInt(groupKey));
          tmp.b3i_1 = rotateLeft(this_3, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var tmp_0 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_4 = $this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_5 = bitwiseXor(this_4, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_6 = rotateLeft(this_5, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_7 = bitwiseXor(this_6, fromInt(tmp2));
          tmp_0.b3i_1 = rotateLeft(this_7, -3 | 0);
        }
       else {
        if (tmp6 instanceof Enum) {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_0 = tmp6.a1_1;
          var tmp_1 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_8 = $this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_9 = bitwiseXor(this_8, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_10 = rotateLeft(this_9, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_11 = bitwiseXor(this_10, fromInt(groupKey_0));
          tmp_1.b3i_1 = rotateLeft(this_11, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_1 = hashCode(tmp6);
          var tmp_2 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_12 = $this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_13 = bitwiseXor(this_12, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_14 = rotateLeft(this_13, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_15 = bitwiseXor(this_14, fromInt(groupKey_1));
          tmp_2.b3i_1 = rotateLeft(this_15, -3 | 0);
        }
      }
    } else {
      var parent_0 = $this.n3h_1.e3j_1;
      var tmp2_0 = $this.n3h_1.t3j(parent_0);
      var tmp6_0 = $this.n3h_1.u3j(parent_0);
      // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroup' call
      var data_0 = $this.n3h_1.s3j(parent_0);
      if (tmp6_0 == null)
        if (!(data_0 == null) && tmp2_0 === 207 && !equals(data_0, Companion_getInstance_0().f30_1)) {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_2 = hashCode(data_0);
          var tmp_3 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_16 = $this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_17 = bitwiseXor(this_16, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_18 = rotateLeft(this_17, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_19 = bitwiseXor(this_18, fromInt(groupKey_2));
          tmp_3.b3i_1 = rotateLeft(this_19, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var tmp_4 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_20 = $this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_21 = bitwiseXor(this_20, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_22 = rotateLeft(this_21, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_23 = bitwiseXor(this_22, fromInt(tmp2_0));
          tmp_4.b3i_1 = rotateLeft(this_23, -3 | 0);
        }
       else {
        if (tmp6_0 instanceof Enum) {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_3 = tmp6_0.a1_1;
          var tmp_5 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_24 = $this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_25 = bitwiseXor(this_24, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_26 = rotateLeft(this_25, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_27 = bitwiseXor(this_26, fromInt(groupKey_3));
          tmp_5.b3i_1 = rotateLeft(this_27, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_4 = hashCode(tmp6_0);
          var tmp_6 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_28 = $this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_29 = bitwiseXor(this_28, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_30 = rotateLeft(this_29, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_31 = bitwiseXor(this_30, fromInt(groupKey_4));
          tmp_6.b3i_1 = rotateLeft(this_31, -3 | 0);
        }
      }
    }
    var expectedNodeCount = $this.q3g_1;
    var pending = $this.o3g_1;
    if (!(pending == null) && pending.c3k_1.n1() > 0) {
      var previous = pending.c3k_1;
      var current = pending.b3l();
      var usedKeys = fastToSet(current);
      var placedKeys = mutableScatterSetOf();
      var currentIndex = 0;
      var currentEnd = current.n1();
      var previousIndex = 0;
      var previousEnd = previous.n1();
      var nodeOffset = 0;
      $l$loop_0: while (previousIndex < previousEnd) {
        var previousInfo = previous.l1(previousIndex);
        if (!usedKeys.m1(previousInfo)) {
          var deleteOffset = pending.u3k(previousInfo);
          $this.t3h_1.c3l(deleteOffset + pending.d3k_1 | 0, previousInfo.s3k_1);
          pending.d3l(previousInfo.r3k_1, 0);
          $this.t3h_1.x3k(previousInfo.r3k_1);
          $this.n3h_1.y3k(previousInfo.r3k_1);
          recordDelete($this);
          $this.n3h_1.y35();
          removeRange($this.y3g_1, previousInfo.r3k_1, previousInfo.r3k_1 + $this.n3h_1.a35(previousInfo.r3k_1) | 0);
          previousIndex = previousIndex + 1 | 0;
          continue $l$loop_0;
        }
        if (placedKeys.m1(previousInfo)) {
          previousIndex = previousIndex + 1 | 0;
          continue $l$loop_0;
        }
        if (currentIndex < currentEnd) {
          var currentInfo = current.l1(currentIndex);
          if (!(currentInfo === previousInfo)) {
            var nodePosition = pending.u3k(currentInfo);
            placedKeys.j1(currentInfo);
            if (!(nodePosition === nodeOffset)) {
              var updatedCount = pending.e3l(currentInfo);
              $this.t3h_1.f3l(nodePosition + pending.d3k_1 | 0, nodeOffset + pending.d3k_1 | 0, updatedCount);
              pending.g3l(nodePosition, nodeOffset, updatedCount);
            }
          } else {
            previousIndex = previousIndex + 1 | 0;
          }
          currentIndex = currentIndex + 1 | 0;
          nodeOffset = nodeOffset + pending.e3l(currentInfo) | 0;
        }
      }
      $this.t3h_1.h3l();
      if (previous.n1() > 0) {
        $this.t3h_1.x3k($this.n3h_1.i3l());
        $this.n3h_1.z30();
      }
    }
    var inserting = $this.a3i_1;
    if (!inserting) {
      var remainingSlots = $this.n3h_1.j3l();
      if (remainingSlots > 0) {
        $this.t3h_1.k3l(remainingSlots);
      }
    }
    var removeIndex = $this.p3g_1;
    while (!$this.n3h_1.l3l()) {
      var startSlot = $this.n3h_1.c3j_1;
      recordDelete($this);
      var nodesToRemove = $this.n3h_1.y35();
      $this.t3h_1.c3l(removeIndex, nodesToRemove);
      removeRange($this.y3g_1, startSlot, $this.n3h_1.c3j_1);
    }
    if (inserting) {
      if (isNode) {
        $this.v3h_1.p3l();
        expectedNodeCount = 1;
      }
      $this.n3h_1.q3l();
      var parentGroup = $this.p3h_1.d34_1;
      $this.p3h_1.z35();
      if (!$this.n3h_1.r3l()) {
        var virtualIndex = insertedGroupVirtualIndex($this, parentGroup);
        $this.p3h_1.a36();
        $this.p3h_1.b36(true);
        recordInsert($this, $this.u3h_1);
        $this.a3i_1 = false;
        if (!$this.h3g_1.oy()) {
          updateNodeCount($this, virtualIndex, 0);
          updateNodeCountOverrides($this, virtualIndex, expectedNodeCount);
        }
      }
    } else {
      if (isNode) {
        $this.t3h_1.m3l();
      }
      $this.t3h_1.n3l();
      var parentGroup_0 = $this.n3h_1.e3j_1;
      var parentNodeCount = updatedNodeCount($this, parentGroup_0);
      if (!(expectedNodeCount === parentNodeCount)) {
        updateNodeCountOverrides($this, parentGroup_0, expectedNodeCount);
      }
      if (isNode) {
        expectedNodeCount = 1;
      }
      $this.n3h_1.o3l();
      $this.t3h_1.h3l();
    }
    exitGroup($this, expectedNodeCount, inserting);
  }
  function recomposeToGroupEnd($this) {
    var wasComposing = $this.l3h_1;
    $this.l3h_1 = true;
    var recomposed = false;
    var parent = $this.n3h_1.e3j_1;
    var end = parent + $this.n3h_1.a35(parent) | 0;
    var recomposeIndex = $this.p3g_1;
    var recomposeCompositeKey = $this.b3i_1;
    var oldGroupNodeCount = $this.q3g_1;
    var oldRGroupIndex = $this.r3g_1;
    var oldGroup = parent;
    var firstInRange_0 = firstInRange($this.y3g_1, $this.n3h_1.c3j_1, end);
    while (!(firstInRange_0 == null)) {
      var location = firstInRange_0.t3l_1;
      var scope = firstInRange_0.s3l_1;
      removeLocation($this.y3g_1, location);
      if (firstInRange_0.a3m()) {
        recomposed = true;
        $this.n3h_1.y3k(location);
        var newGroup = $this.n3h_1.c3j_1;
        recordUpsAndDowns($this, oldGroup, newGroup, parent);
        oldGroup = newGroup;
        $this.p3g_1 = nodeIndexOf($this, location, newGroup, parent, recomposeIndex);
        $this.r3g_1 = rGroupIndexOf($this, newGroup);
        var newParent = $this.n3h_1.y34(newGroup);
        $this.b3i_1 = compositeKeyOf($this, newParent, parent, recomposeCompositeKey);
        $this.r3h_1 = null;
        scope.y3l($this);
        $this.r3h_1 = null;
        $this.n3h_1.z3l(parent);
      } else {
        Stack__push_impl_s8r905($this.k3h_1, scope);
        var observer = $this.l3g_1.d39();
        if (!(observer == null)) {
          try {
            observer.w3l(scope);
            scope.v3l();
          }finally {
            observer.x3l(scope);
          }
        } else {
          scope.v3l();
        }
        Stack__pop_impl_8s4za4($this.k3h_1);
      }
      firstInRange_0 = firstInRange($this.y3g_1, $this.n3h_1.c3j_1, end);
    }
    if (recomposed) {
      recordUpsAndDowns($this, oldGroup, parent, parent);
      $this.n3h_1.z30();
      var parentGroupNodes = updatedNodeCount($this, parent);
      $this.p3g_1 = recomposeIndex + parentGroupNodes | 0;
      $this.q3g_1 = oldGroupNodeCount + parentGroupNodes | 0;
      $this.r3g_1 = oldRGroupIndex;
    } else {
      skipReaderToGroupEnd($this);
    }
    $this.b3i_1 = recomposeCompositeKey;
    $this.l3h_1 = wasComposing;
  }
  function insertedGroupVirtualIndex($this, index) {
    return -2 - index | 0;
  }
  function updateNodeCountOverrides($this, group, newCount) {
    var currentCount = updatedNodeCount($this, group);
    if (!(currentCount === newCount)) {
      var delta = newCount - currentCount | 0;
      var current = group;
      var minPending = _Stack___get_size__impl__mdb81l($this.n3g_1) - 1 | 0;
      $l$loop_0: while (!(current === -1)) {
        var newCurrentNodes = updatedNodeCount($this, current) + delta | 0;
        updateNodeCount($this, current, newCurrentNodes);
        var inductionVariable = minPending;
        if (0 <= inductionVariable)
          $l$loop: do {
            var pendingIndex = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var pending = Stack__peek_impl_gtylu2_0($this.n3g_1, pendingIndex);
            if (!(pending == null) && pending.d3l(current, newCurrentNodes)) {
              minPending = pendingIndex - 1 | 0;
              break $l$loop;
            }
          }
           while (0 <= inductionVariable);
        if (current < 0) {
          current = $this.n3h_1.e3j_1;
        } else {
          if ($this.n3h_1.x34(current))
            break $l$loop_0;
          current = $this.n3h_1.y34(current);
        }
      }
    }
  }
  function nodeIndexOf($this, groupLocation, group, recomposeGroup, recomposeIndex) {
    var anchorGroup = $this.n3h_1.y34(group);
    $l$loop: while (!(anchorGroup === recomposeGroup) && !$this.n3h_1.x34(anchorGroup)) {
      anchorGroup = $this.n3h_1.y34(anchorGroup);
    }
    var index = $this.n3h_1.x34(anchorGroup) ? 0 : recomposeIndex;
    if (anchorGroup === group)
      return index;
    var current = anchorGroup;
    var nodeIndexLimit = index + (updatedNodeCount($this, anchorGroup) - $this.n3h_1.b35(group) | 0) | 0;
    loop: while (index < nodeIndexLimit && current !== groupLocation) {
      current = current + 1 | 0;
      while (current < groupLocation) {
        var end = current + $this.n3h_1.a35(current) | 0;
        if (groupLocation < end)
          continue loop;
        index = index + ($this.n3h_1.x34(current) ? 1 : updatedNodeCount($this, current)) | 0;
        current = end;
      }
      break loop;
    }
    return index;
  }
  function rGroupIndexOf($this, group) {
    var result = 0;
    var parent = $this.n3h_1.y34(group);
    var child = parent + 1 | 0;
    while (child < group) {
      if (!$this.n3h_1.b3m(child)) {
        result = result + 1 | 0;
      }
      child = child + $this.n3h_1.a35(child) | 0;
    }
    return result;
  }
  function updatedNodeCount($this, group) {
    if (group < 0) {
      var tmp0_safe_receiver = $this.u3g_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_0;
        // Inline function 'androidx.collection.IntIntMap.contains' call
        if (tmp0_safe_receiver.hv(group)) {
          tmp_0 = tmp0_safe_receiver.l1(group);
        } else {
          tmp_0 = 0;
        }
        tmp = tmp_0;
      }
      var tmp1_elvis_lhs = tmp;
      return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    }
    var nodeCounts = $this.t3g_1;
    if (!(nodeCounts == null)) {
      var override = nodeCounts[group];
      if (override >= 0)
        return override;
    }
    return $this.n3h_1.b35(group);
  }
  function updateNodeCount($this, group, count) {
    if (!(updatedNodeCount($this, group) === count)) {
      if (group < 0) {
        var tmp0_elvis_lhs = $this.u3g_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var newCounts = new MutableIntIntMap();
          $this.u3g_1 = newCounts;
          tmp = newCounts;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var virtualCounts = tmp;
        virtualCounts.zu(group, count);
      } else {
        var tmp1_elvis_lhs = $this.t3g_1;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var newCounts_0 = new Int32Array($this.n3h_1.n1());
          fill(newCounts_0, -1);
          $this.t3g_1 = newCounts_0;
          tmp_0 = newCounts_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var nodeCounts = tmp_0;
        nodeCounts[group] = count;
      }
    }
  }
  function clearUpdatedNodeCounts($this) {
    $this.t3g_1 = null;
    $this.u3g_1 = null;
  }
  function recordUpsAndDowns($this, oldGroup, newGroup, commonRoot) {
    var reader = $this.n3h_1;
    var nearestCommonRoot = nearestCommonRootOf(reader, oldGroup, newGroup, commonRoot);
    var current = oldGroup;
    while (current > 0 && !(current === nearestCommonRoot)) {
      if (reader.x34(current)) {
        $this.t3h_1.m3l();
      }
      current = reader.y34(current);
    }
    doRecordDownsFor($this, newGroup, nearestCommonRoot);
  }
  function doRecordDownsFor($this, group, nearestCommonRoot) {
    if (group > 0 && !(group === nearestCommonRoot)) {
      doRecordDownsFor($this, $this.n3h_1.y34(group), nearestCommonRoot);
      if ($this.n3h_1.x34(group)) {
        $this.t3h_1.c3m(nodeAt($this, $this.n3h_1, group));
      }
    }
  }
  function compositeKeyOf($this, group, recomposeGroup, recomposeKey) {
    var keyRot = 3;
    var rgiRot = 0;
    // Inline function 'androidx.compose.runtime.CompositeKeyHashCode' call
    var result = fromInt(0);
    var parent = group;
    while (parent >= 0) {
      if (parent === recomposeGroup) {
        var tmp0 = result;
        // Inline function 'androidx.compose.runtime.bottomUpCompoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var other = rgiRot;
        var tmp$ret$2 = rotateLeft(recomposeKey, other);
        result = bitwiseXor(tmp0, tmp$ret$2);
        return result;
      }
      var groupKey = groupCompositeKeyPart($this, $this.n3h_1, parent);
      if (groupKey === 126665345) {
        var tmp0_0 = result;
        // Inline function 'androidx.compose.runtime.bottomUpCompoundWith' call
        var shift = rgiRot;
        // Inline function 'androidx.compose.runtime.rol' call
        var this_0 = fromInt(groupKey);
        var tmp$ret$4 = rotateLeft(this_0, shift);
        result = bitwiseXor(tmp0_0, tmp$ret$4);
        return result;
      }
      var effectiveRGroupIndex = $this.n3h_1.b3m(parent) ? 0 : rGroupIndexOf($this, parent);
      var tmp0_1 = result;
      // Inline function 'androidx.compose.runtime.bottomUpCompoundWith' call
      var shift_0 = keyRot;
      // Inline function 'androidx.compose.runtime.rol' call
      var this_1 = fromInt(groupKey);
      var tmp$ret$6 = rotateLeft(this_1, shift_0);
      var tmp0_2 = bitwiseXor(tmp0_1, tmp$ret$6);
      // Inline function 'androidx.compose.runtime.bottomUpCompoundWith' call
      var shift_1 = rgiRot;
      // Inline function 'androidx.compose.runtime.rol' call
      var this_2 = fromInt(effectiveRGroupIndex);
      var tmp$ret$8 = rotateLeft(this_2, shift_1);
      result = bitwiseXor(tmp0_2, tmp$ret$8);
      keyRot = (keyRot + 6 | 0) % 64 | 0;
      rgiRot = (rgiRot + 6 | 0) % 64 | 0;
      parent = $this.n3h_1.y34(parent);
    }
    return result;
  }
  function groupCompositeKeyPart($this, $receiver, group) {
    var tmp;
    if ($receiver.b3m(group)) {
      var tmp0_safe_receiver = $receiver.u3j(group);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_1;
        if (tmp0_safe_receiver instanceof Enum) {
          tmp_1 = tmp0_safe_receiver.a1_1;
        } else {
          if (tmp0_safe_receiver instanceof MovableContent) {
            tmp_1 = 126665345;
          } else {
            tmp_1 = hashCode(tmp0_safe_receiver);
          }
        }
        tmp_0 = tmp_1;
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    } else {
      // Inline function 'kotlin.let' call
      var it = $receiver.t3j(group);
      var tmp_2;
      if (it === 207) {
        var tmp0_safe_receiver_0 = $receiver.s3j(group);
        var tmp_3;
        if (tmp0_safe_receiver_0 == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_3 = equals(tmp0_safe_receiver_0, Companion_getInstance_0().f30_1) ? it : hashCode(tmp0_safe_receiver_0);
        }
        var tmp1_elvis_lhs_0 = tmp_3;
        tmp_2 = tmp1_elvis_lhs_0 == null ? it : tmp1_elvis_lhs_0;
      } else {
        tmp_2 = it;
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function skipReaderToGroupEnd($this) {
    $this.q3g_1 = $this.n3h_1.d3m();
    $this.n3h_1.z30();
  }
  function addRecomposeScope($this) {
    if ($this.a3i_1) {
      var tmp = $this.m3g_1;
      var scope = new RecomposeScopeImpl(tmp instanceof CompositionImpl ? tmp : THROW_CCE());
      Stack__push_impl_s8r905($this.k3h_1, scope);
      $this.r3j(scope);
      enterRecomposeScope($this, scope);
    } else {
      var invalidation = removeLocation($this.y3g_1, $this.n3h_1.e3j_1);
      var slot = $this.n3h_1.v();
      var tmp_0;
      if (equals(slot, Companion_getInstance_0().f30_1)) {
        var tmp_1 = $this.m3g_1;
        var newScope = new RecomposeScopeImpl(tmp_1 instanceof CompositionImpl ? tmp_1 : THROW_CCE());
        $this.r3j(newScope);
        tmp_0 = newScope;
      } else {
        tmp_0 = slot instanceof RecomposeScopeImpl ? slot : THROW_CCE();
      }
      var scope_0 = tmp_0;
      var tmp_2;
      if (!(invalidation == null)) {
        tmp_2 = true;
      } else {
        // Inline function 'kotlin.also' call
        var this_0 = scope_0.e3m();
        if (this_0) {
          scope_0.f3m(false);
        }
        tmp_2 = this_0;
      }
      scope_0.g3m(tmp_2);
      Stack__push_impl_s8r905($this.k3h_1, scope_0);
      enterRecomposeScope($this, scope_0);
      if (scope_0.m3m()) {
        scope_0.h3m(false);
        scope_0.i3m(true);
        $this.t3h_1.j3m(scope_0);
        if (!$this.e3h_1 && scope_0.l3m()) {
          $this.e3h_1 = true;
          $this.f3h_1 = $this.n3h_1.e3j_1;
          scope_0.k3m(true);
        }
      }
    }
  }
  function enterRecomposeScope($this, scope) {
    scope.n3m($this.h3h_1);
    var tmp0_safe_receiver = $this.l3g_1.d39();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.w3l(scope);
    }
  }
  function exitRecomposeScope($this, scope) {
    var tmp0_safe_receiver = $this.l3g_1.d39();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.x3l(scope);
    }
    return scope.o3m($this.h3h_1);
  }
  function invokeMovableContentLambda($this, content, locals, parameter, force) {
    $this.o30(126665345, content);
    updateSlot($this, parameter);
    var savedCompositeKeyHash = $this.b3i_1;
    try {
      var tmp = $this;
      // Inline function 'androidx.compose.runtime.CompositeKeyHashCode' call
      tmp.b3i_1 = fromInt(126665345);
      if ($this.a3i_1) {
        $this.p3h_1.v35();
      }
      var providersChanged = $this.a3i_1 ? false : !equals($this.n3h_1.w3j(), locals);
      if (providersChanged) {
        recordProviderUpdate($this, locals);
      }
      start($this, 202, get_compositionLocalMap(), Companion_getInstance_7().n3j_1, locals);
      $this.r3h_1 = null;
      if ($this.a3i_1 && !force) {
        $this.q3h_1 = true;
        var anchor = $this.p3h_1.o3k($this.p3h_1.y34($this.p3h_1.d34_1));
        var reference = new MovableContentStateReference(content, parameter, $this.m3g_1, $this.o3h_1, anchor, emptyList(), currentCompositionLocalScope($this), null);
        $this.g3g_1.a3c(reference);
      } else {
        var savedProvidersInvalid = $this.c3h_1;
        $this.c3h_1 = providersChanged;
        invokeComposable($this, ComposableLambda$invoke$ref(composableLambdaInstance(-59194059, true, GapComposer$invokeMovableContentLambda$lambda(content, parameter))));
        $this.c3h_1 = savedProvidersInvalid;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw attachComposeStackTrace_1(e, GapComposer$invokeMovableContentLambda$lambda_0($this));
      } else {
        throw $p;
      }
    }
    finally {
      endGroup($this);
      $this.r3h_1 = null;
      $this.b3i_1 = savedCompositeKeyHash;
      $this.p30();
    }
  }
  function insertMovableContentGuarded($this, references) {
    var tmp0 = $this.t3h_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ComposerChangeListWriter.withChangeList' call
    var newChangeList = asGapBufferChangeList($this.k3g_1);
    var previousChangeList = tmp0.j3i_1;
    try {
      tmp0.j3i_1 = newChangeList;
      $this.t3h_1.p3m();
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = references.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = references.l1(index);
          var to = item.zh();
          var from = item.ai();
          var anchor = asGapAnchor(to.g35_1);
          var toSlotTable = asGapBufferSlotTable(to.f35_1);
          var location = toSlotTable.q3m(anchor);
          var effectiveNodeIndex = new IntRef();
          $this.t3h_1.r3m(effectiveNodeIndex, anchor);
          if (from == null) {
            if (equals(toSlotTable, $this.o3h_1)) {
              createFreshInsertTable($this);
            }
            // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
            // Inline function 'kotlin.let' call
            var reader = toSlotTable.d3i();
            var tmp;
            try {
              reader.y3k(location);
              $this.t3h_1.u3m(location);
              var offsetChanges = new ChangeList();
              recomposeMovableContent($this, VOID, VOID, VOID, VOID, GapComposer$insertMovableContentGuarded$lambda($this, offsetChanges, reader, to));
              $this.t3h_1.v3m(offsetChanges, effectiveNodeIndex);
              tmp = Unit_instance;
            }finally {
              reader.j4();
            }
          } else {
            var resolvedState = $this.g3g_1.d3c(from);
            var tmp1_safe_receiver = resolvedState == null ? null : resolvedState.u3a_1;
            var resolvedSlotTable = tmp1_safe_receiver == null ? null : asGapBufferSlotTable(tmp1_safe_receiver);
            var fromTable = resolvedSlotTable == null ? asGapBufferSlotTable(from.f35_1) : resolvedSlotTable;
            var tmp4_elvis_lhs = resolvedSlotTable == null ? null : resolvedSlotTable.o3k(0);
            var fromAnchor = asGapAnchor(tmp4_elvis_lhs == null ? from.g35_1 : tmp4_elvis_lhs);
            var nodesToInsert = collectNodesFrom(fromTable, fromAnchor);
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!nodesToInsert.r()) {
              $this.t3h_1.s3m(nodesToInsert, effectiveNodeIndex);
              if (equals(toSlotTable, $this.h3g_1)) {
                var group = $this.h3g_1.q3m(anchor);
                updateNodeCount($this, group, updatedNodeCount($this, group) + nodesToInsert.n1() | 0);
              }
            }
            $this.t3h_1.t3m(resolvedState, $this.g3g_1, from, to);
            // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
            // Inline function 'kotlin.let' call
            var reader_0 = fromTable.d3i();
            var tmp_0;
            try {
              $l$block: {
                // Inline function 'androidx.compose.runtime.GapComposer.withReader' call
                var savedReader = $this.n3h_1;
                var savedCountOverrides = $this.t3g_1;
                var savedProviderUpdates = $this.b3h_1;
                $this.t3g_1 = null;
                $this.b3h_1 = null;
                try {
                  $this.n3h_1 = reader_0;
                  var newLocation = fromTable.q3m(asGapAnchor(fromAnchor));
                  reader_0.y3k(newLocation);
                  $this.t3h_1.u3m(newLocation);
                  var offsetChanges_0 = new ChangeList();
                  // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ComposerChangeListWriter.withChangeList' call
                  var this_0 = $this.t3h_1;
                  var previousChangeList_0 = this_0.j3i_1;
                  try {
                    this_0.j3i_1 = offsetChanges_0;
                    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ComposerChangeListWriter.withoutImplicitRootStart' call
                    var this_1 = $this.t3h_1;
                    var previousImplicitRootStart = this_1.m3i_1;
                    try {
                      this_1.m3i_1 = false;
                      var tmp_1 = reader_0.c3j_1;
                      var tmp_2 = from.h35_1;
                      recomposeMovableContent($this, from.e35_1, to.e35_1, tmp_1, tmp_2, GapComposer$insertMovableContentGuarded$lambda_0($this, to));
                    }finally {
                      this_1.m3i_1 = previousImplicitRootStart;
                    }
                  }finally {
                    this_0.j3i_1 = previousChangeList_0;
                  }
                  $this.t3h_1.v3m(offsetChanges_0, effectiveNodeIndex);
                  break $l$block;
                }finally {
                  $this.n3h_1 = savedReader;
                  $this.t3g_1 = savedCountOverrides;
                  $this.b3h_1 = savedProviderUpdates;
                }
              }
              tmp_0 = Unit_instance;
            }finally {
              reader_0.j4();
            }
          }
          $this.t3h_1.w3m();
        }
         while (inductionVariable <= last);
      $this.t3h_1.x3m();
      $this.t3h_1.u3m(0);
    }finally {
      tmp0.j3i_1 = previousChangeList;
    }
  }
  function recomposeMovableContent($this, from, to, index, invalidations, block) {
    from = from === VOID ? null : from;
    to = to === VOID ? null : to;
    index = index === VOID ? null : index;
    invalidations = invalidations === VOID ? emptyList() : invalidations;
    var savedIsComposing = $this.l3h_1;
    var savedNodeIndex = $this.p3g_1;
    try {
      $this.l3h_1 = true;
      $this.p3g_1 = 0;
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = invalidations.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = invalidations.l1(index_0);
          var scope = item.zh();
          var instances = item.ai();
          if (!(instances == null)) {
            $this.f33(scope, instances);
          } else {
            $this.f33(scope, null);
          }
        }
         while (inductionVariable <= last);
      var tmp;
      if (from == null) {
        tmp = null;
      } else {
        tmp = from.a3b(to, index == null ? -1 : index, block);
      }
      var tmp2_elvis_lhs = tmp;
      return tmp2_elvis_lhs == null ? block() : tmp2_elvis_lhs;
    }finally {
      $this.l3h_1 = savedIsComposing;
      $this.p3g_1 = savedNodeIndex;
    }
  }
  function currentStackTrace($this) {
    var tmp;
    if ($this.g3g_1.q3b()) {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList_init_$Create$();
      this_0.o1(buildTrace_3($this.p3h_1));
      this_0.o1(buildTrace_4($this.n3h_1));
      this_0.o1($this.b33());
      var tmp$ret$0 = this_0.t5();
      tmp = new ComposeStackTrace(tmp$ret$0, $this.i3h_1);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function stackTraceForGroup($this, group, dataOffset) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
    // Inline function 'kotlin.let' call
    var reader = $this.h3g_1.d3i();
    var tmp;
    try {
      tmp = traceForGroup_0(reader, group, dataOffset);
    }finally {
      reader.j4();
    }
    return tmp;
  }
  function doCompose($this, invalidationsRequested, content) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!$this.l3h_1) {
      var tmp$ret$1 = 'Reentrant composition is not supported';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var observer = $this.l3g_1.d39();
    var tmp0 = 'Compose:recompose';
    $l$block: {
      // Inline function 'androidx.compose.runtime.internal.trace' call
      var token = Trace_instance.r38(tmp0);
      try {
        $this.h3h_1 = getNumberHashCode(currentSnapshot().w3d());
        $this.b3h_1 = null;
        $this.g33(invalidationsRequested);
        $this.p3g_1 = 0;
        var complete = false;
        $this.l3h_1 = true;
        if (observer == null)
          null;
        else {
          observer.y3m($this.m3g_1);
        }
        try {
          startRoot($this);
          var savedContent = $this.q3j();
          if (!(savedContent === content) && !(content == null)) {
            $this.r3j(!(content == null) ? content : THROW_CCE());
          }
          // Inline function 'androidx.compose.runtime.observeDerivedStateRecalculations' call
          var observer_0 = $this.j3h_1;
          var observers = derivedStateObservers_0();
          try {
            observers.zz(observer_0);
            if (!(content == null)) {
              startGroup_0($this, 200, get_invocation());
              invokeComposable($this, content);
              endGroup($this);
            } else if (($this.w3g_1 || $this.c3h_1) && !(savedContent == null) && !equals(savedContent, Companion_getInstance_0().f30_1)) {
              startGroup_0($this, 200, get_invocation());
              invokeComposable($this, typeof savedContent === 'function' ? savedContent : THROW_CCE());
              endGroup($this);
            } else {
              $this.z3m();
            }
          }finally {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
            var tmp$ret$6 = observers.d3e_1 - 1 | 0;
            observers.h3(tmp$ret$6);
          }
          endRoot($this);
          complete = true;
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            throw attachComposeStackTrace_1(e, GapComposer$doCompose$lambda($this));
          } else {
            throw $p;
          }
        }
        finally {
          if (observer == null)
            null;
          else {
            observer.a3n($this.m3g_1);
          }
          $this.l3h_1 = false;
          $this.y3g_1.c3();
          if (!complete) {
            abortRoot($this);
          }
          createFreshInsertTable($this);
        }
        break $l$block;
      }finally {
        Trace_instance.t38(token);
      }
    }
  }
  function _get_node__db0vwp($this, $receiver) {
    return $receiver.z34($receiver.e3j_1);
  }
  function nodeAt($this, $receiver, index) {
    return $receiver.z34(index);
  }
  function validateNodeExpected($this) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!$this.x3g_1) {
      var tmp$ret$1 = 'A call to createNode(), emitNode() or useNode() expected was not expected';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    $this.x3g_1 = false;
  }
  function validateNodeNotExpected($this) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!$this.x3g_1) {
      var tmp$ret$1 = 'A call to createNode(), emitNode() or useNode() expected';
      composeImmediateRuntimeError(tmp$ret$1);
    }
  }
  function recordInsert($this, anchor) {
    if ($this.v3h_1.r()) {
      $this.t3h_1.c3n(anchor, $this.o3h_1);
    } else {
      $this.t3h_1.b3n(anchor, $this.o3h_1, $this.v3h_1);
      $this.v3h_1 = new FixupList();
    }
  }
  function recordDelete($this) {
    reportFreeMovableContent($this, $this.n3h_1.c3j_1);
    $this.t3h_1.d3n();
  }
  function reportFreeMovableContent($this, groupBeingRemoved) {
    var rootIsNode = $this.n3h_1.x34(groupBeingRemoved);
    if (rootIsNode) {
      $this.t3h_1.h3l();
      $this.t3h_1.c3m($this.n3h_1.z34(groupBeingRemoved));
    }
    reportFreeMovableContent$reportGroup($this, groupBeingRemoved, groupBeingRemoved, rootIsNode, 0);
    $this.t3h_1.h3l();
    if (rootIsNode) {
      $this.t3h_1.m3l();
    }
  }
  function reportAllMovableContent($this) {
    if ($this.h3g_1.f3n()) {
      $this.m3g_1.s39();
      var changes = new ChangeList();
      $this.s3h_1 = changes;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
      // Inline function 'kotlin.let' call
      var reader = $this.h3g_1.d3i();
      var tmp;
      try {
        $this.n3h_1 = reader;
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ComposerChangeListWriter.withChangeList' call
        var this_0 = $this.t3h_1;
        var previousChangeList = this_0.j3i_1;
        try {
          this_0.j3i_1 = changes;
          reportFreeMovableContent($this, 0);
          $this.t3h_1.e3n();
        }finally {
          this_0.j3i_1 = previousChangeList;
        }
        tmp = Unit_instance;
      }finally {
        reader.j4();
      }
    }
  }
  function finalizeCompose($this) {
    $this.t3h_1.g3n();
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!Stack__isEmpty_impl_modt1q($this.n3g_1)) {
      var tmp$ret$1 = 'Start/end imbalance';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    cleanUpCompose($this);
  }
  function cleanUpCompose($this) {
    $this.o3g_1 = null;
    $this.p3g_1 = 0;
    $this.q3g_1 = 0;
    $this.b3i_1 = new Long(0, 0);
    $this.x3g_1 = false;
    $this.t3h_1.h3n();
    Stack__clear_impl_qoqv3c($this.k3h_1);
    clearUpdatedNodeCounts($this);
  }
  function CompositionContextHolder(ref) {
    this.i3n_1 = ref;
  }
  protoOf(CompositionContextHolder).g3f = function () {
  };
  protoOf(CompositionContextHolder).i3f = function () {
    this.i3n_1.s1d();
  };
  protoOf(CompositionContextHolder).h3f = function () {
    this.i3n_1.s1d();
  };
  function CompositionContextImpl($outer, compositeKeyHashCode, collectingParameterInformation, collectingSourceInformation, observerHolder) {
    this.e3g_1 = $outer;
    CompositionContext.call(this);
    this.x3f_1 = compositeKeyHashCode;
    this.y3f_1 = collectingParameterInformation;
    this.z3f_1 = collectingSourceInformation;
    this.a3g_1 = observerHolder;
    this.b3g_1 = null;
    this.c3g_1 = mutableScatterSetOf();
    this.d3g_1 = mutableStateOf(persistentCompositionLocalHashMapOf(), referentialEqualityPolicy());
  }
  protoOf(CompositionContextImpl).o3b = function () {
    return this.x3f_1;
  };
  protoOf(CompositionContextImpl).p3b = function () {
    return this.y3f_1;
  };
  protoOf(CompositionContextImpl).f39 = function () {
    return this.z3f_1;
  };
  protoOf(CompositionContextImpl).n3b = function () {
    return this.a3g_1;
  };
  protoOf(CompositionContextImpl).e39 = function () {
    return this.e3g_1.g3g_1.e39();
  };
  protoOf(CompositionContextImpl).q3b = function () {
    return this.e3g_1.g3g_1.q3b();
  };
  protoOf(CompositionContextImpl).s1d = function () {
    if (this.c3g_1.fv()) {
      var tmp0_safe_receiver = this.b3g_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'androidx.collection.ScatterSet.forEach' call
        var this_0 = this.c3g_1;
        // Inline function 'kotlin.contracts.contract' call
        var elements = this_0.k16_1;
        $l$block: {
          // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
          // Inline function 'kotlin.contracts.contract' call
          var m = this_0.j16_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_1 = slot;
              var tmp$ret$6 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$6, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var composer = elements[index];
                      var _iterator__ex2g4s = tmp0_safe_receiver.t();
                      while (_iterator__ex2g4s.u()) {
                        var table = _iterator__ex2g4s.v();
                        table.d3(composer.h3i());
                      }
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
      }
      this.c3g_1.c3();
    }
  };
  protoOf(CompositionContextImpl).g39 = function (composer) {
    protoOf(CompositionContext).g39.call(this, composer instanceof GapComposer ? composer : THROW_CCE());
    this.c3g_1.j1(composer);
  };
  protoOf(CompositionContextImpl).x3b = function (composer) {
    var tmp0_safe_receiver = this.b3g_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0_safe_receiver.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        element.d3((composer instanceof GapComposer ? composer : THROW_CCE()).h3i());
      }
    }
    if (composer instanceof GapComposer) {
      this.c3g_1.d3(composer);
    }
  };
  protoOf(CompositionContextImpl).u39 = function (composition) {
    this.e3g_1.g3g_1.u39(composition);
  };
  protoOf(CompositionContextImpl).v3b = function (scope) {
    this.e3g_1.g3g_1.v3b(scope);
  };
  protoOf(CompositionContextImpl).r3b = function () {
    return this.e3g_1.g3g_1.r3b();
  };
  protoOf(CompositionContextImpl).o37 = function (composition, content) {
    this.e3g_1.g3g_1.o37(composition, content);
  };
  protoOf(CompositionContextImpl).t3b = function (composition, shouldPause, content) {
    return this.e3g_1.g3g_1.t3b(composition, shouldPause, content);
  };
  protoOf(CompositionContextImpl).u3b = function (composition, shouldPause, invalidScopes) {
    return this.e3g_1.g3g_1.u3b(composition, shouldPause, invalidScopes);
  };
  protoOf(CompositionContextImpl).z38 = function (composition) {
    this.e3g_1.g3g_1.z38(this.e3g_1.m3g_1);
    this.e3g_1.g3g_1.z38(composition);
  };
  protoOf(CompositionContextImpl).b30 = function () {
    return _get_compositionLocalScope__ulge9q(this);
  };
  protoOf(CompositionContextImpl).j3n = function (scope) {
    _set_compositionLocalScope__ya1b9q(this, scope);
  };
  protoOf(CompositionContextImpl).w3b = function (table) {
    var tmp0_elvis_lhs = this.b3g_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = HashSet_init_$Create$();
      this.b3g_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    tmp.j1(table);
  };
  protoOf(CompositionContextImpl).y3b = function () {
    var _unary__edvuaz = this.e3g_1.g3h_1;
    this.e3g_1.g3h_1 = _unary__edvuaz + 1 | 0;
  };
  protoOf(CompositionContextImpl).z3b = function () {
    var _unary__edvuaz = this.e3g_1.g3h_1;
    this.e3g_1.g3h_1 = _unary__edvuaz - 1 | 0;
  };
  protoOf(CompositionContextImpl).a3c = function (reference) {
    this.e3g_1.g3g_1.a3c(reference);
  };
  protoOf(CompositionContextImpl).b3c = function (reference) {
    this.e3g_1.g3g_1.b3c(reference);
  };
  protoOf(CompositionContextImpl).d3c = function (reference) {
    return this.e3g_1.g3g_1.d3c(reference);
  };
  protoOf(CompositionContextImpl).c3c = function (reference, data, applier) {
    this.e3g_1.g3g_1.c3c(reference, data, applier);
  };
  protoOf(CompositionContextImpl).e3c = function (composition) {
    this.e3g_1.g3g_1.e3c(composition);
  };
  protoOf(CompositionContextImpl).s3b = function () {
    return this.e3g_1.m3g_1;
  };
  function GapComposer$derivedStateObserver$1(this$0) {
    this.k3n_1 = this$0;
  }
  protoOf(GapComposer$derivedStateObserver$1).e3e = function (derivedState) {
    var _unary__edvuaz = this.k3n_1.g3h_1;
    this.k3n_1.g3h_1 = _unary__edvuaz + 1 | 0;
  };
  protoOf(GapComposer$derivedStateObserver$1).n3e = function (derivedState) {
    var _unary__edvuaz = this.k3n_1.g3h_1;
    this.k3n_1.g3h_1 = _unary__edvuaz - 1 | 0;
  };
  function GapComposer$invokeMovableContentLambda$lambda($content, $parameter) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        tmp = $content.l3n_1($parameter, $composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GapComposer$invokeMovableContentLambda$lambda_0(this$0) {
    return function () {
      return currentStackTrace(this$0);
    };
  }
  function GapComposer$insertMovableContentGuarded$lambda(this$0, $offsetChanges, $reader, $to) {
    return function () {
      var tmp0 = this$0.t3h_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ComposerChangeListWriter.withChangeList' call
      var newChangeList = $offsetChanges;
      var previousChangeList = tmp0.j3i_1;
      try {
        tmp0.j3i_1 = newChangeList;
        var tmp0_0 = this$0;
        var tmp2 = $reader;
        $l$block: {
          // Inline function 'androidx.compose.runtime.GapComposer.withReader' call
          var savedReader = tmp0_0.n3h_1;
          var savedCountOverrides = tmp0_0.t3g_1;
          var savedProviderUpdates = tmp0_0.b3h_1;
          tmp0_0.t3g_1 = null;
          tmp0_0.b3h_1 = null;
          try {
            tmp0_0.n3h_1 = tmp2;
            // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ComposerChangeListWriter.withoutImplicitRootStart' call
            var this_0 = this$0.t3h_1;
            var previousImplicitRootStart = this_0.m3i_1;
            try {
              this_0.m3i_1 = false;
              invokeMovableContentLambda(this$0, $to.c35_1, $to.i35_1, $to.d35_1, true);
            }finally {
              this_0.m3i_1 = previousImplicitRootStart;
            }
            break $l$block;
          }finally {
            tmp0_0.n3h_1 = savedReader;
            tmp0_0.t3g_1 = savedCountOverrides;
            tmp0_0.b3h_1 = savedProviderUpdates;
          }
        }
      }finally {
        tmp0.j3i_1 = previousChangeList;
      }
      return Unit_instance;
    };
  }
  function GapComposer$insertMovableContentGuarded$lambda_0(this$0, $to) {
    return function () {
      invokeMovableContentLambda(this$0, $to.c35_1, $to.i35_1, $to.d35_1, true);
      return Unit_instance;
    };
  }
  function GapComposer$stackTraceForValue$lambda($value) {
    return function (it) {
      var tmp;
      if (it === $value) {
        tmp = true;
      } else {
        var tmp0_safe_receiver = (!(it == null) ? isInterface(it, RememberObserverHolder) : false) ? it : null;
        tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h33()) === $value;
      }
      return tmp;
    };
  }
  function GapComposer$doCompose$lambda(this$0) {
    return function () {
      return currentStackTrace(this$0);
    };
  }
  function reportFreeMovableContent$movableContentReferenceFor$traverseGroups(this$0, nestedStates, group) {
    var size = this$0.n3h_1.a35(group);
    var end = group + size | 0;
    var current = group + 1 | 0;
    while (current < end) {
      if (this$0.n3h_1.n3n(current)) {
        var tmp0_safe_receiver = reportFreeMovableContent$movableContentReferenceFor(this$0, current);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          nestedStates.j1(tmp0_safe_receiver);
        }
      } else if (this$0.n3h_1.m3n(current)) {
        reportFreeMovableContent$movableContentReferenceFor$traverseGroups(this$0, nestedStates, current);
      }
      current = current + this$0.n3h_1.a35(current) | 0;
    }
  }
  function reportFreeMovableContent$createMovableContentReferenceForGroup(this$0, group, nestedStates) {
    var tmp = this$0.n3h_1.u3j(group);
    var movableContent = tmp instanceof MovableContent ? tmp : THROW_CCE();
    var parameter = this$0.n3h_1.o3n(group, 0);
    var anchor = this$0.n3h_1.o3k(group);
    var end = group + this$0.n3h_1.a35(group) | 0;
    // Inline function 'kotlin.collections.mutableListOf' call
    var invalidations = ArrayList_init_$Create$();
    // Inline function 'androidx.compose.runtime.forEachInRange' call
    var this_0 = this$0.y3g_1;
    var index = findInsertLocation(this_0, group);
    $l$loop: while (index < this_0.n1()) {
      var invalidation = this_0.l1(index);
      if (invalidation.t3l_1 >= end)
        break $l$loop;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = to(invalidation.s3l_1, invalidation.u3l_1);
      invalidations.j1(element);
      index = index + 1 | 0;
    }
    var reference = new MovableContentStateReference(movableContent, parameter, this$0.m3g_1, this$0.h3g_1, anchor, invalidations, currentCompositionLocalScope_0(this$0, group), nestedStates);
    return reference;
  }
  function reportFreeMovableContent$movableContentReferenceFor(this$0, group) {
    var key = this$0.n3h_1.t3j(group);
    var objectKey = this$0.n3h_1.u3j(group);
    var tmp;
    var tmp_0;
    if (key === 126665345) {
      tmp_0 = objectKey instanceof MovableContent;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_1;
      if (this$0.n3h_1.m3n(group)) {
        // Inline function 'kotlin.collections.mutableListOf' call
        var nestedStates = ArrayList_init_$Create$();
        reportFreeMovableContent$movableContentReferenceFor$traverseGroups(this$0, nestedStates, group);
        // Inline function 'kotlin.takeIf' call
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!nestedStates.r()) {
          tmp_2 = nestedStates;
        } else {
          tmp_2 = null;
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = null;
      }
      var nestedStates_0 = tmp_1;
      tmp = reportFreeMovableContent$createMovableContentReferenceForGroup(this$0, group, nestedStates_0);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function reportFreeMovableContent$reportGroup(this$0, $groupBeingRemoved, group, needsNodeDelete, nodeIndex) {
    var reader = this$0.n3h_1;
    var tmp;
    if (reader.n3n(group)) {
      var key = reader.t3j(group);
      var objectKey = reader.u3j(group);
      var tmp_0;
      var tmp_1;
      if (key === 126665345) {
        tmp_1 = objectKey instanceof MovableContent;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var reference = reportFreeMovableContent$movableContentReferenceFor(this$0, group);
        if (!(reference == null)) {
          this$0.g3g_1.b3c(reference);
          this$0.t3h_1.p3n();
          this$0.t3h_1.q3n(this$0.m3g_1, this$0.g3g_1, reference);
        }
        var tmp_2;
        if (needsNodeDelete && !(group === $groupBeingRemoved)) {
          this$0.t3h_1.r3n(nodeIndex, group);
          tmp_2 = 0;
        } else {
          tmp_2 = reader.b35(group);
        }
        tmp_0 = tmp_2;
      } else {
        if (key === 206 && equals(objectKey, get_reference())) {
          var tmp_3 = reader.o3n(group, 0);
          var observerHolder = (!(tmp_3 == null) ? isInterface(tmp_3, RememberObserverHolder) : false) ? tmp_3 : null;
          var tmp_4 = observerHolder == null ? null : observerHolder.h33();
          var contextHolder = tmp_4 instanceof CompositionContextHolder ? tmp_4 : null;
          if (!(contextHolder == null)) {
            var compositionContext = contextHolder.i3n_1;
            // Inline function 'androidx.collection.ScatterSet.forEach' call
            var this_0 = compositionContext.c3g_1;
            // Inline function 'kotlin.contracts.contract' call
            var elements = this_0.k16_1;
            $l$block: {
              // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
              // Inline function 'kotlin.contracts.contract' call
              var m = this_0.j16_1;
              var lastIndex = m.length - 2 | 0;
              var inductionVariable = 0;
              if (inductionVariable <= lastIndex)
                do {
                  var i = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var slot = m[i];
                  // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                  var this_1 = slot;
                  var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
                  if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
                    var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < bitCount)
                      do {
                        var j = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'androidx.collection.isFull' call
                        var value = bitwiseAnd(slot, new Long(255, 0));
                        if (compare(value, new Long(128, 0)) < 0) {
                          var index = (i << 3) + j | 0;
                          var composer = elements[index];
                          reportAllMovableContent(composer);
                          this$0.g3g_1.e3c(composer.m3g_1);
                        }
                        slot = shiftRight(slot, 8);
                      }
                       while (inductionVariable_0 < bitCount);
                    if (!(bitCount === 8)) {
                      break $l$block;
                    }
                  }
                }
                 while (!(i === lastIndex));
            }
          }
          tmp_0 = reader.b35(group);
        } else {
          if (reader.x34(group)) {
            tmp_0 = 1;
          } else {
            tmp_0 = reader.b35(group);
          }
        }
      }
      tmp = tmp_0;
    } else if (reader.m3n(group)) {
      var size = reader.a35(group);
      var end = group + size | 0;
      var current = group + 1 | 0;
      var runningNodeCount = 0;
      while (current < end) {
        var isNode = reader.x34(current);
        if (isNode) {
          this$0.t3h_1.h3l();
          this$0.t3h_1.c3m(reader.z34(current));
        }
        runningNodeCount = runningNodeCount + reportFreeMovableContent$reportGroup(this$0, $groupBeingRemoved, current, isNode || needsNodeDelete, isNode ? 0 : nodeIndex + runningNodeCount | 0) | 0;
        if (isNode) {
          this$0.t3h_1.h3l();
          this$0.t3h_1.m3l();
        }
        current = current + reader.a35(current) | 0;
      }
      tmp = reader.x34(group) ? 1 : runningNodeCount;
    } else if (reader.x34(group)) {
      tmp = 1;
    } else {
      tmp = reader.b35(group);
    }
    return tmp;
  }
  function GapComposer(applier, parentContext, slotTable, abandonSet, changes, lateChanges, observerHolder, composition) {
    InternalComposer.call(this);
    this.f3g_1 = applier;
    this.g3g_1 = parentContext;
    this.h3g_1 = slotTable;
    this.i3g_1 = abandonSet;
    this.j3g_1 = changes;
    this.k3g_1 = lateChanges;
    this.l3g_1 = observerHolder;
    this.m3g_1 = composition;
    this.n3g_1 = _Stack___init__impl__tvpfn5();
    this.o3g_1 = null;
    this.p3g_1 = 0;
    this.q3g_1 = 0;
    this.r3g_1 = 0;
    this.s3g_1 = new IntStack();
    this.t3g_1 = null;
    this.u3g_1 = null;
    this.v3g_1 = false;
    this.w3g_1 = false;
    this.x3g_1 = false;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.y3g_1 = ArrayList_init_$Create$();
    this.z3g_1 = new IntStack();
    this.a3h_1 = persistentCompositionLocalHashMapOf();
    this.b3h_1 = null;
    this.c3h_1 = false;
    this.d3h_1 = new IntStack();
    this.e3h_1 = false;
    this.f3h_1 = -1;
    this.g3h_1 = 0;
    this.h3h_1 = 0;
    this.i3h_1 = this.g3g_1.f39() || this.g3g_1.e39();
    var tmp_0 = this;
    tmp_0.j3h_1 = new GapComposer$derivedStateObserver$1(this);
    this.k3h_1 = _Stack___init__impl__tvpfn5();
    this.l3h_1 = false;
    this.m3h_1 = false;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var this_0 = this.h3g_1.d3i();
    this_0.j4();
    tmp_1.n3h_1 = this_0;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new SlotTable();
    if (this.g3g_1.f39()) {
      this_1.t34();
    }
    if (this.g3g_1.e39()) {
      this_1.v34();
    }
    tmp_2.o3h_1 = this_1;
    var tmp_3 = this;
    // Inline function 'kotlin.also' call
    var this_2 = this.o3h_1.s35();
    this_2.b36(true);
    tmp_3.p3h_1 = this_2;
    this.q3h_1 = false;
    this.r3h_1 = null;
    this.s3h_1 = null;
    this.t3h_1 = new ComposerChangeListWriter(this, asGapBufferChangeList(this.j3g_1));
    var tmp_4 = this;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
    // Inline function 'kotlin.let' call
    var reader = this.o3h_1.d3i();
    var tmp_5;
    try {
      tmp_5 = reader.o3k(0);
    }finally {
      reader.j4();
    }
    tmp_4.u3h_1 = tmp_5;
    this.v3h_1 = new FixupList();
    this.w3h_1 = false;
    this.x3h_1 = null;
    this.y3h_1 = new CompositionErrorContextImpl(this);
    var tmp_6 = this;
    var tmp_7 = this.g3g_1.r3b();
    var tmp0_elvis_lhs = this.s32();
    tmp_6.z3h_1 = tmp_7.xj(tmp0_elvis_lhs == null ? EmptyCoroutineContext_getInstance() : tmp0_elvis_lhs);
    this.a3i_1 = false;
    this.b3i_1 = new Long(0, 0);
    this.c3i_1 = null;
  }
  protoOf(GapComposer).g30 = function () {
    return this.f3g_1;
  };
  protoOf(GapComposer).u32 = function () {
    return this.i3h_1;
  };
  protoOf(GapComposer).q32 = function () {
    return this.l3h_1;
  };
  protoOf(GapComposer).p32 = function () {
    return this.g3h_1 > 0;
  };
  protoOf(GapComposer).t32 = function () {
    return this.s3h_1;
  };
  protoOf(GapComposer).s32 = function () {
    return this.g3g_1.q3b() ? this.y3h_1 : null;
  };
  protoOf(GapComposer).z31 = function () {
    return this.z3h_1;
  };
  protoOf(GapComposer).k30 = function (key) {
    return start(this, key, null, Companion_getInstance_7().n3j_1, null);
  };
  protoOf(GapComposer).l30 = function () {
    return endGroup(this);
  };
  protoOf(GapComposer).m30 = function (key) {
    var pending = this.o3g_1;
    if (!(pending == null)) {
      start(this, key, null, Companion_getInstance_7().n3j_1, null);
      return Unit_instance;
    }
    validateNodeNotExpected(this);
    // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroup' call
    var rGroupIndex = this.r3g_1;
    if (null == null)
      if (!(null == null) && key === 207 && !equals(null, Companion_getInstance_0().f30_1)) {
        // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey = hashCode(null);
        var tmp = this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_0 = this.b3i_1;
        var tmp$ret$3 = rotateLeft(this_0, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_1 = bitwiseXor(tmp$ret$3, fromInt(groupKey));
        var tmp$ret$5 = rotateLeft(this_1, 3);
        tmp.b3i_1 = bitwiseXor(tmp$ret$5, fromInt(rGroupIndex));
      } else {
        // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var tmp_0 = this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_2 = this.b3i_1;
        var tmp$ret$8 = rotateLeft(this_2, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_3 = bitwiseXor(tmp$ret$8, fromInt(key));
        var tmp$ret$10 = rotateLeft(this_3, 3);
        tmp_0.b3i_1 = bitwiseXor(tmp$ret$10, fromInt(rGroupIndex));
      }
     else {
      if (null instanceof Enum) {
        // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey_0 = null.a1_1;
        var tmp_1 = this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_4 = this.b3i_1;
        var tmp$ret$13 = rotateLeft(this_4, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_5 = bitwiseXor(tmp$ret$13, fromInt(groupKey_0));
        var tmp$ret$15 = rotateLeft(this_5, 3);
        tmp_1.b3i_1 = bitwiseXor(tmp$ret$15, fromInt(0));
      } else {
        // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey_1 = hashCode(null);
        var tmp_2 = this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_6 = this.b3i_1;
        var tmp$ret$18 = rotateLeft(this_6, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_7 = bitwiseXor(tmp$ret$18, fromInt(groupKey_1));
        var tmp$ret$20 = rotateLeft(this_7, 3);
        tmp_2.b3i_1 = bitwiseXor(tmp$ret$20, fromInt(0));
      }
    }
    this.r3g_1 = this.r3g_1 + 1 | 0;
    var reader = this.n3h_1;
    if (this.a3i_1) {
      reader.z3j();
      this.p3h_1.u35(key, Companion_getInstance_0().f30_1);
      enterGroup(this, false, null);
      return Unit_instance;
    }
    var slotKey = reader.k3k();
    if (slotKey === key && !reader.s3n()) {
      reader.x3j();
      enterGroup(this, false, null);
      return Unit_instance;
    }
    if (!reader.l3l()) {
      var removeIndex = this.p3g_1;
      var startSlot = reader.c3j_1;
      recordDelete(this);
      var nodesToRemove = reader.y35();
      this.t3h_1.c3l(removeIndex, nodesToRemove);
      removeRange(this.y3g_1, startSlot, reader.c3j_1);
    }
    reader.z3j();
    this.a3i_1 = true;
    this.r3h_1 = null;
    ensureWriter(this);
    var writer = this.p3h_1;
    writer.t35();
    var startIndex = writer.b34_1;
    writer.u35(key, Companion_getInstance_0().f30_1);
    this.u3h_1 = writer.o3k(startIndex);
    enterGroup(this, false, null);
  };
  protoOf(GapComposer).n30 = function () {
    return endGroup(this);
  };
  protoOf(GapComposer).q30 = function () {
    return start(this, -127, null, Companion_getInstance_7().n3j_1, null);
  };
  protoOf(GapComposer).r30 = function () {
    endGroup(this);
    var scope = this.r32();
    if (!(scope == null) && scope.b3l()) {
      scope.t3n(true);
    }
  };
  protoOf(GapComposer).j30 = function () {
    var tmp;
    if (!this.i30() || this.c3h_1) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = this.r32();
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j30()) === true;
    }
    return tmp;
  };
  protoOf(GapComposer).o30 = function (key, dataKey) {
    return start(this, key, dataKey, Companion_getInstance_7().n3j_1, null);
  };
  protoOf(GapComposer).p30 = function () {
    return endGroup(this);
  };
  protoOf(GapComposer).x32 = function () {
    this.b3h_1 = null;
  };
  protoOf(GapComposer).h30 = function () {
    return this.a3i_1;
  };
  protoOf(GapComposer).i30 = function () {
    var tmp;
    var tmp_0;
    if (!this.a3i_1 && !this.e3h_1 && !this.c3h_1) {
      var tmp0_safe_receiver = this.r32();
      tmp_0 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u3n()) === false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !this.w3g_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(GapComposer).z2z = function () {
    return this.b3i_1;
  };
  protoOf(GapComposer).y32 = function () {
    var tmp0 = 'Compose:Composer.dispose';
    $l$block: {
      // Inline function 'androidx.compose.runtime.internal.trace' call
      var token = Trace_instance.r38(tmp0);
      try {
        this.g3g_1.x3b(this);
        this.z32();
        this.f3g_1.c3();
        this.m3h_1 = true;
        break $l$block;
      }finally {
        Trace_instance.t38(token);
      }
    }
  };
  protoOf(GapComposer).z32 = function () {
    Stack__clear_impl_qoqv3c(this.k3h_1);
    this.y3g_1.c3();
    this.j3g_1.c3();
    this.b3h_1 = null;
  };
  protoOf(GapComposer).b31 = function () {
    start(this, 125, null, Companion_getInstance_7().p3j_1, null);
    this.x3g_1 = true;
  };
  protoOf(GapComposer).c31 = function (factory) {
    validateNodeExpected(this);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.a3i_1) {
      var tmp$ret$1 = 'createNode() can only be called when inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var insertIndex = this.s3g_1.v3n();
    var groupAnchor = this.p3h_1.o3k(this.p3h_1.d34_1);
    this.q3g_1 = this.q3g_1 + 1 | 0;
    this.v3h_1.w3n(factory, insertIndex, groupAnchor);
  };
  protoOf(GapComposer).d31 = function () {
    validateNodeExpected(this);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.a3i_1) {
      var tmp$ret$1 = 'useNode() called while inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var node = _get_node__db0vwp(this, this.n3h_1);
    this.t3h_1.c3m(node);
    var tmp;
    if (this.e3h_1) {
      tmp = !(node == null) ? isInterface(node, ComposeNodeLifecycleCallback) : false;
    } else {
      tmp = false;
    }
    if (tmp) {
      this.t3h_1.x3n(node);
    }
  };
  protoOf(GapComposer).e31 = function () {
    return end(this, true);
  };
  protoOf(GapComposer).f31 = function (key, dataKey) {
    if (!this.a3i_1) {
      if (this.n3h_1.k3k() === key && !equals(this.n3h_1.w3j(), dataKey) && this.f3h_1 < 0) {
        this.f3h_1 = this.n3h_1.c3j_1;
        this.e3h_1 = true;
      }
    }
    start(this, key, null, Companion_getInstance_7().n3j_1, dataKey);
  };
  protoOf(GapComposer).g31 = function () {
    if (this.e3h_1 && this.n3h_1.e3j_1 === this.f3h_1) {
      this.f3h_1 = -1;
      this.e3h_1 = false;
    }
    end(this, false);
  };
  protoOf(GapComposer).v32 = function () {
    this.f3h_1 = 0;
    this.e3h_1 = true;
  };
  protoOf(GapComposer).w32 = function () {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(!this.l3h_1 && this.f3h_1 === 0)) {
      var tmp$ret$1 = 'Cannot disable reuse from root if it was caused by other groups';
      throwIllegalArgumentException(tmp$ret$1);
    }
    this.f3h_1 = -1;
    this.e3h_1 = false;
  };
  protoOf(GapComposer).h31 = function (value, block) {
    if (this.a3i_1) {
      this.v3h_1.z3n(value, block);
    } else {
      this.t3h_1.y3n(value, block);
    }
  };
  protoOf(GapComposer).q3j = function () {
    var tmp;
    if (this.a3i_1) {
      validateNodeNotExpected(this);
      tmp = Companion_getInstance_0().f30_1;
    } else {
      // Inline function 'kotlin.let' call
      var it = this.n3h_1.v();
      var tmp_0;
      var tmp_1;
      if (this.e3h_1) {
        tmp_1 = !(!(it == null) ? isInterface(it, ReusableRememberObserverHolder) : false);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = Companion_getInstance_0().f30_1;
      } else {
        tmp_0 = it;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(GapComposer).a3o = function () {
    var tmp;
    if (this.a3i_1) {
      validateNodeNotExpected(this);
      tmp = Companion_getInstance_0().f30_1;
    } else {
      // Inline function 'kotlin.let' call
      var it = this.n3h_1.v();
      var tmp_0;
      var tmp_1;
      if (this.e3h_1) {
        tmp_1 = !(!(it == null) ? isInterface(it, ReusableRememberObserverHolder) : false);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = Companion_getInstance_0().f30_1;
      } else {
        if (!(it == null) ? isInterface(it, RememberObserverHolder) : false) {
          tmp_0 = it.h33();
        } else {
          tmp_0 = it;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(GapComposer).k31 = function (value) {
    var tmp;
    if (!equals(this.q3j(), value)) {
      this.r3j(value);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(GapComposer).q31 = function (value) {
    var tmp;
    if (!(this.q3j() === value)) {
      this.r3j(value);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(GapComposer).l31 = function (value) {
    var next = this.q3j();
    if (!(next == null) ? typeof next === 'boolean' : false) {
      var nextPrimitive = next;
      if (value === nextPrimitive)
        return false;
    }
    this.r3j(value);
    return true;
  };
  protoOf(GapComposer).n31 = function (value) {
    var next = this.q3j();
    if (!(next == null) ? typeof next === 'number' : false) {
      var nextPrimitive = next;
      if (value === nextPrimitive)
        return false;
    }
    this.r3j(value);
    return true;
  };
  protoOf(GapComposer).o31 = function (value) {
    var next = this.q3j();
    if (next instanceof Long) {
      var nextPrimitive = next;
      if (equalsLong(value, nextPrimitive))
        return false;
    }
    this.r3j(value);
    return true;
  };
  protoOf(GapComposer).p31 = function (value) {
    var next = this.q3j();
    if (!(next == null) ? typeof next === 'number' : false) {
      var nextPrimitive = next;
      if (value === nextPrimitive)
        return false;
    }
    this.r3j(value);
    return true;
  };
  protoOf(GapComposer).m31 = function (value) {
    var next = this.q3j();
    if (!(next == null) ? typeof next === 'number' : false) {
      var nextPrimitive = next;
      if (value === nextPrimitive)
        return false;
    }
    this.r3j(value);
    return true;
  };
  protoOf(GapComposer).r3j = function (value) {
    if (this.a3i_1) {
      this.p3h_1.w35(value);
    } else {
      if (this.n3h_1.j3j_1) {
        var groupSlotIndex = this.n3h_1.c3o() - 1 | 0;
        if (this.t3h_1.f3o()) {
          this.t3h_1.e3o(value, this.n3h_1.o3k(this.n3h_1.e3j_1), groupSlotIndex);
        } else {
          this.t3h_1.d3o(value, groupSlotIndex);
        }
      } else {
        this.t3h_1.b3o(this.n3h_1.o3k(this.n3h_1.e3j_1), value);
      }
    }
  };
  protoOf(GapComposer).g3o = function (value) {
    var tmp;
    if (!(value == null) ? isInterface(value, RememberObserver) : false) {
      var holder = new GapRememberObserverHolder(value, rememberObserverGroupIndex(this));
      if (this.a3i_1) {
        this.t3h_1.h3o(holder);
      }
      this.i3g_1.j1(value);
      tmp = holder;
    } else {
      tmp = value;
    }
    var toStore = tmp;
    this.r3j(toStore);
  };
  protoOf(GapComposer).h3i = function () {
    var data = this.c3i_1;
    if (data == null) {
      var newData = new GapCompositionDataImpl(this.m3g_1);
      this.c3i_1 = newData;
      return newData;
    }
    return data;
  };
  protoOf(GapComposer).s31 = function (effect) {
    this.t3h_1.i3o(effect);
  };
  protoOf(GapComposer).t31 = function () {
    return currentCompositionLocalScope(this);
  };
  protoOf(GapComposer).x31 = function (value) {
    var parentScope = currentCompositionLocalScope(this);
    startGroup_0(this, 201, get_provider());
    // Inline function 'kotlin.let' call
    var it = this.i31();
    var tmp;
    if (equals(it, Companion_getInstance_0().f30_1)) {
      tmp = null;
    } else {
      tmp = (!(it == null) ? isInterface(it, ValueHolder) : false) ? it : THROW_CCE();
    }
    var oldState = tmp;
    var tmp_0 = value.d32_1;
    var local = tmp_0 instanceof CompositionLocal ? tmp_0 : THROW_CCE();
    var state = local.j3c(value instanceof ProvidedValue ? value : THROW_CCE(), oldState);
    var change = !equals(state, oldState);
    if (change) {
      this.j31(state);
    }
    var providers;
    var invalid;
    if (this.a3i_1) {
      var tmp_1;
      if (value.k32_1 || !contains_2(parentScope, local)) {
        tmp_1 = parentScope.y3c(local, state);
      } else {
        tmp_1 = parentScope;
      }
      providers = tmp_1;
      invalid = false;
      this.q3h_1 = true;
    } else {
      var tmp_2 = this.n3h_1.s3j(this.n3h_1.c3j_1);
      var oldScope = (!(tmp_2 == null) ? isInterface(tmp_2, PersistentCompositionLocalMap) : false) ? tmp_2 : THROW_CCE();
      providers = (!this.i30() || change) && (value.k32_1 || !contains_2(parentScope, local)) ? parentScope.y3c(local, state) : !change && !this.c3h_1 ? oldScope : this.c3h_1 ? parentScope : oldScope;
      invalid = this.e3h_1 || !(oldScope === providers);
    }
    if (invalid && !this.a3i_1) {
      recordProviderUpdate(this, providers);
    }
    this.d3h_1.g3i(asInt(this.c3h_1));
    this.c3h_1 = invalid;
    this.r3h_1 = providers;
    start(this, 202, get_compositionLocalMap(), Companion_getInstance_7().n3j_1, providers);
  };
  protoOf(GapComposer).y31 = function () {
    endGroup(this);
    endGroup(this);
    this.c3h_1 = asBool(this.d3h_1.k3j());
    this.r3h_1 = null;
  };
  protoOf(GapComposer).v31 = function (values) {
    var parentScope = currentCompositionLocalScope(this);
    startGroup_0(this, 201, get_provider());
    var providers;
    var invalid;
    if (this.a3i_1) {
      var currentProviders = updateCompositionMap(values, parentScope);
      providers = updateProviderMapGroup(this, parentScope, currentProviders);
      invalid = false;
      this.q3h_1 = true;
    } else {
      var tmp = this.n3h_1.j3o(0);
      var oldScope = (!(tmp == null) ? isInterface(tmp, PersistentCompositionLocalMap) : false) ? tmp : THROW_CCE();
      var tmp_0 = this.n3h_1.j3o(1);
      var oldValues = (!(tmp_0 == null) ? isInterface(tmp_0, PersistentCompositionLocalMap) : false) ? tmp_0 : THROW_CCE();
      var currentProviders_0 = updateCompositionMap(values, parentScope, oldValues);
      if (!this.i30() || this.e3h_1 || !equals(oldValues, currentProviders_0)) {
        providers = updateProviderMapGroup(this, parentScope, currentProviders_0);
        invalid = this.e3h_1 || !equals(providers, oldScope);
      } else {
        skipGroup(this);
        providers = oldScope;
        invalid = false;
      }
    }
    if (invalid && !this.a3i_1) {
      recordProviderUpdate(this, providers);
    }
    this.d3h_1.g3i(asInt(this.c3h_1));
    this.c3h_1 = invalid;
    this.r3h_1 = providers;
    start(this, 202, get_compositionLocalMap(), Companion_getInstance_7().n3j_1, providers);
  };
  protoOf(GapComposer).w31 = function () {
    endGroup(this);
    endGroup(this);
    this.c3h_1 = asBool(this.d3h_1.k3j());
    this.r3h_1 = null;
  };
  protoOf(GapComposer).u31 = function (key) {
    return read(currentCompositionLocalScope(this), key);
  };
  protoOf(GapComposer).a30 = function () {
    startGroup_0(this, 206, get_reference());
    if (this.a3i_1) {
      this.p3h_1.v35();
    }
    var tmp = this.q3j();
    var observerHolder = (!(tmp == null) ? isInterface(tmp, RememberObserverHolder) : false) ? tmp : null;
    if (observerHolder == null) {
      observerHolder = new ReusableGapRememberObserverHolder(new CompositionContextHolder(new CompositionContextImpl(this, this.b3i_1, this.v3g_1, this.i3h_1, this.m3g_1.i37_1)), -1);
      this.r3j(observerHolder);
    }
    var tmp_0 = observerHolder.h33();
    var holder = tmp_0 instanceof CompositionContextHolder ? tmp_0 : THROW_CCE();
    holder.i3n_1.j3n(currentCompositionLocalScope(this));
    endGroup(this);
    return holder.i3n_1;
  };
  protoOf(GapComposer).r32 = function () {
    // Inline function 'kotlin.let' call
    var it = this.k3h_1;
    return this.g3h_1 === 0 && Stack__isNotEmpty_impl_ua6a9t(it) ? Stack__peek_impl_gtylu2(it) : null;
  };
  protoOf(GapComposer).f33 = function (scope, instance) {
    var tmp0_elvis_lhs = scope.m35_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var anchor = tmp;
    var slotTable = this.n3h_1.v3i_1;
    var location = asGapAnchor(anchor).m3o(slotTable);
    if (this.l3h_1 && location >= this.n3h_1.c3j_1) {
      insertIfMissing(this.y3g_1, location, scope, instance);
      return true;
    }
    return false;
  };
  protoOf(GapComposer).z3m = function () {
    if (this.y3g_1.r()) {
      skipGroup(this);
    } else {
      var reader = this.n3h_1;
      var key = reader.k3k();
      var dataKey = reader.m3k();
      var aux = reader.w3j();
      var rGroupIndex = this.r3g_1;
      // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroup' call
      if (dataKey == null)
        if (!(aux == null) && key === 207 && !equals(aux, Companion_getInstance_0().f30_1)) {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
          var groupKey = hashCode(aux);
          var tmp = this;
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_0 = this.b3i_1;
          var tmp$ret$3 = rotateLeft(this_0, 3);
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_1 = bitwiseXor(tmp$ret$3, fromInt(groupKey));
          var tmp$ret$5 = rotateLeft(this_1, 3);
          tmp.b3i_1 = bitwiseXor(tmp$ret$5, fromInt(rGroupIndex));
        } else {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
          var tmp_0 = this;
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_2 = this.b3i_1;
          var tmp$ret$8 = rotateLeft(this_2, 3);
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_3 = bitwiseXor(tmp$ret$8, fromInt(key));
          var tmp$ret$10 = rotateLeft(this_3, 3);
          tmp_0.b3i_1 = bitwiseXor(tmp$ret$10, fromInt(rGroupIndex));
        }
       else {
        if (dataKey instanceof Enum) {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
          var groupKey_0 = dataKey.a1_1;
          var tmp_1 = this;
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_4 = this.b3i_1;
          var tmp$ret$13 = rotateLeft(this_4, 3);
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_5 = bitwiseXor(tmp$ret$13, fromInt(groupKey_0));
          var tmp$ret$15 = rotateLeft(this_5, 3);
          tmp_1.b3i_1 = bitwiseXor(tmp$ret$15, fromInt(0));
        } else {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
          var groupKey_1 = hashCode(dataKey);
          var tmp_2 = this;
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_6 = this.b3i_1;
          var tmp$ret$18 = rotateLeft(this_6, 3);
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_7 = bitwiseXor(tmp$ret$18, fromInt(groupKey_1));
          var tmp$ret$20 = rotateLeft(this_7, 3);
          tmp_2.b3i_1 = bitwiseXor(tmp$ret$20, fromInt(0));
        }
      }
      startReaderGroup(this, reader.n3o(), null);
      recomposeToGroupEnd(this);
      reader.o3l();
      // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroup' call
      if (dataKey == null)
        if (!(aux == null) && key === 207 && !equals(aux, Companion_getInstance_0().f30_1)) {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_2 = hashCode(aux);
          var tmp_3 = this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_8 = this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_9 = bitwiseXor(this_8, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_10 = rotateLeft(this_9, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_11 = bitwiseXor(this_10, fromInt(groupKey_2));
          tmp_3.b3i_1 = rotateLeft(this_11, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var tmp_4 = this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_12 = this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_13 = bitwiseXor(this_12, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_14 = rotateLeft(this_13, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_15 = bitwiseXor(this_14, fromInt(key));
          tmp_4.b3i_1 = rotateLeft(this_15, -3 | 0);
        }
       else {
        if (dataKey instanceof Enum) {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_3 = dataKey.a1_1;
          var tmp_5 = this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_16 = this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_17 = bitwiseXor(this_16, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_18 = rotateLeft(this_17, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_19 = bitwiseXor(this_18, fromInt(groupKey_3));
          tmp_5.b3i_1 = rotateLeft(this_19, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.GapComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_4 = hashCode(dataKey);
          var tmp_6 = this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_20 = this.b3i_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_21 = bitwiseXor(this_20, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_22 = rotateLeft(this_21, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_23 = bitwiseXor(this_22, fromInt(groupKey_4));
          tmp_6.b3i_1 = rotateLeft(this_23, -3 | 0);
        }
      }
    }
  };
  protoOf(GapComposer).r31 = function (parametersChanged, flags) {
    if ((flags & 1) === 0 && (this.a3i_1 || this.e3h_1)) {
      var tmp0_elvis_lhs = this.x3h_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return true;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var callback = tmp;
      var tmp1_elvis_lhs = this.r32();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return true;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var scope = tmp_0;
      var pausing = callback.o3o();
      if (pausing && !scope.r3o()) {
        scope.b3a(true);
        scope.p3o(this.e3h_1);
        scope.h3m(true);
        this.t3h_1.q3o(scope);
        this.g3g_1.v3b(scope);
        return false;
      }
      return true;
    }
    return parametersChanged || !this.i30();
  };
  protoOf(GapComposer).z30 = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.q3g_1 === 0)) {
      var tmp$ret$1 = 'No nodes can be emitted before calling skipAndEndGroup';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    if (!this.a3i_1) {
      var tmp0_safe_receiver = this.r32();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.s3o();
      }
      if (this.y3g_1.r()) {
        skipReaderToGroupEnd(this);
      } else {
        recomposeToGroupEnd(this);
      }
    }
  };
  protoOf(GapComposer).a31 = function (changed) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.q3g_1 === 0)) {
      var tmp$ret$1 = 'No nodes can be emitted before calling deactivateToEndGroup';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    if (!this.a3i_1) {
      if (!changed) {
        skipReaderToGroupEnd(this);
        return Unit_instance;
      }
      var start = this.n3h_1.c3j_1;
      var end = this.n3h_1.d3j_1;
      this.t3h_1.t3o();
      removeRange(this.y3g_1, start, end);
      this.n3h_1.z30();
    }
  };
  protoOf(GapComposer).s30 = function (key) {
    this.m30(key);
    addRecomposeScope(this);
    return this;
  };
  protoOf(GapComposer).t30 = function () {
    var scope = Stack__isNotEmpty_impl_ua6a9t(this.k3h_1) ? Stack__pop_impl_8s4za4(this.k3h_1) : null;
    if (!(scope == null)) {
      scope.g3m(false);
      var tmp0_safe_receiver = exitRecomposeScope(this, scope);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.t3h_1.u3o(tmp0_safe_receiver, this.m3g_1);
      }
      if (scope.r3o()) {
        scope.i3m(false);
        this.t3h_1.v3o(scope);
        scope.p3o(false);
        if (scope.w3o()) {
          scope.k3m(false);
          if (this.f3h_1 === this.n3h_1.e3j_1) {
            this.e3h_1 = false;
            this.f3h_1 = -1;
          }
        }
      }
    }
    var tmp;
    if (!(scope == null) && !scope.x3o() && (scope.b3l() || this.v3g_1)) {
      if (scope.m35_1 == null) {
        var tmp_0 = scope;
        var tmp_1;
        if (this.a3i_1) {
          tmp_1 = this.p3h_1.o3k(this.p3h_1.d34_1);
        } else {
          tmp_1 = this.n3h_1.o3k(this.n3h_1.e3j_1);
        }
        tmp_0.m35_1 = tmp_1;
      }
      scope.c3b(false);
      tmp = scope;
    } else {
      tmp = null;
    }
    var result = tmp;
    end(this, false);
    return result;
  };
  protoOf(GapComposer).u30 = function (value, parameter) {
    invokeMovableContentLambda(this, value instanceof MovableContent ? value : THROW_CCE(), currentCompositionLocalScope(this), parameter, false);
  };
  protoOf(GapComposer).v30 = function (references) {
    var tmp0 = 'Compose:insertMovableContent';
    $l$block: {
      // Inline function 'androidx.compose.runtime.internal.trace' call
      var token = Trace_instance.r38(tmp0);
      try {
        var completed = false;
        try {
          insertMovableContentGuarded(this, references);
          completed = true;
        }finally {
          if (completed) {
            cleanUpCompose(this);
          } else {
            abortRoot(this);
          }
        }
        break $l$block;
      }finally {
        Trace_instance.t38(token);
      }
    }
  };
  protoOf(GapComposer).w30 = function (sourceInformation) {
    if (this.a3i_1 && this.i3h_1) {
      this.p3h_1.y3o(sourceInformation);
    }
  };
  protoOf(GapComposer).x30 = function (key, sourceInformation) {
    if (this.a3i_1 && this.i3h_1) {
      this.p3h_1.z3o(key, sourceInformation);
    }
  };
  protoOf(GapComposer).y30 = function () {
    if (this.a3i_1 && this.i3h_1) {
      this.p3h_1.a3p();
    }
  };
  protoOf(GapComposer).a33 = function (value) {
    var tmp0_safe_receiver = findLocation_1(this.h3g_1, GapComposer$stackTraceForValue$lambda(value));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var groupIndex = tmp0_safe_receiver.zh();
      var dataIndex = tmp0_safe_receiver.ai();
      tmp = plus_0(stackTraceForGroup(this, groupIndex, dataIndex), this.b33());
    }
    var tmp1_elvis_lhs = tmp;
    var stackTrace = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
    return new ComposeStackTrace(stackTrace, this.i3h_1);
  };
  protoOf(GapComposer).b33 = function () {
    var tmp = this.g3g_1.s3b();
    var tmp0_elvis_lhs = tmp instanceof CompositionImpl ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return emptyList();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var parentComposition = tmp_0;
    var position = findSubcompositionContextGroup_0(asGapBufferSlotTable(parentComposition.u36_1), this.g3g_1);
    var tmp_1;
    if (!(position == null)) {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
      // Inline function 'kotlin.let' call
      var reader = asGapBufferSlotTable(parentComposition.u36_1).d3i();
      var tmp_2;
      try {
        tmp_2 = traceForGroup_0(reader, position, 0);
      }finally {
        reader.j4();
      }
      tmp_1 = plus_0(tmp_2, parentComposition.k37_1.b33());
    } else {
      tmp_1 = emptyList();
    }
    return tmp_1;
  };
  protoOf(GapComposer).d33 = function (invalidationsRequested, content, shouldPause) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.j3g_1.r()) {
      var tmp$ret$1 = 'Expected applyChanges() to have been called';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.x3h_1 = shouldPause;
    try {
      doCompose(this, invalidationsRequested, content);
    }finally {
      this.x3h_1 = null;
    }
  };
  protoOf(GapComposer).c33 = function (block) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.l3h_1) {
      var tmp$ret$1 = 'Preparing a composition while composing is not supported';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.l3h_1 = true;
    try {
      block();
    }finally {
      this.l3h_1 = false;
    }
  };
  protoOf(GapComposer).e33 = function (invalidationsRequested, shouldPause) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.j3g_1.r()) {
      var tmp$ret$1 = 'Expected applyChanges() to have been called';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var tmp;
    var tmp_0;
    if (_ScopeMap___get_size__impl__f25bvl(invalidationsRequested) > 0) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !this.y3g_1.r();
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = this.w3g_1;
    }
    if (tmp) {
      this.x3h_1 = shouldPause;
      try {
        doCompose(this, invalidationsRequested, null);
      }finally {
        this.x3h_1 = null;
      }
      return this.j3g_1.fv();
    }
    return false;
  };
  protoOf(GapComposer).g33 = function (invalidationsRequested) {
    var inductionVariable = get_lastIndex(this.y3g_1);
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var invalidation = this.y3g_1.l1(i);
        var tmp0_safe_receiver = invalidation.s3l_1.m35_1;
        var anchor = tmp0_safe_receiver == null ? null : asGapAnchor(tmp0_safe_receiver);
        if (!(anchor == null) && anchor.d2y()) {
          if (!(invalidation.t3l_1 === anchor.l3o_1))
            invalidation.t3l_1 = anchor.l3o_1;
        } else {
          this.y3g_1.h3(i);
        }
      }
       while (0 <= inductionVariable);
    // Inline function 'androidx.collection.ScatterMap.forEach' call
    var this_0 = _ScopeMap___get_map__impl__vxhazm(invalidationsRequested);
    var k = this_0.x12_1;
    var v = this_0.y12_1;
    $l$block_0: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= lastIndex)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var slot = m[i_0];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i_0 - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < bitCount)
              do {
                var j = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i_0 << 3) + j | 0;
                  var tmp0 = k[index];
                  var tmp2 = v[index];
                  $l$block: {
                    if (!(tmp0 instanceof RecomposeScopeImpl))
                      THROW_CCE();
                    var tmp0_safe_receiver_0 = tmp0.m35_1;
                    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : asGapAnchor(tmp0_safe_receiver_0);
                    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l3o_1;
                    var tmp;
                    if (tmp2_elvis_lhs == null) {
                      break $l$block;
                    } else {
                      tmp = tmp2_elvis_lhs;
                    }
                    var location = tmp;
                    // Inline function 'kotlin.takeUnless' call
                    var tmp_0;
                    if (!(tmp2 === ScopeInvalidated_instance)) {
                      tmp_0 = tmp2;
                    } else {
                      tmp_0 = null;
                    }
                    var tmp$ret$6 = tmp_0;
                    this.y3g_1.j1(new Invalidation(tmp0, location, tmp$ret$6));
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_1 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i_0 === lastIndex));
    }
    sortWith(this.y3g_1, get_InvalidationLocationAscending());
  };
  protoOf(GapComposer).x2z = function () {
    return this.r32();
  };
  protoOf(GapComposer).i31 = function () {
    return this.a3o();
  };
  protoOf(GapComposer).j31 = function (value) {
    return this.g3o(value);
  };
  protoOf(GapComposer).y2z = function (scope) {
    var tmp0_safe_receiver = scope instanceof RecomposeScopeImpl ? scope : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b3a(true);
    }
  };
  function Invalidation(scope, location, instances) {
    this.s3l_1 = scope;
    this.t3l_1 = location;
    this.u3l_1 = instances;
  }
  protoOf(Invalidation).a3m = function () {
    return this.s3l_1.d3p(this.u3l_1);
  };
  function GapPending$keyMap$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new MultiValueMap(multiMap(this$0.c3k_1.n1()));
      var it = this_0.e3p_1;
      var inductionVariable = 0;
      var last = this$0.c3k_1.n1();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var keyInfo = this$0.c3k_1.l1(index);
          MultiValueMap__add_impl_ww0640(it, get_joinedKey(keyInfo), keyInfo);
        }
         while (inductionVariable < last);
      var tmp$ret$0 = this_0.e3p_1;
      return new MultiValueMap(tmp$ret$0);
    };
  }
  function GapPending$_get_keyMap_$ref_kdm6hs() {
    return constructCallableReference(function (p0) {
      return new MultiValueMap(p0.f3p());
    }, 1, 0, 11);
  }
  function GapPending(keyInfos, startIndex) {
    this.c3k_1 = keyInfos;
    this.d3k_1 = startIndex;
    this.e3k_1 = 0;
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(this.d3k_1 >= 0)) {
      var tmp$ret$1 = 'Invalid start index';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.f3k_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    var runningNodeIndex = 0;
    var result = new MutableIntObjectMap();
    var inductionVariable = 0;
    var last = this.c3k_1.n1();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var keyInfo = this.c3k_1.l1(index);
        result.ew(keyInfo.r3k_1, new GroupInfo(index, runningNodeIndex, keyInfo.s3k_1));
        runningNodeIndex = runningNodeIndex + keyInfo.s3k_1 | 0;
      }
       while (inductionVariable < last);
    tmp_0.g3k_1 = result;
    var tmp_1 = this;
    tmp_1.h3k_1 = lazy(GapPending$keyMap$delegate$lambda(this));
  }
  protoOf(GapPending).f3p = function () {
    var tmp0 = this.h3k_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('keyMap', 1, tmp, GapPending$_get_keyMap_$ref_kdm6hs(), null);
    return tmp0.u1().e3p_1;
  };
  protoOf(GapPending).n3k = function (key, dataKey) {
    var joinedKey = !(dataKey == null) ? new JoinedKey(key, dataKey) : key;
    return MultiValueMap__removeFirst_impl_iz2i9x(this.f3p(), joinedKey);
  };
  protoOf(GapPending).j3k = function (keyInfo) {
    return this.f3k_1.j1(keyInfo);
  };
  protoOf(GapPending).b3l = function () {
    return this.f3k_1;
  };
  protoOf(GapPending).w3k = function (from, to) {
    if (from > to) {
      // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
      var this_0 = this.g3k_1;
      var v = this_0.vv_1;
      $l$block: {
        // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
        var m = this_0.tv_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var group = v[index];
                    var position = group.g3p_1;
                    if (position === from)
                      group.g3p_1 = to;
                    else if (to <= position ? position < from : false)
                      group.g3p_1 = position + 1 | 0;
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    } else if (to > from) {
      // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
      var this_2 = this.g3k_1;
      var v_0 = this_2.vv_1;
      $l$block_0: {
        // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
        var m_0 = this_2.tv_1;
        var lastIndex_0 = m_0.length - 2 | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= lastIndex_0)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var slot_0 = m_0[i_0];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_3 = slot_0;
            var tmp$ret$8 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$8, new Long(-2139062144, -2139062144))) {
              var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < bitCount_0)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                  if (compare(value_0, new Long(128, 0)) < 0) {
                    var index_0 = (i_0 << 3) + j_0 | 0;
                    var group_0 = v_0[index_0];
                    var position_0 = group_0.g3p_1;
                    if (position_0 === from)
                      group_0.g3p_1 = to;
                    else if ((from + 1 | 0) <= position_0 ? position_0 < to : false)
                      group_0.g3p_1 = position_0 - 1 | 0;
                  }
                  slot_0 = shiftRight(slot_0, 8);
                }
                 while (inductionVariable_2 < bitCount_0);
              if (!(bitCount_0 === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i_0 === lastIndex_0));
      }
    }
  };
  protoOf(GapPending).g3l = function (from, to, count) {
    if (from > to) {
      // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
      var this_0 = this.g3k_1;
      var v = this_0.vv_1;
      $l$block: {
        // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
        var m = this_0.tv_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var group = v[index];
                    var position = group.h3p_1;
                    if (from <= position ? position < (from + count | 0) : false)
                      group.h3p_1 = to + (position - from | 0) | 0;
                    else if (to <= position ? position < from : false)
                      group.h3p_1 = position + count | 0;
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    } else if (to > from) {
      // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
      var this_2 = this.g3k_1;
      var v_0 = this_2.vv_1;
      $l$block_0: {
        // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
        var m_0 = this_2.tv_1;
        var lastIndex_0 = m_0.length - 2 | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= lastIndex_0)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var slot_0 = m_0[i_0];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_3 = slot_0;
            var tmp$ret$8 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$8, new Long(-2139062144, -2139062144))) {
              var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < bitCount_0)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                  if (compare(value_0, new Long(128, 0)) < 0) {
                    var index_0 = (i_0 << 3) + j_0 | 0;
                    var group_0 = v_0[index_0];
                    var position_0 = group_0.h3p_1;
                    if (from <= position_0 ? position_0 < (from + count | 0) : false)
                      group_0.h3p_1 = to + (position_0 - from | 0) | 0;
                    else if ((from + 1 | 0) <= position_0 ? position_0 < to : false)
                      group_0.h3p_1 = position_0 - count | 0;
                  }
                  slot_0 = shiftRight(slot_0, 8);
                }
                 while (inductionVariable_2 < bitCount_0);
              if (!(bitCount_0 === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i_0 === lastIndex_0));
      }
    }
  };
  protoOf(GapPending).i3k = function (keyInfo, insertIndex) {
    this.g3k_1.ew(keyInfo.r3k_1, new GroupInfo(-1, insertIndex, 0));
  };
  protoOf(GapPending).d3l = function (group, newCount) {
    var groupInfo = this.g3k_1.l1(group);
    if (!(groupInfo == null)) {
      var index = groupInfo.h3p_1;
      var difference = newCount - groupInfo.i3p_1 | 0;
      groupInfo.i3p_1 = newCount;
      if (!(difference === 0)) {
        // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
        var this_0 = this.g3k_1;
        var v = this_0.vv_1;
        $l$block: {
          // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
          var m = this_0.tv_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_1 = slot;
              var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index_0 = (i << 3) + j | 0;
                      var childGroupInfo = v[index_0];
                      if (childGroupInfo.h3p_1 >= index && !equals(childGroupInfo, groupInfo)) {
                        var newIndex = childGroupInfo.h3p_1 + difference | 0;
                        if (newIndex >= 0)
                          childGroupInfo.h3p_1 = newIndex;
                      }
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
      }
      return true;
    }
    return false;
  };
  protoOf(GapPending).v3k = function (keyInfo) {
    var tmp0_safe_receiver = this.g3k_1.l1(keyInfo.r3k_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g3p_1;
    return tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
  };
  protoOf(GapPending).u3k = function (keyInfo) {
    var tmp0_safe_receiver = this.g3k_1.l1(keyInfo.r3k_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h3p_1;
    return tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
  };
  protoOf(GapPending).e3l = function (keyInfo) {
    var tmp0_safe_receiver = this.g3k_1.l1(keyInfo.r3k_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i3p_1;
    return tmp1_elvis_lhs == null ? keyInfo.s3k_1 : tmp1_elvis_lhs;
  };
  function removeRange(_this__u8e3s4, start, end) {
    _init_properties_GapComposer_kt__ele738();
    var index = findInsertLocation(_this__u8e3s4, start);
    $l$loop: while (index < _this__u8e3s4.n1()) {
      var validation = _this__u8e3s4.l1(index);
      if (validation.t3l_1 < end)
        _this__u8e3s4.h3(index);
      else
        break $l$loop;
    }
  }
  function asInt(_this__u8e3s4) {
    _init_properties_GapComposer_kt__ele738();
    return _this__u8e3s4 ? 1 : 0;
  }
  function asBool(_this__u8e3s4) {
    _init_properties_GapComposer_kt__ele738();
    return !(_this__u8e3s4 === 0);
  }
  function GapRememberObserverHolder(wrapped, afterGroupIndex) {
    this.j3p_1 = wrapped;
    this.k3p_1 = afterGroupIndex;
  }
  protoOf(GapRememberObserverHolder).h33 = function () {
    return this.j3p_1;
  };
  function GapCompositionDataImpl(composition) {
    this.l3p_1 = composition;
  }
  protoOf(GapCompositionDataImpl).hashCode = function () {
    return imul(hashCode(this.l3p_1), 31);
  };
  protoOf(GapCompositionDataImpl).equals = function (other) {
    var tmp;
    if (other instanceof GapCompositionDataImpl) {
      tmp = equals(this.l3p_1, other.l3p_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ReusableGapRememberObserverHolder(wrapped, afterGroupIndex) {
    GapRememberObserverHolder.call(this, wrapped, afterGroupIndex);
  }
  function firstInRange(_this__u8e3s4, start, end) {
    _init_properties_GapComposer_kt__ele738();
    var index = findInsertLocation(_this__u8e3s4, start);
    if (index < _this__u8e3s4.n1()) {
      var firstInvalidation = _this__u8e3s4.l1(index);
      if (firstInvalidation.t3l_1 < end)
        return firstInvalidation;
    }
    return null;
  }
  function removeLocation(_this__u8e3s4, location) {
    _init_properties_GapComposer_kt__ele738();
    var index = findLocation(_this__u8e3s4, location);
    return index >= 0 ? _this__u8e3s4.h3(index) : null;
  }
  function nearestCommonRootOf(_this__u8e3s4, a, b, common) {
    _init_properties_GapComposer_kt__ele738();
    if (a === b)
      return a;
    if (a === common || b === common)
      return common;
    if (_this__u8e3s4.y34(a) === b)
      return b;
    if (_this__u8e3s4.y34(b) === a)
      return a;
    if (_this__u8e3s4.y34(a) === _this__u8e3s4.y34(b))
      return _this__u8e3s4.y34(a);
    var currentA = a;
    var currentB = b;
    var aDistance = distanceFrom(_this__u8e3s4, a, common);
    var bDistance = distanceFrom(_this__u8e3s4, b, common);
    // Inline function 'kotlin.repeat' call
    var times = aDistance - bDistance | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        currentA = _this__u8e3s4.y34(currentA);
      }
       while (inductionVariable < times);
    // Inline function 'kotlin.repeat' call
    var times_0 = bDistance - aDistance | 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < times_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        currentB = _this__u8e3s4.y34(currentB);
      }
       while (inductionVariable_0 < times_0);
    while (!(currentA === currentB)) {
      currentA = _this__u8e3s4.y34(currentA);
      currentB = _this__u8e3s4.y34(currentB);
    }
    return currentA;
  }
  function insertIfMissing(_this__u8e3s4, location, scope, instance) {
    _init_properties_GapComposer_kt__ele738();
    var index = findLocation(_this__u8e3s4, location);
    if (index < 0) {
      var tmp = -(index + 1 | 0) | 0;
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (!(instance == null) ? isInterface(instance, DerivedState) : false) {
        tmp_0 = instance;
      } else {
        tmp_0 = null;
      }
      var tmp$ret$0 = tmp_0;
      _this__u8e3s4.g3(tmp, new Invalidation(scope, location, tmp$ret$0));
    } else {
      var invalidation = _this__u8e3s4.l1(index);
      if (!(instance == null) ? isInterface(instance, DerivedState) : false) {
        var oldInstance = invalidation.u3l_1;
        if (oldInstance == null) {
          invalidation.u3l_1 = instance;
        } else {
          if (oldInstance instanceof MutableScatterSet) {
            if (!(oldInstance instanceof MutableScatterSet))
              THROW_CCE();
            oldInstance.j1(instance);
          } else {
            invalidation.u3l_1 = mutableScatterSetOf_0(oldInstance, instance);
          }
        }
      } else {
        invalidation.u3l_1 = null;
      }
    }
  }
  function collectNodesFrom(_this__u8e3s4, anchor) {
    _init_properties_GapComposer_kt__ele738();
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
    // Inline function 'kotlin.let' call
    var reader = _this__u8e3s4.d3i();
    var tmp;
    try {
      var index = _this__u8e3s4.q3m(anchor);
      collectNodesFrom$collectFromGroup(result, reader, index);
      tmp = Unit_instance;
    }finally {
      reader.j4();
    }
    return result;
  }
  function multiMap(initialCapacity) {
    _init_properties_GapComposer_kt__ele738();
    return _MultiValueMap___init__impl__qt1z0r(new MutableScatterMap(initialCapacity));
  }
  function get_joinedKey(_this__u8e3s4) {
    _init_properties_GapComposer_kt__ele738();
    return !(_this__u8e3s4.q3k_1 == null) ? new JoinedKey(_this__u8e3s4.p3k_1, _this__u8e3s4.q3k_1) : _this__u8e3s4.p3k_1;
  }
  function findInsertLocation(_this__u8e3s4, location) {
    _init_properties_GapComposer_kt__ele738();
    // Inline function 'kotlin.let' call
    var it = findLocation(_this__u8e3s4, location);
    return it < 0 ? -(it + 1 | 0) | 0 : it;
  }
  function findLocation(_this__u8e3s4, location) {
    _init_properties_GapComposer_kt__ele738();
    var low = 0;
    var high = _this__u8e3s4.n1() - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1 | 0;
      var midVal = _this__u8e3s4.l1(mid);
      var cmp = compareTo(midVal.t3l_1, location);
      if (cmp < 0)
        low = mid + 1 | 0;
      else if (cmp > 0)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function distanceFrom(_this__u8e3s4, index, root) {
    _init_properties_GapComposer_kt__ele738();
    var count = 0;
    var current = index;
    while (current > 0 && !(current === root)) {
      current = _this__u8e3s4.y34(current);
      count = count + 1 | 0;
    }
    return count;
  }
  function deactivateCurrentGroup(_this__u8e3s4, rememberManager) {
    _init_properties_GapComposer_kt__ele738();
    var tmp = _this__u8e3s4.b34_1;
    _this__u8e3s4.g34(tmp, deactivateCurrentGroup$lambda(rememberManager, _this__u8e3s4));
  }
  function asGapRememberObserverHolder(_this__u8e3s4) {
    _init_properties_GapComposer_kt__ele738();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof GapRememberObserverHolder ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composition');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function removeData(_this__u8e3s4, index, data) {
    _init_properties_GapComposer_kt__ele738();
    var result = _this__u8e3s4.m3p(index);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(data === result)) {
      var tmp$ret$1 = 'Slot table is out of sync (expected ' + toString_0(data) + ', got ' + toString_0(result) + ')';
      composeImmediateRuntimeError(tmp$ret$1);
    }
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.n3p_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.n3p_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.n3p_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function InvalidationLocationAscending$lambda(i1, i2) {
    _init_properties_GapComposer_kt__ele738();
    return compareTo(i1.t3l_1, i2.t3l_1);
  }
  function collectNodesFrom$collectFromGroup(result, $reader, group) {
    if ($reader.x34(group)) {
      result.j1($reader.z34(group));
    } else {
      var current = group + 1 | 0;
      var end = group + $reader.a35(group) | 0;
      while (current < end) {
        collectNodesFrom$collectFromGroup(result, $reader, current);
        current = current + $reader.a35(current) | 0;
      }
    }
  }
  function deactivateCurrentGroup$lambda($rememberManager, $this_deactivateCurrentGroup) {
    return function (slotIndex, data) {
      var tmp;
      if (!(data == null) ? isInterface(data, ComposeNodeLifecycleCallback) : false) {
        $rememberManager.o3p(data);
        tmp = Unit_instance;
      } else {
        if (!(data == null) ? isInterface(data, ReusableRememberObserverHolder) : false) {
          tmp = Unit_instance;
        } else {
          if (!(data == null) ? isInterface(data, RememberObserverHolder) : false) {
            removeData($this_deactivateCurrentGroup, slotIndex, data);
            $rememberManager.f36(data);
            tmp = Unit_instance;
          } else {
            if (data instanceof RecomposeScopeImpl) {
              removeData($this_deactivateCurrentGroup, slotIndex, data);
              data.r2v();
              tmp = Unit_instance;
            }
          }
        }
      }
      return Unit_instance;
    };
  }
  var properties_initialized_GapComposer_kt_qlrzne;
  function _init_properties_GapComposer_kt__ele738() {
    if (!properties_initialized_GapComposer_kt_qlrzne) {
      properties_initialized_GapComposer_kt_qlrzne = true;
      var tmp = InvalidationLocationAscending$lambda;
      InvalidationLocationAscending = new sam$kotlin_Comparator$0(tmp);
      androidx_compose_runtime_GapComposer_CompositionContextHolder$stable = 8;
      androidx_compose_runtime_GapComposer$stable = 8;
      androidx_compose_runtime_GapRememberObserverHolder$stable = 8;
      androidx_compose_runtime_ReusableGapRememberObserverHolder$stable = 8;
      androidx_compose_runtime_GapCompositionDataImpl$stable = 8;
    }
  }
  function get_LocalHostDefaultProvider() {
    _init_properties_HostDefaultProvider_kt__97v848();
    return LocalHostDefaultProvider;
  }
  var LocalHostDefaultProvider;
  function LocalHostDefaultProvider$lambda() {
    _init_properties_HostDefaultProvider_kt__97v848();
    // Inline function 'kotlin.error' call
    var message = 'CompositionLocal LocalHostDefaultProvider not present';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  var properties_initialized_HostDefaultProvider_kt_bfyipy;
  function _init_properties_HostDefaultProvider_kt__97v848() {
    if (!properties_initialized_HostDefaultProvider_kt_bfyipy) {
      properties_initialized_HostDefaultProvider_kt_bfyipy = true;
      LocalHostDefaultProvider = compositionLocalOf(VOID, LocalHostDefaultProvider$lambda);
    }
  }
  var androidx_compose_runtime_JoinedKey$stable;
  function hashCodeOf($this, value) {
    var tmp;
    if (value instanceof Enum) {
      tmp = value.a1_1;
    } else {
      var tmp1_elvis_lhs = value == null ? null : hashCode(value);
      tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    }
    return tmp;
  }
  function JoinedKey(left, right) {
    this.p3p_1 = left;
    this.q3p_1 = right;
  }
  protoOf(JoinedKey).hashCode = function () {
    return imul(hashCodeOf(this, this.p3p_1), 31) + hashCodeOf(this, this.q3p_1) | 0;
  };
  protoOf(JoinedKey).toString = function () {
    return 'JoinedKey(left=' + toString_0(this.p3p_1) + ', right=' + toString_0(this.q3p_1) + ')';
  };
  protoOf(JoinedKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JoinedKey))
      return false;
    if (!equals(this.p3p_1, other.p3p_1))
      return false;
    if (!equals(this.q3p_1, other.q3p_1))
      return false;
    return true;
  };
  var androidx_compose_runtime_Latch$stable;
  var androidx_compose_runtime_LinkComposer_CompositionContextHolder$stable;
  var androidx_compose_runtime_LinkComposer$stable;
  var androidx_compose_runtime_LinkRememberObserverHolder$stable;
  var androidx_compose_runtime_ReusableLinkRememberObserverHolder$stable;
  var androidx_compose_runtime_LinkCompositionDataImpl$stable;
  function _set_compositionLocalScope__ya1b9q_0($this, _set____db54di) {
    var tmp0 = $this.x3p_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LinkComposer$CompositionContextImpl$_get_compositionLocalScope_$ref_nk7q8o();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('compositionLocalScope', 1, tmp, tmp_0, LinkComposer$CompositionContextImpl$_set_compositionLocalScope_$ref_pt2970());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_compositionLocalScope__ulge9q_0($this) {
    var tmp0 = $this.x3p_1;
    var tmp = KMutableProperty1;
    var tmp_0 = LinkComposer$CompositionContextImpl$_get_compositionLocalScope_$ref_nk7q8o();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('compositionLocalScope', 1, tmp, tmp_0, LinkComposer$CompositionContextImpl$_set_compositionLocalScope_$ref_pt2970());
    return tmp0.u1();
  }
  function LinkComposer$CompositionContextImpl$_get_compositionLocalScope_$ref_nk7q8o() {
    return constructCallableReference(function (p0) {
      return _get_compositionLocalScope__ulge9q_0(p0);
    }, 1, 0, 12);
  }
  function LinkComposer$CompositionContextImpl$_set_compositionLocalScope_$ref_pt2970() {
    return constructCallableReference(function (p0, p1) {
      _set_compositionLocalScope__ya1b9q_0(p0, p1);
      return Unit_instance;
    }, 2, 0, 13);
  }
  function abortRoot_0($this) {
    cleanUpCompose_0($this);
    Stack__clear_impl_qoqv3c($this.i3q_1);
    $this.n3q_1.c3();
    $this.t3q_1.c3();
    $this.x3q_1.c3();
    $this.v3q_1 = null;
    $this.h3r_1.c3();
    var tmp = $this;
    // Inline function 'androidx.compose.runtime.CompositeKeyHashCode' call
    tmp.p3r_1 = fromInt(0);
    $this.i3r_1 = 0;
    $this.s3q_1 = false;
    $this.t3r_1 = false;
    $this.y3q_1 = false;
    $this.n3r_1 = false;
    $this.r3q_1 = false;
    $this.z3q_1 = -1;
    if (!$this.b3r_1.i3s_1) {
      $this.b3r_1.j4();
    }
    resetInsertBuilder($this, false);
  }
  function addRecomposeScope_0($this) {
    if ($this.t3r_1) {
      var scope = new RecomposeScopeImpl($this.g3q_1);
      Stack__push_impl_s8r905($this.m3r_1, scope);
      $this.r3j(scope);
      enterRecomposeScope_0($this, scope);
    } else {
      var parentGroup = $this.b3r_1.k3s();
      var parentRecomposeScope = getRecomposeScopeOrNull($this.b3r_1, parentGroup);
      var tmp;
      if (parentRecomposeScope == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = ScopeMap__remove_impl_ocu4rj($this.h3q_1, parentRecomposeScope);
      }
      var invalidation = tmp;
      var wasInvalidated = $this.b3r_1.l3s(parentGroup);
      if (wasInvalidated) {
        $this.b3r_1.m3s(67108864);
      }
      var slot = $this.b3r_1.v();
      var tmp_0;
      if (equals(slot, Companion_getInstance_0().f30_1)) {
        var newScope = new RecomposeScopeImpl($this.g3q_1);
        $this.r3j(newScope);
        tmp_0 = newScope;
      } else {
        tmp_0 = slot instanceof RecomposeScopeImpl ? slot : THROW_CCE();
      }
      var scope_0 = tmp_0;
      var tmp_1;
      if (wasInvalidated || !(invalidation == null)) {
        tmp_1 = true;
      } else {
        // Inline function 'kotlin.also' call
        var this_0 = scope_0.e3m();
        if (this_0) {
          scope_0.f3m(false);
        }
        tmp_1 = this_0;
      }
      scope_0.g3m(tmp_1);
      Stack__push_impl_s8r905($this.m3r_1, scope_0);
      enterRecomposeScope_0($this, scope_0);
      if (scope_0.m3m()) {
        scope_0.h3m(false);
        scope_0.i3m(true);
        $this.e3r_1.j3m(scope_0);
        if (!$this.y3q_1 && scope_0.l3m()) {
          $this.y3q_1 = true;
          $this.z3q_1 = $this.b3r_1.k3s();
          scope_0.k3m(true);
        }
      }
    }
  }
  function cleanUpCompose_0($this) {
    $this.j3q_1 = null;
    $this.k3q_1 = 0;
    $this.l3q_1 = 0;
    $this.p3r_1 = new Long(0, 0);
    $this.s3q_1 = false;
    Stack__clear_impl_qoqv3c($this.m3r_1);
    clearUpdatedNodeCounts_0($this);
  }
  function clearUpdatedNodeCounts_0($this) {
    $this.o3q_1 = null;
    $this.p3q_1 = null;
  }
  function currentStackTrace_0($this) {
    var tmp;
    if ($this.k3r_1) {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList_init_$Create$();
      this_0.o1(buildTrace_0($this.c3r_1));
      this_0.o1(buildTrace_2($this.b3r_1));
      this_0.o1($this.b33());
      var tmp$ret$0 = this_0.t5();
      tmp = new ComposeStackTrace(tmp$ret$0, $this.k3r_1);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function doCompose_0($this, invalidationsRequested, content) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!$this.n3r_1) {
      var tmp$ret$1 = 'Reentrant composition is not supported';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var observer = $this.f3q_1.d39();
    var tmp0 = 'Compose:recompose';
    $l$block: {
      // Inline function 'androidx.compose.runtime.internal.trace' call
      var token = Trace_instance.r38(tmp0);
      try {
        $this.j3r_1 = getNumberHashCode(currentSnapshot().w3d());
        $this.v3q_1 = null;
        $this.g33(invalidationsRequested);
        $this.k3q_1 = 0;
        var complete = false;
        $this.n3r_1 = true;
        if (observer == null)
          null;
        else {
          observer.y3m($this.g3q_1);
        }
        try {
          startRoot_0($this);
          var savedContent = $this.q3j();
          if (!(savedContent === content) && !(content == null)) {
            $this.r3j(!(content == null) ? content : THROW_CCE());
          }
          // Inline function 'androidx.compose.runtime.observeDerivedStateRecalculations' call
          var observer_0 = $this.l3r_1;
          var observers = derivedStateObservers_0();
          try {
            observers.zz(observer_0);
            if (!(content == null)) {
              startGroup_1($this, 200, get_invocation());
              invokeComposable($this, content);
              endGroup_0($this);
            } else if (($this.r3q_1 || $this.w3q_1) && !(savedContent == null) && !equals(savedContent, Companion_getInstance_0().f30_1)) {
              startGroup_1($this, 200, get_invocation());
              invokeComposable($this, typeof savedContent === 'function' ? savedContent : THROW_CCE());
              endGroup_0($this);
            } else {
              $this.z3m();
            }
          }finally {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
            var tmp$ret$6 = observers.d3e_1 - 1 | 0;
            observers.h3(tmp$ret$6);
          }
          endRoot_0($this);
          complete = true;
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            throw attachComposeStackTrace_1(e, LinkComposer$doCompose$lambda($this));
          } else {
            throw $p;
          }
        }
        finally {
          if (observer == null)
            null;
          else {
            observer.a3n($this.g3q_1);
          }
          $this.n3r_1 = false;
          if (!complete) {
            abortRoot_0($this);
          }
          resetInsertBuilder($this, !complete);
        }
        break $l$block;
      }finally {
        Trace_instance.t38(token);
      }
    }
  }
  function end_0($this, isNode) {
    var rGroupIndex = $this.n3q_1.a3l() - 1 | 0;
    if ($this.t3r_1) {
      var parent = $this.c3r_1.k3s();
      var tmp2 = $this.c3r_1.t3j(parent);
      var tmp6 = $this.c3r_1.u3j(parent);
      // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroup' call
      var data = $this.c3r_1.s3j(parent);
      if (tmp6 == null)
        if (!(data == null) && tmp2 === 207 && !equals(data, Companion_getInstance_0().f30_1)) {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey = hashCode(data);
          var tmp = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_0 = $this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_1 = bitwiseXor(this_0, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_2 = rotateLeft(this_1, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_3 = bitwiseXor(this_2, fromInt(groupKey));
          tmp.p3r_1 = rotateLeft(this_3, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var tmp_0 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_4 = $this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_5 = bitwiseXor(this_4, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_6 = rotateLeft(this_5, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_7 = bitwiseXor(this_6, fromInt(tmp2));
          tmp_0.p3r_1 = rotateLeft(this_7, -3 | 0);
        }
       else {
        if (tmp6 instanceof Enum) {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_0 = tmp6.a1_1;
          var tmp_1 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_8 = $this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_9 = bitwiseXor(this_8, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_10 = rotateLeft(this_9, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_11 = bitwiseXor(this_10, fromInt(groupKey_0));
          tmp_1.p3r_1 = rotateLeft(this_11, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_1 = hashCode(tmp6);
          var tmp_2 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_12 = $this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_13 = bitwiseXor(this_12, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_14 = rotateLeft(this_13, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_15 = bitwiseXor(this_14, fromInt(groupKey_1));
          tmp_2.p3r_1 = rotateLeft(this_15, -3 | 0);
        }
      }
    } else {
      var parent_0 = $this.b3r_1.k3s();
      var tmp2_0 = $this.b3r_1.t3j(parent_0);
      var tmp6_0 = $this.b3r_1.u3j(parent_0);
      // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroup' call
      var data_0 = $this.b3r_1.s3j(parent_0);
      if (tmp6_0 == null)
        if (!(data_0 == null) && tmp2_0 === 207 && !equals(data_0, Companion_getInstance_0().f30_1)) {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_2 = hashCode(data_0);
          var tmp_3 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_16 = $this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_17 = bitwiseXor(this_16, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_18 = rotateLeft(this_17, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_19 = bitwiseXor(this_18, fromInt(groupKey_2));
          tmp_3.p3r_1 = rotateLeft(this_19, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var tmp_4 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_20 = $this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_21 = bitwiseXor(this_20, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_22 = rotateLeft(this_21, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_23 = bitwiseXor(this_22, fromInt(tmp2_0));
          tmp_4.p3r_1 = rotateLeft(this_23, -3 | 0);
        }
       else {
        if (tmp6_0 instanceof Enum) {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_3 = tmp6_0.a1_1;
          var tmp_5 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_24 = $this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_25 = bitwiseXor(this_24, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_26 = rotateLeft(this_25, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_27 = bitwiseXor(this_26, fromInt(groupKey_3));
          tmp_5.p3r_1 = rotateLeft(this_27, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_4 = hashCode(tmp6_0);
          var tmp_6 = $this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_28 = $this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_29 = bitwiseXor(this_28, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_30 = rotateLeft(this_29, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_31 = bitwiseXor(this_30, fromInt(groupKey_4));
          tmp_6.p3r_1 = rotateLeft(this_31, -3 | 0);
        }
      }
    }
    var expectedNodeCount = $this.l3q_1;
    var pending = $this.j3q_1;
    var tmp_7;
    if (!(pending == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_7 = !pending.q3t_1.r();
    } else {
      tmp_7 = false;
    }
    if (tmp_7) {
      var previous = pending.q3t_1;
      var current = pending.b3l();
      var usedKeys = fastToSet(current);
      // Inline function 'kotlin.collections.mutableSetOf' call
      var placedKeys = LinkedHashSet_init_$Create$();
      var currentIndex = 0;
      var currentEnd = current.n1();
      var previousIndex = 0;
      var previousEnd = previous.n1();
      var nodeOffset = 0;
      $l$loop_0: while (previousIndex < previousEnd) {
        var previousInfo = previous.l1(previousIndex);
        if (!usedKeys.m1(previousInfo)) {
          var deleteOffset = pending.x3t(previousInfo);
          $this.e3r_1.c3l(deleteOffset + pending.r3t_1 | 0, previousInfo.b3u_1);
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.KeyInfo.address' call
          var tmp$ret$60 = get_group(previousInfo.a3u_1);
          pending.d3l(tmp$ret$60, 0);
          $this.b3r_1.d3u(previousInfo.a3u_1);
          recordDelete_0($this);
          $this.b3r_1.y35();
          previousIndex = previousIndex + 1 | 0;
          continue $l$loop_0;
        }
        if (placedKeys.m1(previousInfo)) {
          previousIndex = previousIndex + 1 | 0;
          continue $l$loop_0;
        }
        if (currentIndex < currentEnd) {
          var currentInfo = current.l1(currentIndex);
          if (!(currentInfo === previousInfo)) {
            var nodePosition = pending.x3t(currentInfo);
            placedKeys.j1(currentInfo);
            if (!(nodePosition === nodeOffset)) {
              var updatedCount = pending.e3u(currentInfo);
              $this.e3r_1.f3l(nodePosition + pending.r3t_1 | 0, nodeOffset + pending.r3t_1 | 0, updatedCount);
              pending.g3l(nodePosition, nodeOffset, updatedCount);
            }
          } else {
            previousIndex = previousIndex + 1 | 0;
          }
          currentIndex = currentIndex + 1 | 0;
          nodeOffset = nodeOffset + pending.e3u(currentInfo) | 0;
        }
      }
      $this.e3r_1.h3l();
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!previous.r()) {
        $this.b3r_1.z30();
      }
    }
    var inserting = $this.t3r_1;
    if (!inserting) {
      var removeIndex = $this.k3q_1;
      var predecessor = $this.b3r_1.f3u();
      var tmp0 = $this.g3u();
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseSiblings' call
      var group = $this.b3r_1.h3u();
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseSiblings' call
      var groups = tmp0.j3u_1.p3u_1;
      var current_0 = group;
      while (current_0 >= 0) {
        var group_0 = current_0;
        reportFreeMovableContent_0($this, makeGroupHandle($this.b3r_1.k3s(), predecessor, group_0));
        var nodesToRemove = $this.b3r_1.b35(group_0);
        $this.e3r_1.c3l(removeIndex, nodesToRemove);
        $this.e3r_1.h3l();
        predecessor = group_0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
        current_0 = groups[current_0 + 1 | 0];
      }
      $this.e3r_1.y3u($this.b3r_1.h3u(), $this.b3r_1.j3l());
    }
    if (inserting) {
      if (isNode) {
        $this.h3r_1.p3l();
        expectedNodeCount = 1;
      }
      $this.g3r_1 = $this.c3r_1.k3s();
      $this.b3r_1.q3l();
      $this.c3r_1.z35();
      if (!$this.b3r_1.r3l()) {
        var insertSrcAddress = $this.c3r_1.a3v();
        recordInsert_0($this, insertSrcAddress);
        $this.t3r_1 = false;
        if (!$this.g3u().oy()) {
          var insertedGroup = toInsertAddress(insertSrcAddress);
          updateChildNodeCount($this, insertedGroup, 0);
          updateNodeCountOverrides_0($this, insertedGroup, expectedNodeCount);
        }
      }
    } else {
      if (isNode) {
        $this.e3r_1.m3l();
      }
      var parentGroup = $this.b3r_1.z3u();
      var parentNodeCount = updatedNodeCount_0($this, parentGroup);
      if (!(expectedNodeCount === parentNodeCount)) {
        updateNodeCountOverrides_0($this, parentGroup, expectedNodeCount);
      }
      if (isNode) {
        expectedNodeCount = 1;
      }
      $this.g3r_1 = get_group(parentGroup);
      $this.b3r_1.o3l();
      $this.e3r_1.h3l();
    }
    exitGroup_0($this, expectedNodeCount, inserting);
  }
  function endGroup_0($this) {
    return end_0($this, false);
  }
  function endRoot_0($this) {
    endGroup_0($this);
    $this.a3q_1.z3b();
    endGroup_0($this);
    finalizeCompose_0($this);
    $this.b3r_1.j4();
    $this.r3q_1 = false;
    $this.w3q_1 = asBool_0($this.x3q_1.k3j());
  }
  function enterGroup_0($this, isNode, newPending) {
    Stack__push_impl_s8r905($this.i3q_1, $this.j3q_1);
    $this.j3q_1 = newPending;
    $this.n3q_1.g3i($this.l3q_1);
    $this.n3q_1.g3i($this.m3q_1);
    $this.n3q_1.g3i($this.k3q_1);
    if (isNode)
      $this.k3q_1 = 0;
    $this.l3q_1 = 0;
    $this.m3q_1 = 0;
    $this.g3r_1 = -1;
  }
  function executeChangesImmediatelyWithoutApplier($this) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = $this.c3q_1.b3v();
    var tmp;
    try {
      var tmp0_$this = asLinkBufferChangeList($this.d3q_1);
      var tmp3_errorContext = $this.s32();
      tmp0_$this.d3v(ThrowingApplierStub_instance, $this$with, ThrowingRememberManagerStub_instance, tmp3_errorContext);
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
  }
  function exitGroup_0($this, expectedNodeCount, inserting) {
    var previousPending = Stack__pop_impl_8s4za4($this.i3q_1);
    if (!(previousPending == null) && !inserting) {
      previousPending.s3t_1 = previousPending.s3t_1 + 1 | 0;
    }
    $this.j3q_1 = previousPending;
    $this.k3q_1 = $this.n3q_1.k3j() + expectedNodeCount | 0;
    $this.m3q_1 = $this.n3q_1.k3j();
    $this.l3q_1 = $this.n3q_1.k3j() + expectedNodeCount | 0;
  }
  function ensureBuilder($this) {
    if ($this.c3r_1.p3t_1) {
      $this.c3r_1 = SlotTableBuilder_init_$Create$($this.c3q_1.j3u_1, $this.c3q_1.k3u_1, $this.c3q_1.l3u_1);
      $this.c3r_1.k3v();
      $this.d3r_1 = false;
      $this.a3r_1 = null;
    }
  }
  function finalizeCompose_0($this) {
    $this.e3r_1.g3n();
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!Stack__isEmpty_impl_modt1q($this.i3q_1)) {
      var tmp$ret$1 = 'Start/end imbalance';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    cleanUpCompose_0($this);
  }
  function currentCompositionLocalScope_1($this) {
    var tmp0_safe_receiver = $this.a3r_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    return currentCompositionLocalScope_2($this, $this.b3r_1.k3s());
  }
  function currentCompositionLocalScope_2($this, group) {
    if ($this.t3r_1 && $this.d3r_1) {
      var current = $this.c3r_1.k3s();
      while (current >= 0) {
        if ($this.c3r_1.t3j(current) === 202 && equals($this.c3r_1.u3j(current), get_compositionLocalMap())) {
          var tmp = $this.c3r_1.s3j(current);
          var providers = (!(tmp == null) ? isInterface(tmp, PersistentCompositionLocalMap) : false) ? tmp : THROW_CCE();
          $this.a3r_1 = providers;
          return providers;
        }
        current = $this.c3r_1.y34(current);
      }
    }
    if (!$this.b3r_1.oy()) {
      var current_0 = group;
      while (current_0 >= 0) {
        if ($this.b3r_1.t3j(current_0) === 202 && equals($this.b3r_1.u3j(current_0), get_compositionLocalMap())) {
          var tmp0_safe_receiver = $this.v3q_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l1(current_0);
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            var tmp_1 = $this.b3r_1.s3j(current_0);
            tmp_0 = (!(tmp_1 == null) ? isInterface(tmp_1, PersistentCompositionLocalMap) : false) ? tmp_1 : THROW_CCE();
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var providers_0 = tmp_0;
          $this.a3r_1 = providers_0;
          return providers_0;
        }
        current_0 = $this.b3r_1.l3v(current_0);
      }
    }
    $this.a3r_1 = $this.u3q_1;
    return $this.u3q_1;
  }
  function insertMovableContentGuarded_0($this, references) {
    var tmp0 = $this.e3r_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.withChangeList' call
    var newChangeList = asLinkBufferChangeList($this.e3q_1);
    var previousChangeList = tmp0.o3s_1;
    try {
      tmp0.o3s_1 = newChangeList;
      $this.e3r_1.p3m();
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = references.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = references.l1(index);
          var to = item.zh();
          var from = item.ai();
          // Inline function 'androidx.compose.runtime.toGroupHandle' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
          var group = asLinkAnchor(to.g35_1).m3v_1;
          var tmp = shiftLeft(fromInt(0), 32);
          // Inline function 'kotlin.toUInt' call
          // Inline function 'kotlin.UInt.toLong' call
          var this_0 = _UInt___init__impl__l7qpdl(group);
          // Inline function 'kotlin.uintToLong' call
          var value = _UInt___get_data__impl__f0vqqw(this_0);
          var tmp$ret$7 = bitwiseAnd(fromInt(value), new Long(-1, 0));
          var handle = bitwiseOr(tmp, tmp$ret$7);
          var effectiveNodeIndex = new IntRef();
          $this.e3r_1.n3v(effectiveNodeIndex, handle);
          if (from == null) {
            var toSlotTable = asLinkBufferSlotTable(to.f35_1);
            if (equals(toSlotTable, $this.c3r_1.y3s_1)) {
              resetInsertBuilder($this, false);
            }
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.read' call
            // Inline function 'kotlin.with' call
            var $this$with = toSlotTable.d3i();
            var tmp_0;
            try {
              $this$with.d3u(handle);
              var offsetChanges = new ChangeList_0();
              recomposeMovableContent_0($this, VOID, VOID, VOID, VOID, LinkComposer$insertMovableContentGuarded$lambda($this, offsetChanges, $this$with, handle, to));
              $this.e3r_1.q3v(offsetChanges, effectiveNodeIndex);
              tmp_0 = Unit_instance;
            }finally {
              $this$with.j4();
            }
          } else {
            var resolvedState = $this.a3q_1.d3c(from);
            var tmp1_safe_receiver = resolvedState == null ? null : resolvedState.u3a_1;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : asLinkBufferSlotTable(tmp1_safe_receiver);
            var fromTable = tmp2_elvis_lhs == null ? asLinkBufferSlotTable(from.f35_1) : tmp2_elvis_lhs;
            var tmp4_safe_receiver = resolvedState == null ? null : resolvedState.u3a_1;
            var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : asLinkBufferSlotTable(tmp4_safe_receiver);
            var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.i3u_1;
            var fromAddress = tmp6_elvis_lhs == null ? asLinkAnchor(from.g35_1).m3v_1 : tmp6_elvis_lhs;
            var nodesToInsert = collectNodesFrom_0(fromTable, fromAddress);
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!nodesToInsert.r()) {
              $this.e3r_1.s3m(nodesToInsert, effectiveNodeIndex);
              if (equals(to.f35_1, $this.c3q_1)) {
                // Inline function 'androidx.compose.runtime.toGroupHandle' call
                // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
                var group_0 = asLinkAnchor(to.g35_1).m3v_1;
                var tmp_1 = shiftLeft(fromInt(0), 32);
                // Inline function 'kotlin.toUInt' call
                // Inline function 'kotlin.UInt.toLong' call
                var this_1 = _UInt___init__impl__l7qpdl(group_0);
                // Inline function 'kotlin.uintToLong' call
                var value_0 = _UInt___get_data__impl__f0vqqw(this_1);
                var tmp$ret$17 = bitwiseAnd(fromInt(value_0), new Long(-1, 0));
                var tmp_2 = bitwiseOr(tmp_1, tmp$ret$17);
                // Inline function 'androidx.compose.runtime.toGroupHandle' call
                // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
                var group_1 = asLinkAnchor(to.g35_1).m3v_1;
                var tmp_3 = shiftLeft(fromInt(0), 32);
                // Inline function 'kotlin.toUInt' call
                // Inline function 'kotlin.UInt.toLong' call
                var this_2 = _UInt___init__impl__l7qpdl(group_1);
                // Inline function 'kotlin.uintToLong' call
                var value_1 = _UInt___get_data__impl__f0vqqw(this_2);
                var tmp$ret$22 = bitwiseAnd(fromInt(value_1), new Long(-1, 0));
                var tmp$ret$19 = bitwiseOr(tmp_3, tmp$ret$22);
                updateChildNodeCount($this, tmp_2, updatedNodeCount_0($this, tmp$ret$19) + nodesToInsert.n1() | 0);
              }
            }
            $this.e3r_1.t3m(resolvedState, $this.a3q_1, from, to);
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.read' call
            // Inline function 'kotlin.with' call
            var $this$with_0 = fromTable.d3i();
            var tmp_4;
            try {
              $l$block: {
                // Inline function 'androidx.compose.runtime.LinkComposer.withReader' call
                var savedReader = $this.b3r_1;
                var savedCountOverrides = $this.o3q_1;
                var savedProviderUpdates = $this.v3q_1;
                $this.o3q_1 = null;
                $this.v3q_1 = null;
                try {
                  $this.b3r_1 = $this$with_0;
                  $this.b3r_1.y3k(fromAddress);
                  var offsetChanges_0 = new ChangeList_0();
                  // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.withChangeList' call
                  var this_3 = $this.e3r_1;
                  var previousChangeList_0 = this_3.o3s_1;
                  try {
                    this_3.o3s_1 = offsetChanges_0;
                    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.withoutImplicitRootStart' call
                    var this_4 = $this.e3r_1;
                    var previousImplicitRootStart = this_4.p3s_1;
                    try {
                      this_4.p3s_1 = false;
                      var tmp0_0 = $this.e3r_1;
                      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.inRelativeAddressMode' call
                      var relativeStart = $this.b3r_1.o3v();
                      access$_set_editorCurrentPosition__56o8a8(tmp0_0, relativeStart);
                      var newMode = ComposerChangeListWriterAddressMode_RelativeAddressing_getInstance();
                      var previousMode = tmp0_0.w3s_1;
                      var previousCurrentPosition = access$_get_editorCurrentPosition__bcakpw(tmp0_0);
                      tmp0_0.w3s_1 = newMode;
                      try {
                        from.p3v();
                        var tmp_5 = $this.b3r_1.h3u();
                        var tmp_6 = from.h35_1;
                        recomposeMovableContent_0($this, from.e35_1, to.e35_1, tmp_5, tmp_6, LinkComposer$insertMovableContentGuarded$lambda_0($this, to));
                      }finally {
                        tmp0_0.w3s_1 = previousMode;
                        access$_set_editorCurrentPosition__56o8a8(tmp0_0, previousMode.equals(ComposerChangeListWriterAddressMode_RelativeAddressing_getInstance()) ? previousCurrentPosition : new Long(-1, -1));
                      }
                    }finally {
                      this_4.p3s_1 = previousImplicitRootStart;
                    }
                  }finally {
                    this_3.o3s_1 = previousChangeList_0;
                  }
                  $this.e3r_1.q3v(offsetChanges_0, effectiveNodeIndex);
                  break $l$block;
                }finally {
                  $this.b3r_1 = savedReader;
                  $this.o3q_1 = savedCountOverrides;
                  $this.v3q_1 = savedProviderUpdates;
                }
              }
              tmp_4 = Unit_instance;
            }finally {
              $this$with_0.j4();
            }
            $this.e3r_1.r3v(resolvedState);
          }
        }
         while (inductionVariable <= last);
      resetInsertBuilder($this, false);
      $this.e3r_1.x3m();
    }finally {
      tmp0.o3s_1 = previousChangeList;
    }
  }
  function recomposeMovableContent_0($this, from, to, address, invalidations, block) {
    from = from === VOID ? null : from;
    to = to === VOID ? null : to;
    address = address === VOID ? -1 : address;
    invalidations = invalidations === VOID ? emptyList() : invalidations;
    var savedIsComposing = $this.n3r_1;
    var savedNodeIndex = $this.k3q_1;
    try {
      $this.n3r_1 = true;
      $this.k3q_1 = 0;
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = invalidations.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = invalidations.l1(index);
          var scope = item.zh();
          var instances = item.ai();
          if (!(instances == null)) {
            $this.f33(scope, instances);
          } else {
            $this.f33(scope, null);
          }
        }
         while (inductionVariable <= last);
      var tmp1_elvis_lhs = from == null ? null : from.a3b(to, address, block);
      return tmp1_elvis_lhs == null ? block() : tmp1_elvis_lhs;
    }finally {
      $this.n3r_1 = savedIsComposing;
      $this.k3q_1 = savedNodeIndex;
    }
  }
  function invokeMovableContentLambda_0($this, content, locals, parameter, force) {
    $this.o30(126665345, content);
    updateSlot_0($this, parameter);
    var savedCompositeKeyHash = $this.p3r_1;
    try {
      var tmp = $this;
      // Inline function 'androidx.compose.runtime.CompositeKeyHashCode' call
      tmp.p3r_1 = fromInt(126665345);
      if ($this.t3r_1) {
        $this.c3r_1.s3v(268435456);
      }
      var providersChanged = $this.t3r_1 ? false : !equals($this.b3r_1.w3j(), locals);
      if (providersChanged) {
        recordProviderUpdate_0($this, locals);
      }
      start_0($this, 202, get_compositionLocalMap(), Companion_getInstance_7().n3j_1, locals);
      $this.a3r_1 = null;
      if ($this.t3r_1 && !force) {
        $this.d3r_1 = true;
        var address = $this.c3r_1.y34($this.c3r_1.k3s());
        var anchor = $this.c3r_1.y3s_1.j3u_1.u3v(address);
        var reference = new MovableContentStateReference(content, parameter, $this.g3q_1, $this.c3r_1.y3s_1, anchor, emptyList(), currentCompositionLocalScope_1($this), null);
        $this.a3q_1.a3c(reference);
      } else {
        var savedProvidersInvalid = $this.w3q_1;
        $this.w3q_1 = providersChanged;
        $this.e3r_1.t3v($this.b3r_1.o3v(), true);
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.inAnchorMode' call
        var this_0 = $this.e3r_1;
        access$_set_editorCurrentPosition__56o8a8(this_0, new Long(-1, -1));
        var newMode = ComposerChangeListWriterAddressMode_AnchorAddressing_getInstance();
        var previousMode = this_0.w3s_1;
        var previousCurrentPosition = access$_get_editorCurrentPosition__bcakpw(this_0);
        this_0.w3s_1 = newMode;
        try {
          invokeComposable($this, ComposableLambda$invoke$ref(composableLambdaInstance(-1241221479, true, LinkComposer$invokeMovableContentLambda$lambda(content, parameter))));
        }finally {
          this_0.w3s_1 = previousMode;
          access$_set_editorCurrentPosition__56o8a8(this_0, previousMode.equals(ComposerChangeListWriterAddressMode_RelativeAddressing_getInstance()) ? previousCurrentPosition : new Long(-1, -1));
        }
        $this.w3q_1 = savedProvidersInvalid;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw attachComposeStackTrace_1(e, LinkComposer$invokeMovableContentLambda$lambda_0($this));
      } else {
        throw $p;
      }
    }
    finally {
      endGroup_0($this);
      $this.a3r_1 = null;
      $this.p3r_1 = savedCompositeKeyHash;
      $this.p30();
    }
  }
  function isGroupAfterCurrentReaderPosition($this, group) {
    var readerPosition = $this.b3r_1.o3v();
    if (equalsLong(readerPosition, new Long(-1, -1)))
      return true;
    return equalsLong(firstGroupInTopologicalOrder($this.g3u(), group, readerPosition), readerPosition);
  }
  function recomposeToGroupEnd_0($this) {
    var wasComposing = $this.n3r_1;
    $this.n3r_1 = true;
    var recomposed = false;
    var reader = $this.b3r_1;
    var parent = reader.k3s();
    var recomposeIndex = $this.k3q_1;
    var recomposeCompositeKey = $this.p3r_1;
    var oldGroupNodeCount = $this.l3q_1;
    var oldRGroupIndex = $this.m3q_1;
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableReader.traverseChildrenConditionally' call
      var current = reader.v3v(parent);
      while (!(current === -1)) {
        var group = current;
        var tmp;
        if (reader.l3s(group)) {
          reader.y3k(group);
          var scope = requireRecomposeScope($this, group);
          var invalidations = ScopeMap__get_impl_5bu0tb($this.h3q_1, scope);
          var tmp_0;
          if (scope.d3p(invalidations)) {
            recomposed = true;
            $this.a3r_1 = null;
            // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
            var value = $this.m3q_1 === rGroupIndexOf_0($this, group);
            if (false && !value) {
              var tmp$ret$3 = 'rGroupIndex was not tracked correctly';
              composeImmediateRuntimeError(tmp$ret$3);
            }
            scope.y3l($this);
            $this.a3r_1 = null;
            tmp_0 = true;
          } else {
            Stack__push_impl_s8r905($this.m3r_1, scope);
            var observer = $this.f3q_1.d39();
            if (!(observer == null)) {
              try {
                observer.w3l(scope);
                scope.v3l();
              }finally {
                observer.x3l(scope);
              }
            } else {
              scope.v3l();
            }
            Stack__pop_impl_8s4za4($this.m3r_1);
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        var used = tmp;
        var firstChild = reader.v3v(current);
        var tmp_1;
        if (!used && !(firstChild === -1)) {
          var group_0 = current;
          var recomposeRequired = reader.w3v(group_0);
          if (recomposeRequired) {
            var dataKey = reader.u3j(group_0);
            if (dataKey instanceof MovableContent) {
              var tmp_2 = $this;
              // Inline function 'androidx.compose.runtime.CompositeKeyHashCode' call
              tmp_2.p3r_1 = fromInt(126665345);
            } else {
              var tmp2 = reader.t3j(group_0);
              var tmp4 = $this.m3q_1;
              var tmp6 = reader.u3j(group_0);
              // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroup' call
              var data = reader.s3j(group_0);
              if (tmp6 == null)
                if (!(data == null) && tmp2 === 207 && !equals(data, Companion_getInstance_0().f30_1)) {
                  // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
                  var groupKey = hashCode(data);
                  var tmp_3 = $this;
                  // Inline function 'androidx.compose.runtime.compoundWith' call
                  // Inline function 'androidx.compose.runtime.rol' call
                  var this_0 = $this.p3r_1;
                  var tmp$ret$9 = rotateLeft(this_0, 3);
                  // Inline function 'androidx.compose.runtime.compoundWith' call
                  // Inline function 'androidx.compose.runtime.rol' call
                  var this_1 = bitwiseXor(tmp$ret$9, fromInt(groupKey));
                  var tmp$ret$11 = rotateLeft(this_1, 3);
                  tmp_3.p3r_1 = bitwiseXor(tmp$ret$11, fromInt(tmp4));
                } else {
                  // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
                  var tmp_4 = $this;
                  // Inline function 'androidx.compose.runtime.compoundWith' call
                  // Inline function 'androidx.compose.runtime.rol' call
                  var this_2 = $this.p3r_1;
                  var tmp$ret$14 = rotateLeft(this_2, 3);
                  // Inline function 'androidx.compose.runtime.compoundWith' call
                  // Inline function 'androidx.compose.runtime.rol' call
                  var this_3 = bitwiseXor(tmp$ret$14, fromInt(tmp2));
                  var tmp$ret$16 = rotateLeft(this_3, 3);
                  tmp_4.p3r_1 = bitwiseXor(tmp$ret$16, fromInt(tmp4));
                }
               else {
                if (tmp6 instanceof Enum) {
                  // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
                  var groupKey_0 = tmp6.a1_1;
                  var tmp_5 = $this;
                  // Inline function 'androidx.compose.runtime.compoundWith' call
                  // Inline function 'androidx.compose.runtime.rol' call
                  var this_4 = $this.p3r_1;
                  var tmp$ret$19 = rotateLeft(this_4, 3);
                  // Inline function 'androidx.compose.runtime.compoundWith' call
                  // Inline function 'androidx.compose.runtime.rol' call
                  var this_5 = bitwiseXor(tmp$ret$19, fromInt(groupKey_0));
                  var tmp$ret$21 = rotateLeft(this_5, 3);
                  tmp_5.p3r_1 = bitwiseXor(tmp$ret$21, fromInt(0));
                } else {
                  // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
                  var groupKey_1 = hashCode(tmp6);
                  var tmp_6 = $this;
                  // Inline function 'androidx.compose.runtime.compoundWith' call
                  // Inline function 'androidx.compose.runtime.rol' call
                  var this_6 = $this.p3r_1;
                  var tmp$ret$24 = rotateLeft(this_6, 3);
                  // Inline function 'androidx.compose.runtime.compoundWith' call
                  // Inline function 'androidx.compose.runtime.rol' call
                  var this_7 = bitwiseXor(tmp$ret$24, fromInt(groupKey_1));
                  var tmp$ret$26 = rotateLeft(this_7, 3);
                  tmp_6.p3r_1 = bitwiseXor(tmp$ret$26, fromInt(0));
                }
              }
            }
            $this.n3q_1.g3i($this.k3q_1);
            $this.n3q_1.g3i($this.m3q_1);
            if (reader.x34(group_0)) {
              $this.e3r_1.c3m(reader.z34(group_0));
              $this.k3q_1 = 0;
            }
            $this.m3q_1 = 0;
          } else {
            var tmp_7 = $this;
            var tmp_8 = $this.k3q_1;
            var tmp_9;
            if (reader.x34(group_0)) {
              tmp_9 = 1;
            } else {
              // Inline function 'androidx.compose.runtime.toGroupHandle' call
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
              var tmp_10 = shiftLeft(fromInt(0), 32);
              // Inline function 'kotlin.toUInt' call
              // Inline function 'kotlin.UInt.toLong' call
              var this_8 = _UInt___init__impl__l7qpdl(group_0);
              // Inline function 'kotlin.uintToLong' call
              var value_0 = _UInt___get_data__impl__f0vqqw(this_8);
              var tmp$ret$30 = bitwiseAnd(fromInt(value_0), new Long(-1, 0));
              var tmp$ret$27 = bitwiseOr(tmp_10, tmp$ret$30);
              tmp_9 = updatedNodeCount_0($this, tmp$ret$27);
            }
            tmp_7.k3q_1 = tmp_8 + tmp_9 | 0;
            if (!reader.b3m(group_0)) {
              $this.m3q_1 = $this.m3q_1 + 1 | 0;
            }
          }
          tmp_1 = recomposeRequired;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          current = firstChild;
        } else {
          if (firstChild === -1 && !used) {
            var group_1 = current;
            var tmp_11 = $this;
            var tmp_12 = $this.k3q_1;
            var tmp_13;
            if (reader.x34(group_1)) {
              tmp_13 = 1;
            } else {
              // Inline function 'androidx.compose.runtime.toGroupHandle' call
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
              var tmp_14 = shiftLeft(fromInt(0), 32);
              // Inline function 'kotlin.toUInt' call
              // Inline function 'kotlin.UInt.toLong' call
              var this_9 = _UInt___init__impl__l7qpdl(group_1);
              // Inline function 'kotlin.uintToLong' call
              var value_1 = _UInt___get_data__impl__f0vqqw(this_9);
              var tmp$ret$36 = bitwiseAnd(fromInt(value_1), new Long(-1, 0));
              var tmp$ret$33 = bitwiseOr(tmp_14, tmp$ret$36);
              tmp_13 = updatedNodeCount_0($this, tmp$ret$33);
            }
            tmp_11.k3q_1 = tmp_12 + tmp_13 | 0;
            if (!reader.b3m(group_1)) {
              $this.m3q_1 = $this.m3q_1 + 1 | 0;
            }
          }
          var next = reader.x3v(current);
          $l$loop: while (next === -1) {
            current = reader.l3v(current);
            if (current === -1 || current === parent) {
              break $l$block;
            }
            var group_2 = current;
            if (reader.x34(group_2)) {
              $this.e3r_1.m3l();
            }
            $this.m3q_1 = $this.n3q_1.k3j();
            var tmp_15 = $this;
            var tmp_16 = $this.n3q_1.k3j();
            // Inline function 'androidx.compose.runtime.toGroupHandle' call
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
            var tmp_17 = shiftLeft(fromInt(0), 32);
            // Inline function 'kotlin.toUInt' call
            // Inline function 'kotlin.UInt.toLong' call
            var this_10 = _UInt___init__impl__l7qpdl(group_2);
            // Inline function 'kotlin.uintToLong' call
            var value_2 = _UInt___get_data__impl__f0vqqw(this_10);
            var tmp$ret$42 = bitwiseAnd(fromInt(value_2), new Long(-1, 0));
            var tmp$ret$39 = bitwiseOr(tmp_17, tmp$ret$42);
            tmp_15.k3q_1 = tmp_16 + updatedNodeCount_0($this, tmp$ret$39) | 0;
            var tmp2_0 = reader.t3j(group_2);
            var tmp4_0 = $this.m3q_1;
            var tmp6_0 = reader.u3j(group_2);
            // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroup' call
            var data_0 = reader.s3j(group_2);
            if (tmp6_0 == null)
              if (!(data_0 == null) && tmp2_0 === 207 && !equals(data_0, Companion_getInstance_0().f30_1)) {
                // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
                var groupKey_2 = hashCode(data_0);
                var tmp_18 = $this;
                // Inline function 'androidx.compose.runtime.unCompoundWith' call
                var this_11 = $this.p3r_1;
                // Inline function 'androidx.compose.runtime.ror' call
                // Inline function 'kotlin.rotateRight' call
                var this_12 = bitwiseXor(this_11, fromInt(tmp4_0));
                // Inline function 'androidx.compose.runtime.unCompoundWith' call
                var this_13 = rotateLeft(this_12, -3 | 0);
                // Inline function 'androidx.compose.runtime.ror' call
                // Inline function 'kotlin.rotateRight' call
                var this_14 = bitwiseXor(this_13, fromInt(groupKey_2));
                tmp_18.p3r_1 = rotateLeft(this_14, -3 | 0);
              } else {
                // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
                var tmp_19 = $this;
                // Inline function 'androidx.compose.runtime.unCompoundWith' call
                var this_15 = $this.p3r_1;
                // Inline function 'androidx.compose.runtime.ror' call
                // Inline function 'kotlin.rotateRight' call
                var this_16 = bitwiseXor(this_15, fromInt(tmp4_0));
                // Inline function 'androidx.compose.runtime.unCompoundWith' call
                var this_17 = rotateLeft(this_16, -3 | 0);
                // Inline function 'androidx.compose.runtime.ror' call
                // Inline function 'kotlin.rotateRight' call
                var this_18 = bitwiseXor(this_17, fromInt(tmp2_0));
                tmp_19.p3r_1 = rotateLeft(this_18, -3 | 0);
              }
             else {
              if (tmp6_0 instanceof Enum) {
                // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
                var groupKey_3 = tmp6_0.a1_1;
                var tmp_20 = $this;
                // Inline function 'androidx.compose.runtime.unCompoundWith' call
                var this_19 = $this.p3r_1;
                // Inline function 'androidx.compose.runtime.ror' call
                // Inline function 'kotlin.rotateRight' call
                var this_20 = bitwiseXor(this_19, fromInt(0));
                // Inline function 'androidx.compose.runtime.unCompoundWith' call
                var this_21 = rotateLeft(this_20, -3 | 0);
                // Inline function 'androidx.compose.runtime.ror' call
                // Inline function 'kotlin.rotateRight' call
                var this_22 = bitwiseXor(this_21, fromInt(groupKey_3));
                tmp_20.p3r_1 = rotateLeft(this_22, -3 | 0);
              } else {
                // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
                var groupKey_4 = hashCode(tmp6_0);
                var tmp_21 = $this;
                // Inline function 'androidx.compose.runtime.unCompoundWith' call
                var this_23 = $this.p3r_1;
                // Inline function 'androidx.compose.runtime.ror' call
                // Inline function 'kotlin.rotateRight' call
                var this_24 = bitwiseXor(this_23, fromInt(0));
                // Inline function 'androidx.compose.runtime.unCompoundWith' call
                var this_25 = rotateLeft(this_24, -3 | 0);
                // Inline function 'androidx.compose.runtime.ror' call
                // Inline function 'kotlin.rotateRight' call
                var this_26 = bitwiseXor(this_25, fromInt(groupKey_4));
                tmp_21.p3r_1 = rotateLeft(this_26, -3 | 0);
              }
            }
            if (!reader.b3m(group_2)) {
              $this.m3q_1 = $this.m3q_1 + 1 | 0;
            }
            next = reader.x3v(current);
            if (next === -1)
              continue $l$loop;
          }
          current = next;
        }
      }
    }
    reader.z3l(parent);
    if (recomposed) {
      reader.z30();
      // Inline function 'androidx.compose.runtime.toGroupHandle' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
      var tmp_22 = shiftLeft(fromInt(0), 32);
      // Inline function 'kotlin.toUInt' call
      // Inline function 'kotlin.UInt.toLong' call
      var this_27 = _UInt___init__impl__l7qpdl(parent);
      // Inline function 'kotlin.uintToLong' call
      var value_3 = _UInt___get_data__impl__f0vqqw(this_27);
      var tmp$ret$76 = bitwiseAnd(fromInt(value_3), new Long(-1, 0));
      var tmp$ret$73 = bitwiseOr(tmp_22, tmp$ret$76);
      var parentGroupNodes = updatedNodeCount_0($this, tmp$ret$73);
      $this.k3q_1 = recomposeIndex + parentGroupNodes | 0;
      $this.l3q_1 = oldGroupNodeCount + parentGroupNodes | 0;
      $this.m3q_1 = oldRGroupIndex;
    } else {
      skipReaderToGroupEnd_0($this);
    }
    $this.p3r_1 = recomposeCompositeKey;
    $this.n3r_1 = wasComposing;
  }
  function recordDelete_0($this) {
    reportFreeMovableContent_0($this, $this.b3r_1.o3v());
    $this.e3r_1.y3v();
  }
  function recordInsert_0($this, source) {
    if ($this.h3r_1.r()) {
      $this.e3r_1.a3w($this.c3r_1.y3s_1, source);
    } else {
      $this.e3r_1.z3v($this.c3r_1.y3s_1, source, $this.h3r_1);
      $this.h3r_1 = new FixupList_0();
    }
  }
  function recordProviderUpdate_0($this, providers) {
    var tmp0_elvis_lhs = $this.v3q_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var newProviderUpdates = new MutableIntObjectMap();
      $this.v3q_1 = newProviderUpdates;
      tmp = newProviderUpdates;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var providerUpdates = tmp;
    providerUpdates.ew($this.b3r_1.h3u(), providers);
  }
  function reportAllMovableContent_0($this) {
    if ($this.c3q_1.c3w(536870912)) {
      $this.g3q_1.s39();
      var changes = new ChangeList_0();
      $this.q3r_1 = changes;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.read' call
      // Inline function 'kotlin.with' call
      var $this$with = $this.c3q_1.d3i();
      var tmp;
      try {
        $this.b3r_1 = $this$with;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.withChangeList' call
        var this_0 = $this.e3r_1;
        var previousChangeList = this_0.o3s_1;
        try {
          this_0.o3s_1 = changes;
          reportFreeMovableContent_0($this, $this$with.b3w());
        }finally {
          this_0.o3s_1 = previousChangeList;
        }
        tmp = Unit_instance;
      }finally {
        $this$with.j4();
      }
    }
  }
  function reportFreeMovableContent_0($this, groupBeingRemoved) {
    var group = get_group(groupBeingRemoved);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    var rootIsNode = (8388608 & $this.b3r_1.d3w(group)) === 8388608;
    if (rootIsNode) {
      $this.e3r_1.h3l();
      $this.e3r_1.c3m($this.b3r_1.z34(group));
    }
    reportFreeMovableContent$reportGroup_0($this, groupBeingRemoved, rootIsNode, 0);
    $this.e3r_1.h3l();
    if (rootIsNode) {
      $this.e3r_1.m3l();
    }
  }
  function resetInsertBuilder($this, dispose) {
    if (!$this.c3r_1.p3t_1) {
      var table = $this.c3r_1.g3d();
      if (dispose) {
        table.s1d();
      }
    }
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = SlotTableBuilder_init_$Create$($this.c3q_1.j3u_1, false, false);
    this_0.j4();
    tmp.c3r_1 = this_0;
  }
  function requireRecomposeScope($this, group) {
    var slot = $this.b3r_1.e3w(group, 0);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!equals(slot, Companion_getInstance_0().f30_1)) {
      var tmp$ret$1 = 'Cannot obtain RecomposeScope. Group does not have a corresponding slot.';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(slot instanceof RecomposeScopeImpl)) {
      var tmp$ret$3 = 'Expected a RecomposeScope in the first non-utility slot, found ' + toString_0(slot) + '.';
      composeImmediateRuntimeError(tmp$ret$3);
    }
    return slot;
  }
  function requiresRecomposition($this, group) {
    return $this.b3r_1.w3v(group);
  }
  function rGroupIndexOf_0($this, group) {
    var result = 0;
    var groupParent = $this.b3r_1.l3v(group);
    var tmp;
    if (groupParent < 0) {
      tmp = $this.g3u().i3u_1;
    } else {
      tmp = $this.b3r_1.v3v(groupParent);
    }
    var eldestSibling = tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseSiblings' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseSiblings' call
    var groups = $this.g3u().j3u_1.p3u_1;
    var current = eldestSibling;
    while (current >= 0) {
      var predecessor = current;
      if (predecessor === group)
        return result;
      if (!$this.b3r_1.b3m(predecessor)) {
        result = result + 1 | 0;
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      current = groups[current + 1 | 0];
    }
    return result;
  }
  function skipGroup_0($this) {
    $this.l3q_1 = $this.l3q_1 + $this.b3r_1.y35() | 0;
  }
  function skipReaderToGroupEnd_0($this) {
    $this.l3q_1 = $this.b3r_1.f3w();
    $this.b3r_1.z30();
  }
  function start_0($this, key, objectKey, kind, data) {
    validateNodeNotExpected_0($this);
    // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroup' call
    var rGroupIndex = $this.m3q_1;
    if (objectKey == null)
      if (!(data == null) && key === 207 && !equals(data, Companion_getInstance_0().f30_1)) {
        // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey = hashCode(data);
        var tmp = $this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_0 = $this.p3r_1;
        var tmp$ret$3 = rotateLeft(this_0, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_1 = bitwiseXor(tmp$ret$3, fromInt(groupKey));
        var tmp$ret$5 = rotateLeft(this_1, 3);
        tmp.p3r_1 = bitwiseXor(tmp$ret$5, fromInt(rGroupIndex));
      } else {
        // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var tmp_0 = $this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_2 = $this.p3r_1;
        var tmp$ret$8 = rotateLeft(this_2, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_3 = bitwiseXor(tmp$ret$8, fromInt(key));
        var tmp$ret$10 = rotateLeft(this_3, 3);
        tmp_0.p3r_1 = bitwiseXor(tmp$ret$10, fromInt(rGroupIndex));
      }
     else {
      if (objectKey instanceof Enum) {
        // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey_0 = objectKey.a1_1;
        var tmp_1 = $this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_4 = $this.p3r_1;
        var tmp$ret$13 = rotateLeft(this_4, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_5 = bitwiseXor(tmp$ret$13, fromInt(groupKey_0));
        var tmp$ret$15 = rotateLeft(this_5, 3);
        tmp_1.p3r_1 = bitwiseXor(tmp$ret$15, fromInt(0));
      } else {
        // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey_1 = hashCode(objectKey);
        var tmp_2 = $this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_6 = $this.p3r_1;
        var tmp$ret$18 = rotateLeft(this_6, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_7 = bitwiseXor(tmp$ret$18, fromInt(groupKey_1));
        var tmp$ret$20 = rotateLeft(this_7, 3);
        tmp_2.p3r_1 = bitwiseXor(tmp$ret$20, fromInt(0));
      }
    }
    if (objectKey == null) {
      $this.m3q_1 = $this.m3q_1 + 1 | 0;
    }
    // Inline function 'androidx.compose.runtime.composer.GroupKind.isNode' call
    var isNode = !(_GroupKind___get_value__impl__cf5pqe(kind) === _GroupKind___get_value__impl__cf5pqe(Companion_getInstance_7().n3j_1));
    if ($this.t3r_1) {
      $this.b3r_1.z3j();
      var builder = $this.c3r_1;
      if (isNode) {
        var tmp4 = Companion_getInstance_0().f30_1;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startNodeGroup' call
        var node = Companion_getInstance_0().f30_1;
        access$startNewGroup(builder, key, tmp4 === Companion_getInstance_0().f30_1 ? 8388608 : 25165824, tmp4, null, node);
      } else if (!(data == null)) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startDataGroup' call
        var objectKey_0 = objectKey == null ? Companion_getInstance_0().f30_1 : objectKey;
        access$startNewGroup(builder, key, objectKey_0 === Companion_getInstance_0().f30_1 ? 33554432 : 50331648, objectKey_0, data, null);
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startGroup' call
        var objectKey_1 = objectKey == null ? Companion_getInstance_0().f30_1 : objectKey;
        access$startNewGroup(builder, key, objectKey_1 === Companion_getInstance_0().f30_1 ? 0 : 16777216, objectKey_1, null, null);
      }
      var tmp2_safe_receiver = $this.j3q_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var insertKeyInfo = new KeyInfo_0(key, -1, toInsertAddress(builder.z3u()), -1, 0);
        tmp2_safe_receiver.g3w(insertKeyInfo, $this.k3q_1 - tmp2_safe_receiver.r3t_1 | 0);
        tmp2_safe_receiver.h3w(insertKeyInfo);
      }
      enterGroup_0($this, isNode, null);
      return Unit_instance;
    }
    var tmp_3;
    // Inline function 'androidx.compose.runtime.composer.GroupKind.isReusable' call
    if (!!(_GroupKind___get_value__impl__cf5pqe(kind) === _GroupKind___get_value__impl__cf5pqe(Companion_getInstance_7().o3j_1))) {
      tmp_3 = $this.y3q_1;
    } else {
      tmp_3 = false;
    }
    var forceReplace = tmp_3;
    if ($this.j3q_1 == null) {
      var slotKey = $this.b3r_1.k3k();
      if (!forceReplace && slotKey === key && equals(objectKey, $this.b3r_1.m3k())) {
        startReaderGroup_0($this, isNode, data);
      } else {
        $this.j3q_1 = new LinkPending($this.b3r_1.l3k(), $this.k3q_1);
      }
    }
    var pending = $this.j3q_1;
    var newPending = null;
    if (!(pending == null)) {
      var keyInfo = pending.n3k(key, objectKey);
      if (!forceReplace && !(keyInfo == null)) {
        pending.h3w(keyInfo);
        var location = keyInfo.a3u_1;
        $this.k3q_1 = pending.x3t(keyInfo) + pending.r3t_1 | 0;
        var relativePosition = pending.i3w(keyInfo);
        var currentRelativePosition = relativePosition - pending.s3t_1 | 0;
        pending.w3k(relativePosition, pending.s3t_1);
        if (currentRelativePosition > 0) {
          $this.b3r_1.d3u(pending.j3w());
          $this.e3r_1.k3w(currentRelativePosition);
        }
        pending.l3w(keyInfo.c3u_1);
        $this.b3r_1.d3u(location);
        startReaderGroup_0($this, isNode, data);
      } else {
        $this.b3r_1.z3j();
        $this.t3r_1 = true;
        $this.a3r_1 = null;
        ensureBuilder($this);
        var builder_0 = $this.c3r_1;
        if (isNode) {
          var tmp4_0 = Companion_getInstance_0().f30_1;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startNodeGroup' call
          var node_0 = Companion_getInstance_0().f30_1;
          access$startNewGroup(builder_0, key, tmp4_0 === Companion_getInstance_0().f30_1 ? 8388608 : 25165824, tmp4_0, null, node_0);
        } else if (!(data == null)) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startDataGroup' call
          var objectKey_2 = objectKey == null ? Companion_getInstance_0().f30_1 : objectKey;
          access$startNewGroup(builder_0, key, objectKey_2 === Companion_getInstance_0().f30_1 ? 33554432 : 50331648, objectKey_2, data, null);
        } else {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startGroup' call
          var objectKey_3 = objectKey == null ? Companion_getInstance_0().f30_1 : objectKey;
          access$startNewGroup(builder_0, key, objectKey_3 === Companion_getInstance_0().f30_1 ? 0 : 16777216, objectKey_3, null, null);
        }
        var insertKeyInfo_0 = new KeyInfo_0(key, -1, toInsertAddress(builder_0.z3u()), -1, 0);
        pending.g3w(insertKeyInfo_0, $this.k3q_1 - pending.r3t_1 | 0);
        pending.h3w(insertKeyInfo_0);
        // Inline function 'kotlin.collections.mutableListOf' call
        var tmp$ret$31 = ArrayList_init_$Create$();
        newPending = new LinkPending(tmp$ret$31, isNode ? 0 : $this.k3q_1);
      }
    }
    enterGroup_0($this, isNode, newPending);
  }
  function startGroup_1($this, key, dataKey) {
    return start_0($this, key, dataKey, Companion_getInstance_7().n3j_1, null);
  }
  function startReaderGroup_0($this, isNode, data) {
    if (isNode) {
      $this.b3r_1.y3j();
    } else {
      if (!(data == null) && !($this.b3r_1.w3j() === data)) {
        $this.e3r_1.v3j(data);
      }
      $this.b3r_1.x3j();
    }
  }
  function startRoot_0($this) {
    $this.m3q_1 = 0;
    $this.b3r_1 = $this.c3q_1.d3i();
    // Inline function 'androidx.compose.runtime.LinkComposer.startGroup' call
    start_0($this, 100, null, Companion_getInstance_7().n3j_1, null);
    $this.a3q_1.y3b();
    var parentProvider = $this.a3q_1.b30();
    $this.x3q_1.g3i(asInt_0($this.w3q_1));
    $this.w3q_1 = $this.k31(parentProvider);
    $this.a3r_1 = null;
    if (!$this.q3q_1) {
      $this.q3q_1 = $this.a3q_1.p3b();
    }
    if (!$this.k3r_1) {
      $this.k3r_1 = $this.a3q_1.f39();
    }
    var tmp = $this;
    var tmp_0;
    if ($this.k3r_1) {
      var tmp_1 = get_LocalCompositionErrorContext();
      tmp_0 = parentProvider.y3c(tmp_1 instanceof CompositionLocal ? tmp_1 : THROW_CCE(), new StaticValueHolder($this.s32()));
    } else {
      tmp_0 = parentProvider;
    }
    tmp.u3q_1 = tmp_0;
    var tmp0_safe_receiver = read($this.u3q_1, get_LocalInspectionTables());
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.j1($this.h3i());
      $this.a3q_1.w3b(tmp0_safe_receiver);
    }
    // Inline function 'androidx.compose.runtime.LinkComposer.startGroup' call
    var key = $this.a3q_1.o3b().hashCode();
    start_0($this, key, null, Companion_getInstance_7().n3j_1, null);
  }
  function stackTraceForGroup_0($this, group, dataOffset) {
    if (!$this.k3r_1)
      return emptyList();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.read' call
    // Inline function 'kotlin.with' call
    var $this$with = $this.c3q_1.d3i();
    var tmp;
    try {
      tmp = traceForGroup($this$with, group, dataOffset);
    }finally {
      $this$with.j4();
    }
    return tmp;
  }
  function updateChildNodeCount($this, virtualGroup, count) {
    if (!(updatedNodeCount_0($this, virtualGroup) === count)) {
      if (get_isInsertHandle(virtualGroup)) {
        var tmp0_elvis_lhs = $this.p3q_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var newCounts = new MutableIntIntMap();
          $this.p3q_1 = newCounts;
          tmp = newCounts;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var virtualCounts = tmp;
        virtualCounts.zu(get_group(virtualGroup), count);
      } else {
        var tmp1_elvis_lhs = $this.o3q_1;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var newCounts_0 = new MutableIntIntMap();
          $this.o3q_1 = newCounts_0;
          tmp_0 = newCounts_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var nodeCounts = tmp_0;
        // Inline function 'androidx.compose.runtime.toGroupHandle' call
        // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
        var value = !get_isInsertHandle(virtualGroup);
        if (false && !value) {
          var tmp$ret$6 = 'A virtual handle to a group in the builder cannot immediately converted ot a group handle';
          composeImmediateRuntimeError(tmp$ret$6);
        }
        nodeCounts.zu(get_group(virtualGroup), count);
      }
    }
  }
  function updateNodeCountOverrides_0($this, virtualHandle, newCount) {
    var currentCount = updatedNodeCount_0($this, virtualHandle);
    if (!(currentCount === newCount)) {
      var delta = newCount - currentCount | 0;
      var current = virtualHandle;
      var minPending = _Stack___get_size__impl__mdb81l($this.i3q_1) - 1 | 0;
      $l$loop_0: while (!(get_group(current) === -1)) {
        var newCurrentNodes = updatedNodeCount_0($this, current) + delta | 0;
        updateChildNodeCount($this, current, newCurrentNodes);
        var inductionVariable = minPending;
        if (0 <= inductionVariable)
          $l$loop: do {
            var pendingIndex = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var pending = Stack__peek_impl_gtylu2_0($this.i3q_1, pendingIndex);
            if (!(pending == null) && pending.d3l(get_group(current), newCurrentNodes)) {
              minPending = pendingIndex - 1 | 0;
              break $l$loop;
            }
          }
           while (0 <= inductionVariable);
        if (get_isInsertHandle(current)) {
          current = $this.b3r_1.z3u();
        } else {
          var groups = $this.g3u().j3u_1.p3u_1;
          var group = get_group(current);
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
          if ((8388608 & groups[group + 4 | 0]) === 8388608)
            break $l$loop_0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
          // Inline function 'androidx.compose.runtime.toGroupHandle' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
          var group_0 = groups[group + 2 | 0];
          var tmp = shiftLeft(fromInt(0), 32);
          // Inline function 'kotlin.toUInt' call
          // Inline function 'kotlin.UInt.toLong' call
          var this_0 = _UInt___init__impl__l7qpdl(group_0);
          // Inline function 'kotlin.uintToLong' call
          var value = _UInt___get_data__impl__f0vqqw(this_0);
          var tmp$ret$6 = bitwiseAnd(fromInt(value), new Long(-1, 0));
          current = bitwiseOr(tmp, tmp$ret$6);
        }
      }
    }
  }
  function updateProviderMapGroup_0($this, parentScope, currentProviders) {
    // Inline function 'androidx.compose.runtime.mutate' call
    // Inline function 'kotlin.apply' call
    var this_0 = parentScope.a3d();
    this_0.b3(currentProviders);
    var providerScope = this_0.g3d();
    startGroup_1($this, 204, get_providerMaps());
    updateSlot_0($this, providerScope);
    updateSlot_0($this, currentProviders);
    endGroup_0($this);
    return providerScope;
  }
  function updateSlot_0($this, value) {
    $this.q3j();
    $this.r3j(value);
  }
  function updatedNodeCount_0($this, virtualHandle) {
    if (get_isInsertHandle(virtualHandle)) {
      var tmp0_safe_receiver = $this.p3q_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gv(get_group(virtualHandle), 0);
      return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    }
    // Inline function 'androidx.compose.runtime.toGroupHandle' call
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = !get_isInsertHandle(virtualHandle);
    if (false && !value) {
      var tmp$ret$2 = 'A virtual handle to a group in the builder cannot immediately converted ot a group handle';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    var handle = virtualHandle;
    var group = get_group(handle);
    var nodeCounts = $this.o3q_1;
    if (!(nodeCounts == null)) {
      var override = nodeCounts.gv(group, -1);
      if (override >= 0)
        return override;
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
    return $this.g3u().j3u_1.p3u_1[group + 4 | 0] & 8388607;
  }
  function unwrapRememberObserverHolder($this, $receiver) {
    var tmp;
    if (!($receiver == null) ? isInterface($receiver, RememberObserverHolder) : false) {
      tmp = $receiver.h33();
    } else {
      tmp = $receiver;
    }
    return tmp;
  }
  function enterRecomposeScope_0($this, scope) {
    scope.n3m($this.j3r_1);
    var tmp0_safe_receiver = $this.f3q_1.d39();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.w3l(scope);
    }
  }
  function exitRecomposeScope_0($this, scope) {
    var tmp0_safe_receiver = $this.f3q_1.d39();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.x3l(scope);
    }
    return scope.o3m($this.j3r_1);
  }
  function validateNodeExpected_0($this) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!$this.s3q_1) {
      var tmp$ret$1 = 'A call to createNode(), emitNode() or useNode() expected was not expected';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    $this.s3q_1 = false;
  }
  function validateNodeNotExpected_0($this) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!$this.s3q_1) {
      var tmp$ret$1 = 'A call to createNode(), emitNode() or useNode() expected';
      composeImmediateRuntimeError(tmp$ret$1);
    }
  }
  function CompositionContextImpl_0($outer, compositeKeyHashCode, collectingParameterInformation, collectingSourceInformation, observerHolder) {
    this.y3p_1 = $outer;
    CompositionContext.call(this);
    this.r3p_1 = compositeKeyHashCode;
    this.s3p_1 = collectingParameterInformation;
    this.t3p_1 = collectingSourceInformation;
    this.u3p_1 = observerHolder;
    this.v3p_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.w3p_1 = LinkedHashSet_init_$Create$();
    this.x3p_1 = mutableStateOf(persistentCompositionLocalHashMapOf(), referentialEqualityPolicy());
  }
  protoOf(CompositionContextImpl_0).o3b = function () {
    return this.r3p_1;
  };
  protoOf(CompositionContextImpl_0).p3b = function () {
    return this.s3p_1;
  };
  protoOf(CompositionContextImpl_0).f39 = function () {
    return this.t3p_1;
  };
  protoOf(CompositionContextImpl_0).n3b = function () {
    return this.u3p_1;
  };
  protoOf(CompositionContextImpl_0).e39 = function () {
    return this.y3p_1.a3q_1.e39();
  };
  protoOf(CompositionContextImpl_0).q3b = function () {
    return this.y3p_1.a3q_1.q3b();
  };
  protoOf(CompositionContextImpl_0).s1d = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.w3p_1.r()) {
      var tmp0_safe_receiver = this.v3p_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var _iterator__ex2g4s = this.w3p_1.t();
        while (_iterator__ex2g4s.u()) {
          var composer = _iterator__ex2g4s.v();
          var _iterator__ex2g4s_0 = tmp0_safe_receiver.t();
          while (_iterator__ex2g4s_0.u()) {
            var table = _iterator__ex2g4s_0.v();
            table.d3(composer.h3i());
          }
        }
      }
      this.w3p_1.c3();
    }
  };
  protoOf(CompositionContextImpl_0).g39 = function (composer) {
    protoOf(CompositionContext).g39.call(this, composer);
    this.w3p_1.j1(asLinkComposer(composer));
  };
  protoOf(CompositionContextImpl_0).x3b = function (composer) {
    var tmp0_safe_receiver = this.v3p_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0_safe_receiver.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        element.d3(asLinkComposer(composer).h3i());
      }
    }
    // Inline function 'kotlin.collections.remove' call
    var this_0 = this.w3p_1;
    (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).d3(composer);
  };
  protoOf(CompositionContextImpl_0).u39 = function (composition) {
    this.y3p_1.a3q_1.u39(composition);
  };
  protoOf(CompositionContextImpl_0).v3b = function (scope) {
    this.y3p_1.a3q_1.v3b(scope);
  };
  protoOf(CompositionContextImpl_0).r3b = function () {
    return this.y3p_1.a3q_1.r3b();
  };
  protoOf(CompositionContextImpl_0).o37 = function (composition, content) {
    this.y3p_1.a3q_1.o37(composition, content);
  };
  protoOf(CompositionContextImpl_0).t3b = function (composition, shouldPause, content) {
    return this.y3p_1.a3q_1.t3b(composition, shouldPause, content);
  };
  protoOf(CompositionContextImpl_0).u3b = function (composition, shouldPause, invalidScopes) {
    return this.y3p_1.a3q_1.u3b(composition, shouldPause, invalidScopes);
  };
  protoOf(CompositionContextImpl_0).z38 = function (composition) {
    this.y3p_1.a3q_1.z38(this.y3p_1.g3q_1);
    this.y3p_1.a3q_1.z38(composition);
  };
  protoOf(CompositionContextImpl_0).b30 = function () {
    return _get_compositionLocalScope__ulge9q_0(this);
  };
  protoOf(CompositionContextImpl_0).j3n = function (scope) {
    _set_compositionLocalScope__ya1b9q_0(this, scope);
  };
  protoOf(CompositionContextImpl_0).w3b = function (table) {
    var tmp0_elvis_lhs = this.v3p_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = HashSet_init_$Create$();
      this.v3p_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    tmp.j1(table);
  };
  protoOf(CompositionContextImpl_0).y3b = function () {
    var _unary__edvuaz = this.y3p_1.i3r_1;
    this.y3p_1.i3r_1 = _unary__edvuaz + 1 | 0;
  };
  protoOf(CompositionContextImpl_0).z3b = function () {
    var _unary__edvuaz = this.y3p_1.i3r_1;
    this.y3p_1.i3r_1 = _unary__edvuaz - 1 | 0;
  };
  protoOf(CompositionContextImpl_0).a3c = function (reference) {
    this.y3p_1.a3q_1.a3c(reference);
  };
  protoOf(CompositionContextImpl_0).b3c = function (reference) {
    this.y3p_1.a3q_1.b3c(reference);
  };
  protoOf(CompositionContextImpl_0).d3c = function (reference) {
    return this.y3p_1.a3q_1.d3c(reference);
  };
  protoOf(CompositionContextImpl_0).c3c = function (reference, data, applier) {
    this.y3p_1.a3q_1.c3c(reference, data, applier);
  };
  protoOf(CompositionContextImpl_0).e3c = function (composition) {
    this.y3p_1.a3q_1.e3c(composition);
  };
  protoOf(CompositionContextImpl_0).s3b = function () {
    return this.y3p_1.g3q_1;
  };
  function CompositionContextHolder_0(ref) {
    this.m3w_1 = ref;
  }
  protoOf(CompositionContextHolder_0).g3f = function () {
  };
  protoOf(CompositionContextHolder_0).i3f = function () {
    this.m3w_1.s1d();
  };
  protoOf(CompositionContextHolder_0).h3f = function () {
    this.m3w_1.s1d();
  };
  function LinkComposer$derivedStateObserver$1(this$0) {
    this.n3w_1 = this$0;
  }
  protoOf(LinkComposer$derivedStateObserver$1).e3e = function (derivedState) {
    var _unary__edvuaz = this.n3w_1.i3r_1;
    this.n3w_1.i3r_1 = _unary__edvuaz + 1 | 0;
  };
  protoOf(LinkComposer$derivedStateObserver$1).n3e = function (derivedState) {
    var _unary__edvuaz = this.n3w_1.i3r_1;
    this.n3w_1.i3r_1 = _unary__edvuaz - 1 | 0;
  };
  function LinkComposer$stackTraceForValue$lambda($value) {
    return function (it) {
      var tmp;
      if (it === $value) {
        tmp = true;
      } else {
        var tmp0_safe_receiver = (!(it == null) ? isInterface(it, RememberObserverHolder) : false) ? it : null;
        tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h33()) === $value;
      }
      return tmp;
    };
  }
  function LinkComposer$doCompose$lambda(this$0) {
    return function () {
      return currentStackTrace_0(this$0);
    };
  }
  function LinkComposer$insertMovableContentGuarded$lambda(this$0, $offsetChanges, $$this$read, $handle, $to) {
    return function () {
      var tmp0 = this$0.e3r_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.withChangeList' call
      var newChangeList = $offsetChanges;
      var previousChangeList = tmp0.o3s_1;
      try {
        tmp0.o3s_1 = newChangeList;
        var tmp0_0 = this$0;
        var tmp2 = $$this$read;
        $l$block: {
          // Inline function 'androidx.compose.runtime.LinkComposer.withReader' call
          var savedReader = tmp0_0.b3r_1;
          var savedCountOverrides = tmp0_0.o3q_1;
          var savedProviderUpdates = tmp0_0.v3q_1;
          tmp0_0.o3q_1 = null;
          tmp0_0.v3q_1 = null;
          try {
            tmp0_0.b3r_1 = tmp2;
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.withoutImplicitRootStart' call
            var this_0 = this$0.e3r_1;
            var previousImplicitRootStart = this_0.p3s_1;
            try {
              this_0.p3s_1 = false;
              var tmp0_1 = this$0.e3r_1;
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ComposerChangeListWriter.inRelativeAddressMode' call
              var relativeStart = $handle;
              access$_set_editorCurrentPosition__56o8a8(tmp0_1, relativeStart);
              var newMode = ComposerChangeListWriterAddressMode_RelativeAddressing_getInstance();
              var previousMode = tmp0_1.w3s_1;
              var previousCurrentPosition = access$_get_editorCurrentPosition__bcakpw(tmp0_1);
              tmp0_1.w3s_1 = newMode;
              try {
                invokeMovableContentLambda_0(this$0, $to.c35_1, $to.i35_1, $to.d35_1, true);
              }finally {
                tmp0_1.w3s_1 = previousMode;
                access$_set_editorCurrentPosition__56o8a8(tmp0_1, previousMode.equals(ComposerChangeListWriterAddressMode_RelativeAddressing_getInstance()) ? previousCurrentPosition : new Long(-1, -1));
              }
            }finally {
              this_0.p3s_1 = previousImplicitRootStart;
            }
            break $l$block;
          }finally {
            tmp0_0.b3r_1 = savedReader;
            tmp0_0.o3q_1 = savedCountOverrides;
            tmp0_0.v3q_1 = savedProviderUpdates;
          }
        }
      }finally {
        tmp0.o3s_1 = previousChangeList;
      }
      return Unit_instance;
    };
  }
  function LinkComposer$insertMovableContentGuarded$lambda_0(this$0, $to) {
    return function () {
      invokeMovableContentLambda_0(this$0, $to.c35_1, $to.i35_1, $to.d35_1, true);
      return Unit_instance;
    };
  }
  function LinkComposer$invokeMovableContentLambda$lambda($content, $parameter) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        tmp = $content.l3n_1($parameter, $composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LinkComposer$invokeMovableContentLambda$lambda_0(this$0) {
    return function () {
      return currentStackTrace_0(this$0);
    };
  }
  function reportFreeMovableContent$createMovableContentReferenceForGroup_0(this$0, group, nestedStates) {
    var tmp = this$0.b3r_1.u3j(group);
    var movableContent = tmp instanceof MovableContent ? tmp : THROW_CCE();
    var parameter = this$0.b3r_1.e3w(group, 0);
    var invalidations = findInvalidations(this$0.b3r_1, group, this$0.h3q_1);
    var anchor = this$0.g3u().j3u_1.u3v(group);
    var reference = new MovableContentStateReference(movableContent, parameter, this$0.g3q_1, this$0.g3u(), anchor, invalidations, currentCompositionLocalScope_2(this$0, group), nestedStates);
    return reference;
  }
  function reportFreeMovableContent$movableContentReferenceFor_0(this$0, group) {
    var flags = this$0.b3r_1.d3w(group);
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((268435456 & flags) === 268435456) {
      var tmp_0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      if ((536870912 & flags) === 536870912) {
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList_init_$Create$();
        var tmp0 = this$0.b3r_1;
        $l$block: {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableReader.traverseChildrenConditionally' call
          var current = tmp0.v3v(group);
          while (!(current === -1)) {
            var child = current;
            var tmp_1;
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
            if ((268435456 & this$0.b3r_1.d3w(child)) === 268435456) {
              var tmp0_safe_receiver = reportFreeMovableContent$movableContentReferenceFor_0(this$0, child);
              if (tmp0_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                this_0.j1(tmp0_safe_receiver);
              }
              tmp_1 = true;
            } else {
              tmp_1 = false;
            }
            var used = tmp_1;
            var firstChild = tmp0.v3v(current);
            var tmp_2;
            if (!used && !(firstChild === -1)) {
              var child_0 = current;
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
              tmp_2 = (536870912 & this$0.b3r_1.d3w(child_0)) === 536870912;
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              current = firstChild;
            } else {
              var next = tmp0.x3v(current);
              $l$loop: while (next === -1) {
                current = tmp0.l3v(current);
                if (current === -1 || current === group) {
                  break $l$block;
                }
                next = tmp0.x3v(current);
                if (next === -1)
                  continue $l$loop;
              }
              current = next;
            }
          }
        }
        tmp_0 = this_0.t5();
      } else {
        tmp_0 = null;
      }
      var nestedStates = tmp_0;
      tmp = reportFreeMovableContent$createMovableContentReferenceForGroup_0(this$0, group, nestedStates);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function reportFreeMovableContent$reportGroup_0(this$0, handle, needsNodeDelete, nodeIndex) {
    var group = get_group(handle);
    if (group < 0)
      return 0;
    var flags = this$0.b3r_1.d3w(group);
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((268435456 & flags) === 268435456) {
      var reference = reportFreeMovableContent$movableContentReferenceFor_0(this$0, group);
      if (!(reference == null)) {
        this$0.a3q_1.b3c(reference);
        this$0.e3r_1.o3w(this$0.g3q_1, this$0.a3q_1, reference);
      }
      var tmp_0;
      if (needsNodeDelete) {
        this$0.e3r_1.r3n(nodeIndex, group);
        tmp_0 = 0;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
        var flags_0 = this$0.b3r_1.d3w(group);
        var tmp_1;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
        if ((8388608 & flags_0) === 8388608) {
          tmp_1 = 1;
        } else {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
          tmp_1 = flags_0 & 8388607;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      var other = 1073741824;
      if ((other & flags) === other) {
        var tmp_2 = this$0.b3r_1.e3w(group, 0);
        var observerHolder = (!(tmp_2 == null) ? isInterface(tmp_2, RememberObserverHolder) : false) ? tmp_2 : null;
        var tmp_3 = observerHolder == null ? null : observerHolder.h33();
        var contextHolder = tmp_3 instanceof CompositionContextHolder_0 ? tmp_3 : null;
        if (!(contextHolder == null)) {
          var compositionContext = contextHolder.m3w_1;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = compositionContext.w3p_1.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            reportAllMovableContent_0(element);
            this$0.a3q_1.e3c(element.g3q_1);
          }
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
        var flags_1 = this$0.b3r_1.d3w(group);
        var tmp_4;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
        if ((8388608 & flags_1) === 8388608) {
          tmp_4 = 1;
        } else {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
          tmp_4 = flags_1 & 8388607;
        }
        tmp = tmp_4;
      } else {
        var tmp_5;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
        if ((536870912 & flags) === 536870912) {
          tmp_5 = true;
        } else {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
          var other_0 = -2147483648;
          tmp_5 = (other_0 & flags) === other_0;
        }
        if (tmp_5) {
          var runningNodeCount = 0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableReader.traverseChildrenByHandle' call
          var this_0 = this$0.b3r_1;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
          var group_0 = this_0.v3v(group);
          var tmp_6 = shiftLeft(fromInt(-1), 32);
          // Inline function 'kotlin.toUInt' call
          // Inline function 'kotlin.UInt.toLong' call
          var this_1 = _UInt___init__impl__l7qpdl(group_0);
          // Inline function 'kotlin.uintToLong' call
          var value = _UInt___get_data__impl__f0vqqw(this_1);
          var tmp$ret$15 = bitwiseAnd(fromInt(value), new Long(-1, 0));
          var current = bitwiseOr(tmp_6, tmp$ret$15);
          while (!(get_group(current) === -1)) {
            var childHandle = current;
            var childGroup = get_group(childHandle);
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
            var isNode = (8388608 & this$0.b3r_1.d3w(childGroup)) === 8388608;
            if (isNode) {
              this$0.e3r_1.h3l();
              this$0.e3r_1.c3m(this$0.b3r_1.z34(childGroup));
            }
            runningNodeCount = runningNodeCount + reportFreeMovableContent$reportGroup_0(this$0, childHandle, isNode || needsNodeDelete, isNode ? 0 : nodeIndex + runningNodeCount | 0) | 0;
            if (isNode) {
              this$0.e3r_1.h3l();
              this$0.e3r_1.m3l();
            }
            var tmp0 = get_group(current);
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
            var group_1 = this_0.x3v(get_group(current));
            var tmp_7 = shiftLeft(fromInt(tmp0), 32);
            // Inline function 'kotlin.toUInt' call
            // Inline function 'kotlin.UInt.toLong' call
            var this_2 = _UInt___init__impl__l7qpdl(group_1);
            // Inline function 'kotlin.uintToLong' call
            var value_0 = _UInt___get_data__impl__f0vqqw(this_2);
            var tmp$ret$21 = bitwiseAnd(fromInt(value_0), new Long(-1, 0));
            current = bitwiseOr(tmp_7, tmp$ret$21);
          }
          tmp = runningNodeCount;
        } else {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
          var flags_2 = this$0.b3r_1.d3w(group);
          var tmp_8;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
          if ((8388608 & flags_2) === 8388608) {
            tmp_8 = 1;
          } else {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
            tmp_8 = flags_2 & 8388607;
          }
          tmp = tmp_8;
        }
      }
    }
    var childNodeCount = tmp;
    var tmp_9;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp_9 = 1;
    } else {
      tmp_9 = childNodeCount;
    }
    return tmp_9;
  }
  function LinkComposer(applier, parentContext, abandonSet, slotTable, changes, lateChanges, observerHolder, composition) {
    InternalComposer.call(this);
    this.z3p_1 = applier;
    this.a3q_1 = parentContext;
    this.b3q_1 = abandonSet;
    this.c3q_1 = slotTable;
    this.d3q_1 = changes;
    this.e3q_1 = lateChanges;
    this.f3q_1 = observerHolder;
    this.g3q_1 = composition;
    this.h3q_1 = _ScopeMap___init__impl__52wntz();
    this.i3q_1 = _Stack___init__impl__tvpfn5();
    this.j3q_1 = null;
    this.k3q_1 = 0;
    this.l3q_1 = 0;
    this.m3q_1 = 0;
    this.n3q_1 = new IntStack();
    this.o3q_1 = null;
    this.p3q_1 = null;
    this.q3q_1 = false;
    this.r3q_1 = false;
    this.s3q_1 = false;
    this.t3q_1 = new IntStack();
    this.u3q_1 = persistentCompositionLocalHashMapOf();
    this.v3q_1 = null;
    this.w3q_1 = false;
    this.x3q_1 = new IntStack();
    this.y3q_1 = false;
    this.z3q_1 = -1;
    this.a3r_1 = null;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = this.c3q_1.d3i();
    this_0.j4();
    tmp.b3r_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    var this_1 = SlotTableBuilder_init_$Create$(this.c3q_1.j3u_1, false, false);
    this_1.j4();
    tmp_0.c3r_1 = this_1;
    this.d3r_1 = false;
    this.e3r_1 = new ComposerChangeListWriter_0(this, asLinkBufferChangeList(this.d3q_1));
    this.f3r_1 = null;
    this.g3r_1 = -1;
    this.h3r_1 = new FixupList_0();
    this.i3r_1 = 0;
    this.j3r_1 = 0;
    this.k3r_1 = this.a3q_1.f39() || this.a3q_1.e39();
    var tmp_1 = this;
    tmp_1.l3r_1 = new LinkComposer$derivedStateObserver$1(this);
    this.m3r_1 = _Stack___init__impl__tvpfn5();
    this.n3r_1 = false;
    this.o3r_1 = false;
    this.p3r_1 = new Long(0, 0);
    this.q3r_1 = null;
    this.r3r_1 = null;
    this.s3r_1 = new CompositionErrorContextImpl(this);
    this.t3r_1 = false;
    var tmp_2 = this;
    var tmp_3 = this.a3q_1.r3b();
    var tmp0_elvis_lhs = this.s32();
    tmp_2.u3r_1 = tmp_3.xj(tmp0_elvis_lhs == null ? EmptyCoroutineContext_getInstance() : tmp0_elvis_lhs);
  }
  protoOf(LinkComposer).g30 = function () {
    return this.z3p_1;
  };
  protoOf(LinkComposer).g3u = function () {
    return this.b3r_1.x3r_1;
  };
  protoOf(LinkComposer).u32 = function () {
    return this.k3r_1;
  };
  protoOf(LinkComposer).q32 = function () {
    return this.n3r_1;
  };
  protoOf(LinkComposer).p32 = function () {
    return this.i3r_1 > 0;
  };
  protoOf(LinkComposer).r32 = function () {
    // Inline function 'kotlin.let' call
    var it = this.m3r_1;
    return this.i3r_1 === 0 && Stack__isNotEmpty_impl_ua6a9t(it) ? Stack__peek_impl_gtylu2(it) : null;
  };
  protoOf(LinkComposer).z2z = function () {
    return this.p3r_1;
  };
  protoOf(LinkComposer).j30 = function () {
    var tmp;
    if (!this.i30() || this.w3q_1) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = this.r32();
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j30()) === true;
    }
    return tmp;
  };
  protoOf(LinkComposer).t32 = function () {
    return this.q3r_1;
  };
  protoOf(LinkComposer).s32 = function () {
    return this.k3r_1 ? this.s3r_1 : null;
  };
  protoOf(LinkComposer).h30 = function () {
    return this.t3r_1;
  };
  protoOf(LinkComposer).c33 = function (block) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.n3r_1) {
      var tmp$ret$1 = 'Preparing a composition while composing is not supported';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.n3r_1 = true;
    try {
      block();
    }finally {
      this.n3r_1 = false;
    }
  };
  protoOf(LinkComposer).x2z = function () {
    return this.r32();
  };
  protoOf(LinkComposer).y2z = function (scope) {
    var tmp0_safe_receiver = scope instanceof RecomposeScopeImpl ? scope : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b3a(true);
    }
  };
  protoOf(LinkComposer).i30 = function () {
    var tmp;
    var tmp_0;
    if (!this.t3r_1 && !this.y3q_1 && !this.w3q_1) {
      var tmp0_safe_receiver = this.r32();
      tmp_0 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u3n()) === false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !this.r3q_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(LinkComposer).h31 = function (value, block) {
    if (this.t3r_1) {
      this.h3r_1.z3n(value, block);
    } else {
      this.e3r_1.y3n(value, block);
    }
  };
  protoOf(LinkComposer).z31 = function () {
    return this.u3r_1;
  };
  protoOf(LinkComposer).a30 = function () {
    startGroup_1(this, 206, get_reference());
    if (this.t3r_1) {
      this.c3r_1.s3v(1073741824);
    }
    var tmp = this.q3j();
    var observerHolder = (!(tmp == null) ? isInterface(tmp, ReusableRememberObserverHolder) : false) ? tmp : null;
    if (observerHolder == null) {
      observerHolder = new ReusableLinkRememberObserverHolder(new CompositionContextHolder_0(new CompositionContextImpl_0(this, this.p3r_1, this.q3q_1, this.k3r_1, this.g3q_1.i37_1)), get_NullAnchor());
      this.r3j(observerHolder);
    }
    var tmp_0 = observerHolder.h33();
    var holder = tmp_0 instanceof CompositionContextHolder_0 ? tmp_0 : THROW_CCE();
    holder.m3w_1.j3n(currentCompositionLocalScope_1(this));
    endGroup_0(this);
    return holder.m3w_1;
  };
  protoOf(LinkComposer).k31 = function (value) {
    var tmp;
    if (!equals(this.q3j(), value)) {
      this.r3j(value);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(LinkComposer).q31 = function (value) {
    var tmp;
    if (!(this.q3j() === value)) {
      this.r3j(value);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(LinkComposer).l31 = function (value) {
    var next = this.q3j();
    if (!(next == null) ? typeof next === 'boolean' : false) {
      var nextPrimitive = next;
      if (value === nextPrimitive)
        return false;
    }
    this.r3j(value);
    return true;
  };
  protoOf(LinkComposer).n31 = function (value) {
    var next = this.q3j();
    var tmp;
    if (!(next == null) ? typeof next === 'number' : false) {
      tmp = value === next;
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
      this.r3j(value);
      return true;
    }
  };
  protoOf(LinkComposer).o31 = function (value) {
    var next = this.q3j();
    var tmp;
    if (next instanceof Long) {
      tmp = value.equals(next);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
      this.r3j(value);
      return true;
    }
  };
  protoOf(LinkComposer).p31 = function (value) {
    var next = this.q3j();
    var tmp;
    if (!(next == null) ? typeof next === 'number' : false) {
      tmp = value === next;
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
      this.r3j(value);
      return true;
    }
  };
  protoOf(LinkComposer).m31 = function (value) {
    var next = this.q3j();
    var tmp;
    if (!(next == null) ? typeof next === 'number' : false) {
      tmp = equals(value, next);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
      this.r3j(value);
      return true;
    }
  };
  protoOf(LinkComposer).d33 = function (invalidationsRequested, content, shouldPause) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.d3q_1.r()) {
      var tmp$ret$1 = 'Expected applyChanges() to have been called';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.r3r_1 = shouldPause;
    try {
      doCompose_0(this, invalidationsRequested, content);
    }finally {
      this.r3r_1 = null;
    }
  };
  protoOf(LinkComposer).h3i = function () {
    var data = this.f3r_1;
    if (data == null) {
      var newData = new LinkCompositionDataImpl(this.g3q_1);
      this.f3r_1 = newData;
      return newData;
    }
    return data;
  };
  protoOf(LinkComposer).u31 = function (key) {
    return read(currentCompositionLocalScope_1(this), key);
  };
  protoOf(LinkComposer).c31 = function (factory) {
    validateNodeExpected_0(this);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.t3r_1) {
      var tmp$ret$1 = 'createNode() can only be called when inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var insertIndex = this.n3q_1.v3n();
    this.l3q_1 = this.l3q_1 + 1 | 0;
    var handle = this.c3r_1.z3u();
    if (this.e3r_1.r3w()) {
      var anchor = this.c3r_1.y3s_1.j3u_1.u3v(get_group(handle));
      this.h3r_1.q3w(factory, insertIndex, anchor);
    } else {
      this.h3r_1.p3w(factory, insertIndex, this.c3r_1.z3u());
    }
  };
  protoOf(LinkComposer).t31 = function () {
    return currentCompositionLocalScope_1(this);
  };
  protoOf(LinkComposer).z32 = function () {
    Stack__clear_impl_qoqv3c(this.m3r_1);
    ScopeMap__clear_impl_2jofm0(this.h3q_1);
    this.d3q_1.c3();
    this.v3q_1 = null;
  };
  protoOf(LinkComposer).a31 = function (changed) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.l3q_1 === 0)) {
      var tmp$ret$1 = 'No nodes can be emitted before calling deactivateToEndGroup';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    if (!this.t3r_1) {
      if (!changed) {
        skipReaderToGroupEnd_0(this);
        return Unit_instance;
      }
      this.e3r_1.t3o();
      this.b3r_1.z30();
    }
  };
  protoOf(LinkComposer).y32 = function () {
    this.c3q_1.s1d();
    this.a3q_1.x3b(this);
    this.z32();
    this.z3p_1.c3();
    this.o3r_1 = true;
  };
  protoOf(LinkComposer).r30 = function () {
    endGroup_0(this);
    var scope = this.r32();
    if (!(scope == null) && scope.b3l()) {
      scope.t3n(true);
    }
  };
  protoOf(LinkComposer).e31 = function () {
    return end_0(this, true);
  };
  protoOf(LinkComposer).y31 = function () {
    endGroup_0(this);
    endGroup_0(this);
    this.w3q_1 = asBool_0(this.x3q_1.k3j());
    this.a3r_1 = null;
  };
  protoOf(LinkComposer).w31 = function () {
    endGroup_0(this);
    endGroup_0(this);
    this.w3q_1 = asBool_0(this.x3q_1.k3j());
    this.a3r_1 = null;
  };
  protoOf(LinkComposer).l30 = function () {
    return endGroup_0(this);
  };
  protoOf(LinkComposer).t30 = function () {
    var scope = Stack__isNotEmpty_impl_ua6a9t(this.m3r_1) ? Stack__pop_impl_8s4za4(this.m3r_1) : null;
    if (!(scope == null)) {
      scope.g3m(false);
      var tmp0_safe_receiver = exitRecomposeScope_0(this, scope);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.e3r_1.u3o(tmp0_safe_receiver, this.g3q_1);
      }
      if (scope.r3o()) {
        scope.i3m(false);
        this.e3r_1.v3o(scope);
        scope.p3o(false);
        if (scope.w3o() && this.z3q_1 === this.b3r_1.k3s()) {
          scope.k3m(false);
          this.z3q_1 = -1;
          this.y3q_1 = false;
        }
      }
    }
    var tmp;
    if (!(scope == null) && !scope.x3o() && (scope.b3l() || this.q3q_1)) {
      if (scope.m35_1 == null) {
        var tmp_0 = scope;
        var tmp_1;
        if (this.t3r_1) {
          tmp_1 = this.c3r_1.s3w();
        } else {
          tmp_1 = this.b3r_1.s3w();
        }
        tmp_0.m35_1 = tmp_1;
      }
      scope.c3b(false);
      tmp = scope;
    } else {
      tmp = null;
    }
    var result = tmp;
    end_0(this, false);
    return result;
  };
  protoOf(LinkComposer).n30 = function () {
    return endGroup_0(this);
  };
  protoOf(LinkComposer).g31 = function () {
    if (this.y3q_1 && this.b3r_1.k3s() === this.z3q_1) {
      this.z3q_1 = -1;
      this.y3q_1 = false;
    }
    end_0(this, false);
  };
  protoOf(LinkComposer).w32 = function () {
    // Inline function 'kotlin.let' call
    var it = this.z3q_1;
    var reusingGroupKey = it < 0 ? 100 : this.b3r_1.t3j(it);
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(!this.n3r_1 && reusingGroupKey === 100)) {
      var tmp$ret$3 = 'Cannot disable reuse from root if it was caused by other groups';
      throwIllegalArgumentException(tmp$ret$3);
    }
    this.z3q_1 = -1;
    this.y3q_1 = false;
  };
  protoOf(LinkComposer).p30 = function () {
    return endGroup_0(this);
  };
  protoOf(LinkComposer).u30 = function (value, parameter) {
    invokeMovableContentLambda_0(this, value instanceof MovableContent ? value : THROW_CCE(), currentCompositionLocalScope_1(this), parameter, false);
  };
  protoOf(LinkComposer).v30 = function (references) {
    var completed = false;
    try {
      insertMovableContentGuarded_0(this, references);
      completed = true;
    }finally {
      if (completed) {
        cleanUpCompose_0(this);
      } else {
        abortRoot_0(this);
      }
    }
  };
  protoOf(LinkComposer).b33 = function () {
    var tmp = this.a3q_1.s3b();
    var tmp0_elvis_lhs = tmp instanceof CompositionImpl ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return emptyList();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var parentComposition = tmp_0;
    var position = findSubcompositionContextGroup(asLinkBufferSlotTable(parentComposition.u36_1), this.a3q_1);
    var tmp_1;
    if (!(position == null)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.read' call
      // Inline function 'kotlin.with' call
      var $this$with = asLinkBufferSlotTable(parentComposition.u36_1).d3i();
      var tmp_2;
      try {
        tmp_2 = traceForGroup($this$with, position, 0);
      }finally {
        $this$with.j4();
      }
      tmp_1 = plus_0(tmp_2, parentComposition.k37_1.b33());
    } else {
      tmp_1 = emptyList();
    }
    return tmp_1;
  };
  protoOf(LinkComposer).e33 = function (invalidationsRequested, shouldPause) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.d3q_1.r()) {
      var tmp$ret$1 = 'Expected applyChanges() to have been called';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    if (_ScopeMap___get_size__impl__f25bvl(invalidationsRequested) > 0 || ScopeMap__isNotEmpty_impl_w6zp9b(this.h3q_1) || (this.c3q_1.i3u_1 >= 0 && requiresRecomposition(this, this.c3q_1.i3u_1)) || this.r3q_1) {
      this.r3r_1 = shouldPause;
      try {
        this.e3r_1.t3w();
        doCompose_0(this, invalidationsRequested, null);
      }finally {
        this.r3r_1 = null;
      }
      if (asLinkBufferChangeList(this.d3q_1).u3w()) {
        return true;
      } else if (this.d3q_1.fv()) {
        executeChangesImmediatelyWithoutApplier(this);
      }
    }
    return false;
  };
  protoOf(LinkComposer).s31 = function (effect) {
    this.e3r_1.i3o(effect);
  };
  protoOf(LinkComposer).i31 = function () {
    return unwrapRememberObserverHolder(this, this.a3o());
  };
  protoOf(LinkComposer).r31 = function (parametersChanged, flags) {
    if ((flags & 1) === 0 && (this.t3r_1 || this.y3q_1)) {
      var tmp0_elvis_lhs = this.r3r_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return true;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var callback = tmp;
      var tmp1_elvis_lhs = this.r32();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return true;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var scope = tmp_0;
      var pausing = callback.o3o();
      if (pausing && !scope.r3o()) {
        scope.b3a(true);
        scope.p3o(this.y3q_1);
        scope.h3m(true);
        this.e3r_1.q3o(scope);
        this.a3q_1.v3b(scope);
        return false;
      }
      return true;
    }
    return parametersChanged || !this.i30();
  };
  protoOf(LinkComposer).z3m = function () {
    if (!requiresRecomposition(this, this.b3r_1.h3u())) {
      skipGroup_0(this);
    } else {
      var reader = this.b3r_1;
      var key = reader.k3k();
      var dataKey = reader.m3k();
      var aux = reader.w3j();
      var rGroupIndex = this.m3q_1;
      // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroup' call
      if (dataKey == null)
        if (!(aux == null) && key === 207 && !equals(aux, Companion_getInstance_0().f30_1)) {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
          var groupKey = hashCode(aux);
          var tmp = this;
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_0 = this.p3r_1;
          var tmp$ret$3 = rotateLeft(this_0, 3);
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_1 = bitwiseXor(tmp$ret$3, fromInt(groupKey));
          var tmp$ret$5 = rotateLeft(this_1, 3);
          tmp.p3r_1 = bitwiseXor(tmp$ret$5, fromInt(rGroupIndex));
        } else {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
          var tmp_0 = this;
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_2 = this.p3r_1;
          var tmp$ret$8 = rotateLeft(this_2, 3);
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_3 = bitwiseXor(tmp$ret$8, fromInt(key));
          var tmp$ret$10 = rotateLeft(this_3, 3);
          tmp_0.p3r_1 = bitwiseXor(tmp$ret$10, fromInt(rGroupIndex));
        }
       else {
        if (dataKey instanceof Enum) {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
          var groupKey_0 = dataKey.a1_1;
          var tmp_1 = this;
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_4 = this.p3r_1;
          var tmp$ret$13 = rotateLeft(this_4, 3);
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_5 = bitwiseXor(tmp$ret$13, fromInt(groupKey_0));
          var tmp$ret$15 = rotateLeft(this_5, 3);
          tmp_1.p3r_1 = bitwiseXor(tmp$ret$15, fromInt(0));
        } else {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
          var groupKey_1 = hashCode(dataKey);
          var tmp_2 = this;
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_6 = this.p3r_1;
          var tmp$ret$18 = rotateLeft(this_6, 3);
          // Inline function 'androidx.compose.runtime.compoundWith' call
          // Inline function 'androidx.compose.runtime.rol' call
          var this_7 = bitwiseXor(tmp$ret$18, fromInt(groupKey_1));
          var tmp$ret$20 = rotateLeft(this_7, 3);
          tmp_2.p3r_1 = bitwiseXor(tmp$ret$20, fromInt(0));
        }
      }
      startReaderGroup_0(this, reader.n3o(), null);
      recomposeToGroupEnd_0(this);
      reader.o3l();
      // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroup' call
      if (dataKey == null)
        if (!(aux == null) && key === 207 && !equals(aux, Companion_getInstance_0().f30_1)) {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_2 = hashCode(aux);
          var tmp_3 = this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_8 = this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_9 = bitwiseXor(this_8, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_10 = rotateLeft(this_9, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_11 = bitwiseXor(this_10, fromInt(groupKey_2));
          tmp_3.p3r_1 = rotateLeft(this_11, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var tmp_4 = this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_12 = this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_13 = bitwiseXor(this_12, fromInt(rGroupIndex));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_14 = rotateLeft(this_13, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_15 = bitwiseXor(this_14, fromInt(key));
          tmp_4.p3r_1 = rotateLeft(this_15, -3 | 0);
        }
       else {
        if (dataKey instanceof Enum) {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_3 = dataKey.a1_1;
          var tmp_5 = this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_16 = this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_17 = bitwiseXor(this_16, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_18 = rotateLeft(this_17, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_19 = bitwiseXor(this_18, fromInt(groupKey_3));
          tmp_5.p3r_1 = rotateLeft(this_19, -3 | 0);
        } else {
          // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeExitGroupKeyHash' call
          var groupKey_4 = hashCode(dataKey);
          var tmp_6 = this;
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_20 = this.p3r_1;
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_21 = bitwiseXor(this_20, fromInt(0));
          // Inline function 'androidx.compose.runtime.unCompoundWith' call
          var this_22 = rotateLeft(this_21, -3 | 0);
          // Inline function 'androidx.compose.runtime.ror' call
          // Inline function 'kotlin.rotateRight' call
          var this_23 = bitwiseXor(this_22, fromInt(groupKey_4));
          tmp_6.p3r_1 = rotateLeft(this_23, -3 | 0);
        }
      }
    }
  };
  protoOf(LinkComposer).z30 = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.l3q_1 === 0)) {
      var tmp$ret$1 = 'No nodes can be emitted before calling skipAndEndGroup';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    if (!this.t3r_1) {
      var tmp0_safe_receiver = this.r32();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.s3o();
      }
      if (this.b3r_1.h3u() < 0 || !requiresRecomposition(this, this.b3r_1.k3s())) {
        skipReaderToGroupEnd_0(this);
      } else {
        recomposeToGroupEnd_0(this);
      }
    }
  };
  protoOf(LinkComposer).w30 = function (sourceInformation) {
    if (this.t3r_1 && this.k3r_1) {
      this.c3r_1.y3o(sourceInformation);
    }
  };
  protoOf(LinkComposer).y30 = function () {
    if (this.t3r_1 && this.k3r_1) {
      this.c3r_1.a3p();
    }
  };
  protoOf(LinkComposer).x30 = function (key, sourceInformation) {
    if (this.t3r_1 && this.k3r_1) {
      this.c3r_1.z3o(key, sourceInformation);
    }
  };
  protoOf(LinkComposer).a33 = function (value) {
    if (!this.k3r_1)
      return new ComposeStackTrace(emptyList(), false);
    var tmp0_safe_receiver = findLocation_0(this.c3q_1, LinkComposer$stackTraceForValue$lambda(value));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var groupIndex = tmp0_safe_receiver.zh();
      var dataIndex = tmp0_safe_receiver.ai();
      tmp = plus_0(stackTraceForGroup_0(this, groupIndex, dataIndex), this.b33());
    }
    var tmp1_elvis_lhs = tmp;
    return new ComposeStackTrace(tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs, this.k3r_1);
  };
  protoOf(LinkComposer).q30 = function () {
    return start_0(this, -127, null, Companion_getInstance_7().n3j_1, null);
  };
  protoOf(LinkComposer).x31 = function (value) {
    var parentScope = currentCompositionLocalScope_1(this);
    startGroup_1(this, 201, get_provider());
    // Inline function 'kotlin.let' call
    var it = this.i31();
    var tmp;
    if (equals(it, Companion_getInstance_0().f30_1)) {
      tmp = null;
    } else {
      tmp = (!(it == null) ? isInterface(it, ValueHolder) : false) ? it : THROW_CCE();
    }
    var oldState = tmp;
    var tmp_0 = value.d32_1;
    var local = tmp_0 instanceof CompositionLocal ? tmp_0 : THROW_CCE();
    var state = local.j3c(value instanceof ProvidedValue ? value : THROW_CCE(), oldState);
    var change = !equals(state, oldState);
    if (change) {
      this.j31(state);
    }
    var providers;
    var invalid;
    if (this.t3r_1) {
      var tmp_1;
      if (value.k32_1 || !contains_2(parentScope, local)) {
        tmp_1 = parentScope.y3c(local, state);
      } else {
        tmp_1 = parentScope;
      }
      providers = tmp_1;
      invalid = false;
      this.d3r_1 = true;
    } else {
      var tmp_2 = this.b3r_1.s3j(this.b3r_1.h3u());
      var oldScope = (!(tmp_2 == null) ? isInterface(tmp_2, PersistentCompositionLocalMap) : false) ? tmp_2 : THROW_CCE();
      providers = (!this.i30() || change) && (value.k32_1 || !contains_2(parentScope, local)) ? parentScope.y3c(local, state) : !change && !this.w3q_1 ? oldScope : this.w3q_1 ? parentScope : oldScope;
      invalid = this.y3q_1 || !(oldScope === providers);
    }
    if (invalid && !this.t3r_1) {
      recordProviderUpdate_0(this, providers);
    }
    this.x3q_1.g3i(asInt_0(this.w3q_1));
    this.w3q_1 = invalid;
    this.a3r_1 = providers;
    start_0(this, 202, get_compositionLocalMap(), Companion_getInstance_7().n3j_1, providers);
  };
  protoOf(LinkComposer).v31 = function (values) {
    var parentScope = currentCompositionLocalScope_1(this);
    startGroup_1(this, 201, get_provider());
    var providers;
    var invalid;
    if (this.t3r_1) {
      var currentProviders = updateCompositionMap(values, parentScope);
      providers = updateProviderMapGroup_0(this, parentScope, currentProviders);
      invalid = false;
      this.d3r_1 = true;
    } else {
      var tmp = this.b3r_1.l1(0);
      var oldScope = (!(tmp == null) ? isInterface(tmp, PersistentCompositionLocalMap) : false) ? tmp : THROW_CCE();
      var tmp_0 = this.b3r_1.l1(1);
      var oldValues = (!(tmp_0 == null) ? isInterface(tmp_0, PersistentCompositionLocalMap) : false) ? tmp_0 : THROW_CCE();
      var currentProviders_0 = updateCompositionMap(values, parentScope, oldValues);
      if (!this.i30() || this.y3q_1 || !equals(oldValues, currentProviders_0)) {
        providers = updateProviderMapGroup_0(this, parentScope, currentProviders_0);
        invalid = this.y3q_1 || !equals(providers, oldScope);
      } else {
        skipGroup_0(this);
        providers = oldScope;
        invalid = false;
      }
    }
    if (invalid && !this.t3r_1) {
      recordProviderUpdate_0(this, providers);
    }
    this.x3q_1.g3i(asInt_0(this.w3q_1));
    this.w3q_1 = invalid;
    this.a3r_1 = providers;
    start_0(this, 202, get_compositionLocalMap(), Companion_getInstance_7().n3j_1, providers);
  };
  protoOf(LinkComposer).k30 = function (key) {
    return start_0(this, key, null, Companion_getInstance_7().n3j_1, null);
  };
  protoOf(LinkComposer).m30 = function (key) {
    var pending = this.j3q_1;
    if (!(pending == null)) {
      start_0(this, key, null, Companion_getInstance_7().n3j_1, null);
      return Unit_instance;
    }
    validateNodeNotExpected_0(this);
    // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroup' call
    var rGroupIndex = this.m3q_1;
    if (null == null)
      if (!(null == null) && key === 207 && !equals(null, Companion_getInstance_0().f30_1)) {
        // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey = hashCode(null);
        var tmp = this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_0 = this.p3r_1;
        var tmp$ret$3 = rotateLeft(this_0, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_1 = bitwiseXor(tmp$ret$3, fromInt(groupKey));
        var tmp$ret$5 = rotateLeft(this_1, 3);
        tmp.p3r_1 = bitwiseXor(tmp$ret$5, fromInt(rGroupIndex));
      } else {
        // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var tmp_0 = this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_2 = this.p3r_1;
        var tmp$ret$8 = rotateLeft(this_2, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_3 = bitwiseXor(tmp$ret$8, fromInt(key));
        var tmp$ret$10 = rotateLeft(this_3, 3);
        tmp_0.p3r_1 = bitwiseXor(tmp$ret$10, fromInt(rGroupIndex));
      }
     else {
      if (null instanceof Enum) {
        // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey_0 = null.a1_1;
        var tmp_1 = this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_4 = this.p3r_1;
        var tmp$ret$13 = rotateLeft(this_4, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_5 = bitwiseXor(tmp$ret$13, fromInt(groupKey_0));
        var tmp$ret$15 = rotateLeft(this_5, 3);
        tmp_1.p3r_1 = bitwiseXor(tmp$ret$15, fromInt(0));
      } else {
        // Inline function 'androidx.compose.runtime.LinkComposer.updateCompositeKeyWhenWeEnterGroupKeyHash' call
        var groupKey_1 = hashCode(null);
        var tmp_2 = this;
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_6 = this.p3r_1;
        var tmp$ret$18 = rotateLeft(this_6, 3);
        // Inline function 'androidx.compose.runtime.compoundWith' call
        // Inline function 'androidx.compose.runtime.rol' call
        var this_7 = bitwiseXor(tmp$ret$18, fromInt(groupKey_1));
        var tmp$ret$20 = rotateLeft(this_7, 3);
        tmp_2.p3r_1 = bitwiseXor(tmp$ret$20, fromInt(0));
      }
    }
    this.m3q_1 = this.m3q_1 + 1 | 0;
    var reader = this.b3r_1;
    if (this.t3r_1) {
      reader.z3j();
      var tmp0 = this.c3r_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startGroup' call
      var objectKey = Companion_getInstance_0().f30_1;
      access$startNewGroup(tmp0, key, objectKey === Companion_getInstance_0().f30_1 ? 0 : 16777216, objectKey, null, null);
      enterGroup_0(this, false, null);
      return Unit_instance;
    }
    var slotKey = reader.k3k();
    if (slotKey === key && !reader.s3n()) {
      reader.x3j();
      enterGroup_0(this, false, null);
      return Unit_instance;
    }
    if (!reader.l3l()) {
      var removeIndex = this.k3q_1;
      recordDelete_0(this);
      var nodesToRemove = reader.y35();
      this.e3r_1.c3l(removeIndex, nodesToRemove);
    }
    reader.z3j();
    this.t3r_1 = true;
    this.a3r_1 = null;
    ensureBuilder(this);
    var tmp0_0 = this.c3r_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startGroup' call
    var objectKey_0 = Companion_getInstance_0().f30_1;
    access$startNewGroup(tmp0_0, key, objectKey_0 === Companion_getInstance_0().f30_1 ? 0 : 16777216, objectKey_0, null, null);
    enterGroup_0(this, false, null);
  };
  protoOf(LinkComposer).s30 = function (key) {
    this.m30(key);
    addRecomposeScope_0(this);
    return this;
  };
  protoOf(LinkComposer).f31 = function (key, dataKey) {
    if (!this.t3r_1 && this.b3r_1.k3k() === key && !equals(this.b3r_1.w3j(), dataKey) && this.z3q_1 < 0) {
      this.z3q_1 = this.b3r_1.h3u();
      this.y3q_1 = true;
    }
    start_0(this, key, null, Companion_getInstance_7().n3j_1, dataKey);
  };
  protoOf(LinkComposer).b31 = function () {
    start_0(this, 125, null, Companion_getInstance_7().p3j_1, null);
    this.s3q_1 = true;
  };
  protoOf(LinkComposer).v32 = function () {
    this.z3q_1 = this.c3q_1.i3u_1;
    this.y3q_1 = true;
  };
  protoOf(LinkComposer).o30 = function (key, dataKey) {
    return start_0(this, key, dataKey, Companion_getInstance_7().n3j_1, null);
  };
  protoOf(LinkComposer).f33 = function (scope, instance) {
    var tmp0_elvis_lhs = scope.m35_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var anchor = tmp;
    var address = asLinkAnchor(anchor).m3v_1;
    if (address < 0 || !this.n3r_1)
      return false;
    // Inline function 'androidx.compose.runtime.toGroupHandle' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var tmp_0 = shiftLeft(fromInt(0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(address);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$3 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    var tmp$ret$0 = bitwiseOr(tmp_0, tmp$ret$3);
    if (isGroupAfterCurrentReaderPosition(this, tmp$ret$0)) {
      this.b3r_1.v3w(address, 67108864);
      if (instance == null || equals(instance, ScopeInvalidated_instance)) {
        ScopeMap__set_impl_3y8kbx(this.h3q_1, scope, ScopeInvalidated_instance);
      } else {
        if (instance instanceof ScatterSet) {
          ScopeMap__addAll_impl_5vhc63(this.h3q_1, scope, instance instanceof ScatterSet ? instance : THROW_CCE());
        } else {
          if (!equals(ScopeMap__get_impl_5bu0tb(this.h3q_1, scope), ScopeInvalidated_instance)) {
            ScopeMap__add_impl_n8b3uc(this.h3q_1, scope, instance);
          }
        }
      }
      return true;
    }
    return false;
  };
  protoOf(LinkComposer).g33 = function (invalidationsRequested) {
    // Inline function 'androidx.collection.ScatterMap.forEach' call
    var this_0 = _ScopeMap___get_map__impl__vxhazm(invalidationsRequested);
    var k = this_0.x12_1;
    var v = this_0.y12_1;
    $l$block_0: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = k[index];
                  var tmp2 = v[index];
                  $l$block: {
                    if (!(tmp0 instanceof RecomposeScopeImpl))
                      THROW_CCE();
                    var tmp0_safe_receiver = tmp0.m35_1;
                    var anchor = tmp0_safe_receiver == null ? null : asLinkAnchor(tmp0_safe_receiver);
                    if (anchor == null || !anchor.d2y()) {
                      break $l$block;
                    }
                    var address = anchor.m3v_1;
                    this.b3r_1.v3w(address, 67108864);
                    if (equals(tmp2, ScopeInvalidated_instance)) {
                      ScopeMap__set_impl_3y8kbx(this.h3q_1, tmp0, ScopeInvalidated_instance);
                    } else {
                      if (tmp2 instanceof MutableScatterSet) {
                        if (!(tmp2 instanceof MutableScatterSet))
                          THROW_CCE();
                        ScopeMap__addAll_impl_5vhc63(this.h3q_1, tmp0, tmp2);
                      } else {
                        ScopeMap__add_impl_n8b3uc(this.h3q_1, tmp0, tmp2);
                      }
                    }
                    this.b3r_1.v3w(address, 67108864);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i === lastIndex));
    }
  };
  protoOf(LinkComposer).j31 = function (value) {
    return this.g3o(value);
  };
  protoOf(LinkComposer).d31 = function () {
    validateNodeExpected_0(this);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.t3r_1) {
      var tmp$ret$1 = 'useNode() called while inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var node = this.b3r_1.w3w();
    this.e3r_1.c3m(node);
    var tmp;
    if (this.y3q_1) {
      tmp = !(node == null) ? isInterface(node, ComposeNodeLifecycleCallback) : false;
    } else {
      tmp = false;
    }
    if (tmp) {
      this.e3r_1.x3n(node);
    }
  };
  protoOf(LinkComposer).q3j = function () {
    var tmp;
    if (this.t3r_1) {
      validateNodeNotExpected_0(this);
      tmp = Companion_getInstance_0().f30_1;
    } else {
      // Inline function 'kotlin.let' call
      var it = this.b3r_1.v();
      var tmp_0;
      var tmp_1;
      if (this.y3q_1) {
        tmp_1 = !(!(it == null) ? isInterface(it, ReusableRememberObserverHolder) : false);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = Companion_getInstance_0().f30_1;
      } else {
        tmp_0 = it;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LinkComposer).a3o = function () {
    var tmp;
    if (this.t3r_1) {
      validateNodeNotExpected_0(this);
      tmp = Companion_getInstance_0().f30_1;
    } else {
      // Inline function 'kotlin.let' call
      var it = this.b3r_1.v();
      var tmp_0;
      var tmp_1;
      if (this.y3q_1) {
        tmp_1 = !(!(it == null) ? isInterface(it, ReusableRememberObserverHolder) : false);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = Companion_getInstance_0().f30_1;
      } else {
        if (!(it == null) ? isInterface(it, RememberObserverHolder) : false) {
          // Inline function 'kotlin.apply' call
          this.e3r_1.x3w(asLinkRememberObserverHolder(it), this.g3u().j3u_1.u3v(this.g3r_1));
          tmp_0 = it;
        } else {
          tmp_0 = it;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LinkComposer).r3j = function (value) {
    if (this.t3r_1) {
      this.c3r_1.b3x(value);
    } else {
      if (this.b3r_1.h3s_1) {
        this.e3r_1.a3x(this.b3r_1.z3w() - 1 | 0, value);
      } else {
        this.e3r_1.y3w(value);
      }
    }
  };
  protoOf(LinkComposer).x32 = function () {
    this.v3q_1 = null;
  };
  protoOf(LinkComposer).g3o = function (value) {
    var tmp;
    if (!(value == null) ? isInterface(value, RememberObserver) : false) {
      var holder = new LinkRememberObserverHolder(value, this.g3u().j3u_1.u3v(this.g3r_1));
      if (this.t3r_1) {
        this.e3r_1.h3o(holder);
      }
      this.b3q_1.j1(value);
      tmp = holder;
    } else {
      tmp = value;
    }
    var toStore = tmp;
    this.r3j(toStore);
  };
  function LinkPending$keyMap$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new MultiValueMap(multiMap_0(this$0.q3t_1.n1()));
      var it = this_0.e3p_1;
      var inductionVariable = 0;
      var last = this$0.q3t_1.n1();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var keyInfo = this$0.q3t_1.l1(index);
          MultiValueMap__add_impl_ww0640(it, keyInfo.c3x(), keyInfo);
        }
         while (inductionVariable < last);
      var tmp$ret$0 = this_0.e3p_1;
      return new MultiValueMap(tmp$ret$0);
    };
  }
  function LinkPending$_get_keyMap_$ref_6u4qws() {
    return constructCallableReference(function (p0) {
      return new MultiValueMap(p0.d3x());
    }, 1, 0, 14);
  }
  function LinkPending(keyInfos, startIndex) {
    this.q3t_1 = keyInfos;
    this.r3t_1 = startIndex;
    this.s3t_1 = 0;
    this.t3t_1 = new BitVector();
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(this.r3t_1 >= 0)) {
      var tmp$ret$1 = 'Invalid start index';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.u3t_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    var runningNodeIndex = 0;
    var result = new MutableIntObjectMap();
    var inductionVariable = 0;
    var last = this.q3t_1.n1();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var keyInfo = this.q3t_1.l1(index);
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.KeyInfo.address' call
        var tmp$ret$5 = get_group(keyInfo.a3u_1);
        result.ew(tmp$ret$5, new GroupInfo(index, runningNodeIndex, keyInfo.b3u_1));
        runningNodeIndex = runningNodeIndex + keyInfo.b3u_1 | 0;
      }
       while (inductionVariable < last);
    tmp_0.v3t_1 = result;
    var tmp_1 = this;
    tmp_1.w3t_1 = lazy(LinkPending$keyMap$delegate$lambda(this));
  }
  protoOf(LinkPending).d3x = function () {
    var tmp0 = this.w3t_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('keyMap', 1, tmp, LinkPending$_get_keyMap_$ref_6u4qws(), null);
    return tmp0.u1().e3p_1;
  };
  protoOf(LinkPending).n3k = function (key, dataKey) {
    var joinedKey = !(dataKey == null) ? new JoinedKey(key, dataKey) : key;
    return MultiValueMap__removeFirst_impl_iz2i9x(this.d3x(), joinedKey);
  };
  protoOf(LinkPending).h3w = function (keyInfo) {
    return this.u3t_1.j1(keyInfo);
  };
  protoOf(LinkPending).b3l = function () {
    return this.u3t_1;
  };
  protoOf(LinkPending).j3w = function () {
    return this.q3t_1.l1(this.t3t_1.h3x(0)).a3u_1;
  };
  protoOf(LinkPending).l3w = function (index) {
    this.t3t_1.i3x(index, true);
  };
  protoOf(LinkPending).w3k = function (from, to) {
    if (from > to) {
      // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
      var this_0 = this.v3t_1;
      var v = this_0.vv_1;
      $l$block: {
        // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
        var m = this_0.tv_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var group = v[index];
                    var position = group.g3p_1;
                    if (position === from)
                      group.g3p_1 = to;
                    else if (to <= position ? position < from : false)
                      group.g3p_1 = position + 1 | 0;
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    } else if (to > from) {
      // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
      var this_2 = this.v3t_1;
      var v_0 = this_2.vv_1;
      $l$block_0: {
        // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
        var m_0 = this_2.tv_1;
        var lastIndex_0 = m_0.length - 2 | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= lastIndex_0)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var slot_0 = m_0[i_0];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_3 = slot_0;
            var tmp$ret$8 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$8, new Long(-2139062144, -2139062144))) {
              var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < bitCount_0)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                  if (compare(value_0, new Long(128, 0)) < 0) {
                    var index_0 = (i_0 << 3) + j_0 | 0;
                    var group_0 = v_0[index_0];
                    var position_0 = group_0.g3p_1;
                    if (position_0 === from)
                      group_0.g3p_1 = to;
                    else if ((from + 1 | 0) <= position_0 ? position_0 < to : false)
                      group_0.g3p_1 = position_0 - 1 | 0;
                  }
                  slot_0 = shiftRight(slot_0, 8);
                }
                 while (inductionVariable_2 < bitCount_0);
              if (!(bitCount_0 === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i_0 === lastIndex_0));
      }
    }
  };
  protoOf(LinkPending).g3l = function (from, to, count) {
    if (from > to) {
      // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
      var this_0 = this.v3t_1;
      var v = this_0.vv_1;
      $l$block: {
        // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
        var m = this_0.tv_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var group = v[index];
                    var position = group.h3p_1;
                    if (from <= position ? position < (from + count | 0) : false)
                      group.h3p_1 = to + (position - from | 0) | 0;
                    else if (to <= position ? position < from : false)
                      group.h3p_1 = position + count | 0;
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    } else if (to > from) {
      // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
      var this_2 = this.v3t_1;
      var v_0 = this_2.vv_1;
      $l$block_0: {
        // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
        var m_0 = this_2.tv_1;
        var lastIndex_0 = m_0.length - 2 | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= lastIndex_0)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var slot_0 = m_0[i_0];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_3 = slot_0;
            var tmp$ret$8 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$8, new Long(-2139062144, -2139062144))) {
              var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < bitCount_0)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                  if (compare(value_0, new Long(128, 0)) < 0) {
                    var index_0 = (i_0 << 3) + j_0 | 0;
                    var group_0 = v_0[index_0];
                    var position_0 = group_0.h3p_1;
                    if (from <= position_0 ? position_0 < (from + count | 0) : false)
                      group_0.h3p_1 = to + (position_0 - from | 0) | 0;
                    else if ((from + 1 | 0) <= position_0 ? position_0 < to : false)
                      group_0.h3p_1 = position_0 - count | 0;
                  }
                  slot_0 = shiftRight(slot_0, 8);
                }
                 while (inductionVariable_2 < bitCount_0);
              if (!(bitCount_0 === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i_0 === lastIndex_0));
      }
    }
  };
  protoOf(LinkPending).g3w = function (keyInfo, insertIndex) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.KeyInfo.address' call
    var tmp$ret$0 = get_group(keyInfo.a3u_1);
    this.v3t_1.ew(tmp$ret$0, new GroupInfo(-1, insertIndex, 0));
  };
  protoOf(LinkPending).d3l = function (group, newCount) {
    var groupInfo = this.v3t_1.l1(group);
    if (!(groupInfo == null)) {
      var index = groupInfo.h3p_1;
      var difference = newCount - groupInfo.i3p_1 | 0;
      groupInfo.i3p_1 = newCount;
      if (!(difference === 0)) {
        // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
        var this_0 = this.v3t_1;
        var v = this_0.vv_1;
        $l$block: {
          // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
          var m = this_0.tv_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_1 = slot;
              var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index_0 = (i << 3) + j | 0;
                      var childGroupInfo = v[index_0];
                      if (childGroupInfo.h3p_1 >= index && !equals(childGroupInfo, groupInfo)) {
                        var newIndex = childGroupInfo.h3p_1 + difference | 0;
                        if (newIndex >= 0)
                          childGroupInfo.h3p_1 = newIndex;
                      }
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
      }
      return true;
    }
    return false;
  };
  protoOf(LinkPending).i3w = function (keyInfo) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.KeyInfo.address' call
    var tmp$ret$0 = get_group(keyInfo.a3u_1);
    var tmp0_safe_receiver = this.v3t_1.l1(tmp$ret$0);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g3p_1;
    return tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
  };
  protoOf(LinkPending).x3t = function (keyInfo) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.KeyInfo.address' call
    var tmp$ret$0 = get_group(keyInfo.a3u_1);
    var tmp0_safe_receiver = this.v3t_1.l1(tmp$ret$0);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h3p_1;
    return tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
  };
  protoOf(LinkPending).e3u = function (keyInfo) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.KeyInfo.address' call
    var tmp$ret$0 = get_group(keyInfo.a3u_1);
    var tmp0_safe_receiver = this.v3t_1.l1(tmp$ret$0);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i3p_1;
    return tmp1_elvis_lhs == null ? keyInfo.b3u_1 : tmp1_elvis_lhs;
  };
  function ReusableLinkRememberObserverHolder(wrapped, after) {
    LinkRememberObserverHolder.call(this, wrapped, after);
  }
  function LinkCompositionDataImpl(composition) {
    this.l3x_1 = composition;
  }
  protoOf(LinkCompositionDataImpl).hashCode = function () {
    return imul(hashCode(this.l3x_1), 31);
  };
  protoOf(LinkCompositionDataImpl).equals = function (other) {
    var tmp;
    if (other instanceof LinkCompositionDataImpl) {
      tmp = equals(this.l3x_1, other.l3x_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function asBool_0(_this__u8e3s4) {
    return !(_this__u8e3s4 === 0);
  }
  function findSubcompositionContextGroup(_this__u8e3s4, context) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.read' call
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.d3i();
    var tmp;
    try {
      var tmp2 = _this__u8e3s4.i3u_1;
      $l$block_0: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableReader.traverseChildrenConditionally' call
        var current = $this$with.v3v(tmp2);
        while (!(current === -1)) {
          var group = current;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
          var other = 1073741824;
          if ((other & _this__u8e3s4.m3x(group)) === other) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.forEachGroupSlot' call
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
            var slotRange = access$_get_groups__7d4n3r(_this__u8e3s4)[group + 5 | 0];
            if (!(slotRange === -1)) {
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
              var this_0 = _this__u8e3s4.j3u_1;
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
              var smallSize = (slotRange & 15) + 1 | 0;
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
              var address = slotRange >> 4;
              var tmp_0;
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
              if (smallSize > 15) {
                tmp_0 = access$_get_largeSizes__q41gto(this_0).l1(address);
              } else {
                tmp_0 = smallSize;
              }
              var size = tmp_0;
              $l$block: {
                var inductionVariable = 0;
                if (inductionVariable < size)
                  do {
                    var index = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var value = access$_get_slots__7x4q9w_0(_this__u8e3s4)[address + index | 0];
                    if (equals(value, Companion_getInstance_0().f30_1)) {
                      break $l$block;
                    }
                    var observerHolder = (!(value == null) ? isInterface(value, RememberObserverHolder) : false) ? value : null;
                    var wrapped = observerHolder == null ? null : observerHolder.h33();
                    var contextHolder = wrapped instanceof CompositionContextHolder_0 ? wrapped : null;
                    if (!(contextHolder == null) && equals(contextHolder.m3w_1, context)) {
                      return group;
                    }
                  }
                   while (inductionVariable < size);
              }
            }
          }
          var used = false;
          var firstChild = $this$with.v3v(current);
          var tmp_1;
          if (!used && !(firstChild === -1)) {
            var group_0 = current;
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
            var other_0 = -2147483648;
            tmp_1 = (other_0 & _this__u8e3s4.m3x(group_0)) === other_0;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            current = firstChild;
          } else {
            var next = $this$with.x3v(current);
            $l$loop: while (next === -1) {
              current = $this$with.l3v(current);
              if (current === -1 || current === tmp2) {
                break $l$block_0;
              }
              next = $this$with.x3v(current);
              if (next === -1)
                continue $l$loop;
            }
            current = next;
          }
        }
      }
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
    return null;
  }
  function asInt_0(_this__u8e3s4) {
    return _this__u8e3s4 ? 1 : 0;
  }
  function LinkRememberObserverHolder(wrapped, after) {
    this.j3x_1 = wrapped;
    this.k3x_1 = after;
  }
  protoOf(LinkRememberObserverHolder).h33 = function () {
    return this.j3x_1;
  };
  function asLinkRememberObserverHolder(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkRememberObserverHolder ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composition');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function getRecomposeScopeOrNull(_this__u8e3s4, group) {
    var tmp = _this__u8e3s4.n3x(group, 0);
    return tmp instanceof RecomposeScopeImpl ? tmp : null;
  }
  function toInsertAddress(_this__u8e3s4) {
    var tmp0 = get_context(_this__u8e3s4);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var group = -10 - get_group(_this__u8e3s4) | 0;
    var tmp = shiftLeft(fromInt(tmp0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$2 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    return bitwiseOr(tmp, tmp$ret$2);
  }
  function collectNodesFrom_0(_this__u8e3s4, group) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.read' call
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.d3i();
    var tmp;
    try {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableReader.traverseGroupPartially' call
      var tmp0 = access$_get_addressSpace__kppvvr($this$with);
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupPartially' call
        if (group < 0) {
          break $l$block;
        }
        var toVisit = new IntStack();
        var group_0 = group;
        var groups = tmp0.p3u_1;
        $l$loop: while (true) {
          var current = group_0;
          var tmp_0;
          if ($this$with.x34(current)) {
            result.j1($this$with.z34(current));
            tmp_0 = false;
          } else {
            tmp_0 = true;
          }
          var visitChildren = tmp_0;
          if (!(group_0 === group) || false) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
            var nextSibling = groups[group_0 + 1 | 0];
            if (nextSibling >= 0) {
              toVisit.g3i(nextSibling);
            }
          }
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
          var next = groups[group_0 + 3 | 0];
          if (visitChildren && next >= 0) {
            group_0 = next;
          } else {
            // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
            if (toVisit.f3i_1 === 0)
              break $l$loop;
            group_0 = toVisit.k3j();
          }
        }
      }
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
    return result;
  }
  function firstGroupInTopologicalOrder(_this__u8e3s4, a, b) {
    if (equalsLong(a, b))
      return a;
    var addressSpace = _this__u8e3s4.j3u_1;
    var groups = addressSpace.p3u_1;
    var tmp;
    if (get_group(a) === -1) {
      var tmp_0;
      if (get_group(b) === -1) {
        tmp_0 = get_context(a);
      } else {
        var tmp2 = get_context(a);
        var tmp4 = get_group(b);
        var tmp$ret$0;
        $l$block: {
          // Inline function 'androidx.compose.runtime.childOf' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
          var groups_0 = addressSpace.p3u_1;
          var tmp_1;
          if (!true) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
            tmp_1 = groups_0[tmp4 + 2 | 0];
          } else {
            tmp_1 = tmp4;
          }
          var current = tmp_1;
          while (current > 0) {
            if (current === tmp2) {
              tmp$ret$0 = true;
              break $l$block;
            }
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
            current = groups_0[current + 2 | 0];
          }
          // Inline function 'androidx.compose.runtime.runtimeCheck' call
          if (!!(current === 0)) {
            var tmp$ret$6 = 'Traversing parent of group not in the slot table: ' + tmp4;
            composeImmediateRuntimeError(tmp$ret$6);
          }
          tmp$ret$0 = false;
        }
        if (tmp$ret$0) {
          return b;
        } else {
          tmp_0 = get_context(a);
        }
      }
      tmp = tmp_0;
    } else {
      tmp = get_group(a);
    }
    var currentA = tmp;
    var tmp_2;
    if (get_group(b) === -1) {
      var tmp_3;
      if (get_group(a) === -1) {
        tmp_3 = get_context(b);
      } else {
        var tmp2_0 = get_context(b);
        var tmp4_0 = get_group(a);
        var tmp$ret$7;
        $l$block_0: {
          // Inline function 'androidx.compose.runtime.childOf' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
          var groups_1 = addressSpace.p3u_1;
          var tmp_4;
          if (!true) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
            tmp_4 = groups_1[tmp4_0 + 2 | 0];
          } else {
            tmp_4 = tmp4_0;
          }
          var current_0 = tmp_4;
          while (current_0 > 0) {
            if (current_0 === tmp2_0) {
              tmp$ret$7 = true;
              break $l$block_0;
            }
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
            current_0 = groups_1[current_0 + 2 | 0];
          }
          // Inline function 'androidx.compose.runtime.runtimeCheck' call
          if (!!(current_0 === 0)) {
            var tmp$ret$13 = 'Traversing parent of group not in the slot table: ' + tmp4_0;
            composeImmediateRuntimeError(tmp$ret$13);
          }
          tmp$ret$7 = false;
        }
        if (tmp$ret$7) {
          return a;
        } else {
          tmp_3 = get_context(b);
        }
      }
      tmp_2 = tmp_3;
    } else {
      tmp_2 = get_group(b);
    }
    var currentB = tmp_2;
    if (currentA === currentB)
      return a;
    var tmp_5;
    if (currentA === -1) {
      tmp_5 = -1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp_5 = groups[currentA + 2 | 0];
    }
    var aParent = tmp_5;
    var tmp_6;
    if (currentB === -1) {
      tmp_6 = -1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp_6 = groups[currentB + 2 | 0];
    }
    var bParent = tmp_6;
    if (aParent === currentB)
      return b;
    if (bParent === currentA)
      return a;
    if (!(aParent === bParent)) {
      var aDepth = addressSpace.o3x(currentA, _this__u8e3s4.i3u_1);
      var bDepth = addressSpace.o3x(currentB, _this__u8e3s4.i3u_1);
      if (aDepth > bDepth) {
        // Inline function 'kotlin.repeat' call
        var times = aDepth - bDepth | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            currentA = aParent;
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
            aParent = groups[aParent + 2 | 0];
          }
           while (inductionVariable < times);
        if (currentA === currentB)
          return b;
      } else {
        // Inline function 'kotlin.repeat' call
        var times_0 = bDepth - aDepth | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < times_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            currentB = bParent;
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
            bParent = groups[bParent + 2 | 0];
          }
           while (inductionVariable_0 < times_0);
        if (currentB === currentA)
          return a;
      }
      while (!(aParent === bParent)) {
        currentA = aParent;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        aParent = groups[aParent + 2 | 0];
        currentB = bParent;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        bParent = groups[bParent + 2 | 0];
      }
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(currentA === currentB)) {
      var tmp$ret$25 = 'Unexpected slot table structure';
      composeImmediateRuntimeError(tmp$ret$25);
    }
    var tmp0_subject = findFirstSibling(addressSpace, aParent, currentA, currentB);
    var tmp_7;
    if (tmp0_subject === currentA) {
      tmp_7 = a;
    } else if (tmp0_subject === currentB) {
      tmp_7 = b;
    } else {
      composeRuntimeError('Unexpected slot table structure');
    }
    return tmp_7;
  }
  function findInvalidations(_this__u8e3s4, group, invalidations) {
    var tmp;
    if (ScopeMap__isEmpty_impl_55kv6a(invalidations)) {
      tmp = emptyList();
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList_init_$Create$();
      // Inline function 'androidx.compose.runtime.buildScatterSet' call
      var mutableSet = mutableScatterSetOf();
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroup' call
      var tmp0 = _this__u8e3s4.x3r_1.j3u_1;
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroup' call
        if (group < 0) {
          break $l$block;
        }
        var toVisit = new IntStack();
        var group_0 = group;
        var groups = tmp0.p3u_1;
        $l$loop: while (true) {
          var group_1 = group_0;
          var tmp0_safe_receiver = getRecomposeScopeOrNull(_this__u8e3s4, group_1);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            mutableSet.j1(tmp0_safe_receiver);
          }
          if (!(group_0 === group) || false) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
            var nextSibling = groups[group_0 + 1 | 0];
            if (nextSibling >= 0) {
              toVisit.g3i(nextSibling);
            }
          }
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
          var next = groups[group_0 + 3 | 0];
          if (next >= 0) {
            group_0 = next;
          } else {
            // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
            if (toVisit.f3i_1 === 0)
              break $l$loop;
            group_0 = toVisit.k3j();
          }
        }
      }
      var movableRecomposeScopes = mutableSet;
      // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEach' call
      // Inline function 'androidx.collection.ScatterMap.forEach' call
      var this_1 = _ScopeMap___get_map__impl__vxhazm(invalidations);
      var k = this_1.x12_1;
      var v = this_1.y12_1;
      $l$block_0: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = this_1.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_2 = slot;
            var tmp$ret$17 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$17, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var tmp0_0 = k[index];
                    var value_0 = v[index];
                    var recomposeScope = !(tmp0_0 == null) ? tmp0_0 : THROW_CCE();
                    if (movableRecomposeScopes.m1(recomposeScope)) {
                      this_0.j1(to(recomposeScope, value_0));
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i === lastIndex));
      }
      tmp = this_0.t5();
    }
    return tmp;
  }
  function get_isInsertHandle(_this__u8e3s4) {
    return get_group(_this__u8e3s4) < -8;
  }
  function asLinkComposer(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkComposer ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composition');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function multiMap_0(initialCapacity) {
    return _MultiValueMap___init__impl__qt1z0r(new MutableScatterMap(initialCapacity));
  }
  function findFirstSibling(_this__u8e3s4, parent, a, b) {
    if (a === -1)
      return b;
    if (b === -1)
      return a;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseChildren' call
    var groups = _this__u8e3s4.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    var current = groups[parent + 3 | 0];
    while (current > 0) {
      var group = current;
      if (group === a)
        return a;
      if (group === b)
        return b;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      current = groups[current + 1 | 0];
    }
    composeRuntimeError('Unexpected slot table structure');
  }
  function withFrameNanos(onFrame, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.t9();
    return get_monotonicFrameClock(tmp$ret$0).r2z(onFrame, $completion);
  }
  function Key_0() {
  }
  var Key_instance_2;
  function Key_getInstance_0() {
    return Key_instance_2;
  }
  function MonotonicFrameClock() {
  }
  function get_monotonicFrameClock(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4.aa(Key_instance_2);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'A MonotonicFrameClock is not available in this CoroutineContext. Callers should supply an appropriate MonotonicFrameClock using withContext.';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function withFrameMillis(onFrame, $completion) {
    var tmp = new $withFrameMillisCOROUTINE$(onFrame, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function withFrameMillis$lambda($onFrame) {
    return function (it) {
      return $onFrame(divide(it, new Long(1000000, 0)));
    };
  }
  function $withFrameMillisCOROUTINE$(onFrame, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x3x_1 = onFrame;
  }
  protoOf($withFrameMillisCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = get_monotonicFrameClock(this.t9());
            var onFrame = this.x3x_1;
            this.n9_1 = 1;
            suspendResult = tmp0.r2z(withFrameMillis$lambda(onFrame), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var androidx_compose_runtime_MovableContent$stable;
  var androidx_compose_runtime_MovableContentStateReference$stable;
  var androidx_compose_runtime_MovableContentState$stable;
  function movableContentOf(content) {
    var movableContent = new MovableContent(ComposableLambda$invoke$ref_0(composableLambdaInstance(-703201834, true, movableContentOf$lambda(content))));
    return ComposableLambda$invoke$ref(composableLambdaInstance(-328108779, true, movableContentOf$lambda_0(movableContent)));
  }
  function MovableContent(content) {
    this.l3n_1 = content;
  }
  function MovableContentStateReference(content, parameter, composition, slotStorage, anchor, invalidations, locals, nestedReferences) {
    this.c35_1 = content;
    this.d35_1 = parameter;
    this.e35_1 = composition;
    this.f35_1 = slotStorage;
    this.g35_1 = anchor;
    this.h35_1 = invalidations;
    this.i35_1 = locals;
    this.j35_1 = nestedReferences;
  }
  protoOf(MovableContentStateReference).p3v = function () {
    if (this.g35_1.d2y()) {
      var tmp = this;
      var tmp_0 = this.h35_1;
      var tmp_1 = this.e35_1;
      tmp.h35_1 = plus_0(tmp_0, (tmp_1 instanceof CompositionImpl ? tmp_1 : THROW_CCE()).z39(this.g35_1));
    }
  };
  function MovableContentState(slotStorage) {
    this.u3a_1 = slotStorage;
  }
  protoOf(MovableContentState).y32 = function () {
    this.u3a_1.s1d();
  };
  function movableContentOf_0(content) {
    var movableContent = new MovableContent(content);
    return ComposableLambda$invoke$ref_1(composableLambdaInstance(1032736913, true, movableContentOf$lambda_1(movableContent)));
  }
  function movableContentOf$lambda($content) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      $content($composer_0, 0);
      return Unit_instance;
    };
  }
  function movableContentOf$lambda_0($movableContent) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        $composer_0.u30($movableContent, null);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function movableContentOf$lambda_1($movableContent) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(it) : $composer_0.q31(it)) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        $composer_0.u30($movableContent, it);
        tmp_0 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  var androidx_compose_runtime_NextFrameEndCallbackQueue$stable;
  function NextFrameEndCallbackQueue$onNewAwaiters$lambda(this$0, $onNewAwaiters) {
    return function () {
      if (!AtomicBoolean__get_impl_fnomyc(this$0.y3x_1))
        $onNewAwaiters();
      return Unit_instance;
    };
  }
  function NextFrameEndCallbackQueue$markFrameComplete$lambda(it) {
    it.c3y();
    return Unit_instance;
  }
  function NextFrameEndCallbackQueue(onNewAwaiters) {
    this.y3x_1 = _AtomicBoolean___init__impl__fuqz3w_0(false);
    this.z3x_1 = new AwaiterQueue();
    var tmp = this;
    tmp.a3y_1 = NextFrameEndCallbackQueue$onNewAwaiters$lambda(this, onNewAwaiters);
  }
  protoOf(NextFrameEndCallbackQueue).j2z = function () {
    return this.z3x_1.j2z();
  };
  protoOf(NextFrameEndCallbackQueue).d3y = function () {
    AtomicBoolean__set_impl_6dm1t4(this.y3x_1, false);
    this.z3x_1.q2z(NextFrameEndCallbackQueue$markFrameComplete$lambda);
  };
  var androidx_compose_runtime_OpaqueKey$stable;
  function OpaqueKey(key) {
    this.e3y_1 = key;
  }
  protoOf(OpaqueKey).toString = function () {
    return 'OpaqueKey(key=' + this.e3y_1 + ')';
  };
  protoOf(OpaqueKey).hashCode = function () {
    return getStringHashCode(this.e3y_1);
  };
  protoOf(OpaqueKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OpaqueKey))
      return false;
    if (!(this.e3y_1 === other.e3y_1))
      return false;
    return true;
  };
  var androidx_compose_runtime_PausedCompositionImpl$stable;
  var androidx_compose_runtime_RecordingApplier$stable;
  function PausableComposition() {
  }
  function ShouldPauseCallback() {
  }
  function PausableComposition_0(applier, parent) {
    return new CompositionImpl(parent, applier);
  }
  function markComplete($this) {
    var tmp2 = PausedCompositionState_RecomposePending_getInstance();
    // Inline function 'androidx.compose.runtime.PausedCompositionImpl.updateState' call
    var to = PausedCompositionState_ApplyPending_getInstance();
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!$this.m38_1.w21(tmp2, to)) {
      var tmp$ret$2 = 'Unexpected state change from: ' + tmp2.toString() + ' to: ' + to.toString() + '.';
      throwIllegalStateException(tmp$ret$2);
    }
  }
  function applyChanges($this) {
    var tmp0 = 'PausedComposition:applyChanges';
    $l$block: {
      // Inline function 'androidx.compose.runtime.internal.trace' call
      var token = Trace_instance.r38(tmp0);
      try {
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        $this.l38_1;
        try {
          var tmp = $this.k38_1;
          $this.q38_1.f3y(isInterface(tmp, Applier) ? tmp : THROW_CCE(), $this.p38_1);
          $this.p38_1.u38();
          $this.p38_1.v38();
        }finally {
          $this.p38_1.w38();
          $this.f38_1.o39(null);
        }
        break $l$block;
      }finally {
        Trace_instance.t38(token);
      }
    }
  }
  function PausedCompositionImpl(composition, context, composer, abandonSet, content, reusable, applier, lock) {
    this.f38_1 = composition;
    this.g38_1 = context;
    this.h38_1 = composer;
    this.i38_1 = content;
    this.j38_1 = reusable;
    this.k38_1 = applier;
    this.l38_1 = lock;
    this.m38_1 = new AtomicReference(PausedCompositionState_InitialPending_getInstance());
    this.n38_1 = currentThreadId();
    this.o38_1 = emptyScatterSet();
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new RememberEventDispatcher();
    this_0.e38(abandonSet, this.h38_1.s32());
    tmp.p38_1 = this_0;
    this.q38_1 = new RecordingApplier(this.k38_1.e2y());
  }
  protoOf(PausedCompositionImpl).r3a = function () {
    return this.m38_1.f1i().equals(PausedCompositionState_Recomposing_getInstance()) && equalsLong(this.n38_1, currentThreadId());
  };
  protoOf(PausedCompositionImpl).g3y = function () {
    return this.m38_1.f1i().i3(PausedCompositionState_ApplyPending_getInstance()) >= 0;
  };
  protoOf(PausedCompositionImpl).h3y = function (shouldPause) {
    try {
      switch (this.m38_1.f1i().a1_1) {
        case 2:
          if (this.j38_1) {
            this.h38_1.v32();
          }

          try {
            this.o38_1 = this.g38_1.t3b(this.f38_1, shouldPause, this.i38_1);
          }finally {
            if (this.j38_1) {
              this.h38_1.w32();
            }
          }

          var tmp2 = PausedCompositionState_InitialPending_getInstance();
          // Inline function 'androidx.compose.runtime.PausedCompositionImpl.updateState' call

          var to = PausedCompositionState_RecomposePending_getInstance();
          // Inline function 'androidx.compose.runtime.checkPrecondition' call

          if (!this.m38_1.w21(tmp2, to)) {
            var tmp$ret$2 = 'Unexpected state change from: ' + tmp2.toString() + ' to: ' + to.toString() + '.';
            throwIllegalStateException(tmp$ret$2);
          }

          if (this.o38_1.r()) {
            markComplete(this);
          }

          break;
        case 3:
          var tmp2_0 = PausedCompositionState_RecomposePending_getInstance();
          // Inline function 'androidx.compose.runtime.PausedCompositionImpl.updateState' call

          var to_0 = PausedCompositionState_Recomposing_getInstance();
          // Inline function 'androidx.compose.runtime.checkPrecondition' call

          if (!this.m38_1.w21(tmp2_0, to_0)) {
            var tmp$ret$5 = 'Unexpected state change from: ' + tmp2_0.toString() + ' to: ' + to_0.toString() + '.';
            throwIllegalStateException(tmp$ret$5);
          }

          var previousOwner = this.n38_1;
          try {
            this.n38_1 = currentThreadId();
            this.o38_1 = this.g38_1.u3b(this.f38_1, shouldPause, this.o38_1);
          }finally {
            this.n38_1 = previousOwner;
            var tmp2_1 = PausedCompositionState_Recomposing_getInstance();
            // Inline function 'androidx.compose.runtime.PausedCompositionImpl.updateState' call
            var to_1 = PausedCompositionState_RecomposePending_getInstance();
            // Inline function 'androidx.compose.runtime.checkPrecondition' call
            if (!this.m38_1.w21(tmp2_1, to_1)) {
              var tmp$ret$8 = 'Unexpected state change from: ' + tmp2_1.toString() + ' to: ' + to_1.toString() + '.';
              throwIllegalStateException(tmp$ret$8);
            }
          }

          if (this.o38_1.r()) {
            markComplete(this);
          }

          break;
        case 4:
          composeRuntimeError('Recursive call to resume()');
          break;
        case 5:
          // Inline function 'kotlin.error' call

          var message = 'Pausable composition is complete and apply() should be applied';
          throw IllegalStateException_init_$Create$(toString(message));
        case 6:
          // Inline function 'kotlin.error' call

          var message_0 = 'The paused composition has been applied';
          throw IllegalStateException_init_$Create$(toString(message_0));
        case 1:
          // Inline function 'kotlin.error' call

          var message_1 = 'The paused composition has been cancelled';
          throw IllegalStateException_init_$Create$(toString(message_1));
        case 0:
          // Inline function 'kotlin.error' call

          var message_2 = 'The paused composition is invalid because of a previous exception';
          throw IllegalStateException_init_$Create$(toString(message_2));
        default:
          noWhenBranchMatchedException();
          break;
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        this.m38_1.k2p(PausedCompositionState_Invalid_getInstance());
        throw e;
      } else {
        throw $p;
      }
    }
    return this.g3y();
  };
  protoOf(PausedCompositionImpl).i3y = function () {
    try {
      switch (this.m38_1.f1i().a1_1) {
        case 2:
        case 3:
        case 4:
          // Inline function 'kotlin.error' call

          var message = 'The paused composition has not completed yet';
          throw IllegalStateException_init_$Create$(toString(message));
        case 5:
          applyChanges(this);
          var tmp2 = PausedCompositionState_ApplyPending_getInstance();
          // Inline function 'androidx.compose.runtime.PausedCompositionImpl.updateState' call

          var to = PausedCompositionState_Applied_getInstance();
          // Inline function 'androidx.compose.runtime.checkPrecondition' call

          if (!this.m38_1.w21(tmp2, to)) {
            var tmp$ret$3 = 'Unexpected state change from: ' + tmp2.toString() + ' to: ' + to.toString() + '.';
            throwIllegalStateException(tmp$ret$3);
          }

          break;
        case 6:
          // Inline function 'kotlin.error' call

          var message_0 = 'The paused composition has already been applied';
          throw IllegalStateException_init_$Create$(toString(message_0));
        case 1:
          // Inline function 'kotlin.error' call

          var message_1 = 'The paused composition has been cancelled';
          throw IllegalStateException_init_$Create$(toString(message_1));
        case 0:
          // Inline function 'kotlin.error' call

          var message_2 = 'The paused composition is invalid because of a previous exception';
          throw IllegalStateException_init_$Create$(toString(message_2));
        default:
          noWhenBranchMatchedException();
          break;
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        this.m38_1.k2p(PausedCompositionState_Invalid_getInstance());
        throw e;
      } else {
        throw $p;
      }
    }
  };
  protoOf(PausedCompositionImpl).e2z = function () {
    this.m38_1.k2p(PausedCompositionState_Cancelled_getInstance());
    var ignoreSet = this.p38_1.j3y();
    this.p38_1.w38();
    this.f38_1.o39(ignoreSet);
  };
  protoOf(PausedCompositionImpl).m3a = function () {
    this.m38_1.w21(PausedCompositionState_ApplyPending_getInstance(), PausedCompositionState_RecomposePending_getInstance());
  };
  function Companion_4() {
    this.k3y_1 = 0;
    this.l3y_1 = 1;
    this.m3y_1 = 2;
    this.n3y_1 = 3;
    this.o3y_1 = 4;
    this.p3y_1 = 5;
    this.q3y_1 = 6;
    this.r3y_1 = 7;
    this.s3y_1 = 8;
    this.t3y_1 = 9;
  }
  var Companion_instance_5;
  function Companion_getInstance_4() {
    return Companion_instance_5;
  }
  function RecordingApplier(root) {
    var tmp = this;
    // Inline function 'androidx.collection.mutableIntListOf' call
    tmp.n3a_1 = new MutableIntList();
    var tmp_0 = this;
    // Inline function 'androidx.collection.mutableObjectListOf' call
    tmp_0.o3a_1 = new MutableObjectList();
    this.p3a_1 = root;
  }
  protoOf(RecordingApplier).e2y = function () {
    return this.p3a_1;
  };
  protoOf(RecordingApplier).h2y = function (node) {
    this.n3a_1.pv(1);
    this.o3a_1.j1(node);
  };
  protoOf(RecordingApplier).i2y = function () {
    this.n3a_1.pv(0);
  };
  protoOf(RecordingApplier).l2y = function (index, count) {
    this.n3a_1.pv(2);
    this.n3a_1.pv(index);
    this.n3a_1.pv(count);
  };
  protoOf(RecordingApplier).m2y = function (from, to, count) {
    this.n3a_1.pv(3);
    this.n3a_1.pv(from);
    this.n3a_1.pv(to);
    this.n3a_1.pv(count);
  };
  protoOf(RecordingApplier).c3 = function () {
    this.n3a_1.pv(4);
  };
  protoOf(RecordingApplier).k2y = function (index, instance) {
    this.n3a_1.pv(5);
    this.n3a_1.pv(index);
    this.o3a_1.j1(instance);
  };
  protoOf(RecordingApplier).j2y = function (index, instance) {
    this.n3a_1.pv(6);
    this.n3a_1.pv(index);
    this.o3a_1.j1(instance);
  };
  protoOf(RecordingApplier).n2y = function (block, value) {
    this.n3a_1.pv(7);
    this.o3a_1.j1(block);
    this.o3a_1.j1(value);
  };
  protoOf(RecordingApplier).o2y = function () {
    this.n3a_1.pv(8);
  };
  protoOf(RecordingApplier).f3y = function (applier, rememberManager) {
    var currentOperation = 0;
    var currentInstance = 0;
    var operations = this.n3a_1;
    // Inline function 'androidx.collection.IntList.size' call
    var size = operations.jv_1;
    var instances = this.o3a_1;
    // Inline function 'androidx.collection.mutableObjectListOf' call
    var reused = new MutableObjectList();
    applier.f2y();
    try {
      while (currentOperation < size) {
        var _unary__edvuaz = currentOperation;
        currentOperation = _unary__edvuaz + 1 | 0;
        var operation = operations.l1(_unary__edvuaz);
        switch (operation) {
          case 0:
            applier.i2y();
            break;
          case 1:
            var _unary__edvuaz_0 = currentInstance;
            currentInstance = _unary__edvuaz_0 + 1 | 0;
            var node = instances.l1(_unary__edvuaz_0);
            applier.h2y(node);
            break;
          case 2:
            var _unary__edvuaz_1 = currentOperation;
            currentOperation = _unary__edvuaz_1 + 1 | 0;
            var index = operations.l1(_unary__edvuaz_1);
            var _unary__edvuaz_2 = currentOperation;
            currentOperation = _unary__edvuaz_2 + 1 | 0;
            var count = operations.l1(_unary__edvuaz_2);
            applier.l2y(index, count);
            break;
          case 3:
            var _unary__edvuaz_3 = currentOperation;
            currentOperation = _unary__edvuaz_3 + 1 | 0;
            var from = operations.l1(_unary__edvuaz_3);
            var _unary__edvuaz_4 = currentOperation;
            currentOperation = _unary__edvuaz_4 + 1 | 0;
            var to = operations.l1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = currentOperation;
            currentOperation = _unary__edvuaz_5 + 1 | 0;
            var count_0 = operations.l1(_unary__edvuaz_5);
            applier.m2y(from, to, count_0);
            break;
          case 4:
            applier.c3();
            break;
          case 6:
            var _unary__edvuaz_6 = currentOperation;
            currentOperation = _unary__edvuaz_6 + 1 | 0;
            var index_0 = operations.l1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = currentInstance;
            currentInstance = _unary__edvuaz_7 + 1 | 0;
            var instance = instances.l1(_unary__edvuaz_7);
            applier.j2y(index_0, instance);
            break;
          case 5:
            var _unary__edvuaz_8 = currentOperation;
            currentOperation = _unary__edvuaz_8 + 1 | 0;
            var index_1 = operations.l1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = currentInstance;
            currentInstance = _unary__edvuaz_9 + 1 | 0;
            var instance_0 = instances.l1(_unary__edvuaz_9);
            applier.k2y(index_1, instance_0);
            break;
          case 7:
            var _unary__edvuaz_10 = currentInstance;
            currentInstance = _unary__edvuaz_10 + 1 | 0;
            var tmp = instances.l1(_unary__edvuaz_10);
            var block = (!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE();
            var _unary__edvuaz_11 = currentInstance;
            currentInstance = _unary__edvuaz_11 + 1 | 0;
            var value = instances.l1(_unary__edvuaz_11);
            applier.n2y(block, value);
            break;
          case 8:
            var current = applier.e2y();
            if (!(current == null) ? isInterface(current, ComposeNodeLifecycleCallback) : false) {
              rememberManager.u3y(current);
            }

            reused.j1(current);
            applier.o2y();
            break;
        }
      }
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(currentInstance === instances.n1())) {
        var tmp$ret$3 = 'Applier operation size mismatch';
        composeImmediateRuntimeError(tmp$ret$3);
      }
      instances.c3();
      operations.c3();
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        throw new ComposePausableCompositionException(instances, reused, operations, currentOperation - 1 | 0, e);
      } else {
        throw $p;
      }
    }
    finally {
      applier.g2y();
    }
  };
  protoOf(RecordingApplier).q3a = function () {
    this.n3a_1.pv(9);
  };
  var PausedCompositionState_Invalid_instance;
  var PausedCompositionState_Cancelled_instance;
  var PausedCompositionState_InitialPending_instance;
  var PausedCompositionState_RecomposePending_instance;
  var PausedCompositionState_Recomposing_instance;
  var PausedCompositionState_ApplyPending_instance;
  var PausedCompositionState_Applied_instance;
  var PausedCompositionState_entriesInitialized;
  function PausedCompositionState_initEntries() {
    if (PausedCompositionState_entriesInitialized)
      return Unit_instance;
    PausedCompositionState_entriesInitialized = true;
    PausedCompositionState_Invalid_instance = new PausedCompositionState('Invalid', 0);
    PausedCompositionState_Cancelled_instance = new PausedCompositionState('Cancelled', 1);
    PausedCompositionState_InitialPending_instance = new PausedCompositionState('InitialPending', 2);
    PausedCompositionState_RecomposePending_instance = new PausedCompositionState('RecomposePending', 3);
    PausedCompositionState_Recomposing_instance = new PausedCompositionState('Recomposing', 4);
    PausedCompositionState_ApplyPending_instance = new PausedCompositionState('ApplyPending', 5);
    PausedCompositionState_Applied_instance = new PausedCompositionState('Applied', 6);
  }
  function PausedCompositionState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function operationsSequence($this) {
    return sequence(ComposePausableCompositionException$operationsSequence$slambda_0($this, null));
  }
  function ComposePausableCompositionException$operationsSequence$slambda(this$0, resultContinuation) {
    this.d3z_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposePausableCompositionException$operationsSequence$slambda).i3z = function ($this$sequence, $completion) {
    var tmp = this.j3z($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposePausableCompositionException$operationsSequence$slambda).ja = function (p1, $completion) {
    return this.i3z(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposePausableCompositionException$operationsSequence$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.h3z_1 = 0;
            this.g3z_1 = 0;
            this.f3z_1 = 0;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this.h3z_1;
            var tmp0 = this.d3z_1.n3z_1 + 10 | 0;
            var b = this.d3z_1.m3z_1.jv_1;
            if (!(tmp_0 < Math.min(tmp0, b))) {
              this.n9_1 = 3;
              continue $sm;
            }

            var index = this.h3z_1;
            var _unary__edvuaz = this.h3z_1;
            this.h3z_1 = _unary__edvuaz + 1 | 0;
            var operation = this.d3z_1.m3z_1.l1(_unary__edvuaz);
            var tmp_1;
            switch (operation) {
              case 0:
                tmp_1 = 'up';
                break;
              case 1:
                var _unary__edvuaz_0 = this.g3z_1;
                this.g3z_1 = _unary__edvuaz_0 + 1 | 0;
                var node = this.d3z_1.k3z_1.l1(_unary__edvuaz_0);
                tmp_1 = 'down ' + toString_0(node);
                break;
              case 2:
                var _unary__edvuaz_1 = this.h3z_1;
                this.h3z_1 = _unary__edvuaz_1 + 1 | 0;
                var index_0 = this.d3z_1.m3z_1.l1(_unary__edvuaz_1);
                var _unary__edvuaz_2 = this.h3z_1;
                this.h3z_1 = _unary__edvuaz_2 + 1 | 0;
                var count = this.d3z_1.m3z_1.l1(_unary__edvuaz_2);
                tmp_1 = 'remove ' + index_0 + ' ' + count;
                break;
              case 3:
                var _unary__edvuaz_3 = this.h3z_1;
                this.h3z_1 = _unary__edvuaz_3 + 1 | 0;
                var from = this.d3z_1.m3z_1.l1(_unary__edvuaz_3);
                var _unary__edvuaz_4 = this.h3z_1;
                this.h3z_1 = _unary__edvuaz_4 + 1 | 0;
                var to = this.d3z_1.m3z_1.l1(_unary__edvuaz_4);
                var _unary__edvuaz_5 = this.h3z_1;
                this.h3z_1 = _unary__edvuaz_5 + 1 | 0;
                var count_0 = this.d3z_1.m3z_1.l1(_unary__edvuaz_5);
                tmp_1 = 'move ' + from + ' ' + to + ' ' + count_0;
                break;
              case 4:
                tmp_1 = 'clear';
                break;
              case 6:
                var _unary__edvuaz_6 = this.h3z_1;
                this.h3z_1 = _unary__edvuaz_6 + 1 | 0;
                var index_1 = this.d3z_1.m3z_1.l1(_unary__edvuaz_6);
                var _unary__edvuaz_7 = this.g3z_1;
                this.g3z_1 = _unary__edvuaz_7 + 1 | 0;
                var instance = this.d3z_1.k3z_1.l1(_unary__edvuaz_7);
                tmp_1 = 'insertTopDown ' + index_1 + ' ' + toString_0(instance);
                break;
              case 5:
                var _unary__edvuaz_8 = this.h3z_1;
                this.h3z_1 = _unary__edvuaz_8 + 1 | 0;
                var index_2 = this.d3z_1.m3z_1.l1(_unary__edvuaz_8);
                var _unary__edvuaz_9 = this.g3z_1;
                this.g3z_1 = _unary__edvuaz_9 + 1 | 0;
                var instance_0 = this.d3z_1.k3z_1.l1(_unary__edvuaz_9);
                tmp_1 = 'insertBottomUp ' + index_2 + ' ' + toString_0(instance_0);
                break;
              case 7:
                var _unary__edvuaz_10 = this.g3z_1;
                this.g3z_1 = _unary__edvuaz_10 + 1 | 0;
                var tmp_2 = this.d3z_1.k3z_1.l1(_unary__edvuaz_10);
                var block = (!(tmp_2 == null) ? typeof tmp_2 === 'function' : false) ? tmp_2 : THROW_CCE();
                this.g3z_1 = this.g3z_1 + 1 | 0;
                tmp_1 = 'apply ' + toString(block);
                break;
              case 8:
                var _unary__edvuaz_11 = this.f3z_1;
                this.f3z_1 = _unary__edvuaz_11 + 1 | 0;
                tmp_1 = 'reuse ' + toString_0(this.d3z_1.l3z_1.l1(_unary__edvuaz_11));
                break;
              case 9:
                tmp_1 = 'recompose pending';
                break;
              default:
                tmp_1 = 'unknown op: ' + operation;
                break;
            }

            var stringValue = tmp_1;
            this.n9_1 = 2;
            suspendResult = this.e3z_1.oi('' + index + ': ' + stringValue, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ComposePausableCompositionException$operationsSequence$slambda).j3z = function ($this$sequence, completion) {
    var i = new ComposePausableCompositionException$operationsSequence$slambda(this.d3z_1, completion);
    i.e3z_1 = $this$sequence;
    return i;
  };
  function ComposePausableCompositionException$operationsSequence$slambda_0(this$0, resultContinuation) {
    var i = new ComposePausableCompositionException$operationsSequence$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.i3z($this$sequence, $completion);
    }, 1);
  }
  function ComposePausableCompositionException(instances, reused, operations, lastOperation, cause) {
    RuntimeException_init_$Init$(cause, this);
    captureStack(this, ComposePausableCompositionException);
    this.k3z_1 = instances;
    this.l3z_1 = reused;
    this.m3z_1 = operations;
    this.n3z_1 = lastOperation;
    delete this.message;
  }
  protoOf(ComposePausableCompositionException).e = function () {
    return trimMargin('\n            |Failed to execute op number ' + this.n3z_1 + ':\n            |' + joinToString(takeLast(toList(operationsSequence(this)), 50), '\n') + '\n            ');
  };
  function PausedCompositionState_Invalid_getInstance() {
    PausedCompositionState_initEntries();
    return PausedCompositionState_Invalid_instance;
  }
  function PausedCompositionState_Cancelled_getInstance() {
    PausedCompositionState_initEntries();
    return PausedCompositionState_Cancelled_instance;
  }
  function PausedCompositionState_InitialPending_getInstance() {
    PausedCompositionState_initEntries();
    return PausedCompositionState_InitialPending_instance;
  }
  function PausedCompositionState_RecomposePending_getInstance() {
    PausedCompositionState_initEntries();
    return PausedCompositionState_RecomposePending_instance;
  }
  function PausedCompositionState_Recomposing_getInstance() {
    PausedCompositionState_initEntries();
    return PausedCompositionState_Recomposing_instance;
  }
  function PausedCompositionState_ApplyPending_getInstance() {
    PausedCompositionState_initEntries();
    return PausedCompositionState_ApplyPending_instance;
  }
  function PausedCompositionState_Applied_getInstance() {
    PausedCompositionState_initEntries();
    return PausedCompositionState_Applied_instance;
  }
  var androidx_compose_runtime_PausableMonotonicFrameClock$stable;
  function throwIllegalStateException(message) {
    throw IllegalStateException_init_$Create$(message);
  }
  function throwIllegalArgumentException(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function produceState(initialValue, producer, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_0().f30_1) {
      var value = mutableStateOf(initialValue);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var result = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.q31(producer);
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance_0().f30_1) {
      var value_0 = produceState$slambda_0(producer, result, null);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    LaunchedEffect(Unit_instance, tmp$ret$4, $composer_0, 6);
    return result;
  }
  function ProduceStateScope() {
  }
  function ProduceStateScopeImpl(state, coroutineContext) {
    this.o3z_1 = state;
    this.p3z_1 = coroutineContext;
  }
  protoOf(ProduceStateScopeImpl).q19 = function () {
    return this.p3z_1;
  };
  protoOf(ProduceStateScopeImpl).s21 = function (_set____db54di) {
    this.o3z_1.s21(_set____db54di);
  };
  protoOf(ProduceStateScopeImpl).u1 = function () {
    return this.o3z_1.u1();
  };
  function produceState_0(initialValue, key1, key2, producer, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_0().f30_1) {
      var value = mutableStateOf(initialValue);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var result = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.q31(producer);
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance_0().f30_1) {
      var value_0 = produceState$slambda_2(producer, result, null);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    LaunchedEffect_0(key1, key2, tmp$ret$4, $composer_0, 14 & $changed >> 3 | 112 & $changed >> 3);
    return result;
  }
  function produceState$slambda($producer, $result, resultContinuation) {
    this.y3z_1 = $producer;
    this.z3z_1 = $result;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(produceState$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(produceState$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(produceState$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.y3z_1(new ProduceStateScopeImpl(this.z3z_1, this.a40_1.q19()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(produceState$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new produceState$slambda(this.y3z_1, this.z3z_1, completion);
    i.a40_1 = $this$LaunchedEffect;
    return i;
  };
  function produceState$slambda_0($producer, $result, resultContinuation) {
    var i = new produceState$slambda($producer, $result, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function produceState$slambda_1($producer, $result, resultContinuation) {
    this.j40_1 = $producer;
    this.k40_1 = $result;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(produceState$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(produceState$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(produceState$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.j40_1(new ProduceStateScopeImpl(this.k40_1, this.l40_1.q19()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(produceState$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new produceState$slambda_1(this.j40_1, this.k40_1, completion);
    i.l40_1 = $this$LaunchedEffect;
    return i;
  };
  function produceState$slambda_2($producer, $result, resultContinuation) {
    var i = new produceState$slambda_1($producer, $result, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  var androidx_compose_runtime_RecomposeScopeImpl$stable;
  function updateChangedFlags(flags) {
    var lowBits = flags & 306783378;
    var highBits = flags & 613566756;
    return flags & -920350135 | (lowBits | highBits >> 1) | lowBits << 1 & highBits;
  }
  function RecomposeScope() {
  }
  function RecomposeScopeOwner() {
  }
  function _set_rereading__pnqtpo($this, value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = $this.l35_1;
    var tmp = $this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 32;
    } else {
      tmp_0 = existingFlags & ~32;
    }
    tmp.l35_1 = tmp_0;
  }
  function _get_rereading__g2iruw($this) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !(($this.l35_1 & 32) === 0);
  }
  function _set_skipped__p8q2c5($this, value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = $this.l35_1;
    var tmp = $this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 16;
    } else {
      tmp_0 = existingFlags & ~16;
    }
    tmp.l35_1 = tmp_0;
  }
  function checkDerivedStateChanged($this, $receiver, dependencies) {
    if (!isInterface($receiver, DerivedState))
      THROW_CCE();
    var tmp0_elvis_lhs = $receiver.h3d();
    var policy = tmp0_elvis_lhs == null ? structuralEqualityPolicy() : tmp0_elvis_lhs;
    return !policy.w3e($receiver.g3a().i3a(), dependencies.w2($receiver));
  }
  function Companion_5() {
  }
  protoOf(Companion_5).c36 = function (slots, anchors, newOwner) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!anchors.r()) {
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = anchors.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = anchors.l1(index);
          var tmp = slots.n40(item, 0);
          var recomposeScope = tmp instanceof RecomposeScopeImpl ? tmp : null;
          if (recomposeScope == null)
            null;
          else {
            recomposeScope.o40(newOwner);
          }
        }
         while (inductionVariable <= last);
    }
  };
  protoOf(Companion_5).d36 = function (slots, anchors) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!anchors.r()) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.fastAny' call
        // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
        var inductionVariable = 0;
        var last = anchors.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = anchors.l1(index);
            var tmp_0;
            if (slots.q40(item)) {
              var tmp_1 = slots.p40(slots.q3m(item), 0);
              tmp_0 = tmp_1 instanceof RecomposeScopeImpl;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$1 = false;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  var Companion_instance_6;
  function Companion_getInstance_5() {
    return Companion_instance_6;
  }
  function RecomposeScopeImpl$end$lambda(this$0, $token, $instances) {
    return function (composition) {
      var tmp;
      var tmp_0;
      if (this$0.o35_1 === $token && $instances.equals(this$0.p35_1)) {
        tmp_0 = composition instanceof CompositionImpl;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        // Inline function 'androidx.collection.MutableObjectIntMap.removeIf' call
        var this_0 = $instances;
        $l$block: {
          // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
          var m = this_0.dz_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_1 = slot;
              var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var tmp0 = this_0.ez_1[index];
                      var shouldRemove = !(this_0.fz_1[index] === $token);
                      if (shouldRemove) {
                        composition.i3b(tmp0, this$0);
                        if (isInterface(tmp0, DerivedState)) {
                          composition.j3b(tmp0);
                          var tmp0_safe_receiver = this$0.q35_1;
                          if (tmp0_safe_receiver == null)
                            null;
                          else
                            tmp0_safe_receiver.a3(tmp0);
                        }
                      }
                      if (shouldRemove) {
                        this_0.cv(index);
                      }
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function RecomposeScopeImpl(owner) {
    this.k35_1 = owner;
    this.l35_1 = 0;
    this.m35_1 = null;
    this.n35_1 = null;
    this.o35_1 = 0;
    this.p35_1 = null;
    this.q35_1 = null;
  }
  protoOf(RecomposeScopeImpl).d2y = function () {
    var tmp;
    if (!(this.k35_1 == null)) {
      var tmp0_safe_receiver = this.m35_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2y();
      tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RecomposeScopeImpl).f3b = function () {
    return !(this.n35_1 == null);
  };
  protoOf(RecomposeScopeImpl).b3a = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 1;
    } else {
      tmp_0 = existingFlags & ~1;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).b3l = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 1) === 0);
  };
  protoOf(RecomposeScopeImpl).p3o = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 128;
    } else {
      tmp_0 = existingFlags & ~128;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).l3m = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 128) === 0);
  };
  protoOf(RecomposeScopeImpl).k3m = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 1024;
    } else {
      tmp_0 = existingFlags & ~1024;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).w3o = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 1024) === 0);
  };
  protoOf(RecomposeScopeImpl).h3m = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 256;
    } else {
      tmp_0 = existingFlags & ~256;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).m3m = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 256) === 0);
  };
  protoOf(RecomposeScopeImpl).i3m = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 512;
    } else {
      tmp_0 = existingFlags & ~512;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).r3o = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 512) === 0);
  };
  protoOf(RecomposeScopeImpl).t3n = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 2;
    } else {
      tmp_0 = existingFlags & ~2;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).d3b = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 2) === 0);
  };
  protoOf(RecomposeScopeImpl).c3b = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 4;
    } else {
      tmp_0 = existingFlags & ~4;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).j30 = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 4) === 0);
  };
  protoOf(RecomposeScopeImpl).g3m = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 8;
    } else {
      tmp_0 = existingFlags & ~8;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).u3n = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 8) === 0);
  };
  protoOf(RecomposeScopeImpl).y3l = function (composer) {
    var tmp0_safe_receiver = this.n35_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver(composer, 1)) == null) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid restart scope';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  };
  protoOf(RecomposeScopeImpl).r37 = function (value) {
    var tmp0_safe_receiver = this.k35_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i36(this, value);
    return tmp1_elvis_lhs == null ? InvalidationResult_IGNORED_getInstance() : tmp1_elvis_lhs;
  };
  protoOf(RecomposeScopeImpl).r2v = function () {
    var tmp0_safe_receiver = this.k35_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j36(this);
    }
    this.k35_1 = null;
    this.p35_1 = null;
    this.q35_1 = null;
    this.n35_1 = null;
  };
  protoOf(RecomposeScopeImpl).o40 = function (owner) {
    this.k35_1 = owner;
  };
  protoOf(RecomposeScopeImpl).m40 = function () {
    var tmp0_safe_receiver = this.k35_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.i36(this, null);
  };
  protoOf(RecomposeScopeImpl).p3c = function (block) {
    this.n35_1 = block;
  };
  protoOf(RecomposeScopeImpl).f3m = function (value) {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.setFlag' call
    var existingFlags = this.l35_1;
    var tmp = this;
    var tmp_0;
    if (value) {
      tmp_0 = existingFlags | 64;
    } else {
      tmp_0 = existingFlags & ~64;
    }
    tmp.l35_1 = tmp_0;
  };
  protoOf(RecomposeScopeImpl).e3m = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 64) === 0);
  };
  protoOf(RecomposeScopeImpl).x3o = function () {
    // Inline function 'androidx.compose.runtime.RecomposeScopeImpl.getFlag' call
    return !((this.l35_1 & 16) === 0);
  };
  protoOf(RecomposeScopeImpl).n3m = function (token) {
    this.o35_1 = token;
    _set_skipped__p8q2c5(this, false);
  };
  protoOf(RecomposeScopeImpl).s3o = function () {
    if (!this.l3m()) {
      _set_skipped__p8q2c5(this, true);
    }
  };
  protoOf(RecomposeScopeImpl).c3a = function (instance) {
    if (_get_rereading__g2iruw(this))
      return false;
    var tmp0_elvis_lhs = this.p35_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new MutableObjectIntMap();
      this.p35_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var trackedInstances = tmp;
    var token = trackedInstances.pz(instance, this.o35_1, -1);
    if (token === this.o35_1) {
      return true;
    }
    return false;
  };
  protoOf(RecomposeScopeImpl).j3a = function (instance, value) {
    var tmp0_elvis_lhs = this.q35_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new MutableScatterMap();
      this.q35_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var trackedDependencies = tmp;
    trackedDependencies.h13(instance, value);
  };
  protoOf(RecomposeScopeImpl).q37 = function () {
    return !(this.q35_1 == null);
  };
  protoOf(RecomposeScopeImpl).d3p = function (instances) {
    if (instances == null)
      return true;
    var tmp0_elvis_lhs = this.q35_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return true;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var trackedDependencies = tmp;
    var tmp_0;
    if (isInterface(instances, DerivedState)) {
      tmp_0 = checkDerivedStateChanged(this, instances, trackedDependencies);
    } else {
      if (instances instanceof ScatterSet) {
        var tmp_1;
        if (instances.fv()) {
          var tmp$ret$0;
          $l$block: {
            // Inline function 'androidx.collection.ScatterSet.any' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'androidx.collection.ScatterSet.forEach' call
            // Inline function 'kotlin.contracts.contract' call
            var elements = instances.k16_1;
            $l$block_0: {
              // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
              // Inline function 'kotlin.contracts.contract' call
              var m = instances.j16_1;
              var lastIndex = m.length - 2 | 0;
              var inductionVariable = 0;
              if (inductionVariable <= lastIndex)
                do {
                  var i = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var slot = m[i];
                  // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                  var this_0 = slot;
                  var tmp$ret$6 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
                  if (!equalsLong(tmp$ret$6, new Long(-2139062144, -2139062144))) {
                    var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < bitCount)
                      do {
                        var j = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'androidx.collection.isFull' call
                        var value = bitwiseAnd(slot, new Long(255, 0));
                        if (compare(value, new Long(128, 0)) < 0) {
                          var index = (i << 3) + j | 0;
                          var it = elements[index];
                          var tmp_2;
                          if (!(!(it == null) ? isInterface(it, DerivedState) : false)) {
                            tmp_2 = true;
                          } else {
                            tmp_2 = checkDerivedStateChanged(this, it, trackedDependencies);
                          }
                          if (tmp_2) {
                            tmp$ret$0 = true;
                            break $l$block;
                          }
                        }
                        slot = shiftRight(slot, 8);
                      }
                       while (inductionVariable_0 < bitCount);
                    if (!(bitCount === 8)) {
                      break $l$block_0;
                    }
                  }
                }
                 while (!(i === lastIndex));
            }
            tmp$ret$0 = false;
          }
          tmp_1 = tmp$ret$0;
        } else {
          tmp_1 = false;
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = true;
      }
    }
    return tmp_0;
  };
  protoOf(RecomposeScopeImpl).v3l = function () {
    var tmp0_safe_receiver = this.k35_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.p35_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        _set_rereading__pnqtpo(this, true);
        try {
          // Inline function 'androidx.collection.ObjectIntMap.forEach' call
          var k = tmp0_safe_receiver_0.ez_1;
          var v = tmp0_safe_receiver_0.fz_1;
          $l$block: {
            // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
            var m = tmp0_safe_receiver_0.dz_1;
            var lastIndex = m.length - 2 | 0;
            var inductionVariable = 0;
            if (inductionVariable <= lastIndex)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var slot = m[i];
                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                var this_0 = slot;
                var tmp$ret$6 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
                if (!equalsLong(tmp$ret$6, new Long(-2139062144, -2139062144))) {
                  var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                  var inductionVariable_0 = 0;
                  if (inductionVariable_0 < bitCount)
                    do {
                      var j = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      // Inline function 'androidx.collection.isFull' call
                      var value = bitwiseAnd(slot, new Long(255, 0));
                      if (compare(value, new Long(128, 0)) < 0) {
                        var index = (i << 3) + j | 0;
                        var tmp0 = k[index];
                        v[index];
                        tmp0_safe_receiver.k36(tmp0);
                      }
                      slot = shiftRight(slot, 8);
                    }
                     while (inductionVariable_0 < bitCount);
                  if (!(bitCount === 8)) {
                    break $l$block;
                  }
                }
              }
               while (!(i === lastIndex));
          }
        }finally {
          _set_rereading__pnqtpo(this, false);
        }
        tmp = Unit_instance;
      }
    }
  };
  protoOf(RecomposeScopeImpl).o3m = function (token) {
    var tmp0_safe_receiver = this.p35_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      var tmp_1;
      if (!this.x3o()) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'androidx.collection.ObjectIntMap.any' call
          // Inline function 'androidx.collection.ObjectIntMap.forEach' call
          var k = tmp0_safe_receiver.ez_1;
          var v = tmp0_safe_receiver.fz_1;
          $l$block_0: {
            // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
            var m = tmp0_safe_receiver.dz_1;
            var lastIndex = m.length - 2 | 0;
            var inductionVariable = 0;
            if (inductionVariable <= lastIndex)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var slot = m[i];
                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                var this_0 = slot;
                var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
                if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
                  var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                  var inductionVariable_0 = 0;
                  if (inductionVariable_0 < bitCount)
                    do {
                      var j = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      // Inline function 'androidx.collection.isFull' call
                      var value = bitwiseAnd(slot, new Long(255, 0));
                      if (compare(value, new Long(128, 0)) < 0) {
                        var index = (i << 3) + j | 0;
                        k[index];
                        if (!(v[index] === token)) {
                          tmp$ret$2 = true;
                          break $l$block;
                        }
                      }
                      slot = shiftRight(slot, 8);
                    }
                     while (inductionVariable_0 < bitCount);
                  if (!(bitCount === 8)) {
                    break $l$block_0;
                  }
                }
              }
               while (!(i === lastIndex));
          }
          tmp$ret$2 = false;
        }
        tmp_1 = tmp$ret$2;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = RecomposeScopeImpl$end$lambda(this, token, tmp0_safe_receiver);
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  var State_ShutDown_instance;
  var State_ShuttingDown_instance;
  var State_Inactive_instance;
  var State_InactivePendingWork_instance;
  var State_Idle_instance;
  var State_PendingWork_instance;
  var State_entriesInitialized;
  function State_initEntries() {
    if (State_entriesInitialized)
      return Unit_instance;
    State_entriesInitialized = true;
    State_ShutDown_instance = new State('ShutDown', 0);
    State_ShuttingDown_instance = new State('ShuttingDown', 1);
    State_Inactive_instance = new State('Inactive', 2);
    State_InactivePendingWork_instance = new State('InactivePendingWork', 3);
    State_Idle_instance = new State('Idle', 4);
    State_PendingWork_instance = new State('PendingWork', 5);
  }
  function addRunning($this, info) {
    $l$loop: while (true) {
      var old = $this.r40_1.u1();
      var new_0 = old.j1(info);
      if (old === new_0 || $this.r40_1.c9(old, new_0))
        break $l$loop;
    }
  }
  function removeRunning($this, info) {
    $l$loop: while (true) {
      var old = $this.r40_1.u1();
      var new_0 = old.d3(info);
      if (old === new_0 || $this.r40_1.c9(old, new_0))
        break $l$loop;
    }
  }
  function invoke$clearRecompositionState(this$0, toRecompose, toInsert, toApply, toLateApply, toComplete, modifiedValues, alreadyComposed) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this$0.w40_1;
    toRecompose.c3();
    toInsert.c3();
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var inductionVariable = 0;
    var last = toApply.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = toApply.l1(index);
        item.r39();
        recordFailedCompositionLocked(this$0, item);
      }
       while (inductionVariable <= last);
    toApply.c3();
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    // Inline function 'kotlin.contracts.contract' call
    var elements = toLateApply.k16_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m = toLateApply.j16_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= lastIndex)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_0 = slot;
          var tmp$ret$8 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$8, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < bitCount)
              do {
                var j = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index_0 = (i << 3) + j | 0;
                  var it = elements[index_0];
                  it.r39();
                  recordFailedCompositionLocked(this$0, it);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_1 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    toLateApply.c3();
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    // Inline function 'kotlin.contracts.contract' call
    var elements_0 = toComplete.k16_1;
    $l$block_0: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m_0 = toComplete.j16_1;
      var lastIndex_0 = m_0.length - 2 | 0;
      var inductionVariable_2 = 0;
      if (inductionVariable_2 <= lastIndex_0)
        do {
          var i_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var slot_0 = m_0[i_0];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot_0;
          var tmp$ret$16 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$16, new Long(-2139062144, -2139062144))) {
            var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
            var inductionVariable_3 = 0;
            if (inductionVariable_3 < bitCount_0)
              do {
                var j_0 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                if (compare(value_0, new Long(128, 0)) < 0) {
                  var index_1 = (i_0 << 3) + j_0 | 0;
                  elements_0[index_1].y3a();
                }
                slot_0 = shiftRight(slot_0, 8);
              }
               while (inductionVariable_3 < bitCount_0);
            if (!(bitCount_0 === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i_0 === lastIndex_0));
    }
    toComplete.c3();
    modifiedValues.c3();
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    // Inline function 'kotlin.contracts.contract' call
    var elements_1 = alreadyComposed.k16_1;
    $l$block_1: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m_1 = alreadyComposed.j16_1;
      var lastIndex_1 = m_1.length - 2 | 0;
      var inductionVariable_4 = 0;
      if (inductionVariable_4 <= lastIndex_1)
        do {
          var i_1 = inductionVariable_4;
          inductionVariable_4 = inductionVariable_4 + 1 | 0;
          var slot_1 = m_1[i_1];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_2 = slot_1;
          var tmp$ret$24 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$24, new Long(-2139062144, -2139062144))) {
            var bitCount_1 = 8 - (~(i_1 - lastIndex_1 | 0) >>> 31 | 0) | 0;
            var inductionVariable_5 = 0;
            if (inductionVariable_5 < bitCount_1)
              do {
                var j_1 = inductionVariable_5;
                inductionVariable_5 = inductionVariable_5 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value_1 = bitwiseAnd(slot_1, new Long(255, 0));
                if (compare(value_1, new Long(128, 0)) < 0) {
                  var index_2 = (i_1 << 3) + j_1 | 0;
                  var it_0 = elements_1[index_2];
                  it_0.r39();
                  recordFailedCompositionLocked(this$0, it_0);
                }
                slot_1 = shiftRight(slot_1, 8);
              }
               while (inductionVariable_5 < bitCount_1);
            if (!(bitCount_1 === 8)) {
              break $l$block_1;
            }
          }
        }
         while (!(i_1 === lastIndex_1));
    }
    alreadyComposed.c3();
  }
  function invoke$fillToInsert(toInsert, this$0) {
    toInsert.c3();
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this$0.w40_1;
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var this_0 = this$0.e41_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        toInsert.j1(item);
      }
       while (inductionVariable <= last);
    this$0.e41_1.c3();
  }
  function Recomposer$runRecomposeAndApplyChanges$slambda$lambda(this$0, $toRecompose, $modifiedValues, $alreadyComposed, $toInsert, $toApply, $modifiedValuesSet, $toLateApply, $toComplete) {
    return function (frameTime) {
      var tmp;
      if (_get_hasBroadcastFrameClockAwaiters__y6inql(this$0)) {
        var tmp0 = 'Recomposer:animation';
        $l$block: {
          // Inline function 'androidx.compose.runtime.internal.trace' call
          var token = Trace_instance.r38(tmp0);
          try {
            this$0.u40_1.p2z(frameTime);
            Companion_instance_18.w41();
            break $l$block;
          }finally {
            Trace_instance.t38(token);
          }
        }
        tmp = Unit_instance;
      }
      var tmp0_0 = 'Recomposer:recompose';
      $l$block_3: {
        // Inline function 'androidx.compose.runtime.internal.trace' call
        var token_0 = Trace_instance.r38(tmp0_0);
        try {
          recordComposerModifications(this$0);
          // Inline function 'androidx.compose.runtime.platform.synchronized' call
          this$0.w40_1;
          // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
          var this_0 = this$0.c41_1;
          var i = 0;
          var tmp_0 = this_0.b3e_1;
          var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
          var size = this_0.d3e_1;
          while (i < size) {
            var it = content[i];
            // Inline function 'kotlin.collections.plusAssign' call
            $toRecompose.j1(it);
            i = i + 1 | 0;
          }
          this$0.c41_1.c3();
          $modifiedValues.c3();
          $alreadyComposed.c3();
          $l$loop: while (true) {
            var tmp_1;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!$toRecompose.r()) {
              tmp_1 = true;
            } else {
              // Inline function 'kotlin.collections.isNotEmpty' call
              tmp_1 = !$toInsert.r();
            }
            if (!tmp_1) {
              break $l$loop;
            }
            try {
              // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
              var this_1 = $toRecompose;
              var inductionVariable = 0;
              var last = this_1.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = this_1.l1(index);
                  var tmp0_safe_receiver = performRecompose(this$0, item, $modifiedValues);
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.collections.plusAssign' call
                    $toApply.j1(tmp0_safe_receiver);
                  }
                  $alreadyComposed.j1(item);
                }
                 while (inductionVariable <= last);
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                processCompositionError(this$0, e, VOID, true);
                invoke$clearRecompositionState(this$0, $toRecompose, $toInsert, $toApply, $toLateApply, $toComplete, $modifiedValues, $alreadyComposed);
                return Unit_instance;
              } else {
                throw $p;
              }
            }
            finally {
              $toRecompose.c3();
            }
            var tmp_2;
            if ($modifiedValues.fv()) {
              tmp_2 = true;
            } else {
              // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
              tmp_2 = !(this$0.c41_1.d3e_1 === 0);
            }
            if (tmp_2) {
              // Inline function 'androidx.compose.runtime.platform.synchronized' call
              this$0.w40_1;
              // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
              var this_2 = knownCompositionsLocked(this$0);
              var inductionVariable_0 = 0;
              var last_0 = this_2.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = this_2.l1(index_0);
                  if (!$alreadyComposed.m1(item_0) && item_0.x39($modifiedValuesSet)) {
                    // Inline function 'kotlin.collections.plusAssign' call
                    $toRecompose.j1(item_0);
                  }
                }
                 while (inductionVariable_0 <= last_0);
              // Inline function 'androidx.compose.runtime.collection.MutableVector.removeIf' call
              var this_3 = this$0.c41_1;
              var gap = 0;
              var size_0 = this_3.d3e_1;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < size_0)
                $l$loop_0: do {
                  var i_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var value = this_3.b3e_1[i_0];
                  var tmp_3;
                  if (!$alreadyComposed.m1(value) && !$toRecompose.m1(value)) {
                    // Inline function 'kotlin.collections.plusAssign' call
                    $toRecompose.j1(value);
                    tmp_3 = true;
                  } else {
                    tmp_3 = false;
                  }
                  if (tmp_3) {
                    gap = gap + 1 | 0;
                    continue $l$loop_0;
                  }
                  if (gap > 0) {
                    this_3.b3e_1[i_0 - gap | 0] = this_3.b3e_1[i_0];
                  }
                }
                 while (inductionVariable_1 < size_0);
              fill_0(this_3.b3e_1, null, size_0 - gap | 0, size_0);
              this_3.x41(size_0 - gap | 0);
            }
            if ($toRecompose.r()) {
              try {
                invoke$fillToInsert($toInsert, this$0);
                $l$loop_1: while (true) {
                  // Inline function 'kotlin.collections.isNotEmpty' call
                  if (!!$toInsert.r()) {
                    break $l$loop_1;
                  }
                  $toLateApply.n10(performInsertValues(this$0, $toInsert, $modifiedValues));
                  invoke$fillToInsert($toInsert, this$0);
                }
              } catch ($p_0) {
                if ($p_0 instanceof Error) {
                  var e_0 = $p_0;
                  processCompositionError(this$0, e_0, VOID, true);
                  invoke$clearRecompositionState(this$0, $toRecompose, $toInsert, $toApply, $toLateApply, $toComplete, $modifiedValues, $alreadyComposed);
                  return Unit_instance;
                } else {
                  throw $p_0;
                }
              }
            }
          }
          // Inline function 'androidx.compose.runtime.Recomposer.withTransparentSnapshot' call
          var currentSnapshot = Companion_instance_18.e2y();
          var tmp_4;
          if (currentSnapshot instanceof MutableSnapshot) {
            tmp_4 = new TransparentObserverMutableSnapshot(currentSnapshot, null, null, true, false);
          } else {
            tmp_4 = new TransparentObserverSnapshot(currentSnapshot, null, true, false);
          }
          var snapshot = tmp_4;
          try {
            $l$block_2: {
              // Inline function 'androidx.compose.runtime.snapshots.Snapshot.enter' call
              var previous = snapshot.y41();
              try {
                // Inline function 'kotlin.collections.isNotEmpty' call
                if (!$toApply.r()) {
                  var _unary__edvuaz = this$0.t40_1;
                  this$0.t40_1 = add(_unary__edvuaz, get_ONE());
                  try {
                    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
                    var this_4 = $toApply;
                    var inductionVariable_2 = 0;
                    var last_1 = this_4.n1() - 1 | 0;
                    if (inductionVariable_2 <= last_1)
                      do {
                        var index_1 = inductionVariable_2;
                        inductionVariable_2 = inductionVariable_2 + 1 | 0;
                        var item_1 = this_4.l1(index_1);
                        $toComplete.j1(item_1);
                      }
                       while (inductionVariable_2 <= last_1);
                    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
                    var this_5 = $toApply;
                    var inductionVariable_3 = 0;
                    var last_2 = this_5.n1() - 1 | 0;
                    if (inductionVariable_3 <= last_2)
                      do {
                        var index_2 = inductionVariable_3;
                        inductionVariable_3 = inductionVariable_3 + 1 | 0;
                        var item_2 = this_5.l1(index_2);
                        item_2.w3a();
                      }
                       while (inductionVariable_3 <= last_2);
                  } catch ($p_1) {
                    if ($p_1 instanceof Error) {
                      var e_1 = $p_1;
                      processCompositionError(this$0, e_1);
                      invoke$clearRecompositionState(this$0, $toRecompose, $toInsert, $toApply, $toLateApply, $toComplete, $modifiedValues, $alreadyComposed);
                      return Unit_instance;
                    } else {
                      throw $p_1;
                    }
                  }
                  finally {
                    $toApply.c3();
                  }
                }
                if ($toLateApply.fv()) {
                  try {
                    $toComplete.t16($toLateApply);
                    // Inline function 'androidx.collection.ScatterSet.forEach' call
                    var this_6 = $toLateApply;
                    // Inline function 'kotlin.contracts.contract' call
                    var elements = this_6.k16_1;
                    $l$block_0: {
                      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                      // Inline function 'kotlin.contracts.contract' call
                      var m = this_6.j16_1;
                      var lastIndex = m.length - 2 | 0;
                      var inductionVariable_4 = 0;
                      if (inductionVariable_4 <= lastIndex)
                        do {
                          var i_1 = inductionVariable_4;
                          inductionVariable_4 = inductionVariable_4 + 1 | 0;
                          var slot = m[i_1];
                          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                          var this_7 = slot;
                          var tmp$ret$38 = bitwiseAnd(bitwiseAnd(this_7, shiftLeft(invert(this_7), 7)), new Long(-2139062144, -2139062144));
                          if (!equalsLong(tmp$ret$38, new Long(-2139062144, -2139062144))) {
                            var bitCount = 8 - (~(i_1 - lastIndex | 0) >>> 31 | 0) | 0;
                            var inductionVariable_5 = 0;
                            if (inductionVariable_5 < bitCount)
                              do {
                                var j = inductionVariable_5;
                                inductionVariable_5 = inductionVariable_5 + 1 | 0;
                                // Inline function 'androidx.collection.isFull' call
                                var value_0 = bitwiseAnd(slot, new Long(255, 0));
                                if (compare(value_0, new Long(128, 0)) < 0) {
                                  var index_3 = (i_1 << 3) + j | 0;
                                  elements[index_3].x3a();
                                }
                                slot = shiftRight(slot, 8);
                              }
                               while (inductionVariable_5 < bitCount);
                            if (!(bitCount === 8)) {
                              break $l$block_0;
                            }
                          }
                        }
                         while (!(i_1 === lastIndex));
                    }
                  } catch ($p_2) {
                    if ($p_2 instanceof Error) {
                      var e_2 = $p_2;
                      processCompositionError(this$0, e_2);
                      invoke$clearRecompositionState(this$0, $toRecompose, $toInsert, $toApply, $toLateApply, $toComplete, $modifiedValues, $alreadyComposed);
                      return Unit_instance;
                    } else {
                      throw $p_2;
                    }
                  }
                  finally {
                    $toLateApply.c3();
                  }
                }
                if ($toComplete.fv()) {
                  try {
                    // Inline function 'androidx.collection.ScatterSet.forEach' call
                    var this_8 = $toComplete;
                    // Inline function 'kotlin.contracts.contract' call
                    var elements_0 = this_8.k16_1;
                    $l$block_1: {
                      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                      // Inline function 'kotlin.contracts.contract' call
                      var m_0 = this_8.j16_1;
                      var lastIndex_0 = m_0.length - 2 | 0;
                      var inductionVariable_6 = 0;
                      if (inductionVariable_6 <= lastIndex_0)
                        do {
                          var i_2 = inductionVariable_6;
                          inductionVariable_6 = inductionVariable_6 + 1 | 0;
                          var slot_0 = m_0[i_2];
                          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                          var this_9 = slot_0;
                          var tmp$ret$46 = bitwiseAnd(bitwiseAnd(this_9, shiftLeft(invert(this_9), 7)), new Long(-2139062144, -2139062144));
                          if (!equalsLong(tmp$ret$46, new Long(-2139062144, -2139062144))) {
                            var bitCount_0 = 8 - (~(i_2 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                            var inductionVariable_7 = 0;
                            if (inductionVariable_7 < bitCount_0)
                              do {
                                var j_0 = inductionVariable_7;
                                inductionVariable_7 = inductionVariable_7 + 1 | 0;
                                // Inline function 'androidx.collection.isFull' call
                                var value_1 = bitwiseAnd(slot_0, new Long(255, 0));
                                if (compare(value_1, new Long(128, 0)) < 0) {
                                  var index_4 = (i_2 << 3) + j_0 | 0;
                                  elements_0[index_4].y3a();
                                }
                                slot_0 = shiftRight(slot_0, 8);
                              }
                               while (inductionVariable_7 < bitCount_0);
                            if (!(bitCount_0 === 8)) {
                              break $l$block_1;
                            }
                          }
                        }
                         while (!(i_2 === lastIndex_0));
                    }
                  } catch ($p_3) {
                    if ($p_3 instanceof Error) {
                      var e_3 = $p_3;
                      processCompositionError(this$0, e_3);
                      invoke$clearRecompositionState(this$0, $toRecompose, $toInsert, $toApply, $toLateApply, $toComplete, $modifiedValues, $alreadyComposed);
                      return Unit_instance;
                    } else {
                      throw $p_3;
                    }
                  }
                  finally {
                    $toComplete.c3();
                  }
                }
                break $l$block_2;
              }finally {
                snapshot.z41(previous);
              }
            }
          }finally {
            snapshot.s1d();
          }
          // Inline function 'androidx.compose.runtime.platform.synchronized' call
          this$0.w40_1;
          // Inline function 'androidx.compose.runtime.runtimeCheck' call
          if (!(deriveStateLocked(this$0) == null)) {
            var tmp$ret$53 = 'unexpected to get continuation here';
            composeImmediateRuntimeError(tmp$ret$53);
          }
          Companion_instance_18.x3e();
          $alreadyComposed.c3();
          $modifiedValues.c3();
          this$0.k41_1 = null;
          break $l$block_3;
        }finally {
          Trace_instance.t38(token_0);
        }
      }
      return Unit_instance;
    };
  }
  function Recomposer$recompositionRunner$slambda$lambda(this$0) {
    return function (changed, _unused_var__etf5q3) {
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this$0.w40_1;
      var tmp;
      if (this$0.q41_1.u1().i3(State_Idle_getInstance()) >= 0) {
        var snapshotInvalidations = this$0.b41_1;
        // Inline function 'androidx.compose.runtime.collection.fastForEach' call
        var tmp_0;
        if (changed instanceof ScatterSetWrapper) {
          // Inline function 'androidx.collection.ScatterSet.forEach' call
          var this_0 = changed.s37_1;
          // Inline function 'kotlin.contracts.contract' call
          var elements = this_0.k16_1;
          $l$block_0: {
            // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
            // Inline function 'kotlin.contracts.contract' call
            var m = this_0.j16_1;
            var lastIndex = m.length - 2 | 0;
            var inductionVariable = 0;
            if (inductionVariable <= lastIndex)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var slot = m[i];
                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                var this_1 = slot;
                var tmp$ret$7 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
                if (!equalsLong(tmp$ret$7, new Long(-2139062144, -2139062144))) {
                  var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                  var inductionVariable_0 = 0;
                  if (inductionVariable_0 < bitCount)
                    do {
                      var j = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      // Inline function 'androidx.collection.isFull' call
                      var value = bitwiseAnd(slot, new Long(255, 0));
                      if (compare(value, new Long(128, 0)) < 0) {
                        var index = (i << 3) + j | 0;
                        var tmp0 = elements[index];
                        $l$block: {
                          var tmp_1;
                          if (tmp0 instanceof StateObjectImpl) {
                            // Inline function 'androidx.compose.runtime.snapshots.Companion.Composition' call
                            var tmp$ret$11 = _ReaderKind___init__impl__jqeebu(1);
                            tmp_1 = !tmp0.z3e(tmp$ret$11);
                          } else {
                            tmp_1 = false;
                          }
                          if (tmp_1) {
                            break $l$block;
                          }
                          snapshotInvalidations.j1(tmp0);
                        }
                      }
                      slot = shiftRight(slot, 8);
                    }
                     while (inductionVariable_0 < bitCount);
                  if (!(bitCount === 8)) {
                    break $l$block_0;
                  }
                }
              }
               while (!(i === lastIndex));
          }
          tmp_0 = Unit_instance;
        } else {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = changed.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            $l$block_1: {
              var tmp_2;
              if (element instanceof StateObjectImpl) {
                // Inline function 'androidx.compose.runtime.snapshots.Companion.Composition' call
                var tmp$ret$14 = _ReaderKind___init__impl__jqeebu(1);
                tmp_2 = !element.z3e(tmp$ret$14);
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                break $l$block_1;
              }
              snapshotInvalidations.j1(element);
            }
          }
          tmp_0 = Unit_instance;
        }
        tmp = deriveStateLocked(this$0);
      } else {
        tmp = null;
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$16 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.y9(tmp$ret$16);
      }
      return Unit_instance;
    };
  }
  function Recomposer$recompositionRunner$slambda$slambda($block, $parentFrameClock, resultContinuation) {
    this.i42_1 = $block;
    this.j42_1 = $parentFrameClock;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Recomposer$recompositionRunner$slambda$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Recomposer$recompositionRunner$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Recomposer$recompositionRunner$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.i42_1(this.k42_1, this.j42_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Recomposer$recompositionRunner$slambda$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new Recomposer$recompositionRunner$slambda$slambda(this.i42_1, this.j42_1, completion);
    i.k42_1 = $this$coroutineScope;
    return i;
  };
  function Recomposer$recompositionRunner$slambda$slambda_0($block, $parentFrameClock, resultContinuation) {
    var i = new Recomposer$recompositionRunner$slambda$slambda($block, $parentFrameClock, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function State(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function _get_hasBroadcastFrameClockAwaitersLocked__7l4pm1($this) {
    return !$this.p41_1 && $this.u40_1.j2z();
  }
  function _get_hasNextFrameEndAwaitersLocked__u95b0($this) {
    return !$this.p41_1 && $this.v40_1.j2z();
  }
  function _get_hasBroadcastFrameClockAwaiters__y6inql($this) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    return _get_hasBroadcastFrameClockAwaitersLocked__7l4pm1($this);
  }
  function deriveStateLocked($this) {
    if ($this.q41_1.u1().i3(State_ShuttingDown_getInstance()) <= 0) {
      clearKnownCompositionsLocked($this);
      $this.b41_1 = new MutableScatterSet();
      $this.c41_1.c3();
      $this.d41_1.c3();
      $this.e41_1.c3();
      $this.j41_1 = null;
      var tmp0_safe_receiver = $this.l41_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.e1d();
      $this.l41_1 = null;
      $this.o41_1.s21(null);
      return null;
    }
    var tmp;
    if (!($this.o41_1.u1() == null)) {
      tmp = State_Inactive_getInstance();
    } else {
      if ($this.x40_1 == null) {
        $this.b41_1 = new MutableScatterSet();
        $this.c41_1.c3();
        tmp = _get_hasBroadcastFrameClockAwaitersLocked__7l4pm1($this) || _get_hasNextFrameEndAwaitersLocked__u95b0($this) ? State_InactivePendingWork_getInstance() : State_Inactive_getInstance();
      } else {
        var tmp_0;
        var tmp_1;
        var tmp_2;
        var tmp_3;
        var tmp_4;
        var tmp_5;
        var tmp_6;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
        if (!($this.c41_1.d3e_1 === 0)) {
          tmp_6 = true;
        } else {
          tmp_6 = $this.b41_1.fv();
        }
        if (tmp_6) {
          tmp_5 = true;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_5 = !$this.d41_1.r();
        }
        if (tmp_5) {
          tmp_4 = true;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_4 = !$this.e41_1.r();
        }
        if (tmp_4) {
          tmp_3 = true;
        } else {
          tmp_3 = $this.m41_1 > 0;
        }
        if (tmp_3) {
          tmp_2 = true;
        } else {
          tmp_2 = _get_hasBroadcastFrameClockAwaitersLocked__7l4pm1($this);
        }
        if (tmp_2) {
          tmp_1 = true;
        } else {
          tmp_1 = _get_hasNextFrameEndAwaitersLocked__u95b0($this);
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = MultiValueMap__isNotEmpty_impl_ktqbr9($this.f41_1);
        }
        if (tmp_0) {
          tmp = State_PendingWork_getInstance();
        } else {
          tmp = State_Idle_getInstance();
        }
      }
    }
    var newState = tmp;
    $this.q41_1.s21(newState);
    var tmp_7;
    if (newState.equals(State_PendingWork_getInstance())) {
      // Inline function 'kotlin.also' call
      var this_0 = $this.l41_1;
      $this.l41_1 = null;
      tmp_7 = this_0;
    } else {
      tmp_7 = null;
    }
    return tmp_7;
  }
  function onNewFrameAwaiter($this) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    // Inline function 'kotlin.also' call
    var this_0 = deriveStateLocked($this);
    if ($this.q41_1.u1().i3(State_ShuttingDown_getInstance()) <= 0)
      throw CancellationException_init_$Create$('Recomposer shutdown; frame clock awaiter will never resume', $this.y40_1);
    if (this_0 == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
      this_0.y9(tmp$ret$5);
    }
  }
  function _get_shouldKeepRecomposing__5j79sd($this) {
    var tmp;
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    if (!$this.n41_1) {
      tmp = true;
    } else {
      var tmp0 = $this.s41_1.j1b();
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.sequences.any' call
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element.r19()) {
            tmp$ret$2 = true;
            break $l$block;
          }
        }
        tmp$ret$2 = false;
      }
      tmp = tmp$ret$2;
    }
    return tmp;
  }
  function RecomposerInfoImpl($outer) {
    this.l42_1 = $outer;
  }
  function RecomposerErrorState(cause, isRecoverable) {
    this.m42_1 = cause;
    this.n42_1 = isRecoverable;
  }
  function recordComposerModifications($this) {
    var compositions = emptyList();
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    if ($this.b41_1.r())
      return _get_hasFrameWorkLocked__1gtyf7($this);
    compositions = knownCompositionsLocked($this);
    // Inline function 'kotlin.also' call
    var this_0 = wrapIntoSet($this.b41_1);
    $this.b41_1 = new MutableScatterSet();
    var changes = this_0;
    var complete = false;
    try {
      // Inline function 'kotlin.run' call
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
        var this_1 = compositions;
        var inductionVariable = 0;
        var last = this_1.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = this_1.l1(index);
            item.w39(changes);
            if ($this.q41_1.u1().i3(State_ShuttingDown_getInstance()) <= 0) {
              break $l$block;
            }
          }
           while (inductionVariable <= last);
      }
      complete = true;
    }finally {
      if (!complete) {
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        $this.w40_1;
        $this.b41_1.f10(changes);
      }
    }
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    if (!(deriveStateLocked($this) == null)) {
      // Inline function 'kotlin.error' call
      var message = 'called outside of runRecomposeAndApplyChanges';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return _get_hasFrameWorkLocked__1gtyf7($this);
  }
  function registerRunnerJob($this, callingJob) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    var tmp0_safe_receiver = $this.y40_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
    if ($this.q41_1.u1().i3(State_ShuttingDown_getInstance()) <= 0) {
      // Inline function 'kotlin.error' call
      var message = 'Recomposer shut down';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (!($this.x40_1 == null)) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Recomposer already running';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    $this.x40_1 = callingJob;
    if (!(deriveStateLocked($this) == null)) {
      composeImmediateRuntimeError('called outside of runRecomposeAndApplyChanges');
    }
  }
  function processCompositionError($this, e, failedInitialComposition, recoverable) {
    failedInitialComposition = failedInitialComposition === VOID ? null : failedInitialComposition;
    recoverable = recoverable === VOID ? false : recoverable;
    var tmp;
    if (Companion_getInstance_6().s40_1.f1i()) {
      tmp = !(e instanceof ComposeRuntimeError);
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      $this.w40_1;
      logError('Error was captured in composition while live edit was enabled.', e);
      $this.d41_1.c3();
      $this.c41_1.c3();
      $this.b41_1 = new MutableScatterSet();
      $this.e41_1.c3();
      MultiValueMap__clear_impl_g4umn0($this.f41_1);
      $this.h41_1.c3();
      $this.o41_1.s21(new RecomposerErrorState(e, recoverable));
      if (!(failedInitialComposition == null)) {
        recordFailedCompositionLocked($this, failedInitialComposition);
      }
      if (!(deriveStateLocked($this) == null)) {
        composeImmediateRuntimeError('expected to go to inactive state due to composition error');
      }
    } else {
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      $this.w40_1;
      logError('Error was captured in composition.', e);
      var errorState = $this.o41_1.u1();
      if (errorState == null) {
        $this.o41_1.s21(new RecomposerErrorState(e, false));
      } else {
        throw errorState.m42_1;
      }
      throw e;
    }
  }
  function knownCompositions($this) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    return knownCompositionsLocked($this);
  }
  function knownCompositionsLocked($this) {
    var cache = $this.a41_1;
    if (!(cache == null))
      return cache;
    var compositions = $this.z40_1;
    var newCache = compositions.r() ? emptyList() : ArrayList_init_$Create$_1(compositions);
    $this.a41_1 = newCache;
    return newCache;
  }
  function clearKnownCompositionsLocked($this) {
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var this_0 = knownCompositionsLocked($this);
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        unregisterCompositionLocked($this, item);
      }
       while (inductionVariable <= last);
    $this.z40_1.c3();
    $this.a41_1 = emptyList();
  }
  function removeKnownCompositionLocked($this, composition) {
    if ($this.z40_1.d3(composition)) {
      $this.a41_1 = null;
      unregisterCompositionLocked($this, composition);
    }
  }
  function addKnownCompositionLocked($this, composition) {
    // Inline function 'kotlin.collections.plusAssign' call
    $this.z40_1.j1(composition);
    $this.a41_1 = null;
  }
  function registerCompositionLocked($this, composition) {
    var tmp0_safe_receiver = $this.u41_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.collection.ObjectList.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var content = tmp0_safe_receiver.sz_1;
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.tz_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = content[i];
          if (isInterface(composition, ObservableComposition)) {
            it.o42(composition);
          }
        }
         while (inductionVariable < last);
    }
  }
  function unregisterCompositionLocked($this, composition) {
    var tmp0_safe_receiver = $this.u41_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.collection.ObjectList.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var content = tmp0_safe_receiver.sz_1;
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.tz_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = content[i];
          if (isInterface(composition, ObservableComposition)) {
            it.p42(composition);
          }
        }
         while (inductionVariable < last);
    }
  }
  function recordFailedCompositionLocked($this, composition) {
    var tmp0_elvis_lhs = $this.j41_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.mutableListOf' call
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      $this.j41_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var failedCompositions = tmp;
    if (!failedCompositions.m1(composition)) {
      // Inline function 'kotlin.collections.plusAssign' call
      failedCompositions.j1(composition);
    }
    removeKnownCompositionLocked($this, composition);
  }
  function _get_hasSchedulingWork__b617oy($this) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    var tmp;
    var tmp_0;
    var tmp_1;
    if ($this.b41_1.fv()) {
      tmp_1 = true;
    } else {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      tmp_1 = !($this.c41_1.d3e_1 === 0);
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = _get_hasBroadcastFrameClockAwaitersLocked__7l4pm1($this);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = _get_hasNextFrameEndAwaitersLocked__u95b0($this);
    }
    return tmp;
  }
  function awaitWorkAvailable($this, $completion) {
    var tmp = new $awaitWorkAvailableCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function recompositionRunner($this, block, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.t9();
    var parentFrameClock = get_monotonicFrameClock(tmp$ret$0);
    return withContext($this.u40_1, Recomposer$recompositionRunner$slambda_0($this, block, parentFrameClock, null), $completion);
  }
  function performInitialMovableContentInserts($this, composition) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    var tmp0 = $this.e41_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.fastAny' call
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (equals(item.e35_1, composition)) {
            tmp$ret$2 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$2 = false;
    }
    if (!tmp$ret$2)
      return Unit_instance;
    // Inline function 'kotlin.collections.mutableListOf' call
    var toInsert = ArrayList_init_$Create$();
    performInitialMovableContentInserts$fillToInsert(toInsert, $this, composition);
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!toInsert.r()) {
        break $l$loop;
      }
      performInsertValues($this, toInsert, null);
      performInitialMovableContentInserts$fillToInsert(toInsert, $this, composition);
    }
  }
  function performRecompose($this, composition, modifiedValues) {
    var tmp;
    if (composition.x38() || composition.j39()) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = $this.k41_1;
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m1(composition)) === true;
    }
    if (tmp)
      return null;
    var tmp_0;
    $l$block_0: {
      // Inline function 'androidx.compose.runtime.Recomposer.composing' call
      var snapshot = Companion_instance_18.z42(readObserverOf($this, composition), writeObserverOf($this, composition, modifiedValues));
      try {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'androidx.compose.runtime.snapshots.Snapshot.enter' call
          var previous = snapshot.y41();
          try {
            if ((modifiedValues == null ? null : modifiedValues.fv()) === true) {
              composition.y39(Recomposer$performRecompose$lambda(modifiedValues, composition));
            }
            tmp$ret$1 = composition.l3a();
            break $l$block;
          }finally {
            snapshot.z41(previous);
          }
        }
        break $l$block_0;
      }finally {
        applyAndCheck($this, snapshot);
      }
    }
    if (tmp$ret$1) {
      tmp_0 = composition;
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  function performInsertValues($this, references, modifiedValues) {
    // Inline function 'androidx.compose.runtime.snapshots.fastGroupBy' call
    var destination = HashMap_init_$Create$(references.n1());
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var inductionVariable = 0;
    var last = references.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = references.l1(index);
        var key = item.e35_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var value = destination.w2(key);
        var tmp;
        if (value == null) {
          var answer = ArrayList_init_$Create$();
          destination.z2(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var list = tmp;
        list.j1(item);
      }
       while (inductionVariable <= last);
    var tasks = destination;
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = tasks.s1().t();
    while (_iterator__ex2g4s.u()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var composition = _destruct__k2r9zo.t1();
      // Inline function 'kotlin.collections.component2' call
      var refs = _destruct__k2r9zo.u1();
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!!composition.x38()) {
        var tmp$ret$11 = 'Check failed';
        composeImmediateRuntimeError(tmp$ret$11);
      }
      $l$block_4: {
        // Inline function 'androidx.compose.runtime.Recomposer.composing' call
        var snapshot = Companion_instance_18.z42(readObserverOf($this, composition), writeObserverOf($this, composition, modifiedValues));
        try {
          $l$block_3: {
            // Inline function 'androidx.compose.runtime.snapshots.Snapshot.enter' call
            var previous = snapshot.y41();
            try {
              // Inline function 'androidx.compose.runtime.platform.synchronized' call
              $this.w40_1;
              // Inline function 'androidx.compose.runtime.snapshots.fastMap' call
              var target = ArrayList_init_$Create$_0(refs.n1());
              // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
              var inductionVariable_0 = 0;
              var last_0 = refs.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = refs.l1(index_0);
                  // Inline function 'kotlin.also' call
                  var this_0 = MultiValueMap__removeLast_impl_h7l98v($this.f41_1, item_0.c35_1);
                  if (!(this_0 == null)) {
                    $this.g41_1.c43(this_0);
                  }
                  // Inline function 'kotlin.collections.plusAssign' call
                  var element = to(item_0, this_0);
                  target.j1(element);
                }
                 while (inductionVariable_0 <= last_0);
              // Inline function 'kotlin.let' call
              var tmp_0;
              var tmp$ret$26;
              $l$block: {
                // Inline function 'androidx.compose.runtime.snapshots.fastAny' call
                // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
                var inductionVariable_1 = 0;
                var last_1 = target.n1() - 1 | 0;
                if (inductionVariable_1 <= last_1)
                  do {
                    var index_1 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var item_1 = target.l1(index_1);
                    if (item_1.yh_1 == null && $this.g41_1.d43(item_1.xh_1.c35_1)) {
                      tmp$ret$26 = true;
                      break $l$block;
                    }
                  }
                   while (inductionVariable_1 <= last_1);
                tmp$ret$26 = false;
              }
              if (tmp$ret$26) {
                // Inline function 'androidx.compose.runtime.snapshots.fastMap' call
                var target_0 = ArrayList_init_$Create$_0(target.n1());
                // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
                var inductionVariable_2 = 0;
                var last_2 = target.n1() - 1 | 0;
                if (inductionVariable_2 <= last_2)
                  do {
                    var index_2 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var item_2 = target.l1(index_2);
                    var tmp$ret$33;
                    $l$block_0: {
                      var tmp_1;
                      if (item_2.yh_1 == null) {
                        var nestedContentReference = $this.g41_1.e43(item_2.xh_1.c35_1);
                        if (nestedContentReference == null) {
                          tmp$ret$33 = item_2;
                          break $l$block_0;
                        }
                        var content = nestedContentReference.f43_1;
                        var container = nestedContentReference.g43_1;
                        MultiValueMap__add_impl_ww0640($this.i41_1, container, content);
                        tmp_1 = to(item_2.xh_1, content);
                      } else {
                        tmp_1 = item_2;
                      }
                      tmp$ret$33 = tmp_1;
                    }
                    // Inline function 'kotlin.collections.plusAssign' call
                    var element_0 = tmp$ret$33;
                    target_0.j1(element_0);
                  }
                   while (inductionVariable_2 <= last_2);
                tmp_0 = target_0;
              } else {
                tmp_0 = target;
              }
              var pairs = tmp_0;
              var tmp_2;
              var tmp_3;
              var tmp$ret$35;
              $l$block_1: {
                // Inline function 'androidx.compose.runtime.snapshots.fastAll' call
                // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
                var inductionVariable_3 = 0;
                var last_3 = pairs.n1() - 1 | 0;
                if (inductionVariable_3 <= last_3)
                  do {
                    var index_3 = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var item_3 = pairs.l1(index_3);
                    if (!(item_3.yh_1 == null)) {
                      tmp$ret$35 = false;
                      break $l$block_1;
                    }
                  }
                   while (inductionVariable_3 <= last_3);
                tmp$ret$35 = true;
              }
              if (tmp$ret$35) {
                tmp_3 = true;
              } else {
                var tmp$ret$39;
                $l$block_2: {
                  // Inline function 'androidx.compose.runtime.snapshots.fastAll' call
                  // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
                  var inductionVariable_4 = 0;
                  var last_4 = pairs.n1() - 1 | 0;
                  if (inductionVariable_4 <= last_4)
                    do {
                      var index_4 = inductionVariable_4;
                      inductionVariable_4 = inductionVariable_4 + 1 | 0;
                      var item_4 = pairs.l1(index_4);
                      if (!!(item_4.yh_1 == null)) {
                        tmp$ret$39 = false;
                        break $l$block_2;
                      }
                    }
                     while (inductionVariable_4 <= last_4);
                  tmp$ret$39 = true;
                }
                tmp_3 = tmp$ret$39;
              }
              if (tmp_3) {
                tmp_2 = pairs;
              } else {
                // Inline function 'androidx.compose.runtime.snapshots.fastMapNotNull' call
                var target_1 = ArrayList_init_$Create$_0(pairs.n1());
                // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
                var inductionVariable_5 = 0;
                var last_5 = pairs.n1() - 1 | 0;
                if (inductionVariable_5 <= last_5)
                  do {
                    var index_5 = inductionVariable_5;
                    inductionVariable_5 = inductionVariable_5 + 1 | 0;
                    var item_5 = pairs.l1(index_5);
                    var tmp0_safe_receiver = item_5.yh_1 == null ? item_5.xh_1 : null;
                    if (tmp0_safe_receiver == null)
                      null;
                    else {
                      // Inline function 'kotlin.let' call
                      // Inline function 'kotlin.collections.plusAssign' call
                      target_1.j1(tmp0_safe_receiver);
                    }
                  }
                   while (inductionVariable_5 <= last_5);
                var toReturn = target_1;
                // Inline function 'androidx.compose.runtime.platform.synchronized' call
                $this.w40_1;
                // Inline function 'kotlin.collections.plusAssign' call
                var this_1 = $this.e41_1;
                addAll(this_1, toReturn);
                // Inline function 'androidx.compose.runtime.snapshots.fastFilterIndexed' call
                var target_2 = ArrayList_init_$Create$_0(pairs.n1());
                // Inline function 'androidx.compose.runtime.snapshots.fastForEachIndexed' call
                var inductionVariable_6 = 0;
                var last_6 = pairs.n1() - 1 | 0;
                if (inductionVariable_6 <= last_6)
                  do {
                    var index_6 = inductionVariable_6;
                    inductionVariable_6 = inductionVariable_6 + 1 | 0;
                    var item_6 = pairs.l1(index_6);
                    if (!(item_6.yh_1 == null)) {
                      // Inline function 'kotlin.collections.plusAssign' call
                      target_2.j1(item_6);
                    }
                  }
                   while (inductionVariable_6 <= last_6);
                tmp_2 = target_2;
              }
              var toInsert = tmp_2;
              composition.s3a(toInsert);
              break $l$block_3;
            }finally {
              snapshot.z41(previous);
            }
          }
          break $l$block_4;
        }finally {
          applyAndCheck($this, snapshot);
        }
      }
    }
    return toList_0(tasks.x2());
  }
  function discardUnusedMovableContentState($this) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.w40_1;
    var tmp;
    if (MultiValueMap__isNotEmpty_impl_ktqbr9($this.f41_1)) {
      var references = MultiValueMap__values_impl_vxaj3b($this.f41_1);
      MultiValueMap__clear_impl_g4umn0($this.f41_1);
      $this.g41_1.c3();
      MultiValueMap__clear_impl_g4umn0($this.i41_1);
      // Inline function 'androidx.compose.runtime.collection.fastMap' call
      var target = new MutableObjectList(references.n1());
      // Inline function 'androidx.collection.ObjectList.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var content = references.sz_1;
      var inductionVariable = 0;
      var last = references.tz_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = content[i];
          // Inline function 'androidx.collection.MutableObjectList.plusAssign' call
          var element = to(it, $this.h41_1.w2(it));
          target.j1(element);
        }
         while (inductionVariable < last);
      var unusedValues = target;
      $this.h41_1.c3();
      tmp = unusedValues;
    } else {
      tmp = emptyObjectList();
    }
    var unusedValues_0 = tmp;
    // Inline function 'androidx.collection.ObjectList.forEach' call
    // Inline function 'kotlin.contracts.contract' call
    var content_0 = unusedValues_0.sz_1;
    var inductionVariable_0 = 0;
    var last_0 = unusedValues_0.tz_1;
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var destruct = content_0[i_0];
        var reference = destruct.zh();
        var state = destruct.ai();
        if (!(state == null)) {
          reference.e35_1.t3a(state);
        }
      }
       while (inductionVariable_0 < last_0);
  }
  function readObserverOf($this, composition) {
    return Recomposer$readObserverOf$lambda(composition);
  }
  function writeObserverOf($this, composition, modifiedValues) {
    return Recomposer$writeObserverOf$lambda(composition, modifiedValues);
  }
  function applyAndCheck($this, snapshot) {
    try {
      var applyResult = snapshot.u43();
      if (applyResult instanceof Failure) {
        // Inline function 'kotlin.error' call
        var message = 'Unsupported concurrent change during composition. A state object was modified by composition as well as being modified outside composition.';
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }finally {
      snapshot.s1d();
    }
  }
  function _get_hasFrameWorkLocked__1gtyf7($this) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
    if (!($this.c41_1.d3e_1 === 0)) {
      tmp_1 = true;
    } else {
      tmp_1 = _get_hasBroadcastFrameClockAwaitersLocked__7l4pm1($this);
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = _get_hasNextFrameEndAwaitersLocked__u95b0($this);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = MultiValueMap__isNotEmpty_impl_ktqbr9($this.f41_1);
    }
    return tmp;
  }
  function Companion_6() {
    Companion_instance_7 = this;
    this.r40_1 = MutableStateFlow(persistentSetOf());
    this.s40_1 = new AtomicReference(false);
  }
  var Companion_instance_7;
  function Companion_getInstance_6() {
    if (Companion_instance_7 == null)
      new Companion_6();
    return Companion_instance_7;
  }
  function Recomposer$broadcastFrameClock$lambda(this$0) {
    return function () {
      onNewFrameAwaiter(this$0);
      return Unit_instance;
    };
  }
  function Recomposer$nextFrameEndCallbackQueue$lambda(this$0) {
    return function () {
      onNewFrameAwaiter(this$0);
      return Unit_instance;
    };
  }
  function Recomposer$effectJob$lambda$lambda(this$0, $throwable) {
    return function (runnerJobCause) {
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this$0.w40_1;
      var tmp = this$0;
      var tmp0_safe_receiver = $throwable;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.apply' call
        var tmp_1;
        if (runnerJobCause == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_2;
          if (!(runnerJobCause instanceof CancellationException)) {
            tmp_2 = runnerJobCause;
          } else {
            tmp_2 = null;
          }
          tmp_1 = tmp_2;
        }
        var tmp1_safe_receiver = tmp_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          addSuppressed(tmp0_safe_receiver, tmp1_safe_receiver);
        }
        tmp_0 = tmp0_safe_receiver;
      }
      tmp.y40_1 = tmp_0;
      this$0.q41_1.s21(State_ShutDown_getInstance());
      return Unit_instance;
    };
  }
  function Recomposer$effectJob$lambda(this$0) {
    return function (throwable) {
      var cancellation = CancellationException_init_$Create$('Recomposer effect job completed', throwable);
      var continuationToResume = null;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this$0.w40_1;
      var runnerJob = this$0.x40_1;
      var tmp;
      if (!(runnerJob == null)) {
        this$0.q41_1.s21(State_ShuttingDown_getInstance());
        if (!this$0.n41_1) {
          runnerJob.a1b(cancellation);
        } else if (!(this$0.l41_1 == null)) {
          continuationToResume = this$0.l41_1;
        }
        this$0.l41_1 = null;
        tmp = runnerJob.t1a(Recomposer$effectJob$lambda$lambda(this$0, throwable));
      } else {
        this$0.y40_1 = cancellation;
        this$0.q41_1.s21(State_ShutDown_getInstance());
        tmp = Unit_instance;
      }
      var tmp0_safe_receiver = continuationToResume;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.y9(tmp$ret$3);
      }
      return Unit_instance;
    };
  }
  function Recomposer$runRecomposeAndApplyChanges$slambda(this$0, resultContinuation) {
    this.d44_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Recomposer$runRecomposeAndApplyChanges$slambda).o44 = function ($this$recompositionRunner, parentFrameClock, $completion) {
    var tmp = this.p44($this$recompositionRunner, parentFrameClock, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Recomposer$runRecomposeAndApplyChanges$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE();
    return this.o44(tmp, (!(p2 == null) ? isInterface(p2, MonotonicFrameClock) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(Recomposer$runRecomposeAndApplyChanges$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            var tmp_0 = this;
            tmp_0.n44_1 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1.k44_1 = ArrayList_init_$Create$();
            var tmp_2 = this;
            tmp_2.j44_1 = ArrayList_init_$Create$();
            this.h44_1 = mutableScatterSetOf();
            this.g44_1 = mutableScatterSetOf();
            this.m44_1 = new MutableScatterSet();
            this.i44_1 = wrapIntoSet(this.m44_1);
            this.l44_1 = mutableScatterSetOf();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!_get_shouldKeepRecomposing__5j79sd(this.d44_1)) {
              this.n9_1 = 5;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = awaitWorkAvailable(this.d44_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!recordComposerModifications(this.d44_1)) {
              this.n9_1 = 1;
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            this.n9_1 = 4;
            suspendResult = this.f44_1.r2z(Recomposer$runRecomposeAndApplyChanges$slambda$lambda(this.d44_1, this.n44_1, this.m44_1, this.l44_1, this.k44_1, this.j44_1, this.i44_1, this.h44_1, this.g44_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            discardUnusedMovableContentState(this.d44_1);
            this.d44_1.v40_1.d3y();
            this.n9_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Recomposer$runRecomposeAndApplyChanges$slambda).p44 = function ($this$recompositionRunner, parentFrameClock, completion) {
    var i = new Recomposer$runRecomposeAndApplyChanges$slambda(this.d44_1, completion);
    i.e44_1 = $this$recompositionRunner;
    i.f44_1 = parentFrameClock;
    return i;
  };
  function Recomposer$runRecomposeAndApplyChanges$slambda_0(this$0, resultContinuation) {
    var i = new Recomposer$runRecomposeAndApplyChanges$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$recompositionRunner, parentFrameClock, $completion) {
      return i.o44($this$recompositionRunner, parentFrameClock, $completion);
    }, 2);
  }
  function Recomposer$recompositionRunner$slambda(this$0, $block, $parentFrameClock, resultContinuation) {
    this.y44_1 = this$0;
    this.z44_1 = $block;
    this.a45_1 = $parentFrameClock;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Recomposer$recompositionRunner$slambda).p24 = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Recomposer$recompositionRunner$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Recomposer$recompositionRunner$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.c45_1 = get_job(this.b45_1.q19());
            registerRunnerJob(this.y44_1, this.c45_1);
            var tmp_0 = this;
            var tmp_1 = Companion_instance_18;
            tmp_0.d45_1 = tmp_1.e45(Recomposer$recompositionRunner$slambda$lambda(this.y44_1));
            addRunning(Companion_getInstance_6(), this.y44_1.v41_1);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            var this_0 = knownCompositions(this.y44_1);
            var inductionVariable = 0;
            var last = this_0.n1() - 1 | 0;
            if (inductionVariable <= last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var item = this_0.l1(index);
                item.z3a();
              }
               while (inductionVariable <= last);
            this.n9_1 = 2;
            suspendResult = coroutineScope(Recomposer$recompositionRunner$slambda$slambda_0(this.z44_1, this.a45_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            this.d45_1.s1d();
            this.y44_1.w40_1;
            if (this.y44_1.x40_1 === this.c45_1) {
              this.y44_1.x40_1 = null;
            }

            if (!(deriveStateLocked(this.y44_1) == null)) {
              composeImmediateRuntimeError('called outside of runRecomposeAndApplyChanges');
            }

            removeRunning(Companion_getInstance_6(), this.y44_1.v41_1);
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            this.d45_1.s1d();
            this.y44_1.w40_1;
            if (this.y44_1.x40_1 === this.c45_1) {
              this.y44_1.x40_1 = null;
            }

            if (!(deriveStateLocked(this.y44_1) == null)) {
              composeImmediateRuntimeError('called outside of runRecomposeAndApplyChanges');
            }

            removeRunning(Companion_getInstance_6(), this.y44_1.v41_1);
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Recomposer$recompositionRunner$slambda).q24 = function ($this$withContext, completion) {
    var i = new Recomposer$recompositionRunner$slambda(this.y44_1, this.z44_1, this.a45_1, completion);
    i.b45_1 = $this$withContext;
    return i;
  };
  function Recomposer$recompositionRunner$slambda_0(this$0, $block, $parentFrameClock, resultContinuation) {
    var i = new Recomposer$recompositionRunner$slambda(this$0, $block, $parentFrameClock, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.p24($this$withContext, $completion);
    }, 1);
  }
  function performInitialMovableContentInserts$fillToInsert(toInsert, this$0, $composition) {
    toInsert.c3();
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this$0.w40_1;
    var iterator = this$0.e41_1.t();
    while (iterator.u()) {
      var value = iterator.v();
      if (equals(value.e35_1, $composition)) {
        toInsert.j1(value);
        iterator.l4();
      }
    }
  }
  function Recomposer$performRecompose$lambda($modifiedValues, $composition) {
    return function () {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      var this_0 = $modifiedValues;
      // Inline function 'kotlin.contracts.contract' call
      var elements = this_0.k16_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = this_0.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var it = elements[index];
                    $composition.k3a(it);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
      return Unit_instance;
    };
  }
  function Recomposer$readObserverOf$lambda($composition) {
    return function (value) {
      $composition.k36(value);
      return Unit_instance;
    };
  }
  function Recomposer$writeObserverOf$lambda($composition, $modifiedValues) {
    return function (value) {
      $composition.k3a(value);
      var tmp0_safe_receiver = $modifiedValues;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.j1(value);
      return Unit_instance;
    };
  }
  function deletedMovableContent$recordNestedStatesOf(this$0, container, reference) {
    var tmp0_safe_receiver = reference.j35_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0_safe_receiver.l1(index);
          this$0.g41_1.f45(item.c35_1, new NestedMovableContent(item, container));
          deletedMovableContent$recordNestedStatesOf(this$0, container, item);
        }
         while (inductionVariable <= last);
    }
  }
  function State_ShutDown_getInstance() {
    State_initEntries();
    return State_ShutDown_instance;
  }
  function State_ShuttingDown_getInstance() {
    State_initEntries();
    return State_ShuttingDown_instance;
  }
  function State_Inactive_getInstance() {
    State_initEntries();
    return State_Inactive_instance;
  }
  function State_InactivePendingWork_getInstance() {
    State_initEntries();
    return State_InactivePendingWork_instance;
  }
  function State_Idle_getInstance() {
    State_initEntries();
    return State_Idle_instance;
  }
  function State_PendingWork_getInstance() {
    State_initEntries();
    return State_PendingWork_instance;
  }
  function $awaitWorkAvailableCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y42_1 = _this__u8e3s4;
  }
  protoOf($awaitWorkAvailableCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (!_get_hasSchedulingWork__b617oy(this.y42_1)) {
              this.n9_1 = 1;
              var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
              cancellable.v1e();
              this.y42_1.w40_1;
              var tmp_0;
              if (_get_hasSchedulingWork__b617oy(this.y42_1)) {
                tmp_0 = cancellable;
              } else {
                this.y42_1.l41_1 = cancellable;
                tmp_0 = null;
              }
              var tmp0_safe_receiver = tmp_0;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.y9(_Result___init__impl__xyqfz8(Unit_instance));
              }
              suspendResult = returnIfSuspended(cancellable.x1b(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function Recomposer(effectCoroutineContext) {
    Companion_getInstance_6();
    CompositionContext.call(this);
    this.t40_1 = new Long(0, 0);
    var tmp = this;
    tmp.u40_1 = new BroadcastFrameClock(Recomposer$broadcastFrameClock$lambda(this));
    var tmp_0 = this;
    tmp_0.v40_1 = new NextFrameEndCallbackQueue(Recomposer$nextFrameEndCallbackQueue$lambda(this));
    var tmp_1 = this;
    // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
    tmp_1.w40_1 = null == null ? new Object() : null;
    this.x40_1 = null;
    this.y40_1 = null;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.z40_1 = ArrayList_init_$Create$();
    this.a41_1 = null;
    this.b41_1 = new MutableScatterSet();
    var tmp_3 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$4 = Array(16);
    tmp_3.c41_1 = new MutableVector(tmp$ret$4, 0);
    var tmp_4 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_4.d41_1 = ArrayList_init_$Create$();
    var tmp_5 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_5.e41_1 = ArrayList_init_$Create$();
    this.f41_1 = _MultiValueMap___init__impl__qt1z0r();
    this.g41_1 = new NestedContentMap();
    this.h41_1 = mutableScatterMapOf();
    this.i41_1 = _MultiValueMap___init__impl__qt1z0r();
    this.j41_1 = null;
    this.k41_1 = null;
    this.l41_1 = null;
    this.m41_1 = 0;
    this.n41_1 = false;
    this.o41_1 = MutableStateFlow(null);
    this.p41_1 = false;
    this.q41_1 = MutableStateFlow(State_Inactive_getInstance());
    this.r41_1 = new SnapshotThreadLocal();
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_0 = Job(effectCoroutineContext.aa(Key_instance_0));
    this_0.t1a(Recomposer$effectJob$lambda(this));
    tmp_6.s41_1 = this_0;
    this.t41_1 = effectCoroutineContext.xj(this.u40_1).xj(this.s41_1);
    this.u41_1 = null;
    this.v41_1 = new RecomposerInfoImpl(this);
  }
  protoOf(Recomposer).r3b = function () {
    return this.t41_1;
  };
  protoOf(Recomposer).g45 = function ($completion) {
    return recompositionRunner(this, Recomposer$runRecomposeAndApplyChanges$slambda_0(this, null), $completion);
  };
  protoOf(Recomposer).e2z = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    if (this.q41_1.u1().i3(State_Idle_getInstance()) >= 0) {
      this.q41_1.s21(State_ShuttingDown_getInstance());
    }
    this.s41_1.b1b();
  };
  protoOf(Recomposer).o37 = function (composition, content) {
    var composerWasComposing = composition.x38();
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    var tmp;
    if (this.q41_1.u1().i3(State_ShuttingDown_getInstance()) > 0) {
      var new_0 = !knownCompositionsLocked(this).m1(composition);
      if (new_0) {
        registerCompositionLocked(this, composition);
      }
      tmp = new_0;
    } else {
      tmp = true;
    }
    var newComposition = tmp;
    try {
      $l$block_0: {
        // Inline function 'androidx.compose.runtime.Recomposer.composing' call
        var snapshot = Companion_instance_18.z42(readObserverOf(this, composition), writeObserverOf(this, composition, null));
        try {
          $l$block: {
            // Inline function 'androidx.compose.runtime.snapshots.Snapshot.enter' call
            var previous = snapshot.y41();
            try {
              composition.q39(content);
              break $l$block;
            }finally {
              snapshot.z41(previous);
            }
          }
          break $l$block_0;
        }finally {
          applyAndCheck(this, snapshot);
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        if (newComposition) {
          // Inline function 'androidx.compose.runtime.platform.synchronized' call
          this.w40_1;
          unregisterCompositionLocked(this, composition);
        }
        processCompositionError(this, e, composition, true);
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    if (this.q41_1.u1().i3(State_ShuttingDown_getInstance()) > 0) {
      if (!knownCompositionsLocked(this).m1(composition)) {
        addKnownCompositionLocked(this, composition);
      }
    } else {
      unregisterCompositionLocked(this, composition);
    }
    if (!composerWasComposing) {
      Companion_instance_18.x3e();
    }
    try {
      performInitialMovableContentInserts(this, composition);
    } catch ($p_0) {
      if ($p_0 instanceof Error) {
        var e_0 = $p_0;
        processCompositionError(this, e_0, composition, true);
        return Unit_instance;
      } else {
        throw $p_0;
      }
    }
    try {
      composition.w3a();
      composition.x3a();
    } catch ($p_1) {
      if ($p_1 instanceof Error) {
        var e_1 = $p_1;
        processCompositionError(this, e_1);
        return Unit_instance;
      } else {
        throw $p_1;
      }
    }
    if (!composerWasComposing) {
      Companion_instance_18.x3e();
    }
  };
  protoOf(Recomposer).t3b = function (composition, shouldPause, content) {
    var tmp;
    try {
      // Inline function 'androidx.compose.runtime.pausable' call
      var previous = composition.b3b(shouldPause);
      var tmp_0;
      try {
        this.o37(composition, content);
        var tmp0_elvis_lhs = this.r41_1.f1i();
        tmp_0 = tmp0_elvis_lhs == null ? emptyScatterSet() : tmp0_elvis_lhs;
      }finally {
        composition.b3b(previous);
      }
      tmp = tmp_0;
    }finally {
      this.r41_1.r3e(null);
    }
    return tmp;
  };
  protoOf(Recomposer).u3b = function (composition, shouldPause, invalidScopes) {
    var tmp;
    try {
      recordComposerModifications(this);
      composition.w39(wrapIntoSet(invalidScopes));
      // Inline function 'androidx.compose.runtime.pausable' call
      var previous = composition.b3b(shouldPause);
      var tmp_0;
      try {
        var needsApply = performRecompose(this, composition, null);
        if (!(needsApply == null)) {
          performInitialMovableContentInserts(this, composition);
          needsApply.w3a();
          needsApply.x3a();
        }
        var tmp0_elvis_lhs = this.r41_1.f1i();
        tmp_0 = tmp0_elvis_lhs == null ? emptyScatterSet() : tmp0_elvis_lhs;
      }finally {
        composition.b3b(previous);
      }
      tmp = tmp_0;
    }finally {
      this.r41_1.r3e(null);
    }
    return tmp;
  };
  protoOf(Recomposer).v3b = function (scope) {
    var tmp0_elvis_lhs = this.r41_1.f1i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var newScopes = mutableScatterSetOf();
      this.r41_1.r3e(newScopes);
      tmp = newScopes;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var scopes = tmp;
    scopes.j1(scope);
  };
  protoOf(Recomposer).o3b = function () {
    // Inline function 'androidx.compose.runtime.RecomposerCompoundHashKey' call
    // Inline function 'androidx.compose.runtime.CompositeKeyHashCode' call
    return fromInt(1000);
  };
  protoOf(Recomposer).e39 = function () {
    return Companion_getInstance_6().s40_1.f1i();
  };
  protoOf(Recomposer).p3b = function () {
    return false;
  };
  protoOf(Recomposer).f39 = function () {
    return get_composeStackTraceMode() === Companion_getInstance_21().n36_1;
  };
  protoOf(Recomposer).q3b = function () {
    return !(get_composeStackTraceMode() === Companion_getInstance_21().l36_1);
  };
  protoOf(Recomposer).w3b = function (table) {
  };
  protoOf(Recomposer).u39 = function (composition) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    removeKnownCompositionLocked(this, composition);
    // Inline function 'androidx.compose.runtime.collection.MutableVector.minusAssign' call
    this.c41_1.g10(composition);
    // Inline function 'kotlin.collections.minusAssign' call
    this.d41_1.d3(composition);
  };
  protoOf(Recomposer).z38 = function (composition) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    var tmp;
    if (!this.c41_1.lh(composition)) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
      this.c41_1.zz(composition);
      tmp = deriveStateLocked(this);
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.y9(tmp$ret$4);
    }
  };
  protoOf(Recomposer).a3c = function (reference) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    // Inline function 'kotlin.collections.plusAssign' call
    this.e41_1.j1(reference);
    var tmp0_safe_receiver = deriveStateLocked(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.y9(tmp$ret$4);
    }
  };
  protoOf(Recomposer).b3c = function (reference) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    MultiValueMap__add_impl_ww0640(this.f41_1, reference.c35_1, reference);
    if (!(reference.j35_1 == null)) {
      var container = reference;
      deletedMovableContent$recordNestedStatesOf(this, container, reference);
    }
    var tmp0_safe_receiver = deriveStateLocked(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.y9(tmp$ret$3);
    }
  };
  protoOf(Recomposer).c3c = function (reference, data, applier) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    this.h41_1.h13(reference, data);
    var extractions = MultiValueMap__get_impl_k8msu3(this.i41_1, reference);
    if (extractions.fv()) {
      var states = data.u3a_1.m3b(applier, extractions);
      // Inline function 'androidx.collection.ScatterMap.forEach' call
      var k = states.x12_1;
      var v = states.y12_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = states.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_0 = slot;
            var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var tmp0 = k[index];
                    var state = v[index];
                    this.h41_1.h13(tmp0, state);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
  };
  protoOf(Recomposer).e3c = function (composition) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    var tmp0_elvis_lhs = this.k41_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = mutableScatterSetOf();
      this.k41_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var compositionsRemoved = tmp;
    compositionsRemoved.j1(composition);
  };
  protoOf(Recomposer).d3c = function (reference) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.w40_1;
    return this.h41_1.a3(reference);
  };
  protoOf(Recomposer).s3b = function () {
    return null;
  };
  function NestedContentMap$usedContainer$lambda($reference) {
    return function (it) {
      return equals(it.g43_1, $reference);
    };
  }
  function NestedContentMap$usedContainer$lambda_0($reference) {
    return function (it) {
      return equals(it.g43_1, $reference);
    };
  }
  function NestedContentMap() {
    this.a43_1 = _MultiValueMap___init__impl__qt1z0r();
    this.b43_1 = _MultiValueMap___init__impl__qt1z0r();
  }
  protoOf(NestedContentMap).f45 = function (content, nestedContent) {
    MultiValueMap__add_impl_ww0640(this.a43_1, content, nestedContent);
    MultiValueMap__add_impl_ww0640(this.b43_1, nestedContent.g43_1, content);
  };
  protoOf(NestedContentMap).c3 = function () {
    MultiValueMap__clear_impl_g4umn0(this.a43_1);
    MultiValueMap__clear_impl_g4umn0(this.b43_1);
  };
  protoOf(NestedContentMap).e43 = function (key) {
    // Inline function 'kotlin.also' call
    var this_0 = MultiValueMap__removeLast_impl_h7l98v(this.a43_1, key);
    if (MultiValueMap__isEmpty_impl_n67ooe(this.a43_1)) {
      MultiValueMap__clear_impl_g4umn0(this.b43_1);
    }
    return this_0;
  };
  protoOf(NestedContentMap).d43 = function (key) {
    return MultiValueMap__contains_impl_2yjtfa(this.a43_1, key);
  };
  protoOf(NestedContentMap).c43 = function (reference) {
    // Inline function 'androidx.compose.runtime.collection.MultiValueMap.forEachValue' call
    var this_0 = this.b43_1;
    var tmp0_safe_receiver = access$_get_map__v7axsb(this_0).w2(reference);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (tmp0_safe_receiver instanceof MutableObjectList) {
        // Inline function 'androidx.collection.ObjectList.forEach' call
        // Inline function 'kotlin.contracts.contract' call
        var content = tmp0_safe_receiver.sz_1;
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.tz_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var value = content[i];
            var value_0 = !(value == null) ? value : THROW_CCE();
            MultiValueMap__removeValueIf_impl_q0rlrt(this.a43_1, value_0, NestedContentMap$usedContainer$lambda(reference));
          }
           while (inductionVariable < last);
      } else {
        var value_1 = !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
        MultiValueMap__removeValueIf_impl_q0rlrt(this.a43_1, value_1, NestedContentMap$usedContainer$lambda_0(reference));
      }
    }
  };
  function NestedMovableContent(content, container) {
    this.f43_1 = content;
    this.g43_1 = container;
  }
  function RememberObserver() {
  }
  var androidx_compose_runtime_SnapshotMutableDoubleStateImpl$stable;
  var androidx_compose_runtime_SnapshotMutableFloatStateImpl$stable;
  function MutableFloatState() {
  }
  function mutableFloatStateOf(value) {
    return createSnapshotMutableFloatState(value);
  }
  function FloatStateStateRecord(snapshotId, value) {
    StateRecord.call(this, snapshotId);
    this.m45_1 = value;
  }
  protoOf(FloatStateStateRecord).q3d = function (value) {
    var tmp = this;
    tmp.m45_1 = (value instanceof FloatStateStateRecord ? value : THROW_CCE()).m45_1;
  };
  protoOf(FloatStateStateRecord).r3d = function () {
    return this.x3d(currentSnapshot().w3d());
  };
  protoOf(FloatStateStateRecord).x3d = function (snapshotId) {
    return new FloatStateStateRecord(snapshotId, this.m45_1);
  };
  function SnapshotMutableFloatStateImpl(value) {
    StateObjectImpl.call(this);
    var tmp = this;
    // Inline function 'kotlin.let' call
    var snapshot = currentSnapshot();
    // Inline function 'kotlin.also' call
    var this_0 = new FloatStateStateRecord(snapshot.w3d(), value);
    if (!(snapshot instanceof GlobalSnapshot)) {
      this_0.m3e_1 = new FloatStateStateRecord(toSnapshotId(1), value);
    }
    tmp.o45_1 = this_0;
  }
  protoOf(SnapshotMutableFloatStateImpl).f3e = function () {
    return this.o45_1;
  };
  protoOf(SnapshotMutableFloatStateImpl).i45 = function (value) {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.o45_1;
    var it = current_0(this_0);
    if (!(it.m45_1 === value)) {
      // Inline function 'androidx.compose.runtime.snapshots.overwritable' call
      var this_1 = this.o45_1;
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      overwritableRecord(this_1, this, snapshot, it).m45_1 = value;
      // Inline function 'kotlin.also' call
      notifyWrite(snapshot, this);
    }
    return Unit_instance;
  };
  protoOf(SnapshotMutableFloatStateImpl).j45 = function () {
    return readable_0(this.o45_1, this).m45_1;
  };
  protoOf(SnapshotMutableFloatStateImpl).h3d = function () {
    return structuralEqualityPolicy();
  };
  protoOf(SnapshotMutableFloatStateImpl).y3e = function (value) {
    var tmp = this;
    tmp.o45_1 = value instanceof FloatStateStateRecord ? value : THROW_CCE();
  };
  protoOf(SnapshotMutableFloatStateImpl).a3f = function (previous, current, applied) {
    var currentRecord = current instanceof FloatStateStateRecord ? current : THROW_CCE();
    var appliedRecord = applied instanceof FloatStateStateRecord ? applied : THROW_CCE();
    var tmp;
    if (currentRecord.m45_1 === appliedRecord.m45_1) {
      tmp = current;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SnapshotMutableFloatStateImpl).toString = function () {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.o45_1;
    return 'MutableFloatState(value=' + current_0(this_0).m45_1 + ')@' + hashCode(this);
  };
  protoOf(SnapshotMutableFloatStateImpl).s21 = function (_set____db54di) {
    return this.h45((!(_set____db54di == null) ? typeof _set____db54di === 'number' : false) ? _set____db54di : THROW_CCE());
  };
  var androidx_compose_runtime_SnapshotFlowManager$stable;
  var androidx_compose_runtime_SnapshotFlowManagerImpl$stable;
  function snapshotFlow(block) {
    return snapshotFlowImpl(null, block);
  }
  function snapshotFlowImpl(externalManager, block) {
    return flow(snapshotFlowImpl$slambda_0(externalManager, block, null));
  }
  function SnapshotFlowManager() {
    this.p45_1 = new SingleSubscriptionSnapshotFlowManager();
  }
  protoOf(SnapshotFlowManager).q45 = function (channel, block) {
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!!(this.p45_1 == null)) {
      var tmp$ret$1 = 'Called runAndWatch on a manager that has been disposed of';
      throwIllegalStateException(tmp$ret$1);
    }
    var managerImplRef = this.p45_1;
    if (managerImplRef instanceof SingleSubscriptionSnapshotFlowManager) {
      var subscribedChannel = managerImplRef.w45_1;
      if (!(subscribedChannel == null) && !equals(subscribedChannel, channel)) {
        this.p45_1 = managerImplRef.z45();
      }
    }
    return ensureNotNull(this.p45_1).q45(channel, block);
  };
  protoOf(SnapshotFlowManager).b46 = function (channel) {
    var tmp0_safe_receiver = this.p45_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b46(channel);
    }
  };
  protoOf(SnapshotFlowManager).s1d = function () {
    // Inline function 'kotlin.let' call
    var it = this.p45_1;
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!!(it == null)) {
      var tmp$ret$3 = 'Called dispose on a manager that has been disposed of';
      throwIllegalStateException(tmp$ret$3);
    }
    it.y32();
    this.p45_1 = null;
  };
  function SnapshotFlowManagerImpl() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
    tmp.a46_1 = null == null ? new Object() : null;
  }
  protoOf(SnapshotFlowManagerImpl).q45 = function (channel, block) {
    // Inline function 'kotlin.run' call
    var $this$run = Companion_instance_18.f46(this.c46(channel));
    this.d46(channel);
    var tmp;
    try {
      var tmp$ret$2;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Snapshot.enter' call
        var previous = $this$run.y41();
        try {
          tmp$ret$2 = block();
          break $l$block;
        }finally {
          $this$run.z41(previous);
        }
      }
      tmp = tmp$ret$2;
    }finally {
      $this$run.s1d();
    }
    var result = tmp;
    this.e46();
    return result;
  };
  function clearWatchSetImpl($this) {
    $this.t45_1 = null;
    $this.v45_1 = null;
  }
  function SingleSubscriptionSnapshotFlowManager$readObserverCache$lambda(this$0) {
    return function (obj) {
      this$0.g46(ensureNotNull(this$0.w45_1), obj);
      return Unit_instance;
    };
  }
  function SingleSubscriptionSnapshotFlowManager$unregisterApplyObserver$lambda(this$0) {
    return function (changed, _unused_var__etf5q3) {
      var toNotify = null;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this$0.a46_1;
      var watchSet = this$0.u45_1;
      if (watchSet == null) {
        if (contains(changed, this$0.s45_1)) {
          toNotify = this$0.w45_1;
        }
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'androidx.collection.ScatterSet.any' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'androidx.collection.ScatterSet.forEach' call
          // Inline function 'kotlin.contracts.contract' call
          var elements = watchSet.k16_1;
          $l$block_0: {
            // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
            // Inline function 'kotlin.contracts.contract' call
            var m = watchSet.j16_1;
            var lastIndex = m.length - 2 | 0;
            var inductionVariable = 0;
            if (inductionVariable <= lastIndex)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var slot = m[i];
                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                var this_0 = slot;
                var tmp$ret$8 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
                if (!equalsLong(tmp$ret$8, new Long(-2139062144, -2139062144))) {
                  var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                  var inductionVariable_0 = 0;
                  if (inductionVariable_0 < bitCount)
                    do {
                      var j = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      // Inline function 'androidx.collection.isFull' call
                      var value = bitwiseAnd(slot, new Long(255, 0));
                      if (compare(value, new Long(128, 0)) < 0) {
                        var index = (i << 3) + j | 0;
                        var it = elements[index];
                        if (changed.m1(it)) {
                          tmp$ret$2 = true;
                          break $l$block;
                        }
                      }
                      slot = shiftRight(slot, 8);
                    }
                     while (inductionVariable_0 < bitCount);
                  if (!(bitCount === 8)) {
                    break $l$block_0;
                  }
                }
              }
               while (!(i === lastIndex));
          }
          tmp$ret$2 = false;
        }
        if (tmp$ret$2) {
          toNotify = this$0.w45_1;
        }
      }
      var tmp0_safe_receiver = toNotify;
      if (tmp0_safe_receiver == null)
        null;
      else
        new ChannelResult(tmp0_safe_receiver.s1s(Unit_instance));
      return Unit_instance;
    };
  }
  function SingleSubscriptionSnapshotFlowManager() {
    SnapshotFlowManagerImpl.call(this);
    this.s45_1 = null;
    this.t45_1 = null;
    this.u45_1 = null;
    this.v45_1 = null;
    this.w45_1 = null;
    var tmp = this;
    tmp.x45_1 = SingleSubscriptionSnapshotFlowManager$readObserverCache$lambda(this);
    var tmp_0 = this;
    var tmp_1 = Companion_instance_18;
    tmp_0.y45_1 = tmp_1.e45(SingleSubscriptionSnapshotFlowManager$unregisterApplyObserver$lambda(this));
  }
  protoOf(SingleSubscriptionSnapshotFlowManager).g46 = function (channel, obj) {
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!equals(this.w45_1, channel)) {
      var tmp$ret$1 = 'Requested a SingleSubscriptionSnapshotFlowManager to manage multiple subscriptions';
      throwIllegalStateException(tmp$ret$1);
    }
    var workingWatchSetRef = this.v45_1;
    var workingSoleWatchedObjectRef = this.t45_1;
    if (workingWatchSetRef == null) {
      if (workingSoleWatchedObjectRef == null) {
        this.t45_1 = obj;
      } else {
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = mutableScatterSetOf();
        this_0.j1(workingSoleWatchedObjectRef);
        this_0.j1(obj);
        tmp.v45_1 = this_0;
        this.t45_1 = null;
      }
    } else {
      // Inline function 'androidx.compose.runtime.checkPrecondition' call
      if (!(this.t45_1 == null)) {
        var tmp$ret$5 = 'workingSoleWatchedObject must be null when workingWatchSet is non-null';
        throwIllegalStateException(tmp$ret$5);
      }
      workingWatchSetRef.j1(obj);
    }
  };
  protoOf(SingleSubscriptionSnapshotFlowManager).c46 = function (channel) {
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!(this.w45_1 == null || equals(this.w45_1, channel))) {
      var tmp$ret$1 = 'Requested a SingleSubscriptionSnapshotFlowManager to manage multiple subscriptions';
      throwIllegalStateException(tmp$ret$1);
    }
    this.w45_1 = channel;
    return this.x45_1;
  };
  protoOf(SingleSubscriptionSnapshotFlowManager).d46 = function (channel) {
    return clearWatchSetImpl(this);
  };
  protoOf(SingleSubscriptionSnapshotFlowManager).e46 = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.a46_1;
    this.s45_1 = this.t45_1;
    if (this.v45_1 == null) {
      this.u45_1 = null;
    } else {
      if (this.u45_1 == null) {
        this.u45_1 = mutableScatterSetOf();
      }
      var temp = this.u45_1;
      this.u45_1 = this.v45_1;
      this.v45_1 = temp;
    }
  };
  protoOf(SingleSubscriptionSnapshotFlowManager).b46 = function (channel) {
    this.w45_1 = null;
    this.d46(channel);
    this.e46();
  };
  protoOf(SingleSubscriptionSnapshotFlowManager).y32 = function () {
    this.y45_1.s1d();
    clearWatchSetImpl(this);
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.a46_1;
    this.w45_1 = null;
    this.s45_1 = null;
    this.u45_1 = null;
  };
  protoOf(SingleSubscriptionSnapshotFlowManager).z45 = function () {
    // Inline function 'kotlin.also' call
    var this_0 = new MultiSubscriptionSnapshotFlowManager();
    var subscribedChannel = this.w45_1;
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!!(subscribedChannel == null)) {
      var tmp$ret$3 = 'promote must only be called when a manager is managing subscriptions for one channel and needs to start managing them for a second';
      throwIllegalStateException(tmp$ret$3);
    }
    var watchSet = this.u45_1;
    if (watchSet == null) {
      this_0.g46(subscribedChannel, ensureNotNull(this.s45_1));
    } else {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var elements = watchSet.k16_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = watchSet.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$8 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$8, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var obj = elements[index];
                    this_0.g46(subscribedChannel, obj);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
    this_0.e46();
    var multiSubscriptionManager = this_0;
    this.y32();
    return multiSubscriptionManager;
  };
  function Add(obj, channel) {
    this.n46_1 = obj;
    this.o46_1 = channel;
  }
  function RemoveScope(channel) {
    this.p46_1 = channel;
  }
  function MultiSubscriptionSnapshotFlowManager$unregisterApplyObserver$lambda$lambda($changed, this$0) {
    return function (key) {
      var tmp;
      if ($changed.m1(key)) {
        // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
        var this_0 = this$0.i46_1;
        var value = _ScopeMap___get_map__impl__vxhazm(this_0).w2(key);
        if (value != null) {
          if (value instanceof MutableScatterSet) {
            // Inline function 'androidx.collection.ScatterSet.forEach' call
            var this_1 = value instanceof MutableScatterSet ? value : THROW_CCE();
            // Inline function 'kotlin.contracts.contract' call
            var elements = this_1.k16_1;
            $l$block: {
              // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
              // Inline function 'kotlin.contracts.contract' call
              var m = this_1.j16_1;
              var lastIndex = m.length - 2 | 0;
              var inductionVariable = 0;
              if (inductionVariable <= lastIndex)
                do {
                  var i = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var slot = m[i];
                  // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                  var this_2 = slot;
                  var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
                  if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
                    var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < bitCount)
                      do {
                        var j = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'androidx.collection.isFull' call
                        var value_0 = bitwiseAnd(slot, new Long(255, 0));
                        if (compare(value_0, new Long(128, 0)) < 0) {
                          var index = (i << 3) + j | 0;
                          var it = elements[index];
                          this$0.k46_1.j1(it);
                        }
                        slot = shiftRight(slot, 8);
                      }
                       while (inductionVariable_0 < bitCount);
                    if (!(bitCount === 8)) {
                      break $l$block;
                    }
                  }
                }
                 while (!(i === lastIndex));
            }
          } else {
            var it_0 = !(value == null) ? value : THROW_CCE();
            this$0.k46_1.j1(it_0);
          }
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MultiSubscriptionSnapshotFlowManager$unregisterApplyObserver$lambda(this$0) {
    return function (changed, _unused_var__etf5q3) {
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this$0.a46_1;
      var tmp = this$0.i46_1;
      ScopeMap__forEachKey_impl_dgpcls(tmp, MultiSubscriptionSnapshotFlowManager$unregisterApplyObserver$lambda$lambda(changed, this$0));
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      var this_0 = this$0.k46_1;
      // Inline function 'kotlin.contracts.contract' call
      var elements = this_0.k16_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = this_0.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$6 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$6, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    elements[index].s1s(Unit_instance);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
      this$0.k46_1.c3();
      return Unit_instance;
    };
  }
  function MultiSubscriptionSnapshotFlowManager$readObserverFor$lambda(this$0, $channel) {
    return function (obj) {
      this$0.g46($channel, obj);
      return Unit_instance;
    };
  }
  function MultiSubscriptionSnapshotFlowManager() {
    SnapshotFlowManagerImpl.call(this);
    this.i46_1 = _ScopeMap___init__impl__52wntz();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.j46_1 = ArrayList_init_$Create$();
    this.k46_1 = mutableScatterSetOf();
    this.l46_1 = mutableScatterMapOf();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_18;
    tmp_0.m46_1 = tmp_1.e45(MultiSubscriptionSnapshotFlowManager$unregisterApplyObserver$lambda(this));
  }
  protoOf(MultiSubscriptionSnapshotFlowManager).g46 = function (channel, obj) {
    this.j46_1.j1(new Add(obj, channel));
  };
  protoOf(MultiSubscriptionSnapshotFlowManager).c46 = function (channel) {
    var tmp0_elvis_lhs = this.l46_1.w2(channel);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = MultiSubscriptionSnapshotFlowManager$readObserverFor$lambda(this, channel);
      this.l46_1.z2(channel, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MultiSubscriptionSnapshotFlowManager).d46 = function (channel) {
    this.j46_1.j1(new RemoveScope(channel));
  };
  protoOf(MultiSubscriptionSnapshotFlowManager).e46 = function () {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.a46_1;
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var this_0 = this.j46_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        if (item instanceof Add) {
          ScopeMap__add_impl_n8b3uc(this.i46_1, item.n46_1, item.o46_1);
        } else {
          if (item instanceof RemoveScope) {
            ScopeMap__removeScope_impl_8k6ux1(this.i46_1, item.p46_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
       while (inductionVariable <= last);
    this.j46_1.c3();
  };
  protoOf(MultiSubscriptionSnapshotFlowManager).b46 = function (channel) {
    this.l46_1.a3(channel);
    this.d46(channel);
    this.e46();
  };
  protoOf(MultiSubscriptionSnapshotFlowManager).y32 = function () {
    this.m46_1.s1d();
    this.j46_1.c3();
    this.l46_1.c3();
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.a46_1;
    ScopeMap__clear_impl_2jofm0(this.i46_1);
  };
  function collectAsState(_this__u8e3s4, context, $composer, $changed, $default) {
    var context_0 = context;
    var $composer_0 = $composer;
    if (!(($default & 1) === 0))
      context_0 = EmptyCoroutineContext_getInstance();
    return collectAsState_0(_this__u8e3s4, _this__u8e3s4.u1(), context_0, $composer_0, 14 & $changed | 896 & $changed << 3, 0);
  }
  function collectAsState_0(_this__u8e3s4, initial, context, $composer, $changed, $default) {
    var context_0 = {_v: context};
    var $composer_0 = $composer;
    if (!(($default & 2) === 0)) {
      context_0._v = EmptyCoroutineContext_getInstance();
    }
    var tmp = context_0._v;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!($composer_0.q31(context_0._v) | $composer_0.q31(_this__u8e3s4));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (invalid || it === Companion_getInstance_0().f30_1) {
      var value = collectAsState$slambda_0(context_0, _this__u8e3s4, null);
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    var tmp$ret$0 = tmp_0;
    return produceState_0(initial, _this__u8e3s4, tmp, tmp$ret$0, $composer_0, 8 & $changed >> 3 | 14 & $changed >> 3 | 112 & $changed << 3 | 896 & $changed);
  }
  function snapshotFlowImpl$slambda($externalManager, $block, resultContinuation) {
    this.y46_1 = $externalManager;
    this.z46_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(snapshotFlowImpl$slambda).e23 = function ($this$flow, $completion) {
    var tmp = this.f23($this$flow, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(snapshotFlowImpl$slambda).ja = function (p1, $completion) {
    return this.e23((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(snapshotFlowImpl$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.y46_1;
            tmp_0.b47_1 = tmp0_elvis_lhs == null ? new SnapshotFlowManager() : tmp0_elvis_lhs;
            this.c47_1 = Channel(1);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 9;
            this.d47_1 = this.b47_1.q45(this.c47_1, this.z46_1);
            this.n9_1 = 2;
            suspendResult = this.a47_1.a1v(this.d47_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!true) {
              this.n9_1 = 7;
              continue $sm;
            }

            this.n9_1 = 4;
            suspendResult = this.c47_1.u1s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var newValue = this.b47_1.q45(this.c47_1, this.z46_1);
            if (!equals(newValue, this.d47_1)) {
              this.d47_1 = newValue;
              this.n9_1 = 5;
              suspendResult = this.a47_1.a1v(newValue, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.n9_1 = 3;
            continue $sm;
          case 7:
            this.o9_1 = 10;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.o9_1 = 10;
            this.b47_1.b46(this.c47_1);
            if (this.y46_1 == null) {
              this.b47_1.s1d();
            }

            return Unit_instance;
          case 9:
            this.o9_1 = 10;
            var t = this.q9_1;
            this.b47_1.b46(this.c47_1);
            if (this.y46_1 == null) {
              this.b47_1.s1d();
            }

            throw t;
          case 10:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 10) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(snapshotFlowImpl$slambda).f23 = function ($this$flow, completion) {
    var i = new snapshotFlowImpl$slambda(this.y46_1, this.z46_1, completion);
    i.a47_1 = $this$flow;
    return i;
  };
  function snapshotFlowImpl$slambda_0($externalManager, $block, resultContinuation) {
    var i = new snapshotFlowImpl$slambda($externalManager, $block, resultContinuation);
    return constructCallableReference(function ($this$flow, $completion) {
      return i.e23($this$flow, $completion);
    }, 1);
  }
  function collectAsState$slambda$slambda$slambda($this_produceState, resultContinuation) {
    this.m47_1 = $this_produceState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(collectAsState$slambda$slambda$slambda).o47 = function (it, $completion) {
    var tmp = this.p47(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(collectAsState$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.o47(p1, $completion);
  };
  protoOf(collectAsState$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.m47_1.s21(this.n47_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(collectAsState$slambda$slambda$slambda).p47 = function (it, completion) {
    var i = new collectAsState$slambda$slambda$slambda(this.m47_1, completion);
    i.n47_1 = it;
    return i;
  };
  function collectAsState$slambda$slambda$slambda_0($this_produceState, resultContinuation) {
    var i = new collectAsState$slambda$slambda$slambda($this_produceState, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.o47(it, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.q47_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.q47_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.q47_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function collectAsState$slambda$slambda($this_produceState, resultContinuation) {
    this.z47_1 = $this_produceState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(collectAsState$slambda$slambda).o47 = function (it, $completion) {
    var tmp = this.p47(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(collectAsState$slambda$slambda).ja = function (p1, $completion) {
    return this.o47(p1, $completion);
  };
  protoOf(collectAsState$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.z47_1.s21(this.a48_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(collectAsState$slambda$slambda).p47 = function (it, completion) {
    var i = new collectAsState$slambda$slambda(this.z47_1, completion);
    i.a48_1 = it;
    return i;
  };
  function collectAsState$slambda$slambda_0($this_produceState, resultContinuation) {
    var i = new collectAsState$slambda$slambda($this_produceState, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.o47(it, $completion);
    }, 1);
  }
  function collectAsState$slambda$slambda_1($this_collectAsState, $this_produceState, resultContinuation) {
    this.j48_1 = $this_collectAsState;
    this.k48_1 = $this_produceState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(collectAsState$slambda$slambda_1).p24 = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(collectAsState$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(collectAsState$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = collectAsState$slambda$slambda$slambda_0(this.k48_1, null);
            suspendResult = this.j48_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(collectAsState$slambda$slambda_1).q24 = function ($this$withContext, completion) {
    var i = new collectAsState$slambda$slambda_1(this.j48_1, this.k48_1, completion);
    i.l48_1 = $this$withContext;
    return i;
  };
  function collectAsState$slambda$slambda_2($this_collectAsState, $this_produceState, resultContinuation) {
    var i = new collectAsState$slambda$slambda_1($this_collectAsState, $this_produceState, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.p24($this$withContext, $completion);
    }, 1);
  }
  function collectAsState$slambda($context, $this_collectAsState, resultContinuation) {
    this.u48_1 = $context;
    this.v48_1 = $this_collectAsState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(collectAsState$slambda).x48 = function ($this$produceState, $completion) {
    var tmp = this.y48($this$produceState, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(collectAsState$slambda).ja = function (p1, $completion) {
    return this.x48((!(p1 == null) ? isInterface(p1, ProduceStateScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(collectAsState$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (equals(this.u48_1._v, EmptyCoroutineContext_getInstance())) {
              this.n9_1 = 2;
              var tmp_0 = collectAsState$slambda$slambda_0(this.w48_1, null);
              suspendResult = this.v48_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              var tmp_1 = this.u48_1._v;
              suspendResult = withContext(tmp_1, collectAsState$slambda$slambda_2(this.v48_1, this.w48_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(collectAsState$slambda).y48 = function ($this$produceState, completion) {
    var i = new collectAsState$slambda(this.u48_1, this.v48_1, completion);
    i.w48_1 = $this$produceState;
    return i;
  };
  function collectAsState$slambda_0($context, $this_collectAsState, resultContinuation) {
    var i = new collectAsState$slambda($context, $this_collectAsState, resultContinuation);
    return constructCallableReference(function ($this$produceState, $completion) {
      return i.x48($this$produceState, $completion);
    }, 1);
  }
  var androidx_compose_runtime_SnapshotMutableIntStateImpl$stable;
  function MutableIntState() {
  }
  function mutableIntStateOf(value) {
    return createSnapshotMutableIntState(value);
  }
  function IntStateStateRecord(snapshotId, value) {
    StateRecord.call(this, snapshotId);
    this.e49_1 = value;
  }
  protoOf(IntStateStateRecord).q3d = function (value) {
    var tmp = this;
    tmp.e49_1 = (value instanceof IntStateStateRecord ? value : THROW_CCE()).e49_1;
  };
  protoOf(IntStateStateRecord).r3d = function () {
    return this.x3d(currentSnapshot().w3d());
  };
  protoOf(IntStateStateRecord).x3d = function (snapshotId) {
    return new IntStateStateRecord(snapshotId, this.e49_1);
  };
  function SnapshotMutableIntStateImpl(value) {
    StateObjectImpl.call(this);
    var tmp = this;
    // Inline function 'kotlin.let' call
    var snapshot = currentSnapshot();
    // Inline function 'kotlin.also' call
    var this_0 = new IntStateStateRecord(snapshot.w3d(), value);
    if (!(snapshot instanceof GlobalSnapshot)) {
      this_0.m3e_1 = new IntStateStateRecord(toSnapshotId(1), value);
    }
    tmp.g49_1 = this_0;
  }
  protoOf(SnapshotMutableIntStateImpl).f3e = function () {
    return this.g49_1;
  };
  protoOf(SnapshotMutableIntStateImpl).a49 = function (value) {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.g49_1;
    var it = current_0(this_0);
    if (!(it.e49_1 === value)) {
      // Inline function 'androidx.compose.runtime.snapshots.overwritable' call
      var this_1 = this.g49_1;
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      overwritableRecord(this_1, this, snapshot, it).e49_1 = value;
      // Inline function 'kotlin.also' call
      notifyWrite(snapshot, this);
    }
    return Unit_instance;
  };
  protoOf(SnapshotMutableIntStateImpl).b49 = function () {
    return readable_0(this.g49_1, this).e49_1;
  };
  protoOf(SnapshotMutableIntStateImpl).h3d = function () {
    return structuralEqualityPolicy();
  };
  protoOf(SnapshotMutableIntStateImpl).y3e = function (value) {
    var tmp = this;
    tmp.g49_1 = value instanceof IntStateStateRecord ? value : THROW_CCE();
  };
  protoOf(SnapshotMutableIntStateImpl).a3f = function (previous, current, applied) {
    var currentRecord = current instanceof IntStateStateRecord ? current : THROW_CCE();
    var appliedRecord = applied instanceof IntStateStateRecord ? applied : THROW_CCE();
    var tmp;
    if (currentRecord.e49_1 === appliedRecord.e49_1) {
      tmp = current;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SnapshotMutableIntStateImpl).toString = function () {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.g49_1;
    return 'MutableIntState(value=' + current_0(this_0).e49_1 + ')@' + hashCode(this);
  };
  protoOf(SnapshotMutableIntStateImpl).s21 = function (_set____db54di) {
    return this.z48((!(_set____db54di == null) ? typeof _set____db54di === 'number' : false) ? _set____db54di : THROW_CCE());
  };
  var androidx_compose_runtime_SnapshotMutableLongStateImpl$stable;
  function MutableLongState() {
  }
  function mutableLongStateOf(value) {
    return createSnapshotMutableLongState(value);
  }
  function LongStateStateRecord(snapshotId, value) {
    StateRecord.call(this, snapshotId);
    this.m49_1 = value;
  }
  protoOf(LongStateStateRecord).q3d = function (value) {
    var tmp = this;
    tmp.m49_1 = (value instanceof LongStateStateRecord ? value : THROW_CCE()).m49_1;
  };
  protoOf(LongStateStateRecord).r3d = function () {
    return this.x3d(currentSnapshot().w3d());
  };
  protoOf(LongStateStateRecord).x3d = function (snapshotId) {
    return new LongStateStateRecord(snapshotId, this.m49_1);
  };
  function SnapshotMutableLongStateImpl(value) {
    StateObjectImpl.call(this);
    var tmp = this;
    // Inline function 'kotlin.let' call
    var snapshot = currentSnapshot();
    // Inline function 'kotlin.also' call
    var this_0 = new LongStateStateRecord(snapshot.w3d(), value);
    if (!(snapshot instanceof GlobalSnapshot)) {
      this_0.m3e_1 = new LongStateStateRecord(toSnapshotId(1), value);
    }
    tmp.o49_1 = this_0;
  }
  protoOf(SnapshotMutableLongStateImpl).f3e = function () {
    return this.o49_1;
  };
  protoOf(SnapshotMutableLongStateImpl).i49 = function (value) {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.o49_1;
    var it = current_0(this_0);
    if (!equalsLong(it.m49_1, value)) {
      // Inline function 'androidx.compose.runtime.snapshots.overwritable' call
      var this_1 = this.o49_1;
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      overwritableRecord(this_1, this, snapshot, it).m49_1 = value;
      // Inline function 'kotlin.also' call
      notifyWrite(snapshot, this);
    }
    return Unit_instance;
  };
  protoOf(SnapshotMutableLongStateImpl).j49 = function () {
    return readable_0(this.o49_1, this).m49_1;
  };
  protoOf(SnapshotMutableLongStateImpl).h3d = function () {
    return structuralEqualityPolicy();
  };
  protoOf(SnapshotMutableLongStateImpl).y3e = function (value) {
    var tmp = this;
    tmp.o49_1 = value instanceof LongStateStateRecord ? value : THROW_CCE();
  };
  protoOf(SnapshotMutableLongStateImpl).a3f = function (previous, current, applied) {
    var currentRecord = current instanceof LongStateStateRecord ? current : THROW_CCE();
    var appliedRecord = applied instanceof LongStateStateRecord ? applied : THROW_CCE();
    var tmp;
    if (equalsLong(currentRecord.m49_1, appliedRecord.m49_1)) {
      tmp = current;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SnapshotMutableLongStateImpl).toString = function () {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.o49_1;
    return 'MutableLongState(value=' + current_0(this_0).m49_1.toString() + ')@' + hashCode(this);
  };
  protoOf(SnapshotMutableLongStateImpl).s21 = function (_set____db54di) {
    return this.h49(_set____db54di instanceof Long ? _set____db54di : THROW_CCE());
  };
  function SnapshotMutationPolicy() {
  }
  function structuralEqualityPolicy() {
    var tmp = StructuralEqualityPolicy_instance;
    return isInterface(tmp, SnapshotMutationPolicy) ? tmp : THROW_CCE();
  }
  function neverEqualPolicy() {
    var tmp = NeverEqualPolicy_instance;
    return isInterface(tmp, SnapshotMutationPolicy) ? tmp : THROW_CCE();
  }
  function referentialEqualityPolicy() {
    var tmp = ReferentialEqualityPolicy_instance;
    return isInterface(tmp, SnapshotMutationPolicy) ? tmp : THROW_CCE();
  }
  function StructuralEqualityPolicy() {
  }
  protoOf(StructuralEqualityPolicy).q49 = function (a, b) {
    return equals(a, b);
  };
  protoOf(StructuralEqualityPolicy).w3e = function (a, b) {
    return this.q49(a, b);
  };
  protoOf(StructuralEqualityPolicy).toString = function () {
    return 'StructuralEqualityPolicy';
  };
  var StructuralEqualityPolicy_instance;
  function StructuralEqualityPolicy_getInstance() {
    return StructuralEqualityPolicy_instance;
  }
  function NeverEqualPolicy() {
  }
  protoOf(NeverEqualPolicy).q49 = function (a, b) {
    return false;
  };
  protoOf(NeverEqualPolicy).w3e = function (a, b) {
    return this.q49(a, b);
  };
  protoOf(NeverEqualPolicy).toString = function () {
    return 'NeverEqualPolicy';
  };
  var NeverEqualPolicy_instance;
  function NeverEqualPolicy_getInstance() {
    return NeverEqualPolicy_instance;
  }
  function ReferentialEqualityPolicy() {
  }
  protoOf(ReferentialEqualityPolicy).q49 = function (a, b) {
    return a === b;
  };
  protoOf(ReferentialEqualityPolicy).w3e = function (a, b) {
    return this.q49(a, b);
  };
  protoOf(ReferentialEqualityPolicy).toString = function () {
    return 'ReferentialEqualityPolicy';
  };
  var ReferentialEqualityPolicy_instance;
  function ReferentialEqualityPolicy_getInstance() {
    return ReferentialEqualityPolicy_instance;
  }
  var androidx_compose_runtime_SnapshotMutableStateImpl$stable;
  function MutableState() {
  }
  function mutableStateOf(value, policy) {
    policy = policy === VOID ? structuralEqualityPolicy() : policy;
    return createSnapshotMutableState(value, policy);
  }
  function toMutableStateList(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    var this_0 = SnapshotStateList_init_$Create$();
    this_0.e10(_this__u8e3s4);
    return this_0;
  }
  function mutableStateListOf(elements) {
    // Inline function 'kotlin.also' call
    var this_0 = SnapshotStateList_init_$Create$();
    this_0.e10(toList_1(elements));
    return this_0;
  }
  function rememberUpdatedState(newValue, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_0().f30_1) {
      var value = mutableStateOf(newValue);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    // Inline function 'kotlin.apply' call
    var this_0 = tmp;
    this_0.s21(newValue);
    return this_0;
  }
  function mutableStateListOf_0() {
    return SnapshotStateList_init_$Create$();
  }
  function mutableStateMapOf() {
    return new SnapshotStateMap();
  }
  function StateStateRecord(snapshotId, myValue) {
    StateRecord.call(this, snapshotId);
    this.u49_1 = myValue;
  }
  protoOf(StateStateRecord).q3d = function (value) {
    var tmp = this;
    tmp.u49_1 = (value instanceof StateStateRecord ? value : THROW_CCE()).u49_1;
  };
  protoOf(StateStateRecord).r3d = function () {
    return new StateStateRecord(currentSnapshot().w3d(), this.u49_1);
  };
  protoOf(StateStateRecord).x3d = function (snapshotId) {
    return new StateStateRecord(currentSnapshot().w3d(), this.u49_1);
  };
  function SnapshotMutableStateImpl(value, policy) {
    StateObjectImpl.call(this);
    this.w49_1 = policy;
    var tmp = this;
    // Inline function 'kotlin.let' call
    var snapshot = currentSnapshot();
    // Inline function 'kotlin.also' call
    var this_0 = new StateStateRecord(snapshot.w3d(), value);
    if (!(snapshot instanceof GlobalSnapshot)) {
      this_0.m3e_1 = new StateStateRecord(toSnapshotId(1), value);
    }
    tmp.x49_1 = this_0;
  }
  protoOf(SnapshotMutableStateImpl).h3d = function () {
    return this.w49_1;
  };
  protoOf(SnapshotMutableStateImpl).s21 = function (value) {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.x49_1;
    var it = current_0(this_0);
    if (!this.h3d().w3e(it.u49_1, value)) {
      // Inline function 'androidx.compose.runtime.snapshots.overwritable' call
      var this_1 = this.x49_1;
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      overwritableRecord(this_1, this, snapshot, it).u49_1 = value;
      // Inline function 'kotlin.also' call
      notifyWrite(snapshot, this);
    }
    return Unit_instance;
  };
  protoOf(SnapshotMutableStateImpl).u1 = function () {
    return readable_0(this.x49_1, this).u49_1;
  };
  protoOf(SnapshotMutableStateImpl).f3e = function () {
    return this.x49_1;
  };
  protoOf(SnapshotMutableStateImpl).y3e = function (value) {
    var tmp = this;
    tmp.x49_1 = value instanceof StateStateRecord ? value : THROW_CCE();
  };
  protoOf(SnapshotMutableStateImpl).a3f = function (previous, current, applied) {
    var previousRecord = previous instanceof StateStateRecord ? previous : THROW_CCE();
    var currentRecord = current instanceof StateStateRecord ? current : THROW_CCE();
    var appliedRecord = applied instanceof StateStateRecord ? applied : THROW_CCE();
    var tmp;
    if (this.h3d().w3e(currentRecord.u49_1, appliedRecord.u49_1)) {
      tmp = current;
    } else {
      var merged = this.h3d().p49(previousRecord.u49_1, currentRecord.u49_1, appliedRecord.u49_1);
      var tmp_0;
      if (!(merged == null)) {
        // Inline function 'kotlin.also' call
        var this_0 = appliedRecord.x3d(appliedRecord.l3e_1);
        this_0.u49_1 = merged;
        tmp_0 = this_0;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(SnapshotMutableStateImpl).toString = function () {
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = this.x49_1;
    var it = current_0(this_0);
    return 'MutableState(value=' + toString_0(it.u49_1) + ')@' + hashCode(this);
  };
  var androidx_compose_runtime_UnboxedIntState$stable;
  var androidx_compose_runtime_UnboxedLongState$stable;
  var androidx_compose_runtime_UnboxedFloatState$stable;
  var androidx_compose_runtime_UnboxedDoubleState$stable;
  var androidx_compose_runtime_IntStack$stable;
  function _Stack___init__impl__tvpfn5(backing) {
    backing = backing === VOID ? ArrayList_init_$Create$() : backing;
    return backing;
  }
  function _get_backing__s7m0a($this) {
    return $this;
  }
  function _Stack___get_size__impl__mdb81l($this) {
    return _get_backing__s7m0a($this).n1();
  }
  function Stack__push_impl_s8r905($this, value) {
    return _get_backing__s7m0a($this).j1(value);
  }
  function Stack__pop_impl_8s4za4($this) {
    return _get_backing__s7m0a($this).h3(_Stack___get_size__impl__mdb81l($this) - 1 | 0);
  }
  function Stack__peek_impl_gtylu2($this) {
    return _get_backing__s7m0a($this).l1(_Stack___get_size__impl__mdb81l($this) - 1 | 0);
  }
  function Stack__peek_impl_gtylu2_0($this, index) {
    return _get_backing__s7m0a($this).l1(index);
  }
  function Stack__isEmpty_impl_modt1q($this) {
    return _get_backing__s7m0a($this).r();
  }
  function Stack__isNotEmpty_impl_ua6a9t($this) {
    return !Stack__isEmpty_impl_modt1q($this);
  }
  function Stack__clear_impl_qoqv3c($this) {
    return _get_backing__s7m0a($this).c3();
  }
  function Stack__toArray_impl_ox34cp($this) {
    var tmp = 0;
    var tmp_0 = _get_backing__s7m0a($this).n1();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = _get_backing__s7m0a($this).l1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    var tmp_3 = tmp_1;
    return isArray(tmp_3) ? tmp_3 : THROW_CCE();
  }
  function Stack__toString_impl_aq1jdz($this) {
    return 'Stack(backing=' + $this.toString() + ')';
  }
  function Stack__hashCode_impl_wh7g6u($this) {
    return $this.hashCode();
  }
  function Stack__equals_impl_4f06xy($this, other) {
    if (!(other instanceof Stack))
      return false;
    var tmp0_other_with_cast = other.k3o_1;
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function Stack(backing) {
    this.k3o_1 = backing;
  }
  protoOf(Stack).toString = function () {
    return Stack__toString_impl_aq1jdz(this.k3o_1);
  };
  protoOf(Stack).hashCode = function () {
    return Stack__hashCode_impl_wh7g6u(this.k3o_1);
  };
  protoOf(Stack).equals = function (other) {
    return Stack__equals_impl_4f06xy(this.k3o_1, other);
  };
  function resize($this) {
    var copy = copyOf($this.e3i_1, imul($this.e3i_1.length, 2));
    $this.e3i_1 = copy;
    return copy;
  }
  function IntStack() {
    this.e3i_1 = new Int32Array(10);
    this.f3i_1 = 0;
  }
  protoOf(IntStack).g3i = function (value) {
    var slots = this.e3i_1;
    if (this.f3i_1 >= slots.length) {
      slots = resize(this);
    }
    var tmp = slots;
    var _unary__edvuaz = this.f3i_1;
    this.f3i_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = value;
  };
  protoOf(IntStack).k3j = function () {
    var tmp = this.e3i_1;
    this.f3i_1 = this.f3i_1 - 1 | 0;
    return tmp[this.f3i_1];
  };
  protoOf(IntStack).y49 = function (default_0) {
    var tmp;
    if (this.f3i_1 > 0) {
      var tmp_0 = this.e3i_1;
      this.f3i_1 = this.f3i_1 - 1 | 0;
      tmp = tmp_0[this.f3i_1];
    } else {
      tmp = default_0;
    }
    return tmp;
  };
  protoOf(IntStack).z49 = function (default_0) {
    var index = this.f3i_1 - 1 | 0;
    return index >= 0 ? this.e3i_1[index] : default_0;
  };
  protoOf(IntStack).v3n = function () {
    return this.e3i_1[this.f3i_1 - 1 | 0];
  };
  protoOf(IntStack).a3l = function () {
    return this.e3i_1[this.f3i_1 - 2 | 0];
  };
  protoOf(IntStack).a4a = function (index) {
    return this.e3i_1[index];
  };
  protoOf(IntStack).c3 = function () {
    this.f3i_1 = 0;
  };
  protoOf(IntStack).b4a = function (value) {
    var slots = this.e3i_1;
    var tmp0 = slots.length;
    // Inline function 'kotlin.math.min' call
    var b = this.f3i_1;
    var end = Math.min(tmp0, b);
    var inductionVariable = 0;
    if (inductionVariable < end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (slots[i] === value)
          return i;
      }
       while (inductionVariable < end);
    return -1;
  };
  var androidx_compose_runtime_StaticValueHolder$stable;
  var androidx_compose_runtime_LazyValueHolder$stable;
  var androidx_compose_runtime_ComputedValueHolder$stable;
  var androidx_compose_runtime_DynamicValueHolder$stable;
  function ValueHolder() {
  }
  function DynamicValueHolder(state) {
    this.m3c_1 = state;
  }
  protoOf(DynamicValueHolder).b3d = function (map) {
    return this.m3c_1.u1();
  };
  protoOf(DynamicValueHolder).w3c = function (local) {
    return new ProvidedValue(local, null, false, null, this.m3c_1, null, true);
  };
  protoOf(DynamicValueHolder).toString = function () {
    return 'DynamicValueHolder(state=' + toString(this.m3c_1) + ')';
  };
  protoOf(DynamicValueHolder).hashCode = function () {
    return hashCode(this.m3c_1);
  };
  protoOf(DynamicValueHolder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicValueHolder))
      return false;
    if (!equals(this.m3c_1, other.m3c_1))
      return false;
    return true;
  };
  function StaticValueHolder(value) {
    this.l3c_1 = value;
  }
  protoOf(StaticValueHolder).b3d = function (map) {
    return this.l3c_1;
  };
  protoOf(StaticValueHolder).w3c = function (local) {
    return new ProvidedValue(local, this.l3c_1, this.l3c_1 === null, null, null, null, false);
  };
  protoOf(StaticValueHolder).toString = function () {
    return 'StaticValueHolder(value=' + toString_0(this.l3c_1) + ')';
  };
  protoOf(StaticValueHolder).hashCode = function () {
    return this.l3c_1 == null ? 0 : hashCode(this.l3c_1);
  };
  protoOf(StaticValueHolder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StaticValueHolder))
      return false;
    if (!equals(this.l3c_1, other.l3c_1))
      return false;
    return true;
  };
  function ComputedValueHolder(compute) {
    this.k3c_1 = compute;
  }
  protoOf(ComputedValueHolder).b3d = function (map) {
    return this.k3c_1(map);
  };
  protoOf(ComputedValueHolder).w3c = function (local) {
    return new ProvidedValue(local, null, false, null, null, this.k3c_1, false);
  };
  protoOf(ComputedValueHolder).toString = function () {
    return 'ComputedValueHolder(compute=' + toString(this.k3c_1) + ')';
  };
  protoOf(ComputedValueHolder).hashCode = function () {
    return hashCode(this.k3c_1);
  };
  protoOf(ComputedValueHolder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ComputedValueHolder))
      return false;
    if (!equals(this.k3c_1, other.k3c_1))
      return false;
    return true;
  };
  function _get_current__qcrdxk($this) {
    var tmp0 = $this.c4a_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('current', 1, tmp, LazyValueHolder$_get_current_$ref_sagj5g(), null);
    return tmp0.u1();
  }
  function LazyValueHolder$_get_current_$ref_sagj5g() {
    return constructCallableReference(function (p0) {
      return _get_current__qcrdxk(p0);
    }, 1, 0, 15);
  }
  function LazyValueHolder(valueProducer) {
    this.c4a_1 = lazy(valueProducer);
  }
  protoOf(LazyValueHolder).b3d = function (map) {
    return _get_current__qcrdxk(this);
  };
  protoOf(LazyValueHolder).w3c = function (local) {
    composeRuntimeError('Cannot produce a provider from a lazy value holder');
  };
  function removeLast(_this__u8e3s4) {
    if (_this__u8e3s4.r())
      throw NoSuchElementException_init_$Create$('List is empty.');
    var last = _this__u8e3s4.n1() - 1 | 0;
    // Inline function 'kotlin.also' call
    var this_0 = _this__u8e3s4.l1(last);
    _this__u8e3s4.h3(last);
    return this_0;
  }
  function sortedBy(_this__u8e3s4, selector) {
    var tmp;
    if (isSorted(_this__u8e3s4, selector)) {
      tmp = _this__u8e3s4;
    } else {
      // Inline function 'kotlin.also' call
      var this_0 = toMutableObjectList(_this__u8e3s4);
      sortBy(this_0, selector);
      tmp = this_0;
    }
    return tmp;
  }
  function isSorted(_this__u8e3s4, selector) {
    if (_this__u8e3s4.n1() <= 1)
      return true;
    var previousValue = _this__u8e3s4.l1(0);
    var tmp0_elvis_lhs = selector(previousValue);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var previousKey = tmp;
    var inductionVariable = 1;
    var last = _this__u8e3s4.n1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var value = _this__u8e3s4.l1(i);
        var tmp1_elvis_lhs = selector(value);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          return false;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var key = tmp_0;
        if (compareTo(previousKey, key) > 0)
          return false;
        previousKey = key;
      }
       while (inductionVariable < last);
    return true;
  }
  function toMutableObjectList(_this__u8e3s4) {
    var target = new MutableObjectList(_this__u8e3s4.n1());
    // Inline function 'androidx.collection.ObjectList.forEach' call
    // Inline function 'kotlin.contracts.contract' call
    var content = _this__u8e3s4.sz_1;
    var inductionVariable = 0;
    var last = _this__u8e3s4.tz_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'androidx.collection.MutableObjectList.plusAssign' call
        var element = content[i];
        target.j1(element);
      }
       while (inductionVariable < last);
    return target;
  }
  function sortBy(_this__u8e3s4, selector) {
    // Inline function 'kotlin.collections.sortBy' call
    var this_0 = _this__u8e3s4.q10();
    if (this_0.n1() > 1) {
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = sortBy$lambda(selector);
      var tmp$ret$1 = new sam$kotlin_Comparator$0_0(tmp);
      sortWith(this_0, tmp$ret$1);
    }
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.d4a_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).ze = function (a, b) {
    return this.d4a_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).q3 = function () {
    return this.d4a_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sortBy$lambda($selector) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      return compareValues($selector(a), $selector(b));
    };
  }
  function _MultiValueMap___init__impl__qt1z0r(map) {
    map = map === VOID ? new MutableScatterMap() : map;
    return map;
  }
  function _get_map__e6co1h($this) {
    return $this;
  }
  function MultiValueMap__add_impl_ww0640($this, key, value) {
    // Inline function 'androidx.collection.MutableScatterMap.compute' call
    var this_0 = _get_map__e6co1h($this);
    var index = this_0.i13(key);
    var inserting = index < 0;
    var previous = inserting ? null : this_0.y12_1[index];
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value_0 = !(!(previous == null) ? isInterface(previous, KtMutableList) : false);
    if (false && !value_0) {
      var tmp$ret$3 = 'Unexpected value';
      composeImmediateRuntimeError(tmp$ret$3);
    }
    var tmp;
    if (previous == null) {
      tmp = value;
    } else {
      if (previous instanceof MutableObjectList) {
        var list = previous instanceof MutableObjectList ? previous : THROW_CCE();
        list.j1(value);
        tmp = list;
      } else {
        tmp = mutableObjectListOf(previous, value);
      }
    }
    var computedValue = tmp;
    if (inserting) {
      var insertionIndex = ~index;
      this_0.x12_1[insertionIndex] = key;
      this_0.y12_1[insertionIndex] = computedValue;
    } else {
      this_0.y12_1[index] = computedValue;
    }
  }
  function MultiValueMap__clear_impl_g4umn0($this) {
    return _get_map__e6co1h($this).c3();
  }
  function MultiValueMap__contains_impl_2yjtfa($this, key) {
    return _get_map__e6co1h($this).d6(key);
  }
  function MultiValueMap__get_impl_k8msu3($this, key) {
    var entry = _get_map__e6co1h($this).w2(key);
    var tmp;
    if (entry == null) {
      tmp = emptyObjectList();
    } else {
      if (entry instanceof MutableObjectList) {
        tmp = entry instanceof ObjectList ? entry : THROW_CCE();
      } else {
        tmp = objectListOf(!(entry == null) ? entry : THROW_CCE());
      }
    }
    return tmp;
  }
  function MultiValueMap__isEmpty_impl_n67ooe($this) {
    return _get_map__e6co1h($this).r();
  }
  function MultiValueMap__isNotEmpty_impl_ktqbr9($this) {
    return _get_map__e6co1h($this).fv();
  }
  function MultiValueMap__removeLast_impl_h7l98v($this, key) {
    var entry = _get_map__e6co1h($this).w2(key);
    var tmp;
    if (entry == null) {
      tmp = null;
    } else {
      if (entry instanceof MutableObjectList) {
        var list = entry instanceof MutableObjectList ? entry : THROW_CCE();
        var tmp_0 = removeLast(list);
        var result = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
        if (list.r()) {
          _get_map__e6co1h($this).a3(key);
        }
        if (list.n1() === 1) {
          _get_map__e6co1h($this).h13(key, list.vg());
        }
        tmp = result;
      } else {
        _get_map__e6co1h($this).a3(key);
        tmp = !(entry == null) ? entry : THROW_CCE();
      }
    }
    return tmp;
  }
  function MultiValueMap__removeFirst_impl_iz2i9x($this, key) {
    var entry = _get_map__e6co1h($this).w2(key);
    var tmp;
    if (entry == null) {
      tmp = null;
    } else {
      if (entry instanceof MutableObjectList) {
        var list = entry instanceof MutableObjectList ? entry : THROW_CCE();
        var result = list.h3(0);
        if (list.r()) {
          _get_map__e6co1h($this).a3(key);
        }
        if (list.n1() === 1) {
          _get_map__e6co1h($this).h13(key, list.vg());
        }
        tmp = result;
      } else {
        _get_map__e6co1h($this).a3(key);
        tmp = !(entry == null) ? entry : THROW_CCE();
      }
    }
    return tmp;
  }
  function MultiValueMap__values_impl_vxaj3b($this) {
    if (_get_map__e6co1h($this).r())
      return emptyObjectList();
    // Inline function 'androidx.collection.mutableObjectListOf' call
    var result = new MutableObjectList();
    // Inline function 'androidx.collection.ScatterMap.forEachValue' call
    var this_0 = _get_map__e6co1h($this);
    var v = this_0.y12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$3 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$3, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var entry = v[index];
                  if (entry instanceof MutableObjectList) {
                    result.l10(entry instanceof MutableObjectList ? entry : THROW_CCE());
                  } else {
                    result.j1(!(entry == null) ? entry : THROW_CCE());
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    return result;
  }
  function MultiValueMap__removeValueIf_impl_q0rlrt($this, key, condition) {
    var tmp0_safe_receiver = _get_map__e6co1h($this).w2(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (tmp0_safe_receiver instanceof MutableObjectList) {
        // Inline function 'androidx.collection.MutableObjectList.removeIf' call
        var this_0 = tmp0_safe_receiver instanceof MutableObjectList ? tmp0_safe_receiver : THROW_CCE();
        var gap = 0;
        var size = this_0.tz_1;
        var content = this_0.sz_1;
        // Inline function 'androidx.collection.ObjectList.indices' call
        var progression = until(0, this_0.tz_1);
        var inductionVariable = progression.x1_1;
        var last = progression.y1_1;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            content[i - gap | 0] = content[i];
            if (condition(content[i])) {
              gap = gap + 1 | 0;
            }
          }
           while (!(i === last));
        fill_0(content, null, size - gap | 0, size);
        this_0.tz_1 = this_0.tz_1 - gap | 0;
        if (tmp0_safe_receiver.r()) {
          _get_map__e6co1h($this).a3(key);
        }
        if (tmp0_safe_receiver.n1() === 1) {
          _get_map__e6co1h($this).h13(key, tmp0_safe_receiver.vg());
        }
      } else {
        if (condition(!(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE())) {
          _get_map__e6co1h($this).a3(key);
        }
      }
    }
  }
  function MultiValueMap__toString_impl_9zsder($this) {
    return 'MultiValueMap(map=' + $this.toString() + ')';
  }
  function MultiValueMap__hashCode_impl_vqya7m($this) {
    return $this.hashCode();
  }
  function MultiValueMap__equals_impl_qimysq($this, other) {
    if (!(other instanceof MultiValueMap))
      return false;
    var tmp0_other_with_cast = other.e3p_1;
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function access$_get_map__v7axsb($this) {
    return _get_map__e6co1h($this);
  }
  function MultiValueMap(map) {
    this.e3p_1 = map;
  }
  protoOf(MultiValueMap).toString = function () {
    return MultiValueMap__toString_impl_9zsder(this.e3p_1);
  };
  protoOf(MultiValueMap).hashCode = function () {
    return MultiValueMap__hashCode_impl_vqya7m(this.e3p_1);
  };
  protoOf(MultiValueMap).equals = function (other) {
    return MultiValueMap__equals_impl_qimysq(this.e3p_1, other);
  };
  var androidx_compose_runtime_collection_MutableVector$stable;
  function VectorListIterator(list, index) {
    this.e4a_1 = list;
    this.f4a_1 = index;
  }
  protoOf(VectorListIterator).u = function () {
    return this.f4a_1 < this.e4a_1.n1();
  };
  protoOf(VectorListIterator).v = function () {
    var _unary__edvuaz = this.f4a_1;
    this.f4a_1 = _unary__edvuaz + 1 | 0;
    return this.e4a_1.l1(_unary__edvuaz);
  };
  protoOf(VectorListIterator).l4 = function () {
    this.f4a_1 = this.f4a_1 - 1 | 0;
    this.e4a_1.h3(this.f4a_1);
  };
  protoOf(VectorListIterator).v4 = function () {
    return this.f4a_1 > 0;
  };
  protoOf(VectorListIterator).w4 = function () {
    return this.f4a_1;
  };
  protoOf(VectorListIterator).x4 = function () {
    this.f4a_1 = this.f4a_1 - 1 | 0;
    return this.e4a_1.l1(this.f4a_1);
  };
  protoOf(VectorListIterator).y4 = function () {
    return this.f4a_1 - 1 | 0;
  };
  function MutableVectorList(vector) {
    this.g4a_1 = vector;
  }
  protoOf(MutableVectorList).n1 = function () {
    return this.g4a_1.d3e_1;
  };
  protoOf(MutableVectorList).lh = function (element) {
    return this.g4a_1.lh(element);
  };
  protoOf(MutableVectorList).m1 = function (element) {
    if (!true)
      return false;
    return this.lh(element);
  };
  protoOf(MutableVectorList).mh = function (elements) {
    return this.g4a_1.mh(elements);
  };
  protoOf(MutableVectorList).r2 = function (elements) {
    return this.mh(elements);
  };
  protoOf(MutableVectorList).l1 = function (index) {
    checkIndex(this, index);
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    return this.g4a_1.b3e_1[index];
  };
  protoOf(MutableVectorList).yz = function (element) {
    return this.g4a_1.yz(element);
  };
  protoOf(MutableVectorList).q1 = function (element) {
    if (!true)
      return -1;
    return this.yz(element);
  };
  protoOf(MutableVectorList).r = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
    return this.g4a_1.d3e_1 === 0;
  };
  protoOf(MutableVectorList).t = function () {
    return new VectorListIterator(this, 0);
  };
  protoOf(MutableVectorList).zz = function (element) {
    return this.g4a_1.zz(element);
  };
  protoOf(MutableVectorList).j1 = function (element) {
    return this.zz(element);
  };
  protoOf(MutableVectorList).ni = function (index, element) {
    return this.g4a_1.ni(index, element);
  };
  protoOf(MutableVectorList).g3 = function (index, element) {
    return this.ni(index, element);
  };
  protoOf(MutableVectorList).d10 = function (index, elements) {
    return this.g4a_1.d10(index, elements);
  };
  protoOf(MutableVectorList).e3 = function (index, elements) {
    return this.d10(index, elements);
  };
  protoOf(MutableVectorList).e10 = function (elements) {
    return this.g4a_1.e10(elements);
  };
  protoOf(MutableVectorList).o1 = function (elements) {
    return this.e10(elements);
  };
  protoOf(MutableVectorList).c3 = function () {
    return this.g4a_1.c3();
  };
  protoOf(MutableVectorList).p1 = function (index) {
    return new VectorListIterator(this, index);
  };
  protoOf(MutableVectorList).g10 = function (element) {
    return this.g4a_1.g10(element);
  };
  protoOf(MutableVectorList).d3 = function (element) {
    if (!true)
      return false;
    return this.g10(element);
  };
  protoOf(MutableVectorList).h3 = function (index) {
    checkIndex(this, index);
    return this.g4a_1.h3(index);
  };
  protoOf(MutableVectorList).mi = function (index, element) {
    checkIndex(this, index);
    return this.g4a_1.mi(index, element);
  };
  protoOf(MutableVectorList).f3 = function (index, element) {
    return this.mi(index, element);
  };
  protoOf(MutableVectorList).t2 = function (fromIndex, toIndex) {
    checkSubIndex(this, fromIndex, toIndex);
    return new SubList(this, fromIndex, toIndex);
  };
  function SubList(list, start, end) {
    this.h4a_1 = list;
    this.i4a_1 = start;
    this.j4a_1 = end;
  }
  protoOf(SubList).n1 = function () {
    return this.j4a_1 - this.i4a_1 | 0;
  };
  protoOf(SubList).lh = function (element) {
    var inductionVariable = this.i4a_1;
    var last = this.j4a_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.h4a_1.l1(i), element)) {
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(SubList).m1 = function (element) {
    if (!true)
      return false;
    return this.lh(element);
  };
  protoOf(SubList).mh = function (elements) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = elements.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!this.lh(element)) {
        return false;
      }
    }
    return true;
  };
  protoOf(SubList).r2 = function (elements) {
    return this.mh(elements);
  };
  protoOf(SubList).l1 = function (index) {
    checkIndex(this, index);
    return this.h4a_1.l1(index + this.i4a_1 | 0);
  };
  protoOf(SubList).yz = function (element) {
    var inductionVariable = this.i4a_1;
    var last = this.j4a_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.h4a_1.l1(i), element)) {
          return i - this.i4a_1 | 0;
        }
      }
       while (inductionVariable < last);
    return -1;
  };
  protoOf(SubList).q1 = function (element) {
    if (!true)
      return -1;
    return this.yz(element);
  };
  protoOf(SubList).r = function () {
    return this.j4a_1 === this.i4a_1;
  };
  protoOf(SubList).t = function () {
    return new VectorListIterator(this, 0);
  };
  protoOf(SubList).zz = function (element) {
    var _unary__edvuaz = this.j4a_1;
    this.j4a_1 = _unary__edvuaz + 1 | 0;
    this.h4a_1.g3(_unary__edvuaz, element);
    return true;
  };
  protoOf(SubList).j1 = function (element) {
    return this.zz(element);
  };
  protoOf(SubList).ni = function (index, element) {
    this.h4a_1.g3(index + this.i4a_1 | 0, element);
    this.j4a_1 = this.j4a_1 + 1 | 0;
  };
  protoOf(SubList).g3 = function (index, element) {
    return this.ni(index, element);
  };
  protoOf(SubList).d10 = function (index, elements) {
    this.h4a_1.e3(index + this.i4a_1 | 0, elements);
    var size = elements.n1();
    this.j4a_1 = this.j4a_1 + size | 0;
    return size > 0;
  };
  protoOf(SubList).e3 = function (index, elements) {
    return this.d10(index, elements);
  };
  protoOf(SubList).e10 = function (elements) {
    this.h4a_1.e3(this.j4a_1, elements);
    var size = elements.n1();
    this.j4a_1 = this.j4a_1 + size | 0;
    return size > 0;
  };
  protoOf(SubList).o1 = function (elements) {
    return this.e10(elements);
  };
  protoOf(SubList).c3 = function () {
    var inductionVariable = this.j4a_1 - 1 | 0;
    var last = this.i4a_1;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.h4a_1.h3(i);
      }
       while (!(i === last));
    this.j4a_1 = this.i4a_1;
  };
  protoOf(SubList).p1 = function (index) {
    return new VectorListIterator(this, index);
  };
  protoOf(SubList).g10 = function (element) {
    var inductionVariable = this.i4a_1;
    var last = this.j4a_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.h4a_1.l1(i), element)) {
          this.h4a_1.h3(i);
          this.j4a_1 = this.j4a_1 - 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(SubList).d3 = function (element) {
    if (!true)
      return false;
    return this.g10(element);
  };
  protoOf(SubList).h3 = function (index) {
    checkIndex(this, index);
    var item = this.h4a_1.h3(index + this.i4a_1 | 0);
    this.j4a_1 = this.j4a_1 - 1 | 0;
    return item;
  };
  protoOf(SubList).mi = function (index, element) {
    checkIndex(this, index);
    return this.h4a_1.f3(index + this.i4a_1 | 0, element);
  };
  protoOf(SubList).f3 = function (index, element) {
    return this.mi(index, element);
  };
  protoOf(SubList).t2 = function (fromIndex, toIndex) {
    checkSubIndex(this, fromIndex, toIndex);
    return new SubList(this, fromIndex, toIndex);
  };
  function MutableVector(content, size) {
    this.b3e_1 = content;
    this.c3e_1 = null;
    this.d3e_1 = size;
  }
  protoOf(MutableVector).zz = function (element) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.ensureCapacity' call
    var capacity = this.d3e_1 + 1 | 0;
    if (this.b3e_1.length < capacity) {
      this.k4a(capacity);
    }
    this.b3e_1[this.d3e_1] = element;
    this.d3e_1 = this.d3e_1 + 1 | 0;
    return true;
  };
  protoOf(MutableVector).ni = function (index, element) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.ensureCapacity' call
    var capacity = this.d3e_1 + 1 | 0;
    if (this.b3e_1.length < capacity) {
      this.k4a(capacity);
    }
    var content = this.b3e_1;
    if (!(index === this.d3e_1)) {
      var tmp4 = index + 1 | 0;
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = this.d3e_1;
      arrayCopy(content, content, tmp4, index, endIndex);
    }
    content[index] = element;
    this.d3e_1 = this.d3e_1 + 1 | 0;
  };
  protoOf(MutableVector).l4a = function (index, elements) {
    if (elements.r())
      return false;
    var elementsSize = elements.n1();
    // Inline function 'androidx.compose.runtime.collection.MutableVector.ensureCapacity' call
    var capacity = this.d3e_1 + elementsSize | 0;
    if (this.b3e_1.length < capacity) {
      this.k4a(capacity);
    }
    var content = this.b3e_1;
    if (!(index === this.d3e_1)) {
      var tmp4 = index + elementsSize | 0;
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = this.d3e_1;
      arrayCopy(content, content, tmp4, index, endIndex);
    }
    var inductionVariable = 0;
    var last = elements.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        content[index + i | 0] = elements.l1(i);
      }
       while (inductionVariable <= last);
    this.d3e_1 = this.d3e_1 + elementsSize | 0;
    return true;
  };
  protoOf(MutableVector).m4a = function (index, elements) {
    var elementsSize = elements.d3e_1;
    if (elementsSize === 0)
      return false;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.ensureCapacity' call
    var capacity = this.d3e_1 + elementsSize | 0;
    if (this.b3e_1.length < capacity) {
      this.k4a(capacity);
    }
    var content = this.b3e_1;
    if (!(index === this.d3e_1)) {
      var tmp4 = index + elementsSize | 0;
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = this.d3e_1;
      arrayCopy(content, content, tmp4, index, endIndex);
    }
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = elements.b3e_1;
    arrayCopy(this_0, content, index, 0, elementsSize);
    this.d3e_1 = this.d3e_1 + elementsSize | 0;
    return true;
  };
  protoOf(MutableVector).d10 = function (index, elements) {
    if (elements.r())
      return false;
    var elementsSize = elements.n1();
    // Inline function 'androidx.compose.runtime.collection.MutableVector.ensureCapacity' call
    var capacity = this.d3e_1 + elementsSize | 0;
    if (this.b3e_1.length < capacity) {
      this.k4a(capacity);
    }
    var content = this.b3e_1;
    if (!(index === this.d3e_1)) {
      var tmp4 = index + elementsSize | 0;
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = this.d3e_1;
      arrayCopy(content, content, tmp4, index, endIndex);
    }
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index_0 = 0;
    var _iterator__ex2g4s = elements.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var _unary__edvuaz = index_0;
      index_0 = _unary__edvuaz + 1 | 0;
      content[index + checkIndexOverflow(_unary__edvuaz) | 0] = item;
    }
    this.d3e_1 = this.d3e_1 + elementsSize | 0;
    return true;
  };
  protoOf(MutableVector).e10 = function (elements) {
    return this.d10(this.d3e_1, elements);
  };
  protoOf(MutableVector).q10 = function () {
    var tmp0_elvis_lhs = this.c3e_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new MutableVectorList(this);
      this.c3e_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MutableVector).c3 = function () {
    var content = this.b3e_1;
    var inductionVariable = 0;
    var last = this.d3e_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        content[i] = null;
      }
       while (inductionVariable < last);
    this.d3e_1 = 0;
  };
  protoOf(MutableVector).lh = function (element) {
    var inductionVariable = 0;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
    var last = this.d3e_1 - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index = i;
        var tmp$ret$1 = this.b3e_1[index];
        if (equals(tmp$ret$1, element))
          return true;
      }
       while (!(i === last));
    return false;
  };
  protoOf(MutableVector).mh = function (elements) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = elements.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!this.lh(element))
        return false;
    }
    return true;
  };
  protoOf(MutableVector).k4a = function (capacity) {
    var oldContent = this.b3e_1;
    var oldSize = oldContent.length;
    // Inline function 'kotlin.math.max' call
    var b = imul(oldSize, 2);
    var newSize = Math.max(capacity, b);
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = Array(newSize);
    var newContent = isArray(tmp) ? tmp : THROW_CCE();
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(oldContent, newContent, 0, 0, oldSize);
    this.b3e_1 = newContent;
  };
  protoOf(MutableVector).vg = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
    if (this.d3e_1 === 0) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.throwNoSuchElementException' call
      this.n4a('MutableVector is empty.');
    }
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    return this.b3e_1[0];
  };
  protoOf(MutableVector).n4a = function (message) {
    throw NoSuchElementException_init_$Create$(message);
  };
  protoOf(MutableVector).yz = function (element) {
    var tmp = this.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this.d3e_1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(element, content[i]))
          return i;
      }
       while (inductionVariable < size);
    return -1;
  };
  protoOf(MutableVector).xg = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
    if (this.d3e_1 === 0) {
      this.n4a('MutableVector is empty.');
    }
    // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    var index = this.d3e_1 - 1 | 0;
    return this.b3e_1[index];
  };
  protoOf(MutableVector).g10 = function (element) {
    var index = this.yz(element);
    if (index >= 0) {
      this.h3(index);
      return true;
    }
    return false;
  };
  protoOf(MutableVector).h3 = function (index) {
    var content = this.b3e_1;
    var item = content[index];
    // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
    if (!(index === (this.d3e_1 - 1 | 0))) {
      var tmp6 = index + 1 | 0;
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = this.d3e_1;
      arrayCopy(content, content, index, tmp6, endIndex);
    }
    this.d3e_1 = this.d3e_1 - 1 | 0;
    content[this.d3e_1] = null;
    return item;
  };
  protoOf(MutableVector).e5 = function (start, end) {
    if (end > start) {
      if (end < this.d3e_1) {
        var tmp0 = this.b3e_1;
        var tmp2 = this.b3e_1;
        // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.d3e_1;
        arrayCopy(tmp0, tmp2, start, end, endIndex);
      }
      var newSize = this.d3e_1 - (end - start | 0) | 0;
      var inductionVariable = newSize;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var last = this.d3e_1 - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.b3e_1[i] = null;
        }
         while (!(i === last));
      this.d3e_1 = newSize;
    }
  };
  protoOf(MutableVector).x41 = function (newSize) {
    this.d3e_1 = newSize;
  };
  protoOf(MutableVector).mi = function (index, element) {
    var content = this.b3e_1;
    var old = content[index];
    content[index] = element;
    return old;
  };
  protoOf(MutableVector).o4a = function (comparator) {
    var tmp = this.b3e_1;
    sortWith_0(isArray(tmp) ? tmp : THROW_CCE(), comparator, 0, this.d3e_1);
  };
  function checkIndex(_this__u8e3s4, index) {
    var size = _this__u8e3s4.n1();
    if (index < 0 || index >= size) {
      throwListIndexOutOfBoundsException(index, size);
    }
  }
  function checkSubIndex(_this__u8e3s4, fromIndex, toIndex) {
    if (fromIndex > toIndex) {
      throwReversedIndicesException(fromIndex, toIndex);
    }
    if (fromIndex < 0) {
      throwNegativeIndexException(fromIndex);
    }
    if (toIndex > _this__u8e3s4.n1()) {
      throwOutOfRangeException(toIndex, _this__u8e3s4.n1());
    }
  }
  function throwListIndexOutOfBoundsException(index, size) {
    throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' is out of bounds. The list has ' + size + ' elements.');
  }
  function throwReversedIndicesException(fromIndex, toIndex) {
    throw IllegalArgumentException_init_$Create$('Indices are out of order. fromIndex (' + fromIndex + ') is greater than toIndex (' + toIndex + ').');
  }
  function throwNegativeIndexException(fromIndex) {
    throw IndexOutOfBoundsException_init_$Create$('fromIndex (' + fromIndex + ') is less than 0.');
  }
  function throwOutOfRangeException(toIndex, size) {
    throw IndexOutOfBoundsException_init_$Create$('toIndex (' + toIndex + ') is more than than the list size (' + size + ')');
  }
  var androidx_compose_runtime_collection_ScatterSetWrapper$stable;
  function wrapIntoSet(_this__u8e3s4) {
    return new ScatterSetWrapper(_this__u8e3s4);
  }
  function ScatterSetWrapper$iterator$slambda(this$0, resultContinuation) {
    this.x4a_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScatterSetWrapper$iterator$slambda).i4b = function ($this$iterator, $completion) {
    var tmp = this.j4b($this$iterator, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ScatterSetWrapper$iterator$slambda).ja = function (p1, $completion) {
    return this.i4b(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScatterSetWrapper$iterator$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            var this_0 = this.x4a_1.s37_1;
            this.b4b_1 = this_0.k16_1;
            this.h4b_1 = this_0;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.f4b_1 = this.h4b_1.j16_1;
            this.e4b_1 = this.f4b_1.length - 2 | 0;
            this.g4b_1 = numberRangeToNumber(0, this.e4b_1).t();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!this.g4b_1.u()) {
              this.n9_1 = 9;
              continue $sm;
            }

            this.c4b_1 = this.g4b_1.v();
            this.a4b_1 = this.f4b_1[this.c4b_1];
            var this_1 = this.a4b_1;
            if (!equalsLong(bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144)), new Long(-2139062144, -2139062144))) {
              this.z4a_1 = 8 - (~(this.c4b_1 - this.e4b_1 | 0) >>> 31 | 0) | 0;
              this.d4b_1 = until(0, this.z4a_1).t();
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 8;
              continue $sm;
            }

          case 3:
            if (!this.d4b_1.u()) {
              this.n9_1 = 6;
              continue $sm;
            }

            var j = this.d4b_1.v();
            var value = bitwiseAnd(this.a4b_1, new Long(255, 0));
            if (compare(value, new Long(128, 0)) < 0) {
              var index = (this.c4b_1 << 3) + j | 0;
              var it = this.b4b_1[index];
              this.n9_1 = 4;
              suspendResult = this.y4a_1.oi(it, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.a4b_1 = shiftRight(this.a4b_1, 8);
            this.n9_1 = 3;
            continue $sm;
          case 6:
            if (!(this.z4a_1 === 8)) {
              this.n9_1 = 10;
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 7:
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.n9_1 = 2;
            continue $sm;
          case 9:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 10;
            continue $sm;
          case 10:
            return Unit_instance;
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 11) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScatterSetWrapper$iterator$slambda).j4b = function ($this$iterator, completion) {
    var i = new ScatterSetWrapper$iterator$slambda(this.x4a_1, completion);
    i.y4a_1 = $this$iterator;
    return i;
  };
  function ScatterSetWrapper$iterator$slambda_0(this$0, resultContinuation) {
    var i = new ScatterSetWrapper$iterator$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$iterator, $completion) {
      return i.i4b($this$iterator, $completion);
    }, 1);
  }
  function ScatterSetWrapper(set) {
    this.s37_1 = set;
  }
  protoOf(ScatterSetWrapper).n1 = function () {
    return this.s37_1.n1();
  };
  protoOf(ScatterSetWrapper).r = function () {
    return this.s37_1.r();
  };
  protoOf(ScatterSetWrapper).t = function () {
    return iterator(ScatterSetWrapper$iterator$slambda_0(this, null));
  };
  protoOf(ScatterSetWrapper).mh = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!this.s37_1.m1(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(ScatterSetWrapper).r2 = function (elements) {
    return this.mh(elements);
  };
  protoOf(ScatterSetWrapper).lh = function (element) {
    return this.s37_1.m1(element);
  };
  protoOf(ScatterSetWrapper).m1 = function (element) {
    if (!true)
      return false;
    return this.lh(element);
  };
  function _ScopeMap___init__impl__52wntz(map) {
    map = map === VOID ? mutableScatterMapOf() : map;
    return map;
  }
  function _ScopeMap___get_map__impl__vxhazm($this) {
    return $this;
  }
  function _ScopeMap___get_size__impl__f25bvl($this) {
    return _ScopeMap___get_map__impl__vxhazm($this).n1();
  }
  function ScopeMap__get_impl_5bu0tb($this, key) {
    return _ScopeMap___get_map__impl__vxhazm($this).w2(key);
  }
  function ScopeMap__add_impl_n8b3uc($this, key, scope) {
    // Inline function 'androidx.collection.MutableScatterMap.compute' call
    var this_0 = _ScopeMap___get_map__impl__vxhazm($this);
    var index = this_0.i13(key);
    var inserting = index < 0;
    var value = inserting ? null : this_0.y12_1[index];
    var tmp;
    if (value == null) {
      tmp = scope;
    } else {
      if (value instanceof MutableScatterSet) {
        (value instanceof MutableScatterSet ? value : THROW_CCE()).j1(scope);
        tmp = value;
      } else {
        var tmp_0;
        if (!(value === scope)) {
          var set = new MutableScatterSet();
          set.j1(!(value == null) ? value : THROW_CCE());
          set.j1(scope);
          tmp_0 = set;
        } else {
          tmp_0 = value;
        }
        tmp = tmp_0;
      }
    }
    var computedValue = tmp;
    if (inserting) {
      var insertionIndex = ~index;
      this_0.x12_1[insertionIndex] = key;
      this_0.y12_1[insertionIndex] = computedValue;
    } else {
      this_0.y12_1[index] = computedValue;
    }
  }
  function ScopeMap__addAll_impl_5vhc63($this, key, scope) {
    // Inline function 'androidx.collection.MutableScatterMap.compute' call
    var this_0 = _ScopeMap___get_map__impl__vxhazm($this);
    var index = this_0.i13(key);
    var inserting = index < 0;
    var value = inserting ? null : this_0.y12_1[index];
    var tmp;
    if (value == null) {
      // Inline function 'kotlin.also' call
      var this_1 = mutableScatterSetOf();
      this_1.s16(scope);
      tmp = this_1;
    } else {
      if (value instanceof MutableScatterSet) {
        // Inline function 'kotlin.also' call
        var this_2 = value instanceof MutableScatterSet ? value : THROW_CCE();
        this_2.s16(scope);
        tmp = this_2;
      } else {
        if (value == null)
          THROW_CCE();
        var tmp_0;
        if (scope.n1() === 1 && scope.m1(value)) {
          tmp_0 = value;
        } else {
          var set = mutableScatterSetOf();
          set.s16(scope);
          set.j1(value);
          tmp_0 = set;
        }
        tmp = tmp_0;
      }
    }
    var computedValue = tmp;
    if (inserting) {
      var insertionIndex = ~index;
      this_0.x12_1[insertionIndex] = key;
      this_0.y12_1[insertionIndex] = computedValue;
    } else {
      this_0.y12_1[index] = computedValue;
    }
  }
  function ScopeMap__set_impl_3y8kbx($this, key, value) {
    _ScopeMap___get_map__impl__vxhazm($this).h13(key, value);
  }
  function ScopeMap__contains_impl_6qp7s6($this, element) {
    return _ScopeMap___get_map__impl__vxhazm($this).u2(element);
  }
  function ScopeMap__forEachKey_impl_dgpcls($this, block) {
    var tmp0 = _ScopeMap___get_map__impl__vxhazm($this);
    // Inline function 'androidx.collection.ScatterMap.forEachKey' call
    var block_0 = typeof block === 'function' ? block : THROW_CCE();
    var k = tmp0.x12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = tmp0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_0 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  block_0(k[index]);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  }
  function ScopeMap__clear_impl_2jofm0($this) {
    _ScopeMap___get_map__impl__vxhazm($this).c3();
  }
  function ScopeMap__isEmpty_impl_55kv6a($this) {
    return _ScopeMap___get_map__impl__vxhazm($this).r();
  }
  function ScopeMap__isNotEmpty_impl_w6zp9b($this) {
    return _ScopeMap___get_map__impl__vxhazm($this).fv();
  }
  function ScopeMap__remove_impl_ocu4rj($this, key) {
    return _ScopeMap___get_map__impl__vxhazm($this).a3(key);
  }
  function ScopeMap__remove_impl_ocu4rj_0($this, key, scope) {
    var tmp0_elvis_lhs = _ScopeMap___get_map__impl__vxhazm($this).w2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    if (value instanceof MutableScatterSet) {
      var set = value instanceof MutableScatterSet ? value : THROW_CCE();
      var removed = set.d3(scope);
      if (removed && set.r()) {
        _ScopeMap___get_map__impl__vxhazm($this).a3(key);
      }
      return removed;
    } else {
      if (equals(value, scope)) {
        _ScopeMap___get_map__impl__vxhazm($this).a3(key);
        tmp_0 = true;
      } else {
        tmp_0 = false;
      }
    }
    return tmp_0;
  }
  function ScopeMap__removeScope_impl_8k6ux1($this, scope) {
    // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
    var this_0 = _ScopeMap___get_map__impl__vxhazm($this);
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  this_0.x12_1[index];
                  var value_0 = this_0.y12_1[index];
                  var tmp;
                  if (value_0 instanceof MutableScatterSet) {
                    var set = value_0 instanceof MutableScatterSet ? value_0 : THROW_CCE();
                    set.d3(scope);
                    tmp = set.r();
                  } else {
                    tmp = value_0 === scope;
                  }
                  if (tmp) {
                    this_0.hw(index);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  }
  var androidx_compose_runtime_composer_DebugStringFormattable$stable;
  function DebugStringFormattable() {
  }
  var androidx_compose_runtime_composer_GroupInfo$stable;
  function GroupInfo(slotIndex, nodeIndex, nodeCount) {
    this.g3p_1 = slotIndex;
    this.h3p_1 = nodeIndex;
    this.i3p_1 = nodeCount;
  }
  function _GroupKind___init__impl__iwqg06(value) {
    return value;
  }
  function _GroupKind___get_value__impl__cf5pqe($this) {
    return $this;
  }
  function Companion_7() {
    Companion_instance_8 = this;
    this.n3j_1 = _GroupKind___init__impl__iwqg06(0);
    this.o3j_1 = _GroupKind___init__impl__iwqg06(1);
    this.p3j_1 = _GroupKind___init__impl__iwqg06(2);
  }
  var Companion_instance_8;
  function Companion_getInstance_7() {
    if (Companion_instance_8 == null)
      new Companion_7();
    return Companion_instance_8;
  }
  function GroupSourceInformation() {
  }
  var androidx_compose_runtime_composer_ThrowingRememberManagerStub$stable;
  function throwIllegalOperationException_0($this) {
    composeImmediateRuntimeError('ChangeList cannot call the RememberManager when executing pending changes outside of the applier phase.');
  }
  function ThrowingRememberManagerStub() {
  }
  protoOf(ThrowingRememberManagerStub).o4b = function (instance) {
    return throwIllegalOperationException_0(this);
  };
  protoOf(ThrowingRememberManagerStub).f36 = function (instance) {
    return throwIllegalOperationException_0(this);
  };
  protoOf(ThrowingRememberManagerStub).i3o = function (effect) {
    return throwIllegalOperationException_0(this);
  };
  protoOf(ThrowingRememberManagerStub).o3p = function (instance) {
    return throwIllegalOperationException_0(this);
  };
  protoOf(ThrowingRememberManagerStub).e36 = function (instance) {
    return throwIllegalOperationException_0(this);
  };
  protoOf(ThrowingRememberManagerStub).q3o = function (scope) {
    return throwIllegalOperationException_0(this);
  };
  protoOf(ThrowingRememberManagerStub).j3m = function (scope) {
    return throwIllegalOperationException_0(this);
  };
  protoOf(ThrowingRememberManagerStub).v3o = function (scope) {
    return throwIllegalOperationException_0(this);
  };
  var ThrowingRememberManagerStub_instance;
  function ThrowingRememberManagerStub_getInstance() {
    return ThrowingRememberManagerStub_instance;
  }
  var androidx_compose_runtime_composer_gapbuffer_GapAnchor$stable;
  function GapAnchor(loc) {
    this.l3o_1 = loc;
  }
  protoOf(GapAnchor).d2y = function () {
    return !(this.l3o_1 === -2147483648);
  };
  protoOf(GapAnchor).m3o = function (slots) {
    return slots.q3m(this);
  };
  protoOf(GapAnchor).p4b = function (writer) {
    return writer.q3m(this);
  };
  protoOf(GapAnchor).toString = function () {
    return anyToString(this) + '{ location = ' + this.l3o_1 + ' }';
  };
  function asGapAnchor(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof GapAnchor ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composition');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function get_EmptyLongArray() {
    _init_properties_SlotTable_kt__9b2e7y();
    return EmptyLongArray;
  }
  var EmptyLongArray;
  var androidx_compose_runtime_composer_gapbuffer_SlotTable$stable;
  var androidx_compose_runtime_composer_gapbuffer_GapGroupSourceInformation$stable;
  var androidx_compose_runtime_composer_gapbuffer_SlotReader$stable;
  var androidx_compose_runtime_composer_gapbuffer_KeyInfo$stable;
  var androidx_compose_runtime_composer_gapbuffer_SlotWriter$stable;
  var androidx_compose_runtime_composer_gapbuffer_BitVector$stable;
  function tryAnchor($this, index) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!$this.o34_1) {
      var tmp$ret$1 = 'use active SlotWriter to crate an anchor for location instead';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    return (0 <= index ? index < $this.j34_1 : false) ? find($this.q34_1, index, $this.j34_1) : null;
  }
  function SlotTable$extractNestedStates$lambda(this$0) {
    return function (it) {
      return this$0.q3m(asGapAnchor(it.g35_1));
    };
  }
  function extractNestedStates$closeToGroupContaining($writer, group) {
    while ($writer.d34_1 >= 0 && $writer.c34_1 <= group) {
      $writer.z30();
      $writer.z35();
    }
  }
  function extractNestedStates$openParent($writer, parent) {
    extractNestedStates$closeToGroupContaining($writer, parent);
    while (!($writer.b34_1 === parent) && !$writer.l3l()) {
      if (parent < get_nextGroup($writer)) {
        $writer.x3j();
      } else {
        $writer.y35();
      }
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!($writer.b34_1 === parent)) {
      var tmp$ret$1 = 'Unexpected slot table structure';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    $writer.x3j();
  }
  function SlotTable() {
    SlotStorage.call(this);
    this.i34_1 = new Int32Array(0);
    this.j34_1 = 0;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(0);
    while (tmp_0 < 0) {
      tmp_1[tmp_0] = null;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.k34_1 = tmp_1;
    this.l34_1 = 0;
    this.m34_1 = 0;
    var tmp_2 = this;
    // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
    tmp_2.n34_1 = null == null ? new Object() : null;
    this.o34_1 = false;
    this.p34_1 = 0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.q34_1 = ArrayList_init_$Create$();
    this.r34_1 = null;
    this.s34_1 = null;
  }
  protoOf(SlotTable).oy = function () {
    return this.j34_1 === 0;
  };
  protoOf(SlotTable).t39 = function (rememberManager) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = this.s35();
    var normalClose = false;
    var tmp;
    try {
      removeCurrentGroup(writer, rememberManager);
      // Inline function 'kotlin.also' call
      normalClose = true;
      tmp = Unit_instance;
    }finally {
      writer.b36(normalClose);
    }
  };
  protoOf(SlotTable).d3i = function () {
    if (this.o34_1) {
      // Inline function 'kotlin.error' call
      var message = 'Cannot read while a writer is pending';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.m34_1 = this.m34_1 + 1 | 0;
    return new SlotReader(this);
  };
  protoOf(SlotTable).s35 = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.o34_1) {
      var tmp$ret$1 = 'Cannot start a writer when another writer is pending';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.m34_1 <= 0)) {
      var tmp$ret$3 = 'Cannot start a writer when a reader is pending';
      composeImmediateRuntimeError(tmp$ret$3);
    }
    this.o34_1 = true;
    this.p34_1 = this.p34_1 + 1 | 0;
    return new SlotWriter(this);
  };
  protoOf(SlotTable).o3k = function (index) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.o34_1) {
      var tmp$ret$1 = 'use active SlotWriter to create an anchor location instead';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(0 <= index ? index < this.j34_1 : false)) {
      var tmp$ret$3 = 'Parameter index is out of range';
      throwIllegalArgumentException(tmp$ret$3);
    }
    var tmp0 = this.q34_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.getOrAdd' call
    var effectiveSize = this.j34_1;
    var location = search(tmp0, index, effectiveSize);
    var tmp;
    if (location < 0) {
      var anchor = new GapAnchor(index);
      tmp0.g3(-(location + 1 | 0) | 0, anchor);
      tmp = anchor;
    } else {
      tmp = tmp0.l1(location);
    }
    return tmp;
  };
  protoOf(SlotTable).q3m = function (anchor) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.o34_1) {
      var tmp$ret$1 = 'Use active SlotWriter to determine anchor location instead';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!anchor.d2y()) {
      var tmp$ret$3 = 'Anchor refers to a group that was removed';
      throwIllegalArgumentException(tmp$ret$3);
    }
    return anchor.l3o_1;
  };
  protoOf(SlotTable).q40 = function (anchor) {
    var tmp;
    if (anchor.d2y()) {
      // Inline function 'kotlin.let' call
      var it = search(this.q34_1, anchor.l3o_1, this.j34_1);
      tmp = (it >= 0 && equals(this.q34_1.l1(it), anchor));
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SlotTable).y38 = function (group, anchor) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.o34_1) {
      var tmp$ret$1 = 'Writer is active';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(0 <= group ? group < this.j34_1 : false)) {
      var tmp$ret$3 = 'Invalid group index';
      composeImmediateRuntimeError(tmp$ret$3);
    }
    var gapAnchor = asGapAnchor(anchor);
    var tmp;
    if (this.q40(gapAnchor)) {
      var containsUpper = group + groupSize(this.i34_1, group) | 0;
      var containsArg = gapAnchor.l3o_1;
      tmp = group <= containsArg ? containsArg < containsUpper : false;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SlotTable).a3a = function (parent, child) {
    var group = asGapAnchor(parent).l3o_1;
    var groupEnd = group + groupSize(this.i34_1, group) | 0;
    var containsArg = asGapAnchor(child).l3o_1;
    return group <= containsArg ? containsArg < groupEnd : false;
  };
  protoOf(SlotTable).q4b = function (reader, sourceInformationMap) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(reader.v3i_1 === this && this.m34_1 > 0)) {
      var tmp$ret$1 = 'Unexpected reader close()';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.m34_1 = this.m34_1 - 1 | 0;
    if (!(sourceInformationMap == null)) {
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this.n34_1;
      var thisMap = this.r34_1;
      if (!(thisMap == null)) {
        thisMap.b3(sourceInformationMap);
      } else {
        this.r34_1 = sourceInformationMap;
      }
    }
  };
  protoOf(SlotTable).r4b = function (writer, groups, groupsSize, slots, slotsSize, anchors, sourceInformationMap, calledByMap) {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(writer.i33_1 === this && this.o34_1)) {
      var tmp$ret$1 = 'Unexpected writer close()';
      throwIllegalArgumentException(tmp$ret$1);
    }
    this.o34_1 = false;
    this.s4b(groups, groupsSize, slots, slotsSize, anchors, sourceInformationMap, calledByMap);
  };
  protoOf(SlotTable).s4b = function (groups, groupsSize, slots, slotsSize, anchors, sourceInformationMap, calledByMap) {
    this.i34_1 = groups;
    this.j34_1 = groupsSize;
    this.k34_1 = slots;
    this.l34_1 = slotsSize;
    this.q34_1 = anchors;
    this.r34_1 = sourceInformationMap;
    this.s34_1 = calledByMap;
  };
  protoOf(SlotTable).e3b = function (scope) {
    var tmp0_safe_receiver = scope.m35_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.q40(asGapAnchor(tmp0_safe_receiver));
    }
    return tmp === true;
  };
  protoOf(SlotTable).f3n = function () {
    var tmp;
    if (this.j34_1 > 0) {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.containsMark' call
      tmp = !((this.i34_1[imul(0, 5) + 1 | 0] & 67108864) === 0);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SlotTable).t4b = function (group) {
    var tmp0_safe_receiver = this.r34_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = tryAnchor(this, group);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = tmp0_safe_receiver.w2(tmp0_safe_receiver_0);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(SlotTable).v34 = function () {
    this.s34_1 = new MutableIntObjectMap();
  };
  protoOf(SlotTable).t34 = function () {
    this.r34_1 = HashMap_init_$Create$_0();
  };
  protoOf(SlotTable).l3b = function (rememberManager) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = this.s35();
    var normalClose = false;
    var tmp;
    try {
      deactivateCurrentGroup(writer, rememberManager);
      // Inline function 'kotlin.also' call
      normalClose = true;
      tmp = Unit_instance;
    }finally {
      writer.b36(normalClose);
    }
  };
  protoOf(SlotTable).s1d = function () {
  };
  protoOf(SlotTable).m3b = function (applier, references) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'androidx.compose.runtime.collection.fastFilter' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'androidx.compose.runtime.collection.all' call
        // Inline function 'androidx.collection.ObjectList.forEach' call
        // Inline function 'kotlin.contracts.contract' call
        var content = references.sz_1;
        var inductionVariable = 0;
        var last = references.tz_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var it = content[i];
            if (!this.q40(asGapAnchor(it.g35_1))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < last);
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        tmp$ret$0 = references;
        break $l$block_0;
      }
      var target = new MutableObjectList();
      // Inline function 'androidx.collection.ObjectList.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var content_0 = references.sz_1;
      var inductionVariable_0 = 0;
      var last_0 = references.tz_1;
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var it_0 = content_0[i_0];
          if (this.q40(asGapAnchor(it_0.g35_1))) {
            // Inline function 'androidx.collection.MutableObjectList.plusAssign' call
            target.j1(it_0);
          }
        }
         while (inductionVariable_0 < last_0);
      tmp$ret$0 = target;
    }
    var tmp = tmp$ret$0;
    var referencesToExtract = sortedBy(tmp, SlotTable$extractNestedStates$lambda(this));
    if (referencesToExtract.r())
      return emptyScatterMap();
    var result = mutableScatterMapOf();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = this.s35();
    var normalClose = false;
    var tmp_0;
    try {
      // Inline function 'androidx.collection.ObjectList.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var content_1 = referencesToExtract.sz_1;
      var inductionVariable_1 = 0;
      var last_1 = referencesToExtract.tz_1;
      if (inductionVariable_1 < last_1)
        do {
          var i_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var reference = content_1[i_1];
          var newGroup = writer.q3m(asGapAnchor(reference.g35_1));
          var newParent = writer.y34(newGroup);
          extractNestedStates$closeToGroupContaining(writer, newParent);
          extractNestedStates$openParent(writer, newParent);
          writer.u4b(newGroup - writer.b34_1 | 0);
          var content_2 = extractMovableContentAtCurrent(reference.e35_1, reference, writer, applier);
          result.h13(reference, content_2);
        }
         while (inductionVariable_1 < last_1);
      extractNestedStates$closeToGroupContaining(writer, 2147483647);
      // Inline function 'kotlin.also' call
      normalClose = true;
      tmp_0 = Unit_instance;
    }finally {
      writer.b36(normalClose);
    }
    return result;
  };
  protoOf(SlotTable).v3a = function (rememberManager, state) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = this.s35();
    var normalClose = false;
    var tmp;
    try {
      removeCurrentGroup(writer, rememberManager);
      // Inline function 'kotlin.also' call
      normalClose = true;
      tmp = Unit_instance;
    }finally {
      writer.b36(normalClose);
    }
  };
  protoOf(SlotTable).z3a = function () {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.fastForEach' call
    var this_0 = this.k34_1;
    var inductionVariable = 0;
    var last = this_0.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = this_0[i];
        var tmp0_safe_receiver = (!(it == null) ? isInterface(it, RecomposeScope) : false) ? it : null;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.m40();
        }
      }
       while (inductionVariable < last);
  };
  protoOf(SlotTable).p40 = function (group, slotIndex) {
    var start = slotAnchor(this.i34_1, group);
    var tmp;
    if ((group + 1 | 0) < this.j34_1) {
      var tmp0 = this.i34_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.dataAnchor' call
      var address = group + 1 | 0;
      tmp = tmp0[imul(address, 5) + 4 | 0];
    } else {
      tmp = this.k34_1.length;
    }
    var end = tmp;
    var len = end - start | 0;
    var tmp_0;
    if (0 <= slotIndex ? slotIndex < len : false) {
      return this.k34_1[start + slotIndex | 0];
    } else {
      tmp_0 = Companion_getInstance_0().f30_1;
    }
    return tmp_0;
  };
  protoOf(SlotTable).t = function () {
    return new GroupIterator(this, 0, this.j34_1);
  };
  function asGapBufferSlotTable(_this__u8e3s4) {
    _init_properties_SlotTable_kt__9b2e7y();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof SlotTable ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composition');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function node($this, $receiver, index) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    if (!(($receiver[imul(index, 5) + 1 | 0] & 1073741824) === 0)) {
      var tmp_0 = $this.y3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeIndex' call
      tmp = tmp_0[$receiver[imul(index, 5) + 4 | 0]];
    } else {
      tmp = Companion_getInstance_0().f30_1;
    }
    return tmp;
  }
  function aux($this, $receiver, index) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasAux' call
    if (!(($receiver[imul(index, 5) + 1 | 0] & 268435456) === 0)) {
      tmp = $this.y3i_1[auxIndex_0($receiver, index)];
    } else {
      tmp = Companion_getInstance_0().f30_1;
    }
    return tmp;
  }
  function objectKey($this, $receiver, index) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasObjectKey' call
    if (!(($receiver[imul(index, 5) + 1 | 0] & 536870912) === 0)) {
      tmp = $this.y3i_1[objectKeyIndex($receiver, index)];
    } else {
      tmp = null;
    }
    return tmp;
  }
  function SlotReader(table) {
    this.v3i_1 = table;
    this.w3i_1 = this.v3i_1.i34_1;
    this.x3i_1 = this.v3i_1.j34_1;
    this.y3i_1 = this.v3i_1.k34_1;
    this.z3i_1 = this.v3i_1.l34_1;
    this.a3j_1 = null;
    this.b3j_1 = false;
    this.c3j_1 = 0;
    this.d3j_1 = this.x3i_1;
    this.e3j_1 = -1;
    this.f3j_1 = new IntStack();
    this.g3j_1 = 0;
    this.h3j_1 = 0;
    this.i3j_1 = 0;
    this.j3j_1 = false;
  }
  protoOf(SlotReader).n1 = function () {
    return this.x3i_1;
  };
  protoOf(SlotReader).v4b = function () {
    return this.h3j_1 - slotAnchor(this.w3i_1, this.e3j_1) | 0;
  };
  protoOf(SlotReader).y34 = function (index) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.parentAnchor' call
    return this.w3i_1[imul(index, 5) + 2 | 0];
  };
  protoOf(SlotReader).n3o = function () {
    var tmp0 = this.w3i_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    var address = this.c3j_1;
    return !((tmp0[imul(address, 5) + 1 | 0] & 1073741824) === 0);
  };
  protoOf(SlotReader).x34 = function (index) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    return !((this.w3i_1[imul(index, 5) + 1 | 0] & 1073741824) === 0);
  };
  protoOf(SlotReader).b35 = function (index) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
    return this.w3i_1[imul(index, 5) + 1 | 0] & 67108863;
  };
  protoOf(SlotReader).z34 = function (index) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    if (!((this.w3i_1[imul(index, 5) + 1 | 0] & 1073741824) === 0)) {
      tmp = node(this, this.w3i_1, index);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SlotReader).l3l = function () {
    return this.r3l() || this.c3j_1 === this.d3j_1;
  };
  protoOf(SlotReader).r3l = function () {
    return this.g3j_1 > 0;
  };
  protoOf(SlotReader).w4b = function () {
    return groupSize(this.w3i_1, this.c3j_1);
  };
  protoOf(SlotReader).a35 = function (index) {
    return groupSize(this.w3i_1, index);
  };
  protoOf(SlotReader).x4b = function (group) {
    var start = slotAnchor(this.w3i_1, group);
    var next = group + 1 | 0;
    var tmp;
    if (next < this.x3i_1) {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.dataAnchor' call
      tmp = this.w3i_1[imul(next, 5) + 4 | 0];
    } else {
      tmp = this.z3i_1;
    }
    var end = tmp;
    return end - start | 0;
  };
  protoOf(SlotReader).i3l = function () {
    return this.d3j_1;
  };
  protoOf(SlotReader).k3k = function () {
    var tmp;
    if (this.c3j_1 < this.d3j_1) {
      var tmp0 = this.w3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.key' call
      var address = this.c3j_1;
      tmp = tmp0[imul(address, 5)];
    } else {
      tmp = 0;
    }
    return tmp;
  };
  protoOf(SlotReader).t3j = function (index) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.key' call
    return this.w3i_1[imul(index, 5)];
  };
  protoOf(SlotReader).c3o = function () {
    return this.h3j_1 - slotAnchor(this.w3i_1, this.e3j_1) | 0;
  };
  protoOf(SlotReader).b3m = function (index) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasObjectKey' call
    return !((this.w3i_1[imul(index, 5) + 1 | 0] & 536870912) === 0);
  };
  protoOf(SlotReader).s3n = function () {
    var tmp;
    if (this.c3j_1 < this.d3j_1) {
      var tmp0 = this.w3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasObjectKey' call
      var address = this.c3j_1;
      tmp = !((tmp0[imul(address, 5) + 1 | 0] & 536870912) === 0);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SlotReader).m3k = function () {
    return this.c3j_1 < this.d3j_1 ? objectKey(this, this.w3i_1, this.c3j_1) : null;
  };
  protoOf(SlotReader).u3j = function (index) {
    return objectKey(this, this.w3i_1, index);
  };
  protoOf(SlotReader).w3j = function () {
    return this.c3j_1 < this.d3j_1 ? aux(this, this.w3i_1, this.c3j_1) : 0;
  };
  protoOf(SlotReader).s3j = function (index) {
    return aux(this, this.w3i_1, index);
  };
  protoOf(SlotReader).n3n = function (index) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasMark' call
    return !((this.w3i_1[imul(index, 5) + 1 | 0] & 134217728) === 0);
  };
  protoOf(SlotReader).m3n = function (index) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.containsMark' call
    return !((this.w3i_1[imul(index, 5) + 1 | 0] & 67108864) === 0);
  };
  protoOf(SlotReader).d3m = function () {
    var tmp;
    if (this.e3j_1 >= 0) {
      var tmp0 = this.w3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
      var address = this.e3j_1;
      tmp = tmp0[imul(address, 5) + 1 | 0] & 67108863;
    } else {
      tmp = 0;
    }
    return tmp;
  };
  protoOf(SlotReader).j3l = function () {
    return this.i3j_1 - this.h3j_1 | 0;
  };
  protoOf(SlotReader).j3o = function (index) {
    return this.o3n(this.c3j_1, index);
  };
  protoOf(SlotReader).o3n = function (group, index) {
    var start = slotAnchor(this.w3i_1, group);
    var next = group + 1 | 0;
    var tmp;
    if (next < this.x3i_1) {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.dataAnchor' call
      tmp = this.w3i_1[imul(next, 5) + 4 | 0];
    } else {
      tmp = this.z3i_1;
    }
    var end = tmp;
    var address = start + index | 0;
    return address < end ? this.y3i_1[address] : Companion_getInstance_0().f30_1;
  };
  protoOf(SlotReader).v = function () {
    if (this.g3j_1 > 0 || this.h3j_1 >= this.i3j_1) {
      this.j3j_1 = false;
      return Companion_getInstance_0().f30_1;
    }
    this.j3j_1 = true;
    var tmp = this.y3i_1;
    var _unary__edvuaz = this.h3j_1;
    this.h3j_1 = _unary__edvuaz + 1 | 0;
    return tmp[_unary__edvuaz];
  };
  protoOf(SlotReader).z3j = function () {
    this.g3j_1 = this.g3j_1 + 1 | 0;
  };
  protoOf(SlotReader).q3l = function () {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(this.g3j_1 > 0)) {
      var tmp$ret$1 = 'Unbalanced begin/end empty';
      throwIllegalArgumentException(tmp$ret$1);
    }
    this.g3j_1 = this.g3j_1 - 1 | 0;
  };
  protoOf(SlotReader).j4 = function () {
    this.b3j_1 = true;
    this.v3i_1.q4b(this, this.a3j_1);
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.y3i_1 = [];
  };
  protoOf(SlotReader).x3j = function () {
    if (this.g3j_1 <= 0) {
      var parent = this.e3j_1;
      var currentGroup = this.c3j_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.parentAnchor' call
      // Inline function 'androidx.compose.runtime.requirePrecondition' call
      if (!(this.w3i_1[imul(currentGroup, 5) + 2 | 0] === parent)) {
        var tmp$ret$2 = 'Invalid slot table detected';
        throwIllegalArgumentException(tmp$ret$2);
      }
      var tmp0_safe_receiver = this.a3j_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w2(this.o3k(parent));
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.e4c(this.v3i_1, currentGroup);
      }
      var currentSlotStack = this.f3j_1;
      var currentSlot = this.h3j_1;
      var currentEndSlot = this.i3j_1;
      if (currentSlot === 0 && currentEndSlot === 0) {
        currentSlotStack.g3i(-1);
      } else {
        currentSlotStack.g3i(currentSlot);
      }
      this.e3j_1 = currentGroup;
      this.d3j_1 = currentGroup + groupSize(this.w3i_1, currentGroup) | 0;
      this.c3j_1 = currentGroup + 1 | 0;
      this.h3j_1 = slotAnchor(this.w3i_1, currentGroup);
      var tmp = this;
      var tmp_0;
      if (currentGroup >= (this.x3i_1 - 1 | 0)) {
        tmp_0 = this.z3i_1;
      } else {
        var tmp0 = this.w3i_1;
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.dataAnchor' call
        var address = currentGroup + 1 | 0;
        tmp_0 = tmp0[imul(address, 5) + 4 | 0];
      }
      tmp.i3j_1 = tmp_0;
    }
  };
  protoOf(SlotReader).y3j = function () {
    if (this.g3j_1 <= 0) {
      var tmp0 = this.w3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
      var address = this.c3j_1;
      // Inline function 'androidx.compose.runtime.requirePrecondition' call
      if (!!((tmp0[imul(address, 5) + 1 | 0] & 1073741824) === 0)) {
        var tmp$ret$2 = 'Expected a node group';
        throwIllegalArgumentException(tmp$ret$2);
      }
      this.x3j();
    }
  };
  protoOf(SlotReader).y35 = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.g3j_1 === 0)) {
      var tmp$ret$1 = 'Cannot skip while in an empty region';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var tmp;
    var tmp0 = this.w3i_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    var address = this.c3j_1;
    if (!((tmp0[imul(address, 5) + 1 | 0] & 1073741824) === 0)) {
      tmp = 1;
    } else {
      var tmp0_0 = this.w3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
      var address_0 = this.c3j_1;
      tmp = tmp0_0[imul(address_0, 5) + 1 | 0] & 67108863;
    }
    var count = tmp;
    this.c3j_1 = this.c3j_1 + groupSize(this.w3i_1, this.c3j_1) | 0;
    return count;
  };
  protoOf(SlotReader).z30 = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.g3j_1 === 0)) {
      var tmp$ret$1 = 'Cannot skip the enclosing group while in an empty region';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.c3j_1 = this.d3j_1;
    this.h3j_1 = 0;
    this.i3j_1 = 0;
  };
  protoOf(SlotReader).y3k = function (index) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.g3j_1 === 0)) {
      var tmp$ret$1 = 'Cannot reposition while in an empty region';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.c3j_1 = index;
    var tmp;
    if (index < this.x3i_1) {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.parentAnchor' call
      tmp = this.w3i_1[imul(index, 5) + 2 | 0];
    } else {
      tmp = -1;
    }
    var parent = tmp;
    if (!(parent === this.e3j_1)) {
      this.e3j_1 = parent;
      if (parent < 0)
        this.d3j_1 = this.x3i_1;
      else
        this.d3j_1 = parent + groupSize(this.w3i_1, parent) | 0;
      this.h3j_1 = 0;
      this.i3j_1 = 0;
    }
  };
  protoOf(SlotReader).z3l = function (index) {
    var newCurrentEnd = index + groupSize(this.w3i_1, index) | 0;
    var current = this.c3j_1;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(current >= index && current <= newCurrentEnd)) {
      var tmp$ret$1 = 'Index ' + index + ' is not a parent of ' + current;
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.e3j_1 = index;
    this.d3j_1 = newCurrentEnd;
    this.h3j_1 = 0;
    this.i3j_1 = 0;
  };
  protoOf(SlotReader).o3l = function () {
    if (this.g3j_1 === 0) {
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(this.c3j_1 === this.d3j_1)) {
        var tmp$ret$1 = 'endGroup() not called at the end of a group';
        composeImmediateRuntimeError(tmp$ret$1);
      }
      var tmp0 = this.w3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.parentAnchor' call
      var address = this.e3j_1;
      var parent = tmp0[imul(address, 5) + 2 | 0];
      this.e3j_1 = parent;
      this.d3j_1 = parent < 0 ? this.x3i_1 : parent + groupSize(this.w3i_1, parent) | 0;
      var currentSlotStack = this.f3j_1;
      var newCurrentSlot = currentSlotStack.k3j();
      if (newCurrentSlot < 0) {
        this.h3j_1 = 0;
        this.i3j_1 = 0;
      } else {
        this.h3j_1 = newCurrentSlot;
        var tmp = this;
        var tmp_0;
        if (parent >= (this.x3i_1 - 1 | 0)) {
          tmp_0 = this.z3i_1;
        } else {
          var tmp0_0 = this.w3i_1;
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.dataAnchor' call
          var address_0 = parent + 1 | 0;
          tmp_0 = tmp0_0[imul(address_0, 5) + 4 | 0];
        }
        tmp.i3j_1 = tmp_0;
      }
    }
  };
  protoOf(SlotReader).l3k = function () {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    if (this.g3j_1 > 0)
      return result;
    var index = 0;
    var childIndex = this.c3j_1;
    while (childIndex < this.d3j_1) {
      var tmp0 = this.w3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.key' call
      var address = childIndex;
      var tmp = tmp0[imul(address, 5)];
      var tmp_0 = objectKey(this, this.w3i_1, childIndex);
      var tmp_1 = childIndex;
      var tmp_2;
      var tmp0_0 = this.w3i_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
      var address_0 = childIndex;
      if (!((tmp0_0[imul(address_0, 5) + 1 | 0] & 1073741824) === 0)) {
        tmp_2 = 1;
      } else {
        var tmp0_1 = this.w3i_1;
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
        var address_1 = childIndex;
        tmp_2 = tmp0_1[imul(address_1, 5) + 1 | 0] & 67108863;
      }
      var tmp_3 = tmp_2;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      result.j1(new KeyInfo(tmp, tmp_0, tmp_1, tmp_3, _unary__edvuaz));
      childIndex = childIndex + groupSize(this.w3i_1, childIndex) | 0;
    }
    return result;
  };
  protoOf(SlotReader).toString = function () {
    return 'SlotReader(current=' + this.c3j_1 + ', key=' + this.k3k() + ', parent=' + this.e3j_1 + ', end=' + this.d3j_1 + ')';
  };
  protoOf(SlotReader).o3k = function (index) {
    var tmp0 = this.v3i_1.q34_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.getOrAdd' call
    var effectiveSize = this.x3i_1;
    var location = search(tmp0, index, effectiveSize);
    var tmp;
    if (location < 0) {
      var anchor = new GapAnchor(index);
      tmp0.g3(-(location + 1 | 0) | 0, anchor);
      tmp = anchor;
    } else {
      tmp = tmp0.l1(location);
    }
    return tmp;
  };
  function moveGroup($this, fromWriter, fromIndex, toWriter, updateFromCursor, updateToCursor, removeSourceGroup) {
    removeSourceGroup = removeSourceGroup === VOID ? true : removeSourceGroup;
    var groupsToMove = fromWriter.a35(fromIndex);
    var sourceGroupsEnd = fromIndex + groupsToMove | 0;
    var sourceSlotsStart = dataIndex(fromWriter, fromIndex);
    var sourceSlotsEnd = dataIndex(fromWriter, sourceGroupsEnd);
    var slotsToMove = sourceSlotsEnd - sourceSlotsStart | 0;
    var hasMarks = containsAnyGroupMarks(fromWriter, fromIndex);
    insertGroups(toWriter, groupsToMove);
    insertSlots(toWriter, slotsToMove, toWriter.b34_1);
    if (fromWriter.o33_1 < sourceGroupsEnd) {
      moveGroupGapTo(fromWriter, sourceGroupsEnd);
    }
    if (fromWriter.s33_1 < sourceSlotsEnd) {
      moveSlotGapTo(fromWriter, sourceSlotsEnd, sourceGroupsEnd);
    }
    var groups = toWriter.j33_1;
    var currentGroup = toWriter.b34_1;
    var tmp0 = fromWriter.j33_1;
    var tmp4 = imul(currentGroup, 5);
    var tmp6 = imul(fromIndex, 5);
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = imul(sourceGroupsEnd, 5);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, groups, tmp4, tmp6, endIndex);
    var slots = toWriter.k33_1;
    var currentSlot = toWriter.q33_1;
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = fromWriter.k33_1;
    arrayCopy(this_0, slots, currentSlot, sourceSlotsStart, sourceSlotsEnd);
    var parent = toWriter.d34_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateParentAnchor' call
    groups[imul(currentGroup, 5) + 2 | 0] = parent;
    var parentDelta = currentGroup - fromIndex | 0;
    var moveEnd = currentGroup + groupsToMove | 0;
    // Inline function 'kotlin.with' call
    var dataIndexDelta = currentSlot - dataIndex_0(toWriter, groups, currentGroup) | 0;
    var slotsGapOwner = toWriter.u33_1;
    var slotsGapLen = toWriter.t33_1;
    var slotsCapacity = slots.length;
    var inductionVariable = currentGroup;
    if (inductionVariable < moveEnd)
      do {
        var groupAddress = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(groupAddress === currentGroup)) {
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.parentAnchor' call
          var previousParent = groups[imul(groupAddress, 5) + 2 | 0];
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateParentAnchor' call
          var value = previousParent + parentDelta | 0;
          groups[imul(groupAddress, 5) + 2 | 0] = value;
        }
        // Inline function 'kotlin.with' call
        var newDataIndex = dataIndex_0(toWriter, groups, groupAddress) + dataIndexDelta | 0;
        // Inline function 'kotlin.with' call
        var newDataAnchor = dataIndexToDataAnchor(toWriter, newDataIndex, slotsGapOwner < groupAddress ? 0 : toWriter.s33_1, slotsGapLen, slotsCapacity);
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateDataAnchor' call
        groups[imul(groupAddress, 5) + 4 | 0] = newDataAnchor;
        if (groupAddress === slotsGapOwner) {
          slotsGapOwner = slotsGapOwner + 1 | 0;
        }
      }
       while (inductionVariable < moveEnd);
    toWriter.u33_1 = slotsGapOwner;
    var startAnchors = locationOf(fromWriter.l33_1, fromIndex, fromWriter.f4c());
    var endAnchors = locationOf(fromWriter.l33_1, sourceGroupsEnd, fromWriter.f4c());
    var tmp_0;
    if (startAnchors < endAnchors) {
      var sourceAnchors = fromWriter.l33_1;
      var anchors = ArrayList_init_$Create$_0(endAnchors - startAnchors | 0);
      var anchorDelta = currentGroup - fromIndex | 0;
      var inductionVariable_0 = startAnchors;
      if (inductionVariable_0 < endAnchors)
        do {
          var anchorIndex = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var sourceAnchor = sourceAnchors.l1(anchorIndex);
          sourceAnchor.l3o_1 = sourceAnchor.l3o_1 + anchorDelta | 0;
          anchors.j1(sourceAnchor);
        }
         while (inductionVariable_0 < endAnchors);
      var insertLocation = locationOf(toWriter.l33_1, toWriter.b34_1, toWriter.f4c());
      toWriter.l33_1.e3(insertLocation, anchors);
      sourceAnchors.t2(startAnchors, endAnchors).c3();
      tmp_0 = anchors;
    } else {
      tmp_0 = emptyList();
    }
    var anchors_0 = tmp_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!anchors_0.r()) {
      var sourceSourceInformationMap = fromWriter.m33_1;
      var destinationSourceInformation = toWriter.m33_1;
      if (!(sourceSourceInformationMap == null) && !(destinationSourceInformation == null)) {
        // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
        var inductionVariable_1 = 0;
        var last = anchors_0.n1() - 1 | 0;
        if (inductionVariable_1 <= last)
          do {
            var index = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var item = anchors_0.l1(index);
            var information = sourceSourceInformationMap.w2(item);
            if (!(information == null)) {
              sourceSourceInformationMap.a3(item);
              // Inline function 'kotlin.collections.set' call
              destinationSourceInformation.z2(item, information);
            }
          }
           while (inductionVariable_1 <= last);
      }
    }
    var toWriterParent = toWriter.d34_1;
    var tmp0_safe_receiver = toWriter.g4c(parent);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var predecessor = -1;
      var child = toWriterParent + 1 | 0;
      var endGroup = toWriter.b34_1;
      while (child < endGroup) {
        predecessor = child;
        child = child + groupSize(toWriter.j33_1, child) | 0;
      }
      tmp0_safe_receiver.h4c(toWriter, predecessor, endGroup);
    }
    var parentGroup = fromWriter.y34(fromIndex);
    var tmp_1;
    if (!removeSourceGroup) {
      tmp_1 = false;
    } else if (updateFromCursor) {
      var needsStartGroups = parentGroup >= 0;
      if (needsStartGroups) {
        fromWriter.x3j();
        fromWriter.u4b(parentGroup - fromWriter.b34_1 | 0);
        fromWriter.x3j();
      }
      fromWriter.u4b(fromIndex - fromWriter.b34_1 | 0);
      var anchorsRemoved = fromWriter.h34();
      if (needsStartGroups) {
        fromWriter.z30();
        fromWriter.z35();
        fromWriter.z30();
        fromWriter.z35();
      }
      tmp_1 = anchorsRemoved;
    } else {
      var anchorsRemoved_0 = removeGroups(fromWriter, fromIndex, groupsToMove);
      removeSlots(fromWriter, sourceSlotsStart, slotsToMove, fromIndex - 1 | 0);
      tmp_1 = anchorsRemoved_0;
    }
    var anchorsRemoved_1 = tmp_1;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!anchorsRemoved_1) {
      var tmp$ret$24 = 'Unexpectedly removed anchors';
      composeImmediateRuntimeError(tmp$ret$24);
    }
    var tmp_2 = toWriter;
    var tmp_3 = toWriter.w33_1;
    var tmp_4;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    if (!((groups[imul(currentGroup, 5) + 1 | 0] & 1073741824) === 0)) {
      tmp_4 = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
      tmp_4 = groups[imul(currentGroup, 5) + 1 | 0] & 67108863;
    }
    tmp_2.w33_1 = tmp_3 + tmp_4 | 0;
    if (updateToCursor) {
      toWriter.b34_1 = currentGroup + groupsToMove | 0;
      toWriter.q33_1 = currentSlot + slotsToMove | 0;
    }
    if (hasMarks) {
      updateContainsMark(toWriter, parent);
    }
    return anchors_0;
  }
  function rawUpdate($this, value) {
    var result = $this.i4c();
    $this.j4c(value);
    return result;
  }
  function groupSourceInformationFor($this, parent, sourceInformation) {
    var tmp0_safe_receiver = $this.m33_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.getOrPut' call
      var key = $this.o3k(parent);
      var value = tmp0_safe_receiver.w2(key);
      var tmp_0;
      if (value == null) {
        var result = new GapGroupSourceInformation(0, sourceInformation, 0);
        if (sourceInformation == null) {
          var child = parent + 1 | 0;
          var end = $this.b34_1;
          while (child < end) {
            result.k4c($this, child);
            child = child + groupSize($this.j33_1, child) | 0;
          }
        }
        var answer = result;
        tmp0_safe_receiver.z2(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function _get_currentGroupSlotIndex__p1glxf($this) {
    return $this.l4c($this.d34_1);
  }
  function startGroup_2($this, key, objectKey, isNode, aux) {
    var previousParent = $this.d34_1;
    var inserting = $this.v33_1 > 0;
    $this.z33_1.g3i($this.w33_1);
    var tmp = $this;
    var tmp_0;
    if (inserting) {
      var current = $this.b34_1;
      var newCurrentSlot = dataIndex_0($this, $this.j33_1, groupIndexToAddress($this, current));
      insertGroups($this, 1);
      $this.q33_1 = newCurrentSlot;
      $this.r33_1 = newCurrentSlot;
      var currentAddress = groupIndexToAddress($this, current);
      var hasObjectKey = !(objectKey === Companion_getInstance_0().f30_1);
      var hasAux = !isNode && !(aux === Companion_getInstance_0().f30_1);
      var tmp0_gapLen = $this.t33_1;
      var tmp1_gapStart = $this.s33_1;
      var tmp2_capacity = $this.k33_1.length;
      // Inline function 'kotlin.let' call
      var anchor = dataIndexToDataAnchor($this, newCurrentSlot, tmp1_gapStart, tmp0_gapLen, tmp2_capacity);
      var tmp_1;
      if (anchor >= 0 && $this.u33_1 < current) {
        var slotsSize = $this.k33_1.length - $this.t33_1 | 0;
        tmp_1 = -((slotsSize - anchor | 0) + 1 | 0) | 0;
      } else {
        tmp_1 = anchor;
      }
      var dataAnchor = tmp_1;
      initGroup($this.j33_1, currentAddress, key, isNode, hasObjectKey, hasAux, $this.d34_1, dataAnchor);
      var dataSlotsNeeded = ((isNode ? 1 : 0) + (hasObjectKey ? 1 : 0) | 0) + (hasAux ? 1 : 0) | 0;
      if (dataSlotsNeeded > 0) {
        insertSlots($this, dataSlotsNeeded, current);
        var slots = $this.k33_1;
        var currentSlot = $this.q33_1;
        if (isNode) {
          var _unary__edvuaz = currentSlot;
          currentSlot = _unary__edvuaz + 1 | 0;
          slots[_unary__edvuaz] = aux;
        }
        if (hasObjectKey) {
          var _unary__edvuaz_0 = currentSlot;
          currentSlot = _unary__edvuaz_0 + 1 | 0;
          slots[_unary__edvuaz_0] = objectKey;
        }
        if (hasAux) {
          var _unary__edvuaz_1 = currentSlot;
          currentSlot = _unary__edvuaz_1 + 1 | 0;
          slots[_unary__edvuaz_1] = aux;
        }
        $this.q33_1 = currentSlot;
      }
      $this.w33_1 = 0;
      var newCurrent = current + 1 | 0;
      $this.d34_1 = current;
      $this.b34_1 = newCurrent;
      if (previousParent >= 0) {
        var tmp3_safe_receiver = $this.g4c(previousParent);
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.k4c($this, current);
        }
      }
      tmp_0 = newCurrent;
    } else {
      $this.x33_1.g3i(previousParent);
      saveCurrentGroupEnd($this);
      var currentGroup = $this.b34_1;
      var currentGroupAddress = groupIndexToAddress($this, currentGroup);
      if (!equals(aux, Companion_getInstance_0().f30_1)) {
        if (isNode) {
          $this.n4c(aux);
        } else {
          $this.m4c(aux);
        }
      }
      $this.q33_1 = slotIndex($this, $this.j33_1, currentGroupAddress);
      $this.r33_1 = dataIndex_0($this, $this.j33_1, groupIndexToAddress($this, $this.b34_1 + 1 | 0));
      var tmp_2 = $this;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
      tmp_2.w33_1 = $this.j33_1[imul(currentGroupAddress, 5) + 1 | 0] & 67108863;
      $this.d34_1 = currentGroup;
      $this.b34_1 = currentGroup + 1 | 0;
      tmp_0 = currentGroup + groupSize($this.j33_1, currentGroupAddress) | 0;
    }
    tmp.c34_1 = tmp_0;
  }
  function childGroupAtIndex($this, parent, index) {
    var end = parent + $this.a35(parent) | 0;
    var childGroup = parent + 1 | 0;
    var current = 0;
    while (childGroup < end && current < index) {
      var childAddress = groupIndexToAddress($this, childGroup);
      childGroup = childGroup + groupSize($this.j33_1, childAddress) | 0;
      var tmp;
      if (childGroup < end) {
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasObjectKey' call
        tmp = !!(($this.j33_1[imul(childAddress, 5) + 1 | 0] & 536870912) === 0);
      } else {
        tmp = false;
      }
      if (tmp) {
        current = current + 1 | 0;
      }
    }
    return childGroup;
  }
  function Companion_8() {
  }
  var Companion_instance_9;
  function Companion_getInstance_8() {
    return Companion_instance_9;
  }
  function containsGroupMark($this, group) {
    var tmp;
    if (group >= 0) {
      var tmp0 = $this.j33_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.containsMark' call
      var address = groupIndexToAddress($this, group);
      tmp = !((tmp0[imul(address, 5) + 1 | 0] & 67108864) === 0);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function containsAnyGroupMarks($this, group) {
    var tmp;
    if (group >= 0) {
      var tmp0 = $this.j33_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.containsAnyMark' call
      var address = groupIndexToAddress($this, group);
      tmp = !((tmp0[imul(address, 5) + 1 | 0] & 201326592) === 0);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function recalculateMarks($this) {
    var tmp0_safe_receiver = $this.f34_1;
    var tmp = tmp0_safe_receiver;
    if ((tmp == null ? null : new PrioritySet(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      var set = (tmp_0 == null ? null : new PrioritySet(tmp_0)).o4c_1;
      while (PrioritySet__isNotEmpty_impl_q82m5n(set)) {
        updateContainsMarkNow($this, PrioritySet__takeMax_impl_e5irrm(set), set);
      }
    }
  }
  function updateContainsMark($this, group) {
    if (group >= 0) {
      var tmp0_elvis_lhs = $this.f34_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new PrioritySet(tmp_0)) == null) {
        // Inline function 'kotlin.also' call
        var this_0 = new PrioritySet(_PrioritySet___init__impl__yrk5ut());
        $this.f34_1 = this_0.o4c_1;
        tmp = this_0.o4c_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      PrioritySet__add_impl_enzb2u(tmp, group);
    }
  }
  function updateContainsMarkNow($this, group, set) {
    var groupAddress = groupIndexToAddress($this, group);
    var containsAnyMarks = childContainsAnyMarks($this, group);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.containsMark' call
    var markChanges = !(!(($this.j33_1[imul(groupAddress, 5) + 1 | 0] & 67108864) === 0) === containsAnyMarks);
    if (markChanges) {
      updateContainsMark_0($this.j33_1, groupAddress, containsAnyMarks);
      var parent = $this.y34(group);
      if (parent >= 0) {
        PrioritySet__add_impl_enzb2u(set, parent);
      }
    }
  }
  function childContainsAnyMarks($this, group) {
    var child = group + 1 | 0;
    var end = group + $this.a35(group) | 0;
    while (child < end) {
      var tmp0 = $this.j33_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.containsAnyMark' call
      var address = groupIndexToAddress($this, child);
      if (!((tmp0[imul(address, 5) + 1 | 0] & 201326592) === 0))
        return true;
      child = child + $this.a35(child) | 0;
    }
    return false;
  }
  function saveCurrentGroupEnd($this) {
    $this.y33_1.g3i((_get_capacity__a9k9f3($this) - $this.p33_1 | 0) - $this.c34_1 | 0);
  }
  function restoreCurrentGroupEnd($this) {
    var newGroupEnd = (_get_capacity__a9k9f3($this) - $this.p33_1 | 0) - $this.y33_1.k3j() | 0;
    $this.c34_1 = newGroupEnd;
    return newGroupEnd;
  }
  function fixParentAnchorsFor($this, parent, endGroup, firstChild) {
    var parentAnchor = parentIndexToAnchor($this, parent, $this.o33_1);
    var child = firstChild;
    while (child < endGroup) {
      var tmp0 = $this.j33_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateParentAnchor' call
      var address = groupIndexToAddress($this, child);
      tmp0[imul(address, 5) + 2 | 0] = parentAnchor;
      var childEnd = child + groupSize($this.j33_1, groupIndexToAddress($this, child)) | 0;
      fixParentAnchorsFor($this, child, childEnd, child + 1 | 0);
      child = childEnd;
    }
  }
  function moveGroupGapTo($this, index) {
    var gapLen = $this.p33_1;
    var gapStart = $this.o33_1;
    if (!(gapStart === index)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this.l33_1.r()) {
        updateAnchors($this, gapStart, index);
      }
      if (gapLen > 0) {
        var groups = $this.j33_1;
        var groupPhysicalAddress = imul(index, 5);
        var groupPhysicalGapLen = imul(gapLen, 5);
        var groupPhysicalGapStart = imul(gapStart, 5);
        if (index < gapStart) {
          // Inline function 'kotlin.collections.copyInto' call
          var destinationOffset = groupPhysicalAddress + groupPhysicalGapLen | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = groups;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, groups, destinationOffset, groupPhysicalAddress, groupPhysicalGapStart);
        } else {
          var tmp6 = groupPhysicalGapStart + groupPhysicalGapLen | 0;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = groupPhysicalAddress + groupPhysicalGapLen | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_0 = groups;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp_0, groups, groupPhysicalGapStart, tmp6, endIndex);
        }
      }
      var groupAddress = index < gapStart ? index + gapLen | 0 : gapStart;
      var capacity = _get_capacity__a9k9f3($this);
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(groupAddress < capacity)) {
        var tmp$ret$13 = 'Check failed';
        composeImmediateRuntimeError(tmp$ret$13);
      }
      while (groupAddress < capacity) {
        var tmp0 = $this.j33_1;
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.parentAnchor' call
        var address = groupAddress;
        var oldAnchor = tmp0[imul(address, 5) + 2 | 0];
        var oldIndex = parentAnchorToIndex($this, oldAnchor);
        var newAnchor = parentIndexToAnchor($this, oldIndex, index);
        if (!(newAnchor === oldAnchor)) {
          var tmp0_0 = $this.j33_1;
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateParentAnchor' call
          var address_0 = groupAddress;
          tmp0_0[imul(address_0, 5) + 2 | 0] = newAnchor;
        }
        groupAddress = groupAddress + 1 | 0;
        if (groupAddress === index)
          groupAddress = groupAddress + gapLen | 0;
      }
    }
    $this.o33_1 = index;
  }
  function moveSlotGapTo($this, index, group) {
    var gapLen = $this.t33_1;
    var gapStart = $this.s33_1;
    var slotsGapOwner = $this.u33_1;
    if (!(gapStart === index)) {
      var slots = $this.k33_1;
      if (index < gapStart) {
        // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = index + gapLen | 0;
        arrayCopy(slots, slots, destinationOffset, index, gapStart);
      } else {
        var tmp6 = gapStart + gapLen | 0;
        // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = index + gapLen | 0;
        arrayCopy(slots, slots, gapStart, tmp6, endIndex);
      }
    }
    var tmp0 = group + 1 | 0;
    // Inline function 'kotlin.math.min' call
    var b = $this.f4c();
    var newSlotsGapOwner = Math.min(tmp0, b);
    if (!(slotsGapOwner === newSlotsGapOwner)) {
      var slotsSize = $this.k33_1.length - gapLen | 0;
      if (newSlotsGapOwner < slotsGapOwner) {
        var updateAddress = groupIndexToAddress($this, newSlotsGapOwner);
        var stopUpdateAddress = groupIndexToAddress($this, slotsGapOwner);
        var groupGapStart = $this.o33_1;
        while (updateAddress < stopUpdateAddress) {
          var tmp0_0 = $this.j33_1;
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.dataAnchor' call
          var address = updateAddress;
          var anchor = tmp0_0[imul(address, 5) + 4 | 0];
          // Inline function 'androidx.compose.runtime.runtimeCheck' call
          if (!(anchor >= 0)) {
            var tmp$ret$7 = 'Unexpected anchor value, expected a positive anchor';
            composeImmediateRuntimeError(tmp$ret$7);
          }
          var tmp0_1 = $this.j33_1;
          var tmp2 = updateAddress;
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateDataAnchor' call
          var anchor_0 = -((slotsSize - anchor | 0) + 1 | 0) | 0;
          tmp0_1[imul(tmp2, 5) + 4 | 0] = anchor_0;
          updateAddress = updateAddress + 1 | 0;
          if (updateAddress === groupGapStart)
            updateAddress = updateAddress + $this.p33_1 | 0;
        }
      } else {
        var updateAddress_0 = groupIndexToAddress($this, slotsGapOwner);
        var stopUpdateAddress_0 = groupIndexToAddress($this, newSlotsGapOwner);
        while (updateAddress_0 < stopUpdateAddress_0) {
          var tmp0_2 = $this.j33_1;
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.dataAnchor' call
          var address_0 = updateAddress_0;
          var anchor_1 = tmp0_2[imul(address_0, 5) + 4 | 0];
          // Inline function 'androidx.compose.runtime.runtimeCheck' call
          if (!(anchor_1 < 0)) {
            var tmp$ret$11 = 'Unexpected anchor value, expected a negative anchor';
            composeImmediateRuntimeError(tmp$ret$11);
          }
          var tmp0_3 = $this.j33_1;
          var tmp2_0 = updateAddress_0;
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateDataAnchor' call
          var anchor_2 = (slotsSize + anchor_1 | 0) + 1 | 0;
          tmp0_3[imul(tmp2_0, 5) + 4 | 0] = anchor_2;
          updateAddress_0 = updateAddress_0 + 1 | 0;
          if (updateAddress_0 === $this.o33_1)
            updateAddress_0 = updateAddress_0 + $this.p33_1 | 0;
        }
      }
      $this.u33_1 = newSlotsGapOwner;
    }
    $this.s33_1 = index;
  }
  function clearSlotGap($this) {
    var slotsGapStart = $this.s33_1;
    var slotsGapEnd = slotsGapStart + $this.t33_1 | 0;
    fill_0($this.k33_1, null, slotsGapStart, slotsGapEnd);
  }
  function insertGroups($this, size) {
    if (size > 0) {
      var currentGroup = $this.b34_1;
      moveGroupGapTo($this, currentGroup);
      var gapStart = $this.o33_1;
      var gapLen = $this.p33_1;
      var oldCapacity = $this.j33_1.length / 5 | 0;
      var oldSize = oldCapacity - gapLen | 0;
      if (gapLen < size) {
        var groups = $this.j33_1;
        var tmp0 = imul(oldCapacity, 2);
        // Inline function 'kotlin.math.max' call
        var b = oldSize + size | 0;
        // Inline function 'kotlin.math.max' call
        var a = Math.max(tmp0, b);
        var newCapacity = Math.max(a, 32);
        var newGroups = new Int32Array(imul(newCapacity, 5));
        var newGapLen = newCapacity - oldSize | 0;
        var oldGapEndAddress = gapStart + gapLen | 0;
        var newGapEndAddress = gapStart + newGapLen | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = imul(gapStart, 5);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = groups;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, newGroups, 0, 0, endIndex);
        var tmp4 = imul(newGapEndAddress, 5);
        var tmp6 = imul(oldGapEndAddress, 5);
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = imul(oldCapacity, 5);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = groups;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, newGroups, tmp4, tmp6, endIndex_0);
        $this.j33_1 = newGroups;
        gapLen = newGapLen;
      }
      var currentEnd = $this.c34_1;
      if (currentEnd >= gapStart)
        $this.c34_1 = currentEnd + size | 0;
      $this.o33_1 = gapStart + size | 0;
      $this.p33_1 = gapLen - size | 0;
      var index = oldSize > 0 ? dataIndex($this, currentGroup + size | 0) : 0;
      var anchor = dataIndexToDataAnchor($this, index, $this.u33_1 < gapStart ? 0 : $this.s33_1, $this.t33_1, $this.k33_1.length);
      var inductionVariable = gapStart;
      var last = gapStart + size | 0;
      if (inductionVariable < last)
        do {
          var groupAddress = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateDataAnchor' call
          $this.j33_1[imul(groupAddress, 5) + 4 | 0] = anchor;
        }
         while (inductionVariable < last);
      var slotsGapOwner = $this.u33_1;
      if (slotsGapOwner >= gapStart) {
        $this.u33_1 = slotsGapOwner + size | 0;
      }
    }
  }
  function insertSlots($this, size, group) {
    if (size > 0) {
      moveSlotGapTo($this, $this.q33_1, group);
      var gapStart = $this.s33_1;
      var gapLen = $this.t33_1;
      if (gapLen < size) {
        var slots = $this.k33_1;
        var oldCapacity = slots.length;
        var oldSize = oldCapacity - gapLen | 0;
        var tmp0 = imul(oldCapacity, 2);
        // Inline function 'kotlin.math.max' call
        var b = oldSize + size | 0;
        // Inline function 'kotlin.math.max' call
        var a = Math.max(tmp0, b);
        var newCapacity = Math.max(a, 32);
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = Array(newCapacity);
        while (tmp < newCapacity) {
          tmp_0[tmp] = null;
          tmp = tmp + 1 | 0;
        }
        var newData = tmp_0;
        var newGapLen = newCapacity - oldSize | 0;
        var oldGapEndAddress = gapStart + gapLen | 0;
        var newGapEndAddress = gapStart + newGapLen | 0;
        // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
        // Inline function 'kotlin.collections.copyInto' call
        arrayCopy(slots, newData, 0, 0, gapStart);
        // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
        // Inline function 'kotlin.collections.copyInto' call
        arrayCopy(slots, newData, newGapEndAddress, oldGapEndAddress, oldCapacity);
        $this.k33_1 = newData;
        gapLen = newGapLen;
      }
      var currentDataEnd = $this.r33_1;
      if (currentDataEnd >= gapStart)
        $this.r33_1 = currentDataEnd + size | 0;
      $this.s33_1 = gapStart + size | 0;
      $this.t33_1 = gapLen - size | 0;
    }
  }
  function removeGroups($this, start, len) {
    var tmp;
    if (len > 0) {
      var anchorsRemoved = false;
      var anchors = $this.l33_1;
      moveGroupGapTo($this, start);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!anchors.r()) {
        anchorsRemoved = removeAnchors($this, start, len, $this.m33_1);
      }
      $this.o33_1 = start;
      var previousGapLen = $this.p33_1;
      var newGapLen = previousGapLen + len | 0;
      $this.p33_1 = newGapLen;
      var slotsGapOwner = $this.u33_1;
      if (slotsGapOwner > start) {
        var tmp_0 = $this;
        // Inline function 'kotlin.math.max' call
        var b = slotsGapOwner - len | 0;
        tmp_0.u33_1 = Math.max(start, b);
      }
      if ($this.c34_1 >= $this.o33_1)
        $this.c34_1 = $this.c34_1 - len | 0;
      var parent = $this.d34_1;
      if (containsGroupMark($this, parent)) {
        updateContainsMark($this, parent);
      }
      tmp = anchorsRemoved;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function removeSlots($this, start, len, group) {
    if (len > 0) {
      var gapLen = $this.t33_1;
      var removeEnd = start + len | 0;
      moveSlotGapTo($this, removeEnd, group);
      $this.s33_1 = start;
      $this.t33_1 = gapLen + len | 0;
      fill_0($this.k33_1, null, start, start + len | 0);
      var currentDataEnd = $this.r33_1;
      if (currentDataEnd >= start)
        $this.r33_1 = currentDataEnd - len | 0;
    }
  }
  function updateNodeOfGroup($this, index, value) {
    var address = groupIndexToAddress($this, index);
    var tmp;
    if (address < $this.j33_1.length) {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
      tmp = !(($this.j33_1[imul(address, 5) + 1 | 0] & 1073741824) === 0);
    } else {
      tmp = false;
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!tmp) {
      var tmp$ret$2 = 'Updating the node of a group at ' + index + ' that was not created with as a node group';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    $this.k33_1[dataIndexToDataAddress($this, nodeIndex($this, $this.j33_1, address))] = value;
  }
  function updateAnchors($this, previousGapStart, newGapStart) {
    var gapLen = $this.p33_1;
    var size = _get_capacity__a9k9f3($this) - gapLen | 0;
    if (previousGapStart < newGapStart) {
      var index = locationOf($this.l33_1, previousGapStart, size);
      $l$loop_0: while (index < $this.l33_1.n1()) {
        var anchor = $this.l33_1.l1(index);
        var location = anchor.l3o_1;
        if (location < 0) {
          var newLocation = size + location | 0;
          if (newLocation < newGapStart) {
            anchor.l3o_1 = size + location | 0;
            index = index + 1 | 0;
          } else
            break $l$loop_0;
        } else
          break $l$loop_0;
      }
    } else {
      var index_0 = locationOf($this.l33_1, newGapStart, size);
      $l$loop_1: while (index_0 < $this.l33_1.n1()) {
        var anchor_0 = $this.l33_1.l1(index_0);
        var location_0 = anchor_0.l3o_1;
        if (location_0 >= 0) {
          anchor_0.l3o_1 = -(size - location_0 | 0) | 0;
          index_0 = index_0 + 1 | 0;
        } else
          break $l$loop_1;
      }
    }
  }
  function removeAnchors($this, gapStart, size, sourceInformationMap) {
    var gapLen = $this.p33_1;
    var removeEnd = gapStart + size | 0;
    var groupsSize = _get_capacity__a9k9f3($this) - gapLen | 0;
    // Inline function 'kotlin.let' call
    var it = locationOf($this.l33_1, gapStart + size | 0, groupsSize);
    var index = it >= $this.l33_1.n1() ? it - 1 | 0 : it;
    var removeAnchorEnd = 0;
    var removeAnchorStart = index + 1 | 0;
    $l$loop: while (index >= 0) {
      var anchor = $this.l33_1.l1(index);
      var location = $this.q3m(anchor);
      if (location >= gapStart) {
        if (location < removeEnd) {
          anchor.l3o_1 = -2147483648;
          if (sourceInformationMap == null)
            null;
          else
            sourceInformationMap.a3(anchor);
          removeAnchorStart = index;
          if (removeAnchorEnd === 0)
            removeAnchorEnd = index + 1 | 0;
        }
        index = index - 1 | 0;
      } else
        break $l$loop;
    }
    // Inline function 'kotlin.also' call
    var this_0 = removeAnchorStart < removeAnchorEnd;
    if (this_0) {
      $this.l33_1.t2(removeAnchorStart, removeAnchorEnd).c3();
    }
    return this_0;
  }
  function moveAnchors($this, originalLocation, newLocation, size) {
    var end = originalLocation + size | 0;
    var groupsSize = $this.f4c();
    var index = locationOf($this.l33_1, originalLocation, groupsSize);
    // Inline function 'kotlin.collections.mutableListOf' call
    var removedAnchors = ArrayList_init_$Create$();
    if (index >= 0) {
      $l$loop: while (index < $this.l33_1.n1()) {
        var anchor = $this.l33_1.l1(index);
        var location = $this.q3m(anchor);
        if (location >= originalLocation && location < end) {
          removedAnchors.j1(anchor);
          $this.l33_1.h3(index);
        } else
          break $l$loop;
      }
    }
    var moveDelta = newLocation - originalLocation | 0;
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var inductionVariable = 0;
    var last = removedAnchors.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = removedAnchors.l1(index_0);
        var anchorIndex = $this.q3m(item);
        var newAnchorIndex = anchorIndex + moveDelta | 0;
        if (newAnchorIndex >= $this.o33_1) {
          item.l3o_1 = -(groupsSize - newAnchorIndex | 0) | 0;
        } else {
          item.l3o_1 = newAnchorIndex;
        }
        var insertIndex = locationOf($this.l33_1, newAnchorIndex, groupsSize);
        $this.l33_1.g3(insertIndex, item);
      }
       while (inductionVariable <= last);
  }
  function _get_capacity__a9k9f3($this) {
    return $this.j33_1.length / 5 | 0;
  }
  function groupIndexToAddress($this, index) {
    return index + imul($this.p33_1, index < $this.o33_1 ? 0 : 1) | 0;
  }
  function dataIndexToDataAddress($this, dataIndex) {
    return dataIndex + imul($this.t33_1, dataIndex < $this.s33_1 ? 0 : 1) | 0;
  }
  function parent($this, $receiver, index) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.parentAnchor' call
    var address = groupIndexToAddress($this, index);
    var tmp$ret$0 = $receiver[imul(address, 5) + 2 | 0];
    return parentAnchorToIndex($this, tmp$ret$0);
  }
  function dataIndex($this, index) {
    return dataIndex_0($this, $this.j33_1, groupIndexToAddress($this, index));
  }
  function dataIndex_0($this, $receiver, address) {
    var tmp;
    if (address >= _get_capacity__a9k9f3($this)) {
      tmp = $this.k33_1.length - $this.t33_1 | 0;
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.dataAnchor' call
      var tmp$ret$0 = $receiver[imul(address, 5) + 4 | 0];
      tmp = dataAnchorToDataIndex($this, tmp$ret$0, $this.t33_1, $this.k33_1.length);
    }
    return tmp;
  }
  function slotIndex($this, $receiver, address) {
    return address >= _get_capacity__a9k9f3($this) ? $this.k33_1.length - $this.t33_1 | 0 : dataAnchorToDataIndex($this, slotAnchor($receiver, address), $this.t33_1, $this.k33_1.length);
  }
  function updateDataIndex($this, $receiver, address, dataIndex) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.updateDataAnchor' call
    var anchor = dataIndexToDataAnchor($this, dataIndex, $this.s33_1, $this.t33_1, $this.k33_1.length);
    $receiver[imul(address, 5) + 4 | 0] = anchor;
  }
  function nodeIndex($this, $receiver, address) {
    return dataIndex_0($this, $receiver, address);
  }
  function auxIndex($this, $receiver, address) {
    var tmp = dataIndex_0($this, $receiver, address);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.groupInfo' call
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.countOneBits' call
    var value = $receiver[imul(address, 5) + 1 | 0] >> 29;
    return tmp + countOneBits(value) | 0;
  }
  function dataIndexToDataAnchor($this, index, gapStart, gapLen, capacity) {
    return index > gapStart ? -(((capacity - gapLen | 0) - index | 0) + 1 | 0) | 0 : index;
  }
  function dataAnchorToDataIndex($this, anchor, gapLen, capacity) {
    return anchor < 0 ? ((capacity - gapLen | 0) + anchor | 0) + 1 | 0 : anchor;
  }
  function parentIndexToAnchor($this, index, gapStart) {
    return index < gapStart ? index : -(($this.f4c() - index | 0) - -2 | 0) | 0;
  }
  function parentAnchorToIndex($this, index) {
    return index > -2 ? index : ($this.f4c() + index | 0) - -2 | 0;
  }
  function access$_get_slots__7x4q9w($this) {
    return $this.k33_1;
  }
  function access$dataIndexToDataAddress($this, dataIndex) {
    return dataIndexToDataAddress($this, dataIndex);
  }
  function SlotWriter(table) {
    this.i33_1 = table;
    this.j33_1 = this.i33_1.i34_1;
    this.k33_1 = this.i33_1.k34_1;
    this.l33_1 = this.i33_1.q34_1;
    this.m33_1 = this.i33_1.r34_1;
    this.n33_1 = this.i33_1.s34_1;
    this.o33_1 = this.i33_1.j34_1;
    this.p33_1 = (this.j33_1.length / 5 | 0) - this.i33_1.j34_1 | 0;
    this.q33_1 = 0;
    this.r33_1 = 0;
    this.s33_1 = this.i33_1.l34_1;
    this.t33_1 = this.k33_1.length - this.i33_1.l34_1 | 0;
    this.u33_1 = this.i33_1.j34_1;
    this.v33_1 = 0;
    this.w33_1 = 0;
    this.x33_1 = new IntStack();
    this.y33_1 = new IntStack();
    this.z33_1 = new IntStack();
    this.a34_1 = null;
    this.b34_1 = 0;
    this.c34_1 = this.i33_1.j34_1;
    this.d34_1 = -1;
    this.e34_1 = false;
    this.f34_1 = null;
  }
  protoOf(SlotWriter).l3l = function () {
    return this.b34_1 === this.c34_1;
  };
  protoOf(SlotWriter).n3o = function () {
    var tmp;
    if (this.b34_1 < this.c34_1) {
      var tmp0 = this.j33_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
      var address = groupIndexToAddress(this, this.b34_1);
      tmp = !((tmp0[imul(address, 5) + 1 | 0] & 1073741824) === 0);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SlotWriter).u34 = function () {
    return !(this.m33_1 == null);
  };
  protoOf(SlotWriter).w34 = function () {
    return !(this.n33_1 == null);
  };
  protoOf(SlotWriter).x34 = function (index) {
    var tmp0 = this.j33_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    var address = groupIndexToAddress(this, index);
    return !((tmp0[imul(address, 5) + 1 | 0] & 1073741824) === 0);
  };
  protoOf(SlotWriter).b35 = function (index) {
    var tmp0 = this.j33_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
    var address = groupIndexToAddress(this, index);
    return tmp0[imul(address, 5) + 1 | 0] & 67108863;
  };
  protoOf(SlotWriter).t3j = function (index) {
    var tmp0 = this.j33_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.key' call
    var address = groupIndexToAddress(this, index);
    return tmp0[imul(address, 5)];
  };
  protoOf(SlotWriter).u3j = function (index) {
    var address = groupIndexToAddress(this, index);
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasObjectKey' call
    if (!((this.j33_1[imul(address, 5) + 1 | 0] & 536870912) === 0)) {
      tmp = this.k33_1[objectKeyIndex(this.j33_1, address)];
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SlotWriter).p4c = function (index) {
    return imul(groupIndexToAddress(this, index), 5) < this.j33_1.length;
  };
  protoOf(SlotWriter).b3m = function (index) {
    var address = groupIndexToAddress(this, index);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasObjectKey' call
    return !((this.j33_1[imul(address, 5) + 1 | 0] & 536870912) === 0);
  };
  protoOf(SlotWriter).a35 = function (index) {
    return groupSize(this.j33_1, groupIndexToAddress(this, index));
  };
  protoOf(SlotWriter).s3j = function (index) {
    var address = groupIndexToAddress(this, index);
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasAux' call
    if (!((this.j33_1[imul(address, 5) + 1 | 0] & 268435456) === 0)) {
      tmp = this.k33_1[auxIndex(this, this.j33_1, address)];
    } else {
      tmp = Companion_getInstance_0().f30_1;
    }
    return tmp;
  };
  protoOf(SlotWriter).q4c = function (index) {
    return index > this.d34_1 && index < this.c34_1 || (this.d34_1 === 0 && index === 0);
  };
  protoOf(SlotWriter).r4c = function (index) {
    return this.s4c(index, this.b34_1);
  };
  protoOf(SlotWriter).s4c = function (index, group) {
    var tmp;
    if (group === this.d34_1) {
      tmp = this.c34_1;
    } else if (group > this.x33_1.z49(0)) {
      tmp = group + this.a35(group) | 0;
    } else {
      var openIndex = this.x33_1.b4a(group);
      tmp = openIndex < 0 ? group + this.a35(group) | 0 : (_get_capacity__a9k9f3(this) - this.p33_1 | 0) - this.y33_1.a4a(openIndex) | 0;
    }
    var end = tmp;
    return index > group && index < end;
  };
  protoOf(SlotWriter).z34 = function (index) {
    var address = groupIndexToAddress(this, index);
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    if (!((this.j33_1[imul(address, 5) + 1 | 0] & 1073741824) === 0)) {
      tmp = this.k33_1[dataIndexToDataAddress(this, nodeIndex(this, this.j33_1, address))];
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SlotWriter).t4c = function (anchor) {
    return this.z34(anchor.p4b(this));
  };
  protoOf(SlotWriter).y34 = function (index) {
    return parent(this, this.j33_1, index);
  };
  protoOf(SlotWriter).b36 = function (normalClose) {
    this.e34_1 = true;
    var tmp;
    if (normalClose) {
      // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
      tmp = this.x33_1.f3i_1 === 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      moveGroupGapTo(this, this.f4c());
      moveSlotGapTo(this, this.k33_1.length - this.t33_1 | 0, this.o33_1);
      clearSlotGap(this);
      recalculateMarks(this);
    }
    this.i33_1.r4b(this, this.j33_1, this.o33_1, this.k33_1, this.s33_1, this.l33_1, this.m33_1, this.n33_1);
  };
  protoOf(SlotWriter).u4c = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 === 0)) {
      var tmp$ret$1 = 'Cannot reset when inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    recalculateMarks(this);
    this.b34_1 = 0;
    this.c34_1 = _get_capacity__a9k9f3(this) - this.p33_1 | 0;
    this.q33_1 = 0;
    this.r33_1 = 0;
    this.w33_1 = 0;
  };
  protoOf(SlotWriter).w35 = function (value) {
    if (this.v33_1 > 0 && !(this.q33_1 === this.s33_1)) {
      var tmp0_elvis_lhs = this.a34_1;
      // Inline function 'kotlin.also' call
      var this_0 = tmp0_elvis_lhs == null ? new MutableIntObjectMap() : tmp0_elvis_lhs;
      this.a34_1 = this_0;
      // Inline function 'androidx.collection.MutableIntObjectMap.getOrPut' call
      var key = this.d34_1;
      var tmp0_elvis_lhs_0 = this_0.l1(key);
      var tmp;
      if (tmp0_elvis_lhs_0 == null) {
        // Inline function 'kotlin.also' call
        var this_1 = new MutableObjectList();
        this_0.ew(key, this_1);
        tmp = this_1;
      } else {
        tmp = tmp0_elvis_lhs_0;
      }
      var deferred = tmp;
      deferred.j1(value);
      return Companion_getInstance_0().f30_1;
    }
    return rawUpdate(this, value);
  };
  protoOf(SlotWriter).v4c = function (anchor, value) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 === 0)) {
      var tmp$ret$1 = 'Can only append a slot if not current inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var previousCurrentSlot = this.q33_1;
    var previousCurrentSlotEnd = this.r33_1;
    var anchorIndex = this.q3m(anchor);
    var slotIndex = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, anchorIndex + 1 | 0));
    this.q33_1 = slotIndex;
    this.r33_1 = slotIndex;
    insertSlots(this, 1, anchorIndex);
    if (previousCurrentSlot >= slotIndex) {
      previousCurrentSlot = previousCurrentSlot + 1 | 0;
      previousCurrentSlotEnd = previousCurrentSlotEnd + 1 | 0;
    }
    this.k33_1[slotIndex] = value;
    this.q33_1 = previousCurrentSlot;
    this.r33_1 = previousCurrentSlotEnd;
  };
  protoOf(SlotWriter).w4c = function (count) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(count > 0)) {
      var tmp$ret$2 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    var parent = this.d34_1;
    var groupSlotStart = slotIndex(this, this.j33_1, groupIndexToAddress(this, parent));
    var groupSlotEnd = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, parent + 1 | 0));
    var removeStart = groupSlotEnd - count | 0;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(removeStart >= groupSlotStart)) {
      var tmp$ret$5 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$5);
    }
    removeSlots(this, removeStart, count, parent);
    var currentSlot = this.q33_1;
    if (currentSlot >= groupSlotStart) {
      this.q33_1 = currentSlot - count | 0;
    }
  };
  protoOf(SlotWriter).m4c = function (value) {
    var address = groupIndexToAddress(this, this.b34_1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasAux' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!((this.j33_1[imul(address, 5) + 1 | 0] & 268435456) === 0)) {
      var tmp$ret$2 = 'Updating the data of a group that was not created with a data slot';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    this.k33_1[dataIndexToDataAddress(this, auxIndex(this, this.j33_1, address))] = value;
  };
  protoOf(SlotWriter).y3o = function (sourceInformation) {
    if (this.v33_1 > 0) {
      groupSourceInformationFor(this, this.d34_1, sourceInformation);
    }
  };
  protoOf(SlotWriter).z3o = function (key, value) {
    if (this.v33_1 > 0) {
      var tmp0_safe_receiver = this.n33_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        add_1(tmp0_safe_receiver, key, this.t3j(this.d34_1));
      }
      var tmp1_safe_receiver = groupSourceInformationFor(this, this.d34_1, null);
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.x4c(key, value, _get_currentGroupSlotIndex__p1glxf(this));
      }
    }
  };
  protoOf(SlotWriter).a3p = function () {
    if (this.v33_1 > 0) {
      var tmp0_safe_receiver = groupSourceInformationFor(this, this.d34_1, null);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.y4c(_get_currentGroupSlotIndex__p1glxf(this));
      }
    }
  };
  protoOf(SlotWriter).n4c = function (value) {
    return updateNodeOfGroup(this, this.b34_1, value);
  };
  protoOf(SlotWriter).z4c = function (anchor, value) {
    return updateNodeOfGroup(this, anchor.p4b(this), value);
  };
  protoOf(SlotWriter).j4c = function (value) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.q33_1 <= this.r33_1)) {
      var tmp$ret$1 = 'Writing to an invalid slot';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.k33_1[dataIndexToDataAddress(this, this.q33_1 - 1 | 0)] = value;
  };
  protoOf(SlotWriter).a4d = function (group, index) {
    var address = groupIndexToAddress(this, group);
    var slotsStart = slotIndex(this, this.j33_1, address);
    var slotsEnd = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, group + 1 | 0));
    var slotsIndex = slotsStart + index | 0;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(slotsIndex >= slotsStart && slotsIndex < slotsEnd)) {
      var tmp$ret$1 = 'Write to an invalid slot index ' + index + ' for group ' + group;
      composeImmediateRuntimeError(tmp$ret$1);
    }
    return slotsIndex;
  };
  protoOf(SlotWriter).b4d = function (group, index, value) {
    var slotsIndex = this.a4d(group, index);
    var slotAddress = dataIndexToDataAddress(this, slotsIndex);
    var result = this.k33_1[slotAddress];
    this.k33_1[slotAddress] = value;
    return result;
  };
  protoOf(SlotWriter).m3p = function (slotIndex) {
    var address = dataIndexToDataAddress(this, slotIndex);
    var result = this.k33_1[address];
    this.k33_1[address] = Companion_getInstance_0().f30_1;
    return result;
  };
  protoOf(SlotWriter).i4c = function () {
    if (this.v33_1 > 0) {
      insertSlots(this, 1, this.d34_1);
    }
    var tmp = this.k33_1;
    var _unary__edvuaz = this.q33_1;
    this.q33_1 = _unary__edvuaz + 1 | 0;
    return tmp[dataIndexToDataAddress(this, _unary__edvuaz)];
  };
  protoOf(SlotWriter).n40 = function (anchor, index) {
    return this.c4d(this.q3m(anchor), index);
  };
  protoOf(SlotWriter).c4d = function (groupIndex, index) {
    var address = groupIndexToAddress(this, groupIndex);
    var slotsStart = slotIndex(this, this.j33_1, address);
    var slotsEnd = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, groupIndex + 1 | 0));
    var slotsIndex = slotsStart + index | 0;
    if (!(slotsStart <= slotsIndex ? slotsIndex < slotsEnd : false)) {
      return Companion_getInstance_0().f30_1;
    }
    var slotAddress = dataIndexToDataAddress(this, slotsIndex);
    return this.k33_1[slotAddress];
  };
  protoOf(SlotWriter).d4d = function (groupIndex) {
    return slotIndex(this, this.j33_1, groupIndexToAddress(this, groupIndex));
  };
  protoOf(SlotWriter).e4d = function (groupIndex) {
    return dataIndex_0(this, this.j33_1, groupIndexToAddress(this, groupIndex + 1 | 0));
  };
  protoOf(SlotWriter).l4c = function (group) {
    var tmp = this.q33_1 - this.d4d(group) | 0;
    var tmp0_safe_receiver = this.a34_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l1(group);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n1();
    return tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
  };
  protoOf(SlotWriter).u4b = function (amount) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(amount >= 0)) {
      var tmp$ret$1 = 'Cannot seek backwards';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!(this.v33_1 <= 0)) {
      var tmp$ret$3 = 'Cannot call seek() while inserting';
      throwIllegalStateException(tmp$ret$3);
    }
    if (amount === 0)
      return Unit_instance;
    var index = this.b34_1 + amount | 0;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(index >= this.d34_1 && index <= this.c34_1)) {
      var tmp$ret$5 = 'Cannot seek outside the current group (' + this.d34_1 + '-' + this.c34_1 + ')';
      composeImmediateRuntimeError(tmp$ret$5);
    }
    this.b34_1 = index;
    var newSlot = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, index));
    this.q33_1 = newSlot;
    this.r33_1 = newSlot;
  };
  protoOf(SlotWriter).f4d = function (anchor) {
    return this.u4b(anchor.p4b(this) - this.b34_1 | 0);
  };
  protoOf(SlotWriter).z30 = function () {
    var newGroup = this.c34_1;
    this.b34_1 = newGroup;
    this.q33_1 = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, newGroup));
  };
  protoOf(SlotWriter).t35 = function () {
    var _unary__edvuaz = this.v33_1;
    this.v33_1 = _unary__edvuaz + 1 | 0;
    if (_unary__edvuaz === 0) {
      saveCurrentGroupEnd(this);
    }
  };
  protoOf(SlotWriter).a36 = function () {
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!(this.v33_1 > 0)) {
      var tmp$ret$1 = 'Unbalanced begin/end insert';
      throwIllegalStateException(tmp$ret$1);
    }
    this.v33_1 = this.v33_1 - 1 | 0;
    if (this.v33_1 === 0) {
      // Inline function 'androidx.compose.runtime.IntStack.size' call
      var tmp = this.z33_1.f3i_1;
      // Inline function 'androidx.compose.runtime.IntStack.size' call
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(tmp === this.x33_1.f3i_1)) {
        var tmp$ret$5 = 'startGroup/endGroup mismatch while inserting';
        composeImmediateRuntimeError(tmp$ret$5);
      }
      restoreCurrentGroupEnd(this);
    }
  };
  protoOf(SlotWriter).x3j = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 === 0)) {
      var tmp$ret$1 = 'Key must be supplied when inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    startGroup_2(this, 0, Companion_getInstance_0().f30_1, false, Companion_getInstance_0().f30_1);
  };
  protoOf(SlotWriter).u35 = function (key, dataKey) {
    return startGroup_2(this, key, dataKey, false, Companion_getInstance_0().f30_1);
  };
  protoOf(SlotWriter).b3k = function (key, objectKey) {
    return startGroup_2(this, key, objectKey, true, Companion_getInstance_0().f30_1);
  };
  protoOf(SlotWriter).a3k = function (key, objectKey, aux) {
    return startGroup_2(this, key, objectKey, false, aux);
  };
  protoOf(SlotWriter).z35 = function () {
    var inserting = this.v33_1 > 0;
    var currentGroup = this.b34_1;
    var currentGroupEnd = this.c34_1;
    var groupIndex = this.d34_1;
    var groupAddress = groupIndexToAddress(this, groupIndex);
    var newNodes = this.w33_1;
    var newGroupSize = currentGroup - groupIndex | 0;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    var isNode = !((this.j33_1[imul(groupAddress, 5) + 1 | 0] & 1073741824) === 0);
    if (inserting) {
      var deferredSlotWrites = this.a34_1;
      var tmp1_safe_receiver = deferredSlotWrites == null ? null : deferredSlotWrites.l1(groupIndex);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'androidx.collection.ObjectList.forEach' call
        // Inline function 'kotlin.contracts.contract' call
        var content = tmp1_safe_receiver.sz_1;
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.tz_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var value = content[i];
            rawUpdate(this, value);
          }
           while (inductionVariable < last);
        deferredSlotWrites.gw(groupIndex);
      }
      updateGroupSize(this.j33_1, groupAddress, newGroupSize);
      updateNodeCount_0(this.j33_1, groupAddress, newNodes);
      this.w33_1 = this.z33_1.k3j() + (isNode ? 1 : newNodes) | 0;
      this.d34_1 = parent(this, this.j33_1, groupIndex);
      var nextAddress = this.d34_1 < 0 ? this.f4c() : groupIndexToAddress(this, this.d34_1 + 1 | 0);
      var newCurrentSlot = nextAddress < 0 ? 0 : dataIndex_0(this, this.j33_1, nextAddress);
      this.q33_1 = newCurrentSlot;
      this.r33_1 = newCurrentSlot;
    } else {
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(currentGroup === currentGroupEnd)) {
        var tmp$ret$7 = 'Expected to be at the end of a group';
        composeImmediateRuntimeError(tmp$ret$7);
      }
      var oldGroupSize = groupSize(this.j33_1, groupAddress);
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
      var oldNodes = this.j33_1[imul(groupAddress, 5) + 1 | 0] & 67108863;
      updateGroupSize(this.j33_1, groupAddress, newGroupSize);
      updateNodeCount_0(this.j33_1, groupAddress, newNodes);
      var newParent = this.x33_1.k3j();
      restoreCurrentGroupEnd(this);
      this.d34_1 = newParent;
      var groupParent = parent(this, this.j33_1, groupIndex);
      this.w33_1 = this.z33_1.k3j();
      if (groupParent === newParent) {
        this.w33_1 = this.w33_1 + (isNode ? 0 : newNodes - oldNodes | 0) | 0;
      } else {
        var groupSizeDelta = newGroupSize - oldGroupSize | 0;
        var nodesDelta = isNode ? 0 : newNodes - oldNodes | 0;
        if (!(groupSizeDelta === 0) || !(nodesDelta === 0)) {
          var current = groupParent;
          while (!(current === 0) && !(current === newParent) && (!(nodesDelta === 0) || !(groupSizeDelta === 0))) {
            var currentAddress = groupIndexToAddress(this, current);
            if (!(groupSizeDelta === 0)) {
              var newSize = groupSize(this.j33_1, currentAddress) + groupSizeDelta | 0;
              updateGroupSize(this.j33_1, currentAddress, newSize);
            }
            if (!(nodesDelta === 0)) {
              var tmp = this.j33_1;
              // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
              var tmp$ret$9 = this.j33_1[imul(currentAddress, 5) + 1 | 0] & 67108863;
              updateNodeCount_0(tmp, currentAddress, tmp$ret$9 + nodesDelta | 0);
            }
            // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
            if (!((this.j33_1[imul(currentAddress, 5) + 1 | 0] & 1073741824) === 0))
              nodesDelta = 0;
            current = parent(this, this.j33_1, current);
          }
        }
        this.w33_1 = this.w33_1 + nodesDelta | 0;
      }
    }
    return newNodes;
  };
  protoOf(SlotWriter).g4d = function (index) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 <= 0)) {
      var tmp$ret$1 = 'Cannot call ensureStarted() while inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var parent = this.d34_1;
    if (!(parent === index)) {
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(index >= parent && index < this.c34_1)) {
        var tmp$ret$3 = 'Started group at ' + index + ' must be a subgroup of the group at ' + parent;
        composeImmediateRuntimeError(tmp$ret$3);
      }
      var oldCurrent = this.b34_1;
      var oldCurrentSlot = this.q33_1;
      var oldCurrentSlotEnd = this.r33_1;
      this.b34_1 = index;
      this.x3j();
      this.b34_1 = oldCurrent;
      this.q33_1 = oldCurrentSlot;
      this.r33_1 = oldCurrentSlotEnd;
    }
  };
  protoOf(SlotWriter).h4d = function (anchor) {
    return this.g4d(anchor.p4b(this));
  };
  protoOf(SlotWriter).y35 = function () {
    var groupAddress = groupIndexToAddress(this, this.b34_1);
    var newGroup = this.b34_1 + groupSize(this.j33_1, groupAddress) | 0;
    this.b34_1 = newGroup;
    this.q33_1 = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, newGroup));
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
    if (!((this.j33_1[imul(groupAddress, 5) + 1 | 0] & 1073741824) === 0)) {
      tmp = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
      tmp = this.j33_1[imul(groupAddress, 5) + 1 | 0] & 67108863;
    }
    return tmp;
  };
  protoOf(SlotWriter).h34 = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 === 0)) {
      var tmp$ret$1 = 'Cannot remove group while inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var oldGroup = this.b34_1;
    var oldSlot = this.q33_1;
    var dataStart = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, oldGroup));
    var count = this.y35();
    var tmp0_safe_receiver = this.g4c(this.d34_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.i4d(oldGroup);
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = tmp0_safe_receiver.j4d(tmp0_safe_receiver_0);
      }
    }
    var tmp1_safe_receiver = this.f34_1;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new PrioritySet(tmp_0)) == null)
      null;
    else {
      var tmp_1 = tmp1_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_1 == null ? null : new PrioritySet(tmp_1)).o4c_1;
      while (PrioritySet__isNotEmpty_impl_q82m5n(it) && PrioritySet__peek_impl_la0uk4(it) >= oldGroup) {
        PrioritySet__takeMax_impl_e5irrm(it);
      }
    }
    var anchorsRemoved = removeGroups(this, oldGroup, this.b34_1 - oldGroup | 0);
    removeSlots(this, dataStart, this.q33_1 - dataStart | 0, oldGroup - 1 | 0);
    this.b34_1 = oldGroup;
    this.q33_1 = oldSlot;
    this.w33_1 = this.w33_1 - count | 0;
    return anchorsRemoved;
  };
  protoOf(SlotWriter).g34 = function (group, block) {
    var deferredSlotIndexes = null;
    var deferredAfters = null;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotWriter.traverseGroupAndChildren' call
    var current = group;
    var currentParent = this.y34(current);
    var size = this.f4c();
    var end = group + this.a35(group) | 0;
    while (current < end) {
      var child = current;
      var inductionVariable = dataIndex(this, child);
      var last = dataIndex(this, child + 1 | 0);
      if (inductionVariable < last)
        $l$loop: do {
          var slotIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var address = dataIndexToDataAddress(this, slotIndex);
          var value = this.k33_1[address];
          if (!(value == null) ? isInterface(value, RememberObserverHolder) : false) {
            var after = asGapRememberObserverHolder(value).k3p_1;
            if (after >= 0) {
              var index = childGroupAtIndex(this, child, after);
              var tmp0_elvis_lhs = deferredAfters;
              var tmp;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.also' call
                var this_0 = mutableIntSetOf();
                deferredAfters = this_0;
                tmp = this_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var afters = tmp;
              var tmp1_elvis_lhs = deferredSlotIndexes;
              var tmp_0;
              if (tmp1_elvis_lhs == null) {
                // Inline function 'androidx.collection.mutableIntListOf' call
                // Inline function 'kotlin.also' call
                var this_1 = new MutableIntList();
                deferredSlotIndexes = this_1;
                tmp_0 = this_1;
              } else {
                tmp_0 = tmp1_elvis_lhs;
              }
              var slots = tmp_0;
              afters.pv(index);
              slots.pv(index);
              slots.pv(slotIndex);
              continue $l$loop;
            }
          }
          block(slotIndex, value);
        }
         while (inductionVariable < last);
      var next = current + 1 | 0;
      var nextParent = next < size ? this.y34(next) : -1;
      if (!(nextParent === current)) {
        $l$loop_1: while (true) {
          var child_0 = current;
          var slotIndexes = deferredSlotIndexes;
          var afters_0 = deferredAfters;
          if (!(slotIndexes == null) && !(afters_0 == null) && afters_0.gw(child_0)) {
            var expected = 0;
            // Inline function 'androidx.collection.IntList.size' call
            var size_0 = slotIndexes.jv_1;
            // Inline function 'kotlin.repeat' call
            var times = size_0 / 2 | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < times)
              do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var start = imul(index_0, 2);
                var after_0 = slotIndexes.l1(start);
                if (after_0 === child_0) {
                  var slotIndex_0 = slotIndexes.l1(start + 1 | 0);
                  var data = this.k33_1[dataIndexToDataAddress(this, slotIndex_0)];
                  block(slotIndex_0, data);
                } else {
                  if (!(start === expected)) {
                    var _unary__edvuaz = expected;
                    expected = _unary__edvuaz + 1 | 0;
                    slotIndexes.rv(_unary__edvuaz, after_0);
                    var _unary__edvuaz_0 = expected;
                    expected = _unary__edvuaz_0 + 1 | 0;
                    slotIndexes.rv(_unary__edvuaz_0, slotIndexes.l1(start + 1 | 0));
                  } else
                    expected = expected + 2 | 0;
                }
              }
               while (inductionVariable_0 < times);
            if (!(expected === size_0)) {
              slotIndexes.e5(expected, size_0);
            }
          }
          if (current === group)
            break $l$loop_1;
          if (currentParent === nextParent)
            break $l$loop_1;
          current = currentParent;
          currentParent = this.y34(current);
        }
      }
      current = next;
      currentParent = nextParent;
    }
  };
  protoOf(SlotWriter).k3w = function (offset) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 === 0)) {
      var tmp$ret$1 = 'Cannot move a group while inserting';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(offset >= 0)) {
      var tmp$ret$3 = 'Parameter offset is out of bounds';
      composeImmediateRuntimeError(tmp$ret$3);
    }
    if (offset === 0)
      return Unit_instance;
    var current = this.b34_1;
    var parent = this.d34_1;
    var parentEnd = this.c34_1;
    var count = offset;
    var groupToMove = current;
    while (count > 0) {
      groupToMove = groupToMove + groupSize(this.j33_1, groupIndexToAddress(this, groupToMove)) | 0;
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(groupToMove <= parentEnd)) {
        var tmp$ret$5 = 'Parameter offset is out of bounds';
        composeImmediateRuntimeError(tmp$ret$5);
      }
      count = count - 1 | 0;
    }
    var moveLen = groupSize(this.j33_1, groupIndexToAddress(this, groupToMove));
    var destinationSlot = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, this.b34_1));
    var dataStart = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, groupToMove));
    var dataEnd = dataIndex_0(this, this.j33_1, groupIndexToAddress(this, groupToMove + moveLen | 0));
    var moveDataLen = dataEnd - dataStart | 0;
    // Inline function 'kotlin.math.max' call
    var a = this.b34_1 - 1 | 0;
    var tmp$ret$6 = Math.max(a, 0);
    insertSlots(this, moveDataLen, tmp$ret$6);
    insertGroups(this, moveLen);
    var groups = this.j33_1;
    var moveLocationAddress = groupIndexToAddress(this, groupToMove + moveLen | 0);
    var moveLocationOffset = imul(moveLocationAddress, 5);
    var currentAddress = groupIndexToAddress(this, current);
    var tmp4 = imul(currentAddress, 5);
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = moveLocationOffset + imul(moveLen, 5) | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = groups;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, groups, tmp4, moveLocationOffset, endIndex);
    if (moveDataLen > 0) {
      var slots = this.k33_1;
      var tmp6 = dataIndexToDataAddress(this, dataStart + moveDataLen | 0);
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex_0 = dataIndexToDataAddress(this, dataEnd + moveDataLen | 0);
      arrayCopy(slots, slots, destinationSlot, tmp6, endIndex_0);
    }
    var dataMoveDistance = (dataStart + moveDataLen | 0) - destinationSlot | 0;
    var slotsGapStart = this.s33_1;
    var slotsGapLen = this.t33_1;
    var slotsCapacity = this.k33_1.length;
    var slotsGapOwner = this.u33_1;
    var inductionVariable = current;
    var last = current + moveLen | 0;
    if (inductionVariable < last)
      do {
        var group = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var groupAddress = groupIndexToAddress(this, group);
        var oldIndex = dataIndex_0(this, groups, groupAddress);
        var newIndex = oldIndex - dataMoveDistance | 0;
        var newAnchor = dataIndexToDataAnchor(this, newIndex, slotsGapOwner < groupAddress ? 0 : slotsGapStart, slotsGapLen, slotsCapacity);
        updateDataIndex(this, groups, groupAddress, newAnchor);
      }
       while (inductionVariable < last);
    moveAnchors(this, groupToMove + moveLen | 0, current, moveLen);
    var anchorsRemoved = removeGroups(this, groupToMove + moveLen | 0, moveLen);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!anchorsRemoved) {
      var tmp$ret$15 = 'Unexpectedly removed anchors';
      composeImmediateRuntimeError(tmp$ret$15);
    }
    fixParentAnchorsFor(this, parent, this.c34_1, current);
    if (moveDataLen > 0) {
      removeSlots(this, dataStart + moveDataLen | 0, moveDataLen, (groupToMove + moveLen | 0) - 1 | 0);
    }
  };
  protoOf(SlotWriter).r35 = function (groupAnchor, anchor) {
    var group = this.q3m(groupAnchor);
    var groupEnd = group + groupSize(this.j33_1, group) | 0;
    var containsArg = anchor.l3o_1;
    return group <= containsArg ? containsArg < groupEnd : false;
  };
  protoOf(SlotWriter).x35 = function (anchor, offset, writer) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(writer.v33_1 > 0)) {
      var tmp$ret$2 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 === 0)) {
      var tmp$ret$5 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$5);
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!anchor.d2y()) {
      var tmp$ret$8 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$8);
    }
    var location = this.q3m(anchor) + offset | 0;
    var currentGroup = this.b34_1;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(currentGroup <= location ? location < this.c34_1 : false)) {
      var tmp$ret$11 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$11);
    }
    var parent = this.y34(location);
    var size = this.a35(location);
    var nodes = this.x34(location) ? 1 : this.b35(location);
    var result = moveGroup(Companion_instance_9, this, location, writer, false, false);
    updateContainsMark(this, parent);
    var current = parent;
    var updatingNodes = nodes > 0;
    while (current >= currentGroup) {
      var currentAddress = groupIndexToAddress(this, current);
      updateGroupSize(this.j33_1, currentAddress, groupSize(this.j33_1, currentAddress) - size | 0);
      if (updatingNodes) {
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.isNode' call
        if (!((this.j33_1[imul(currentAddress, 5) + 1 | 0] & 1073741824) === 0))
          updatingNodes = false;
        else {
          var tmp = this.j33_1;
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.nodeCount' call
          var tmp$ret$13 = this.j33_1[imul(currentAddress, 5) + 1 | 0] & 67108863;
          updateNodeCount_0(tmp, currentAddress, tmp$ret$13 - nodes | 0);
        }
      }
      current = this.y34(current);
    }
    if (updatingNodes) {
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(this.w33_1 >= nodes)) {
        var tmp$ret$16 = 'Check failed';
        composeImmediateRuntimeError(tmp$ret$16);
      }
      this.w33_1 = this.w33_1 - nodes | 0;
    }
    return result;
  };
  protoOf(SlotWriter).k4d = function (table, index, removeSourceGroup) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 > 0)) {
      var tmp$ret$2 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    if (index === 0 && this.b34_1 === 0 && this.i33_1.j34_1 === 0 && groupSize(table.i34_1, index) === table.j34_1) {
      var myGroups = this.j33_1;
      var mySlots = this.k33_1;
      var myAnchors = this.l33_1;
      var mySourceInformation = this.m33_1;
      var myCallInformation = this.n33_1;
      var groups = table.i34_1;
      var groupsSize = table.j34_1;
      var slots = table.k34_1;
      var slotsSize = table.l34_1;
      var sourceInformation = table.r34_1;
      var callInformation = table.s34_1;
      this.j33_1 = groups;
      this.k33_1 = slots;
      this.l33_1 = table.q34_1;
      this.o33_1 = groupsSize;
      this.p33_1 = (groups.length / 5 | 0) - groupsSize | 0;
      this.s33_1 = slotsSize;
      this.t33_1 = slots.length - slotsSize | 0;
      this.u33_1 = groupsSize;
      this.m33_1 = sourceInformation;
      this.n33_1 = callInformation;
      table.s4b(myGroups, 0, mySlots, 0, myAnchors, mySourceInformation, myCallInformation);
      return this.l33_1;
    }
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = table.s35();
    var normalClose = false;
    var tmp;
    try {
      // Inline function 'kotlin.also' call
      var this_0 = moveGroup(Companion_instance_9, writer, index, this, true, true, removeSourceGroup);
      normalClose = true;
      tmp = this_0;
    }finally {
      writer.b36(normalClose);
    }
    return tmp;
  };
  protoOf(SlotWriter).l4d = function (offset, table, index) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.v33_1 <= 0 && this.a35(this.b34_1 + offset | 0) === 1)) {
      var tmp$ret$2 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    var previousCurrentGroup = this.b34_1;
    var previousCurrentSlot = this.q33_1;
    var previousCurrentSlotEnd = this.r33_1;
    this.u4b(offset);
    this.x3j();
    this.t35();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = table.s35();
    var normalClose = false;
    var tmp;
    try {
      // Inline function 'kotlin.also' call
      var this_0 = moveGroup(Companion_instance_9, writer, index, this, false, true);
      normalClose = true;
      tmp = this_0;
    }finally {
      writer.b36(normalClose);
    }
    var anchors = tmp;
    this.a36();
    this.z35();
    this.b34_1 = previousCurrentGroup;
    this.q33_1 = previousCurrentSlot;
    this.r33_1 = previousCurrentSlotEnd;
    return anchors;
  };
  protoOf(SlotWriter).o3k = function (index) {
    var tmp0 = this.l33_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.getOrAdd' call
    var effectiveSize = this.f4c();
    var location = search(tmp0, index, effectiveSize);
    var tmp;
    if (location < 0) {
      var anchor = new GapAnchor(index <= this.o33_1 ? index : -(this.f4c() - index | 0) | 0);
      tmp0.g3(-(location + 1 | 0) | 0, anchor);
      tmp = anchor;
    } else {
      tmp = tmp0.l1(location);
    }
    return tmp;
  };
  protoOf(SlotWriter).m4d = function (group) {
    var groupAddress = groupIndexToAddress(this, group);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.hasMark' call
    if (!!((this.j33_1[imul(groupAddress, 5) + 1 | 0] & 134217728) === 0)) {
      updateMark(this.j33_1, groupAddress, true);
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.containsMark' call
      if (!!((this.j33_1[imul(groupAddress, 5) + 1 | 0] & 67108864) === 0)) {
        updateContainsMark(this, this.y34(group));
      }
    }
  };
  protoOf(SlotWriter).v35 = function (group, $super) {
    group = group === VOID ? this.d34_1 : group;
    var tmp;
    if ($super === VOID) {
      this.m4d(group);
      tmp = Unit_instance;
    } else {
      tmp = $super.m4d.call(this, group);
    }
    return tmp;
  };
  protoOf(SlotWriter).q3m = function (anchor) {
    // Inline function 'kotlin.let' call
    var it = anchor.l3o_1;
    return it < 0 ? this.f4c() + it | 0 : it;
  };
  protoOf(SlotWriter).toString = function () {
    return 'SlotWriter(current = ' + this.b34_1 + ' end=' + this.c34_1 + ' size = ' + this.f4c() + ' ' + ('gap=' + this.o33_1 + '-' + (this.o33_1 + this.p33_1 | 0) + ')');
  };
  protoOf(SlotWriter).g4c = function (group) {
    var tmp0_safe_receiver = this.m33_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.i4d(group);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = tmp0_safe_receiver.w2(tmp0_safe_receiver_0);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(SlotWriter).i4d = function (group) {
    return (0 <= group ? group < this.f4c() : false) ? find(this.l33_1, group, this.f4c()) : null;
  };
  protoOf(SlotWriter).f4c = function () {
    return _get_capacity__a9k9f3(this) - this.p33_1 | 0;
  };
  function KeyInfo(key, objectKey, location, nodes, index) {
    this.p3k_1 = key;
    this.q3k_1 = objectKey;
    this.r3k_1 = location;
    this.s3k_1 = nodes;
    this.t3k_1 = index;
  }
  function BitVector() {
    this.e3x_1 = new Long(0, 0);
    this.f3x_1 = new Long(0, 0);
    this.g3x_1 = get_EmptyLongArray();
  }
  protoOf(BitVector).n1 = function () {
    return imul(this.g3x_1.length + 2 | 0, 64);
  };
  protoOf(BitVector).l1 = function (index) {
    if (index < 64)
      return !equalsLong(bitwiseAnd(this.e3x_1, shiftLeft(new Long(1, 0), index)), new Long(0, 0));
    if (index < 128)
      return !equalsLong(bitwiseAnd(this.f3x_1, shiftLeft(new Long(1, 0), index - 64 | 0)), new Long(0, 0));
    var others = this.g3x_1;
    var size = others.length;
    if (size === 0)
      return false;
    var address = (index / 64 | 0) - 2 | 0;
    if (address >= size)
      return false;
    var bit = index % 64 | 0;
    return !equalsLong(bitwiseAnd(others[address], shiftLeft(new Long(1, 0), bit)), new Long(0, 0));
  };
  protoOf(BitVector).i3x = function (index, value) {
    if (index < 64) {
      var mask = shiftLeft(new Long(1, 0), index);
      var tmp = this;
      var tmp_0 = bitwiseAnd(this.e3x_1, invert(mask));
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.toBit' call
      var tmp$ret$0 = value ? 1 : 0;
      tmp.e3x_1 = bitwiseOr(tmp_0, shiftLeft(fromInt(tmp$ret$0), index));
      return Unit_instance;
    }
    if (index < 128) {
      var mask_0 = shiftLeft(new Long(1, 0), index - 64 | 0);
      var tmp_1 = this;
      var tmp_2 = bitwiseAnd(this.f3x_1, invert(mask_0));
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.toBit' call
      var tmp$ret$1 = value ? 1 : 0;
      tmp_1.f3x_1 = bitwiseOr(tmp_2, shiftLeft(fromInt(tmp$ret$1), index));
      return Unit_instance;
    }
    var address = (index / 64 | 0) - 2 | 0;
    var newIndex = index % 64 | 0;
    var mask_1 = shiftLeft(new Long(1, 0), newIndex);
    var others = this.g3x_1;
    if (address >= others.length) {
      others = copyOf_0(others, address + 1 | 0);
      this.g3x_1 = others;
    }
    var bits = others[address];
    var tmp_3 = others;
    var tmp_4 = bitwiseAnd(bits, invert(mask_1));
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.toBit' call
    var tmp$ret$2 = value ? 1 : 0;
    tmp_3[address] = bitwiseOr(tmp_4, shiftLeft(fromInt(tmp$ret$2), newIndex));
  };
  protoOf(BitVector).h3x = function (index) {
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.BitVector.nextBit' call
      if (index < 64) {
        var it = this.e3x_1;
        var tmp$ret$1 = invert(it);
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.firstBitSet' call
        var this_0 = shiftLeft(shiftRightUnsigned(tmp$ret$1, index), index);
        var bit = countTrailingZeroBits(this_0);
        if (bit < 64) {
          tmp$ret$0 = bit;
          break $l$block_1;
        }
      }
      if (index < 128) {
        var index_0 = index - 64 | 0;
        var it_0 = this.f3x_1;
        var tmp$ret$3 = invert(it_0);
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.firstBitSet' call
        var this_1 = shiftLeft(shiftRightUnsigned(tmp$ret$3, index_0), index_0);
        var bit_0 = countTrailingZeroBits(this_1);
        if (bit_0 < 64) {
          tmp$ret$0 = 64 + bit_0 | 0;
          break $l$block_1;
        }
      }
      // Inline function 'kotlin.math.max' call
      var index_1 = Math.max(index, 128);
      var start = (index_1 / 64 | 0) - 2 | 0;
      var others = this.g3x_1;
      var inductionVariable = start;
      var last = others.length;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it_1 = others[i];
          var value = invert(it_1);
          if (i === start) {
            var shift = index_1 % 64 | 0;
            value = shiftLeft(shiftRightUnsigned(value, shift), shift);
          }
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.firstBitSet' call
          var this_2 = value;
          var bit_1 = countTrailingZeroBits(this_2);
          if (bit_1 < 64) {
            tmp$ret$0 = (128 + imul(i, 64) | 0) + bit_1 | 0;
            break $l$block_1;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = 2147483647;
    }
    return tmp$ret$0;
  };
  protoOf(BitVector).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    var first = true;
    this_0.q('BitVector [');
    var inductionVariable = 0;
    var last = this.n1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.l1(i)) {
          if (!first) {
            this_0.q(', ');
          }
          first = false;
          this_0.ed(i);
        }
      }
       while (inductionVariable < last);
    this_0.s(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  };
  function openInformation($this) {
    var tmp0_safe_receiver = $this.b4c_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp$ret$2;
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.fastLastOrNull' call
        var index = tmp0_safe_receiver.n1() - 1 | 0;
        while (index >= 0) {
          var value = tmp0_safe_receiver.l1(index);
          var tmp_0;
          if (value instanceof GapGroupSourceInformation) {
            tmp_0 = !value.c4c_1;
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$2 = value;
            break $l$block;
          }
          index = index - 1 | 0;
        }
        tmp$ret$2 = null;
      }
      tmp = tmp$ret$2;
    }
    var tmp_1 = tmp;
    var tmp1_safe_receiver = tmp_1 instanceof GapGroupSourceInformation ? tmp_1 : null;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : openInformation(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? $this : tmp2_elvis_lhs;
  }
  function add_0($this, group) {
    var tmp0_elvis_lhs = $this.b4c_1;
    var groups = tmp0_elvis_lhs == null ? ArrayList_init_$Create$() : tmp0_elvis_lhs;
    $this.b4c_1 = groups;
    groups.j1(group);
  }
  function hasAnchor($this, anchor) {
    var tmp0_safe_receiver = $this.b4c_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.fastAny' call
        // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0_safe_receiver.l1(index);
            var tmp_0;
            if (equals(item, anchor)) {
              tmp_0 = true;
            } else {
              var tmp_1;
              if (item instanceof GapGroupSourceInformation) {
                tmp_1 = hasAnchor(item, anchor);
              } else {
                tmp_1 = false;
              }
              tmp_0 = tmp_1;
            }
            if (tmp_0) {
              tmp$ret$0 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    }
    return tmp === true;
  }
  function GapGroupSourceInformation(key, sourceInformation, dataStartOffset) {
    this.y4b_1 = key;
    this.z4b_1 = sourceInformation;
    this.a4c_1 = dataStartOffset;
    this.b4c_1 = null;
    this.c4c_1 = false;
    this.d4c_1 = 0;
  }
  protoOf(GapGroupSourceInformation).t1 = function () {
    return this.y4b_1;
  };
  protoOf(GapGroupSourceInformation).n4b = function () {
    return this.z4b_1;
  };
  protoOf(GapGroupSourceInformation).m4b = function () {
    return this.a4c_1;
  };
  protoOf(GapGroupSourceInformation).ie = function () {
    return this.b4c_1;
  };
  protoOf(GapGroupSourceInformation).k4b = function () {
    return this.c4c_1;
  };
  protoOf(GapGroupSourceInformation).l4b = function () {
    return this.d4c_1;
  };
  protoOf(GapGroupSourceInformation).x4c = function (key, sourceInformation, dataOffset) {
    add_0(openInformation(this), new GapGroupSourceInformation(key, sourceInformation, dataOffset));
  };
  protoOf(GapGroupSourceInformation).y4c = function (dataOffset) {
    openInformation(this).t1i(dataOffset);
  };
  protoOf(GapGroupSourceInformation).k4c = function (writer, group) {
    add_0(openInformation(this), writer.o3k(group));
  };
  protoOf(GapGroupSourceInformation).e4c = function (table, group) {
    add_0(openInformation(this), table.o3k(group));
  };
  protoOf(GapGroupSourceInformation).h4c = function (writer, predecessor, group) {
    var tmp0_elvis_lhs = this.b4c_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      this.b4c_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var groups = tmp;
    var tmp_0;
    if (predecessor >= 0) {
      var anchor = writer.i4d(predecessor);
      var tmp_1;
      if (!(anchor == null)) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.fastIndexOf' call
          var index = 0;
          var size = groups.n1();
          while (index < size) {
            var value = groups.l1(index);
            var tmp_2;
            if (equals(value, anchor)) {
              tmp_2 = true;
            } else {
              var tmp_3;
              if (value instanceof GapGroupSourceInformation) {
                tmp_3 = hasAnchor(value, anchor);
              } else {
                tmp_3 = false;
              }
              tmp_2 = tmp_3;
            }
            if (tmp_2) {
              tmp$ret$2 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$2 = -1;
        }
        tmp_1 = tmp$ret$2;
      } else {
        tmp_1 = 0;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = 0;
    }
    var index_0 = tmp_0;
    groups.g3(index_0, writer.o3k(group));
  };
  protoOf(GapGroupSourceInformation).t1i = function (dataOffset) {
    this.c4c_1 = true;
    this.d4c_1 = dataOffset;
  };
  protoOf(GapGroupSourceInformation).j4d = function (anchor) {
    var groups = this.b4c_1;
    if (!(groups == null)) {
      var index = groups.n1() - 1 | 0;
      while (index >= 0) {
        var item = groups.l1(index);
        if (item instanceof GapAnchor) {
          if (equals(item, anchor)) {
            groups.h3(index);
          }
        } else {
          if (item instanceof GapGroupSourceInformation)
            if (!item.j4d(anchor)) {
              groups.h3(index);
            }
        }
        index = index - 1 | 0;
      }
      if (groups.r()) {
        this.b4c_1 = null;
        return false;
      }
      return true;
    }
    return true;
  };
  function find(_this__u8e3s4, index, effectiveSize) {
    _init_properties_SlotTable_kt__9b2e7y();
    var location = search(_this__u8e3s4, index, effectiveSize);
    return location >= 0 ? _this__u8e3s4.l1(location) : null;
  }
  function search(_this__u8e3s4, location, effectiveSize) {
    _init_properties_SlotTable_kt__9b2e7y();
    var low = 0;
    var high = _this__u8e3s4.n1() - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1 | 0;
      // Inline function 'kotlin.let' call
      var it = _this__u8e3s4.l1(mid).l3o_1;
      var midVal = it < 0 ? effectiveSize + it | 0 : it;
      var cmp = compareTo(midVal, location);
      if (cmp < 0)
        low = mid + 1 | 0;
      else if (cmp > 0)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function groupSize(_this__u8e3s4, address) {
    _init_properties_SlotTable_kt__9b2e7y();
    return _this__u8e3s4[imul(address, 5) + 3 | 0];
  }
  function slotAnchor(_this__u8e3s4, address) {
    _init_properties_SlotTable_kt__9b2e7y();
    // Inline function 'kotlin.let' call
    var slot = imul(address, 5);
    var tmp = _this__u8e3s4[slot + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.countOneBits' call
    var value = _this__u8e3s4[slot + 1 | 0] >> 28;
    return tmp + countOneBits(value) | 0;
  }
  function get_nextGroup(_this__u8e3s4) {
    _init_properties_SlotTable_kt__9b2e7y();
    return _this__u8e3s4.b34_1 + _this__u8e3s4.a35(_this__u8e3s4.b34_1) | 0;
  }
  function objectKeyIndex(_this__u8e3s4, address) {
    _init_properties_SlotTable_kt__9b2e7y();
    // Inline function 'kotlin.let' call
    var slot = imul(address, 5);
    var tmp = _this__u8e3s4[slot + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.countOneBits' call
    var value = _this__u8e3s4[slot + 1 | 0] >> 30;
    return tmp + countOneBits(value) | 0;
  }
  function auxIndex_0(_this__u8e3s4, address) {
    _init_properties_SlotTable_kt__9b2e7y();
    // Inline function 'kotlin.let' call
    var slot = imul(address, 5);
    var tmp;
    if (slot >= _this__u8e3s4.length) {
      tmp = _this__u8e3s4.length;
    } else {
      var tmp_0 = _this__u8e3s4[slot + 4 | 0];
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.countOneBits' call
      var value = _this__u8e3s4[slot + 1 | 0] >> 29;
      tmp = tmp_0 + countOneBits(value) | 0;
    }
    return tmp;
  }
  function validateRead($this) {
    if (!($this.n4d_1.p34_1 === $this.q4d_1)) {
      throwConcurrentModificationException();
    }
  }
  function GroupIterator(table, start, end) {
    this.n4d_1 = table;
    this.o4d_1 = end;
    this.p4d_1 = start;
    this.q4d_1 = this.n4d_1.p34_1;
    if (this.n4d_1.o34_1) {
      throwConcurrentModificationException();
    }
  }
  protoOf(GroupIterator).u = function () {
    return this.p4d_1 < this.o4d_1;
  };
  protoOf(GroupIterator).v = function () {
    validateRead(this);
    var group = this.p4d_1;
    this.p4d_1 = this.p4d_1 + groupSize(this.n4d_1.i34_1, group) | 0;
    return new SlotTableGroup(this.n4d_1, group, this.q4d_1);
  };
  function validateRead_0($this) {
    if (!($this.r4d_1.p34_1 === $this.t4d_1)) {
      throwConcurrentModificationException();
    }
  }
  function SlotTableGroup(table, group, version) {
    version = version === VOID ? table.p34_1 : version;
    this.r4d_1 = table;
    this.s4d_1 = group;
    this.t4d_1 = version;
  }
  protoOf(SlotTableGroup).t = function () {
    validateRead_0(this);
    var tmp0_safe_receiver = this.r4d_1.t4b(this.s4d_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new SourceInformationGroupIterator(this.r4d_1, this.s4d_1, tmp0_safe_receiver, new AnchoredGroupPath(this.s4d_1));
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? new GroupIterator(this.r4d_1, this.s4d_1 + 1 | 0, this.s4d_1 + groupSize(this.r4d_1.i34_1, this.s4d_1) | 0) : tmp1_elvis_lhs;
  };
  protoOf(SlotTableGroup).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof SlotTableGroup) {
      tmp_1 = other.s4d_1 === this.s4d_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = other.t4d_1 === this.t4d_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.r4d_1, this.r4d_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SlotTableGroup).hashCode = function () {
    return this.s4d_1 + imul(31, hashCode(this.r4d_1)) | 0;
  };
  function add_1(_this__u8e3s4, key, value) {
    _init_properties_SlotTable_kt__9b2e7y();
    var tmp0_elvis_lhs = _this__u8e3s4.l1(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new MutableIntSet();
      _this__u8e3s4.ew(key, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    tmp.pv(value);
  }
  function initGroup(_this__u8e3s4, address, key, isNode, hasDataKey, hasData, parentAnchor, dataAnchor) {
    _init_properties_SlotTable_kt__9b2e7y();
    var arrayIndex = imul(address, 5);
    _this__u8e3s4[arrayIndex + 0 | 0] = key;
    var tmp = arrayIndex + 1 | 0;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.toBit' call
    var tmp_0 = (isNode ? 1 : 0) << 30;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.toBit' call
    var tmp_1 = tmp_0 | (hasDataKey ? 1 : 0) << 29;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.toBit' call
    _this__u8e3s4[tmp] = tmp_1 | (hasData ? 1 : 0) << 28;
    _this__u8e3s4[arrayIndex + 2 | 0] = parentAnchor;
    _this__u8e3s4[arrayIndex + 3 | 0] = 0;
    _this__u8e3s4[arrayIndex + 4 | 0] = dataAnchor;
  }
  function updateGroupSize(_this__u8e3s4, address, value) {
    _init_properties_SlotTable_kt__9b2e7y();
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value_0 = value >= 0;
    if (false && !value_0) {
      var tmp$ret$2 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    _this__u8e3s4[imul(address, 5) + 3 | 0] = value;
  }
  function updateNodeCount_0(_this__u8e3s4, address, value) {
    _init_properties_SlotTable_kt__9b2e7y();
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value_0 = value >= 0 && value < 67108863;
    if (false && !value_0) {
      var tmp$ret$2 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    _this__u8e3s4[imul(address, 5) + 1 | 0] = _this__u8e3s4[imul(address, 5) + 1 | 0] & -67108864 | value;
  }
  function _PrioritySet___init__impl__yrk5ut(list) {
    var tmp;
    if (list === VOID) {
      // Inline function 'androidx.collection.mutableIntListOf' call
      tmp = new MutableIntList();
    } else {
      tmp = list;
    }
    list = tmp;
    return list;
  }
  function _get_list__d9tsa5($this) {
    return $this;
  }
  function PrioritySet__add_impl_enzb2u($this, value) {
    var tmp;
    // Inline function 'androidx.collection.IntList.isNotEmpty' call
    if (!(_get_list__d9tsa5($this).jv_1 === 0)) {
      var tmp_0;
      if (_get_list__d9tsa5($this).l1(0) === value) {
        tmp_0 = true;
      } else {
        var tmp_1 = _get_list__d9tsa5($this);
        // Inline function 'androidx.collection.IntList.size' call
        var tmp$ret$1 = _get_list__d9tsa5($this).jv_1;
        tmp_0 = tmp_1.l1(tmp$ret$1 - 1 | 0) === value;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    if (tmp)
      return Unit_instance;
    // Inline function 'androidx.collection.IntList.size' call
    var index = _get_list__d9tsa5($this).jv_1;
    _get_list__d9tsa5($this).pv(value);
    $l$loop: while (index > 0) {
      var parent = ((index + 1 | 0) >>> 1 | 0) - 1 | 0;
      var parentValue = _get_list__d9tsa5($this).l1(parent);
      if (value > parentValue) {
        _get_list__d9tsa5($this).rv(index, parentValue);
      } else
        break $l$loop;
      index = parent;
    }
    _get_list__d9tsa5($this).rv(index, value);
  }
  function PrioritySet__isNotEmpty_impl_q82m5n($this) {
    // Inline function 'androidx.collection.IntList.isNotEmpty' call
    return !(_get_list__d9tsa5($this).jv_1 === 0);
  }
  function PrioritySet__peek_impl_la0uk4($this) {
    return _get_list__d9tsa5($this).vg();
  }
  function PrioritySet__takeMax_impl_e5irrm($this) {
    // Inline function 'androidx.collection.IntList.size' call
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = _get_list__d9tsa5($this).jv_1 > 0;
    if (false && !value) {
      var tmp$ret$2 = 'Set is empty';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    var value_0 = _get_list__d9tsa5($this).l1(0);
    $l$loop: while (true) {
      var tmp;
      // Inline function 'androidx.collection.IntList.isNotEmpty' call
      if (!(_get_list__d9tsa5($this).jv_1 === 0)) {
        tmp = _get_list__d9tsa5($this).l1(0) === value_0;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      _get_list__d9tsa5($this).rv(0, _get_list__d9tsa5($this).xg());
      var tmp_0 = _get_list__d9tsa5($this);
      // Inline function 'androidx.collection.IntList.size' call
      var tmp$ret$4 = _get_list__d9tsa5($this).jv_1;
      tmp_0.h3(tmp$ret$4 - 1 | 0);
      var index = 0;
      // Inline function 'androidx.collection.IntList.size' call
      var size = _get_list__d9tsa5($this).jv_1;
      // Inline function 'androidx.collection.IntList.size' call
      var max = _get_list__d9tsa5($this).jv_1 >>> 1 | 0;
      $l$loop_2: while (index < max) {
        var indexValue = _get_list__d9tsa5($this).l1(index);
        var left = imul(index + 1 | 0, 2) - 1 | 0;
        var leftValue = _get_list__d9tsa5($this).l1(left);
        var right = imul(index + 1 | 0, 2);
        if (right < size) {
          var rightValue = _get_list__d9tsa5($this).l1(right);
          if (rightValue > leftValue) {
            if (rightValue > indexValue) {
              _get_list__d9tsa5($this).rv(index, rightValue);
              _get_list__d9tsa5($this).rv(right, indexValue);
              index = right;
              continue $l$loop_2;
            } else
              break $l$loop_2;
          }
        }
        if (leftValue > indexValue) {
          _get_list__d9tsa5($this).rv(index, leftValue);
          _get_list__d9tsa5($this).rv(left, indexValue);
          index = left;
        } else
          break $l$loop_2;
      }
    }
    return value_0;
  }
  function PrioritySet__toString_impl_tq1jgd($this) {
    return 'PrioritySet(list=' + $this.toString() + ')';
  }
  function PrioritySet__hashCode_impl_jjwlpw($this) {
    return $this.hashCode();
  }
  function PrioritySet__equals_impl_fc3ryo($this, other) {
    if (!(other instanceof PrioritySet))
      return false;
    var tmp0_other_with_cast = other.o4c_1;
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function PrioritySet(list) {
    this.o4c_1 = list;
  }
  protoOf(PrioritySet).toString = function () {
    return PrioritySet__toString_impl_tq1jgd(this.o4c_1);
  };
  protoOf(PrioritySet).hashCode = function () {
    return PrioritySet__hashCode_impl_jjwlpw(this.o4c_1);
  };
  protoOf(PrioritySet).equals = function (other) {
    return PrioritySet__equals_impl_fc3ryo(this.o4c_1, other);
  };
  function locationOf(_this__u8e3s4, index, effectiveSize) {
    _init_properties_SlotTable_kt__9b2e7y();
    // Inline function 'kotlin.let' call
    var it = search(_this__u8e3s4, index, effectiveSize);
    return it >= 0 ? it : -(it + 1 | 0) | 0;
  }
  function updateMark(_this__u8e3s4, address, value) {
    _init_properties_SlotTable_kt__9b2e7y();
    var arrayIndex = imul(address, 5) + 1 | 0;
    var element = _this__u8e3s4[arrayIndex];
    var tmp = element & -134217729;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.toBit' call
    _this__u8e3s4[arrayIndex] = tmp | (value ? 1 : 0) << 27;
  }
  function updateContainsMark_0(_this__u8e3s4, address, value) {
    _init_properties_SlotTable_kt__9b2e7y();
    var arrayIndex = imul(address, 5) + 1 | 0;
    var element = _this__u8e3s4[arrayIndex];
    var tmp = element & -67108865;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.toBit' call
    _this__u8e3s4[arrayIndex] = tmp | (value ? 1 : 0) << 26;
  }
  function throwConcurrentModificationException() {
    _init_properties_SlotTable_kt__9b2e7y();
    throw ConcurrentModificationException_init_$Create$();
  }
  function SourceInformationGroupIterator(table, parent, group, path) {
    this.u4d_1 = table;
    this.v4d_1 = parent;
    this.w4d_1 = group;
    this.x4d_1 = path;
    this.y4d_1 = this.u4d_1.p34_1;
    this.z4d_1 = 0;
  }
  protoOf(SourceInformationGroupIterator).u = function () {
    var tmp0_safe_receiver = this.w4d_1.b4c_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.z4d_1 < tmp0_safe_receiver.n1();
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(SourceInformationGroupIterator).v = function () {
    var tmp0_safe_receiver = this.w4d_1.b4c_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var _unary__edvuaz = this.z4d_1;
      this.z4d_1 = _unary__edvuaz + 1 | 0;
      tmp = tmp0_safe_receiver.l1(_unary__edvuaz);
    }
    var group = tmp;
    var tmp_0;
    if (group instanceof GapAnchor) {
      tmp_0 = new SlotTableGroup(this.u4d_1, group.l3o_1, this.y4d_1);
    } else {
      if (group instanceof GapGroupSourceInformation) {
        tmp_0 = new SourceInformationSlotTableGroup(this.u4d_1, this.v4d_1, group, new RelativeGroupPath(this.x4d_1, this.z4d_1 - 1 | 0));
      } else {
        composeRuntimeError('Unexpected group information structure');
      }
    }
    return tmp_0;
  };
  function AnchoredGroupPath(group) {
    SourceInformationGroupPath.call(this);
    this.a4e_1 = group;
  }
  protoOf(AnchoredGroupPath).equals = function (other) {
    var tmp;
    if (other instanceof AnchoredGroupPath) {
      tmp = other.a4e_1 === this.a4e_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AnchoredGroupPath).hashCode = function () {
    return imul(this.a4e_1, 31);
  };
  function SourceInformationGroupPath() {
  }
  function SourceInformationSlotTableGroup(table, parent, sourceInformation, identityPath) {
    this.b4e_1 = table;
    this.c4e_1 = parent;
    this.d4e_1 = sourceInformation;
    this.e4e_1 = identityPath;
    this.f4e_1 = this.d4e_1.y4b_1;
    this.g4e_1 = this;
  }
  protoOf(SourceInformationSlotTableGroup).t = function () {
    return new SourceInformationGroupIterator(this.b4e_1, this.c4e_1, this.d4e_1, this.e4e_1);
  };
  protoOf(SourceInformationSlotTableGroup).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof SourceInformationSlotTableGroup) {
      tmp_1 = other.c4e_1 === this.c4e_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(other.b4e_1, this.b4e_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.e4e_1, this.e4e_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SourceInformationSlotTableGroup).hashCode = function () {
    var result = imul(this.c4e_1, 31) + hashCode(this.b4e_1) | 0;
    result = imul(result, 31) + hashCode(this.e4e_1) | 0;
    return result;
  };
  function RelativeGroupPath(parent, index) {
    SourceInformationGroupPath.call(this);
    this.h4e_1 = parent;
    this.i4e_1 = index;
  }
  protoOf(RelativeGroupPath).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof RelativeGroupPath) {
      tmp_0 = equals(other.h4e_1, this.h4e_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.i4e_1 === this.i4e_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RelativeGroupPath).hashCode = function () {
    return imul(this.i4e_1, 31) + hashCode(this.h4e_1) | 0;
  };
  var properties_initialized_SlotTable_kt_ohxdls;
  function _init_properties_SlotTable_kt__9b2e7y() {
    if (!properties_initialized_SlotTable_kt_ohxdls) {
      properties_initialized_SlotTable_kt_ohxdls = true;
      EmptyLongArray = longArray(0);
      androidx_compose_runtime_composer_gapbuffer_SlotTable$stable = 8;
      androidx_compose_runtime_composer_gapbuffer_GapGroupSourceInformation$stable = 8;
      androidx_compose_runtime_composer_gapbuffer_SlotReader$stable = 8;
      androidx_compose_runtime_composer_gapbuffer_KeyInfo$stable = 8;
      androidx_compose_runtime_composer_gapbuffer_SlotWriter$stable = 8;
      androidx_compose_runtime_composer_gapbuffer_BitVector$stable = 8;
    }
  }
  var androidx_compose_runtime_composer_gapbuffer_changelist_ChangeList$stable;
  function ChangeList() {
    Changes.call(this);
    this.j4e_1 = new Operations();
  }
  protoOf(ChangeList).r = function () {
    return this.j4e_1.r();
  };
  protoOf(ChangeList).c3 = function () {
    this.j4e_1.c3();
  };
  protoOf(ChangeList).s38 = function (slotStorage, applier, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = asGapBufferSlotTable(slotStorage).s35();
    var normalClose = false;
    var tmp;
    try {
      this.s4e(applier, writer, rememberManager, errorContext);
      // Inline function 'kotlin.also' call
      normalClose = true;
      tmp = Unit_instance;
    }finally {
      writer.b36(normalClose);
    }
  };
  protoOf(ChangeList).s4e = function (applier, slots, rememberManager, errorContext) {
    return this.j4e_1.t4e(applier, slots, rememberManager, errorContext);
  };
  protoOf(ChangeList).u4e = function (value) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = Remember_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Remember.Value' call
    Remember_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, value);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).x4e = function (scope) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = RememberPausingScope_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RememberPausingScope.Scope' call
    RememberPausingScope_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, scope);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).y4e = function (scope) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = StartResumingScope_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.StartResumingScope.Scope' call
    StartResumingScope_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, scope);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).z4e = function (scope) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = EndResumingScope_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndResumingScope.Scope' call
    EndResumingScope_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, scope);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).a4f = function (value, groupSlotIndex) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = UpdateValue_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateValue.Value' call
    UpdateValue_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, value);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateValue.GroupSlotIndex' call
    UpdateValue_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53($this$push);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_0 = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value_0) {
        var tmp$ret$8 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa($this$push).d4f(0);
        composeImmediateRuntimeError(tmp$ret$8);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp = $this$with.m4e_1;
    var tmp_0 = $this$with.n4e_1;
    tmp[(tmp_0 - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0) + 0 | 0] = groupSlotIndex;
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).e4f = function (value, anchor, groupSlotIndex) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = UpdateAnchoredValue_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.Value' call
    UpdateAnchoredValue_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.Anchor' call
    UpdateAnchoredValue_getInstance();
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip(1);
    WriteScope__setObjects_impl_utvr6i($this$push, tmp, value, tmp$ret$3, anchor);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.GroupSlotIndex' call
    UpdateAnchoredValue_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53($this$push);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_0 = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value_0) {
        var tmp$ret$9 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa($this$push).d4f(0);
        composeImmediateRuntimeError(tmp$ret$9);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp_0 = $this$with.m4e_1;
    var tmp_1 = $this$with.n4e_1;
    tmp_0[(tmp_1 - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0) + 0 | 0] = groupSlotIndex;
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).f4f = function (anchor, value) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = AppendValue_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AppendValue.Anchor' call
    AppendValue_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AppendValue.Value' call
    AppendValue_getInstance();
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip(1);
    WriteScope__setObjects_impl_utvr6i($this$push, tmp, anchor, tmp$ret$3, value);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).g4f = function (count) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = TrimParentValues_getInstance();
    tmp0.v4e(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.TrimParentValues.Count' call
    TrimParentValues_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53(tmp0_0);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$7 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$7);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp = $this$with.m4e_1;
    var tmp_0 = $this$with.n4e_1;
    tmp[(tmp_0 - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0) + 0 | 0] = count;
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).h4f = function () {
    this.j4e_1.i4f(ResetSlots_getInstance());
  };
  protoOf(ChangeList).j4f = function () {
    this.j4e_1.i4f(DeactivateCurrentGroup_getInstance());
  };
  protoOf(ChangeList).k4f = function (data) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = UpdateAuxData_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAuxData.Data' call
    UpdateAuxData_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, data);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).l4f = function () {
    this.j4e_1.i4f(EnsureRootGroupStarted_getInstance());
  };
  protoOf(ChangeList).m4f = function (anchor) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = EnsureGroupStarted_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EnsureGroupStarted.Anchor' call
    EnsureGroupStarted_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, anchor);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).n4f = function () {
    this.j4e_1.i4f(EndCurrentGroup_getInstance());
  };
  protoOf(ChangeList).o4f = function () {
    this.j4e_1.i4f(SkipToEndOfCurrentGroup_getInstance());
  };
  protoOf(ChangeList).p4f = function () {
    this.j4e_1.i4f(RemoveCurrentGroup_getInstance());
  };
  protoOf(ChangeList).q4f = function (anchor, from) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = InsertSlots_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlots.Anchor' call
    InsertSlots_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlots.FromSlotTable' call
    InsertSlots_getInstance();
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip(1);
    WriteScope__setObjects_impl_utvr6i($this$push, tmp, anchor, tmp$ret$3, from);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).r4f = function (anchor, from, fixups) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = InsertSlotsWithFixups_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.Anchor' call
    InsertSlotsWithFixups_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.FromSlotTable' call
    InsertSlotsWithFixups_getInstance();
    var tmp_0 = _ObjectParameter___init__impl__iyg1ip(1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.Fixups' call
    InsertSlotsWithFixups_getInstance();
    var tmp$ret$4 = _ObjectParameter___init__impl__iyg1ip(2);
    WriteScope__setObjects_impl_utvr6i_0($this$push, tmp, anchor, tmp_0, from, tmp$ret$4, fixups);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).s4f = function (offset) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = MoveCurrentGroup_getInstance();
    tmp0.v4e(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveCurrentGroup.Offset' call
    MoveCurrentGroup_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53(tmp0_0);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$7 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$7);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp = $this$with.m4e_1;
    var tmp_0 = $this$with.n4e_1;
    tmp[(tmp_0 - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0) + 0 | 0] = offset;
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).t4f = function (action, composition) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = EndCompositionScope_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndCompositionScope.Action' call
    EndCompositionScope_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndCompositionScope.Composition' call
    EndCompositionScope_getInstance();
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip(1);
    WriteScope__setObjects_impl_utvr6i($this$push, tmp, action, tmp$ret$3, composition);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).u4f = function (node) {
    if (!(node == null) ? isInterface(node, ComposeNodeLifecycleCallback) : false) {
      this.j4e_1.i4f(UseCurrentNode_getInstance());
    }
  };
  protoOf(ChangeList).v4f = function (value, block) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = UpdateNode_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateNode.Value' call
    UpdateNode_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateNode.Block' call
    UpdateNode_getInstance();
    var tmp_0 = _ObjectParameter___init__impl__iyg1ip(1);
    WriteScope__setObjects_impl_utvr6i($this$push, tmp, value, tmp_0, typeof block === 'function' ? block : THROW_CCE());
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).w4f = function (removeFrom, moveCount) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = RemoveNode_getInstance();
    tmp0.v4e(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RemoveNode.RemoveIndex' call
    RemoveNode_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RemoveNode.Count' call
    RemoveNode_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInts' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53(tmp0_0);
    if (false) {
      var mask = 1 << 0 | 1 << 1;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$8 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(0) + (', ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(1));
        composeImmediateRuntimeError(tmp$ret$8);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp = $this$with.n4e_1;
    var base = tmp - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0;
    var intArgs = $this$with.m4e_1;
    intArgs[base + 0 | 0] = removeFrom;
    intArgs[base + 1 | 0] = moveCount;
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).x4f = function (to, from, count) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = MoveNode_getInstance();
    tmp0.v4e(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.To' call
    MoveNode_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.From' call
    MoveNode_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.Count' call
    MoveNode_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInts' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53(tmp0_0);
    if (false) {
      var mask = 1 << 1 | 1 << 0 | 1 << 2;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$9 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(1) + (', ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(0)) + (', ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(2));
        composeImmediateRuntimeError(tmp$ret$9);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp = $this$with.n4e_1;
    var base = tmp - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0;
    var intArgs = $this$with.m4e_1;
    intArgs[base + 1 | 0] = to;
    intArgs[base + 0 | 0] = from;
    intArgs[base + 2 | 0] = count;
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).y4f = function (distance) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = AdvanceSlotsBy_getInstance();
    tmp0.v4e(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AdvanceSlotsBy.Distance' call
    AdvanceSlotsBy_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53(tmp0_0);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$7 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$7);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp = $this$with.m4e_1;
    var tmp_0 = $this$with.n4e_1;
    tmp[(tmp_0 - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0) + 0 | 0] = distance;
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).z4f = function (count) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = Ups_getInstance();
    tmp0.v4e(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Ups.Count' call
    Ups_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53(tmp0_0);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$7 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa(tmp0_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$7);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp = $this$with.m4e_1;
    var tmp_0 = $this$with.n4e_1;
    tmp[(tmp_0 - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0) + 0 | 0] = count;
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).a4g = function (nodes) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(nodes.length === 0)) {
      var tmp0 = this.j4e_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
      var operation = Downs_getInstance();
      tmp0.v4e(operation);
      var $this$push = _WriteScope___init__impl__4xwato(tmp0);
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Downs.Nodes' call
      Downs_getInstance();
      var tmp$ret$4 = _ObjectParameter___init__impl__iyg1ip(0);
      WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$4, nodes);
      tmp0.w4e(operation);
    }
  };
  protoOf(ChangeList).b4g = function (effect) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = SideEffect_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.SideEffect.Effect' call
    SideEffect_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, effect);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).c4g = function (effectiveNodeIndexOut, anchor) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = DetermineMovableContentNodeIndex_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.DetermineMovableContentNodeIndex.EffectiveNodeIndexOut' call
    DetermineMovableContentNodeIndex_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.DetermineMovableContentNodeIndex.Anchor' call
    DetermineMovableContentNodeIndex_getInstance();
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip(1);
    WriteScope__setObjects_impl_utvr6i($this$push, tmp, effectiveNodeIndexOut, tmp$ret$3, anchor);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).d4g = function (nodes, effectiveNodeIndex) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!nodes.r()) {
      var tmp0 = this.j4e_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
      var operation = CopyNodesToNewAnchorLocation_getInstance();
      tmp0.v4e(operation);
      var $this$push = _WriteScope___init__impl__4xwato(tmp0);
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopyNodesToNewAnchorLocation.Nodes' call
      CopyNodesToNewAnchorLocation_getInstance();
      var tmp = _ObjectParameter___init__impl__iyg1ip(1);
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopyNodesToNewAnchorLocation.EffectiveNodeIndex' call
      CopyNodesToNewAnchorLocation_getInstance();
      var tmp$ret$4 = _ObjectParameter___init__impl__iyg1ip(0);
      WriteScope__setObjects_impl_utvr6i($this$push, tmp, nodes, tmp$ret$4, effectiveNodeIndex);
      tmp0.w4e(operation);
    }
  };
  protoOf(ChangeList).e4g = function (resolvedState, parentContext, from, to) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = CopySlotTableToAnchorLocation_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.ResolvedState' call
    CopySlotTableToAnchorLocation_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.ParentCompositionContext' call
    CopySlotTableToAnchorLocation_getInstance();
    var tmp_0 = _ObjectParameter___init__impl__iyg1ip(1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.To' call
    CopySlotTableToAnchorLocation_getInstance();
    var tmp_1 = _ObjectParameter___init__impl__iyg1ip(3);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.From' call
    CopySlotTableToAnchorLocation_getInstance();
    var tmp$ret$5 = _ObjectParameter___init__impl__iyg1ip(2);
    WriteScope__setObjects_impl_utvr6i_1($this$push, tmp, resolvedState, tmp_0, parentContext, tmp_1, to, tmp$ret$5, from);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).f4g = function (composition, parentContext, reference) {
    var tmp0 = this.j4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = ReleaseMovableGroupAtCurrent_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.Composition' call
    ReleaseMovableGroupAtCurrent_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.ParentCompositionContext' call
    ReleaseMovableGroupAtCurrent_getInstance();
    var tmp_0 = _ObjectParameter___init__impl__iyg1ip(1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.Reference' call
    ReleaseMovableGroupAtCurrent_getInstance();
    var tmp$ret$4 = _ObjectParameter___init__impl__iyg1ip(2);
    WriteScope__setObjects_impl_utvr6i_0($this$push, tmp, composition, tmp_0, parentContext, tmp$ret$4, reference);
    tmp0.w4e(operation);
  };
  protoOf(ChangeList).g4g = function () {
    this.j4e_1.i4f(EndMovableContentPlacement_getInstance());
  };
  protoOf(ChangeList).h4g = function (changeList, effectiveNodeIndex) {
    if (changeList.fv()) {
      var tmp0 = this.j4e_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
      var operation = ApplyChangeList_getInstance();
      tmp0.v4e(operation);
      var $this$push = _WriteScope___init__impl__4xwato(tmp0);
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ApplyChangeList.Changes' call
      ApplyChangeList_getInstance();
      var tmp = _ObjectParameter___init__impl__iyg1ip(0);
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ApplyChangeList.EffectiveNodeIndex' call
      ApplyChangeList_getInstance();
      var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip(1);
      WriteScope__setObjects_impl_utvr6i($this$push, tmp, changeList, tmp$ret$3, effectiveNodeIndex);
      tmp0.w4e(operation);
    }
  };
  function asGapBufferChangeList(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ChangeList ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composition');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  var androidx_compose_runtime_composer_gapbuffer_changelist_ComposerChangeListWriter$stable;
  function _get_reader__fd8dw8($this) {
    return $this.i3i_1.n3h_1;
  }
  function pushApplierOperationPreamble($this) {
    pushPendingUpsAndDowns($this);
  }
  function pushSlotEditingOperationPreamble($this) {
    realizeOperationLocation($this);
    $this.p3n();
  }
  function pushSlotTableOperationPreamble($this, useParentSlot) {
    useParentSlot = useParentSlot === VOID ? false : useParentSlot;
    realizeOperationLocation($this, useParentSlot);
  }
  function ensureRootStarted($this) {
    if (!$this.k3i_1 && $this.m3i_1) {
      pushSlotTableOperationPreamble($this);
      $this.j3i_1.l4f();
      $this.k3i_1 = true;
    }
  }
  function ensureGroupStarted($this, anchor) {
    pushSlotTableOperationPreamble($this);
    $this.j3i_1.m4f(anchor);
    $this.k3i_1 = true;
  }
  function realizeOperationLocation($this, forParent) {
    forParent = forParent === VOID ? false : forParent;
    var location = forParent ? _get_reader__fd8dw8($this).e3j_1 : _get_reader__fd8dw8($this).c3j_1;
    var distance = location - $this.n3i_1 | 0;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(distance >= 0)) {
      var tmp$ret$1 = 'Tried to seek backward';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    if (distance > 0) {
      $this.j3i_1.y4f(distance);
      $this.n3i_1 = location;
    }
  }
  function realizeNodeMovementOperations($this) {
    if ($this.t3i_1 > 0) {
      if ($this.q3i_1 >= 0) {
        realizeRemoveNode($this, $this.q3i_1, $this.t3i_1);
        $this.q3i_1 = -1;
      } else {
        realizeMoveNode($this, $this.s3i_1, $this.r3i_1, $this.t3i_1);
        $this.r3i_1 = -1;
        $this.s3i_1 = -1;
      }
      $this.t3i_1 = 0;
    }
  }
  function realizeRemoveNode($this, removeFrom, moveCount) {
    pushApplierOperationPreamble($this);
    $this.j3i_1.w4f(removeFrom, moveCount);
  }
  function realizeMoveNode($this, to, from, count) {
    pushApplierOperationPreamble($this);
    $this.j3i_1.x4f(to, from, count);
  }
  function pushPendingUpsAndDowns($this) {
    if ($this.o3i_1 > 0) {
      $this.j3i_1.z4f($this.o3i_1);
      $this.o3i_1 = 0;
    }
    if (Stack__isNotEmpty_impl_ua6a9t($this.p3i_1)) {
      $this.j3i_1.a4g(Stack__toArray_impl_ox34cp($this.p3i_1));
      Stack__clear_impl_qoqv3c($this.p3i_1);
    }
  }
  function Companion_9() {
    this.i4g_1 = -2;
  }
  var Companion_instance_10;
  function Companion_getInstance_9() {
    return Companion_instance_10;
  }
  function ComposerChangeListWriter(composer, changeList) {
    this.i3i_1 = composer;
    this.j3i_1 = changeList;
    this.k3i_1 = false;
    this.l3i_1 = new IntStack();
    this.m3i_1 = true;
    this.n3i_1 = 0;
    this.o3i_1 = 0;
    this.p3i_1 = _Stack___init__impl__tvpfn5();
    this.q3i_1 = -1;
    this.r3i_1 = -1;
    this.s3i_1 = -1;
    this.t3i_1 = 0;
  }
  protoOf(ComposerChangeListWriter).x3k = function (location) {
    this.n3i_1 = this.n3i_1 + (location - _get_reader__fd8dw8(this).c3j_1 | 0) | 0;
  };
  protoOf(ComposerChangeListWriter).u3m = function (location) {
    this.n3i_1 = location;
  };
  protoOf(ComposerChangeListWriter).p3n = function () {
    if (_get_reader__fd8dw8(this).n1() > 0) {
      var reader = _get_reader__fd8dw8(this);
      var location = reader.e3j_1;
      if (!(this.l3i_1.z49(-2) === location)) {
        ensureRootStarted(this);
        if (location > 0) {
          var anchor = reader.o3k(location);
          this.l3i_1.g3i(location);
          ensureGroupStarted(this, anchor);
        }
      }
    }
  };
  protoOf(ComposerChangeListWriter).f3o = function () {
    return (_get_reader__fd8dw8(this).e3j_1 - this.n3i_1 | 0) < 0;
  };
  protoOf(ComposerChangeListWriter).h3o = function (value) {
    this.j3i_1.u4e(value);
  };
  protoOf(ComposerChangeListWriter).q3o = function (scope) {
    this.j3i_1.x4e(scope);
  };
  protoOf(ComposerChangeListWriter).j3m = function (scope) {
    this.j3i_1.y4e(scope);
  };
  protoOf(ComposerChangeListWriter).v3o = function (scope) {
    this.j3i_1.z4e(scope);
  };
  protoOf(ComposerChangeListWriter).d3o = function (value, groupSlotIndex) {
    pushSlotTableOperationPreamble(this, true);
    this.j3i_1.a4f(value, groupSlotIndex);
  };
  protoOf(ComposerChangeListWriter).e3o = function (value, anchor, groupSlotIndex) {
    this.j3i_1.e4f(value, anchor, groupSlotIndex);
  };
  protoOf(ComposerChangeListWriter).b3o = function (anchor, value) {
    this.j3i_1.f4f(anchor, value);
  };
  protoOf(ComposerChangeListWriter).k3l = function (count) {
    if (count > 0) {
      pushSlotEditingOperationPreamble(this);
      this.j3i_1.g4f(count);
    }
  };
  protoOf(ComposerChangeListWriter).p3m = function () {
    this.j3i_1.h4f();
  };
  protoOf(ComposerChangeListWriter).v3j = function (data) {
    pushSlotTableOperationPreamble(this);
    this.j3i_1.k4f(data);
  };
  protoOf(ComposerChangeListWriter).u3i = function () {
    if (this.k3i_1) {
      pushSlotTableOperationPreamble(this);
      pushSlotTableOperationPreamble(this);
      this.j3i_1.n4f();
      this.k3i_1 = false;
    }
  };
  protoOf(ComposerChangeListWriter).n3l = function () {
    var location = _get_reader__fd8dw8(this).e3j_1;
    var currentStartedGroup = this.l3i_1.z49(-1);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(currentStartedGroup <= location)) {
      var tmp$ret$1 = 'Missed recording an endGroup';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    if (this.l3i_1.z49(-1) === location) {
      pushSlotTableOperationPreamble(this);
      this.l3i_1.k3j();
      this.j3i_1.n4f();
    }
  };
  protoOf(ComposerChangeListWriter).w3m = function () {
    this.j3i_1.o4f();
  };
  protoOf(ComposerChangeListWriter).d3n = function () {
    pushSlotEditingOperationPreamble(this);
    this.j3i_1.p4f();
    this.n3i_1 = this.n3i_1 + _get_reader__fd8dw8(this).w4b() | 0;
  };
  protoOf(ComposerChangeListWriter).c3n = function (anchor, from) {
    pushPendingUpsAndDowns(this);
    pushSlotEditingOperationPreamble(this);
    realizeNodeMovementOperations(this);
    this.j3i_1.q4f(anchor, from);
  };
  protoOf(ComposerChangeListWriter).b3n = function (anchor, from, fixups) {
    pushPendingUpsAndDowns(this);
    pushSlotEditingOperationPreamble(this);
    realizeNodeMovementOperations(this);
    this.j3i_1.r4f(anchor, from, fixups);
  };
  protoOf(ComposerChangeListWriter).z3k = function (offset) {
    pushSlotEditingOperationPreamble(this);
    this.j3i_1.s4f(offset);
  };
  protoOf(ComposerChangeListWriter).u3o = function (action, composition) {
    this.j3i_1.t4f(action, composition);
  };
  protoOf(ComposerChangeListWriter).x3n = function (node) {
    pushApplierOperationPreamble(this);
    this.j3i_1.u4f(node);
  };
  protoOf(ComposerChangeListWriter).y3n = function (value, block) {
    pushApplierOperationPreamble(this);
    this.j3i_1.v4f(value, block);
  };
  protoOf(ComposerChangeListWriter).c3l = function (nodeIndex, count) {
    if (count > 0) {
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!(nodeIndex >= 0)) {
        var tmp$ret$1 = 'Invalid remove index ' + nodeIndex;
        composeImmediateRuntimeError(tmp$ret$1);
      }
      if (this.q3i_1 === nodeIndex) {
        this.t3i_1 = this.t3i_1 + count | 0;
      } else {
        realizeNodeMovementOperations(this);
        this.q3i_1 = nodeIndex;
        this.t3i_1 = count;
      }
    }
  };
  protoOf(ComposerChangeListWriter).f3l = function (from, to, count) {
    if (count > 0) {
      if (this.t3i_1 > 0 && this.r3i_1 === (from - this.t3i_1 | 0) && this.s3i_1 === (to - this.t3i_1 | 0)) {
        this.t3i_1 = this.t3i_1 + count | 0;
      } else {
        realizeNodeMovementOperations(this);
        this.r3i_1 = from;
        this.s3i_1 = to;
        this.t3i_1 = count;
      }
    }
  };
  protoOf(ComposerChangeListWriter).e3n = function () {
    pushPendingUpsAndDowns(this);
    if (this.k3i_1) {
      this.w3m();
      this.u3i();
    }
  };
  protoOf(ComposerChangeListWriter).h3l = function () {
    realizeNodeMovementOperations(this);
  };
  protoOf(ComposerChangeListWriter).r3n = function (nodeIndex, group) {
    this.h3l();
    pushPendingUpsAndDowns(this);
    var nodeCount = _get_reader__fd8dw8(this).x34(group) ? 1 : _get_reader__fd8dw8(this).b35(group);
    if (nodeCount > 0) {
      this.c3l(nodeIndex, nodeCount);
    }
  };
  protoOf(ComposerChangeListWriter).m3l = function () {
    realizeNodeMovementOperations(this);
    if (Stack__isNotEmpty_impl_ua6a9t(this.p3i_1)) {
      Stack__pop_impl_8s4za4(this.p3i_1);
    } else {
      this.o3i_1 = this.o3i_1 + 1 | 0;
    }
  };
  protoOf(ComposerChangeListWriter).c3m = function (node) {
    realizeNodeMovementOperations(this);
    Stack__push_impl_s8r905(this.p3i_1, node);
  };
  protoOf(ComposerChangeListWriter).i3o = function (effect) {
    this.j3i_1.b4g(effect);
  };
  protoOf(ComposerChangeListWriter).r3m = function (effectiveNodeIndexOut, anchor) {
    pushPendingUpsAndDowns(this);
    this.j3i_1.c4g(effectiveNodeIndexOut, anchor);
  };
  protoOf(ComposerChangeListWriter).s3m = function (nodes, effectiveNodeIndex) {
    this.j3i_1.d4g(nodes, effectiveNodeIndex);
  };
  protoOf(ComposerChangeListWriter).t3m = function (resolvedState, parentContext, from, to) {
    this.j3i_1.e4g(resolvedState, parentContext, from, to);
  };
  protoOf(ComposerChangeListWriter).q3n = function (composition, parentContext, reference) {
    this.j3i_1.f4g(composition, parentContext, reference);
  };
  protoOf(ComposerChangeListWriter).x3m = function () {
    pushPendingUpsAndDowns(this);
    this.j3i_1.g4g();
    this.n3i_1 = 0;
  };
  protoOf(ComposerChangeListWriter).v3m = function (other, effectiveNodeIndex) {
    this.j3i_1.h4g(other, effectiveNodeIndex);
  };
  protoOf(ComposerChangeListWriter).g3n = function () {
    pushPendingUpsAndDowns(this);
    // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.l3i_1.f3i_1 === 0)) {
      var tmp$ret$2 = 'Missed recording an endGroup()';
      composeImmediateRuntimeError(tmp$ret$2);
    }
  };
  protoOf(ComposerChangeListWriter).h3n = function () {
    this.k3i_1 = false;
    this.l3i_1.c3();
    this.n3i_1 = 0;
    this.m3i_1 = true;
    this.o3i_1 = 0;
    Stack__clear_impl_qoqv3c(this.p3i_1);
    this.q3i_1 = -1;
    this.r3i_1 = -1;
    this.s3i_1 = -1;
    this.t3i_1 = 0;
  };
  protoOf(ComposerChangeListWriter).t3o = function () {
    pushSlotTableOperationPreamble(this);
    this.j3i_1.j4f();
  };
  var androidx_compose_runtime_composer_gapbuffer_changelist_FixupList$stable;
  function FixupList() {
    OperationsDebugStringFormattable.call(this);
    this.l3j_1 = new Operations();
    this.m3j_1 = new Operations();
  }
  protoOf(FixupList).r = function () {
    return this.l3j_1.r();
  };
  protoOf(FixupList).c3 = function () {
    this.m3j_1.c3();
    this.l3j_1.c3();
  };
  protoOf(FixupList).j4g = function (applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.m3j_1.r()) {
      var tmp$ret$1 = 'FixupList has pending fixup operations that were not realized. Were there mismatched insertNode() and endNodeInsert() calls?';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.l3j_1.t4e(applier, slots, rememberManager, errorContext);
  };
  protoOf(FixupList).w3n = function (factory, insertIndex, groupAnchor) {
    var tmp0 = this.l3j_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = InsertNodeFixup_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.Factory' call
    InsertNodeFixup_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, factory);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.InsertIndex' call
    InsertNodeFixup_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53($this$push);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$8 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa($this$push).d4f(0);
        composeImmediateRuntimeError(tmp$ret$8);
      }
      access$_set_pushedIntMask__hk28ql($this$with, access$_get_pushedIntMask__wrtr8x($this$with) | mask);
    }
    var tmp = $this$with.m4e_1;
    var tmp_0 = $this$with.n4e_1;
    tmp[(tmp_0 - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].b4f_1 | 0) + 0 | 0] = insertIndex;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.GroupAnchor' call
    InsertNodeFixup_getInstance();
    var tmp$ret$11 = _ObjectParameter___init__impl__iyg1ip(1);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$11, groupAnchor);
    tmp0.w4e(operation);
    var tmp0_0 = this.m3j_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation_0 = PostInsertNodeFixup_getInstance();
    tmp0_0.v4e(operation_0);
    var $this$push_0 = _WriteScope___init__impl__4xwato(tmp0_0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.PostInsertNodeFixup.InsertIndex' call
    PostInsertNodeFixup_getInstance();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with_0 = access$_get_stack__7szo53($this$push_0);
    if (false) {
      var mask_0 = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_0 = (access$_get_pushedIntMask__wrtr8x($this$with_0) & mask_0) === 0;
      if (false && !value_0) {
        var tmp$ret$19 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa($this$push_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$19);
      }
      access$_set_pushedIntMask__hk28ql($this$with_0, access$_get_pushedIntMask__wrtr8x($this$with_0) | mask_0);
    }
    var tmp_1 = $this$with_0.m4e_1;
    var tmp_2 = $this$with_0.n4e_1;
    tmp_1[(tmp_2 - $this$with_0.k4e_1[$this$with_0.l4e_1 - 1 | 0].b4f_1 | 0) + 0 | 0] = insertIndex;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.PostInsertNodeFixup.GroupAnchor' call
    PostInsertNodeFixup_getInstance();
    var tmp$ret$22 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push_0, tmp$ret$22, groupAnchor);
    tmp0_0.w4e(operation_0);
  };
  protoOf(FixupList).p3l = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.m3j_1.fv()) {
      var tmp$ret$1 = 'Cannot end node insertion, there are no pending operations that can be realized.';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.m3j_1.k4g(this.l3j_1);
  };
  protoOf(FixupList).z3n = function (value, block) {
    var tmp0 = this.l3j_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.push' call
    var operation = UpdateNode_getInstance();
    tmp0.v4e(operation);
    var $this$push = _WriteScope___init__impl__4xwato(tmp0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateNode.Value' call
    UpdateNode_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(0);
    WriteScope__setObject_impl_rr41y9($this$push, tmp$ret$2, value);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateNode.Block' call
    UpdateNode_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip(1);
    WriteScope__setObject_impl_rr41y9($this$push, tmp, typeof block === 'function' ? block : THROW_CCE());
    tmp0.w4e(operation);
  };
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_Ups$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_Downs$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_AdvanceSlotsBy$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_SideEffect$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_Remember$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_RememberPausingScope$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_StartResumingScope$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EndResumingScope$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_AppendValue$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_TrimParentValues$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UpdateValue$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UpdateAnchoredValue$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UpdateAuxData$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EnsureRootGroupStarted$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EnsureGroupStarted$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_RemoveCurrentGroup$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_MoveCurrentGroup$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EndCurrentGroup$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_SkipToEndOfCurrentGroup$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EndCompositionScope$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UseCurrentNode$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UpdateNode$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_RemoveNode$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_MoveNode$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_InsertSlots$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_InsertSlotsWithFixups$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_InsertNodeFixup$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_PostInsertNodeFixup$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_DeactivateCurrentGroup$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_ResetSlots$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_DetermineMovableContentNodeIndex$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_CopyNodesToNewAnchorLocation$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_CopySlotTableToAnchorLocation$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EndMovableContentPlacement$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_ReleaseMovableGroupAtCurrent$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_ApplyChangeList$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation_TestOperation$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operation$stable;
  function _ObjectParameter___init__impl__iyg1ip(offset) {
    return offset;
  }
  function _ObjectParameter___get_offset__impl__x7fx93($this) {
    return $this;
  }
  function Ups() {
    Ups_instance = this;
    Operation.call(this, 1);
  }
  protoOf(Ups).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Ups.Count' call
    if (parameter === 0) {
      tmp = 'count';
    } else {
      tmp = protoOf(Operation).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(Ups).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Ups.Count' call
    // Inline function 'kotlin.repeat' call
    var times = _this__u8e3s4.o4g(0);
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        applier.i2y();
      }
       while (inductionVariable < times);
  };
  var Ups_instance;
  function Ups_getInstance() {
    if (Ups_instance == null)
      new Ups();
    return Ups_instance;
  }
  function Downs() {
    Downs_instance = this;
    Operation.call(this, VOID, 1);
  }
  protoOf(Downs).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Downs.Nodes' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'nodes';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(Downs).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Downs.Nodes' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var nodes = _this__u8e3s4.u4g(tmp$ret$0);
    var inductionVariable = 0;
    var last = nodes.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        nodeApplier.h2y(nodes[index]);
      }
       while (inductionVariable <= last);
  };
  var Downs_instance;
  function Downs_getInstance() {
    if (Downs_instance == null)
      new Downs();
    return Downs_instance;
  }
  function AdvanceSlotsBy() {
    AdvanceSlotsBy_instance = this;
    Operation.call(this, 1);
  }
  protoOf(AdvanceSlotsBy).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AdvanceSlotsBy.Distance' call
    if (parameter === 0) {
      tmp = 'distance';
    } else {
      tmp = protoOf(Operation).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(AdvanceSlotsBy).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AdvanceSlotsBy.Distance' call
    slots.u4b(_this__u8e3s4.o4g(0));
  };
  var AdvanceSlotsBy_instance;
  function AdvanceSlotsBy_getInstance() {
    if (AdvanceSlotsBy_instance == null)
      new AdvanceSlotsBy();
    return AdvanceSlotsBy_instance;
  }
  function SideEffect_0() {
    SideEffect_instance = this;
    Operation.call(this, VOID, 1);
  }
  protoOf(SideEffect_0).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.SideEffect.Effect' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'effect';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(SideEffect_0).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.SideEffect.Effect' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    rememberManager.i3o(_this__u8e3s4.u4g(tmp$ret$0));
  };
  var SideEffect_instance;
  function SideEffect_getInstance() {
    if (SideEffect_instance == null)
      new SideEffect_0();
    return SideEffect_instance;
  }
  function Remember() {
    Remember_instance = this;
    Operation.call(this, VOID, 1);
  }
  protoOf(Remember).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Remember.Value' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'value';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(Remember).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Remember.Value' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    rememberManager.o4b(_this__u8e3s4.u4g(tmp$ret$0));
  };
  var Remember_instance;
  function Remember_getInstance() {
    if (Remember_instance == null)
      new Remember();
    return Remember_instance;
  }
  function RememberPausingScope() {
    RememberPausingScope_instance = this;
    Operation.call(this, VOID, 1);
  }
  protoOf(RememberPausingScope).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RememberPausingScope.Scope' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'scope';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(RememberPausingScope).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RememberPausingScope.Scope' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var scope = _this__u8e3s4.u4g(tmp$ret$0);
    rememberManager.q3o(scope);
  };
  var RememberPausingScope_instance;
  function RememberPausingScope_getInstance() {
    if (RememberPausingScope_instance == null)
      new RememberPausingScope();
    return RememberPausingScope_instance;
  }
  function StartResumingScope() {
    StartResumingScope_instance = this;
    Operation.call(this, VOID, 1);
  }
  protoOf(StartResumingScope).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.StartResumingScope.Scope' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'scope';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(StartResumingScope).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.StartResumingScope.Scope' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var scope = _this__u8e3s4.u4g(tmp$ret$0);
    rememberManager.j3m(scope);
  };
  var StartResumingScope_instance;
  function StartResumingScope_getInstance() {
    if (StartResumingScope_instance == null)
      new StartResumingScope();
    return StartResumingScope_instance;
  }
  function EndResumingScope() {
    EndResumingScope_instance = this;
    Operation.call(this, VOID, 1);
  }
  protoOf(EndResumingScope).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndResumingScope.Scope' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'scope';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(EndResumingScope).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndResumingScope.Scope' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var scope = _this__u8e3s4.u4g(tmp$ret$0);
    rememberManager.v3o(scope);
  };
  var EndResumingScope_instance;
  function EndResumingScope_getInstance() {
    if (EndResumingScope_instance == null)
      new EndResumingScope();
    return EndResumingScope_instance;
  }
  function AppendValue() {
    AppendValue_instance = this;
    Operation.call(this, VOID, 2);
  }
  protoOf(AppendValue).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AppendValue.Anchor' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'anchor';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AppendValue.Value' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'value';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(AppendValue).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AppendValue.Anchor' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var anchor = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.AppendValue.Value' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(1);
    var value = _this__u8e3s4.u4g(tmp$ret$1);
    if (!(value == null) ? isInterface(value, RememberObserverHolder) : false) {
      rememberManager.o4b(value);
    }
    slots.v4c(anchor, value);
  };
  var AppendValue_instance;
  function AppendValue_getInstance() {
    if (AppendValue_instance == null)
      new AppendValue();
    return AppendValue_instance;
  }
  function TrimParentValues() {
    TrimParentValues_instance = this;
    Operation.call(this, 1);
  }
  protoOf(TrimParentValues).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.TrimParentValues.Count' call
    if (parameter === 0) {
      tmp = 'count';
    } else {
      tmp = protoOf(Operation).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(TrimParentValues).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.TrimParentValues.Count' call
    var count = _this__u8e3s4.o4g(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotWriter.forEachTailSlot' call
    var groupIndex = slots.d34_1;
    var slotsStart = slots.d4d(groupIndex);
    var slotsEnd = slots.e4d(groupIndex);
    // Inline function 'kotlin.math.max' call
    var b = slotsEnd - count | 0;
    var inductionVariable = Math.max(slotsStart, b);
    if (inductionVariable < slotsEnd)
      do {
        var slotIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var value = access$_get_slots__7x4q9w(slots)[access$dataIndexToDataAddress(slots, slotIndex)];
        if (!(value == null) ? isInterface(value, RememberObserverHolder) : false) {
          rememberManager.f36(value);
        } else {
          if (value instanceof RecomposeScopeImpl) {
            value.r2v();
          }
        }
      }
       while (inductionVariable < slotsEnd);
    slots.w4c(count);
  };
  var TrimParentValues_instance;
  function TrimParentValues_getInstance() {
    if (TrimParentValues_instance == null)
      new TrimParentValues();
    return TrimParentValues_instance;
  }
  function UpdateValue() {
    UpdateValue_instance = this;
    Operation.call(this, 1, 1);
  }
  protoOf(UpdateValue).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateValue.GroupSlotIndex' call
    if (parameter === 0) {
      tmp = 'groupSlotIndex';
    } else {
      tmp = protoOf(Operation).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(UpdateValue).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateValue.Value' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'value';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(UpdateValue).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateValue.Value' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var value = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateValue.GroupSlotIndex' call
    var groupSlotIndex = _this__u8e3s4.o4g(0);
    if (!(value == null) ? isInterface(value, RememberObserverHolder) : false) {
      rememberManager.o4b(value);
    }
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotWriter.set' call
    var previous = slots.b4d(slots.b34_1, groupSlotIndex, value);
    if (!(previous == null) ? isInterface(previous, RememberObserverHolder) : false) {
      rememberManager.f36(previous);
    } else {
      if (previous instanceof RecomposeScopeImpl) {
        previous.r2v();
      }
    }
  };
  var UpdateValue_instance;
  function UpdateValue_getInstance() {
    if (UpdateValue_instance == null)
      new UpdateValue();
    return UpdateValue_instance;
  }
  function UpdateAnchoredValue() {
    UpdateAnchoredValue_instance = this;
    Operation.call(this, 1, 2);
  }
  protoOf(UpdateAnchoredValue).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.GroupSlotIndex' call
    if (parameter === 0) {
      tmp = 'groupSlotIndex';
    } else {
      tmp = protoOf(Operation).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(UpdateAnchoredValue).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.Value' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'value';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.Anchor' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'anchor';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(UpdateAnchoredValue).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.Value' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var value = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.Anchor' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(1);
    var anchor = _this__u8e3s4.u4g(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAnchoredValue.GroupSlotIndex' call
    var groupSlotIndex = _this__u8e3s4.o4g(0);
    if (!(value == null) ? isInterface(value, RememberObserverHolder) : false) {
      rememberManager.o4b(value);
    }
    var groupIndex = slots.q3m(anchor);
    var previous = slots.b4d(groupIndex, groupSlotIndex, value);
    if (!(previous == null) ? isInterface(previous, RememberObserverHolder) : false) {
      rememberManager.f36(previous);
    } else {
      if (previous instanceof RecomposeScopeImpl) {
        previous.r2v();
      }
    }
  };
  var UpdateAnchoredValue_instance;
  function UpdateAnchoredValue_getInstance() {
    if (UpdateAnchoredValue_instance == null)
      new UpdateAnchoredValue();
    return UpdateAnchoredValue_instance;
  }
  function UpdateAuxData() {
    UpdateAuxData_instance = this;
    Operation.call(this, VOID, 1);
  }
  protoOf(UpdateAuxData).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAuxData.Data' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'data';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(UpdateAuxData).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateAuxData.Data' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    slots.m4c(_this__u8e3s4.u4g(tmp$ret$0));
  };
  var UpdateAuxData_instance;
  function UpdateAuxData_getInstance() {
    if (UpdateAuxData_instance == null)
      new UpdateAuxData();
    return UpdateAuxData_instance;
  }
  function EnsureRootGroupStarted() {
    EnsureRootGroupStarted_instance = this;
    Operation.call(this);
  }
  protoOf(EnsureRootGroupStarted).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    slots.g4d(0);
  };
  var EnsureRootGroupStarted_instance;
  function EnsureRootGroupStarted_getInstance() {
    if (EnsureRootGroupStarted_instance == null)
      new EnsureRootGroupStarted();
    return EnsureRootGroupStarted_instance;
  }
  function EnsureGroupStarted() {
    EnsureGroupStarted_instance = this;
    Operation.call(this, VOID, 1);
  }
  protoOf(EnsureGroupStarted).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EnsureGroupStarted.Anchor' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'anchor';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(EnsureGroupStarted).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EnsureGroupStarted.Anchor' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    slots.h4d(_this__u8e3s4.u4g(tmp$ret$0));
  };
  var EnsureGroupStarted_instance;
  function EnsureGroupStarted_getInstance() {
    if (EnsureGroupStarted_instance == null)
      new EnsureGroupStarted();
    return EnsureGroupStarted_instance;
  }
  function RemoveCurrentGroup() {
    RemoveCurrentGroup_instance = this;
    Operation.call(this);
  }
  protoOf(RemoveCurrentGroup).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    removeCurrentGroup(slots, rememberManager);
  };
  var RemoveCurrentGroup_instance;
  function RemoveCurrentGroup_getInstance() {
    if (RemoveCurrentGroup_instance == null)
      new RemoveCurrentGroup();
    return RemoveCurrentGroup_instance;
  }
  function MoveCurrentGroup() {
    MoveCurrentGroup_instance = this;
    Operation.call(this, 1);
  }
  protoOf(MoveCurrentGroup).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveCurrentGroup.Offset' call
    if (parameter === 0) {
      tmp = 'offset';
    } else {
      tmp = protoOf(Operation).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(MoveCurrentGroup).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveCurrentGroup.Offset' call
    slots.k3w(_this__u8e3s4.o4g(0));
  };
  var MoveCurrentGroup_instance;
  function MoveCurrentGroup_getInstance() {
    if (MoveCurrentGroup_instance == null)
      new MoveCurrentGroup();
    return MoveCurrentGroup_instance;
  }
  function EndCurrentGroup() {
    EndCurrentGroup_instance = this;
    Operation.call(this);
  }
  protoOf(EndCurrentGroup).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    slots.z35();
  };
  var EndCurrentGroup_instance;
  function EndCurrentGroup_getInstance() {
    if (EndCurrentGroup_instance == null)
      new EndCurrentGroup();
    return EndCurrentGroup_instance;
  }
  function SkipToEndOfCurrentGroup() {
    SkipToEndOfCurrentGroup_instance = this;
    Operation.call(this);
  }
  protoOf(SkipToEndOfCurrentGroup).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    slots.z30();
  };
  var SkipToEndOfCurrentGroup_instance;
  function SkipToEndOfCurrentGroup_getInstance() {
    if (SkipToEndOfCurrentGroup_instance == null)
      new SkipToEndOfCurrentGroup();
    return SkipToEndOfCurrentGroup_instance;
  }
  function EndCompositionScope() {
    EndCompositionScope_instance = this;
    Operation.call(this, VOID, 2);
  }
  protoOf(EndCompositionScope).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndCompositionScope.Action' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'anchor';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndCompositionScope.Composition' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'composition';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(EndCompositionScope).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndCompositionScope.Action' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var action = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.EndCompositionScope.Composition' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(1);
    var composition = _this__u8e3s4.u4g(tmp$ret$1);
    action(composition);
  };
  var EndCompositionScope_instance;
  function EndCompositionScope_getInstance() {
    if (EndCompositionScope_instance == null)
      new EndCompositionScope();
    return EndCompositionScope_instance;
  }
  function UseCurrentNode() {
    UseCurrentNode_instance = this;
    Operation.call(this);
  }
  protoOf(UseCurrentNode).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    applier.o2y();
  };
  var UseCurrentNode_instance;
  function UseCurrentNode_getInstance() {
    if (UseCurrentNode_instance == null)
      new UseCurrentNode();
    return UseCurrentNode_instance;
  }
  function UpdateNode() {
    UpdateNode_instance = this;
    Operation.call(this, VOID, 2);
  }
  protoOf(UpdateNode).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateNode.Value' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'value';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateNode.Block' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'block';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(UpdateNode).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateNode.Value' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var value = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.UpdateNode.Block' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(1);
    var block = _this__u8e3s4.u4g(tmp$ret$1);
    applier.n2y(block, value);
  };
  var UpdateNode_instance;
  function UpdateNode_getInstance() {
    if (UpdateNode_instance == null)
      new UpdateNode();
    return UpdateNode_instance;
  }
  function RemoveNode() {
    RemoveNode_instance = this;
    Operation.call(this, 2);
  }
  protoOf(RemoveNode).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RemoveNode.RemoveIndex' call
    if (parameter === 0) {
      tmp = 'removeIndex';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RemoveNode.Count' call
      if (parameter === 1) {
        tmp = 'count';
      } else {
        tmp = protoOf(Operation).d4f.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(RemoveNode).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RemoveNode.RemoveIndex' call
    var tmp = _this__u8e3s4.o4g(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.RemoveNode.Count' call
    applier.l2y(tmp, _this__u8e3s4.o4g(1));
  };
  var RemoveNode_instance;
  function RemoveNode_getInstance() {
    if (RemoveNode_instance == null)
      new RemoveNode();
    return RemoveNode_instance;
  }
  function MoveNode() {
    MoveNode_instance = this;
    Operation.call(this, 3);
  }
  protoOf(MoveNode).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.From' call
    if (parameter === 0) {
      tmp = 'from';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.To' call
      if (parameter === 1) {
        tmp = 'to';
      } else {
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.Count' call
        if (parameter === 2) {
          tmp = 'count';
        } else {
          tmp = protoOf(Operation).d4f.call(this, parameter);
        }
      }
    }
    return tmp;
  };
  protoOf(MoveNode).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.From' call
    var tmp = _this__u8e3s4.o4g(0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.To' call
    var tmp_0 = _this__u8e3s4.o4g(1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.MoveNode.Count' call
    applier.m2y(tmp, tmp_0, _this__u8e3s4.o4g(2));
  };
  var MoveNode_instance;
  function MoveNode_getInstance() {
    if (MoveNode_instance == null)
      new MoveNode();
    return MoveNode_instance;
  }
  function InsertSlots() {
    InsertSlots_instance = this;
    Operation.call(this, VOID, 2);
  }
  protoOf(InsertSlots).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlots.Anchor' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'anchor';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlots.FromSlotTable' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'from';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(InsertSlots).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlots.FromSlotTable' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(1);
    var insertTable = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlots.Anchor' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(0);
    var anchor = _this__u8e3s4.u4g(tmp$ret$1);
    slots.t35();
    slots.k4d(insertTable, anchor.m3o(insertTable), false);
    slots.a36();
  };
  var InsertSlots_instance;
  function InsertSlots_getInstance() {
    if (InsertSlots_instance == null)
      new InsertSlots();
    return InsertSlots_instance;
  }
  function InsertSlotsWithFixups() {
    InsertSlotsWithFixups_instance = this;
    Operation.call(this, VOID, 3);
  }
  protoOf(InsertSlotsWithFixups).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.Anchor' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'anchor';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.FromSlotTable' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'from';
      } else {
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.Fixups' call
        if (parameter === _ObjectParameter___init__impl__iyg1ip(2)) {
          tmp = 'fixups';
        } else {
          tmp = protoOf(Operation).r4g.call(this, parameter);
        }
      }
    }
    return tmp;
  };
  protoOf(InsertSlotsWithFixups).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.FromSlotTable' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(1);
    var insertTable = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.Anchor' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(0);
    var anchor = _this__u8e3s4.u4g(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertSlotsWithFixups.Fixups' call
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(2);
    var fixups = _this__u8e3s4.u4g(tmp$ret$2);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.write' call
    // Inline function 'kotlin.let' call
    var writer = insertTable.s35();
    var normalClose = false;
    var tmp;
    try {
      fixups.j4g(applier, writer, rememberManager, errorContext == null ? null : withCurrentStackTrace(errorContext, slots));
      // Inline function 'kotlin.also' call
      normalClose = true;
      tmp = Unit_instance;
    }finally {
      writer.b36(normalClose);
    }
    slots.t35();
    slots.k4d(insertTable, anchor.m3o(insertTable), false);
    slots.a36();
  };
  var InsertSlotsWithFixups_instance;
  function InsertSlotsWithFixups_getInstance() {
    if (InsertSlotsWithFixups_instance == null)
      new InsertSlotsWithFixups();
    return InsertSlotsWithFixups_instance;
  }
  function InsertNodeFixup() {
    InsertNodeFixup_instance = this;
    Operation.call(this, 1, 2);
  }
  protoOf(InsertNodeFixup).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.InsertIndex' call
    if (parameter === 0) {
      tmp = 'insertIndex';
    } else {
      tmp = protoOf(Operation).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(InsertNodeFixup).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.Factory' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'factory';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.GroupAnchor' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'groupAnchor';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(InsertNodeFixup).q4g = function (_this__u8e3s4, slots) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.GroupAnchor' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(1);
    return _this__u8e3s4.u4g(tmp$ret$0);
  };
  protoOf(InsertNodeFixup).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.Factory' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var node = _this__u8e3s4.u4g(tmp$ret$0)();
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.GroupAnchor' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(1);
    var groupAnchor = _this__u8e3s4.u4g(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.InsertNodeFixup.InsertIndex' call
    var insertIndex = _this__u8e3s4.o4g(0);
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    slots.z4c(groupAnchor, node);
    nodeApplier.j2y(insertIndex, node);
    nodeApplier.h2y(node);
  };
  var InsertNodeFixup_instance;
  function InsertNodeFixup_getInstance() {
    if (InsertNodeFixup_instance == null)
      new InsertNodeFixup();
    return InsertNodeFixup_instance;
  }
  function PostInsertNodeFixup() {
    PostInsertNodeFixup_instance = this;
    Operation.call(this, 1, 1);
  }
  protoOf(PostInsertNodeFixup).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.PostInsertNodeFixup.InsertIndex' call
    if (parameter === 0) {
      tmp = 'insertIndex';
    } else {
      tmp = protoOf(Operation).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(PostInsertNodeFixup).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.PostInsertNodeFixup.GroupAnchor' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'groupAnchor';
    } else {
      tmp = protoOf(Operation).r4g.call(this, parameter);
    }
    return tmp;
  };
  protoOf(PostInsertNodeFixup).q4g = function (_this__u8e3s4, slots) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.PostInsertNodeFixup.GroupAnchor' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    return _this__u8e3s4.u4g(tmp$ret$0);
  };
  protoOf(PostInsertNodeFixup).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.PostInsertNodeFixup.GroupAnchor' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var groupAnchor = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.PostInsertNodeFixup.InsertIndex' call
    var insertIndex = _this__u8e3s4.o4g(0);
    applier.i2y();
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    var nodeToInsert = slots.t4c(groupAnchor);
    nodeApplier.k2y(insertIndex, nodeToInsert);
  };
  var PostInsertNodeFixup_instance;
  function PostInsertNodeFixup_getInstance() {
    if (PostInsertNodeFixup_instance == null)
      new PostInsertNodeFixup();
    return PostInsertNodeFixup_instance;
  }
  function DeactivateCurrentGroup() {
    DeactivateCurrentGroup_instance = this;
    Operation.call(this);
  }
  protoOf(DeactivateCurrentGroup).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    deactivateCurrentGroup(slots, rememberManager);
  };
  var DeactivateCurrentGroup_instance;
  function DeactivateCurrentGroup_getInstance() {
    if (DeactivateCurrentGroup_instance == null)
      new DeactivateCurrentGroup();
    return DeactivateCurrentGroup_instance;
  }
  function ResetSlots() {
    ResetSlots_instance = this;
    Operation.call(this);
  }
  protoOf(ResetSlots).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    slots.u4c();
  };
  var ResetSlots_instance;
  function ResetSlots_getInstance() {
    if (ResetSlots_instance == null)
      new ResetSlots();
    return ResetSlots_instance;
  }
  function DetermineMovableContentNodeIndex() {
    DetermineMovableContentNodeIndex_instance = this;
    Operation.call(this, VOID, 2);
  }
  protoOf(DetermineMovableContentNodeIndex).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.DetermineMovableContentNodeIndex.EffectiveNodeIndexOut' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'effectiveNodeIndexOut';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.DetermineMovableContentNodeIndex.Anchor' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'anchor';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(DetermineMovableContentNodeIndex).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.DetermineMovableContentNodeIndex.EffectiveNodeIndexOut' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var effectiveNodeIndexOut = _this__u8e3s4.u4g(tmp$ret$0);
    var tmp = effectiveNodeIndexOut;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.DetermineMovableContentNodeIndex.Anchor' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(1);
    var tmp_0 = _this__u8e3s4.u4g(tmp$ret$1);
    tmp.s3e_1 = positionToInsert(slots, tmp_0, isInterface(applier, Applier) ? applier : THROW_CCE());
  };
  var DetermineMovableContentNodeIndex_instance;
  function DetermineMovableContentNodeIndex_getInstance() {
    if (DetermineMovableContentNodeIndex_instance == null)
      new DetermineMovableContentNodeIndex();
    return DetermineMovableContentNodeIndex_instance;
  }
  function CopyNodesToNewAnchorLocation() {
    CopyNodesToNewAnchorLocation_instance = this;
    Operation.call(this, VOID, 2);
  }
  protoOf(CopyNodesToNewAnchorLocation).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopyNodesToNewAnchorLocation.EffectiveNodeIndex' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'effectiveNodeIndex';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopyNodesToNewAnchorLocation.Nodes' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'nodes';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(CopyNodesToNewAnchorLocation).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopyNodesToNewAnchorLocation.EffectiveNodeIndex' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var effectiveNodeIndex = _this__u8e3s4.u4g(tmp$ret$0).s3e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopyNodesToNewAnchorLocation.Nodes' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(1);
    var nodesToInsert = _this__u8e3s4.u4g(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.snapshots.fastForEachIndexed' call
    var inductionVariable = 0;
    var last = nodesToInsert.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = nodesToInsert.l1(index);
        if (!isInterface(applier, Applier))
          THROW_CCE();
        applier.k2y(effectiveNodeIndex + index | 0, item);
        applier.j2y(effectiveNodeIndex + index | 0, item);
      }
       while (inductionVariable <= last);
  };
  var CopyNodesToNewAnchorLocation_instance;
  function CopyNodesToNewAnchorLocation_getInstance() {
    if (CopyNodesToNewAnchorLocation_instance == null)
      new CopyNodesToNewAnchorLocation();
    return CopyNodesToNewAnchorLocation_instance;
  }
  function CopySlotTableToAnchorLocation() {
    CopySlotTableToAnchorLocation_instance = this;
    Operation.call(this, VOID, 4);
  }
  protoOf(CopySlotTableToAnchorLocation).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.ResolvedState' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'resolvedState';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.ParentCompositionContext' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'resolvedCompositionContext';
      } else {
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.From' call
        if (parameter === _ObjectParameter___init__impl__iyg1ip(2)) {
          tmp = 'from';
        } else {
          // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.To' call
          if (parameter === _ObjectParameter___init__impl__iyg1ip(3)) {
            tmp = 'to';
          } else {
            tmp = protoOf(Operation).r4g.call(this, parameter);
          }
        }
      }
    }
    return tmp;
  };
  protoOf(CopySlotTableToAnchorLocation).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.From' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(2);
    var from = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.To' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(3);
    var to = _this__u8e3s4.u4g(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.ParentCompositionContext' call
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(1);
    var parentCompositionContext = _this__u8e3s4.u4g(tmp$ret$2);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.CopySlotTableToAnchorLocation.ResolvedState' call
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip(0);
    var tmp0_elvis_lhs = _this__u8e3s4.u4g(tmp$ret$3);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? parentCompositionContext.d3c(from) : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      composeRuntimeError('Could not resolve state for movable content');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var resolvedState = tmp;
    var anchors = slots.l4d(1, asGapBufferSlotTable(resolvedState.u3a_1), 2);
    var tmp_0 = Companion_instance_6;
    var tmp_1 = to.e35_1;
    tmp_0.c36(slots, anchors, isInterface(tmp_1, RecomposeScopeOwner) ? tmp_1 : THROW_CCE());
  };
  var CopySlotTableToAnchorLocation_instance;
  function CopySlotTableToAnchorLocation_getInstance() {
    if (CopySlotTableToAnchorLocation_instance == null)
      new CopySlotTableToAnchorLocation();
    return CopySlotTableToAnchorLocation_instance;
  }
  function EndMovableContentPlacement() {
    EndMovableContentPlacement_instance = this;
    Operation.call(this);
  }
  protoOf(EndMovableContentPlacement).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    positionToParentOf(slots, isInterface(applier, Applier) ? applier : THROW_CCE(), 0);
    slots.z35();
  };
  var EndMovableContentPlacement_instance;
  function EndMovableContentPlacement_getInstance() {
    if (EndMovableContentPlacement_instance == null)
      new EndMovableContentPlacement();
    return EndMovableContentPlacement_instance;
  }
  function ReleaseMovableGroupAtCurrent() {
    ReleaseMovableGroupAtCurrent_instance = this;
    Operation.call(this, VOID, 3);
  }
  protoOf(ReleaseMovableGroupAtCurrent).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.Composition' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'composition';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.ParentCompositionContext' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'parentCompositionContext';
      } else {
        // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.Reference' call
        if (parameter === _ObjectParameter___init__impl__iyg1ip(2)) {
          tmp = 'reference';
        } else {
          tmp = protoOf(Operation).r4g.call(this, parameter);
        }
      }
    }
    return tmp;
  };
  protoOf(ReleaseMovableGroupAtCurrent).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.Composition' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(0);
    var composition = _this__u8e3s4.u4g(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.Reference' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(2);
    var reference = _this__u8e3s4.u4g(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ReleaseMovableGroupAtCurrent.ParentCompositionContext' call
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip(1);
    var parentContext = _this__u8e3s4.u4g(tmp$ret$2);
    var state = extractMovableContentAtCurrent(composition, reference, slots, null);
    parentContext.c3c(reference, state, applier);
  };
  var ReleaseMovableGroupAtCurrent_instance;
  function ReleaseMovableGroupAtCurrent_getInstance() {
    if (ReleaseMovableGroupAtCurrent_instance == null)
      new ReleaseMovableGroupAtCurrent();
    return ReleaseMovableGroupAtCurrent_instance;
  }
  function ApplyChangeList() {
    ApplyChangeList_instance = this;
    Operation.call(this, VOID, 2);
  }
  protoOf(ApplyChangeList).r4g = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ApplyChangeList.Changes' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip(0)) {
      tmp = 'changes';
    } else {
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ApplyChangeList.EffectiveNodeIndex' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip(1)) {
        tmp = 'effectiveNodeIndex';
      } else {
        tmp = protoOf(Operation).r4g.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(ApplyChangeList).n4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ApplyChangeList.EffectiveNodeIndex' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip(1);
    var tmp0_safe_receiver = _this__u8e3s4.u4g(tmp$ret$0);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s3e_1;
    var effectiveNodeIndex = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.ApplyChangeList.Changes' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip(0);
    var tmp = _this__u8e3s4.u4g(tmp$ret$1);
    var tmp_0;
    if (effectiveNodeIndex > 0) {
      tmp_0 = new OffsetApplier(applier, effectiveNodeIndex);
    } else {
      tmp_0 = applier;
    }
    var tmp_1 = tmp_0;
    tmp.s4e(tmp_1, slots, rememberManager, errorContext == null ? null : withCurrentStackTrace(errorContext, slots));
  };
  var ApplyChangeList_instance;
  function ApplyChangeList_getInstance() {
    if (ApplyChangeList_instance == null)
      new ApplyChangeList();
    return ApplyChangeList_instance;
  }
  function Operation(ints, objects) {
    ints = ints === VOID ? 0 : ints;
    objects = objects === VOID ? 0 : objects;
    this.b4f_1 = ints;
    this.c4f_1 = objects;
  }
  protoOf(Operation).m = function () {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = getKClassFromExpression(this).o();
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(Operation).p4g = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.withCurrentStackTrace' call
    var location = this.q4g(_this__u8e3s4, slots);
    try {
      this.n4g(_this__u8e3s4, applier, slots, rememberManager, errorContext);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw attachComposeStackTrace(e, errorContext, slots, location);
      } else {
        throw $p;
      }
    }
  };
  protoOf(Operation).q4g = function (_this__u8e3s4, slots) {
    return null;
  };
  protoOf(Operation).d4f = function (parameter) {
    return 'IntParameter(' + parameter + ')';
  };
  protoOf(Operation).r4g = function (parameter) {
    return 'ObjectParameter(' + _ObjectParameter___get_offset__impl__x7fx93(parameter) + ')';
  };
  protoOf(Operation).toString = function () {
    return this.m();
  };
  function withCurrentStackTrace(_this__u8e3s4, slots) {
    var parent = _this__u8e3s4;
    return new withCurrentStackTrace$1(parent, slots);
  }
  function positionToInsert(slots, anchor, applier) {
    var destination = slots.q3m(anchor);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(slots.b34_1 < destination)) {
      var tmp$ret$2 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    positionToParentOf(slots, applier, destination);
    var nodeIndex = currentNodeIndex(slots);
    while (slots.b34_1 < destination) {
      if (slots.r4c(destination)) {
        if (slots.n3o()) {
          applier.h2y(slots.z34(slots.b34_1));
          nodeIndex = 0;
        }
        slots.x3j();
      } else
        nodeIndex = nodeIndex + slots.y35() | 0;
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(slots.b34_1 === destination)) {
      var tmp$ret$5 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$5);
    }
    return nodeIndex;
  }
  function positionToParentOf(slots, applier, index) {
    while (!slots.q4c(index)) {
      slots.z30();
      if (slots.x34(slots.d34_1)) {
        applier.i2y();
      }
      slots.z35();
    }
  }
  function attachComposeStackTrace(_this__u8e3s4, errorContext, writer, anchor) {
    if (errorContext == null)
      return _this__u8e3s4;
    return attachComposeStackTrace_1(_this__u8e3s4, attachComposeStackTrace$lambda(anchor, writer, errorContext));
  }
  function currentNodeIndex(slots) {
    var original = slots.b34_1;
    var current = slots.d34_1;
    while (current >= 0 && !slots.x34(current)) {
      current = slots.y34(current);
    }
    var index = 0;
    current = current + 1 | 0;
    while (current < original) {
      if (slots.s4c(original, current)) {
        if (slots.x34(current))
          index = 0;
        current = current + 1 | 0;
      } else {
        index = index + (slots.x34(current) ? 1 : slots.b35(current)) | 0;
        current = current + slots.a35(current) | 0;
      }
    }
    return index;
  }
  function withCurrentStackTrace$1($parent, $slots) {
    this.l4j_1 = $parent;
    this.m4j_1 = $slots;
  }
  protoOf(withCurrentStackTrace$1).n4j = function (currentOffset) {
    var parentTrace = this.l4j_1.n4j(null);
    var currentGroup = this.m4j_1.d34_1;
    if (currentGroup < 0)
      return parentTrace;
    return plus_0(buildTrace_3(this.m4j_1, currentOffset, currentGroup, this.m4j_1.y34(currentGroup)), parentTrace);
  };
  protoOf(withCurrentStackTrace$1).o4j = function () {
    return this.l4j_1.o4j();
  };
  function attachComposeStackTrace$lambda($anchor, $writer, $errorContext) {
    return function () {
      var tmp;
      if (!($anchor == null)) {
        $writer.f4d($anchor);
        tmp = Unit_instance;
      }
      var trace = buildTrace_3($writer);
      var tmp0_safe_receiver = lastOrNull(trace);
      var offset = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r4j_1;
      // Inline function 'kotlin.let' call
      var it = $errorContext.n4j(offset);
      var tmp_0;
      if (offset == null || it.r()) {
        tmp_0 = it;
      } else {
        var head = first(it);
        var tail = drop(it, 1);
        tmp_0 = plus_0(listOf(head.s4j(VOID, VOID, offset)), tail);
      }
      var parentTrace = tmp_0;
      return new ComposeStackTrace(plus_0(trace, parentTrace), $errorContext.o4j());
    };
  }
  var androidx_compose_runtime_composer_gapbuffer_changelist_Operations$stable;
  var androidx_compose_runtime_composer_gapbuffer_changelist_OperationsDebugStringFormattable$stable;
  function _WriteScope___init__impl__4xwato(stack) {
    return stack;
  }
  function _get_stack__b8zp2v($this) {
    return $this;
  }
  function _WriteScope___get_operation__impl__krvgwa($this) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.peekOperation' call
    var this_0 = _get_stack__b8zp2v($this);
    return this_0.k4e_1[this_0.l4e_1 - 1 | 0];
  }
  function WriteScope__setObject_impl_rr41y9($this, parameter, value) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_stack__b8zp2v($this);
    if (false) {
      var mask = 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter);
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_0 = ($this$with.r4e_1 & mask) === 0;
      if (false && !value_0) {
        var tmp$ret$3 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter);
        composeImmediateRuntimeError(tmp$ret$3);
      }
      $this$with.r4e_1 = $this$with.r4e_1 | mask;
    }
    var tmp = $this$with.o4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.topObjectIndexOf' call
    var tmp_0 = $this$with.p4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.peekOperation' call
    tmp[(tmp_0 - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].c4f_1 | 0) + _ObjectParameter___get_offset__impl__x7fx93(parameter) | 0] = value;
    return Unit_instance;
  }
  function WriteScope__setObjects_impl_utvr6i($this, parameter1, value1, parameter2, value2) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_stack__b8zp2v($this);
    if (false) {
      var mask = 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter1) | 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter2);
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = ($this$with.r4e_1 & mask) === 0;
      if (false && !value) {
        var tmp$ret$3 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter1) + (', ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter2));
        composeImmediateRuntimeError(tmp$ret$3);
      }
      $this$with.r4e_1 = $this$with.r4e_1 | mask;
    }
    var tmp = $this$with.p4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.peekOperation' call
    var base = tmp - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].c4f_1 | 0;
    var objectArgs = $this$with.o4e_1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter1) | 0] = value1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter2) | 0] = value2;
    return Unit_instance;
  }
  function WriteScope__setObjects_impl_utvr6i_0($this, parameter1, value1, parameter2, value2, parameter3, value3) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_stack__b8zp2v($this);
    if (false) {
      var mask = 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter1) | 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter2) | 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter3);
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = ($this$with.r4e_1 & mask) === 0;
      if (false && !value) {
        var tmp$ret$3 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter1) + (', ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter2)) + (', ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter3));
        composeImmediateRuntimeError(tmp$ret$3);
      }
      $this$with.r4e_1 = $this$with.r4e_1 | mask;
    }
    var tmp = $this$with.p4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.peekOperation' call
    var base = tmp - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].c4f_1 | 0;
    var objectArgs = $this$with.o4e_1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter1) | 0] = value1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter2) | 0] = value2;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter3) | 0] = value3;
    return Unit_instance;
  }
  function WriteScope__setObjects_impl_utvr6i_1($this, parameter1, value1, parameter2, value2, parameter3, value3, parameter4, value4) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_stack__b8zp2v($this);
    if (false) {
      var mask = 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter1) | 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter2) | 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter3) | 1 << _ObjectParameter___get_offset__impl__x7fx93(parameter4);
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = ($this$with.r4e_1 & mask) === 0;
      if (false && !value) {
        var tmp$ret$3 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter1) + (', ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter2)) + (', ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter3)) + (', ' + _WriteScope___get_operation__impl__krvgwa($this).r4g(parameter4));
        composeImmediateRuntimeError(tmp$ret$3);
      }
      $this$with.r4e_1 = $this$with.r4e_1 | mask;
    }
    var tmp = $this$with.p4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.peekOperation' call
    var base = tmp - $this$with.k4e_1[$this$with.l4e_1 - 1 | 0].c4f_1 | 0;
    var objectArgs = $this$with.o4e_1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter1) | 0] = value1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter2) | 0] = value2;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter3) | 0] = value3;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93(parameter4) | 0] = value4;
    return Unit_instance;
  }
  function access$_get_stack__7szo53($this) {
    return _get_stack__b8zp2v($this);
  }
  function determineNewSize($this, currentSize, requiredSize) {
    var resizeAmount = coerceAtMost(currentSize, 1024);
    return coerceAtLeast(currentSize + resizeAmount | 0, requiredSize);
  }
  function resizeOpCodes($this) {
    var resizeAmount = coerceAtMost($this.l4e_1, 1024);
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.l4e_1 + resizeAmount | 0;
    var tmp = Array(size);
    var newOpCodes = isArray(tmp) ? tmp : THROW_CCE();
    var tmp_0 = $this;
    var tmp0 = $this.k4e_1;
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = $this.l4e_1;
    arrayCopy(tmp0, newOpCodes, 0, 0, endIndex);
    tmp_0.k4e_1 = newOpCodes;
  }
  function resizeIntArgs($this, currentSize, requiredSize) {
    var newIntArgs = new Int32Array(determineNewSize($this, currentSize, requiredSize));
    // Inline function 'kotlin.collections.copyInto' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = $this.m4e_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newIntArgs, 0, 0, currentSize);
    $this.m4e_1 = newIntArgs;
  }
  function resizeObjectArgs($this, currentSize, requiredSize) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = determineNewSize($this, currentSize, requiredSize);
    var newObjectArgs = Array(size);
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = $this.o4e_1;
    arrayCopy(this_0, newObjectArgs, 0, 0, currentSize);
    $this.o4e_1 = newObjectArgs;
  }
  function exceptionMessageForOperationPushNoScope($this, operation) {
    return 'Cannot push ' + operation.toString() + ' without arguments because it expects ' + ('' + operation.b4f_1 + ' ints and ' + operation.c4f_1 + ' objects.');
  }
  function exceptionMessageForOperationPushWithScope($this, operation) {
    var missingIntCount = 0;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.repeat' call
    var times = operation.b4f_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ((1 << index & $this.q4e_1) === 0) {
          if (missingIntCount > 0) {
            this_0.q(', ');
          }
          this_0.q(operation.d4f(index));
          missingIntCount = missingIntCount + 1 | 0;
        }
      }
       while (inductionVariable < times);
    var missingInts = this_0.toString();
    var missingObjectCount = 0;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.repeat' call
    var times_0 = operation.c4f_1;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < times_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if ((1 << index_0 & $this.r4e_1) === 0) {
          if (missingIntCount > 0) {
            this_1.q(', ');
          }
          this_1.q(operation.r4g(_ObjectParameter___init__impl__iyg1ip(index_0)));
          missingObjectCount = missingObjectCount + 1 | 0;
        }
      }
       while (inductionVariable_0 < times_0);
    var missingObjects = this_1.toString();
    return 'Error while pushing ' + operation.toString() + '. Not all arguments were provided. ' + ('Missing ' + missingIntCount + ' int arguments (' + missingInts + ') ') + ('and ' + missingObjectCount + ' object arguments (' + missingObjects + ').');
  }
  function OpIterator($outer) {
    this.w4j_1 = $outer;
    this.t4j_1 = 0;
    this.u4j_1 = 0;
    this.v4j_1 = 0;
  }
  protoOf(OpIterator).v = function () {
    if (this.t4j_1 >= this.w4j_1.l4e_1)
      return false;
    var op = this.x4j();
    this.u4j_1 = this.u4j_1 + op.b4f_1 | 0;
    this.v4j_1 = this.v4j_1 + op.c4f_1 | 0;
    this.t4j_1 = this.t4j_1 + 1 | 0;
    return this.t4j_1 < this.w4j_1.l4e_1;
  };
  protoOf(OpIterator).x4j = function () {
    return this.w4j_1.k4e_1[this.t4j_1];
  };
  protoOf(OpIterator).o4g = function (parameter) {
    return this.w4j_1.m4e_1[this.u4j_1 + parameter | 0];
  };
  protoOf(OpIterator).u4g = function (parameter) {
    return this.w4j_1.o4e_1[this.v4j_1 + _ObjectParameter___get_offset__impl__x7fx93(parameter) | 0];
  };
  function access$_get_pushedIntMask__wrtr8x($this) {
    return $this.q4e_1;
  }
  function access$_set_pushedIntMask__hk28ql($this, _set____db54di) {
    $this.q4e_1 = _set____db54di;
    return Unit_instance;
  }
  function Operations() {
    OperationsDebugStringFormattable.call(this);
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(16);
    tmp.k4e_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.l4e_1 = 0;
    this.m4e_1 = new Int32Array(16);
    this.n4e_1 = 0;
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_1.o4e_1 = Array(16);
    this.p4e_1 = 0;
    this.q4e_1 = 0;
    this.r4e_1 = 0;
  }
  protoOf(Operations).n1 = function () {
    return this.l4e_1;
  };
  protoOf(Operations).r = function () {
    return this.n1() === 0;
  };
  protoOf(Operations).fv = function () {
    return !(this.n1() === 0);
  };
  protoOf(Operations).c3 = function () {
    this.l4e_1 = 0;
    this.n4e_1 = 0;
    fill_0(this.o4e_1, null, 0, this.p4e_1);
    this.p4e_1 = 0;
  };
  protoOf(Operations).v4e = function (operation) {
    if (false) {
      this.q4e_1 = 0;
      this.r4e_1 = 0;
    }
    if (this.l4e_1 === this.k4e_1.length) {
      resizeOpCodes(this);
    }
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.ensureIntArgsSizeAtLeast' call
    var requiredSize = this.n4e_1 + operation.b4f_1 | 0;
    var currentSize = this.m4e_1.length;
    if (requiredSize > currentSize) {
      resizeIntArgs(this, currentSize, requiredSize);
    }
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.ensureObjectArgsSizeAtLeast' call
    var requiredSize_0 = this.p4e_1 + operation.c4f_1 | 0;
    var currentSize_0 = this.o4e_1.length;
    if (requiredSize_0 > currentSize_0) {
      resizeObjectArgs(this, currentSize_0, requiredSize_0);
    }
    var tmp = this.k4e_1;
    var _unary__edvuaz = this.l4e_1;
    this.l4e_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = operation;
    this.n4e_1 = this.n4e_1 + operation.b4f_1 | 0;
    this.p4e_1 = this.p4e_1 + operation.c4f_1 | 0;
  };
  protoOf(Operations).i4f = function (operation) {
    if (false) {
      // Inline function 'androidx.compose.runtime.requirePrecondition' call
      if (!((operation.b4f_1 & operation.c4f_1) === 0)) {
        var tmp$ret$1 = exceptionMessageForOperationPushNoScope(this, operation);
        throwIllegalArgumentException(tmp$ret$1);
      }
    }
    this.v4e(operation);
  };
  protoOf(Operations).w4e = function (operation) {
    var tmp;
    var tmp_0 = this.q4e_1;
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.createExpectedArgMask' call
    var paramCount = operation.b4f_1;
    if (tmp_0 === ((paramCount === 0 ? 0 : -1) >>> (32 - paramCount | 0) | 0)) {
      var tmp_1 = this.r4e_1;
      // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.createExpectedArgMask' call
      var paramCount_0 = operation.c4f_1;
      tmp = tmp_1 === ((paramCount_0 === 0 ? 0 : -1) >>> (32 - paramCount_0 | 0) | 0);
    } else {
      tmp = false;
    }
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = tmp;
    if (false && !value) {
      var tmp$ret$3 = exceptionMessageForOperationPushWithScope(this, operation);
      composeImmediateRuntimeError(tmp$ret$3);
    }
  };
  protoOf(Operations).k4g = function (other) {
    var opCodes = this.k4e_1;
    this.l4e_1 = this.l4e_1 - 1 | 0;
    var op = opCodes[this.l4e_1];
    (isArray(opCodes) ? opCodes : THROW_CCE())[this.l4e_1] = null;
    other.v4e(op);
    var tmp0 = this.o4e_1;
    var tmp2 = other.o4e_1;
    var tmp4 = other.p4e_1 - op.c4f_1 | 0;
    var tmp6 = this.p4e_1 - op.c4f_1 | 0;
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.p4e_1;
    arrayCopy(tmp0, tmp2, tmp4, tmp6, endIndex);
    fill_0(this.o4e_1, null, this.p4e_1 - op.c4f_1 | 0, this.p4e_1);
    var tmp0_0 = this.m4e_1;
    var tmp2_0 = other.m4e_1;
    var tmp4_0 = other.n4e_1 - op.b4f_1 | 0;
    var tmp6_0 = this.n4e_1 - op.b4f_1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = this.n4e_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2_0, tmp4_0, tmp6_0, endIndex_0);
    this.p4e_1 = this.p4e_1 - op.c4f_1 | 0;
    this.n4e_1 = this.n4e_1 - op.b4f_1 | 0;
  };
  protoOf(Operations).t4e = function (applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.drain' call
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.changelist.Operations.forEach' call
    if (this.fv()) {
      var iterator = new OpIterator(this);
      do {
        // Inline function 'kotlin.with' call
        iterator.x4j().p4g(iterator, applier, slots, rememberManager, errorContext);
      }
       while (iterator.v());
    }
    this.c3();
  };
  protoOf(Operations).toString = function () {
    return protoOf(OperationsDebugStringFormattable).toString.call(this);
  };
  function OperationsDebugStringFormattable() {
  }
  var androidx_compose_runtime_composer_linkbuffer_GroupFlagsSpec$stable;
  function utilitySlotsCountForFlags(flags) {
    return countOneBits(flags & 58720256);
  }
  function propagatingFlagsOf(flags) {
    return flags & -1476395008 | (flags & 1409286144) << 1;
  }
  function get_group(_this__u8e3s4) {
    return convertToInt(_this__u8e3s4);
  }
  function makeGroupHandle(parent, predecessor, group) {
    var tmp;
    if (group >= 0) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
      var tmp_0 = shiftLeft(fromInt(predecessor), 32);
      // Inline function 'kotlin.toUInt' call
      // Inline function 'kotlin.UInt.toLong' call
      var this_0 = _UInt___init__impl__l7qpdl(group);
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_0);
      var tmp$ret$2 = bitwiseAnd(fromInt(value), new Long(-1, 0));
      tmp = bitwiseOr(tmp_0, tmp$ret$2);
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
      var tmp_1 = shiftLeft(fromInt(parent), 32);
      // Inline function 'kotlin.toUInt' call
      // Inline function 'kotlin.UInt.toLong' call
      var this_1 = _UInt___init__impl__l7qpdl(-1);
      // Inline function 'kotlin.uintToLong' call
      var value_0 = _UInt___get_data__impl__f0vqqw(this_1);
      var tmp$ret$6 = bitwiseAnd(fromInt(value_0), new Long(-1, 0));
      tmp = bitwiseOr(tmp_1, tmp$ret$6);
    }
    return tmp;
  }
  function get_context(_this__u8e3s4) {
    return convertToInt(shiftRightUnsigned(_this__u8e3s4, 32));
  }
  var androidx_compose_runtime_composer_linkbuffer_KeyInfo$stable;
  function KeyInfo_0(key, objectKey, handle, nodes, index) {
    this.y3t_1 = key;
    this.z3t_1 = objectKey;
    this.a3u_1 = handle;
    this.b3u_1 = nodes;
    this.c3u_1 = index;
  }
  protoOf(KeyInfo_0).c3x = function () {
    return !(this.z3t_1 == null) ? new JoinedKey(this.y3t_1, this.z3t_1) : this.y3t_1;
  };
  function get_NullAnchor() {
    _init_properties_LinkAnchor_kt__865x01();
    return NullAnchor;
  }
  var NullAnchor;
  function get_LazyAnchor() {
    _init_properties_LinkAnchor_kt__865x01();
    return LazyAnchor;
  }
  var LazyAnchor;
  var androidx_compose_runtime_composer_linkbuffer_LinkAnchor$stable;
  var androidx_compose_runtime_composer_linkbuffer_AnchorHandle$stable;
  function LinkAnchor(address) {
    this.m3v_1 = address;
  }
  protoOf(LinkAnchor).d2y = function () {
    return !(this.m3v_1 === -1);
  };
  protoOf(LinkAnchor).toString = function () {
    return anyToString(this) + '{ address: ' + this.m3v_1 + ' }';
  };
  function asLinkAnchor(_this__u8e3s4) {
    _init_properties_LinkAnchor_kt__865x01();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkAnchor ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composition');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AnchorHandle(groupAnchor, contextAnchor) {
    this.y4j_1 = groupAnchor;
    this.z4j_1 = contextAnchor;
  }
  protoOf(AnchorHandle).a4k = function () {
    var tmp0 = this.z4j_1.m3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var group = this.y4j_1.m3v_1;
    var tmp = shiftLeft(fromInt(tmp0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$2 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    return bitwiseOr(tmp, tmp$ret$2);
  };
  protoOf(AnchorHandle).toString = function () {
    return anyToString(this) + ': ' + this.y4j_1.m3v_1 + ':' + this.z4j_1.m3v_1;
  };
  function anchorHandle(_this__u8e3s4, handle) {
    _init_properties_LinkAnchor_kt__865x01();
    return new AnchorHandle(anchorHandle$anchorOf(_this__u8e3s4, get_group(handle)), anchorHandle$anchorOf(_this__u8e3s4, get_context(handle)));
  }
  function anchorHandle$anchorOf($this_anchorHandle, address) {
    switch (address) {
      case -1:
        return get_NullAnchor();
      case 0:
        return get_LazyAnchor();
      default:
        return $this_anchorHandle.u3v(address);
    }
  }
  var properties_initialized_LinkAnchor_kt_1ezf01;
  function _init_properties_LinkAnchor_kt__865x01() {
    if (!properties_initialized_LinkAnchor_kt_1ezf01) {
      properties_initialized_LinkAnchor_kt_1ezf01 = true;
      NullAnchor = new LinkAnchor(-1);
      LazyAnchor = new LinkAnchor(0);
      androidx_compose_runtime_composer_linkbuffer_LinkAnchor$stable = 8;
      androidx_compose_runtime_composer_linkbuffer_AnchorHandle$stable = 8;
    }
  }
  var androidx_compose_runtime_composer_linkbuffer_LinkGroupSourceInformation$stable;
  function openInformation_0($this) {
    var tmp0_safe_receiver = $this.e4k_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp$ret$2;
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.fastLastOrNull' call
        var index = tmp0_safe_receiver.n1() - 1 | 0;
        while (index >= 0) {
          var value = tmp0_safe_receiver.l1(index);
          var tmp_0;
          if (value instanceof LinkGroupSourceInformation) {
            tmp_0 = !value.f4k_1;
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$2 = value;
            break $l$block;
          }
          index = index - 1 | 0;
        }
        tmp$ret$2 = null;
      }
      tmp = tmp$ret$2;
    }
    var tmp_1 = tmp;
    var tmp1_safe_receiver = (tmp_1 == null ? true : tmp_1 instanceof LinkGroupSourceInformation) ? tmp_1 : THROW_CCE();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : openInformation_0(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? $this : tmp2_elvis_lhs;
  }
  function add_2($this, group) {
    var tmp0_elvis_lhs = $this.e4k_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      $this.e4k_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var groups = tmp;
    groups.j1(group);
  }
  function hasGroup($this, anchor) {
    var tmp0_safe_receiver = $this.e4k_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.fastAny' call
        // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0_safe_receiver.l1(index);
            var tmp_0;
            if (equals(item, anchor)) {
              tmp_0 = true;
            } else {
              var tmp_1;
              if (item instanceof LinkGroupSourceInformation) {
                tmp_1 = hasGroup(item, anchor);
              } else {
                tmp_1 = false;
              }
              tmp_0 = tmp_1;
            }
            if (tmp_0) {
              tmp$ret$0 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    }
    return tmp === true;
  }
  function LinkGroupSourceInformation(key, sourceInformation, dataStartOffset) {
    this.b4k_1 = key;
    this.c4k_1 = sourceInformation;
    this.d4k_1 = dataStartOffset;
    this.e4k_1 = null;
    this.f4k_1 = false;
    this.g4k_1 = 0;
  }
  protoOf(LinkGroupSourceInformation).t1 = function () {
    return this.b4k_1;
  };
  protoOf(LinkGroupSourceInformation).n4b = function () {
    return this.c4k_1;
  };
  protoOf(LinkGroupSourceInformation).m4b = function () {
    return this.d4k_1;
  };
  protoOf(LinkGroupSourceInformation).ie = function () {
    return this.e4k_1;
  };
  protoOf(LinkGroupSourceInformation).k4b = function () {
    return this.f4k_1;
  };
  protoOf(LinkGroupSourceInformation).l4b = function () {
    return this.g4k_1;
  };
  protoOf(LinkGroupSourceInformation).x4c = function (key, sourceInformation, dataOffset) {
    add_2(openInformation_0(this), new LinkGroupSourceInformation(key, sourceInformation, dataOffset));
  };
  protoOf(LinkGroupSourceInformation).y4c = function (dataOffset) {
    openInformation_0(this).t1i(dataOffset);
  };
  protoOf(LinkGroupSourceInformation).h4k = function (anchor) {
    add_2(openInformation_0(this), anchor);
  };
  protoOf(LinkGroupSourceInformation).i4k = function (predecessor, group) {
    var tmp0_elvis_lhs = this.e4k_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      this.e4k_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var groups = tmp;
    var tmp_0;
    if (!(predecessor == null)) {
      var tmp$ret$2;
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.fastIndexOf' call
        var index = 0;
        var size = groups.n1();
        while (index < size) {
          var value = groups.l1(index);
          var tmp_1;
          if (equals(value, predecessor)) {
            tmp_1 = true;
          } else {
            var tmp_2;
            if (value instanceof LinkGroupSourceInformation) {
              tmp_2 = hasGroup(value, predecessor);
            } else {
              tmp_2 = false;
            }
            tmp_1 = tmp_2;
          }
          if (tmp_1) {
            tmp$ret$2 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$2 = -1;
      }
      tmp_0 = tmp$ret$2;
    } else {
      tmp_0 = 0;
    }
    var index_0 = tmp_0;
    groups.g3(index_0, group);
  };
  protoOf(LinkGroupSourceInformation).t1i = function (dataOffset) {
    this.f4k_1 = true;
    this.g4k_1 = dataOffset;
  };
  protoOf(LinkGroupSourceInformation).j4k = function (anchor) {
    var groups = this.e4k_1;
    if (!(groups == null)) {
      var index = groups.n1() - 1 | 0;
      while (index >= 0) {
        var item = groups.l1(index);
        if (item instanceof LinkAnchor) {
          if (equals(item, anchor)) {
            groups.h3(index);
          }
        } else {
          if (item instanceof LinkGroupSourceInformation)
            if (!item.j4k(anchor)) {
              groups.h3(index);
            }
        }
        index = index - 1 | 0;
      }
      if (groups.r()) {
        this.e4k_1 = null;
        return false;
      }
      return true;
    }
    return true;
  };
  var androidx_compose_runtime_composer_linkbuffer_SlotTable$stable;
  function _get_groups__sds409($this) {
    return $this.j3u_1.p3u_1;
  }
  function _get_slots__bd4r7o($this) {
    return $this.j3u_1.q3u_1;
  }
  function Companion_10() {
  }
  var Companion_instance_11;
  function Companion_getInstance_10() {
    return Companion_instance_11;
  }
  function access$_get_groups__7d4n3r($this) {
    return _get_groups__sds409($this);
  }
  function access$_get_slots__7x4q9w_0($this) {
    return _get_slots__bd4r7o($this);
  }
  function SlotTable_0(root, addressSpace, recordSourceInformation, recordCallByInformation) {
    root = root === VOID ? -1 : root;
    addressSpace = addressSpace === VOID ? SlotTableAddressSpace_init_$Create$() : addressSpace;
    recordSourceInformation = recordSourceInformation === VOID ? false : recordSourceInformation;
    recordCallByInformation = recordCallByInformation === VOID ? false : recordCallByInformation;
    SlotStorage.call(this);
    this.i3u_1 = root;
    this.j3u_1 = addressSpace;
    this.k3u_1 = recordSourceInformation;
    this.l3u_1 = recordCallByInformation;
    this.m3u_1 = null;
    this.n3u_1 = 0;
    this.o3u_1 = 0;
  }
  protoOf(SlotTable_0).k4k = function () {
    return !(this.m3u_1 == null);
  };
  protoOf(SlotTable_0).s1d = function () {
    if (!(this.i3u_1 === -1)) {
      this.j3u_1.l4k(this.i3u_1);
      this.i3u_1 = -1;
    }
  };
  protoOf(SlotTable_0).d3i = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.k4k()) {
      var tmp$ret$1 = 'Cannot read while a writer is pending';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.n3u_1 = this.n3u_1 + 1 | 0;
    return new SlotTableReader(this);
  };
  protoOf(SlotTable_0).m4k = function (reader) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(reader.x3r_1 === this && this.n3u_1 > 0)) {
      var tmp$ret$1 = 'Unexpected reader close()';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.n3u_1 = this.n3u_1 - 1 | 0;
  };
  protoOf(SlotTable_0).b3v = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.k4k()) {
      var tmp$ret$1 = 'Cannot start a writer when another writer is pending';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.n3u_1 <= 0)) {
      var tmp$ret$3 = 'Cannot start a writer when a reader is pending';
      composeImmediateRuntimeError(tmp$ret$3);
    }
    this.o3u_1 = this.o3u_1 + 1 | 0;
    var editor = new SlotTableEditor(this);
    this.m3u_1 = editor;
    return editor;
  };
  protoOf(SlotTable_0).n4k = function (editor) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.m3u_1 === editor)) {
      var tmp$ret$1 = 'Attempted to close an editor that was not the current editor';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.m3u_1 = null;
  };
  protoOf(SlotTable_0).dm = function (group) {
    if (group < 0 || !this.j3u_1.dm(group))
      return false;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseParents' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups = this.j3u_1.p3u_1;
    var tmp;
    if (!false) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups[group + 2 | 0];
    } else {
      tmp = group;
    }
    var current = tmp;
    while (current > 0) {
      if (current === this.i3u_1)
        return true;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$6 = 'Traversing parent of group not in the slot table: ' + group;
      composeImmediateRuntimeError(tmp$ret$6);
    }
    return false;
  };
  protoOf(SlotTable_0).o4k = function (anchor) {
    return anchor.d2y() && this.j3u_1.p4k(anchor) && this.dm(anchor.m3v_1);
  };
  protoOf(SlotTable_0).c3w = function (flags) {
    var tmp;
    if (this.oy()) {
      tmp = false;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      tmp = (flags & this.j3u_1.p3u_1[this.i3u_1 + 4 | 0]) === flags;
    }
    return tmp;
  };
  protoOf(SlotTable_0).q4k = function (group) {
    var groups = this.j3u_1.p3u_1;
    var slots = this.j3u_1.q3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroup' call
    var tmp0 = this.j3u_1;
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroup' call
      if (group < 0) {
        break $l$block;
      }
      var toVisit = new IntStack();
      var group_0 = group;
      var groups_0 = tmp0.p3u_1;
      $l$loop: while (true) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
        var tmp$ret$3 = groups[group_0 + 5 | 0];
        var recomposeScope = recomposeScopeOrNullInRegion(slots, tmp$ret$3);
        if (!(recomposeScope == null))
          return true;
        if (!(group_0 === group) || false) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          var nextSibling = groups_0[group_0 + 1 | 0];
          if (nextSibling >= 0) {
            toVisit.g3i(nextSibling);
          }
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        var next = groups_0[group_0 + 3 | 0];
        if (next >= 0) {
          group_0 = next;
        } else {
          // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
          if (toVisit.f3i_1 === 0)
            break $l$loop;
          group_0 = toVisit.k3j();
        }
      }
    }
    return false;
  };
  protoOf(SlotTable_0).r4k = function (groupAnchor, childAnchor) {
    if (!groupAnchor.d2y())
      return false;
    if (!childAnchor.d2y())
      return false;
    if (equals(groupAnchor, childAnchor))
      return true;
    var addressSpace = this.j3u_1;
    if (!addressSpace.p4k(childAnchor))
      return false;
    if (!addressSpace.p4k(groupAnchor))
      return false;
    var group = groupAnchor.m3v_1;
    var childGroup = childAnchor.m3v_1;
    if (!addressSpace.dm(group))
      return false;
    if (!addressSpace.dm(childGroup))
      return false;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseParents' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups = addressSpace.p3u_1;
    var tmp;
    if (!false) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups[childGroup + 2 | 0];
    } else {
      tmp = childGroup;
    }
    var current = tmp;
    while (current > 0) {
      if (current === group)
        return true;
      if (group <= 0)
        return false;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$6 = 'Traversing parent of group not in the slot table: ' + childGroup;
      composeImmediateRuntimeError(tmp$ret$6);
    }
    return false;
  };
  protoOf(SlotTable_0).t39 = function (rememberManager) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = this.b3v();
    var tmp;
    try {
      removeCurrentGroup_0($this$with, rememberManager);
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
  };
  protoOf(SlotTable_0).l3b = function (rememberManager) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = this.b3v();
    var tmp;
    try {
      deactivateCurrentGroup_0($this$with, rememberManager);
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
  };
  protoOf(SlotTable_0).m3b = function (applier, references) {
    var result = mutableScatterMapOf();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = this.b3v();
    var tmp;
    try {
      // Inline function 'androidx.collection.ObjectList.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var content = references.sz_1;
      var inductionVariable = 0;
      var last = references.tz_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var reference = content[i];
          var anchor = asLinkAnchor(reference.g35_1);
          if ($this$with.e3v_1.o4k(anchor)) {
            $this$with.s4k(anchor);
            result.h13(reference, extractMovableContentAtCurrent_0(reference.e35_1, reference, $this$with, applier));
          }
        }
         while (inductionVariable < last);
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
    return result;
  };
  protoOf(SlotTable_0).y38 = function (group, anchor) {
    var anchor_0 = asLinkAnchor(anchor);
    return this.j3u_1.p4k(anchor_0) && this.t4k(anchor_0.m3v_1, group);
  };
  protoOf(SlotTable_0).a3a = function (parent, child) {
    return this.r4k(asLinkAnchor(parent), asLinkAnchor(child));
  };
  protoOf(SlotTable_0).v3a = function (rememberManager, state) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = this.b3v();
    var tmp;
    try {
      removeCurrentGroup_0($this$with, rememberManager);
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
  };
  protoOf(SlotTable_0).z3a = function () {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.forEachSlot' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.k4k()) {
      var tmp$ret$2 = 'Cannot read while an editor is pending';
      composeImmediateRuntimeError(tmp$ret$2);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseTable' call
    var tmp0 = this.j3u_1;
    var tmp2 = this.i3u_1;
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroup' call
      if (tmp2 < 0) {
        break $l$block;
      }
      var toVisit = new IntStack();
      var group = tmp2;
      var groups = tmp0.p3u_1;
      $l$loop: while (true) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.forEachGroupSlot' call
        var group_0 = group;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
        var slotRange = access$_get_groups__7d4n3r(this)[group_0 + 5 | 0];
        if (!(slotRange === -1)) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
          var this_0 = this.j3u_1;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
          var smallSize = (slotRange & 15) + 1 | 0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
          var address = slotRange >> 4;
          var tmp;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
          if (smallSize > 15) {
            tmp = access$_get_largeSizes__q41gto(this_0).l1(address);
          } else {
            tmp = smallSize;
          }
          var size = tmp;
          $l$block_0: {
            var inductionVariable = 0;
            if (inductionVariable < size)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var value = access$_get_slots__7x4q9w_0(this)[address + index | 0];
                if (equals(value, Companion_getInstance_0().f30_1)) {
                  break $l$block_0;
                }
                var tmp0_safe_receiver = (!(value == null) ? isInterface(value, RecomposeScope) : false) ? value : null;
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  tmp0_safe_receiver.m40();
                }
              }
               while (inductionVariable < size);
          }
        }
        if (!(group === tmp2) || true) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          var nextSibling = groups[group + 1 | 0];
          if (nextSibling >= 0) {
            toVisit.g3i(nextSibling);
          }
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        var next = groups[group + 3 | 0];
        if (next >= 0) {
          group = next;
        } else {
          // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
          if (toVisit.f3i_1 === 0)
            break $l$loop;
          group = toVisit.k3j();
        }
      }
    }
    return Unit_instance;
  };
  protoOf(SlotTable_0).e3b = function (scope) {
    var tmp0_safe_receiver = scope.m35_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var anchor = asLinkAnchor(tmp0_safe_receiver);
      tmp = (this.j3u_1.p4k(anchor) && this.t4k(anchor.m3v_1, this.i3u_1));
    }
    return tmp === true;
  };
  protoOf(SlotTable_0).t4k = function (child, parent) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroupAndParents' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups = this.j3u_1.p3u_1;
    var tmp;
    if (!true) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups[child + 2 | 0];
    } else {
      tmp = child;
    }
    var current = tmp;
    while (current > 0) {
      if (current === parent)
        return true;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$6 = 'Traversing parent of group not in the slot table: ' + child;
      composeImmediateRuntimeError(tmp$ret$6);
    }
    return false;
  };
  protoOf(SlotTable_0).t34 = function () {
    this.k3u_1 = true;
  };
  protoOf(SlotTable_0).v34 = function () {
    this.l3u_1 = true;
  };
  protoOf(SlotTable_0).oy = function () {
    return this.i3u_1 === -1;
  };
  protoOf(SlotTable_0).t = function () {
    return new GroupIterator_0(this, this.i3u_1);
  };
  protoOf(SlotTable_0).u4k = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    return _get_groups__sds409(this)[group + 1 | 0];
  };
  protoOf(SlotTable_0).v4k = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    return _get_groups__sds409(this)[group + 3 | 0];
  };
  protoOf(SlotTable_0).m3x = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    return _get_groups__sds409(this)[group + 4 | 0];
  };
  function asLinkBufferSlotTable(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof SlotTable_0 ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composer');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findLocation_0(_this__u8e3s4, filter) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.read' call
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.d3i();
    var tmp;
    try {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroup' call
      var group = _this__u8e3s4.i3u_1;
      var tmp0 = _this__u8e3s4.j3u_1;
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroup' call
        if (group < 0) {
          break $l$block;
        }
        var toVisit = new IntStack();
        var group_0 = group;
        var groups = tmp0.p3u_1;
        $l$loop: while (true) {
          var group_1 = group_0;
          if ($this$with.x34(group_1) && filter($this$with.z34(group_1))) {
            return new ObjectLocation(group_1, null);
          }
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.forEachGroupSlot' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
          var slotRange = access$_get_groups__7d4n3r(_this__u8e3s4)[group_1 + 5 | 0];
          if (!(slotRange === -1)) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
            var this_0 = _this__u8e3s4.j3u_1;
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
            var smallSize = (slotRange & 15) + 1 | 0;
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
            var address = slotRange >> 4;
            var tmp_0;
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
            if (smallSize > 15) {
              tmp_0 = access$_get_largeSizes__q41gto(this_0).l1(address);
            } else {
              tmp_0 = smallSize;
            }
            var size = tmp_0;
            $l$block_0: {
              var inductionVariable = 0;
              if (inductionVariable < size)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var value = access$_get_slots__7x4q9w_0(_this__u8e3s4)[address + index | 0];
                  if (equals(value, Companion_getInstance_0().f30_1)) {
                    break $l$block_0;
                  }
                  if (filter(value)) {
                    return new ObjectLocation(group_1, index);
                  }
                }
                 while (inductionVariable < size);
            }
          }
          if (!(group_0 === group) || false) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
            var nextSibling = groups[group_0 + 1 | 0];
            if (nextSibling >= 0) {
              toVisit.g3i(nextSibling);
            }
          }
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
          var next = groups[group_0 + 3 | 0];
          if (next >= 0) {
            group_0 = next;
          } else {
            // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
            if (toVisit.f3i_1 === 0)
              break $l$loop;
            group_0 = toVisit.k3j();
          }
        }
      }
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
    return null;
  }
  function recomposeScopeOrNullInRegion(_this__u8e3s4, slotRegion) {
    if (slotRegion < 0)
      return null;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var slotStart = slotRegion >> 4;
    var tmp = _this__u8e3s4[slotStart];
    return tmp instanceof RecomposeScopeImpl ? tmp : null;
  }
  function removeCurrentGroup_0(_this__u8e3s4, rememberManager) {
    var tmp = _this__u8e3s4.h3u();
    var tmp_0 = removeCurrentGroup$lambda_0(rememberManager);
    _this__u8e3s4.w4k(tmp, new sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0(tmp_0));
    _this__u8e3s4.x4k();
  }
  function deactivateCurrentGroup_0(_this__u8e3s4, rememberManager) {
    var tmp = _this__u8e3s4.h3u();
    var tmp_0 = deactivateCurrentGroup$lambda_0(rememberManager);
    _this__u8e3s4.w4k(tmp, new sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_0(tmp_0));
  }
  function extractMovableContentAtCurrent_0(composition, reference, slots, applier) {
    var currentGroup = slots.h3u();
    if (!(applier == null) && slots.y4k(currentGroup) > 0) {
      if (!isInterface(applier, Applier))
        THROW_CCE();
      // Inline function 'kotlin.run' call
      var tmp$ret$1;
      $l$block: {
        var tmp0 = slots.e3v_1.j3u_1;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseParents' call
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
        var group = slots.k3s();
        var groups = tmp0.p3u_1;
        var tmp;
        if (!false) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
          tmp = groups[group + 2 | 0];
        } else {
          tmp = group;
        }
        var current = tmp;
        while (current > 0) {
          var it = current;
          if (slots.x34(it)) {
            tmp$ret$1 = it;
            break $l$block;
          }
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
          current = groups[current + 2 | 0];
        }
        // Inline function 'androidx.compose.runtime.runtimeCheck' call
        if (!!(current === 0)) {
          var tmp$ret$8 = 'Traversing parent of group not in the slot table: ' + group;
          composeImmediateRuntimeError(tmp$ret$8);
        }
        tmp$ret$1 = -1;
      }
      var parentNodeGroup = tmp$ret$1;
      if (parentNodeGroup >= 0 && slots.x34(parentNodeGroup)) {
        var tmp0_elvis_lhs = slots.z34(parentNodeGroup);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          composeImmediateRuntimeError('Invalid slot table structure');
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var node = tmp_0;
        var nodeIndex = nodeIndexOf_0(currentGroup, slots.e3v_1);
        var count = slots.y4k(currentGroup);
        applier.h2y(node);
        applier.l2y(nodeIndex, count);
        applier.i2y();
      }
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.buildSubTable' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.Companion.build' call
    var addressSpace = slots.e3v_1.j3u_1;
    var builder = SlotTableBuilder_init_$Create$(addressSpace, false, false);
    builder.k3v();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startGroup' call
    var objectKey = reference.c35_1;
    access$startNewGroup(builder, 126665345, objectKey === Companion_getInstance_0().f30_1 ? 0 : 16777216, objectKey, null, null);
    builder.s3v(268435456);
    builder.b3x(reference.d35_1);
    var contentAddress = slots.v3v(asLinkAnchor(reference.g35_1).m3v_1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.toGroupHandle' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var tmp_1 = shiftLeft(fromInt(0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(contentAddress);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$16 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    var tmp$ret$13 = bitwiseOr(tmp_1, tmp$ret$16);
    builder.z4k(slots, tmp$ret$13);
    builder.z35();
    var slotTable = builder.g3d();
    var state = new MovableContentState(slotTable);
    var newOwner = null;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.forEachSlot' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!slotTable.k4k()) {
      var tmp$ret$20 = 'Cannot read while an editor is pending';
      composeImmediateRuntimeError(tmp$ret$20);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseTable' call
    var tmp0_0 = slotTable.j3u_1;
    var tmp2 = slotTable.i3u_1;
    $l$block_0: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroup' call
      if (tmp2 < 0) {
        break $l$block_0;
      }
      var toVisit = new IntStack();
      var group_0 = tmp2;
      var groups_0 = tmp0_0.p3u_1;
      $l$loop: while (true) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.forEachGroupSlot' call
        var group_1 = group_0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
        var slotRange = access$_get_groups__7d4n3r(slotTable)[group_1 + 5 | 0];
        if (!(slotRange === -1)) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
          var this_1 = slotTable.j3u_1;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
          var smallSize = (slotRange & 15) + 1 | 0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
          var address = slotRange >> 4;
          var tmp_2;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
          if (smallSize > 15) {
            tmp_2 = access$_get_largeSizes__q41gto(this_1).l1(address);
          } else {
            tmp_2 = smallSize;
          }
          var size = tmp_2;
          $l$block_1: {
            var inductionVariable = 0;
            if (inductionVariable < size)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var value_0 = access$_get_slots__7x4q9w_0(slotTable)[address + index | 0];
                if (equals(value_0, Companion_getInstance_0().f30_1)) {
                  break $l$block_1;
                }
                if (value_0 instanceof RecomposeScopeImpl) {
                  var tmp0_elvis_lhs_0 = newOwner;
                  var tmp_3;
                  if (tmp0_elvis_lhs_0 == null) {
                    // Inline function 'kotlin.also' call
                    var this_2 = new extractMovableContentAtCurrent$1(composition, reference);
                    newOwner = this_2;
                    tmp_3 = this_2;
                  } else {
                    tmp_3 = tmp0_elvis_lhs_0;
                  }
                  var owner = tmp_3;
                  value_0.o40(owner);
                }
              }
               while (inductionVariable < size);
          }
        }
        if (!(group_0 === tmp2) || true) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          var nextSibling = groups_0[group_0 + 1 | 0];
          if (nextSibling >= 0) {
            toVisit.g3i(nextSibling);
          }
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        var next = groups_0[group_0 + 3 | 0];
        if (next >= 0) {
          group_0 = next;
        } else {
          // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
          if (toVisit.f3i_1 === 0)
            break $l$loop;
          group_0 = toVisit.k3j();
        }
      }
    }
    return state;
  }
  function validateRead_1($this) {
    if (!($this.a4l_1.o3u_1 === $this.c4l_1)) {
      throwConcurrentModificationException_0();
    }
  }
  function SlotTableGroup_0(table, group, version) {
    version = version === VOID ? table.o3u_1 : version;
    this.a4l_1 = table;
    this.b4l_1 = group;
    this.c4l_1 = version;
  }
  protoOf(SlotTableGroup_0).t = function () {
    validateRead_1(this);
    var sourceInformation = this.a4l_1.j3u_1.t4b(this.b4l_1);
    var tmp;
    if (!(sourceInformation == null)) {
      tmp = new SourceInformationGroupIterator_0(this.a4l_1, this.b4l_1, sourceInformation, new AnchoredGroupPath_0(this.b4l_1));
    } else {
      tmp = new GroupIterator_0(this.a4l_1, this.a4l_1.v4k(this.b4l_1));
    }
    return tmp;
  };
  protoOf(SlotTableGroup_0).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof SlotTableGroup_0) {
      tmp_1 = other.b4l_1 === this.b4l_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = other.c4l_1 === this.c4l_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.a4l_1, this.a4l_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SlotTableGroup_0).hashCode = function () {
    return this.b4l_1 + imul(31, hashCode(this.a4l_1)) | 0;
  };
  function validateRead_2($this) {
    if (!($this.d4l_1.o3u_1 === $this.f4l_1)) {
      throwConcurrentModificationException_0();
    }
  }
  function GroupIterator_0(table, address) {
    this.d4l_1 = table;
    this.e4l_1 = address;
    this.f4l_1 = this.d4l_1.o3u_1;
    if (this.d4l_1.k4k()) {
      throwConcurrentModificationException_0();
    }
  }
  protoOf(GroupIterator_0).u = function () {
    return !(this.e4l_1 === -1);
  };
  protoOf(GroupIterator_0).v = function () {
    validateRead_2(this);
    var current = this.e4l_1;
    this.e4l_1 = this.d4l_1.u4k(current);
    return new SlotTableGroup_0(this.d4l_1, current, this.f4l_1);
  };
  function nodeIndexOf_0(groupAddress, table) {
    var current = groupAddress;
    var nodeIndex = 0;
    var addressSpace = table.j3u_1;
    var groups = addressSpace.p3u_1;
    $l$loop: while (current > 0) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      var parent = groups[current + 2 | 0];
      // Inline function 'kotlin.run' call
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseChildren' call
        var groups_0 = addressSpace.p3u_1;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        var current_0 = groups_0[parent + 3 | 0];
        while (current_0 > 0) {
          if (current_0 === current) {
            break $l$block;
          }
          var tmp = nodeIndex;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNodeCount' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
          var flags = groups[current + 4 | 0];
          var tmp_0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
          if ((8388608 & flags) === 8388608) {
            tmp_0 = 1;
          } else {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
            tmp_0 = flags & 8388607;
          }
          nodeIndex = tmp + tmp_0 | 0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          current_0 = groups_0[current_0 + 1 | 0];
        }
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      if ((8388608 & groups[parent + 4 | 0]) === 8388608)
        break $l$loop;
      current = parent;
    }
    return nodeIndex;
  }
  function SourceInformationGroupIterator_0(table, parent, group, path) {
    this.g4l_1 = table;
    this.h4l_1 = parent;
    this.i4l_1 = group;
    this.j4l_1 = path;
    this.k4l_1 = this.g4l_1.o3u_1;
    this.l4l_1 = 0;
  }
  protoOf(SourceInformationGroupIterator_0).u = function () {
    var tmp0_safe_receiver = this.i4l_1.e4k_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.l4l_1 < tmp0_safe_receiver.n1();
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(SourceInformationGroupIterator_0).v = function () {
    var tmp0_safe_receiver = this.i4l_1.e4k_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var _unary__edvuaz = this.l4l_1;
      this.l4l_1 = _unary__edvuaz + 1 | 0;
      tmp = tmp0_safe_receiver.l1(_unary__edvuaz);
    }
    var group = tmp;
    var tmp_0;
    if (group instanceof LinkAnchor) {
      tmp_0 = new SlotTableGroup_0(this.g4l_1, group.m3v_1, this.k4l_1);
    } else {
      if (group instanceof LinkGroupSourceInformation) {
        tmp_0 = new SourceInformationSlotTableGroup_0(this.g4l_1, this.h4l_1, group, new RelativeGroupPath_0(this.j4l_1, this.l4l_1 - 1 | 0));
      } else {
        composeRuntimeError('Unexpected group information structure');
      }
    }
    return tmp_0;
  };
  function AnchoredGroupPath_0(group) {
    SourceInformationGroupPath_0.call(this);
    this.m4l_1 = group;
  }
  protoOf(AnchoredGroupPath_0).equals = function (other) {
    var tmp;
    if (other instanceof AnchoredGroupPath_0) {
      tmp = other.m4l_1 === this.m4l_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AnchoredGroupPath_0).hashCode = function () {
    return imul(this.m4l_1, 31);
  };
  function throwConcurrentModificationException_0() {
    throw ConcurrentModificationException_init_$Create$();
  }
  function SourceInformationGroupPath_0() {
  }
  function SourceInformationSlotTableGroup_0(table, parent, sourceInformation, identityPath) {
    this.n4l_1 = table;
    this.o4l_1 = parent;
    this.p4l_1 = sourceInformation;
    this.q4l_1 = identityPath;
    this.r4l_1 = this.p4l_1.b4k_1;
    this.s4l_1 = this;
  }
  protoOf(SourceInformationSlotTableGroup_0).t = function () {
    return new SourceInformationGroupIterator_0(this.n4l_1, this.o4l_1, this.p4l_1, this.q4l_1);
  };
  protoOf(SourceInformationSlotTableGroup_0).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof SourceInformationSlotTableGroup_0) {
      tmp_1 = other.o4l_1 === this.o4l_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(other.n4l_1, this.n4l_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.q4l_1, this.q4l_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SourceInformationSlotTableGroup_0).hashCode = function () {
    var result = imul(this.o4l_1, 31) + hashCode(this.n4l_1) | 0;
    result = imul(result, 31) + hashCode(this.q4l_1) | 0;
    return result;
  };
  function RelativeGroupPath_0(parent, index) {
    SourceInformationGroupPath_0.call(this);
    this.t4l_1 = parent;
    this.u4l_1 = index;
  }
  protoOf(RelativeGroupPath_0).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof RelativeGroupPath_0) {
      tmp_0 = equals(other.t4l_1, this.t4l_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.u4l_1 === this.u4l_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RelativeGroupPath_0).hashCode = function () {
    return imul(this.u4l_1, 31) + hashCode(this.t4l_1) | 0;
  };
  function adoptScopesInGroupToNewParent(_this__u8e3s4, group, newOwner) {
    var groups = _this__u8e3s4.j3u_1.p3u_1;
    var slots = _this__u8e3s4.j3u_1.q3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroup' call
    var tmp0 = _this__u8e3s4.j3u_1;
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroup' call
      if (group < 0) {
        break $l$block;
      }
      var toVisit = new IntStack();
      var group_0 = group;
      var groups_0 = tmp0.p3u_1;
      $l$loop: while (true) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
        var tmp$ret$3 = groups[group_0 + 5 | 0];
        var tmp0_safe_receiver = recomposeScopeOrNullInRegion(slots, tmp$ret$3);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.o40(newOwner);
        }
        if (!(group_0 === group) || false) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          var nextSibling = groups_0[group_0 + 1 | 0];
          if (nextSibling >= 0) {
            toVisit.g3i(nextSibling);
          }
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        var next = groups_0[group_0 + 3 | 0];
        if (next >= 0) {
          group_0 = next;
        } else {
          // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
          if (toVisit.f3i_1 === 0)
            break $l$loop;
          group_0 = toVisit.k3j();
        }
      }
    }
  }
  function sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0(function_0) {
    this.v4l_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0).w4l = function (group, slotIndex, slot) {
    return this.v4l_1(group, slotIndex, slot);
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0).q3 = function () {
    return this.v4l_1;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, VisitSlotsInRememberOrderCallback) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_0(function_0) {
    this.x4l_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_0).w4l = function (group, slotIndex, slot) {
    return this.x4l_1(group, slotIndex, slot);
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_0).q3 = function () {
    return this.x4l_1;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, VisitSlotsInRememberOrderCallback) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function removeCurrentGroup$lambda_0($rememberManager) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, slot) {
      var tmp;
      if (!(slot == null) ? isInterface(slot, ComposeNodeLifecycleCallback) : false) {
        $rememberManager.e36(slot);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (!(slot == null) ? isInterface(slot, RememberObserverHolder) : false) {
        $rememberManager.f36(slot);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if (slot instanceof RecomposeScopeImpl) {
        slot.r2v();
        tmp_1 = Unit_instance;
      }
      return false;
    };
  }
  function deactivateCurrentGroup$lambda_0($rememberManager) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, data) {
      var tmp;
      if (!(data == null) ? isInterface(data, ComposeNodeLifecycleCallback) : false) {
        $rememberManager.o3p(data);
        tmp = false;
      } else {
        if (!(data == null) ? isInterface(data, ReusableRememberObserverHolder) : false) {
          tmp = false;
        } else {
          if (!(data == null) ? isInterface(data, RememberObserverHolder) : false) {
            $rememberManager.f36(data);
            tmp = true;
          } else {
            if (data instanceof RecomposeScopeImpl) {
              data.r2v();
              tmp = true;
            } else {
              tmp = false;
            }
          }
        }
      }
      return tmp;
    };
  }
  function extractMovableContentAtCurrent$1($composition, $reference) {
    this.y4l_1 = $composition;
    this.z4l_1 = $reference;
  }
  protoOf(extractMovableContentAtCurrent$1).i36 = function (scope, instance) {
    var tmp = this.y4l_1;
    var tmp0_safe_receiver = isInterface(tmp, RecomposeScopeOwner) ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i36(scope, instance);
    var result = tmp1_elvis_lhs == null ? InvalidationResult_IGNORED_getInstance() : tmp1_elvis_lhs;
    if (result.equals(InvalidationResult_IGNORED_getInstance())) {
      var _receiver__tnumb7 = this.z4l_1;
      var tmp_0 = _receiver__tnumb7;
      var tmp_1 = _receiver__tnumb7.h35_1;
      tmp_0.h35_1 = plus_1(tmp_1, to(scope, instance == null ? ScopeInvalidated_instance : instance));
      return InvalidationResult_SCHEDULED_getInstance();
    }
    return result;
  };
  protoOf(extractMovableContentAtCurrent$1).j36 = function (scope) {
  };
  protoOf(extractMovableContentAtCurrent$1).k36 = function (value) {
  };
  function get_Unallocated() {
    _init_properties_SlotTableAddresSpace_kt__s94bxz();
    return Unallocated;
  }
  var Unallocated;
  var androidx_compose_runtime_composer_linkbuffer_SlotTableAddressSpace$stable;
  var androidx_compose_runtime_composer_linkbuffer_SlotMoveManager$stable;
  function _get_largeSizes__ejlmqc($this) {
    var tmp0_elvis_lhs = $this.r3u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var largeSizes = mutableIntIntMapOf();
      $this.r3u_1 = largeSizes;
      tmp = largeSizes;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SlotTableAddressSpace_init_$Init$($this) {
    SlotTableAddressSpace.call($this, Companion_getInstance_11().a4m_1, Companion_getInstance_11().b4m_1);
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
    if ($this.p3u_1[0 + 0 | 0] === 0) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      tmp_3 = $this.p3u_1[0 + 1 | 0] === -1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp_2 = $this.p3u_1[0 + 2 | 0] === 0;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
      tmp_1 = $this.p3u_1[0 + 3 | 0] === 6;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      tmp_0 = $this.p3u_1[0 + 4 | 0] === 0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      tmp = $this.p3u_1[0 + 5 | 0] === 0;
    } else {
      tmp = false;
    }
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = tmp;
    if (false && !value) {
      var tmp$ret$7 = 'EmptyGroupData array was written to: ' + $this.p1b() + '.';
      composeImmediateRuntimeError(tmp$ret$7);
    }
    return $this;
  }
  function SlotTableAddressSpace_init_$Create$() {
    return SlotTableAddressSpace_init_$Init$(objectCreate(protoOf(SlotTableAddressSpace)));
  }
  function removeSourceInformation($this, address) {
    var tmp0_elvis_lhs = $this.w3u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var map = tmp;
    var tmp1_elvis_lhs = $this.v3u_1.l1(address);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var anchor = tmp_0;
    var tmp_1 = $this.v3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    var tmp$ret$0 = $this.p3u_1[address + 2 | 0];
    var tmp2_elvis_lhs = tmp_1.l1(tmp$ret$0);
    var tmp_2;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_2 = tmp2_elvis_lhs;
    }
    var parent = tmp_2;
    var tmp3_elvis_lhs = map.w2(parent);
    var tmp_3;
    if (tmp3_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_3 = tmp3_elvis_lhs;
    }
    var parentSourceInformation = tmp_3;
    parentSourceInformation.j4k(anchor);
  }
  function freeGroup($this, address) {
    var groups = $this.p3u_1;
    if ((address + 6 | 0) > groups.length) {
      return Unit_instance;
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsIsMarkedDeleted' call
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!((groups[address + 4 | 0] & 8388607) === 8388607)) {
      var tmp$ret$3 = 'Recursive loop in group structure detected at ' + address;
      composeImmediateRuntimeError(tmp$ret$3);
    }
    var tmp0_safe_receiver = $this.v3u_1.l1(address);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.m3v_1 = -1;
      $this.v3u_1.gw(address);
      var tmp0_safe_receiver_0 = $this.w3u_1;
      tmp0_safe_receiver_0 == null || tmp0_safe_receiver_0.a3(tmp0_safe_receiver);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var tmp$ret$6 = groups[address + 5 | 0];
    freeSlots($this, tmp$ret$6);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    groups[address + 5 | 0] = -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    var child = groups[address + 3 | 0];
    while (!(child === -1)) {
      if ((child + 6 | 0) > groups.length) {
        return Unit_instance;
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      var next = groups[child + 1 | 0];
      freeGroup($this, child);
      child = next;
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    groups[address + 1 | 0] = groups[0 + 1 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    groups[address + 2 | 0] = -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    groups[0 + 1 | 0] = address;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    groups[address + 4 | 0] = 8388607;
  }
  function allocateSlots($this, size) {
    var unallocatedStart = $this.s3u_1;
    var unallocatedEnd = $this.t3u_1;
    if ((unallocatedStart + size | 0) <= unallocatedEnd) {
      var newAddress = unallocatedStart;
      $this.s3u_1 = newAddress + size | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (size > 15) {
        _get_largeSizes__ejlmqc($this).zu(newAddress, size);
      }
      fill_0($this.q3u_1, Companion_getInstance_0().f30_1, newAddress, newAddress + size | 0);
      return slotRangeFromAddressAndSize(newAddress, size);
    } else {
      compactAndMaybeGrow($this, size);
      var newUnallocatedStart = $this.s3u_1;
      var newUnallocatedEnd = $this.t3u_1;
      if ((newUnallocatedStart + size | 0) <= newUnallocatedEnd) {
        var newAddress_0 = newUnallocatedStart;
        $this.s3u_1 = newAddress_0 + size | 0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
        if (size > 15) {
          _get_largeSizes__ejlmqc($this).zu(newAddress_0, size);
        }
        fill_0($this.q3u_1, Companion_getInstance_0().f30_1, newAddress_0, newAddress_0 + size | 0);
        return slotRangeFromAddressAndSize(newAddress_0, size);
      }
      composeRuntimeError('compactAndMaybeGrow did not grow enough');
    }
  }
  function growSlotRangeAtGroup($this, group, currentSize, newSize) {
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = newSize > currentSize;
    if (false && !value) {
      var tmp$ret$1 = 'Should have called resizeSlotRange() instead';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var unallocatedStart = $this.s3u_1;
    var unallocatedEnd = $this.t3u_1;
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value_0 = unallocatedEnd >= unallocatedStart;
    if (false && !value_0) {
      var tmp$ret$3 = 'Unexpected unallocated range';
      composeImmediateRuntimeError(tmp$ret$3);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var range = $this.p3u_1[group + 5 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var address = range >> 4;
    if ((address + currentSize | 0) === unallocatedStart) {
      if ((address + newSize | 0) <= unallocatedEnd) {
        $this.s3u_1 = $this.s3u_1 + (newSize - currentSize | 0) | 0;
        if (newSize > 15) {
          _get_largeSizes__ejlmqc($this).zu(address, newSize);
        }
        var newRange = slotRangeFromAddressAndSize(address, newSize);
        var tmp0 = $this.q3u_1;
        var tmp2 = address + currentSize | 0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.clearRange' call
        var end = address + newSize | 0;
        if (end === (tmp2 + 1 | 0)) {
          tmp0[tmp2] = get_Unallocated();
        } else {
          fill_0(tmp0, get_Unallocated(), tmp2, end);
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
        $this.p3u_1[group + 5 | 0] = newRange;
        return newRange;
      }
    }
    var needed = newSize - currentSize | 0;
    var tmp0_0 = $this.q3u_1;
    var tmp2_0 = address + currentSize | 0;
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.allUnallocated' call
      var end_0 = tmp2_0 + needed | 0;
      if (end_0 >= tmp0_0.length) {
        tmp$ret$8 = false;
        break $l$block_0;
      }
      var inductionVariable = tmp2_0;
      if (inductionVariable < end_0)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(tmp0_0[i] === get_Unallocated())) {
            tmp$ret$8 = false;
            break $l$block_0;
          }
        }
         while (inductionVariable < end_0);
      tmp$ret$8 = true;
    }
    if (tmp$ret$8) {
      if (newSize > 15) {
        _get_largeSizes__ejlmqc($this).zu(address, newSize);
      }
      var newRange_0 = slotRangeFromAddressAndSize(address, newSize);
      var tmp0_1 = $this.q3u_1;
      var tmp2_1 = address + currentSize | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.clearRange' call
      var end_1 = address + newSize | 0;
      if (end_1 === (tmp2_1 + 1 | 0)) {
        tmp0_1[tmp2_1] = get_Unallocated();
      } else {
        fill_0(tmp0_1, get_Unallocated(), tmp2_1, end_1);
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      $this.p3u_1[group + 5 | 0] = newRange_0;
      $this.u3u_1 = $this.u3u_1 - needed | 0;
      return newRange_0;
    }
    var bufferedSize = newSize + 8 | 0;
    var bufferedRange = allocateSlots($this, bufferedSize);
    var newRange_1 = shrinkSlotRange($this, bufferedRange, bufferedSize, newSize);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var newAddress = newRange_1 >> 4;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var currentRange = $this.p3u_1[group + 5 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var currentAddress = currentRange >> 4;
    if (!(newAddress === currentAddress)) {
      var tmp0_2 = $this.q3u_1;
      var tmp2_2 = $this.q3u_1;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = currentAddress + currentSize | 0;
      arrayCopy(tmp0_2, tmp2_2, newAddress, currentAddress, endIndex);
      freeSlotsAt($this, currentAddress, currentSize);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    $this.p3u_1[group + 5 | 0] = newRange_1;
    return newRange_1;
  }
  function shrinkSlotRange($this, range, currentSize, newSize) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var address = range >> 4;
    if (newSize === 0) {
      if (!(range === -1)) {
        freeSlotsAt($this, address, currentSize);
      }
      return -1;
    }
    var sizeToFree = currentSize - newSize | 0;
    var addressToFree = address + newSize | 0;
    if (sizeToFree > 0) {
      freeSlotsAt($this, addressToFree, sizeToFree);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
    if (newSize > 15) {
      _get_largeSizes__ejlmqc($this).zu(address, newSize);
    }
    return slotRangeFromAddressAndSize(address, newSize);
  }
  function shrinkSlotRangeAtGroup($this, group, currentSize, newSize) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var range = $this.p3u_1[group + 5 | 0];
    var newRange = shrinkSlotRange($this, range, currentSize, newSize);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    $this.p3u_1[group + 5 | 0] = newRange;
    return newRange;
  }
  function freeSlots($this, slotRange) {
    if (!(slotRange === -1)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (slotRange & 15) + 1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var address = slotRange >> 4;
      var tmp;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        tmp = access$_get_largeSizes__q41gto($this).l1(address);
      } else {
        tmp = smallSize;
      }
      var size = tmp;
      freeSlotsAt($this, address, size);
    }
  }
  function freeSlotsAt($this, address, size) {
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = size > 0;
    if (false && !value) {
      var tmp$ret$1 = 'Invalid freeSlotAt call';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var tmp0 = $this.q3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.clearRange' call
    var end = address + size | 0;
    if (end === (address + 1 | 0)) {
      tmp0[address] = get_Unallocated();
    } else {
      fill_0(tmp0, get_Unallocated(), address, end);
    }
    $this.u3u_1 = $this.u3u_1 + size | 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
    if (size > 15) {
      _get_largeSizes__ejlmqc($this).av(address);
    }
  }
  function growGroups($this) {
    var oldSize = $this.p3u_1.length;
    var newSize = coerceAtLeast(imul($this.p3u_1.length, 2), 768);
    $this.p3u_1 = copyOf($this.p3u_1, newSize);
    initGroups($this.p3u_1, oldSize);
  }
  function compactAndMaybeGrow($this, required) {
    var slots = $this.q3u_1;
    var currentSize = slots.length;
    var unallocatedSize = $this.t3u_1 - $this.s3u_1 | 0;
    var spaceUsed = slots.length - (unallocatedSize + $this.u3u_1 | 0) | 0;
    var spaceNeeded = spaceUsed + required | 0;
    var adjustedSpace = spaceNeeded + (slots.length >> 5) | 0;
    // Inline function 'kotlin.countLeadingZeroBits' call
    // Inline function 'kotlin.let' call
    var it = 1 << (32 - clz32(adjustedSpace) | 0);
    var newSize = it < currentSize ? currentSize : it;
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = (newSize - unallocatedSize | 0) > required;
    if (false && !value) {
      var tmp$ret$5 = 'Check failed';
      composeImmediateRuntimeError(tmp$ret$5);
    }
    var tmp;
    if (!(newSize === currentSize)) {
      tmp = newSlotsArray(coerceAtLeast(newSize, 256));
    } else {
      tmp = slots;
    }
    var newSlots = tmp;
    var newLargeSizes = mutableIntIntMapOf();
    var current = 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    var groupsEnd = $this.p3u_1[0 + 3 | 0];
    var mover = new SlotMoveManager(slots, newSlots);
    var nestedLast = groupsEnd - 1 | 0;
    var inductionVariable = 6;
    var last = getProgressionLastElement(6, nestedLast, 6);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 6 | 0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
        var slotRange = $this.p3u_1[index + 5 | 0];
        if (!(slotRange === -1)) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
          var smallSize = (slotRange & 15) + 1 | 0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
          var address = slotRange >> 4;
          var tmp_0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
          if (smallSize > 15) {
            tmp_0 = access$_get_largeSizes__q41gto($this).l1(address);
          } else {
            tmp_0 = smallSize;
          }
          var size = tmp_0;
          mover.m2y(current, address, address + size | 0);
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
          if (size > 15) {
            newLargeSizes.zu(current, size);
          }
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
          $this.p3u_1[index + 5 | 0] = slotRangeFromAddressAndSize(current, size);
          current = current + size | 0;
        }
      }
       while (!(index === last));
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(current === spaceUsed)) {
      var tmp$ret$16 = 'Unexpected slot compaction result, computed we had ' + spaceUsed + ' slots, but copied ' + ('' + current + ' slots');
      composeImmediateRuntimeError(tmp$ret$16);
    }
    $this.q3u_1 = mover.i4m();
    var tmp_1 = $this;
    // Inline function 'kotlin.takeIf' call
    var tmp_2;
    if (newLargeSizes.fv()) {
      tmp_2 = newLargeSizes;
    } else {
      tmp_2 = null;
    }
    tmp_1.r3u_1 = tmp_2;
    $this.s3u_1 = current;
    $this.t3u_1 = newSlots.length;
    $this.u3u_1 = 0;
  }
  function Companion_11() {
    Companion_instance_12 = this;
    this.a4m_1 = newGroupsArray(6);
    this.b4m_1 = newSlotsArray(0);
  }
  var Companion_instance_12;
  function Companion_getInstance_11() {
    if (Companion_instance_12 == null)
      new Companion_11();
    return Companion_instance_12;
  }
  function access$_get_largeSizes__q41gto($this) {
    return _get_largeSizes__ejlmqc($this);
  }
  function access$growGroups($this) {
    return growGroups($this);
  }
  function copyTreeFrom$copyGroup($sourceSpace, this$0, parent, address) {
    var sourceGroups = $sourceSpace.p3u_1;
    var sourceSlots = $sourceSpace.q3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var sourceFlags = sourceGroups[address + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.allocateGroup' call
    var key = sourceGroups[address + 0 | 0];
    // Inline function 'kotlin.let' call
    var it = access$groupAllocate$tSlotTableAddresSpaceKt(this$0.p3u_1, key, parent, sourceFlags);
    var tmp;
    if (it < 0) {
      access$growGroups(this$0);
      tmp = access$groupAllocate$tSlotTableAddresSpaceKt(this$0.p3u_1, key, parent, sourceFlags);
    } else {
      tmp = it;
    }
    var newGroupAddress = tmp;
    var anchor = this$0.j4m($sourceSpace, address, newGroupAddress);
    this$0.k4m($sourceSpace, anchor);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = sourceGroups[address + 5 | 0];
    if (!(slotRange === -1)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (slotRange & 15) + 1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var address_0 = slotRange >> 4;
      var tmp_0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        tmp_0 = access$_get_largeSizes__q41gto($sourceSpace).l1(address_0);
      } else {
        tmp_0 = smallSize;
      }
      var size = tmp_0;
      var newSlotRange = allocateSlots(this$0, size);
      var tmp2 = this$0.q3u_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var tmp4 = newSlotRange >> 4;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = address_0 + size | 0;
      arrayCopy(sourceSlots, tmp2, tmp4, address_0, endIndex);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      this$0.p3u_1[newGroupAddress + 5 | 0] = newSlotRange;
    }
    var previousSiblingAddress = -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    var currentChildAddress = sourceGroups[address + 3 | 0];
    while (!(currentChildAddress === -1)) {
      var newChildAddress = copyTreeFrom$copyGroup($sourceSpace, this$0, newGroupAddress, currentChildAddress);
      if (previousSiblingAddress === -1) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        this$0.p3u_1[newGroupAddress + 3 | 0] = newChildAddress;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
        this$0.p3u_1[previousSiblingAddress + 1 | 0] = newChildAddress;
      }
      previousSiblingAddress = newChildAddress;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      currentChildAddress = sourceGroups[currentChildAddress + 1 | 0];
    }
    return newGroupAddress;
  }
  function SlotTableAddressSpace(groups, slots) {
    Companion_getInstance_11();
    this.p3u_1 = groups;
    this.q3u_1 = slots;
    this.r3u_1 = null;
    this.s3u_1 = 0;
    this.t3u_1 = this.q3u_1.length;
    this.u3u_1 = 0;
    this.v3u_1 = mutableIntObjectMapOf();
    this.w3u_1 = null;
    this.x3u_1 = null;
  }
  protoOf(SlotTableAddressSpace).l4k = function (address) {
    removeSourceInformation(this, address);
    freeGroup(this, address);
  };
  protoOf(SlotTableAddressSpace).l4m = function () {
    var reserved = this.s3u_1;
    var end = this.t3u_1;
    this.s3u_1 = end;
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(reserved);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp = bitwiseAnd(fromInt(value), new Long(-1, 0));
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_1 = _UInt___init__impl__l7qpdl(end);
    // Inline function 'kotlin.uintToLong' call
    var value_0 = _UInt___get_data__impl__f0vqqw(this_1);
    var tmp$ret$4 = bitwiseAnd(fromInt(value_0), new Long(-1, 0));
    return bitwiseOr(tmp, shiftLeft(tmp$ret$4, 32));
  };
  protoOf(SlotTableAddressSpace).m4m = function (start, end) {
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = end >= start;
    if (false && !value) {
      var tmp$ret$1 = 'Invalid call to restoreSlots';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    if (end === this.t3u_1) {
      this.s3u_1 = start;
    }
  };
  protoOf(SlotTableAddressSpace).n4m = function (address, size) {
    _get_largeSizes__ejlmqc(this).zu(address, size);
  };
  protoOf(SlotTableAddressSpace).o4m = function (group, offset, value) {
    var groups = this.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var range = groups[group + 5 | 0];
    var tmp;
    if (range === -1) {
      var newRange = allocateSlots(this, offset + 1 | 0);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      groups[group + 5 | 0] = newRange;
      tmp = newRange;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (range & 15) + 1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var address = range >> 4;
      var tmp_0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        tmp_0 = access$_get_largeSizes__q41gto(this).l1(address);
      } else {
        tmp_0 = smallSize;
      }
      var size = tmp_0;
      var tmp_1;
      if (offset >= size) {
        tmp_1 = growSlotRangeAtGroup(this, group, size, offset + 1 | 0);
      } else {
        tmp_1 = range;
      }
      tmp = tmp_1;
    }
    var newRange_0 = tmp;
    var tmp_2 = this.q3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    tmp_2[(newRange_0 >> 4) + offset | 0] = value;
    return newRange_0;
  };
  protoOf(SlotTableAddressSpace).t4b = function (group) {
    var tmp0_safe_receiver = this.w3u_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.v3u_1.l1(group);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = tmp0_safe_receiver.w2(tmp0_safe_receiver_0);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(SlotTableAddressSpace).p4m = function (parent, sourceInformation, group) {
    var sourceInformationMap = this.w3u_1;
    if (sourceInformationMap == null) {
      sourceInformationMap = mutableScatterMapOf();
      this.w3u_1 = sourceInformationMap;
    }
    var tmp0 = sourceInformationMap;
    // Inline function 'androidx.collection.MutableScatterMap.getOrPut' call
    var key = this.u3v(parent);
    var tmp0_elvis_lhs = tmp0.w2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new LinkGroupSourceInformation(0, sourceInformation, 0);
      if (sourceInformation == null) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        var child = this.p3u_1[parent + 3 | 0];
        while (!(child === group) && !(child === -1)) {
          this_0.h4k(this.u3v(child));
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          child = this.p3u_1[child + 1 | 0];
        }
      }
      // Inline function 'kotlin.also' call
      tmp0.h13(key, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(SlotTableAddressSpace).q4m = function (key, parentKey) {
    var calledByMap = this.x3u_1;
    if (calledByMap == null) {
      calledByMap = mutableIntObjectMapOf();
      this.x3u_1 = calledByMap;
    }
    // Inline function 'androidx.collection.MutableIntObjectMap.getOrPut' call
    var this_0 = calledByMap;
    var tmp0_elvis_lhs = this_0.l1(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_1 = mutableIntSetOf();
      this_0.ew(key, this_1);
      tmp = this_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    tmp.pv(parentKey);
  };
  protoOf(SlotTableAddressSpace).r4m = function (group, size, newSize) {
    var tmp;
    if (newSize === size) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      tmp = this.p3u_1[group + 5 | 0];
    } else if (newSize > size) {
      tmp = growSlotRangeAtGroup(this, group, size, newSize);
    } else {
      tmp = shrinkSlotRangeAtGroup(this, group, size, newSize);
    }
    return tmp;
  };
  protoOf(SlotTableAddressSpace).s4m = function (group, newSize) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = this.p3u_1[group + 5 | 0];
    var tmp;
    if (!(slotRange === -1) || !(newSize === 0)) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotSize' call
        if (slotRange === -1) {
          tmp$ret$1 = 0;
          break $l$block;
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
        var smallSize = (slotRange & 15) + 1 | 0;
        var tmp_0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
        if (smallSize > 15) {
          var tmp_1 = access$_get_largeSizes__q41gto(this);
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
          var tmp$ret$4 = slotRange >> 4;
          tmp_0 = tmp_1.l1(tmp$ret$4);
        } else {
          tmp_0 = smallSize;
        }
        tmp$ret$1 = tmp_0;
      }
      tmp = this.r4m(group, tmp$ret$1, newSize);
    } else {
      tmp = slotRange;
    }
    return tmp;
  };
  protoOf(SlotTableAddressSpace).t4m = function (sourceSpace, sourceAddress) {
    return copyTreeFrom$copyGroup(sourceSpace, this, -1, sourceAddress);
  };
  protoOf(SlotTableAddressSpace).u4m = function (group, previous) {
    var tmp0_elvis_lhs = this.w3u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var sourceInformationMap = tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    var parent = this.p3u_1[group + 2 | 0];
    var tmp1_elvis_lhs = this.v3u_1.l1(parent);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var anchor = tmp_0;
    var tmp2_elvis_lhs = sourceInformationMap.w2(anchor);
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var parentInformation = tmp_1;
    var previousAnchor = !(previous === -1) ? this.u3v(previous) : null;
    parentInformation.i4k(previousAnchor, this.u3v(group));
  };
  protoOf(SlotTableAddressSpace).u3v = function (address) {
    if (address === -1)
      return get_NullAnchor();
    else if (address === 0)
      return get_LazyAnchor();
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(address >= 0)) {
      var tmp$ret$1 = 'Invalid anchor address ' + address;
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.collection.MutableIntObjectMap.getOrPut' call
    var this_0 = this.v3u_1;
    var tmp0_elvis_lhs = this_0.l1(address);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_1 = new LinkAnchor(address);
      this_0.ew(address, this_1);
      tmp = this_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(SlotTableAddressSpace).p4k = function (anchor) {
    return this.v3u_1.l1(anchor.m3v_1) === anchor;
  };
  protoOf(SlotTableAddressSpace).j4m = function (sourceSpace, oldAddress, newAddress) {
    // Inline function 'androidx.collection.IntObjectMap.contains' call
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = !this.v3u_1.hv(newAddress);
    if (false && !value) {
      var tmp$ret$2 = 'Anchor already exists for group address ' + newAddress;
      composeImmediateRuntimeError(tmp$ret$2);
    }
    var tmp0_safe_receiver = sourceSpace.v3u_1.gw(oldAddress);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.m3v_1 = newAddress;
      this.v3u_1.ew(newAddress, tmp0_safe_receiver);
      tmp = tmp0_safe_receiver;
    }
    return tmp;
  };
  protoOf(SlotTableAddressSpace).k4m = function (sourceSpace, anchor) {
    if (anchor == null)
      return Unit_instance;
    var tmp0_elvis_lhs = sourceSpace.w3u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var sourceSourceInformationMap = tmp;
    var tmp1_elvis_lhs = sourceSourceInformationMap.w2(anchor);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var sourceInformation = tmp_0;
    var thisSourceInformationMap = this.w3u_1;
    if (thisSourceInformationMap == null) {
      thisSourceInformationMap = mutableScatterMapOf();
      this.w3u_1 = thisSourceInformationMap;
    } else {
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = !thisSourceInformationMap.d6(anchor);
      if (false && !value) {
        var tmp$ret$1 = 'Source information already exists for group ' + anchor.m3v_1;
        composeImmediateRuntimeError(tmp$ret$1);
      }
    }
    thisSourceInformationMap.h13(anchor, sourceInformation);
    sourceSourceInformationMap.a3(anchor);
  };
  protoOf(SlotTableAddressSpace).o3x = function (groupAddress, common) {
    var current = groupAddress;
    var depth = 0;
    var groups = this.p3u_1;
    while (!(current === common) && current >= 0) {
      depth = depth + 1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups[current + 2 | 0];
    }
    return depth;
  };
  protoOf(SlotTableAddressSpace).dm = function (group) {
    var tmp;
    if (group > 0) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
      tmp = group < this.p3u_1[0 + 3 | 0];
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SlotTableAddressSpace).p1b = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q('SlotTableAddressSpace:\n');
    var groups = this.p3u_1;
    this_0.q('  Group size: ');
    this_0.ed(groups.length);
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    this_0.q('  Slots size: ');
    this_0.ed(this.q3u_1.length);
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    this_0.q(' Groups:');
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    var unallocatedGroupsStart = groups[0 + 3 | 0];
    var unallocatedGroupSize = (groups.length - unallocatedGroupsStart | 0) / 6 | 0;
    this_0.q('  Unallocated groups: ');
    this_0.ed(unallocatedGroupSize);
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    var freeGroupCount = 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    var currentFreeGroup = groups[0 + 1 | 0];
    while (!(currentFreeGroup === -1)) {
      freeGroupCount = freeGroupCount + 1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      currentFreeGroup = groups[currentFreeGroup + 1 | 0];
    }
    this_0.q('  Free groups:        ');
    this_0.ed(freeGroupCount);
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    var totalFreeGroups = freeGroupCount + unallocatedGroupSize | 0;
    this_0.q('  Total free groups:  ');
    this_0.ed(totalFreeGroups);
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    this_0.q('  Used group%:        ');
    var usedGroups = (groups.length / 6 | 0) - totalFreeGroups | 0;
    var availableGroups = groups.length / 6 | 0;
    this_0.hd(usedGroups / availableGroups);
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    this_0.q(' Slots:');
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    var unallocatedSlotsSize = this.t3u_1 - this.s3u_1 | 0;
    this_0.q('  Unallocated slots: ');
    this_0.ed(unallocatedSlotsSize);
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    this_0.q('  Slot used%:    ');
    var availableSlots = this.q3u_1.length;
    var usedSlots = (availableSlots - this.u3u_1 | 0) - unallocatedSlotsSize | 0;
    this_0.hd(usedSlots / availableSlots);
    // Inline function 'kotlin.text.appendLine' call
    this_0.s(_Char___init__impl__6a9atx(10));
    return this_0.toString();
  };
  function newGroupsArray(capacity) {
    _init_properties_SlotTableAddresSpace_kt__s94bxz();
    var array = new Int32Array(capacity);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    array[0 + 1 | 0] = -1;
    initGroups(array, 6);
    return array;
  }
  function newSlotsArray(capacity) {
    _init_properties_SlotTableAddresSpace_kt__s94bxz();
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.apply' call
    var this_0 = Array(capacity);
    fill_0(this_0, get_Unallocated());
    return this_0;
  }
  function groupAllocate(_this__u8e3s4, key, parent, flags) {
    _init_properties_SlotTableAddresSpace_kt__s94bxz();
    if (_this__u8e3s4 == null || _this__u8e3s4.length < 6)
      return -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    // Inline function 'kotlin.let' call
    var it = _this__u8e3s4[0 + 3 | 0];
    var tmp;
    if (it >= _this__u8e3s4.length) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      var nextFree = _this__u8e3s4[0 + 1 | 0];
      if (nextFree < 0)
        return -1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      _this__u8e3s4[0 + 1 | 0] = _this__u8e3s4[nextFree + 1 | 0];
      tmp = nextFree;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
      _this__u8e3s4[0 + 3 | 0] = it + 6 | 0;
      tmp = it;
    }
    var address = tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
    _this__u8e3s4[address + 0 | 0] = key;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    _this__u8e3s4[address + 2 | 0] = parent;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    _this__u8e3s4[address + 1 | 0] = -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    _this__u8e3s4[address + 3 | 0] = -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    _this__u8e3s4[address + 4 | 0] = flags;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    _this__u8e3s4[address + 5 | 0] = -1;
    return address;
  }
  function slotRangeFromAddressAndSize(address, size) {
    _init_properties_SlotTableAddresSpace_kt__s94bxz();
    var tmp = address << 4;
    var tmp_0;
    if (size > 15) {
      tmp_0 = 15;
    } else {
      tmp_0 = size - 1 | 0;
    }
    return tmp | tmp_0;
  }
  function initGroups(_this__u8e3s4, offset) {
    _init_properties_SlotTableAddresSpace_kt__s94bxz();
    if (_this__u8e3s4 == null)
      return Unit_instance;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    _this__u8e3s4[0 + 1 | 0] = -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    _this__u8e3s4[0 + 3 | 0] = offset;
  }
  function flush($this) {
    if ($this.e4m_1 >= 0) {
      var source = $this.c4m_1;
      var tmp2 = $this.d4m_1;
      var tmp4 = $this.e4m_1;
      var tmp6 = $this.f4m_1;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = $this.g4m_1;
      arrayCopy(source, tmp2, tmp4, tmp6, endIndex);
      if (source === $this.d4m_1) {
        fill_0(source, get_Unallocated(), $this.f4m_1, $this.g4m_1);
      }
      var end = $this.e4m_1 + ($this.g4m_1 - $this.f4m_1 | 0) | 0;
      $this.e4m_1 = -1;
      $this.g4m_1 = -1;
      if (end > $this.h4m_1)
        $this.h4m_1 = end;
    }
  }
  function SlotMoveManager(source, destination) {
    this.c4m_1 = source;
    this.d4m_1 = destination;
    this.e4m_1 = -1;
    this.f4m_1 = -1;
    this.g4m_1 = -1;
    this.h4m_1 = -1;
  }
  protoOf(SlotMoveManager).m2y = function (destinationOffset, startIndex, endIndex) {
    if (this.c4m_1 === this.d4m_1) {
      if (startIndex === destinationOffset)
        return Unit_instance;
      var destinationEnd = destinationOffset + (endIndex - startIndex | 0) | 0;
      var tmp0 = this.d4m_1;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.allUnallocated' call
        var end = destinationOffset + destinationEnd | 0;
        if (end >= tmp0.length) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var inductionVariable = destinationOffset;
        if (inductionVariable < end)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(tmp0[i] === get_Unallocated())) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
           while (inductionVariable < end);
        tmp$ret$0 = true;
      }
      if (!tmp$ret$0) {
        var tmp = this;
        // Inline function 'kotlin.collections.copyOf' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d4m_1 = this.c4m_1.slice();
      }
    }
    if (this.g4m_1 === startIndex) {
      this.g4m_1 = endIndex;
    } else {
      flush(this);
      this.e4m_1 = destinationOffset;
      this.f4m_1 = startIndex;
      this.g4m_1 = endIndex;
    }
  };
  protoOf(SlotMoveManager).i4m = function () {
    flush(this);
    if (this.h4m_1 >= 0 && this.h4m_1 < this.d4m_1.length) {
      var tmp0 = this.d4m_1;
      var tmp2 = this.h4m_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.clearRange' call
      var end = this.d4m_1.length;
      if (end === (tmp2 + 1 | 0)) {
        tmp0[tmp2] = get_Unallocated();
      } else {
        fill_0(tmp0, get_Unallocated(), tmp2, end);
      }
    }
    return this.d4m_1;
  };
  function buildTrace(_this__u8e3s4, group, child, traceBuilder) {
    _init_properties_SlotTableAddresSpace_kt__s94bxz();
    var childData = child;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups = _this__u8e3s4.p3u_1;
    var tmp;
    if (!true) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups[group + 2 | 0];
    } else {
      tmp = group;
    }
    var current = tmp;
    while (current > 0) {
      var currentGroup = current;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      var flags = _this__u8e3s4.p3u_1[currentGroup + 4 | 0];
      var tmp_0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      if ((16777216 & flags) === 16777216) {
        var tmp_1 = _this__u8e3s4.q3u_1;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
        var tmp_2 = _this__u8e3s4.p3u_1[currentGroup + 5 | 0] >> 4;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.objectKeySlotIndex' call
        tmp_0 = tmp_1[tmp_2 + countOneBits(flags & 8388608) | 0];
      } else {
        tmp_0 = null;
      }
      var objectKey = tmp_0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
      var tmp$ret$8 = _this__u8e3s4.p3u_1[currentGroup + 0 | 0];
      traceBuilder.w4m(tmp$ret$8, objectKey, _this__u8e3s4.t4b(currentGroup), childData);
      childData = _this__u8e3s4.u3v(currentGroup);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$11 = 'Traversing parent of group not in the slot table: ' + group;
      composeImmediateRuntimeError(tmp$ret$11);
    }
    return traceBuilder.x4m();
  }
  function access$groupAllocate$tSlotTableAddresSpaceKt($receiver, key, parent, flags) {
    return groupAllocate($receiver, key, parent, flags);
  }
  function Unallocated$1() {
  }
  protoOf(Unallocated$1).toString = function () {
    return 'Unallocated';
  };
  var properties_initialized_SlotTableAddresSpace_kt_g1zt3;
  function _init_properties_SlotTableAddresSpace_kt__s94bxz() {
    if (!properties_initialized_SlotTableAddresSpace_kt_g1zt3) {
      properties_initialized_SlotTableAddresSpace_kt_g1zt3 = true;
      Unallocated = new Unallocated$1();
      androidx_compose_runtime_composer_linkbuffer_SlotTableAddressSpace$stable = 8;
      androidx_compose_runtime_composer_linkbuffer_SlotMoveManager$stable = 8;
    }
  }
  var androidx_compose_runtime_composer_linkbuffer_SlotTableBuilder$stable;
  var androidx_compose_runtime_composer_linkbuffer_BuilderTraceBuilder$stable;
  function SlotTableBuilder_init_$Init$(addressSpace, recordSourceInformation, recordCallByInformation, $this) {
    SlotTableBuilder.call($this, new SlotTable_0(VOID, addressSpace, recordSourceInformation, recordCallByInformation), recordSourceInformation, recordCallByInformation);
    return $this;
  }
  function SlotTableBuilder_init_$Create$(addressSpace, recordSourceInformation, recordCallByInformation) {
    return SlotTableBuilder_init_$Init$(addressSpace, recordSourceInformation, recordCallByInformation, objectCreate(protoOf(SlotTableBuilder)));
  }
  function startNewGroup($this, key, flags, objectKey, aux, node) {
    var parent = $this.c3t_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.allocateGroup' call
    var this_0 = $this.b3t_1;
    // Inline function 'kotlin.let' call
    var it = access$groupAllocate$tSlotTableAddresSpaceKt(this_0.p3u_1, key, parent, flags);
    var tmp;
    if (it < 0) {
      access$growGroups(this_0);
      tmp = access$groupAllocate$tSlotTableAddresSpaceKt(this_0.p3u_1, key, parent, flags);
    } else {
      tmp = it;
    }
    var group = tmp;
    var groups = $this.b3t_1.p3u_1;
    var previousSibling = $this.e3t_1;
    if (previousSibling === -1) {
      if (parent === -1) {
        $this.y3s_1.i3u_1 = group;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        groups[parent + 3 | 0] = group;
      }
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      groups[previousSibling + 1 | 0] = group;
    }
    $this.d3t_1.g3i(parent);
    $this.f3t_1.g3i(previousSibling);
    $this.c3t_1 = group;
    $this.e3t_1 = -1;
    if (!(parent === -1)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChildNodeCount' call
      var value = $this.g3t_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      var newFlags = groups[parent + 4 | 0] & -8388608 | value;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      groups[parent + 4 | 0] = newFlags;
    }
    $this.g3t_1 = 0;
    saveSlotRange($this, parent);
    var newStart = $this.o3t_1;
    $this.i3t_1 = newStart;
    $this.j3t_1 = newStart;
    $this.k3t_1 = $this.n3t_1;
    $this.l3t_1 = true;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      $this.b3x(node);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((16777216 & flags) === 16777216) {
      $this.b3x(objectKey);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((33554432 & flags) === 33554432) {
      $this.b3x(aux);
    }
    var modifiedCurrent = $this.j3t_1;
    var modifiedStart = $this.i3t_1;
    if (modifiedCurrent > modifiedStart) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      groups[group + 5 | 0] = slotRangeFromAddressAndSize(modifiedStart, modifiedCurrent - modifiedStart | 0);
    }
    if ($this.z3s_1 && parent >= 0) {
      $this.b3t_1.p4m(parent, null, group).h4k($this.b3t_1.u3v(group));
    }
  }
  function buildEnd($this) {
    if (!($this.c3t_1 === -1)) {
      saveSlotRange($this, $this.c3t_1);
    }
    returnReservedSlotRegion($this);
  }
  function saveSlotRange($this, group) {
    if (group < 0)
      return 0;
    var groups = $this.b3t_1.p3u_1;
    var slotCurrent = $this.j3t_1;
    var slotAddress = $this.i3t_1;
    if (slotCurrent > slotAddress) {
      var tmp;
      if ($this.l3t_1) {
        var slotSize = slotCurrent - slotAddress | 0;
        var slotRange = slotRangeFromAddressAndSize(slotAddress, slotSize);
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
        if (slotSize > 15) {
          $this.b3t_1.n4m(slotAddress, slotSize);
        }
        $this.o3t_1 = slotCurrent;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
        groups[group + 5 | 0] = slotRange;
        tmp = slotSize;
      } else {
        var slotSize_0 = slotCurrent - slotAddress | 0;
        var slotAllocated = $this.k3t_1 - slotAddress | 0;
        if (!(slotAllocated === slotSize_0)) {
          $this.b3t_1.r4m(group, slotAllocated, slotSize_0);
        }
        tmp = slotSize_0;
      }
      var slotSize_1 = tmp;
      return slotSize_1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      groups[group + 5 | 0] = -1;
      return 0;
    }
  }
  function restoreFromSlotRange($this, group) {
    var groups = $this.b3t_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = groups[group + 5 | 0];
    if (!(slotRange === -1)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
      var this_0 = $this.b3t_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (slotRange & 15) + 1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var address = slotRange >> 4;
      var tmp;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        tmp = access$_get_largeSizes__q41gto(this_0).l1(address);
      } else {
        tmp = smallSize;
      }
      var size = tmp;
      $this.i3t_1 = address;
      var end = address + size | 0;
      $this.k3t_1 = end;
      $this.j3t_1 = end;
      $this.l3t_1 = false;
    } else {
      var reserve = $this.o3t_1;
      $this.i3t_1 = reserve;
      $this.j3t_1 = reserve;
      $this.k3t_1 = $this.n3t_1;
      $this.l3t_1 = true;
    }
  }
  function reserveSlotSlotRegion($this) {
    var reservation = $this.b3t_1.l4m();
    var start = convertToInt(reservation);
    var end = convertToInt(shiftRightUnsigned(reservation, 32));
    $this.m3t_1 = start;
    $this.o3t_1 = start;
    $this.n3t_1 = end;
  }
  function returnReservedSlotRegion($this) {
    if (!($this.m3t_1 === $this.n3t_1)) {
      $this.b3t_1.m4m($this.o3t_1, $this.n3t_1);
      $this.m3t_1 = 0;
      $this.o3t_1 = 0;
      $this.n3t_1 = 0;
    }
  }
  function slowAppend($this, value) {
    var parent = $this.c3t_1;
    var size = saveSlotRange($this, parent);
    returnReservedSlotRegion($this);
    $this.b3t_1.o4m(parent, size, value);
    $this.h3t_1 = $this.b3t_1.q3u_1;
    reserveSlotSlotRegion($this);
    restoreFromSlotRange($this, parent);
  }
  function access$startNewGroup($this, key, flags, objectKey, aux, node) {
    return startNewGroup($this, key, flags, objectKey, aux, node);
  }
  function SlotTableBuilder(table, recordSourceInformation, recordCallByInformation) {
    this.y3s_1 = table;
    this.z3s_1 = recordSourceInformation;
    this.a3t_1 = recordCallByInformation;
    this.b3t_1 = this.y3s_1.j3u_1;
    this.c3t_1 = -1;
    this.d3t_1 = new IntStack();
    var tmp = this;
    var tmp0 = this.y3s_1.i3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.lastSiblingOf' call
    var addressSpace = this.b3t_1;
    var tmp_0;
    if (tmp0 === -1) {
      tmp_0 = -1;
    } else {
      var last = -1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseSiblings' call
      var groups = addressSpace.p3u_1;
      var current = tmp0;
      while (current >= 0) {
        last = current;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
        current = groups[current + 1 | 0];
      }
      tmp_0 = last;
    }
    tmp.e3t_1 = tmp_0;
    this.f3t_1 = new IntStack();
    this.g3t_1 = 0;
    this.h3t_1 = this.b3t_1.q3u_1;
    this.i3t_1 = 0;
    this.j3t_1 = 0;
    this.k3t_1 = 0;
    this.l3t_1 = false;
    this.m3t_1 = 0;
    this.n3t_1 = 0;
    this.o3t_1 = 0;
    this.p3t_1 = false;
  }
  protoOf(SlotTableBuilder).oy = function () {
    return this.c3t_1 === -1;
  };
  protoOf(SlotTableBuilder).k3s = function () {
    return this.c3t_1;
  };
  protoOf(SlotTableBuilder).s3w = function () {
    return this.b3t_1.u3v(this.k3s());
  };
  protoOf(SlotTableBuilder).y4m = function () {
    return this.j3t_1 - this.i3t_1 | 0;
  };
  protoOf(SlotTableBuilder).z3u = function () {
    var tmp;
    // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
    if (this.f3t_1.f3i_1 === 0) {
      tmp = -1;
    } else {
      tmp = this.f3t_1.v3n();
    }
    var tmp0 = tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var group = this.c3t_1;
    var tmp_0 = shiftLeft(fromInt(tmp0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$3 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    return bitwiseOr(tmp_0, tmp$ret$3);
  };
  protoOf(SlotTableBuilder).t3j = function (address) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
    return this.b3t_1.p3u_1[address + 0 | 0];
  };
  protoOf(SlotTableBuilder).u3j = function (address) {
    // Inline function 'kotlin.let' call
    var it = this.b3t_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var flags = it[address + 4 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((16777216 & flags) === 16777216) {
      var tmp_0 = this.h3t_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var tmp_1 = it[address + 5 | 0] >> 4;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.objectKeySlotIndex' call
      tmp = tmp_0[tmp_1 + countOneBits(flags & 8388608) | 0];
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SlotTableBuilder).s3j = function (address) {
    // Inline function 'kotlin.let' call
    var it = this.b3t_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var flags = it[address + 4 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((33554432 & flags) === 33554432) {
      var tmp_0 = this.h3t_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var tmp_1 = it[address + 5 | 0] >> 4;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.auxSlotIndex' call
      tmp = tmp_0[tmp_1 + countOneBits(flags & 25165824) | 0];
    } else {
      tmp = Companion_getInstance_0().f30_1;
    }
    return tmp;
  };
  protoOf(SlotTableBuilder).a3v = function () {
    var last = this.y3s_1.i3u_1;
    var previous = -1;
    if (!(last === -1)) {
      var tmp0 = this.b3t_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseSiblingsAfter' call
      var group = this.y3s_1.i3u_1;
      var groups = tmp0.p3u_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      var current = groups[group + 1 | 0];
      while (current >= 0) {
        var group_0 = current;
        previous = last;
        last = group_0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
        current = groups[current + 1 | 0];
      }
    }
    var tmp0_0 = previous;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var group_1 = last;
    var tmp = shiftLeft(fromInt(tmp0_0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group_1);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$6 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    return bitwiseOr(tmp, tmp$ret$6);
  };
  protoOf(SlotTableBuilder).y34 = function (address) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    return this.b3t_1.p3u_1[address + 2 | 0];
  };
  protoOf(SlotTableBuilder).k3v = function () {
    reserveSlotSlotRegion(this);
  };
  protoOf(SlotTableBuilder).z35 = function () {
    var previousParent = this.c3t_1;
    var groups = this.b3t_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChildNodeCount' call
    var value = this.g3t_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
    var newFlags = groups[previousParent + 4 | 0] & -8388608 | value;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    groups[previousParent + 4 | 0] = newFlags;
    saveSlotRange(this, previousParent);
    var newParent = this.d3t_1.k3j();
    this.c3t_1 = newParent;
    var previousSibling = this.f3t_1.k3j();
    var tmp = this;
    var tmp_0;
    if (previousSibling === -1) {
      var tmp_1;
      if (newParent === -1) {
        tmp_1 = this.y3s_1.i3u_1;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        tmp_1 = groups[newParent + 3 | 0];
      }
      tmp_0 = tmp_1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      tmp_0 = groups[previousSibling + 1 | 0];
    }
    tmp.e3t_1 = tmp_0;
    restoreFromSlotRange(this, this.c3t_1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNodeCount' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var flags = groups[previousParent + 4 | 0];
    var tmp_2;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp_2 = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp_2 = flags & 8388607;
    }
    var nodeGroupCount = tmp_2;
    var tmp_3 = this;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChildNodeCount' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
    tmp_3.g3t_1 = (groups[this.c3t_1 + 4 | 0] & 8388607) + nodeGroupCount | 0;
    return nodeGroupCount;
  };
  protoOf(SlotTableBuilder).b3x = function (value) {
    if (this.j3t_1 < this.k3t_1) {
      var tmp = this.h3t_1;
      var _unary__edvuaz = this.j3t_1;
      this.j3t_1 = _unary__edvuaz + 1 | 0;
      tmp[_unary__edvuaz] = value;
      return Unit_instance;
    }
    slowAppend(this, value);
  };
  protoOf(SlotTableBuilder).s3v = function (flags) {
    var groups = this.b3t_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var newFlags = flags | groups[this.c3t_1 + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    groups[this.c3t_1 + 4 | 0] = newFlags;
    var propagatingFlags = propagatingFlagsOf(newFlags);
    if (!(propagatingFlags === 0)) {
      var tmp0 = this.b3t_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseParents' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
      var group = this.c3t_1;
      var groups_0 = tmp0.p3u_1;
      var tmp;
      if (!false) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        tmp = groups_0[group + 2 | 0];
      } else {
        tmp = group;
      }
      var current = tmp;
      while (current > 0) {
        var it = current;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        var flags_0 = groups[it + 4 | 0];
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
        if ((propagatingFlags & flags_0) === propagatingFlags)
          return Unit_instance;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        groups[it + 4 | 0] = flags_0 | propagatingFlags;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        current = groups_0[current + 2 | 0];
      }
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!!(current === 0)) {
        var tmp$ret$11 = 'Traversing parent of group not in the slot table: ' + group;
        composeImmediateRuntimeError(tmp$ret$11);
      }
    }
  };
  protoOf(SlotTableBuilder).z4k = function (sourceEditor, sourceHandle) {
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = equals(sourceEditor.h3v_1, this.b3t_1);
    if (false && !value) {
      var tmp$ret$1 = 'Cannot move groups to a build from a separate address space';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var previous = sourceEditor.o3v();
    sourceEditor.z4m(sourceHandle);
    sourceEditor.a4n(false);
    sourceEditor.z4m(previous);
    var group = get_group(sourceHandle);
    var groups = this.b3t_1.p3u_1;
    var parent = this.c3t_1;
    var previousSibling = this.e3t_1;
    if (previousSibling === -1) {
      if (parent === -1) {
        this.y3s_1.i3u_1 = group;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        groups[parent + 3 | 0] = group;
      }
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      groups[previousSibling + 1 | 0] = group;
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    groups[group + 2 | 0] = parent;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    groups[group + 1 | 0] = -1;
    this.e3t_1 = group;
    var tmp = this;
    var tmp_0 = this.g3t_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNodeCount' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var flags = groups[group + 4 | 0];
    var tmp_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp_1 = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp_1 = flags & 8388607;
    }
    tmp.g3t_1 = tmp_0 + tmp_1 | 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var tmp$ret$11 = groups[group + 4 | 0];
    var propagatingFlags = propagatingFlagsOf(tmp$ret$11);
    if (!(propagatingFlags === 0)) {
      // Inline function 'kotlin.run' call
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
        var groups_0 = this.b3t_1.p3u_1;
        var tmp_2;
        if (!true) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
          tmp_2 = groups_0[parent + 2 | 0];
        } else {
          tmp_2 = parent;
        }
        var current = tmp_2;
        while (current > 0) {
          var ancestor = current;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
          var ancestorFlags = groups[ancestor + 4 | 0];
          var alreadyHave = ancestorFlags & propagatingFlags;
          if (!(alreadyHave === propagatingFlags)) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
            groups[ancestor + 4 | 0] = ancestorFlags | propagatingFlags;
          } else {
            break $l$block;
          }
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
          current = groups_0[current + 2 | 0];
        }
        // Inline function 'androidx.compose.runtime.runtimeCheck' call
        if (!!(current === 0)) {
          var tmp$ret$21 = 'Traversing parent of group not in the slot table: ' + parent;
          composeImmediateRuntimeError(tmp$ret$21);
        }
      }
    }
  };
  protoOf(SlotTableBuilder).y3o = function (sourceInformation) {
    if (this.z3s_1) {
      this.b3t_1.p4m(this.c3t_1, sourceInformation, -1);
    }
  };
  protoOf(SlotTableBuilder).z3o = function (key, sourceInformation) {
    if (this.a3t_1) {
      this.b3t_1.q4m(key, this.t3j(this.c3t_1));
    }
    if (this.z3s_1) {
      this.b3t_1.p4m(this.c3t_1, null, -1).x4c(key, sourceInformation, this.j3t_1 - this.i3t_1 | 0);
    }
  };
  protoOf(SlotTableBuilder).a3p = function () {
    if (this.z3s_1) {
      this.b3t_1.p4m(this.c3t_1, null, -1).y4c(this.j3t_1 - this.i3t_1 | 0);
    }
  };
  protoOf(SlotTableBuilder).j4 = function () {
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = !this.p3t_1;
    if (false && !value) {
      var tmp$ret$1 = 'Closing an already closed builder';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.p3t_1 = true;
  };
  protoOf(SlotTableBuilder).g3d = function () {
    buildEnd(this);
    this.j4();
    return this.y3s_1;
  };
  function buildTrace_0(_this__u8e3s4) {
    if (!_this__u8e3s4.p3t_1 && !_this__u8e3s4.oy()) {
      return buildTrace(_this__u8e3s4.y3s_1.j3u_1, _this__u8e3s4.k3s(), _this__u8e3s4.y4m(), new BuilderTraceBuilder(_this__u8e3s4));
    }
    return emptyList();
  }
  function BuilderTraceBuilder(builder) {
    ComposeStackTraceBuilder.call(this);
    this.c4n_1 = builder;
  }
  protoOf(BuilderTraceBuilder).d4n = function (anchor) {
    return this.c4n_1.y3s_1.j3u_1.t4b(asLinkAnchor(anchor).m3v_1);
  };
  protoOf(BuilderTraceBuilder).e4n = function (anchor) {
    return this.c4n_1.t3j(asLinkAnchor(anchor).m3v_1);
  };
  var androidx_compose_runtime_composer_linkbuffer_SlotTableEditor$stable;
  var androidx_compose_runtime_composer_linkbuffer_EditorTraceBuilder$stable;
  function insertGroup($this, group) {
    var previousSibling = $this.j3v_1;
    var parent = $this.f3v_1;
    var groups = $this.h3v_1.p3u_1;
    if (previousSibling === -1) {
      if (parent === -1)
        $this.e3v_1.i3u_1 = group;
      else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        groups[parent + 3 | 0] = group;
      }
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      groups[previousSibling + 1 | 0] = group;
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    groups[group + 2 | 0] = parent;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    groups[group + 1 | 0] = $this.g3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var flags = groups[group + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp = flags & 8388607;
    }
    var nodeCountDelta = tmp;
    $this.g3v_1 = group;
    var flagsToAdd = propagatingFlagsOf(flags);
    propagateChanges($this, group, nodeCountDelta, 0, flagsToAdd, false);
  }
  function VisitSlotsInRememberOrderCallback() {
  }
  function propagateChanges($this, group, nodeCountDelta, flagsToRemove, flagsToAdd, removingGroup) {
    var effectiveNodeCountDelta = nodeCountDelta;
    var effectiveFlagsToRemove = flagsToRemove;
    var effectiveFlagsToAdd = flagsToAdd;
    var groups = $this.h3v_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseParents' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups_0 = $this.h3v_1.p3u_1;
    var tmp;
    if (!false) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups_0[group + 2 | 0];
    } else {
      tmp = group;
    }
    var current = tmp;
    while (current > 0) {
      var current_0 = current;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      var flags = groups[current_0 + 4 | 0];
      if (!(effectiveNodeCountDelta === 0)) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChildNodeCount' call
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
        var nodes = groups[current_0 + 4 | 0] & 8388607;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChildNodeCount' call
        var value = nodes + effectiveNodeCountDelta | 0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
        var newFlags = groups[current_0 + 4 | 0] & -8388608 | value;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        groups[current_0 + 4 | 0] = newFlags;
        flags = newFlags;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
        if ((8388608 & flags) === 8388608)
          effectiveNodeCountDelta = 0;
      }
      var computedFlagsToRemove = 0;
      if (!(effectiveFlagsToRemove === 0)) {
        var flagsToCheck = effectiveFlagsToRemove | effectiveFlagsToRemove >> 1;
        // Inline function 'kotlin.run' call
        $l$block: {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseChildren' call
          var groups_1 = $this.h3v_1.p3u_1;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
          var current_1 = groups_1[current_0 + 3 | 0];
          while (current_1 > 0) {
            var child = current_1;
            var tmp_0;
            if (!removingGroup || !(child === group)) {
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
              tmp_0 = !((flagsToCheck & groups[child + 4 | 0]) === 0);
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              computedFlagsToRemove = 0;
              break $l$block;
            }
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
            current_1 = groups_1[current_1 + 1 | 0];
          }
          computedFlagsToRemove = effectiveFlagsToRemove;
        }
      }
      if (!(computedFlagsToRemove === 0) || !(effectiveFlagsToAdd === 0)) {
        var newFlags_0 = flags & ~computedFlagsToRemove | effectiveFlagsToAdd;
        if (!(newFlags_0 === flags)) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
          groups[current_0 + 4 | 0] = newFlags_0;
          effectiveFlagsToRemove = computedFlagsToRemove;
        } else {
          effectiveFlagsToAdd = 0;
        }
      } else {
        effectiveFlagsToAdd = 0;
      }
      if (effectiveNodeCountDelta === 0 && effectiveFlagsToRemove === 0 && effectiveFlagsToAdd === 0) {
        return Unit_instance;
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups_0[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$23 = 'Traversing parent of group not in the slot table: ' + group;
      composeImmediateRuntimeError(tmp$ret$23);
    }
  }
  function SlotTableEditor(table) {
    this.e3v_1 = table;
    this.f3v_1 = -1;
    this.g3v_1 = this.e3v_1.i3u_1;
    this.h3v_1 = this.e3v_1.j3u_1;
    this.i3v_1 = false;
    this.j3v_1 = -1;
  }
  protoOf(SlotTableEditor).h3u = function () {
    return this.g3v_1;
  };
  protoOf(SlotTableEditor).k3s = function () {
    return this.f3v_1;
  };
  protoOf(SlotTableEditor).n3o = function () {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    return (8388608 & this.h3v_1.p3u_1[this.g3v_1 + 4 | 0]) === 8388608;
  };
  protoOf(SlotTableEditor).oy = function () {
    return this.e3v_1.oy();
  };
  protoOf(SlotTableEditor).f4n = function () {
    return this.z34(this.g3v_1);
  };
  protoOf(SlotTableEditor).g4n = function () {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    return (8388608 & this.h3v_1.p3u_1[this.f3v_1 + 4 | 0]) === 8388608;
  };
  protoOf(SlotTableEditor).t3j = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
    return this.h3v_1.p3u_1[group + 0 | 0];
  };
  protoOf(SlotTableEditor).z34 = function (group) {
    var groups = this.h3v_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var flags = groups[group + 4 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      var slots = this.h3v_1.q3u_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var tmp_0 = groups[group + 5 | 0] >> 4;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.nodeSlotIndex' call
      tmp = slots[tmp_0 + 0 | 0];
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SlotTableEditor).h4n = function (group, newValue) {
    var addressSpace = this.h3v_1;
    var groups = addressSpace.p3u_1;
    var slots = addressSpace.q3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var groupFlags = groups[group + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = (8388608 & groupFlags) === 8388608;
    if (false && !value) {
      var tmp$ret$3 = 'Cannot update node for group that does not have node slot';
      composeImmediateRuntimeError(tmp$ret$3);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = groups[group + 5 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var tmp = slotRange >> 4;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.nodeSlotIndex' call
    var slotAddress = tmp + 0 | 0;
    slots[slotAddress] = newValue;
  };
  protoOf(SlotTableEditor).d3w = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    return this.h3v_1.p3u_1[group + 4 | 0];
  };
  protoOf(SlotTableEditor).x34 = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    return (8388608 & this.d3w(group)) === 8388608;
  };
  protoOf(SlotTableEditor).y4k = function (groups) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNodeCount' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var flags = this.h3v_1.p3u_1[groups + 4 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp = flags & 8388607;
    }
    return tmp;
  };
  protoOf(SlotTableEditor).l3v = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    return this.h3v_1.p3u_1[group + 2 | 0];
  };
  protoOf(SlotTableEditor).v3v = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    return this.h3v_1.p3u_1[group + 3 | 0];
  };
  protoOf(SlotTableEditor).o3v = function () {
    var tmp0 = this.j3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var group = this.g3v_1;
    var tmp = shiftLeft(fromInt(tmp0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$2 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    return bitwiseOr(tmp, tmp$ret$2);
  };
  protoOf(SlotTableEditor).j4 = function () {
    if (!this.i3v_1) {
      this.i3v_1 = true;
      this.e3v_1.n4k(this);
    }
  };
  protoOf(SlotTableEditor).x3j = function () {
    var current = this.g3v_1;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(current > 0)) {
      var tmp$ret$1 = 'Cannot start a group because current does not refer to a child of a group';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.f3v_1 = current;
    var groups = this.h3v_1.p3u_1;
    if ((current + 6 | 0) > groups.length)
      return Unit_instance;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    tmp.g3v_1 = groups[current + 3 | 0];
    this.j3v_1 = -1;
  };
  protoOf(SlotTableEditor).o3l = function () {
    var parent = this.f3v_1;
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = parent >= 0;
    if (false && !value) {
      var tmp$ret$1 = 'No group is started. Cannot end group.';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var groups = this.h3v_1.p3u_1;
    if ((parent + 6 | 0) > groups.length)
      return Unit_instance;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    var newCurrent = groups[parent + 1 | 0];
    var tmp = this;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    tmp.f3v_1 = groups[parent + 2 | 0];
    this.j3v_1 = parent;
    this.g3v_1 = newCurrent;
  };
  protoOf(SlotTableEditor).a4n = function (freeGroup) {
    var groups = this.h3v_1.p3u_1;
    var current = this.g3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var currentFlags = groups[current + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & currentFlags) === 8388608) {
      tmp = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp = currentFlags & 8388607;
    }
    var nodeCountDelta = -tmp | 0;
    var flagsToRemove = propagatingFlagsOf(currentFlags);
    propagateChanges(this, current, nodeCountDelta, flagsToRemove, 0, true);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    var next = groups[current + 1 | 0];
    var previousSibling = this.j3v_1;
    if (previousSibling === -1) {
      var parent = this.f3v_1;
      if (parent === -1) {
        this.e3v_1.i3u_1 = next;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        groups[parent + 3 | 0] = next;
      }
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      groups[previousSibling + 1 | 0] = next;
    }
    if (freeGroup) {
      this.h3v_1.l4k(current);
    }
    this.g3v_1 = next;
  };
  protoOf(SlotTableEditor).x4k = function (freeGroup, $super) {
    freeGroup = freeGroup === VOID ? true : freeGroup;
    var tmp;
    if ($super === VOID) {
      this.a4n(freeGroup);
      tmp = Unit_instance;
    } else {
      tmp = $super.a4n.call(this, freeGroup);
    }
    return tmp;
  };
  protoOf(SlotTableEditor).k3w = function (offset) {
    if (offset === 0)
      return Unit_instance;
    var current = this.g3v_1;
    var previousSibling = this.j3v_1;
    var source = current;
    var previousSource = previousSibling;
    var groups = this.h3v_1.p3u_1;
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < offset)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        previousSource = source;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
        source = groups[source + 1 | 0];
        // Inline function 'kotlin.check' call
        if (!!(source === -1)) {
          var message = 'Offset(' + offset + ') too large';
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
       while (inductionVariable < offset);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    var sourceNext = groups[source + 1 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    groups[previousSource + 1 | 0] = sourceNext;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    groups[source + 1 | 0] = current;
    if (previousSibling === -1) {
      var parent = this.f3v_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
      groups[parent + 3 | 0] = source;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      groups[previousSibling + 1 | 0] = source;
    }
    this.g3v_1 = source;
  };
  protoOf(SlotTableEditor).i4n = function (sourceTable, sourceHandle, destination) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = sourceTable.b3v();
    var tmp;
    try {
      tmp = this.j4n($this$with, sourceHandle, destination);
    }finally {
      $this$with.j4();
    }
  };
  protoOf(SlotTableEditor).k4n = function (sourceTable, sourceHandle, destination, $super) {
    destination = destination === VOID ? new Long(-1, -1) : destination;
    var tmp;
    if ($super === VOID) {
      this.i4n(sourceTable, sourceHandle, destination);
      tmp = Unit_instance;
    } else {
      tmp = $super.i4n.call(this, sourceTable, sourceHandle, destination);
    }
    return tmp;
  };
  protoOf(SlotTableEditor).j4n = function (sourceEditor, sourceHandle, destination) {
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = !equalsLong(sourceHandle, new Long(-1, -1));
    if (false && !value) {
      var tmp$ret$1 = 'Invalid source handle';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    sourceEditor.z4m(sourceHandle);
    var tmp;
    if (!equals(sourceEditor.h3v_1, this.h3v_1)) {
      var newGroup = this.h3v_1.t4m(sourceEditor.h3v_1, get_group(sourceHandle));
      sourceEditor.a4n(true);
      tmp = newGroup;
    } else {
      var newGroup_0 = get_group(sourceHandle);
      sourceEditor.a4n(false);
      tmp = newGroup_0;
    }
    var newGroup_1 = tmp;
    var tmp_0;
    if (!equalsLong(destination, new Long(-1, -1))) {
      // Inline function 'kotlin.also' call
      var this_0 = this.o3v();
      this.z4m(destination);
      tmp_0 = this_0;
    } else {
      tmp_0 = new Long(-1, -1);
    }
    var previous = tmp_0;
    var previousPreviousSibling = this.j3v_1;
    insertGroup(this, newGroup_1);
    this.j3v_1 = previousPreviousSibling;
    this.g3v_1 = newGroup_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var tmp_1 = shiftLeft(fromInt(previousPreviousSibling), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_1 = _UInt___init__impl__l7qpdl(newGroup_1);
    // Inline function 'kotlin.uintToLong' call
    var value_0 = _UInt___get_data__impl__f0vqqw(this_1);
    var tmp$ret$6 = bitwiseAnd(fromInt(value_0), new Long(-1, 0));
    var result = bitwiseOr(tmp_1, tmp$ret$6);
    if (!equalsLong(previous, new Long(-1, -1))) {
      this.z4m(previous);
    }
    if (this.e3v_1.k3u_1) {
      this.h3v_1.u4m(newGroup_1, previousPreviousSibling);
    }
    return result;
  };
  protoOf(SlotTableEditor).y35 = function () {
    var current = this.g3v_1;
    // Inline function 'kotlin.check' call
    if (!!(current === -1)) {
      var message = 'Skipping past the end of a group';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.j3v_1 = current;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    tmp.g3v_1 = this.h3v_1.p3u_1[current + 1 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNodeCount' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var flags = this.h3v_1.p3u_1[current + 4 | 0];
    var tmp_0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp_0 = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp_0 = flags & 8388607;
    }
    return tmp_0;
  };
  protoOf(SlotTableEditor).s4k = function (anchor) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var group = anchor.m3v_1;
    var tmp = shiftLeft(fromInt(0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$2 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    var tmp$ret$0 = bitwiseOr(tmp, tmp$ret$2);
    this.z4m(tmp$ret$0);
  };
  protoOf(SlotTableEditor).z4m = function (handle) {
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = this.l4n(handle);
    if (false && !value) {
      var tmp$ret$1 = 'Handle ' + get_group(handle) + ':' + get_context(handle) + ' is not in the table being read';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var handleContext = get_context(handle);
    var groups = this.h3v_1.p3u_1;
    var destinationGroup = get_group(handle);
    var tmp;
    if (destinationGroup === -1) {
      tmp = handleContext;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups[destinationGroup + 2 | 0];
    }
    var destinationParent = tmp;
    var destinationPreviousSibling = destinationGroup === -1 ? -1 : handleContext;
    this.f3v_1 = destinationParent;
    this.g3v_1 = destinationGroup;
    var newPrevious = destinationPreviousSibling;
    var tmp_0;
    if (destinationPreviousSibling === -1) {
      var tmp_1;
      if (destinationParent === -1) {
        tmp_1 = !(this.e3v_1.i3u_1 === destinationGroup);
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        tmp_1 = !(groups[destinationParent + 3 | 0] === destinationGroup);
      }
      tmp_0 = tmp_1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      tmp_0 = !(groups[destinationPreviousSibling + 1 | 0] === destinationGroup);
    }
    if (tmp_0) {
      var tmp_2;
      if (destinationParent === -1) {
        tmp_2 = this.e3v_1.i3u_1;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        tmp_2 = groups[destinationParent + 3 | 0];
      }
      var firstChild = tmp_2;
      newPrevious = -1;
      // Inline function 'kotlin.run' call
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseSiblings' call
        var groups_0 = this.h3v_1.p3u_1;
        var current = firstChild;
        while (current >= 0) {
          var it = current;
          if (it === destinationGroup) {
            break $l$block;
          }
          newPrevious = it;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          current = groups_0[current + 1 | 0];
        }
      }
    }
    var tmp_3;
    if (newPrevious === -1) {
      var tmp_4;
      if (destinationParent === -1) {
        tmp_4 = this.e3v_1.i3u_1 === destinationGroup;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        tmp_4 = groups[destinationParent + 3 | 0] === destinationGroup;
      }
      tmp_3 = tmp_4;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      tmp_3 = groups[newPrevious + 1 | 0] === destinationGroup;
    }
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value_0 = tmp_3;
    if (false && !value_0) {
      var tmp$ret$14 = "Could not find group's previous in seek()";
      composeImmediateRuntimeError(tmp$ret$14);
    }
    this.j3v_1 = newPrevious;
  };
  protoOf(SlotTableEditor).m4c = function (value) {
    var groups = this.h3v_1.p3u_1;
    var current = this.g3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var flags = groups[current + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value_0 = (33554432 & flags) === 33554432;
    if (false && !value_0) {
      var tmp$ret$3 = "Cannot update a group's aux that does not have an aux slot allocated";
      composeImmediateRuntimeError(tmp$ret$3);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var tmp = groups[current + 5 | 0] >> 4;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.auxSlotIndex' call
    var slotAddress = tmp + countOneBits(flags & 25165824) | 0;
    this.h3v_1.q3u_1[slotAddress] = value;
  };
  protoOf(SlotTableEditor).m4n = function (slotAddress, value) {
    var slots = this.h3v_1.q3u_1;
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value_0 = 0 <= slotAddress ? slotAddress < slots.length : false;
    if (false && !value_0) {
      var tmp$ret$1 = 'Attempted to write to an invalid slot address.';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    var oldValue = slots[slotAddress];
    slots[slotAddress] = value;
    return oldValue;
  };
  protoOf(SlotTableEditor).n4n = function (index, value) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var tmp$ret$1 = this.h3v_1.p3u_1[this.f3v_1 + 5 | 0] >> 4;
    return this.m4n(tmp$ret$1 + index | 0, value);
  };
  protoOf(SlotTableEditor).o4n = function (value) {
    var groups = this.h3v_1.p3u_1;
    var parent = this.f3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = groups[parent + 5 | 0];
    if (slotRange === -1) {
      this.h3v_1.o4m(parent, 0, value);
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
      var this_0 = this.h3v_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (slotRange & 15) + 1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var address = slotRange >> 4;
      var tmp;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        tmp = access$_get_largeSizes__q41gto(this_0).l1(address);
      } else {
        tmp = smallSize;
      }
      var size = tmp;
      this.h3v_1.o4m(parent, size, value);
    }
  };
  protoOf(SlotTableEditor).p4n = function (slots) {
    var addressSpace = this.h3v_1;
    var parent = this.f3v_1;
    var groups = addressSpace.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = groups[parent + 5 | 0];
    var tmp$ret$1;
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotSize' call
      if (slotRange === -1) {
        tmp$ret$1 = 0;
        break $l$block;
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (slotRange & 15) + 1 | 0;
      var tmp;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        var tmp_0 = access$_get_largeSizes__q41gto(addressSpace);
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
        var tmp$ret$4 = slotRange >> 4;
        tmp = tmp_0.l1(tmp$ret$4);
      } else {
        tmp = smallSize;
      }
      tmp$ret$1 = tmp;
    }
    var size = tmp$ret$1;
    var newSize = size - slots | 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var tmp$ret$5 = groups[parent + 4 | 0];
    var utilitySlots = utilitySlotsCountForFlags(tmp$ret$5);
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(newSize >= utilitySlots)) {
      var tmp$ret$7 = 'Attempted to trim more slots than the group has';
      composeImmediateRuntimeError(tmp$ret$7);
    }
    addressSpace.s4m(parent, newSize);
  };
  protoOf(SlotTableEditor).l4n = function (groupHandle) {
    // Inline function 'kotlin.let' call
    var it = get_group(groupHandle);
    var tmp;
    if (!(it === -1)) {
      tmp = it;
    } else {
      tmp = get_context(groupHandle);
    }
    var group = tmp;
    if (group === -1)
      return false;
    var root = this.e3v_1.i3u_1;
    var groups = this.h3v_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups_0 = this.h3v_1.p3u_1;
    var tmp_0;
    if (!true) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp_0 = groups_0[group + 2 | 0];
    } else {
      tmp_0 = group;
    }
    var current = tmp_0;
    while (current > 0) {
      var it_0 = current;
      if (it_0 === root)
        return true;
      if (it_0 <= 0) {
        return false;
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      if (groups[it_0 + 2 | 0] === -1) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseSiblings' call
        var groups_1 = this.h3v_1.p3u_1;
        var current_0 = root;
        while (current_0 >= 0) {
          if (current_0 === it_0)
            return true;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          current_0 = groups_1[current_0 + 1 | 0];
        }
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups_0[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$11 = 'Traversing parent of group not in the slot table: ' + group;
      composeImmediateRuntimeError(tmp$ret$11);
    }
    return false;
  };
  protoOf(SlotTableEditor).w4k = function (inGroup, callback) {
    if (inGroup < 0)
      return Unit_instance;
    var groups = this.h3v_1.p3u_1;
    var slots = this.h3v_1.q3u_1;
    var lastVisitedChild = -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = groups[inGroup + 5 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableEditor.forEachSlotInRangeIndexed' call
    if (!(slotRange === -1)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
      var this_0 = this.h3v_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (slotRange & 15) + 1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var address = slotRange >> 4;
      var tmp;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        tmp = access$_get_largeSizes__q41gto(this_0).l1(address);
      } else {
        tmp = smallSize;
      }
      var size = tmp;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableEditor.forEachSlotInRangeIndexed' call
      var end = address + size | 0;
      var inductionVariable = address;
      if (inductionVariable < end)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0 = index - address | 0;
          var slotValue = slots[index];
          if (!(slotValue == null) ? isInterface(slotValue, RememberObserverHolder) : false) {
            var requiredLastChild = asLinkRememberObserverHolder(slotValue).k3x_1.m3v_1;
            while (!(lastVisitedChild === requiredLastChild)) {
              var tmp_0;
              if (lastVisitedChild < 0) {
                // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
                tmp_0 = groups[inGroup + 3 | 0];
              } else {
                // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
                tmp_0 = groups[lastVisitedChild + 1 | 0];
              }
              var nextGroup = tmp_0;
              // Inline function 'androidx.compose.runtime.runtimeCheck' call
              if (!(nextGroup >= 0)) {
                var tmp$ret$12 = 'A RememberObserver cannot be forgotten correctly because its group ordering metadata is inconsistent with the rest of the SlotTable';
                composeImmediateRuntimeError(tmp$ret$12);
              }
              this.w4k(nextGroup, callback);
              lastVisitedChild = nextGroup;
            }
          }
          var shouldClear = callback.w4l(inGroup, tmp0, slotValue);
          if (shouldClear) {
            // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
            var slotAddress = slotRange >> 4;
            slots[slotAddress + tmp0 | 0] = Companion_getInstance_0().f30_1;
          }
        }
         while (inductionVariable < end);
    }
    var tmp_1;
    if (lastVisitedChild < 0) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
      tmp_1 = groups[inGroup + 3 | 0];
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      tmp_1 = groups[lastVisitedChild + 1 | 0];
    }
    var nextGroup_0 = tmp_1;
    while (nextGroup_0 >= 0) {
      this.w4k(nextGroup_0, callback);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      nextGroup_0 = groups[nextGroup_0 + 1 | 0];
    }
  };
  protoOf(SlotTableEditor).q4n = function (inGroup, firstTailGroupToVisit, tailSlots, callback) {
    if (inGroup < 0)
      return Unit_instance;
    var groups = this.h3v_1.p3u_1;
    var slots = this.h3v_1.q3u_1;
    var inTailGroupRegion = false;
    var lastVisitedChild = -1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = groups[inGroup + 5 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var slotAddress = slotRange >> 4;
    var tmp0 = this.h3v_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotSize' call
      if (slotRange === -1) {
        tmp$ret$2 = 0;
        break $l$block;
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (slotRange & 15) + 1 | 0;
      var tmp;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        var tmp_0 = access$_get_largeSizes__q41gto(tmp0);
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
        var tmp$ret$5 = slotRange >> 4;
        tmp = tmp_0.l1(tmp$ret$5);
      } else {
        tmp = smallSize;
      }
      tmp$ret$2 = tmp;
    }
    var slotSize = tmp$ret$2;
    var start = (slotAddress + slotSize | 0) - tailSlots | 0;
    var end = start + tailSlots | 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableEditor.forEachSlotInRangeIndexed' call
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_0 = index - start | 0;
        var slotValue = slots[index];
        if (!(slotValue == null) ? isInterface(slotValue, RememberObserverHolder) : false) {
          var requiredLastChild = asLinkRememberObserverHolder(slotValue).k3x_1.m3v_1;
          while (!(lastVisitedChild === requiredLastChild)) {
            var tmp_1;
            if (lastVisitedChild < 0) {
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
              tmp_1 = groups[inGroup + 3 | 0];
            } else {
              // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
              tmp_1 = groups[lastVisitedChild + 1 | 0];
            }
            var nextGroup = tmp_1;
            // Inline function 'androidx.compose.runtime.runtimeCheck' call
            if (!(nextGroup >= 0)) {
              var tmp$ret$11 = 'A RememberObserver cannot be forgotten correctly because its group ordering metadata is inconsistent with the rest of the SlotTable';
              composeImmediateRuntimeError(tmp$ret$11);
            }
            inTailGroupRegion = !!(inTailGroupRegion | firstTailGroupToVisit === nextGroup);
            if (inTailGroupRegion) {
              this.w4k(nextGroup, callback);
            }
            lastVisitedChild = nextGroup;
          }
        }
        var shouldClear = callback.w4l(inGroup, tmp0_0, slotValue);
        if (shouldClear) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
          var slotAddress_0 = slotRange >> 4;
          slots[slotAddress_0 + tmp0_0 | 0] = Companion_getInstance_0().f30_1;
        }
      }
       while (inductionVariable < end);
    var tmp_2;
    if (lastVisitedChild < 0) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
      tmp_2 = groups[inGroup + 3 | 0];
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      tmp_2 = groups[lastVisitedChild + 1 | 0];
    }
    var nextGroup_0 = tmp_2;
    while (nextGroup_0 >= 0) {
      inTailGroupRegion = !!(inTailGroupRegion | firstTailGroupToVisit === nextGroup_0);
      if (inTailGroupRegion) {
        this.w4k(nextGroup_0, callback);
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      nextGroup_0 = groups[nextGroup_0 + 1 | 0];
    }
  };
  protoOf(SlotTableEditor).r4n = function (flags) {
    var flagsToClear = flags | propagatingFlagsOf(flags);
    var addressSpace = this.h3v_1;
    var groups = addressSpace.p3u_1;
    var tmp2 = this.e3v_1.i3u_1;
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupPartially' call
      if (tmp2 < 0) {
        break $l$block;
      }
      var toVisit = new IntStack();
      var group = tmp2;
      var groups_0 = addressSpace.p3u_1;
      $l$loop: while (true) {
        var group_0 = group;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        var groupFlags = groups[group_0 + 4 | 0];
        var tmp;
        if ((flagsToClear & groupFlags) === 0) {
          tmp = false;
        } else {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
          groups[group_0 + 4 | 0] = groupFlags & ~flagsToClear;
          tmp = true;
        }
        var visitChildren = tmp;
        if (!(group === tmp2) || true) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          var nextSibling = groups_0[group + 1 | 0];
          if (nextSibling >= 0) {
            toVisit.g3i(nextSibling);
          }
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        var next = groups_0[group + 3 | 0];
        if (visitChildren && next >= 0) {
          group = next;
        } else {
          // Inline function 'androidx.compose.runtime.IntStack.isEmpty' call
          if (toVisit.f3i_1 === 0)
            break $l$loop;
          group = toVisit.k3j();
        }
      }
    }
  };
  protoOf(SlotTableEditor).u4c = function () {
    this.f3v_1 = -1;
    this.j3v_1 = -1;
    this.g3v_1 = this.e3v_1.i3u_1;
  };
  function removeGroupAndForgetSlots(_this__u8e3s4, rememberManager) {
    var tmp = _this__u8e3s4.h3u();
    var tmp_0 = removeGroupAndForgetSlots$lambda(rememberManager);
    _this__u8e3s4.w4k(tmp, new sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_1(tmp_0));
    _this__u8e3s4.x4k();
  }
  function deactivateGroup(_this__u8e3s4, rememberManager) {
    var tmp = _this__u8e3s4.h3u();
    var tmp_0 = deactivateGroup$lambda(_this__u8e3s4, rememberManager);
    _this__u8e3s4.w4k(tmp, new sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_2(tmp_0));
  }
  function buildTrace_1(_this__u8e3s4, child, group) {
    child = child === VOID ? null : child;
    group = group === VOID ? _this__u8e3s4.h3u() : group;
    if (!_this__u8e3s4.i3v_1 && !_this__u8e3s4.oy()) {
      return buildTrace(_this__u8e3s4.e3v_1.j3u_1, group, child, new EditorTraceBuilder(_this__u8e3s4));
    }
    return emptyList();
  }
  function EditorTraceBuilder(editor) {
    ComposeStackTraceBuilder.call(this);
    this.t4n_1 = editor;
  }
  protoOf(EditorTraceBuilder).d4n = function (anchor) {
    return this.t4n_1.e3v_1.j3u_1.t4b(asLinkAnchor(anchor).m3v_1);
  };
  protoOf(EditorTraceBuilder).e4n = function (anchor) {
    return this.t4n_1.t3j(asLinkAnchor(anchor).m3v_1);
  };
  function sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_1(function_0) {
    this.u4n_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_1).w4l = function (group, slotIndex, slot) {
    return this.u4n_1(group, slotIndex, slot);
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_1).q3 = function () {
    return this.u4n_1;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, VisitSlotsInRememberOrderCallback) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_2(function_0) {
    this.v4n_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_2).w4l = function (group, slotIndex, slot) {
    return this.v4n_1(group, slotIndex, slot);
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_2).q3 = function () {
    return this.v4n_1;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, VisitSlotsInRememberOrderCallback) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function removeGroupAndForgetSlots$lambda($rememberManager) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, slot) {
      var tmp;
      if (!(slot == null) ? isInterface(slot, ComposeNodeLifecycleCallback) : false) {
        $rememberManager.e36(slot);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (!(slot == null) ? isInterface(slot, RememberObserverHolder) : false) {
        $rememberManager.f36(slot);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if (slot instanceof RecomposeScopeImpl) {
        slot.r2v();
        tmp_1 = Unit_instance;
      }
      return false;
    };
  }
  function deactivateGroup$lambda($this_deactivateGroup, $rememberManager) {
    return function (slotGroup, slotIndex, data) {
      var tmp;
      if (!(data == null) ? isInterface(data, ComposeNodeLifecycleCallback) : false) {
        var tmp_0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.nodeSlotIndex' call
        $this_deactivateGroup.d3w(slotGroup);
        if (slotIndex === 0) {
          $rememberManager.o3p(data);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        if (!(data == null) ? isInterface(data, ReusableRememberObserverHolder) : false) {
          tmp = Unit_instance;
        } else {
          if (!(data == null) ? isInterface(data, RememberObserverHolder) : false) {
            $rememberManager.f36(data);
            return true;
          } else {
            if (data instanceof RecomposeScopeImpl) {
              data.r2v();
              return true;
            }
          }
        }
      }
      return false;
    };
  }
  var androidx_compose_runtime_composer_linkbuffer_SlotTableReader$stable;
  var androidx_compose_runtime_composer_linkbuffer_ReaderTraceBuilder$stable;
  function _set_current__qj3kk($this, value) {
    $this.c3s_1 = value;
  }
  function _get_current__qcrdxk_0($this) {
    return $this.c3s_1;
  }
  function _set_previousSibling__c0fm6y($this, value) {
    $this.j3s_1 = value;
  }
  function access$_get_addressSpace__kppvvr($this) {
    return $this.y3r_1;
  }
  function SlotTableReader(table) {
    this.x3r_1 = table;
    this.y3r_1 = this.x3r_1.j3u_1;
    this.z3r_1 = this.y3r_1.p3u_1;
    this.a3s_1 = this.x3r_1.j3u_1.q3u_1;
    this.b3s_1 = -1;
    this.c3s_1 = this.x3r_1.i3u_1;
    this.d3s_1 = 0;
    this.e3s_1 = 0;
    this.f3s_1 = new IntStack();
    this.g3s_1 = 0;
    this.h3s_1 = false;
    this.i3s_1 = false;
    this.j3s_1 = -1;
  }
  protoOf(SlotTableReader).y4m = function () {
    var tmp;
    if (this.b3s_1 >= 0) {
      var tmp_0 = this.d3s_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      tmp = tmp_0 - (this.z3r_1[this.b3s_1 + 5 | 0] >> 4) | 0;
    } else {
      tmp = 0;
    }
    return tmp;
  };
  protoOf(SlotTableReader).oy = function () {
    return this.x3r_1.oy();
  };
  protoOf(SlotTableReader).f3u = function () {
    return this.j3s_1;
  };
  protoOf(SlotTableReader).j3l = function () {
    return this.e3s_1 - this.d3s_1 | 0;
  };
  protoOf(SlotTableReader).e3w = function (address, slotIndex) {
    if (slotIndex >= 0) {
      var groups = this.z3r_1;
      var slots = this.a3s_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      var slotRange = groups[address + 5 | 0];
      if (!(slotRange === -1)) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        var flags = groups[address + 4 | 0];
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
        var this_0 = this.y3r_1;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
        var smallSize = (slotRange & 15) + 1 | 0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
        var address_0 = slotRange >> 4;
        var tmp;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
        if (smallSize > 15) {
          tmp = access$_get_largeSizes__q41gto(this_0).l1(address_0);
        } else {
          tmp = smallSize;
        }
        var size = tmp;
        var offset = slotIndex + utilitySlotsCountForFlags(flags) | 0;
        if (offset < size)
          return slots[address_0 + offset | 0];
      }
    }
    return Companion_getInstance_0().f30_1;
  };
  protoOf(SlotTableReader).n3x = function (address, slotIndex) {
    var tmp0_safe_receiver = this.e3w(address, slotIndex);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = equals(tmp0_safe_receiver, Companion_getInstance_0().f30_1) ? null : tmp0_safe_receiver;
    }
    return tmp;
  };
  protoOf(SlotTableReader).b35 = function (address) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var flags = this.z3r_1[address + 4 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp = flags & 8388607;
    }
    return tmp;
  };
  protoOf(SlotTableReader).z3w = function () {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = this.z3r_1[this.b3s_1 + 5 | 0];
    if (slotRange === -1)
      return 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var slotAddress = slotRange >> 4;
    return this.d3s_1 - slotAddress | 0;
  };
  protoOf(SlotTableReader).w3j = function () {
    return this.s3j(_get_current__qcrdxk_0(this));
  };
  protoOf(SlotTableReader).k3k = function () {
    // Inline function 'kotlin.let' call
    var it = _get_current__qcrdxk_0(this);
    var tmp;
    if (!(it === -1)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
      tmp = this.y3r_1.p3u_1[it + 0 | 0];
    } else {
      tmp = 0;
    }
    return tmp;
  };
  protoOf(SlotTableReader).m3k = function () {
    return this.u3j(_get_current__qcrdxk_0(this));
  };
  protoOf(SlotTableReader).s3j = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var flags = this.z3r_1[group + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = this.z3r_1[group + 5 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((33554432 & flags) === 33554432) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableReader.upToDateSlots' call
      if (this.g3s_1 > 0) {
        this.a3s_1 = this.y3r_1.q3u_1;
      }
      var tmp_0 = this.a3s_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var tmp_1 = slotRange >> 4;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.auxSlotIndex' call
      tmp = tmp_0[tmp_1 + countOneBits(flags & 25165824) | 0];
    } else {
      tmp = Companion_getInstance_0().f30_1;
    }
    return tmp;
  };
  protoOf(SlotTableReader).s3n = function () {
    return this.b3m(_get_current__qcrdxk_0(this));
  };
  protoOf(SlotTableReader).b3m = function (address) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    return (16777216 & this.z3r_1[address + 4 | 0]) === 16777216;
  };
  protoOf(SlotTableReader).u3j = function (address) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var flags = this.z3r_1[address + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = this.z3r_1[address + 5 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((16777216 & flags) === 16777216) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableReader.upToDateSlots' call
      if (this.g3s_1 > 0) {
        this.a3s_1 = this.y3r_1.q3u_1;
      }
      var tmp_0 = this.a3s_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var tmp_1 = slotRange >> 4;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.objectKeySlotIndex' call
      tmp = tmp_0[tmp_1 + countOneBits(flags & 8388608) | 0];
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SlotTableReader).w4n = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var flags = this.z3r_1[group + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = this.z3r_1[group + 5 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableReader.upToDateSlots' call
      if (this.g3s_1 > 0) {
        this.a3s_1 = this.y3r_1.q3u_1;
      }
      var tmp_0 = this.a3s_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var tmp_1 = slotRange >> 4;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.nodeSlotIndex' call
      tmp = tmp_0[tmp_1 + 0 | 0];
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SlotTableReader).l3l = function () {
    return _get_current__qcrdxk_0(this) === -1 && !this.r3l();
  };
  protoOf(SlotTableReader).n3o = function () {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    return (8388608 & this.z3r_1[_get_current__qcrdxk_0(this) + 4 | 0]) === 8388608;
  };
  protoOf(SlotTableReader).r3l = function () {
    return this.g3s_1 > 0;
  };
  protoOf(SlotTableReader).x34 = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    return (8388608 & this.z3r_1[group + 4 | 0]) === 8388608;
  };
  protoOf(SlotTableReader).h3u = function () {
    return _get_current__qcrdxk_0(this);
  };
  protoOf(SlotTableReader).k3s = function () {
    return this.b3s_1;
  };
  protoOf(SlotTableReader).s3w = function () {
    return this.y3r_1.u3v(this.k3s());
  };
  protoOf(SlotTableReader).z3u = function () {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var group = this.b3s_1;
    var tmp = shiftLeft(fromInt(0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$2 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    return bitwiseOr(tmp, tmp$ret$2);
  };
  protoOf(SlotTableReader).w3w = function () {
    return this.w4n(this.b3s_1);
  };
  protoOf(SlotTableReader).f3w = function () {
    var tmp;
    if (!(this.b3s_1 === -1)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
      var flags = this.z3r_1[this.b3s_1 + 4 | 0];
      var tmp_0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      if ((8388608 & flags) === 8388608) {
        tmp_0 = 1;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
        tmp_0 = flags & 8388607;
      }
      tmp = tmp_0;
    } else {
      tmp = 0;
    }
    return tmp;
  };
  protoOf(SlotTableReader).z34 = function (group) {
    var tmp = this.a3s_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    return tmp[this.z3r_1[group + 5 | 0] >> 4];
  };
  protoOf(SlotTableReader).l3v = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    return this.z3r_1[group + 2 | 0];
  };
  protoOf(SlotTableReader).v3v = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    return this.z3r_1[group + 3 | 0];
  };
  protoOf(SlotTableReader).x3v = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    return this.z3r_1[group + 1 | 0];
  };
  protoOf(SlotTableReader).o3v = function () {
    var handle = makeGroupHandle(this.b3s_1, this.f3u(), _get_current__qcrdxk_0(this));
    return handle;
  };
  protoOf(SlotTableReader).b3w = function () {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var group = this.x3r_1.i3u_1;
    var tmp = shiftLeft(fromInt(-1), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$2 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    return bitwiseOr(tmp, tmp$ret$2);
  };
  protoOf(SlotTableReader).l3s = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    return (67108864 & this.z3r_1[group + 4 | 0]) === 67108864;
  };
  protoOf(SlotTableReader).w3v = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    return !((201326592 & this.z3r_1[group + 4 | 0]) === 0);
  };
  protoOf(SlotTableReader).d3w = function (address) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    return this.z3r_1[address + 4 | 0];
  };
  protoOf(SlotTableReader).j4 = function () {
    if (!this.i3s_1) {
      this.i3s_1 = true;
      this.x3r_1.m4k(this);
    }
  };
  protoOf(SlotTableReader).x3j = function () {
    var current = _get_current__qcrdxk_0(this);
    this.b3s_1 = current;
    var groups = this.z3r_1;
    if ((current + 6 | 0) > groups.length)
      return Unit_instance;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    var tmp$ret$0 = groups[current + 3 | 0];
    _set_current__qj3kk(this, tmp$ret$0);
    _set_previousSibling__c0fm6y(this, -1);
    this.f3s_1.g3i(this.e3s_1 - this.d3s_1 | 0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = groups[current + 5 | 0];
    if (!(slotRange === -1)) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      var flags = groups[current + 4 | 0];
      var tmp = this;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      tmp.d3s_1 = (slotRange >> 4) + utilitySlotsCountForFlags(flags) | 0;
      var tmp_0 = this;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var tmp_1 = slotRange >> 4;
      var tmp0 = this.y3r_1;
      var tmp$ret$5;
      $l$block: {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotSize' call
        if (slotRange === -1) {
          tmp$ret$5 = 0;
          break $l$block;
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
        var smallSize = (slotRange & 15) + 1 | 0;
        var tmp_2;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
        if (smallSize > 15) {
          var tmp_3 = access$_get_largeSizes__q41gto(tmp0);
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
          var tmp$ret$8 = slotRange >> 4;
          tmp_2 = tmp_3.l1(tmp$ret$8);
        } else {
          tmp_2 = smallSize;
        }
        tmp$ret$5 = tmp_2;
      }
      tmp_0.e3s_1 = tmp_1 + tmp$ret$5 | 0;
    } else {
      this.d3s_1 = -1;
      this.e3s_1 = -1;
    }
  };
  protoOf(SlotTableReader).y3j = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.n3o()) {
      var tmp$ret$1 = 'Expected a node group';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.x3j();
  };
  protoOf(SlotTableReader).o3l = function () {
    var parent = this.b3s_1;
    var array = this.z3r_1;
    if ((parent + 6 | 0) > array.length)
      return Unit_instance;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    var newCurrent = array[parent + 1 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    var newParent = array[parent + 2 | 0];
    this.b3s_1 = newParent;
    _set_previousSibling__c0fm6y(this, parent);
    _set_current__qj3kk(this, newCurrent);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
    var slotRange = this.z3r_1[newParent + 5 | 0];
    var tmp = this;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
    var tmp_0 = slotRange >> 4;
    var tmp0 = this.y3r_1;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotSize' call
      if (slotRange === -1) {
        tmp$ret$4 = 0;
        break $l$block;
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
      var smallSize = (slotRange & 15) + 1 | 0;
      var tmp_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
      if (smallSize > 15) {
        var tmp_2 = access$_get_largeSizes__q41gto(tmp0);
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
        var tmp$ret$7 = slotRange >> 4;
        tmp_1 = tmp_2.l1(tmp$ret$7);
      } else {
        tmp_1 = smallSize;
      }
      tmp$ret$4 = tmp_1;
    }
    tmp.e3s_1 = tmp_0 + tmp$ret$4 | 0;
    this.d3s_1 = this.e3s_1 - this.f3s_1.y49(0) | 0;
  };
  protoOf(SlotTableReader).y35 = function () {
    var current = _get_current__qcrdxk_0(this);
    var groups = this.z3r_1;
    if ((current + 6 | 0) > groups.length)
      return 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var flags = groups[current + 4 | 0];
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp = flags & 8388607;
    }
    var nodes = tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
    var tmp$ret$4 = groups[current + 1 | 0];
    _set_current__qj3kk(this, tmp$ret$4);
    _set_previousSibling__c0fm6y(this, current);
    return nodes;
  };
  protoOf(SlotTableReader).z30 = function () {
    _set_current__qj3kk(this, -1);
    _set_previousSibling__c0fm6y(this, 0);
    this.d3s_1 = 0;
    this.e3s_1 = 0;
  };
  protoOf(SlotTableReader).z3l = function (parent) {
    _set_previousSibling__c0fm6y(this, 0);
    this.b3s_1 = parent;
    this.d3s_1 = 0;
    this.e3s_1 = 0;
  };
  protoOf(SlotTableReader).v = function () {
    var tmp;
    if (this.r3l() || this.d3s_1 >= this.e3s_1) {
      this.h3s_1 = false;
      tmp = Companion_getInstance_0().f30_1;
    } else {
      this.h3s_1 = true;
      var tmp_0 = this.a3s_1;
      var _unary__edvuaz = this.d3s_1;
      this.d3s_1 = _unary__edvuaz + 1 | 0;
      tmp = tmp_0[_unary__edvuaz];
    }
    return tmp;
  };
  protoOf(SlotTableReader).t3j = function (group) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
    return this.z3r_1[group + 0 | 0];
  };
  protoOf(SlotTableReader).l1 = function (index) {
    return this.e3w(_get_current__qcrdxk_0(this), index);
  };
  protoOf(SlotTableReader).z3j = function () {
    this.g3s_1 = this.g3s_1 + 1 | 0;
  };
  protoOf(SlotTableReader).q3l = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(this.g3s_1 > 0)) {
      var tmp$ret$1 = 'Unbalanced begin/end empty';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.g3s_1 = this.g3s_1 - 1 | 0;
    if (this.g3s_1 === 0) {
      this.a3s_1 = this.y3r_1.q3u_1;
      this.z3r_1 = this.y3r_1.p3u_1;
      var offset = this.e3s_1 - this.d3s_1 | 0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      var slotRange = this.z3r_1[this.b3s_1 + 5 | 0];
      if (!(slotRange === -1)) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.slotAddressAndSize' call
        var this_0 = this.y3r_1;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotSmallSizeOf' call
        var smallSize = (slotRange & 15) + 1 | 0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
        var address = slotRange >> 4;
        var tmp;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.isLargeSlotRangeSize' call
        if (smallSize > 15) {
          tmp = access$_get_largeSizes__q41gto(this_0).l1(address);
        } else {
          tmp = smallSize;
        }
        var size = tmp;
        this.d3s_1 = (address + size | 0) - offset | 0;
        this.e3s_1 = address + size | 0;
      }
    }
  };
  protoOf(SlotTableReader).y3k = function (group) {
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = group > 0;
    if (false && !value) {
      var tmp$ret$1 = 'Cannot reposition to group ' + group;
      composeImmediateRuntimeError(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var tmp = shiftLeft(fromInt(0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(group);
    // Inline function 'kotlin.uintToLong' call
    var value_0 = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$4 = bitwiseAnd(fromInt(value_0), new Long(-1, 0));
    var tmp$ret$2 = bitwiseOr(tmp, tmp$ret$4);
    this.d3u(tmp$ret$2);
  };
  protoOf(SlotTableReader).d3u = function (handle) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!this.r3l()) {
      var tmp$ret$1 = 'Cannot reposition while in an empty region';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    _set_current__qj3kk(this, get_group(handle));
    _set_previousSibling__c0fm6y(this, get_context(handle));
    var tmp = this;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
    tmp.b3s_1 = this.z3r_1[_get_current__qcrdxk_0(this) + 2 | 0];
  };
  protoOf(SlotTableReader).l3k = function () {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    if (this.r3l())
      return result;
    var predecessor = this.f3u();
    var index = 0;
    var groups = this.z3r_1;
    var slots = this.a3s_1;
    var tmp0 = this.x3r_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseSiblings' call
    var group = this.h3u();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseSiblings' call
    var groups_0 = tmp0.j3u_1.p3u_1;
    var current = group;
    while (current >= 0) {
      var address = current;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      var flags = groups[address + 4 | 0];
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupSlotRange' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.slotAddressOf' call
      var slotAddress = groups[address + 5 | 0] >> 4;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupKey' call
      var tmp = groups[address + 0 | 0];
      var tmp_0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      if ((16777216 & flags) === 16777216) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.objectKeySlotIndex' call
        tmp_0 = slots[slotAddress + countOneBits(flags & 8388608) | 0];
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
      var groupContext = predecessor;
      var tmp_2 = shiftLeft(fromInt(groupContext), 32);
      // Inline function 'kotlin.toUInt' call
      // Inline function 'kotlin.UInt.toLong' call
      var this_0 = _UInt___init__impl__l7qpdl(address);
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_0);
      var tmp$ret$12 = bitwiseAnd(fromInt(value), new Long(-1, 0));
      var tmp_3 = bitwiseOr(tmp_2, tmp$ret$12);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
      var tmp_4;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      if ((8388608 & flags) === 8388608) {
        tmp_4 = 1;
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
        tmp_4 = flags & 8388607;
      }
      var tmp_5 = tmp_4;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      result.j1(new KeyInfo_0(tmp, tmp_1, tmp_3, tmp_5, _unary__edvuaz));
      predecessor = address;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
      current = groups_0[current + 1 | 0];
    }
    return result;
  };
  protoOf(SlotTableReader).v3w = function (groupAddress, flags) {
    var propagatingFlags = propagatingFlagsOf(flags);
    var groups = this.y3r_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroupAndParents' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups_0 = this.x3r_1.j3u_1.p3u_1;
    var tmp;
    if (!true) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups_0[groupAddress + 2 | 0];
    } else {
      tmp = groupAddress;
    }
    var current = tmp;
    while (current > 0) {
      var address = current;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      var currentFlags = groups[address + 4 | 0];
      var flagsToSet = address === groupAddress ? flags : propagatingFlags;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
      if ((flagsToSet & currentFlags) === flagsToSet)
        return Unit_instance;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
      groups[address + 4 | 0] = currentFlags | flagsToSet;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups_0[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$9 = 'Traversing parent of group not in the slot table: ' + groupAddress;
      composeImmediateRuntimeError(tmp$ret$9);
    }
  };
  protoOf(SlotTableReader).m3s = function (flags) {
    this.x4n(this.b3s_1, flags);
  };
  protoOf(SlotTableReader).x4n = function (group, flags) {
    var groups = this.y3r_1.p3u_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    var currentFlags = groups[group + 4 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if (!((flags & currentFlags) === flags))
      return Unit_instance;
    var newFlags = currentFlags & ~flags;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
    groups[group + 4 | 0] = newFlags;
    var propagatingFlags = propagatingFlagsOf(flags);
    if (!((newFlags & propagatingFlags) === 0))
      return Unit_instance;
    var checkFlags = propagatingFlags | flags;
    // Inline function 'kotlin.run' call
    $l$block_0: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseParents' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
      var groups_0 = this.y3r_1.p3u_1;
      var tmp;
      if (!false) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        tmp = groups_0[group + 2 | 0];
      } else {
        tmp = group;
      }
      var current = tmp;
      while (current > 0) {
        var groupAddress = current;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        var flags_0 = groups[groupAddress + 4 | 0];
        if ((flags_0 & propagatingFlags) === 0) {
          break $l$block_0;
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseChildren' call
        var groups_1 = this.y3r_1.p3u_1;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
        var current_0 = groups_1[groupAddress + 3 | 0];
        while (current_0 > 0) {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
          if (!((checkFlags & groups[current_0 + 4 | 0]) === 0)) {
            break $l$block_0;
          }
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          current_0 = groups_1[current_0 + 1 | 0];
        }
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlags' call
        groups[groupAddress + 4 | 0] = flags_0 & ~propagatingFlags;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        current = groups_0[current + 2 | 0];
      }
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!!(current === 0)) {
        var tmp$ret$18 = 'Traversing parent of group not in the slot table: ' + group;
        composeImmediateRuntimeError(tmp$ret$18);
      }
    }
  };
  function traceForGroup(_this__u8e3s4, group, child) {
    var reader = _this__u8e3s4;
    var traceBuilder = new ReaderTraceBuilder(reader);
    var addressSpace = reader.x3r_1.j3u_1;
    var childAnchor = child;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups = addressSpace.p3u_1;
    var tmp;
    if (!true) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups[group + 2 | 0];
    } else {
      tmp = group;
    }
    var current = tmp;
    while (current > 0) {
      var currentGroup = current;
      traceBuilder.w4m(_this__u8e3s4.t3j(currentGroup), _this__u8e3s4.u3j(currentGroup), addressSpace.t4b(currentGroup), childAnchor);
      childAnchor = addressSpace.u3v(currentGroup);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$5 = 'Traversing parent of group not in the slot table: ' + group;
      composeImmediateRuntimeError(tmp$ret$5);
    }
    return traceBuilder.x4m();
  }
  function buildTrace_2(_this__u8e3s4) {
    if (!_this__u8e3s4.i3s_1 && !_this__u8e3s4.oy()) {
      return buildTrace(_this__u8e3s4.x3r_1.j3u_1, _this__u8e3s4.k3s(), _this__u8e3s4.y4m(), new ReaderTraceBuilder(_this__u8e3s4));
    }
    return emptyList();
  }
  function ReaderTraceBuilder(reader) {
    ComposeStackTraceBuilder.call(this);
    this.z4n_1 = reader;
  }
  protoOf(ReaderTraceBuilder).d4n = function (anchor) {
    return this.z4n_1.x3r_1.j3u_1.t4b(asLinkAnchor(anchor).m3v_1);
  };
  protoOf(ReaderTraceBuilder).e4n = function (anchor) {
    return this.z4n_1.t3j(asLinkAnchor(anchor).m3v_1);
  };
  var androidx_compose_runtime_composer_linkbuffer_changelist_ChangeList$stable;
  function ChangeList_0() {
    Changes.call(this);
    this.c3v_1 = new Operations_0();
  }
  protoOf(ChangeList_0).r = function () {
    return this.c3v_1.r();
  };
  protoOf(ChangeList_0).u3w = function () {
    return this.c3v_1.a4o_1;
  };
  protoOf(ChangeList_0).c3 = function () {
    this.c3v_1.c3();
  };
  protoOf(ChangeList_0).s38 = function (slotStorage, applier, rememberManager, errorContext) {
    var slotTable = asLinkBufferSlotTable(slotStorage);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = slotTable.b3v();
    var tmp;
    try {
      this.d3v(applier, $this$with, rememberManager, errorContext);
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
  };
  protoOf(ChangeList_0).d3v = function (applier, slots, rememberManager, errorContext) {
    return this.c3v_1.j4o(applier, slots, rememberManager, errorContext);
  };
  protoOf(ChangeList_0).u4e = function (value) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = Remember_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Remember.Value' call
    Remember_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, value);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).x4e = function (scope) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = RememberPausingScope_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RememberPausingScope.Scope' call
    RememberPausingScope_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, scope);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).y4e = function (scope) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = StartResumingScope_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.StartResumingScope.Scope' call
    StartResumingScope_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, scope);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).z4e = function (scope) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = EndResumingScope_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndResumingScope.Scope' call
    EndResumingScope_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, scope);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).m4o = function (holder, after) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = UpdateRememberObserverHolderOrdering_getInstance();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateRememberObserverHolderOrdering.Holder' call
    UpdateRememberObserverHolderOrdering_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(1);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, holder);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateRememberObserverHolderOrdering.After' call
    UpdateRememberObserverHolderOrdering_getInstance();
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$3, after);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).n4o = function (slotIndex, value) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = UpdateValueRelative_getInstance();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateValueRelative.SlotIndex' call
    UpdateValueRelative_getInstance();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0($this$push);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_0 = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value_0) {
        var tmp$ret$7 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0($this$push).d4f(0);
        composeImmediateRuntimeError(tmp$ret$7);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.d4o_1;
    var tmp_0 = $this$with.e4o_1;
    tmp[(tmp_0 - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0) + 0 | 0] = slotIndex;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateValueRelative.Value' call
    UpdateValueRelative_getInstance();
    var tmp$ret$10 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$10, value);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).r4o = function (value) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = AppendValue_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.AppendValue.Value' call
    AppendValue_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, value);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).s4o = function (firstTailGroupToRemove, count) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = RemoveTailGroupsAndValues_getInstance();
    tmp0.k4o(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveTailGroupsAndValues.FirstTailGroupToRemove' call
    RemoveTailGroupsAndValues_getInstance();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveTailGroupsAndValues.TailSlotCount' call
    RemoveTailGroupsAndValues_getInstance();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInts' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0(tmp0_0);
    if (false) {
      var mask = 1 << 0 | 1 << 1;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$8 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(0) + (', ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(1));
        composeImmediateRuntimeError(tmp$ret$8);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.e4o_1;
    var base = tmp - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0;
    var intArgs = $this$with.d4o_1;
    intArgs[base + 0 | 0] = firstTailGroupToRemove;
    intArgs[base + 1 | 0] = count;
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).h4f = function () {
    this.c3v_1.t4o(ResetSlots_getInstance_0());
  };
  protoOf(ChangeList_0).u4o = function () {
    this.c3v_1.t4o(DeactivateGroup_getInstance());
  };
  protoOf(ChangeList_0).k4f = function (data) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = UpdateAuxData_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateAuxData.Data' call
    UpdateAuxData_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, data);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).v4o = function () {
    this.c3v_1.t4o(RemoveGroup_getInstance());
  };
  protoOf(ChangeList_0).w4o = function (sourceTable, source) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = InsertSlots_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.SourceHighBits' call
    InsertSlots_getInstance_0();
    var tmp = 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.SourceLowBits' call
    InsertSlots_getInstance_0();
    WriteScope__setLong_impl_x9ao3o($this$push, tmp, 1, source);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.FromSlotTable' call
    InsertSlots_getInstance_0();
    var tmp$ret$4 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$4, sourceTable);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).x4o = function (sourceTable, source, fixups) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = InsertSlotsWithFixups_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.SourceHighBits' call
    InsertSlotsWithFixups_getInstance_0();
    var tmp = 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.SourceLowBits' call
    InsertSlotsWithFixups_getInstance_0();
    WriteScope__setLong_impl_x9ao3o($this$push, tmp, 1, source);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.FromSlotTable' call
    InsertSlotsWithFixups_getInstance_0();
    var tmp_0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.Fixups' call
    InsertSlotsWithFixups_getInstance_0();
    var tmp$ret$5 = _ObjectParameter___init__impl__iyg1ip_0(1);
    WriteScope__setObjects_impl_utvr6i_2($this$push, tmp_0, sourceTable, tmp$ret$5, fixups);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).y4o = function (offset) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = MoveGroup_getInstance();
    tmp0.k4o(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveGroup.Offset' call
    MoveGroup_getInstance();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0(tmp0_0);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$7 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$7);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.d4o_1;
    var tmp_0 = $this$with.e4o_1;
    tmp[(tmp_0 - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0) + 0 | 0] = offset;
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).z4o = function () {
    this.c3v_1.t4o(ClearAllRecompositionRequired_getInstance());
  };
  protoOf(ChangeList_0).t4f = function (action, composition) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = EndCompositionScope_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndCompositionScope.Action' call
    EndCompositionScope_getInstance_0();
    var tmp = _ObjectParameter___init__impl__iyg1ip_0(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndCompositionScope.Composition' call
    EndCompositionScope_getInstance_0();
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip_0(1);
    WriteScope__setObjects_impl_utvr6i_2($this$push, tmp, action, tmp$ret$3, composition);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).u4f = function (node) {
    if (!(node == null) ? isInterface(node, ComposeNodeLifecycleCallback) : false) {
      this.c3v_1.t4o(UseCurrentNode_getInstance_0());
    }
  };
  protoOf(ChangeList_0).v4f = function (value, block) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = UpdateNode_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateNode.Value' call
    UpdateNode_getInstance_0();
    var tmp = _ObjectParameter___init__impl__iyg1ip_0(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateNode.Block' call
    UpdateNode_getInstance_0();
    var tmp_0 = _ObjectParameter___init__impl__iyg1ip_0(1);
    WriteScope__setObjects_impl_utvr6i_2($this$push, tmp, value, tmp_0, typeof block === 'function' ? block : THROW_CCE());
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).w4f = function (nodeIndex, removeCount) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = RemoveNode_getInstance_0();
    tmp0.k4o(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveNode.RemoveIndex' call
    RemoveNode_getInstance_0();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveNode.Count' call
    RemoveNode_getInstance_0();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInts' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0(tmp0_0);
    if (false) {
      var mask = 1 << 0 | 1 << 1;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$8 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(0) + (', ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(1));
        composeImmediateRuntimeError(tmp$ret$8);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.e4o_1;
    var base = tmp - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0;
    var intArgs = $this$with.d4o_1;
    intArgs[base + 0 | 0] = nodeIndex;
    intArgs[base + 1 | 0] = removeCount;
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).x4f = function (to, from, count) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = MoveNode_getInstance_0();
    tmp0.k4o(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.To' call
    MoveNode_getInstance_0();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.From' call
    MoveNode_getInstance_0();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.Count' call
    MoveNode_getInstance_0();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInts' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0(tmp0_0);
    if (false) {
      var mask = 1 << 1 | 1 << 0 | 1 << 2;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$9 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(1) + (', ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(0)) + (', ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(2));
        composeImmediateRuntimeError(tmp$ret$9);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.e4o_1;
    var base = tmp - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0;
    var intArgs = $this$with.d4o_1;
    intArgs[base + 1 | 0] = to;
    intArgs[base + 0 | 0] = from;
    intArgs[base + 2 | 0] = count;
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).a4p = function (handle) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = SeekToGroupHandle_getInstance();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToGroupHandle.GroupHandleHighBits' call
    SeekToGroupHandle_getInstance();
    var tmp = 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToGroupHandle.GroupHandleLowBits' call
    SeekToGroupHandle_getInstance();
    WriteScope__setLong_impl_x9ao3o($this$push, tmp, 1, handle);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).b4p = function (addressSpace, handle) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = SeekToAnchor_getInstance();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToAnchor.AnchorHandle' call
    SeekToAnchor_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, anchorHandle(addressSpace, handle));
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).c4p = function () {
    this.c3v_1.t4o(StartGroup_getInstance());
  };
  protoOf(ChangeList_0).d4p = function () {
    this.c3v_1.t4o(SkipGroup_getInstance());
  };
  protoOf(ChangeList_0).z4f = function (count) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = Ups_getInstance_0();
    tmp0.k4o(operation);
    var tmp0_0 = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Ups.Count' call
    Ups_getInstance_0();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0(tmp0_0);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$7 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0(tmp0_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$7);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.d4o_1;
    var tmp_0 = $this$with.e4o_1;
    tmp[(tmp_0 - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0) + 0 | 0] = count;
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).a4g = function (nodes) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(nodes.length === 0)) {
      var tmp0 = this.c3v_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
      var operation = Downs_getInstance_0();
      tmp0.k4o(operation);
      var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Downs.Nodes' call
      Downs_getInstance_0();
      var tmp$ret$4 = _ObjectParameter___init__impl__iyg1ip_0(0);
      WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$4, nodes);
      tmp0.l4o(operation);
    }
  };
  protoOf(ChangeList_0).b4g = function (effect) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = SideEffect_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SideEffect.Effect' call
    SideEffect_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, effect);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).e4p = function (effectiveNodeIndexOut, groupHandle) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = DetermineMovableContentNodeIndex_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.EffectiveNodeIndexOut' call
    DetermineMovableContentNodeIndex_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, effectiveNodeIndexOut);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.GroupHandleHighBits' call
    DetermineMovableContentNodeIndex_getInstance_0();
    var tmp = 1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.GroupHandleLowBits' call
    DetermineMovableContentNodeIndex_getInstance_0();
    WriteScope__setLong_impl_x9ao3o($this$push, tmp, 0, groupHandle);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).d4g = function (nodes, effectiveNodeIndex) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!nodes.r()) {
      var tmp0 = this.c3v_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
      var operation = CopyNodesToNewAnchorLocation_getInstance_0();
      tmp0.k4o(operation);
      var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopyNodesToNewAnchorLocation.Nodes' call
      CopyNodesToNewAnchorLocation_getInstance_0();
      var tmp = _ObjectParameter___init__impl__iyg1ip_0(1);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopyNodesToNewAnchorLocation.EffectiveNodeIndex' call
      CopyNodesToNewAnchorLocation_getInstance_0();
      var tmp$ret$4 = _ObjectParameter___init__impl__iyg1ip_0(0);
      WriteScope__setObjects_impl_utvr6i_2($this$push, tmp, nodes, tmp$ret$4, effectiveNodeIndex);
      tmp0.l4o(operation);
    }
  };
  protoOf(ChangeList_0).e4g = function (resolvedState, parentContext, from, to) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = CopySlotTableToHandleLocation_getInstance();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.ResolvedState' call
    CopySlotTableToHandleLocation_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip_0(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.ParentCompositionContext' call
    CopySlotTableToHandleLocation_getInstance();
    var tmp_0 = _ObjectParameter___init__impl__iyg1ip_0(1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.To' call
    CopySlotTableToHandleLocation_getInstance();
    var tmp_1 = _ObjectParameter___init__impl__iyg1ip_0(3);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.From' call
    CopySlotTableToHandleLocation_getInstance();
    var tmp$ret$5 = _ObjectParameter___init__impl__iyg1ip_0(2);
    WriteScope__setObjects_impl_utvr6i_4($this$push, tmp, resolvedState, tmp_0, parentContext, tmp_1, to, tmp$ret$5, from);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).f4p = function (composition, parentContext, reference) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = ReleaseMovableGroup_getInstance();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.Composition' call
    ReleaseMovableGroup_getInstance();
    var tmp = _ObjectParameter___init__impl__iyg1ip_0(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.ParentCompositionContext' call
    ReleaseMovableGroup_getInstance();
    var tmp_0 = _ObjectParameter___init__impl__iyg1ip_0(1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.Reference' call
    ReleaseMovableGroup_getInstance();
    var tmp$ret$4 = _ObjectParameter___init__impl__iyg1ip_0(2);
    WriteScope__setObjects_impl_utvr6i_3($this$push, tmp, composition, tmp_0, parentContext, tmp$ret$4, reference);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).g4g = function () {
    this.c3v_1.t4o(EndMovableContentPlacement_getInstance_0());
  };
  protoOf(ChangeList_0).g4p = function (resolvedState) {
    var tmp0 = this.c3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = DisposeMovableContentState_getInstance();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DisposeMovableContentState.ResolvedState' call
    DisposeMovableContentState_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, resolvedState);
    tmp0.l4o(operation);
  };
  protoOf(ChangeList_0).h4p = function (changeList, effectiveNodeIndex) {
    if (changeList.fv()) {
      var tmp0 = this.c3v_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
      var operation = ApplyChangeList_getInstance_0();
      tmp0.k4o(operation);
      var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ApplyChangeList.Changes' call
      ApplyChangeList_getInstance_0();
      var tmp = _ObjectParameter___init__impl__iyg1ip_0(0);
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ApplyChangeList.EffectiveNodeIndex' call
      ApplyChangeList_getInstance_0();
      var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip_0(1);
      WriteScope__setObjects_impl_utvr6i_2($this$push, tmp, changeList, tmp$ret$3, effectiveNodeIndex);
      if (changeList.c3v_1.a4o_1) {
        WriteScope__requireApplication_impl_fouec3($this$push);
      }
      tmp0.l4o(operation);
    }
  };
  function asLinkBufferChangeList(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ChangeList_0 ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      composeRuntimeError('Inconsistent composition');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  var androidx_compose_runtime_composer_linkbuffer_changelist_ComposerChangeListWriter$stable;
  function _get_reader__fd8dw8_0($this) {
    return $this.n3s_1.b3r_1;
  }
  function pushApplierOperationPreamble_0($this) {
    pushPendingUpsAndDowns_0($this);
  }
  function pushSlotOperationPreamble($this) {
    var readerLocation = _get_reader__fd8dw8_0($this).o3v();
    if (!equalsLong($this.x3s_1, readerLocation)) {
      $this.i4p(readerLocation);
    }
  }
  function pushSlotOperationPreambleUnconditionally($this) {
    $this.i4p(_get_reader__fd8dw8_0($this).o3v());
  }
  function realizeNodeMovementOperations_0($this) {
    if ($this.v3s_1 > 0) {
      if ($this.s3s_1 >= 0) {
        realizeRemoveNode_0($this, $this.s3s_1, $this.v3s_1);
        $this.s3s_1 = -1;
      } else {
        realizeMoveNode_0($this, $this.u3s_1, $this.t3s_1, $this.v3s_1);
        $this.u3s_1 = -1;
        $this.t3s_1 = -1;
      }
      $this.v3s_1 = 0;
    }
  }
  function realizeRemoveNode_0($this, nodeIndex, removeCount) {
    pushApplierOperationPreamble_0($this);
    $this.o3s_1.w4f(nodeIndex, removeCount);
  }
  function realizeMoveNode_0($this, to, from, count) {
    pushApplierOperationPreamble_0($this);
    $this.o3s_1.x4f(to, from, count);
  }
  function pushPendingUpsAndDowns_0($this) {
    if ($this.q3s_1 > 0) {
      $this.o3s_1.z4f($this.q3s_1);
      $this.q3s_1 = 0;
    }
    if (Stack__isNotEmpty_impl_ua6a9t($this.r3s_1)) {
      $this.o3s_1.a4g(Stack__toArray_impl_ox34cp($this.r3s_1));
      Stack__clear_impl_qoqv3c($this.r3s_1);
    }
  }
  function access$_get_editorCurrentPosition__bcakpw($this) {
    return $this.x3s_1;
  }
  function access$_set_editorCurrentPosition__56o8a8($this, _set____db54di) {
    $this.x3s_1 = _set____db54di;
    return Unit_instance;
  }
  function ComposerChangeListWriter_0(composer, changeList) {
    this.n3s_1 = composer;
    this.o3s_1 = changeList;
    this.p3s_1 = true;
    this.q3s_1 = 0;
    this.r3s_1 = _Stack___init__impl__tvpfn5();
    this.s3s_1 = -1;
    this.t3s_1 = -1;
    this.u3s_1 = -1;
    this.v3s_1 = -1;
    this.w3s_1 = ComposerChangeListWriterAddressMode_AbsoluteAddressing_getInstance();
    this.x3s_1 = new Long(-1, -1);
  }
  protoOf(ComposerChangeListWriter_0).t3w = function () {
    Stack__clear_impl_qoqv3c(this.r3s_1);
    this.q3s_1 = 0;
    this.s3s_1 = -1;
    this.t3s_1 = -1;
    this.u3s_1 = -1;
    this.w3s_1 = ComposerChangeListWriterAddressMode_AbsoluteAddressing_getInstance();
    this.x3s_1 = new Long(-1, -1);
  };
  protoOf(ComposerChangeListWriter_0).t3v = function (handle, resetRelativeAddressing) {
    switch (this.w3s_1.a1_1) {
      case 0:
        this.o3s_1.a4p(handle);
        break;
      case 1:
        this.o3s_1.b4p(_get_reader__fd8dw8_0(this).x3r_1.j3u_1, handle);
        break;
      case 2:
        var groupAddress = get_group(handle);
        var parentOfHandle = groupAddress === -1 ? get_context(handle) : _get_reader__fd8dw8_0(this).l3v(groupAddress);
        // Inline function 'androidx.compose.runtime.runtimeCheck' call

        if (!(parentOfHandle === get_group(this.x3s_1))) {
          var tmp$ret$1 = 'Relative addressing only supports navigating to a child of the current group';
          composeImmediateRuntimeError(tmp$ret$1);
        }

        this.o3s_1.c4p();
        var currentChild = _get_reader__fd8dw8_0(this).v3v(parentOfHandle);
        while (!(currentChild === groupAddress)) {
          this.o3s_1.d4p();
          currentChild = _get_reader__fd8dw8_0(this).x3v(currentChild);
        }

        if (resetRelativeAddressing) {
          this.w3s_1 = ComposerChangeListWriterAddressMode_AbsoluteAddressing_getInstance();
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.x3s_1 = handle;
  };
  protoOf(ComposerChangeListWriter_0).i4p = function (handle, resetRelativeAddressing, $super) {
    resetRelativeAddressing = resetRelativeAddressing === VOID ? false : resetRelativeAddressing;
    var tmp;
    if ($super === VOID) {
      this.t3v(handle, resetRelativeAddressing);
      tmp = Unit_instance;
    } else {
      tmp = $super.t3v.call(this, handle, resetRelativeAddressing);
    }
    return tmp;
  };
  protoOf(ComposerChangeListWriter_0).r3w = function () {
    return this.w3s_1.equals(ComposerChangeListWriterAddressMode_AnchorAddressing_getInstance());
  };
  protoOf(ComposerChangeListWriter_0).h3o = function (value) {
    pushSlotOperationPreamble(this);
    this.o3s_1.u4e(value);
  };
  protoOf(ComposerChangeListWriter_0).q3o = function (scope) {
    this.o3s_1.x4e(scope);
  };
  protoOf(ComposerChangeListWriter_0).j3m = function (scope) {
    this.o3s_1.y4e(scope);
  };
  protoOf(ComposerChangeListWriter_0).v3o = function (scope) {
    this.o3s_1.z4e(scope);
  };
  protoOf(ComposerChangeListWriter_0).x3w = function (holder, after) {
    if (!equals(holder.k3x_1, after)) {
      this.o3s_1.m4o(holder, after);
    }
  };
  protoOf(ComposerChangeListWriter_0).a3x = function (slotIndex, value) {
    pushSlotOperationPreamble(this);
    this.o3s_1.n4o(slotIndex, value);
  };
  protoOf(ComposerChangeListWriter_0).y3w = function (value) {
    pushSlotOperationPreamble(this);
    this.o3s_1.r4o(value);
  };
  protoOf(ComposerChangeListWriter_0).y3u = function (firstTailGroupToRemove, count) {
    if (firstTailGroupToRemove >= 0 || count > 0) {
      pushSlotOperationPreamble(this);
      this.o3s_1.s4o(firstTailGroupToRemove, count);
    }
  };
  protoOf(ComposerChangeListWriter_0).p3m = function () {
    this.o3s_1.h4f();
    this.x3s_1 = new Long(-1, -1);
  };
  protoOf(ComposerChangeListWriter_0).v3j = function (data) {
    pushSlotOperationPreamble(this);
    this.o3s_1.k4f(data);
  };
  protoOf(ComposerChangeListWriter_0).y3v = function () {
    pushSlotOperationPreamble(this);
    this.o3s_1.v4o();
  };
  protoOf(ComposerChangeListWriter_0).a3w = function (sourceTable, source) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!equalsLong(source, new Long(-1, -1))) {
      var tmp$ret$1 = 'Tried moving from an unspecified position';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    pushPendingUpsAndDowns_0(this);
    pushSlotOperationPreamble(this);
    realizeNodeMovementOperations_0(this);
    this.o3s_1.w4o(sourceTable, source);
  };
  protoOf(ComposerChangeListWriter_0).z3v = function (sourceTable, source, fixups) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!equalsLong(source, new Long(-1, -1))) {
      var tmp$ret$1 = 'Tried moving from an unspecified position';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    pushPendingUpsAndDowns_0(this);
    pushSlotOperationPreamble(this);
    realizeNodeMovementOperations_0(this);
    this.o3s_1.x4o(sourceTable, source, fixups);
  };
  protoOf(ComposerChangeListWriter_0).k3w = function (offset) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(offset >= 0)) {
      var tmp$ret$1 = 'Offset must not be negative';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    pushSlotOperationPreambleUnconditionally(this);
    this.o3s_1.y4o(offset);
    this.x3s_1 = new Long(-1, -1);
  };
  protoOf(ComposerChangeListWriter_0).u3o = function (action, composition) {
    this.o3s_1.t4f(action, composition);
  };
  protoOf(ComposerChangeListWriter_0).x3n = function (node) {
    pushApplierOperationPreamble_0(this);
    this.o3s_1.u4f(node);
  };
  protoOf(ComposerChangeListWriter_0).y3n = function (value, block) {
    pushApplierOperationPreamble_0(this);
    this.o3s_1.v4f(value, block);
  };
  protoOf(ComposerChangeListWriter_0).c3l = function (nodeIndex, count) {
    if (count > 0) {
      if (this.s3s_1 === nodeIndex) {
        this.v3s_1 = this.v3s_1 + count | 0;
      } else {
        realizeNodeMovementOperations_0(this);
        this.s3s_1 = nodeIndex;
        this.v3s_1 = count;
      }
    }
  };
  protoOf(ComposerChangeListWriter_0).f3l = function (fromNodeIndex, toNodeIndex, count) {
    if (count > 0) {
      if (this.v3s_1 > 0 && this.t3s_1 === fromNodeIndex && this.u3s_1 === toNodeIndex) {
        this.v3s_1 = this.v3s_1 + count | 0;
      } else {
        realizeNodeMovementOperations_0(this);
        this.u3s_1 = toNodeIndex;
        this.t3s_1 = fromNodeIndex;
        this.v3s_1 = count;
      }
    }
  };
  protoOf(ComposerChangeListWriter_0).h3l = function () {
    realizeNodeMovementOperations_0(this);
  };
  protoOf(ComposerChangeListWriter_0).r3n = function (nodeIndex, group) {
    this.h3l();
    pushPendingUpsAndDowns_0(this);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsNodeCount' call
    var flags = _get_reader__fd8dw8_0(this).d3w(group);
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.contains' call
    if ((8388608 & flags) === 8388608) {
      tmp = 1;
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupFlagsChildNodeCount' call
      tmp = flags & 8388607;
    }
    var tmp$ret$0 = tmp;
    this.c3l(nodeIndex, tmp$ret$0);
  };
  protoOf(ComposerChangeListWriter_0).m3l = function () {
    realizeNodeMovementOperations_0(this);
    if (Stack__isNotEmpty_impl_ua6a9t(this.r3s_1)) {
      Stack__pop_impl_8s4za4(this.r3s_1);
    } else {
      this.q3s_1 = this.q3s_1 + 1 | 0;
    }
  };
  protoOf(ComposerChangeListWriter_0).c3m = function (node) {
    realizeNodeMovementOperations_0(this);
    Stack__push_impl_s8r905(this.r3s_1, node);
  };
  protoOf(ComposerChangeListWriter_0).i3o = function (effect) {
    this.o3s_1.b4g(effect);
  };
  protoOf(ComposerChangeListWriter_0).n3v = function (effectiveNodeIndexOut, handle) {
    pushPendingUpsAndDowns_0(this);
    this.o3s_1.e4p(effectiveNodeIndexOut, handle);
    this.x3s_1 = handle;
  };
  protoOf(ComposerChangeListWriter_0).s3m = function (nodes, effectiveNodeIndex) {
    this.o3s_1.d4g(nodes, effectiveNodeIndex);
  };
  protoOf(ComposerChangeListWriter_0).t3m = function (resolvedState, parentContext, from, to) {
    this.o3s_1.e4g(resolvedState, parentContext, from, to);
  };
  protoOf(ComposerChangeListWriter_0).o3w = function (composition, parentContext, reference) {
    this.o3s_1.f4p(composition, parentContext, reference);
    this.x3s_1 = new Long(-1, -1);
  };
  protoOf(ComposerChangeListWriter_0).x3m = function () {
    this.o3s_1.g4g();
    this.q3s_1 = 0;
  };
  protoOf(ComposerChangeListWriter_0).r3v = function (resolvedState) {
    if (!(resolvedState == null)) {
      this.o3s_1.g4p(resolvedState);
    }
  };
  protoOf(ComposerChangeListWriter_0).q3v = function (other, effectiveNodeIndex) {
    this.o3s_1.h4p(other, effectiveNodeIndex);
  };
  protoOf(ComposerChangeListWriter_0).g3n = function () {
    pushPendingUpsAndDowns_0(this);
    this.o3s_1.z4o();
    this.x3s_1 = new Long(-1, -1);
  };
  protoOf(ComposerChangeListWriter_0).t3o = function () {
    pushSlotOperationPreamble(this);
    this.o3s_1.u4o();
  };
  var ComposerChangeListWriterAddressMode_AbsoluteAddressing_instance;
  var ComposerChangeListWriterAddressMode_AnchorAddressing_instance;
  var ComposerChangeListWriterAddressMode_RelativeAddressing_instance;
  var ComposerChangeListWriterAddressMode_entriesInitialized;
  function ComposerChangeListWriterAddressMode_initEntries() {
    if (ComposerChangeListWriterAddressMode_entriesInitialized)
      return Unit_instance;
    ComposerChangeListWriterAddressMode_entriesInitialized = true;
    ComposerChangeListWriterAddressMode_AbsoluteAddressing_instance = new ComposerChangeListWriterAddressMode('AbsoluteAddressing', 0);
    ComposerChangeListWriterAddressMode_AnchorAddressing_instance = new ComposerChangeListWriterAddressMode('AnchorAddressing', 1);
    ComposerChangeListWriterAddressMode_RelativeAddressing_instance = new ComposerChangeListWriterAddressMode('RelativeAddressing', 2);
  }
  function ComposerChangeListWriterAddressMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ComposerChangeListWriterAddressMode_AbsoluteAddressing_getInstance() {
    ComposerChangeListWriterAddressMode_initEntries();
    return ComposerChangeListWriterAddressMode_AbsoluteAddressing_instance;
  }
  function ComposerChangeListWriterAddressMode_AnchorAddressing_getInstance() {
    ComposerChangeListWriterAddressMode_initEntries();
    return ComposerChangeListWriterAddressMode_AnchorAddressing_instance;
  }
  function ComposerChangeListWriterAddressMode_RelativeAddressing_getInstance() {
    ComposerChangeListWriterAddressMode_initEntries();
    return ComposerChangeListWriterAddressMode_RelativeAddressing_instance;
  }
  var androidx_compose_runtime_composer_linkbuffer_changelist_FixupList$stable;
  function FixupList_0() {
    DebugStringFormattable.call(this);
    this.v3r_1 = new Operations_0();
    this.w3r_1 = new Operations_0();
  }
  protoOf(FixupList_0).r = function () {
    return this.v3r_1.r();
  };
  protoOf(FixupList_0).c3 = function () {
    this.w3r_1.c3();
    this.v3r_1.c3();
  };
  protoOf(FixupList_0).j4p = function (applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.w3r_1.r()) {
      var tmp$ret$1 = 'FixupList has pending fixup operations that were not realized. Were there mismatched insertNode() and endNodeInsert() calls?';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.v3r_1.j4o(applier, slots, rememberManager, errorContext);
  };
  protoOf(FixupList_0).p3w = function (factory, insertIndex, groupHandle) {
    var tmp0 = this.v3r_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = InsertNodeFixup_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.Factory' call
    InsertNodeFixup_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, factory);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.InsertIndex' call
    InsertNodeFixup_getInstance_0();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0($this$push);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$8 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0($this$push).d4f(0);
        composeImmediateRuntimeError(tmp$ret$8);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.d4o_1;
    var tmp_0 = $this$with.e4o_1;
    tmp[(tmp_0 - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0) + 0 | 0] = insertIndex;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.GroupHandleHigh' call
    InsertNodeFixup_getInstance_0();
    var tmp_1 = 1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.GroupHandleLow' call
    InsertNodeFixup_getInstance_0();
    WriteScope__setLong_impl_x9ao3o($this$push, tmp_1, 2, groupHandle);
    tmp0.l4o(operation);
    var tmp0_0 = this.w3r_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation_0 = PostInsertNodeFixup_getInstance_0();
    tmp0_0.k4o(operation_0);
    var $this$push_0 = _WriteScope___init__impl__4xwato_0(tmp0_0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.InsertIndex' call
    PostInsertNodeFixup_getInstance_0();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with_0 = access$_get_stack__7szo53_0($this$push_0);
    if (false) {
      var mask_0 = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_0 = (access$_get_pushedIntMask__wrtr8x_0($this$with_0) & mask_0) === 0;
      if (false && !value_0) {
        var tmp$ret$20 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0($this$push_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$20);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with_0, access$_get_pushedIntMask__wrtr8x_0($this$with_0) | mask_0);
    }
    var tmp_2 = $this$with_0.d4o_1;
    var tmp_3 = $this$with_0.e4o_1;
    tmp_2[(tmp_3 - $this$with_0.b4o_1[$this$with_0.c4o_1 - 1 | 0].o4o_1 | 0) + 0 | 0] = insertIndex;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.GroupHandleHigh' call
    PostInsertNodeFixup_getInstance_0();
    var tmp_4 = 1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.GroupHandleLow' call
    PostInsertNodeFixup_getInstance_0();
    WriteScope__setLong_impl_x9ao3o($this$push_0, tmp_4, 2, groupHandle);
    tmp0_0.l4o(operation_0);
  };
  protoOf(FixupList_0).q3w = function (factory, insertIndex, anchor) {
    var tmp0 = this.v3r_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = InsertNodeFixupByAnchor_getInstance();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.Factory' call
    InsertNodeFixupByAnchor_getInstance();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, factory);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.InsertIndex' call
    InsertNodeFixupByAnchor_getInstance();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0($this$push);
    if (false) {
      var mask = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value) {
        var tmp$ret$8 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0($this$push).d4f(0);
        composeImmediateRuntimeError(tmp$ret$8);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.d4o_1;
    var tmp_0 = $this$with.e4o_1;
    tmp[(tmp_0 - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0) + 0 | 0] = insertIndex;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.Anchor' call
    InsertNodeFixupByAnchor_getInstance();
    var tmp$ret$11 = _ObjectParameter___init__impl__iyg1ip_0(1);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$11, anchor);
    tmp0.l4o(operation);
    var tmp0_0 = this.w3r_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation_0 = PostInsertNodeFixupByAnchor_getInstance();
    tmp0_0.k4o(operation_0);
    var $this$push_0 = _WriteScope___init__impl__4xwato_0(tmp0_0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixupByAnchor.InsertIndex' call
    PostInsertNodeFixupByAnchor_getInstance();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    // Inline function 'kotlin.with' call
    var $this$with_0 = access$_get_stack__7szo53_0($this$push_0);
    if (false) {
      var mask_0 = 1 << 0;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_0 = (access$_get_pushedIntMask__wrtr8x_0($this$with_0) & mask_0) === 0;
      if (false && !value_0) {
        var tmp$ret$19 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0($this$push_0).d4f(0);
        composeImmediateRuntimeError(tmp$ret$19);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with_0, access$_get_pushedIntMask__wrtr8x_0($this$with_0) | mask_0);
    }
    var tmp_1 = $this$with_0.d4o_1;
    var tmp_2 = $this$with_0.e4o_1;
    tmp_1[(tmp_2 - $this$with_0.b4o_1[$this$with_0.c4o_1 - 1 | 0].o4o_1 | 0) + 0 | 0] = insertIndex;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixupByAnchor.Anchor' call
    PostInsertNodeFixupByAnchor_getInstance();
    var tmp$ret$22 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push_0, tmp$ret$22, anchor);
    tmp0_0.l4o(operation_0);
  };
  protoOf(FixupList_0).p3l = function () {
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!this.w3r_1.fv()) {
      var tmp$ret$1 = 'Cannot end node insertion, there are no pending operations that can be realized.';
      composeImmediateRuntimeError(tmp$ret$1);
    }
    this.w3r_1.k4p(this.v3r_1);
  };
  protoOf(FixupList_0).z3n = function (value, block) {
    var tmp0 = this.v3r_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.push' call
    var operation = UpdateNode_getInstance_0();
    tmp0.k4o(operation);
    var $this$push = _WriteScope___init__impl__4xwato_0(tmp0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateNode.Value' call
    UpdateNode_getInstance_0();
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(0);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp$ret$2, value);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateNode.Block' call
    UpdateNode_getInstance_0();
    var tmp = _ObjectParameter___init__impl__iyg1ip_0(1);
    WriteScope__setObject_impl_rr41y9_0($this$push, tmp, typeof block === 'function' ? block : THROW_CCE());
    tmp0.l4o(operation);
  };
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_Ups$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_Downs$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_SeekToAnchor$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_SeekToGroupHandle$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_StartGroup$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_SkipGroup$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_SideEffect$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_Remember$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_RememberPausingScope$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_StartResumingScope$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_EndResumingScope$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_AppendValue$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_RemoveTailGroupsAndValues$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateValue$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateRememberObserverHolderOrdering$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateValueRelative$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateAuxData$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_RemoveGroup$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_MoveGroup$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_ClearAllRecompositionRequired$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_EndCompositionScope$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UseCurrentNode$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateNode$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_RemoveNode$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_MoveNode$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_InsertSlots$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_InsertSlotsWithFixups$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_InsertNodeFixup$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_InsertNodeFixupByAnchor$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_PostInsertNodeFixup$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_PostInsertNodeFixupByAnchor$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_DeactivateGroup$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_ResetSlots$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_DetermineMovableContentNodeIndex$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_CopyNodesToNewAnchorLocation$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_EndMovableContentPlacement$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_CopySlotTableToHandleLocation$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_ReleaseMovableGroup$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_DisposeMovableContentState$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_ApplyChangeList$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation_TestOperation$stable;
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operation$stable;
  function _ObjectParameter___init__impl__iyg1ip_0(offset) {
    return offset;
  }
  function _ObjectParameter___get_offset__impl__x7fx93_0($this) {
    return $this;
  }
  function sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_3(function_0) {
    this.l4p_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_3).w4l = function (group, slotIndex, slot) {
    return this.l4p_1(group, slotIndex, slot);
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_3).q3 = function () {
    return this.l4p_1;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, VisitSlotsInRememberOrderCallback) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_3).hashCode = function () {
    return hashCode(this.q3());
  };
  function Operation$RemoveTailGroupsAndValues$execute$lambda($rememberManager) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, value) {
      var tmp;
      if (!(value == null) ? isInterface(value, ComposeNodeLifecycleCallback) : false) {
        value.d30();
        tmp = Unit_instance;
      } else {
        if (!(value == null) ? isInterface(value, RememberObserverHolder) : false) {
          $rememberManager.f36(value);
          tmp = Unit_instance;
        } else {
          if (value instanceof RecomposeScopeImpl) {
            value.r2v();
            tmp = Unit_instance;
          }
        }
      }
      return false;
    };
  }
  function Ups_0() {
    Ups_instance_0 = this;
    Operation_0.call(this, 1);
  }
  protoOf(Ups_0).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Ups.Count' call
    if (parameter === 0) {
      tmp = 'count';
    } else {
      tmp = protoOf(Operation_0).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(Ups_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Ups.Count' call
    // Inline function 'kotlin.repeat' call
    var times = _this__u8e3s4.o4g(0);
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        applier.i2y();
      }
       while (inductionVariable < times);
  };
  var Ups_instance_0;
  function Ups_getInstance_0() {
    if (Ups_instance_0 == null)
      new Ups_0();
    return Ups_instance_0;
  }
  function Downs_0() {
    Downs_instance_0 = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(Downs_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Downs.Nodes' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'nodes';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(Downs_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Downs.Nodes' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var nodes = _this__u8e3s4.w4p(tmp$ret$0);
    var inductionVariable = 0;
    var last = nodes.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        nodeApplier.h2y(nodes[index]);
      }
       while (inductionVariable <= last);
  };
  var Downs_instance_0;
  function Downs_getInstance_0() {
    if (Downs_instance_0 == null)
      new Downs_0();
    return Downs_instance_0;
  }
  function SeekToAnchor() {
    SeekToAnchor_instance = this;
    Operation_0.call(this, VOID, 1, false);
  }
  protoOf(SeekToAnchor).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToAnchor.AnchorHandle' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'anchorHandle';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(SeekToAnchor).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToAnchor.AnchorHandle' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var anchorHandle = _this__u8e3s4.w4p(tmp$ret$0);
    slots.z4m(anchorHandle.a4k());
  };
  var SeekToAnchor_instance;
  function SeekToAnchor_getInstance() {
    if (SeekToAnchor_instance == null)
      new SeekToAnchor();
    return SeekToAnchor_instance;
  }
  function SeekToGroupHandle() {
    SeekToGroupHandle_instance = this;
    Operation_0.call(this, 2, VOID, false);
  }
  protoOf(SeekToGroupHandle).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToGroupHandle.GroupHandleHighBits' call
    if (parameter === 0) {
      tmp = 'group[32..63]';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToGroupHandle.GroupHandleLowBits' call
      if (parameter === 1) {
        tmp = 'group[0..31]';
      } else {
        tmp = protoOf(Operation_0).d4f.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(SeekToGroupHandle).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToGroupHandle.GroupHandleHighBits' call
    var tmp = 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SeekToGroupHandle.GroupHandleLowBits' call
    var handle = getLong(_this__u8e3s4, tmp, 1);
    slots.z4m(handle);
  };
  var SeekToGroupHandle_instance;
  function SeekToGroupHandle_getInstance() {
    if (SeekToGroupHandle_instance == null)
      new SeekToGroupHandle();
    return SeekToGroupHandle_instance;
  }
  function StartGroup() {
    StartGroup_instance = this;
    Operation_0.call(this);
  }
  protoOf(StartGroup).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    slots.x3j();
  };
  var StartGroup_instance;
  function StartGroup_getInstance() {
    if (StartGroup_instance == null)
      new StartGroup();
    return StartGroup_instance;
  }
  function SkipGroup() {
    SkipGroup_instance = this;
    Operation_0.call(this);
  }
  protoOf(SkipGroup).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    slots.y35();
  };
  var SkipGroup_instance;
  function SkipGroup_getInstance() {
    if (SkipGroup_instance == null)
      new SkipGroup();
    return SkipGroup_instance;
  }
  function SideEffect_1() {
    SideEffect_instance_0 = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(SideEffect_1).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SideEffect.Effect' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'effect';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(SideEffect_1).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.SideEffect.Effect' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    rememberManager.i3o(_this__u8e3s4.w4p(tmp$ret$0));
  };
  var SideEffect_instance_0;
  function SideEffect_getInstance_0() {
    if (SideEffect_instance_0 == null)
      new SideEffect_1();
    return SideEffect_instance_0;
  }
  function Remember_0() {
    Remember_instance_0 = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(Remember_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Remember.Value' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'value';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(Remember_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Remember.Value' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    rememberManager.o4b(_this__u8e3s4.w4p(tmp$ret$0));
  };
  var Remember_instance_0;
  function Remember_getInstance_0() {
    if (Remember_instance_0 == null)
      new Remember_0();
    return Remember_instance_0;
  }
  function RememberPausingScope_0() {
    RememberPausingScope_instance_0 = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(RememberPausingScope_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RememberPausingScope.Scope' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'scope';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(RememberPausingScope_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RememberPausingScope.Scope' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var scope = _this__u8e3s4.w4p(tmp$ret$0);
    rememberManager.q3o(scope);
  };
  var RememberPausingScope_instance_0;
  function RememberPausingScope_getInstance_0() {
    if (RememberPausingScope_instance_0 == null)
      new RememberPausingScope_0();
    return RememberPausingScope_instance_0;
  }
  function StartResumingScope_0() {
    StartResumingScope_instance_0 = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(StartResumingScope_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.StartResumingScope.Scope' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'scope';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(StartResumingScope_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.StartResumingScope.Scope' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var scope = _this__u8e3s4.w4p(tmp$ret$0);
    rememberManager.j3m(scope);
  };
  var StartResumingScope_instance_0;
  function StartResumingScope_getInstance_0() {
    if (StartResumingScope_instance_0 == null)
      new StartResumingScope_0();
    return StartResumingScope_instance_0;
  }
  function EndResumingScope_0() {
    EndResumingScope_instance_0 = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(EndResumingScope_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndResumingScope.Scope' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'scope';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(EndResumingScope_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndResumingScope.Scope' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var scope = _this__u8e3s4.w4p(tmp$ret$0);
    rememberManager.v3o(scope);
  };
  var EndResumingScope_instance_0;
  function EndResumingScope_getInstance_0() {
    if (EndResumingScope_instance_0 == null)
      new EndResumingScope_0();
    return EndResumingScope_instance_0;
  }
  function AppendValue_0() {
    AppendValue_instance_0 = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(AppendValue_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.AppendValue.Value' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'value';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(AppendValue_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.AppendValue.Value' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var value = _this__u8e3s4.w4p(tmp$ret$0);
    if (!(value == null) ? isInterface(value, RememberObserverHolder) : false) {
      rememberManager.o4b(value);
    }
    slots.o4n(value);
  };
  var AppendValue_instance_0;
  function AppendValue_getInstance_0() {
    if (AppendValue_instance_0 == null)
      new AppendValue_0();
    return AppendValue_instance_0;
  }
  function RemoveTailGroupsAndValues() {
    RemoveTailGroupsAndValues_instance = this;
    Operation_0.call(this, 2);
  }
  protoOf(RemoveTailGroupsAndValues).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveTailGroupsAndValues.FirstTailGroupToRemove' call
    if (parameter === 0) {
      tmp = 'firstTailGroupToRemove';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveTailGroupsAndValues.TailSlotCount' call
      if (parameter === 1) {
        tmp = 'tailSlotCount';
      } else {
        tmp = protoOf(Operation_0).d4f.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(RemoveTailGroupsAndValues).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveTailGroupsAndValues.TailSlotCount' call
    var tailSlotCount = _this__u8e3s4.o4g(1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveTailGroupsAndValues.FirstTailGroupToRemove' call
    var firstTailGroupToRemove = _this__u8e3s4.o4g(0);
    var tmp = slots.k3s();
    var tmp_0 = Operation$RemoveTailGroupsAndValues$execute$lambda(rememberManager);
    slots.q4n(tmp, firstTailGroupToRemove, tailSlotCount, new sam$androidx_compose_runtime_composer_linkbuffer_SlotTableEditor_VisitSlotsInRememberOrderCallback$0_3(tmp_0));
    slots.p4n(tailSlotCount);
    while (!(slots.h3u() === firstTailGroupToRemove)) {
      slots.y35();
    }
    while (slots.h3u() >= 0) {
      slots.a4n(true);
    }
  };
  var RemoveTailGroupsAndValues_instance;
  function RemoveTailGroupsAndValues_getInstance() {
    if (RemoveTailGroupsAndValues_instance == null)
      new RemoveTailGroupsAndValues();
    return RemoveTailGroupsAndValues_instance;
  }
  function UpdateRememberObserverHolderOrdering() {
    UpdateRememberObserverHolderOrdering_instance = this;
    Operation_0.call(this, 0, 2);
  }
  protoOf(UpdateRememberObserverHolderOrdering).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateRememberObserverHolderOrdering.After' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'after';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateRememberObserverHolderOrdering.Holder' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'rememberObserverHolder';
      } else {
        tmp = protoOf(Operation_0).s4p.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(UpdateRememberObserverHolderOrdering).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateRememberObserverHolderOrdering.Holder' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var holder = _this__u8e3s4.w4p(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateRememberObserverHolderOrdering.After' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var after = _this__u8e3s4.w4p(tmp$ret$1);
    holder.k3x_1 = after;
  };
  var UpdateRememberObserverHolderOrdering_instance;
  function UpdateRememberObserverHolderOrdering_getInstance() {
    if (UpdateRememberObserverHolderOrdering_instance == null)
      new UpdateRememberObserverHolderOrdering();
    return UpdateRememberObserverHolderOrdering_instance;
  }
  function UpdateValueRelative() {
    UpdateValueRelative_instance = this;
    Operation_0.call(this, 1, 1);
  }
  protoOf(UpdateValueRelative).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateValueRelative.SlotIndex' call
    if (parameter === 0) {
      tmp = 'slotIndex';
    } else {
      tmp = protoOf(Operation_0).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(UpdateValueRelative).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateValueRelative.Value' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'value';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(UpdateValueRelative).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateValueRelative.Value' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var value = _this__u8e3s4.w4p(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateValueRelative.SlotIndex' call
    var slotIndex = _this__u8e3s4.o4g(0);
    if (!(value == null) ? isInterface(value, RememberObserverHolder) : false) {
      rememberManager.o4b(value);
    }
    var previous = slots.n4n(slotIndex, value);
    if (!(previous == null) ? isInterface(previous, RememberObserverHolder) : false) {
      rememberManager.f36(previous);
    } else {
      if (previous instanceof RecomposeScopeImpl) {
        previous.r2v();
      }
    }
  };
  var UpdateValueRelative_instance;
  function UpdateValueRelative_getInstance() {
    if (UpdateValueRelative_instance == null)
      new UpdateValueRelative();
    return UpdateValueRelative_instance;
  }
  function UpdateAuxData_0() {
    UpdateAuxData_instance_0 = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(UpdateAuxData_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateAuxData.Data' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'data';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(UpdateAuxData_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateAuxData.Data' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    slots.m4c(_this__u8e3s4.w4p(tmp$ret$0));
  };
  var UpdateAuxData_instance_0;
  function UpdateAuxData_getInstance_0() {
    if (UpdateAuxData_instance_0 == null)
      new UpdateAuxData_0();
    return UpdateAuxData_instance_0;
  }
  function RemoveGroup() {
    RemoveGroup_instance = this;
    Operation_0.call(this);
  }
  protoOf(RemoveGroup).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    removeGroupAndForgetSlots(slots, rememberManager);
  };
  var RemoveGroup_instance;
  function RemoveGroup_getInstance() {
    if (RemoveGroup_instance == null)
      new RemoveGroup();
    return RemoveGroup_instance;
  }
  function MoveGroup() {
    MoveGroup_instance = this;
    Operation_0.call(this, 1);
  }
  protoOf(MoveGroup).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveGroup.Offset' call
    if (parameter === 0) {
      tmp = 'offset';
    } else {
      tmp = protoOf(Operation_0).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(MoveGroup).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveGroup.Offset' call
    slots.k3w(_this__u8e3s4.o4g(0));
  };
  var MoveGroup_instance;
  function MoveGroup_getInstance() {
    if (MoveGroup_instance == null)
      new MoveGroup();
    return MoveGroup_instance;
  }
  function ClearAllRecompositionRequired() {
    ClearAllRecompositionRequired_instance = this;
    Operation_0.call(this, VOID, VOID, false);
  }
  protoOf(ClearAllRecompositionRequired).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    slots.r4n(67108864);
  };
  var ClearAllRecompositionRequired_instance;
  function ClearAllRecompositionRequired_getInstance() {
    if (ClearAllRecompositionRequired_instance == null)
      new ClearAllRecompositionRequired();
    return ClearAllRecompositionRequired_instance;
  }
  function EndCompositionScope_0() {
    EndCompositionScope_instance_0 = this;
    Operation_0.call(this, VOID, 2);
  }
  protoOf(EndCompositionScope_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndCompositionScope.Action' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'anchor';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndCompositionScope.Composition' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'composition';
      } else {
        tmp = protoOf(Operation_0).s4p.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(EndCompositionScope_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndCompositionScope.Action' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var action = _this__u8e3s4.w4p(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.EndCompositionScope.Composition' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var composition = _this__u8e3s4.w4p(tmp$ret$1);
    action(composition);
  };
  var EndCompositionScope_instance_0;
  function EndCompositionScope_getInstance_0() {
    if (EndCompositionScope_instance_0 == null)
      new EndCompositionScope_0();
    return EndCompositionScope_instance_0;
  }
  function UseCurrentNode_0() {
    UseCurrentNode_instance_0 = this;
    Operation_0.call(this);
  }
  protoOf(UseCurrentNode_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    applier.o2y();
  };
  var UseCurrentNode_instance_0;
  function UseCurrentNode_getInstance_0() {
    if (UseCurrentNode_instance_0 == null)
      new UseCurrentNode_0();
    return UseCurrentNode_instance_0;
  }
  function UpdateNode_0() {
    UpdateNode_instance_0 = this;
    Operation_0.call(this, VOID, 2);
  }
  protoOf(UpdateNode_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateNode.Value' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'value';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateNode.Block' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'block';
      } else {
        tmp = protoOf(Operation_0).s4p.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(UpdateNode_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateNode.Value' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var value = _this__u8e3s4.w4p(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.UpdateNode.Block' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var block = _this__u8e3s4.w4p(tmp$ret$1);
    applier.n2y(block, value);
  };
  var UpdateNode_instance_0;
  function UpdateNode_getInstance_0() {
    if (UpdateNode_instance_0 == null)
      new UpdateNode_0();
    return UpdateNode_instance_0;
  }
  function RemoveNode_0() {
    RemoveNode_instance_0 = this;
    Operation_0.call(this, 2);
  }
  protoOf(RemoveNode_0).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveNode.RemoveIndex' call
    if (parameter === 0) {
      tmp = 'removeIndex';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveNode.Count' call
      if (parameter === 1) {
        tmp = 'count';
      } else {
        tmp = protoOf(Operation_0).d4f.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(RemoveNode_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveNode.RemoveIndex' call
    var tmp = _this__u8e3s4.o4g(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.RemoveNode.Count' call
    applier.l2y(tmp, _this__u8e3s4.o4g(1));
  };
  var RemoveNode_instance_0;
  function RemoveNode_getInstance_0() {
    if (RemoveNode_instance_0 == null)
      new RemoveNode_0();
    return RemoveNode_instance_0;
  }
  function MoveNode_0() {
    MoveNode_instance_0 = this;
    Operation_0.call(this, 3);
  }
  protoOf(MoveNode_0).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.From' call
    if (parameter === 0) {
      tmp = 'from';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.To' call
      if (parameter === 1) {
        tmp = 'to';
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.Count' call
        if (parameter === 2) {
          tmp = 'count';
        } else {
          tmp = protoOf(Operation_0).d4f.call(this, parameter);
        }
      }
    }
    return tmp;
  };
  protoOf(MoveNode_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.From' call
    var tmp = _this__u8e3s4.o4g(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.To' call
    var tmp_0 = _this__u8e3s4.o4g(1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.MoveNode.Count' call
    applier.m2y(tmp, tmp_0, _this__u8e3s4.o4g(2));
  };
  var MoveNode_instance_0;
  function MoveNode_getInstance_0() {
    if (MoveNode_instance_0 == null)
      new MoveNode_0();
    return MoveNode_instance_0;
  }
  function InsertSlots_0() {
    InsertSlots_instance_0 = this;
    Operation_0.call(this, 2, 1);
  }
  protoOf(InsertSlots_0).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.SourceHighBits' call
    if (parameter === 0) {
      tmp = 'source[32..63]';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.SourceLowBits' call
      if (parameter === 1) {
        tmp = 'source[0..31]';
      } else {
        tmp = protoOf(Operation_0).d4f.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(InsertSlots_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.FromSlotTable' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'from';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(InsertSlots_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.FromSlotTable' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var tmp = _this__u8e3s4.w4p(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.SourceHighBits' call
    var tmp_0 = 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlots.SourceLowBits' call
    slots.k4n(tmp, getLong(_this__u8e3s4, tmp_0, 1));
    slots.y35();
  };
  var InsertSlots_instance_0;
  function InsertSlots_getInstance_0() {
    if (InsertSlots_instance_0 == null)
      new InsertSlots_0();
    return InsertSlots_instance_0;
  }
  function InsertSlotsWithFixups_0() {
    InsertSlotsWithFixups_instance_0 = this;
    Operation_0.call(this, 2, 2);
  }
  protoOf(InsertSlotsWithFixups_0).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.SourceHighBits' call
    if (parameter === 0) {
      tmp = 'sourceHandle[32..63]';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.SourceLowBits' call
      if (parameter === 1) {
        tmp = 'sourceHandle[0..31]';
      } else {
        tmp = protoOf(Operation_0).d4f.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(InsertSlotsWithFixups_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.FromSlotTable' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'from';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.Fixups' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'fixups';
      } else {
        tmp = protoOf(Operation_0).s4p.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(InsertSlotsWithFixups_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.FromSlotTable' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var insertTable = _this__u8e3s4.w4p(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.Fixups' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var fixups = _this__u8e3s4.w4p(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = insertTable.b3v();
    var tmp;
    try {
      fixups.j4p(applier, $this$with, rememberManager, errorContext == null ? null : withCurrentStackTrace_0(errorContext, slots));
      tmp = Unit_instance;
    }finally {
      $this$with.j4();
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.SourceHighBits' call
    var tmp_0 = 0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertSlotsWithFixups.SourceLowBits' call
    slots.k4n(insertTable, getLong(_this__u8e3s4, tmp_0, 1));
    slots.y35();
  };
  var InsertSlotsWithFixups_instance_0;
  function InsertSlotsWithFixups_getInstance_0() {
    if (InsertSlotsWithFixups_instance_0 == null)
      new InsertSlotsWithFixups_0();
    return InsertSlotsWithFixups_instance_0;
  }
  function InsertNodeFixup_0() {
    InsertNodeFixup_instance_0 = this;
    Operation_0.call(this, 3, 1);
  }
  protoOf(InsertNodeFixup_0).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.InsertIndex' call
    if (parameter === 0) {
      tmp = 'insertIndex';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.GroupHandleHigh' call
      if (parameter === 1) {
        tmp = 'groupHandleHigh';
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.GroupHandleLow' call
        if (parameter === 2) {
          tmp = 'groupHandleLow';
        } else {
          tmp = protoOf(Operation_0).d4f.call(this, parameter);
        }
      }
    }
    return tmp;
  };
  protoOf(InsertNodeFixup_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.Factory' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'factory';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(InsertNodeFixup_0).r4p = function (_this__u8e3s4, slots) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.GroupHandleHigh' call
    var tmp = 1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.GroupHandleLow' call
    return getLong(_this__u8e3s4, tmp, 2);
  };
  protoOf(InsertNodeFixup_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.Factory' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var node = _this__u8e3s4.w4p(tmp$ret$0)();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixup.InsertIndex' call
    var insertIndex = _this__u8e3s4.o4g(0);
    var groupAddress = get_group(this.r4p(_this__u8e3s4, slots));
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    slots.h4n(groupAddress, node);
    nodeApplier.j2y(insertIndex, node);
    nodeApplier.h2y(node);
  };
  var InsertNodeFixup_instance_0;
  function InsertNodeFixup_getInstance_0() {
    if (InsertNodeFixup_instance_0 == null)
      new InsertNodeFixup_0();
    return InsertNodeFixup_instance_0;
  }
  function InsertNodeFixupByAnchor() {
    InsertNodeFixupByAnchor_instance = this;
    Operation_0.call(this, 1, 2);
  }
  protoOf(InsertNodeFixupByAnchor).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.InsertIndex' call
    if (parameter === 0) {
      tmp = 'insertIndex';
    } else {
      tmp = protoOf(Operation_0).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(InsertNodeFixupByAnchor).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.Factory' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'factory';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.Anchor' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'anchor';
      } else {
        tmp = protoOf(Operation_0).s4p.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(InsertNodeFixupByAnchor).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.Factory' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var node = _this__u8e3s4.w4p(tmp$ret$0)();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.InsertIndex' call
    var insertIndex = _this__u8e3s4.o4g(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.InsertNodeFixupByAnchor.Anchor' call
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var groupAddress = _this__u8e3s4.w4p(tmp$ret$2).m3v_1;
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    slots.h4n(groupAddress, node);
    nodeApplier.j2y(insertIndex, node);
    nodeApplier.h2y(node);
  };
  var InsertNodeFixupByAnchor_instance;
  function InsertNodeFixupByAnchor_getInstance() {
    if (InsertNodeFixupByAnchor_instance == null)
      new InsertNodeFixupByAnchor();
    return InsertNodeFixupByAnchor_instance;
  }
  function PostInsertNodeFixup_0() {
    PostInsertNodeFixup_instance_0 = this;
    Operation_0.call(this, 3);
  }
  protoOf(PostInsertNodeFixup_0).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.InsertIndex' call
    if (parameter === 0) {
      tmp = 'insertIndex';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.GroupHandleHigh' call
      if (parameter === 1) {
        tmp = 'groupHandleHigh';
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.GroupHandleLow' call
        if (parameter === 2) {
          tmp = 'groupHandleLow';
        } else {
          tmp = protoOf(Operation_0).d4f.call(this, parameter);
        }
      }
    }
    return tmp;
  };
  protoOf(PostInsertNodeFixup_0).r4p = function (_this__u8e3s4, slots) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.GroupHandleHigh' call
    var tmp = 1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.GroupHandleLow' call
    return getLong(_this__u8e3s4, tmp, 2);
  };
  protoOf(PostInsertNodeFixup_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.InsertIndex' call
    var insertIndex = _this__u8e3s4.o4g(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.GroupHandleHigh' call
    var tmp = 1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixup.GroupHandleLow' call
    var groupAddress = get_group(getLong(_this__u8e3s4, tmp, 2));
    applier.i2y();
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    nodeApplier.k2y(insertIndex, slots.z34(groupAddress));
  };
  var PostInsertNodeFixup_instance_0;
  function PostInsertNodeFixup_getInstance_0() {
    if (PostInsertNodeFixup_instance_0 == null)
      new PostInsertNodeFixup_0();
    return PostInsertNodeFixup_instance_0;
  }
  function PostInsertNodeFixupByAnchor() {
    PostInsertNodeFixupByAnchor_instance = this;
    Operation_0.call(this, 1, 1);
  }
  protoOf(PostInsertNodeFixupByAnchor).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixupByAnchor.InsertIndex' call
    if (parameter === 0) {
      tmp = 'insertIndex';
    } else {
      tmp = protoOf(Operation_0).d4f.call(this, parameter);
    }
    return tmp;
  };
  protoOf(PostInsertNodeFixupByAnchor).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixupByAnchor.Anchor' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'anchor';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(PostInsertNodeFixupByAnchor).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixupByAnchor.InsertIndex' call
    var insertIndex = _this__u8e3s4.o4g(0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.PostInsertNodeFixupByAnchor.Anchor' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var groupAddress = _this__u8e3s4.w4p(tmp$ret$1).m3v_1;
    applier.i2y();
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    nodeApplier.k2y(insertIndex, slots.z34(groupAddress));
  };
  var PostInsertNodeFixupByAnchor_instance;
  function PostInsertNodeFixupByAnchor_getInstance() {
    if (PostInsertNodeFixupByAnchor_instance == null)
      new PostInsertNodeFixupByAnchor();
    return PostInsertNodeFixupByAnchor_instance;
  }
  function DeactivateGroup() {
    DeactivateGroup_instance = this;
    Operation_0.call(this);
  }
  protoOf(DeactivateGroup).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    deactivateGroup(slots, rememberManager);
  };
  var DeactivateGroup_instance;
  function DeactivateGroup_getInstance() {
    if (DeactivateGroup_instance == null)
      new DeactivateGroup();
    return DeactivateGroup_instance;
  }
  function ResetSlots_0() {
    ResetSlots_instance_0 = this;
    Operation_0.call(this);
  }
  protoOf(ResetSlots_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    slots.u4c();
  };
  var ResetSlots_instance_0;
  function ResetSlots_getInstance_0() {
    if (ResetSlots_instance_0 == null)
      new ResetSlots_0();
    return ResetSlots_instance_0;
  }
  function DetermineMovableContentNodeIndex_0() {
    DetermineMovableContentNodeIndex_instance_0 = this;
    Operation_0.call(this, 2, 1);
  }
  protoOf(DetermineMovableContentNodeIndex_0).d4f = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.GroupHandleLowBits' call
    if (parameter === 0) {
      tmp = 'groupHandle[32..63]';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.GroupHandleHighBits' call
      if (parameter === 1) {
        tmp = 'groupHandle[0..31]';
      } else {
        tmp = protoOf(Operation_0).d4f.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(DetermineMovableContentNodeIndex_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.EffectiveNodeIndexOut' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'effectiveNodeIndexOut';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(DetermineMovableContentNodeIndex_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.EffectiveNodeIndexOut' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var effectiveNodeIndexOut = _this__u8e3s4.w4p(tmp$ret$0);
    var tmp = effectiveNodeIndexOut;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.GroupHandleHighBits' call
    var tmp_0 = 1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DetermineMovableContentNodeIndex.GroupHandleLowBits' call
    var tmp_1 = getLong(_this__u8e3s4, tmp_0, 0);
    tmp.s3e_1 = positionToInsert_0(slots, tmp_1, isInterface(applier, Applier) ? applier : THROW_CCE());
  };
  var DetermineMovableContentNodeIndex_instance_0;
  function DetermineMovableContentNodeIndex_getInstance_0() {
    if (DetermineMovableContentNodeIndex_instance_0 == null)
      new DetermineMovableContentNodeIndex_0();
    return DetermineMovableContentNodeIndex_instance_0;
  }
  function CopyNodesToNewAnchorLocation_0() {
    CopyNodesToNewAnchorLocation_instance_0 = this;
    Operation_0.call(this, VOID, 2);
  }
  protoOf(CopyNodesToNewAnchorLocation_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopyNodesToNewAnchorLocation.EffectiveNodeIndex' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'effectiveNodeIndex';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopyNodesToNewAnchorLocation.Nodes' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'nodes';
      } else {
        tmp = protoOf(Operation_0).s4p.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(CopyNodesToNewAnchorLocation_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopyNodesToNewAnchorLocation.EffectiveNodeIndex' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var effectiveNodeIndex = _this__u8e3s4.w4p(tmp$ret$0).s3e_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopyNodesToNewAnchorLocation.Nodes' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var nodesToInsert = _this__u8e3s4.w4p(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.snapshots.fastForEachIndexed' call
    var inductionVariable = 0;
    var last = nodesToInsert.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = nodesToInsert.l1(index);
        if (!isInterface(applier, Applier))
          THROW_CCE();
        applier.k2y(effectiveNodeIndex + index | 0, item);
        applier.j2y(effectiveNodeIndex + index | 0, item);
      }
       while (inductionVariable <= last);
  };
  var CopyNodesToNewAnchorLocation_instance_0;
  function CopyNodesToNewAnchorLocation_getInstance_0() {
    if (CopyNodesToNewAnchorLocation_instance_0 == null)
      new CopyNodesToNewAnchorLocation_0();
    return CopyNodesToNewAnchorLocation_instance_0;
  }
  function EndMovableContentPlacement_0() {
    EndMovableContentPlacement_instance_0 = this;
    Operation_0.call(this);
  }
  protoOf(EndMovableContentPlacement_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    while (slots.k3s() >= 0) {
      if (slots.g4n()) {
        applier.i2y();
      }
      slots.o3l();
    }
  };
  var EndMovableContentPlacement_instance_0;
  function EndMovableContentPlacement_getInstance_0() {
    if (EndMovableContentPlacement_instance_0 == null)
      new EndMovableContentPlacement_0();
    return EndMovableContentPlacement_instance_0;
  }
  function CopySlotTableToHandleLocation() {
    CopySlotTableToHandleLocation_instance = this;
    Operation_0.call(this, VOID, 4);
  }
  protoOf(CopySlotTableToHandleLocation).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.ResolvedState' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'resolvedState';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.ParentCompositionContext' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'resolvedCompositionContext';
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.From' call
        if (parameter === _ObjectParameter___init__impl__iyg1ip_0(2)) {
          tmp = 'from';
        } else {
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.To' call
          if (parameter === _ObjectParameter___init__impl__iyg1ip_0(3)) {
            tmp = 'to';
          } else {
            tmp = protoOf(Operation_0).s4p.call(this, parameter);
          }
        }
      }
    }
    return tmp;
  };
  protoOf(CopySlotTableToHandleLocation).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.From' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(2);
    var from = _this__u8e3s4.w4p(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.To' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(3);
    var to = _this__u8e3s4.w4p(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.ParentCompositionContext' call
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var parentCompositionContext = _this__u8e3s4.w4p(tmp$ret$2);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.CopySlotTableToHandleLocation.ResolvedState' call
    var tmp$ret$3 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var tmp0_elvis_lhs = _this__u8e3s4.w4p(tmp$ret$3);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? parentCompositionContext.d3c(from) : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      composeRuntimeError('Could not resolve state for movable content');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var resolvedState = tmp;
    var resolvedTable = asLinkBufferSlotTable(resolvedState.u3a_1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.edit' call
    // Inline function 'kotlin.with' call
    var $this$with = resolvedTable.b3v();
    var tmp_0;
    try {
      $this$with.x3j();
      $this$with.x3j();
      var tmp_1 = $this$with.o3v();
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
      var groupContext = slots.v3v(slots.h3u());
      var tmp_2 = shiftLeft(fromInt(groupContext), 32);
      // Inline function 'kotlin.toUInt' call
      // Inline function 'kotlin.UInt.toLong' call
      var this_0 = _UInt___init__impl__l7qpdl(-1);
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_0);
      var tmp$ret$10 = bitwiseAnd(fromInt(value), new Long(-1, 0));
      var tmp$ret$8 = bitwiseOr(tmp_2, tmp$ret$10);
      tmp_0 = slots.j4n($this$with, tmp_1, tmp$ret$8);
    }finally {
      $this$with.j4();
    }
    var newGroup = tmp_0;
    var tmp_3 = get_group(newGroup);
    var tmp_4 = to.e35_1;
    adoptScopesInGroupToNewParent(slots.e3v_1, tmp_3, isInterface(tmp_4, RecomposeScopeOwner) ? tmp_4 : THROW_CCE());
  };
  var CopySlotTableToHandleLocation_instance;
  function CopySlotTableToHandleLocation_getInstance() {
    if (CopySlotTableToHandleLocation_instance == null)
      new CopySlotTableToHandleLocation();
    return CopySlotTableToHandleLocation_instance;
  }
  function ReleaseMovableGroup() {
    ReleaseMovableGroup_instance = this;
    Operation_0.call(this, VOID, 3);
  }
  protoOf(ReleaseMovableGroup).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.Composition' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'composition';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.ParentCompositionContext' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'parentCompositionContext';
      } else {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.Reference' call
        if (parameter === _ObjectParameter___init__impl__iyg1ip_0(2)) {
          tmp = 'reference';
        } else {
          tmp = protoOf(Operation_0).s4p.call(this, parameter);
        }
      }
    }
    return tmp;
  };
  protoOf(ReleaseMovableGroup).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.Composition' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var tmp = _this__u8e3s4.w4p(tmp$ret$0);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.ParentCompositionContext' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var tmp_0 = _this__u8e3s4.w4p(tmp$ret$1);
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ReleaseMovableGroup.Reference' call
    var tmp$ret$2 = _ObjectParameter___init__impl__iyg1ip_0(2);
    releaseMovableGroup(tmp, tmp_0, _this__u8e3s4.w4p(tmp$ret$2), slots, applier);
  };
  var ReleaseMovableGroup_instance;
  function ReleaseMovableGroup_getInstance() {
    if (ReleaseMovableGroup_instance == null)
      new ReleaseMovableGroup();
    return ReleaseMovableGroup_instance;
  }
  function DisposeMovableContentState() {
    DisposeMovableContentState_instance = this;
    Operation_0.call(this, VOID, 1);
  }
  protoOf(DisposeMovableContentState).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DisposeMovableContentState.ResolvedState' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'resolvedState';
    } else {
      tmp = protoOf(Operation_0).s4p.call(this, parameter);
    }
    return tmp;
  };
  protoOf(DisposeMovableContentState).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.DisposeMovableContentState.ResolvedState' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var resolvedState = _this__u8e3s4.w4p(tmp$ret$0);
    resolvedState.y32();
  };
  var DisposeMovableContentState_instance;
  function DisposeMovableContentState_getInstance() {
    if (DisposeMovableContentState_instance == null)
      new DisposeMovableContentState();
    return DisposeMovableContentState_instance;
  }
  function ApplyChangeList_0() {
    ApplyChangeList_instance_0 = this;
    Operation_0.call(this, VOID, 2, false);
  }
  protoOf(ApplyChangeList_0).s4p = function (parameter) {
    var tmp;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ApplyChangeList.Changes' call
    if (parameter === _ObjectParameter___init__impl__iyg1ip_0(0)) {
      tmp = 'changes';
    } else {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ApplyChangeList.EffectiveNodeIndex' call
      if (parameter === _ObjectParameter___init__impl__iyg1ip_0(1)) {
        tmp = 'effectiveNodeIndex';
      } else {
        tmp = protoOf(Operation_0).s4p.call(this, parameter);
      }
    }
    return tmp;
  };
  protoOf(ApplyChangeList_0).p4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ApplyChangeList.EffectiveNodeIndex' call
    var tmp$ret$0 = _ObjectParameter___init__impl__iyg1ip_0(1);
    var tmp0_safe_receiver = _this__u8e3s4.w4p(tmp$ret$0);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s3e_1;
    var effectiveNodeIndex = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.ApplyChangeList.Changes' call
    var tmp$ret$1 = _ObjectParameter___init__impl__iyg1ip_0(0);
    var tmp = _this__u8e3s4.w4p(tmp$ret$1);
    var tmp_0;
    if (effectiveNodeIndex > 0) {
      tmp_0 = new OffsetApplier(applier, effectiveNodeIndex);
    } else {
      tmp_0 = applier;
    }
    var tmp_1 = tmp_0;
    tmp.d3v(tmp_1, slots, rememberManager, errorContext == null ? null : withCurrentStackTrace_0(errorContext, slots));
  };
  var ApplyChangeList_instance_0;
  function ApplyChangeList_getInstance_0() {
    if (ApplyChangeList_instance_0 == null)
      new ApplyChangeList_0();
    return ApplyChangeList_instance_0;
  }
  function Operation_0(ints, objects, isExternallyVisible) {
    ints = ints === VOID ? 0 : ints;
    objects = objects === VOID ? 0 : objects;
    isExternallyVisible = isExternallyVisible === VOID ? true : isExternallyVisible;
    this.o4o_1 = ints;
    this.p4o_1 = objects;
    this.q4o_1 = isExternallyVisible;
  }
  protoOf(Operation_0).m = function () {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = getKClassFromExpression(this).o();
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(Operation_0).q4p = function (_this__u8e3s4, applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.withCurrentStackTrace' call
    var location = this.r4p(_this__u8e3s4, slots);
    try {
      this.p4p(_this__u8e3s4, applier, slots, rememberManager, errorContext);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw attachComposeStackTrace_0(e, errorContext, slots, location);
      } else {
        throw $p;
      }
    }
  };
  protoOf(Operation_0).r4p = function (_this__u8e3s4, slots) {
    return new Long(-1, -1);
  };
  protoOf(Operation_0).d4f = function (parameter) {
    return 'IntParameter(' + parameter + ')';
  };
  protoOf(Operation_0).s4p = function (parameter) {
    return 'ObjectParameter(' + _ObjectParameter___get_offset__impl__x7fx93_0(parameter) + ')';
  };
  protoOf(Operation_0).toString = function () {
    return this.m();
  };
  function withCurrentStackTrace_0(_this__u8e3s4, slots) {
    var parent = _this__u8e3s4;
    return new withCurrentStackTrace$1_0(parent, slots);
  }
  function positionToInsert_0(slots, destination, applier) {
    positionToParentOf_0(slots, applier, destination);
    var startParentGroup = slots.k3s();
    var target = get_group(destination);
    // Inline function 'kotlin.apply' call
    var this_0 = new IntStack();
    $l$block: {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroupAndParents' call
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
      var groups = slots.e3v_1.j3u_1.p3u_1;
      var tmp;
      if (!true) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        tmp = groups[target + 2 | 0];
      } else {
        tmp = target;
      }
      var current = tmp;
      while (current > 0) {
        var parent = current;
        if (parent === startParentGroup) {
          break $l$block;
        }
        this_0.g3i(parent);
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        current = groups[current + 2 | 0];
      }
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!!(current === 0)) {
        var tmp$ret$8 = 'Traversing parent of group not in the slot table: ' + target;
        composeImmediateRuntimeError(tmp$ret$8);
      }
    }
    var parents = this_0;
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!(slots.k3s() === startParentGroup)) {
      var tmp$ret$10 = 'Unexpected slot table structure when inserting movable content';
      composeImmediateRuntimeError(tmp$ret$10);
    }
    var startingGroup = slots.h3u();
    var nodeIndex = 0;
    var foundParentNode = false;
    while (!(slots.h3u() === target)) {
      var tmp_0;
      // Inline function 'androidx.compose.runtime.IntStack.isNotEmpty' call
      if (!(parents.f3i_1 === 0)) {
        tmp_0 = slots.h3u() === parents.v3n();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        if (slots.n3o()) {
          applier.h2y(slots.f4n());
          nodeIndex = 0;
          foundParentNode = true;
        }
        slots.x3j();
        parents.k3j();
      } else {
        nodeIndex = nodeIndex + slots.y35() | 0;
      }
    }
    return nodeIndex + (!foundParentNode ? nodeIndex_0(slots, startingGroup) : 0) | 0;
  }
  function releaseMovableGroup(composition, parentContext, reference, slots, applier) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.buildSubTable' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.Companion.build' call
    var addressSpace = slots.e3v_1.j3u_1;
    var builder = SlotTableBuilder_init_$Create$(addressSpace, false, false);
    builder.k3v();
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableBuilder.startGroup' call
    var objectKey = reference.c35_1;
    access$startNewGroup(builder, 126665345, objectKey === Companion_getInstance_0().f30_1 ? 0 : 16777216, objectKey, null, null);
    builder.s3v(268435456);
    builder.b3x(reference.d35_1);
    var wrapperGroup = asLinkAnchor(reference.g35_1).m3v_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupChild' call
    var movableContentReference = slots.e3v_1.j3u_1.p3u_1[wrapperGroup + 3 | 0];
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.makeGroupHandle' call
    var tmp = shiftLeft(fromInt(0), 32);
    // Inline function 'kotlin.toUInt' call
    // Inline function 'kotlin.UInt.toLong' call
    var this_0 = _UInt___init__impl__l7qpdl(movableContentReference);
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(this_0);
    var tmp$ret$7 = bitwiseAnd(fromInt(value), new Long(-1, 0));
    var tmp$ret$5 = bitwiseOr(tmp, tmp$ret$7);
    builder.z4k(slots, tmp$ret$5);
    builder.z35();
    var slotTable = builder.g3d();
    var state = new MovableContentState(slotTable);
    if (slotTable.q4k(slotTable.i3u_1)) {
      var movableContentRecomposeScopeOwner = new releaseMovableGroup$movableContentRecomposeScopeOwner$1(composition, reference);
      adoptScopesInGroupToNewParent(slotTable, slotTable.i3u_1, movableContentRecomposeScopeOwner);
    }
    parentContext.c3c(reference, state, applier);
  }
  function attachComposeStackTrace_0(_this__u8e3s4, errorContext, editor, handle) {
    if (errorContext == null)
      return _this__u8e3s4;
    return attachComposeStackTrace_1(_this__u8e3s4, attachComposeStackTrace$lambda_0(handle, editor, errorContext));
  }
  function positionToParentOf_0(slots, applier, handle) {
    if (slots.k3s() >= 0) {
      // Inline function 'kotlin.apply' call
      var this_0 = mutableIntSetOf();
      var slotTable = slots.e3v_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroupAndParents' call
      var group = slots.l3v(get_group(handle));
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
      var groups = slotTable.j3u_1.p3u_1;
      var tmp;
      if (!true) {
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        tmp = groups[group + 2 | 0];
      } else {
        tmp = group;
      }
      var current = tmp;
      while (current > 0) {
        var parent = current;
        this_0.pv(parent);
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
        current = groups[current + 2 | 0];
      }
      // Inline function 'androidx.compose.runtime.runtimeCheck' call
      if (!!(current === 0)) {
        var tmp$ret$8 = 'Traversing parent of group not in the slot table: ' + group;
        composeImmediateRuntimeError(tmp$ret$8);
      }
      var parents = this_0;
      while (slots.k3s() >= 0 && !parents.dm(slots.k3s())) {
        if (slots.g4n()) {
          applier.i2y();
        }
        slots.o3l();
      }
    }
  }
  function nodeIndex_0(slots, group) {
    if (group < 0)
      return 0;
    var slotTable = slots.e3v_1;
    var index = 0;
    var lastExploredGroup = group;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseGroupAndParents' call
    var group_0 = lastExploredGroup;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseGroupAndParents' call
    var groups = slotTable.j3u_1.p3u_1;
    var tmp;
    if (!true) {
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      tmp = groups[group_0 + 2 | 0];
    } else {
      tmp = group_0;
    }
    var current = tmp;
    while (current > 0) {
      var tmp0 = current;
      $l$block: {
        if (slots.x34(tmp0))
          return index;
        var grandParent = slots.l3v(tmp0);
        var tmp_0;
        if (grandParent < 0) {
          tmp_0 = slotTable.i3u_1;
        } else {
          tmp_0 = slots.v3v(grandParent);
        }
        var firstSibling = tmp_0;
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTable.traverseSiblings' call
        // Inline function 'androidx.compose.runtime.composer.linkbuffer.SlotTableAddressSpace.traverseSiblings' call
        var groups_0 = slotTable.j3u_1.p3u_1;
        var current_0 = firstSibling;
        while (current_0 >= 0) {
          var predecessor = current_0;
          if (predecessor === lastExploredGroup) {
            lastExploredGroup = grandParent;
            break $l$block;
          }
          index = index + slots.y4k(predecessor) | 0;
          // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupNext' call
          current_0 = groups_0[current_0 + 1 | 0];
        }
        lastExploredGroup = grandParent;
      }
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.groupParent' call
      current = groups[current + 2 | 0];
    }
    // Inline function 'androidx.compose.runtime.runtimeCheck' call
    if (!!(current === 0)) {
      var tmp$ret$10 = 'Traversing parent of group not in the slot table: ' + group_0;
      composeImmediateRuntimeError(tmp$ret$10);
    }
    return index;
  }
  function withCurrentStackTrace$1_0($parent, $slots) {
    this.e4u_1 = $parent;
    this.f4u_1 = $slots;
  }
  protoOf(withCurrentStackTrace$1_0).n4j = function (currentOffset) {
    var parentTrace = this.e4u_1.n4j(null);
    var currentGroup = this.f4u_1.k3s();
    if (currentGroup < 0)
      return parentTrace;
    return plus_0(buildTrace_1(this.f4u_1, currentOffset, currentGroup), parentTrace);
  };
  protoOf(withCurrentStackTrace$1_0).o4j = function () {
    return this.e4u_1.o4j();
  };
  function releaseMovableGroup$movableContentRecomposeScopeOwner$1($composition, $reference) {
    this.g4u_1 = $composition;
    this.h4u_1 = $reference;
  }
  protoOf(releaseMovableGroup$movableContentRecomposeScopeOwner$1).i36 = function (scope, instance) {
    var tmp = this.g4u_1;
    var tmp0_safe_receiver = isInterface(tmp, RecomposeScopeOwner) ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i36(scope, instance);
    var result = tmp1_elvis_lhs == null ? InvalidationResult_IGNORED_getInstance() : tmp1_elvis_lhs;
    if (result.equals(InvalidationResult_IGNORED_getInstance())) {
      var _receiver__tnumb7 = this.h4u_1;
      var tmp_0 = _receiver__tnumb7;
      var tmp_1 = _receiver__tnumb7.h35_1;
      tmp_0.h35_1 = plus_1(tmp_1, to(scope, instance == null ? ScopeInvalidated_instance : instance));
      return InvalidationResult_SCHEDULED_getInstance();
    }
    return result;
  };
  protoOf(releaseMovableGroup$movableContentRecomposeScopeOwner$1).j36 = function (scope) {
  };
  protoOf(releaseMovableGroup$movableContentRecomposeScopeOwner$1).k36 = function (value) {
  };
  function attachComposeStackTrace$lambda_0($handle, $editor, $errorContext) {
    return function () {
      var tmp;
      if (!equalsLong($handle, new Long(-1, -1))) {
        $editor.z4m($handle);
        tmp = Unit_instance;
      }
      var trace = buildTrace_1($editor);
      var tmp0_safe_receiver = lastOrNull(trace);
      var offset = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r4j_1;
      // Inline function 'kotlin.let' call
      var it = $errorContext.n4j(offset);
      var tmp_0;
      if (offset == null || it.r()) {
        tmp_0 = it;
      } else {
        var head = first(it);
        var tail = drop(it, 1);
        tmp_0 = plus_0(listOf(head.s4j(VOID, VOID, offset)), tail);
      }
      var parentTrace = tmp_0;
      return new ComposeStackTrace(plus_0(trace, parentTrace), $errorContext.o4j());
    };
  }
  function getLong(_this__u8e3s4, highBitsParam, lowBitsParam) {
    var lowBits = _this__u8e3s4.o4g(lowBitsParam);
    var highBits = _this__u8e3s4.o4g(highBitsParam);
    return bitwiseOr(shiftLeft(fromInt(highBits), 32), bitwiseAnd(fromInt(lowBits), new Long(-1, 0)));
  }
  var androidx_compose_runtime_composer_linkbuffer_changelist_Operations$stable;
  function _WriteScope___init__impl__4xwato_0(stack) {
    return stack;
  }
  function _get_stack__b8zp2v_0($this) {
    return $this;
  }
  function _WriteScope___get_operation__impl__krvgwa_0($this) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.peekOperation' call
    var this_0 = _get_stack__b8zp2v_0($this);
    return this_0.b4o_1[this_0.c4o_1 - 1 | 0];
  }
  function WriteScope__setLong_impl_x9ao3o($this, highParameter, lowParameter, value) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    var value_0 = convertToInt(shiftRightUnsigned(value, 32));
    // Inline function 'kotlin.with' call
    var $this$with = access$_get_stack__7szo53_0($this);
    if (false) {
      var mask = 1 << highParameter;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_1 = (access$_get_pushedIntMask__wrtr8x_0($this$with) & mask) === 0;
      if (false && !value_1) {
        var tmp$ret$4 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0($this).d4f(highParameter);
        composeImmediateRuntimeError(tmp$ret$4);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with, access$_get_pushedIntMask__wrtr8x_0($this$with) | mask);
    }
    var tmp = $this$with.d4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.topIntIndexOf' call
    var tmp_0 = $this$with.e4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.peekOperation' call
    tmp[(tmp_0 - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].o4o_1 | 0) + highParameter | 0] = value_0;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.WriteScope.setInt' call
    var value_2 = convertToInt(value);
    // Inline function 'kotlin.with' call
    var $this$with_0 = access$_get_stack__7szo53_0($this);
    if (false) {
      var mask_0 = 1 << lowParameter;
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_3 = (access$_get_pushedIntMask__wrtr8x_0($this$with_0) & mask_0) === 0;
      if (false && !value_3) {
        var tmp$ret$11 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0($this).d4f(lowParameter);
        composeImmediateRuntimeError(tmp$ret$11);
      }
      access$_set_pushedIntMask__hk28ql_0($this$with_0, access$_get_pushedIntMask__wrtr8x_0($this$with_0) | mask_0);
    }
    var tmp_1 = $this$with_0.d4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.topIntIndexOf' call
    var tmp_2 = $this$with_0.e4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.peekOperation' call
    tmp_1[(tmp_2 - $this$with_0.b4o_1[$this$with_0.c4o_1 - 1 | 0].o4o_1 | 0) + lowParameter | 0] = value_2;
  }
  function WriteScope__setObject_impl_rr41y9_0($this, parameter, value) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_stack__b8zp2v_0($this);
    if (false) {
      var mask = 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter);
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value_0 = ($this$with.i4o_1 & mask) === 0;
      if (false && !value_0) {
        var tmp$ret$3 = 'Already pushed argument ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter);
        composeImmediateRuntimeError(tmp$ret$3);
      }
      $this$with.i4o_1 = $this$with.i4o_1 | mask;
    }
    var tmp = $this$with.f4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.topObjectIndexOf' call
    var tmp_0 = $this$with.g4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.peekOperation' call
    tmp[(tmp_0 - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].p4o_1 | 0) + _ObjectParameter___get_offset__impl__x7fx93_0(parameter) | 0] = value;
    return Unit_instance;
  }
  function WriteScope__setObjects_impl_utvr6i_2($this, parameter1, value1, parameter2, value2) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_stack__b8zp2v_0($this);
    if (false) {
      var mask = 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter1) | 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter2);
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = ($this$with.i4o_1 & mask) === 0;
      if (false && !value) {
        var tmp$ret$3 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter1) + (', ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter2));
        composeImmediateRuntimeError(tmp$ret$3);
      }
      $this$with.i4o_1 = $this$with.i4o_1 | mask;
    }
    var tmp = $this$with.g4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.peekOperation' call
    var base = tmp - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].p4o_1 | 0;
    var objectArgs = $this$with.f4o_1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter1) | 0] = value1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter2) | 0] = value2;
    return Unit_instance;
  }
  function WriteScope__setObjects_impl_utvr6i_3($this, parameter1, value1, parameter2, value2, parameter3, value3) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_stack__b8zp2v_0($this);
    if (false) {
      var mask = 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter1) | 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter2) | 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter3);
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = ($this$with.i4o_1 & mask) === 0;
      if (false && !value) {
        var tmp$ret$3 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter1) + (', ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter2)) + (', ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter3));
        composeImmediateRuntimeError(tmp$ret$3);
      }
      $this$with.i4o_1 = $this$with.i4o_1 | mask;
    }
    var tmp = $this$with.g4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.peekOperation' call
    var base = tmp - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].p4o_1 | 0;
    var objectArgs = $this$with.f4o_1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter1) | 0] = value1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter2) | 0] = value2;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter3) | 0] = value3;
    return Unit_instance;
  }
  function WriteScope__setObjects_impl_utvr6i_4($this, parameter1, value1, parameter2, value2, parameter3, value3, parameter4, value4) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_stack__b8zp2v_0($this);
    if (false) {
      var mask = 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter1) | 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter2) | 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter3) | 1 << _ObjectParameter___get_offset__impl__x7fx93_0(parameter4);
      // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
      var value = ($this$with.i4o_1 & mask) === 0;
      if (false && !value) {
        var tmp$ret$3 = 'Already pushed argument(s) ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter1) + (', ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter2)) + (', ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter3)) + (', ' + _WriteScope___get_operation__impl__krvgwa_0($this).s4p(parameter4));
        composeImmediateRuntimeError(tmp$ret$3);
      }
      $this$with.i4o_1 = $this$with.i4o_1 | mask;
    }
    var tmp = $this$with.g4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.peekOperation' call
    var base = tmp - $this$with.b4o_1[$this$with.c4o_1 - 1 | 0].p4o_1 | 0;
    var objectArgs = $this$with.f4o_1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter1) | 0] = value1;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter2) | 0] = value2;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter3) | 0] = value3;
    objectArgs[base + _ObjectParameter___get_offset__impl__x7fx93_0(parameter4) | 0] = value4;
    return Unit_instance;
  }
  function WriteScope__requireApplication_impl_fouec3($this) {
    _get_stack__b8zp2v_0($this).a4o_1 = true;
  }
  function access$_get_stack__7szo53_0($this) {
    return _get_stack__b8zp2v_0($this);
  }
  function determineNewSize_0($this, currentSize, requiredSize) {
    var resizeAmount = coerceAtMost(currentSize, 1024);
    return coerceAtLeast(currentSize + resizeAmount | 0, requiredSize);
  }
  function resizeOpCodes_0($this) {
    var resizeAmount = coerceAtMost($this.c4o_1, 1024);
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.c4o_1 + resizeAmount | 0;
    var tmp = Array(size);
    var newOpCodes = isArray(tmp) ? tmp : THROW_CCE();
    var tmp_0 = $this;
    var tmp0 = $this.b4o_1;
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = $this.c4o_1;
    arrayCopy(tmp0, newOpCodes, 0, 0, endIndex);
    tmp_0.b4o_1 = newOpCodes;
  }
  function resizeIntArgs_0($this, currentSize, requiredSize) {
    var newIntArgs = new Int32Array(determineNewSize_0($this, currentSize, requiredSize));
    // Inline function 'kotlin.collections.copyInto' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = $this.d4o_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newIntArgs, 0, 0, currentSize);
    $this.d4o_1 = newIntArgs;
  }
  function resizeObjectArgs_0($this, currentSize, requiredSize) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = determineNewSize_0($this, currentSize, requiredSize);
    var newObjectArgs = Array(size);
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = $this.f4o_1;
    arrayCopy(this_0, newObjectArgs, 0, 0, currentSize);
    $this.f4o_1 = newObjectArgs;
  }
  function exceptionMessageForOperationPushNoScope_0($this, operation) {
    return 'Cannot push ' + operation.toString() + ' without arguments because it expects ' + ('' + operation.o4o_1 + ' ints and ' + operation.p4o_1 + ' objects.');
  }
  function exceptionMessageForOperationPushWithScope_0($this, operation) {
    var missingIntCount = 0;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.repeat' call
    var times = operation.o4o_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ((1 << index & $this.h4o_1) === 0) {
          if (missingIntCount > 0) {
            this_0.q(', ');
          }
          this_0.q(operation.d4f(index));
          missingIntCount = missingIntCount + 1 | 0;
        }
      }
       while (inductionVariable < times);
    var missingInts = this_0.toString();
    var missingObjectCount = 0;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.repeat' call
    var times_0 = operation.p4o_1;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < times_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if ((1 << index_0 & $this.i4o_1) === 0) {
          if (missingIntCount > 0) {
            this_1.q(', ');
          }
          this_1.q(operation.s4p(_ObjectParameter___init__impl__iyg1ip_0(index_0)));
          missingObjectCount = missingObjectCount + 1 | 0;
        }
      }
       while (inductionVariable_0 < times_0);
    var missingObjects = this_1.toString();
    return 'Error while pushing ' + operation.toString() + '. Not all arguments were provided. ' + ('Missing ' + missingIntCount + ' int arguments (' + missingInts + ') ') + ('and ' + missingObjectCount + ' object arguments (' + missingObjects + ').');
  }
  function OpIterator_0($outer) {
    this.l4u_1 = $outer;
    this.i4u_1 = 0;
    this.j4u_1 = 0;
    this.k4u_1 = 0;
  }
  protoOf(OpIterator_0).v = function () {
    if (this.i4u_1 >= this.l4u_1.c4o_1)
      return false;
    var op = this.x4j();
    this.j4u_1 = this.j4u_1 + op.o4o_1 | 0;
    this.k4u_1 = this.k4u_1 + op.p4o_1 | 0;
    this.i4u_1 = this.i4u_1 + 1 | 0;
    return this.i4u_1 < this.l4u_1.c4o_1;
  };
  protoOf(OpIterator_0).x4j = function () {
    return this.l4u_1.b4o_1[this.i4u_1];
  };
  protoOf(OpIterator_0).o4g = function (parameter) {
    return this.l4u_1.d4o_1[this.j4u_1 + parameter | 0];
  };
  protoOf(OpIterator_0).w4p = function (parameter) {
    return this.l4u_1.f4o_1[this.k4u_1 + _ObjectParameter___get_offset__impl__x7fx93_0(parameter) | 0];
  };
  function access$_get_pushedIntMask__wrtr8x_0($this) {
    return $this.h4o_1;
  }
  function access$_set_pushedIntMask__hk28ql_0($this, _set____db54di) {
    $this.h4o_1 = _set____db54di;
    return Unit_instance;
  }
  function Operations_0() {
    DebugStringFormattable.call(this);
    this.a4o_1 = false;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(16);
    tmp.b4o_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.c4o_1 = 0;
    this.d4o_1 = new Int32Array(16);
    this.e4o_1 = 0;
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_1.f4o_1 = Array(16);
    this.g4o_1 = 0;
    this.h4o_1 = 0;
    this.i4o_1 = 0;
  }
  protoOf(Operations_0).n1 = function () {
    return this.c4o_1;
  };
  protoOf(Operations_0).r = function () {
    return this.n1() === 0;
  };
  protoOf(Operations_0).fv = function () {
    return !(this.n1() === 0);
  };
  protoOf(Operations_0).c3 = function () {
    this.c4o_1 = 0;
    this.e4o_1 = 0;
    fill_0(this.f4o_1, null, 0, this.g4o_1);
    this.g4o_1 = 0;
    this.a4o_1 = false;
  };
  protoOf(Operations_0).k4o = function (operation) {
    if (false) {
      this.h4o_1 = 0;
      this.i4o_1 = 0;
    }
    if (this.c4o_1 === this.b4o_1.length) {
      resizeOpCodes_0(this);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.ensureIntArgsSizeAtLeast' call
    var requiredSize = this.e4o_1 + operation.o4o_1 | 0;
    var currentSize = this.d4o_1.length;
    if (requiredSize > currentSize) {
      resizeIntArgs_0(this, currentSize, requiredSize);
    }
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.ensureObjectArgsSizeAtLeast' call
    var requiredSize_0 = this.g4o_1 + operation.p4o_1 | 0;
    var currentSize_0 = this.f4o_1.length;
    if (requiredSize_0 > currentSize_0) {
      resizeObjectArgs_0(this, currentSize_0, requiredSize_0);
    }
    var tmp = this.b4o_1;
    var _unary__edvuaz = this.c4o_1;
    this.c4o_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = operation;
    this.e4o_1 = this.e4o_1 + operation.o4o_1 | 0;
    this.g4o_1 = this.g4o_1 + operation.p4o_1 | 0;
    if (operation.q4o_1)
      this.a4o_1 = true;
  };
  protoOf(Operations_0).t4o = function (operation) {
    if (false) {
      // Inline function 'androidx.compose.runtime.requirePrecondition' call
      if (!((operation.o4o_1 & operation.p4o_1) === 0)) {
        var tmp$ret$1 = exceptionMessageForOperationPushNoScope_0(this, operation);
        throwIllegalArgumentException(tmp$ret$1);
      }
    }
    this.k4o(operation);
  };
  protoOf(Operations_0).l4o = function (operation) {
    var tmp;
    var tmp_0 = this.h4o_1;
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.createExpectedArgMask' call
    var paramCount = operation.o4o_1;
    if (tmp_0 === ((paramCount === 0 ? 0 : -1) >>> (32 - paramCount | 0) | 0)) {
      var tmp_1 = this.i4o_1;
      // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.createExpectedArgMask' call
      var paramCount_0 = operation.p4o_1;
      tmp = tmp_1 === ((paramCount_0 === 0 ? 0 : -1) >>> (32 - paramCount_0 | 0) | 0);
    } else {
      tmp = false;
    }
    // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
    var value = tmp;
    if (false && !value) {
      var tmp$ret$3 = exceptionMessageForOperationPushWithScope_0(this, operation);
      composeImmediateRuntimeError(tmp$ret$3);
    }
  };
  protoOf(Operations_0).k4p = function (other) {
    var opCodes = this.b4o_1;
    this.c4o_1 = this.c4o_1 - 1 | 0;
    var op = opCodes[this.c4o_1];
    (isArray(opCodes) ? opCodes : THROW_CCE())[this.c4o_1] = null;
    other.k4o(op);
    var tmp0 = this.f4o_1;
    var tmp2 = other.f4o_1;
    var tmp4 = other.g4o_1 - op.p4o_1 | 0;
    var tmp6 = this.g4o_1 - op.p4o_1 | 0;
    // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.g4o_1;
    arrayCopy(tmp0, tmp2, tmp4, tmp6, endIndex);
    fill_0(this.f4o_1, null, this.g4o_1 - op.p4o_1 | 0, this.g4o_1);
    var tmp0_0 = this.d4o_1;
    var tmp2_0 = other.d4o_1;
    var tmp4_0 = other.e4o_1 - op.o4o_1 | 0;
    var tmp6_0 = this.e4o_1 - op.o4o_1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = this.e4o_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2_0, tmp4_0, tmp6_0, endIndex_0);
    this.g4o_1 = this.g4o_1 - op.p4o_1 | 0;
    this.e4o_1 = this.e4o_1 - op.o4o_1 | 0;
  };
  protoOf(Operations_0).j4o = function (applier, slots, rememberManager, errorContext) {
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.drain' call
    // Inline function 'androidx.compose.runtime.composer.linkbuffer.changelist.Operations.forEach' call
    if (this.fv()) {
      var iterator = new OpIterator_0(this);
      do {
        // Inline function 'kotlin.with' call
        iterator.x4j().q4p(iterator, applier, slots, rememberManager, errorContext);
      }
       while (iterator.v());
    }
    this.c3();
  };
  protoOf(Operations_0).toString = function () {
    return protoOf(DebugStringFormattable).toString.call(this);
  };
  function SubList_0(source, fromIndex, toIndex) {
    AbstractList.call(this);
    this.m4u_1 = source;
    this.n4u_1 = fromIndex;
    this.o4u_1 = toIndex;
    this.p4u_1 = 0;
    ListImplementation_instance.q4u(this.n4u_1, this.o4u_1, this.m4u_1.n1());
    this.p4u_1 = this.o4u_1 - this.n4u_1 | 0;
  }
  protoOf(SubList_0).l1 = function (index) {
    ListImplementation_instance.r4u(index, this.p4u_1);
    return this.m4u_1.l1(this.n4u_1 + index | 0);
  };
  protoOf(SubList_0).n1 = function () {
    return this.p4u_1;
  };
  protoOf(SubList_0).t2 = function (fromIndex, toIndex) {
    ListImplementation_instance.q4u(fromIndex, toIndex, this.p4u_1);
    return new SubList_0(this.m4u_1, this.n4u_1 + fromIndex | 0, this.n4u_1 + toIndex | 0);
  };
  function ImmutableList() {
  }
  var androidx_compose_runtime_external_kotlinx_collections_immutable_adapters_ImmutableCollectionAdapter$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_adapters_ImmutableListAdapter$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_adapters_ImmutableSetAdapter$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_adapters_ImmutableMapAdapter$stable;
  function persistentSetOf() {
    return Companion_getInstance_15().t4u();
  }
  function persistentHashMapOf() {
    return Companion_getInstance_13().v4u();
  }
  function persistentListOf() {
    return persistentVectorOf();
  }
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_AbstractListIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_SingleElementListIterator$stable;
  function SingleElementListIterator(element, index) {
    AbstractListIterator.call(this, index, 1);
    this.y4u_1 = element;
  }
  protoOf(SingleElementListIterator).v = function () {
    this.b4v();
    this.z4u_1 = this.z4u_1 + 1 | 0;
    return this.y4u_1;
  };
  protoOf(SingleElementListIterator).x4 = function () {
    this.c4v();
    this.z4u_1 = this.z4u_1 - 1 | 0;
    return this.y4u_1;
  };
  function AbstractListIterator(index, size) {
    this.z4u_1 = index;
    this.a4v_1 = size;
  }
  protoOf(AbstractListIterator).u = function () {
    return this.z4u_1 < this.a4v_1;
  };
  protoOf(AbstractListIterator).v4 = function () {
    return this.z4u_1 > 0;
  };
  protoOf(AbstractListIterator).w4 = function () {
    return this.z4u_1;
  };
  protoOf(AbstractListIterator).y4 = function () {
    return this.z4u_1 - 1 | 0;
  };
  protoOf(AbstractListIterator).b4v = function () {
    if (!this.u())
      throw NoSuchElementException_init_$Create$_0();
  };
  protoOf(AbstractListIterator).c4v = function () {
    if (!this.v4())
      throw NoSuchElementException_init_$Create$_0();
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_AbstractPersistentList$stable;
  function AbstractPersistentList() {
    AbstractList.call(this);
  }
  protoOf(AbstractPersistentList).t2 = function (fromIndex, toIndex) {
    return subList.call(this, fromIndex, toIndex);
  };
  protoOf(AbstractPersistentList).o1 = function (elements) {
    // Inline function 'androidx.compose.runtime.external.kotlinx.collections.immutable.mutate' call
    // Inline function 'kotlin.apply' call
    var this_0 = this.a3d();
    this_0.o1(elements);
    return this_0.g3d();
  };
  protoOf(AbstractPersistentList).d3 = function (element) {
    var index = this.q1(element);
    if (!(index === -1)) {
      return this.h3(index);
    }
    return this;
  };
  protoOf(AbstractPersistentList).m1 = function (element) {
    return !(this.q1(element) === -1);
  };
  protoOf(AbstractPersistentList).r2 = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!this.m1(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractPersistentList).t = function () {
    return this.s2();
  };
  protoOf(AbstractPersistentList).s2 = function () {
    return this.p1(0);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_BufferIterator$stable;
  function BufferIterator(buffer, index, size) {
    AbstractListIterator.call(this, index, size);
    this.g4v_1 = buffer;
  }
  protoOf(BufferIterator).v = function () {
    if (!this.u()) {
      throw NoSuchElementException_init_$Create$_0();
    }
    var _unary__edvuaz = this.z4u_1;
    this.z4u_1 = _unary__edvuaz + 1 | 0;
    return this.g4v_1[_unary__edvuaz];
  };
  protoOf(BufferIterator).x4 = function () {
    if (!this.v4()) {
      throw NoSuchElementException_init_$Create$_0();
    }
    this.z4u_1 = this.z4u_1 - 1 | 0;
    return this.g4v_1[this.z4u_1];
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_PersistentVector$stable;
  function rootSize($this) {
    return rootSize_1($this.j4v_1);
  }
  function pushFilledTail($this, root, filledTail, newTail) {
    if ($this.j4v_1 >> 5 > 1 << $this.k4v_1) {
      var newRoot = presizedBufferWith(root);
      var newRootShift = $this.k4v_1 + 5 | 0;
      newRoot = pushTail($this, newRoot, newRootShift, filledTail);
      return new PersistentVector(newRoot, newTail, $this.j4v_1 + 1 | 0, newRootShift);
    }
    var newRoot_0 = pushTail($this, root, $this.k4v_1, filledTail);
    return new PersistentVector(newRoot_0, newTail, $this.j4v_1 + 1 | 0, $this.k4v_1);
  }
  function pushTail($this, root, shift, tail) {
    var bufferIndex = indexSegment($this.j4v_1 - 1 | 0, shift);
    var tmp1_elvis_lhs = root == null ? null : copyOf_1(root, 32);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOfNulls' call
      tmp = Array(32);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var newRootNode = tmp;
    if (shift === 5) {
      newRootNode[bufferIndex] = tail;
    } else {
      var tmp_0 = newRootNode[bufferIndex];
      newRootNode[bufferIndex] = pushTail($this, (tmp_0 == null ? true : isArray(tmp_0)) ? tmp_0 : THROW_CCE(), shift - 5 | 0, tail);
    }
    return newRootNode;
  }
  function insertIntoTail($this, root, tailIndex, element) {
    var tailSize = $this.j4v_1 - rootSize($this) | 0;
    var newTail = copyOf_1($this.i4v_1, 32);
    if (tailSize < 32) {
      var tmp0 = $this.i4v_1;
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset = tailIndex + 1 | 0;
      arrayCopy(tmp0, newTail, destinationOffset, tailIndex, tailSize);
      newTail[tailIndex] = element;
      return new PersistentVector(root, newTail, $this.j4v_1 + 1 | 0, $this.k4v_1);
    }
    var lastElement = $this.i4v_1[31];
    var tmp0_0 = $this.i4v_1;
    var tmp4 = tailIndex + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = tailSize - 1 | 0;
    arrayCopy(tmp0_0, newTail, tmp4, tailIndex, endIndex);
    newTail[tailIndex] = element;
    return pushFilledTail($this, root, newTail, presizedBufferWith(lastElement));
  }
  function insertIntoRoot($this, root, shift, index, element, elementCarry) {
    var bufferIndex = indexSegment(index, shift);
    if (shift === 0) {
      var tmp;
      if (bufferIndex === 0) {
        // Inline function 'kotlin.arrayOfNulls' call
        tmp = Array(32);
      } else {
        tmp = copyOf_1(root, 32);
      }
      var newRoot = tmp;
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset = bufferIndex + 1 | 0;
      arrayCopy(root, newRoot, destinationOffset, bufferIndex, 31);
      elementCarry.l4v_1 = root[31];
      newRoot[bufferIndex] = element;
      return newRoot;
    }
    var newRoot_0 = copyOf_1(root, 32);
    var lowerLevelShift = shift - 5 | 0;
    var tmp_0 = root[bufferIndex];
    newRoot_0[bufferIndex] = insertIntoRoot($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), lowerLevelShift, index, element, elementCarry);
    var inductionVariable = bufferIndex + 1 | 0;
    if (inductionVariable < 32)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (newRoot_0[i] == null)
          break $l$loop;
        var tmp_1 = root[i];
        newRoot_0[i] = insertIntoRoot($this, (!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : THROW_CCE(), lowerLevelShift, 0, elementCarry.l4v_1, elementCarry);
      }
       while (inductionVariable < 32);
    return newRoot_0;
  }
  function removeFromTailAt($this, root, rootSize, shift, index) {
    var tailSize = $this.j4v_1 - rootSize | 0;
    assert(index < tailSize);
    if (tailSize === 1) {
      return pullLastBufferFromRoot($this, root, rootSize, shift);
    }
    var newTail = copyOf_1($this.i4v_1, 32);
    if (index < (tailSize - 1 | 0)) {
      var tmp0 = $this.i4v_1;
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = index + 1 | 0;
      arrayCopy(tmp0, newTail, index, startIndex, tailSize);
    }
    newTail[tailSize - 1 | 0] = null;
    return new PersistentVector(root, newTail, (rootSize + tailSize | 0) - 1 | 0, shift);
  }
  function pullLastBufferFromRoot($this, root, rootSize, shift) {
    if (shift === 0) {
      var buffer = root.length === 33 ? copyOf_1(root, 32) : root;
      return new SmallPersistentVector(buffer);
    }
    var tailCarry = new ObjectRef(null);
    var newRoot = ensureNotNull(pullLastBuffer($this, root, shift, rootSize - 1 | 0, tailCarry));
    var tmp = tailCarry.l4v_1;
    var newTail = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
    if (newRoot[1] == null) {
      var tmp_0 = newRoot[0];
      var lowerLevelRoot = (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE();
      return new PersistentVector(lowerLevelRoot, newTail, rootSize, shift - 5 | 0);
    }
    return new PersistentVector(newRoot, newTail, rootSize, shift);
  }
  function pullLastBuffer($this, root, shift, index, tailCarry) {
    var bufferIndex = indexSegment(index, shift);
    var tmp;
    if (shift === 5) {
      tailCarry.l4v_1 = root[bufferIndex];
      tmp = null;
    } else {
      var tmp_0 = root[bufferIndex];
      tmp = pullLastBuffer($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), shift - 5 | 0, index, tailCarry);
    }
    var newBufferAtIndex = tmp;
    if (newBufferAtIndex == null && bufferIndex === 0) {
      return null;
    }
    var newRoot = copyOf_1(root, 32);
    newRoot[bufferIndex] = newBufferAtIndex;
    return newRoot;
  }
  function removeFromRootAt($this, root, shift, index, tailCarry) {
    var bufferIndex = indexSegment(index, shift);
    if (shift === 0) {
      var tmp;
      if (bufferIndex === 0) {
        // Inline function 'kotlin.arrayOfNulls' call
        tmp = Array(32);
      } else {
        tmp = copyOf_1(root, 32);
      }
      var newRoot = tmp;
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = bufferIndex + 1 | 0;
      arrayCopy(root, newRoot, bufferIndex, startIndex, 32);
      newRoot[31] = tailCarry.l4v_1;
      tailCarry.l4v_1 = root[bufferIndex];
      return newRoot;
    }
    var bufferLastIndex = 31;
    if (root[bufferLastIndex] == null) {
      bufferLastIndex = indexSegment(rootSize($this) - 1 | 0, shift);
    }
    var newRoot_0 = copyOf_1(root, 32);
    var lowerLevelShift = shift - 5 | 0;
    var inductionVariable = bufferLastIndex;
    var last = bufferIndex + 1 | 0;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp_0 = newRoot_0[i];
        newRoot_0[i] = removeFromRootAt($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), lowerLevelShift, 0, tailCarry);
      }
       while (!(i === last));
    var tmp_1 = newRoot_0[bufferIndex];
    newRoot_0[bufferIndex] = removeFromRootAt($this, (!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : THROW_CCE(), lowerLevelShift, index, tailCarry);
    return newRoot_0;
  }
  function bufferFor($this, index) {
    if (rootSize($this) <= index) {
      return $this.i4v_1;
    }
    var buffer = $this.h4v_1;
    var shift = $this.k4v_1;
    while (shift > 0) {
      var tmp = buffer[indexSegment(index, shift)];
      buffer = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
      shift = shift - 5 | 0;
    }
    return buffer;
  }
  function setInRoot($this, root, shift, index, e) {
    var bufferIndex = indexSegment(index, shift);
    var newRoot = copyOf_1(root, 32);
    if (shift === 0) {
      newRoot[bufferIndex] = e;
    } else {
      var tmp = newRoot[bufferIndex];
      newRoot[bufferIndex] = setInRoot($this, (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE(), shift - 5 | 0, index, e);
    }
    return newRoot;
  }
  function PersistentVector(root, tail, size, rootShift) {
    AbstractPersistentList.call(this);
    this.h4v_1 = root;
    this.i4v_1 = tail;
    this.j4v_1 = size;
    this.k4v_1 = rootShift;
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(this.j4v_1 > 32)) {
      var tmp$ret$1 = 'Trie-based persistent vector should have at least ' + ('33 elements, got ' + this.j4v_1);
      throwIllegalArgumentException(tmp$ret$1);
    }
    assert((this.j4v_1 - rootSize_1(this.j4v_1) | 0) <= coerceAtMost(this.i4v_1.length, 32));
  }
  protoOf(PersistentVector).n1 = function () {
    return this.j4v_1;
  };
  protoOf(PersistentVector).j1 = function (element) {
    var tailSize = this.j4v_1 - rootSize(this) | 0;
    if (tailSize < 32) {
      var newTail = copyOf_1(this.i4v_1, 32);
      newTail[tailSize] = element;
      return new PersistentVector(this.h4v_1, newTail, this.j4v_1 + 1 | 0, this.k4v_1);
    }
    var newTail_0 = presizedBufferWith(element);
    return pushFilledTail(this, this.h4v_1, this.i4v_1, newTail_0);
  };
  protoOf(PersistentVector).d4v = function (index, element) {
    ListImplementation_instance.m4v(index, this.j4v_1);
    if (index === this.j4v_1) {
      return this.j1(element);
    }
    var rootSize_0 = rootSize(this);
    if (index >= rootSize_0) {
      return insertIntoTail(this, this.h4v_1, index - rootSize_0 | 0, element);
    }
    var elementCarry = new ObjectRef(null);
    var newRoot = insertIntoRoot(this, this.h4v_1, this.k4v_1, index, element, elementCarry);
    return insertIntoTail(this, newRoot, 0, elementCarry.l4v_1);
  };
  protoOf(PersistentVector).h3 = function (index) {
    ListImplementation_instance.r4u(index, this.j4v_1);
    var rootSize_0 = rootSize(this);
    if (index >= rootSize_0) {
      return removeFromTailAt(this, this.h4v_1, rootSize_0, this.k4v_1, index - rootSize_0 | 0);
    }
    var newRoot = removeFromRootAt(this, this.h4v_1, this.k4v_1, index, new ObjectRef(this.i4v_1[0]));
    return removeFromTailAt(this, newRoot, rootSize_0, this.k4v_1, 0);
  };
  protoOf(PersistentVector).a3d = function () {
    return new PersistentVectorBuilder(this, this.h4v_1, this.i4v_1, this.k4v_1);
  };
  protoOf(PersistentVector).p1 = function (index) {
    ListImplementation_instance.m4v(index, this.j4v_1);
    var tmp = this.i4v_1;
    return new PersistentVectorIterator(this.h4v_1, isArray(tmp) ? tmp : THROW_CCE(), index, this.j4v_1, (this.k4v_1 / 5 | 0) + 1 | 0);
  };
  protoOf(PersistentVector).l1 = function (index) {
    ListImplementation_instance.r4u(index, this.j4v_1);
    var buffer = bufferFor(this, index);
    return buffer[index & 31];
  };
  protoOf(PersistentVector).f3 = function (index, element) {
    ListImplementation_instance.r4u(index, this.j4v_1);
    if (rootSize(this) <= index) {
      var newTail = copyOf_1(this.i4v_1, 32);
      newTail[index & 31] = element;
      return new PersistentVector(this.h4v_1, newTail, this.j4v_1, this.k4v_1);
    }
    var newRoot = setInRoot(this, this.h4v_1, this.k4v_1, index, element);
    return new PersistentVector(newRoot, this.i4v_1, this.j4v_1, this.k4v_1);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_PersistentVectorBuilder$stable;
  function rootSize_0($this) {
    if ($this.v4v_1 <= 32) {
      return 0;
    }
    return rootSize_1($this.v4v_1);
  }
  function tailSize($this, size) {
    if (size <= 32) {
      return size;
    }
    return size - rootSize_1(size) | 0;
  }
  function tailSize_0($this) {
    return tailSize($this, $this.v4v_1);
  }
  function isMutable($this, buffer) {
    return buffer.length === 33 && buffer[32] === $this.s4v_1;
  }
  function makeMutable($this, buffer) {
    if (buffer == null) {
      return mutableBuffer($this);
    }
    if (isMutable($this, buffer)) {
      return buffer;
    }
    var tmp2 = mutableBuffer($this);
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = coerceAtMost(buffer.length, 32);
    arrayCopy(buffer, tmp2, 0, 0, endIndex);
    return tmp2;
  }
  function makeMutableShiftingRight($this, buffer, distance) {
    if (isMutable($this, buffer)) {
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = 32 - distance | 0;
      arrayCopy(buffer, buffer, distance, 0, endIndex);
      return buffer;
    }
    var tmp2 = mutableBuffer($this);
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = 32 - distance | 0;
    arrayCopy(buffer, tmp2, distance, 0, endIndex_0);
    return tmp2;
  }
  function mutableBufferWith($this, element) {
    // Inline function 'kotlin.arrayOfNulls' call
    var buffer = Array(33);
    buffer[0] = element;
    buffer[32] = $this.s4v_1;
    return buffer;
  }
  function mutableBuffer($this) {
    // Inline function 'kotlin.arrayOfNulls' call
    var buffer = Array(33);
    buffer[32] = $this.s4v_1;
    return buffer;
  }
  function pushFilledTail_0($this, root, filledTail, newTail) {
    var tmp;
    if ($this.v4v_1 >> 5 > 1 << $this.r4v_1) {
      $this.t4v_1 = pushTail_0($this, mutableBufferWith($this, root), filledTail, $this.r4v_1 + 5 | 0);
      $this.u4v_1 = newTail;
      $this.r4v_1 = $this.r4v_1 + 5 | 0;
      $this.v4v_1 = $this.v4v_1 + 1 | 0;
      tmp = Unit_instance;
    } else if (root == null) {
      $this.t4v_1 = filledTail;
      $this.u4v_1 = newTail;
      $this.v4v_1 = $this.v4v_1 + 1 | 0;
      tmp = Unit_instance;
    } else {
      $this.t4v_1 = pushTail_0($this, root, filledTail, $this.r4v_1);
      $this.u4v_1 = newTail;
      $this.v4v_1 = $this.v4v_1 + 1 | 0;
      tmp = Unit_instance;
    }
    return tmp;
  }
  function pushTail_0($this, root, tail, shift) {
    var index = indexSegment($this.v4v_1 - 1 | 0, shift);
    var mutableRoot = makeMutable($this, root);
    if (shift === 5) {
      mutableRoot[index] = tail;
    } else {
      var tmp = mutableRoot[index];
      mutableRoot[index] = pushTail_0($this, (tmp == null ? true : isArray(tmp)) ? tmp : THROW_CCE(), tail, shift - 5 | 0);
    }
    return mutableRoot;
  }
  function copyToBuffer($this, buffer, bufferIndex, sourceIterator) {
    var index = bufferIndex;
    while (index < 32 && sourceIterator.u()) {
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      buffer[_unary__edvuaz] = sourceIterator.v();
    }
    return buffer;
  }
  function pushBuffersIncreasingHeightIfNeeded($this, root, rootSize, buffers) {
    var buffersIterator = arrayIterator(buffers);
    var mutableRoot = rootSize >> 5 < 1 << $this.r4v_1 ? pushBuffers($this, root, rootSize, $this.r4v_1, buffersIterator) : makeMutable($this, root);
    while (buffersIterator.u()) {
      $this.r4v_1 = $this.r4v_1 + 5 | 0;
      mutableRoot = mutableBufferWith($this, mutableRoot);
      pushBuffers($this, mutableRoot, 1 << $this.r4v_1, $this.r4v_1, buffersIterator);
    }
    return mutableRoot;
  }
  function pushBuffers($this, root, rootSize, shift, buffersIterator) {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!buffersIterator.u()) {
      var tmp$ret$1 = 'invalid buffersIterator';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(shift >= 0)) {
      var tmp$ret$3 = 'negative shift';
      throwIllegalArgumentException(tmp$ret$3);
    }
    if (shift === 0) {
      return buffersIterator.v();
    }
    var mutableRoot = makeMutable($this, root);
    var index = indexSegment(rootSize, shift);
    var tmp = index;
    var tmp_0 = mutableRoot[index];
    mutableRoot[tmp] = pushBuffers($this, (tmp_0 == null ? true : isArray(tmp_0)) ? tmp_0 : THROW_CCE(), rootSize, shift - 5 | 0, buffersIterator);
    $l$loop: while (true) {
      var tmp_1;
      index = index + 1 | 0;
      if (index < 32) {
        tmp_1 = buffersIterator.u();
      } else {
        tmp_1 = false;
      }
      if (!tmp_1) {
        break $l$loop;
      }
      var tmp_2 = index;
      var tmp_3 = mutableRoot[index];
      mutableRoot[tmp_2] = pushBuffers($this, (tmp_3 == null ? true : isArray(tmp_3)) ? tmp_3 : THROW_CCE(), 0, shift - 5 | 0, buffersIterator);
    }
    return mutableRoot;
  }
  function insertIntoTail_0($this, root, index, element) {
    var tailSize = tailSize_0($this);
    var mutableTail = makeMutable($this, $this.u4v_1);
    if (tailSize < 32) {
      var tmp0 = $this.u4v_1;
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset = index + 1 | 0;
      arrayCopy(tmp0, mutableTail, destinationOffset, index, tailSize);
      mutableTail[index] = element;
      $this.t4v_1 = root;
      $this.u4v_1 = mutableTail;
      $this.v4v_1 = $this.v4v_1 + 1 | 0;
    } else {
      var lastElement = $this.u4v_1[31];
      var tmp0_0 = $this.u4v_1;
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset_0 = index + 1 | 0;
      arrayCopy(tmp0_0, mutableTail, destinationOffset_0, index, 31);
      mutableTail[index] = element;
      pushFilledTail_0($this, root, mutableTail, mutableBufferWith($this, lastElement));
    }
  }
  function insertIntoRoot_0($this, root, shift, index, element, elementCarry) {
    var bufferIndex = indexSegment(index, shift);
    if (shift === 0) {
      elementCarry.l4v_1 = root[31];
      var tmp2 = makeMutable($this, root);
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset = bufferIndex + 1 | 0;
      arrayCopy(root, tmp2, destinationOffset, bufferIndex, 31);
      var mutableRoot = tmp2;
      mutableRoot[bufferIndex] = element;
      return mutableRoot;
    }
    var mutableRoot_0 = makeMutable($this, root);
    var lowerLevelShift = shift - 5 | 0;
    var tmp = mutableRoot_0[bufferIndex];
    mutableRoot_0[bufferIndex] = insertIntoRoot_0($this, (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE(), lowerLevelShift, index, element, elementCarry);
    var inductionVariable = bufferIndex + 1 | 0;
    if (inductionVariable < 32)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (mutableRoot_0[i] == null)
          break $l$loop;
        var tmp_0 = mutableRoot_0[i];
        mutableRoot_0[i] = insertIntoRoot_0($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), lowerLevelShift, 0, elementCarry.l4v_1, elementCarry);
      }
       while (inductionVariable < 32);
    return mutableRoot_0;
  }
  function insertIntoRoot_1($this, elements, index, rightShift, buffers, nullBuffers, nextBuffer) {
    var tmp0 = $this.t4v_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'root is null';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        break $l$block;
      }
    }
    var startLeafIndex = index >> 5;
    var startLeaf = shiftLeafBuffers($this, startLeafIndex, rightShift, buffers, nullBuffers, nextBuffer);
    var lastLeafIndex = (rootSize_0($this) >> 5) - 1 | 0;
    var newNullBuffers = nullBuffers - (lastLeafIndex - startLeafIndex | 0) | 0;
    var newNextBuffer = newNullBuffers < nullBuffers ? ensureNotNull(buffers[newNullBuffers]) : nextBuffer;
    splitToBuffers($this, elements, index, startLeaf, 32, buffers, newNullBuffers, newNextBuffer);
  }
  function shiftLeafBuffers($this, startLeafIndex, rightShift, buffers, nullBuffers, nextBuffer) {
    var tmp0 = $this.t4v_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'root is null';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        break $l$block;
      }
    }
    var leafCount = rootSize_0($this) >> 5;
    var leafBufferIterator_0 = leafBufferIterator($this, leafCount);
    var bufferIndex = nullBuffers;
    var buffer = nextBuffer;
    while (!(leafBufferIterator_0.y4() === startLeafIndex)) {
      var currentBuffer = leafBufferIterator_0.x4();
      var tmp2 = buffer;
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = 32 - rightShift | 0;
      arrayCopy(currentBuffer, tmp2, 0, startIndex, 32);
      buffer = makeMutableShiftingRight($this, currentBuffer, rightShift);
      bufferIndex = bufferIndex - 1 | 0;
      buffers[bufferIndex] = buffer;
    }
    return leafBufferIterator_0.x4();
  }
  function splitToBuffers($this, elements, index, startBuffer, startBufferSize, buffers, nullBuffers, nextBuffer) {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(nullBuffers >= 1)) {
      var tmp$ret$1 = 'requires at least one nullBuffer';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var firstBuffer = makeMutable($this, startBuffer);
    buffers[0] = firstBuffer;
    var newNextBuffer = nextBuffer;
    var newNullBuffers = nullBuffers;
    var startBufferStartIndex = index & 31;
    var endBufferEndIndex = ((index + elements.n1() | 0) - 1 | 0) & 31;
    var elementsToShift = startBufferSize - startBufferStartIndex | 0;
    if ((endBufferEndIndex + elementsToShift | 0) < 32) {
      var tmp2 = newNextBuffer;
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset = endBufferEndIndex + 1 | 0;
      arrayCopy(firstBuffer, tmp2, destinationOffset, startBufferStartIndex, startBufferSize);
    } else {
      var toCopyToLast = ((endBufferEndIndex + elementsToShift | 0) - 32 | 0) + 1 | 0;
      if (nullBuffers === 1) {
        newNextBuffer = firstBuffer;
      } else {
        newNextBuffer = mutableBuffer($this);
        newNullBuffers = newNullBuffers - 1 | 0;
        buffers[newNullBuffers] = newNextBuffer;
      }
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = startBufferSize - toCopyToLast | 0;
      arrayCopy(firstBuffer, nextBuffer, 0, startIndex, startBufferSize);
      var tmp2_0 = newNextBuffer;
      var tmp4 = endBufferEndIndex + 1 | 0;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = startBufferSize - toCopyToLast | 0;
      arrayCopy(firstBuffer, tmp2_0, tmp4, startBufferStartIndex, endIndex);
    }
    var elementsIterator = elements.t();
    copyToBuffer($this, firstBuffer, startBufferStartIndex, elementsIterator);
    var inductionVariable = 1;
    var last = newNullBuffers;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        buffers[i] = copyToBuffer($this, mutableBuffer($this), 0, elementsIterator);
      }
       while (inductionVariable < last);
    copyToBuffer($this, newNextBuffer, 0, elementsIterator);
  }
  function bufferFor_0($this, index) {
    if (rootSize_0($this) <= index) {
      return $this.u4v_1;
    }
    var buffer = ensureNotNull($this.t4v_1);
    var shift = $this.r4v_1;
    while (shift > 0) {
      var tmp = buffer[indexSegment(index, shift)];
      buffer = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
      shift = shift - 5 | 0;
    }
    return buffer;
  }
  function removeFromTailAt_0($this, root, rootSize, shift, index) {
    var tailSize = $this.v4v_1 - rootSize | 0;
    assert(index < tailSize);
    var removedElement;
    if (tailSize === 1) {
      removedElement = $this.u4v_1[0];
      pullLastBufferFromRoot_0($this, root, rootSize, shift);
    } else {
      removedElement = $this.u4v_1[index];
      var tmp0 = $this.u4v_1;
      var tmp2 = makeMutable($this, $this.u4v_1);
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = index + 1 | 0;
      arrayCopy(tmp0, tmp2, index, startIndex, tailSize);
      var mutableTail = tmp2;
      mutableTail[tailSize - 1 | 0] = null;
      $this.t4v_1 = root;
      $this.u4v_1 = mutableTail;
      $this.v4v_1 = (rootSize + tailSize | 0) - 1 | 0;
      $this.r4v_1 = shift;
    }
    return removedElement;
  }
  function removeFromRootAt_0($this, root, shift, index, tailCarry) {
    var bufferIndex = indexSegment(index, shift);
    if (shift === 0) {
      var removedElement = root[bufferIndex];
      var tmp2 = makeMutable($this, root);
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = bufferIndex + 1 | 0;
      arrayCopy(root, tmp2, bufferIndex, startIndex, 32);
      var mutableRoot = tmp2;
      mutableRoot[31] = tailCarry.l4v_1;
      tailCarry.l4v_1 = removedElement;
      return mutableRoot;
    }
    var bufferLastIndex = 31;
    if (root[bufferLastIndex] == null) {
      bufferLastIndex = indexSegment(rootSize_0($this) - 1 | 0, shift);
    }
    var mutableRoot_0 = makeMutable($this, root);
    var lowerLevelShift = shift - 5 | 0;
    var inductionVariable = bufferLastIndex;
    var last = bufferIndex + 1 | 0;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp = mutableRoot_0[i];
        mutableRoot_0[i] = removeFromRootAt_0($this, (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE(), lowerLevelShift, 0, tailCarry);
      }
       while (!(i === last));
    var tmp_0 = mutableRoot_0[bufferIndex];
    mutableRoot_0[bufferIndex] = removeFromRootAt_0($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), lowerLevelShift, index, tailCarry);
    return mutableRoot_0;
  }
  function pullLastBufferFromRoot_0($this, root, rootSize, shift) {
    if (shift === 0) {
      $this.t4v_1 = null;
      var tmp = $this;
      var tmp_0;
      if (root == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = root;
      }
      tmp.u4v_1 = tmp_0;
      $this.v4v_1 = rootSize;
      $this.r4v_1 = shift;
      return Unit_instance;
    }
    var tailCarry = new ObjectRef(null);
    var newRoot = ensureNotNull(pullLastBuffer_0($this, ensureNotNull(root), shift, rootSize, tailCarry));
    var tmp_1 = $this;
    var tmp_2 = tailCarry.l4v_1;
    tmp_1.u4v_1 = (!(tmp_2 == null) ? isArray(tmp_2) : false) ? tmp_2 : THROW_CCE();
    $this.v4v_1 = rootSize;
    if (newRoot[1] == null) {
      var tmp_3 = $this;
      var tmp_4 = newRoot[0];
      tmp_3.t4v_1 = (tmp_4 == null ? true : isArray(tmp_4)) ? tmp_4 : THROW_CCE();
      $this.r4v_1 = shift - 5 | 0;
    } else {
      $this.t4v_1 = newRoot;
      $this.r4v_1 = shift;
    }
  }
  function pullLastBuffer_0($this, root, shift, rootSize, tailCarry) {
    var bufferIndex = indexSegment(rootSize - 1 | 0, shift);
    var tmp;
    if (shift === 5) {
      tailCarry.l4v_1 = root[bufferIndex];
      tmp = null;
    } else {
      var tmp_0 = root[bufferIndex];
      tmp = pullLastBuffer_0($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), shift - 5 | 0, rootSize, tailCarry);
    }
    var newBufferAtIndex = tmp;
    if (newBufferAtIndex == null && bufferIndex === 0) {
      return null;
    }
    var mutableRoot = makeMutable($this, root);
    mutableRoot[bufferIndex] = newBufferAtIndex;
    return mutableRoot;
  }
  function setInRoot_0($this, root, shift, index, e, oldElementCarry) {
    var bufferIndex = indexSegment(index, shift);
    var mutableRoot = makeMutable($this, root);
    if (shift === 0) {
      if (!(mutableRoot === root)) {
        $this.p4_1 = $this.p4_1 + 1 | 0;
      }
      oldElementCarry.l4v_1 = mutableRoot[bufferIndex];
      mutableRoot[bufferIndex] = e;
      return mutableRoot;
    }
    var tmp = mutableRoot[bufferIndex];
    mutableRoot[bufferIndex] = setInRoot_0($this, (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE(), shift - 5 | 0, index, e, oldElementCarry);
    return mutableRoot;
  }
  function leafBufferIterator($this, index) {
    var tmp0 = $this.t4v_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Invalid root';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    var root = tmp$ret$0;
    var leafCount = rootSize_0($this) >> 5;
    ListImplementation_instance.m4v(index, leafCount);
    if ($this.r4v_1 === 0) {
      return new SingleElementListIterator(root, index);
    }
    var trieHeight = $this.r4v_1 / 5 | 0;
    return new TrieIterator(root, index, leafCount, trieHeight);
  }
  function PersistentVectorBuilder(vector, vectorRoot, vectorTail, rootShift) {
    AbstractMutableList.call(this);
    this.o4v_1 = vector;
    this.p4v_1 = vectorRoot;
    this.q4v_1 = vectorTail;
    this.r4v_1 = rootShift;
    this.s4v_1 = new MutabilityOwnership();
    this.t4v_1 = this.p4v_1;
    this.u4v_1 = this.q4v_1;
    this.v4v_1 = this.o4v_1.n1();
  }
  protoOf(PersistentVectorBuilder).n1 = function () {
    return this.v4v_1;
  };
  protoOf(PersistentVectorBuilder).w4v = function () {
    return this.p4_1;
  };
  protoOf(PersistentVectorBuilder).g3d = function () {
    var tmp = this;
    var tmp_0;
    if (this.t4v_1 === this.p4v_1 && this.u4v_1 === this.q4v_1) {
      tmp_0 = this.o4v_1;
    } else {
      this.s4v_1 = new MutabilityOwnership();
      this.p4v_1 = this.t4v_1;
      this.q4v_1 = this.u4v_1;
      var tmp_1;
      if (this.t4v_1 == null) {
        var tmp_2;
        // Inline function 'kotlin.collections.isEmpty' call
        if (this.u4v_1.length === 0) {
          tmp_2 = persistentVectorOf();
        } else {
          tmp_2 = new SmallPersistentVector(copyOf_1(this.u4v_1, this.v4v_1));
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = new PersistentVector(ensureNotNull(this.t4v_1), this.u4v_1, this.v4v_1, this.r4v_1);
      }
      tmp_0 = tmp_1;
    }
    tmp.o4v_1 = tmp_0;
    return this.o4v_1;
  };
  protoOf(PersistentVectorBuilder).j1 = function (element) {
    this.p4_1 = this.p4_1 + 1 | 0;
    var tailSize = tailSize_0(this);
    if (tailSize < 32) {
      var mutableTail = makeMutable(this, this.u4v_1);
      mutableTail[tailSize] = element;
      this.u4v_1 = mutableTail;
      this.v4v_1 = this.v4v_1 + 1 | 0;
    } else {
      var newTail = mutableBufferWith(this, element);
      pushFilledTail_0(this, this.t4v_1, this.u4v_1, newTail);
    }
    return true;
  };
  protoOf(PersistentVectorBuilder).o1 = function (elements) {
    if (elements.r()) {
      return false;
    }
    this.p4_1 = this.p4_1 + 1 | 0;
    var tailSize = tailSize_0(this);
    var elementsIterator = elements.t();
    if ((32 - tailSize | 0) >= elements.n1()) {
      this.u4v_1 = copyToBuffer(this, makeMutable(this, this.u4v_1), tailSize, elementsIterator);
      this.v4v_1 = this.v4v_1 + elements.n1() | 0;
    } else {
      var buffersSize = ((elements.n1() + tailSize | 0) - 1 | 0) / 32 | 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var buffers = Array(buffersSize);
      buffers[0] = copyToBuffer(this, makeMutable(this, this.u4v_1), tailSize, elementsIterator);
      var inductionVariable = 1;
      if (inductionVariable < buffersSize)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          buffers[index] = copyToBuffer(this, mutableBuffer(this), 0, elementsIterator);
        }
         while (inductionVariable < buffersSize);
      var tmp = this;
      var tmp_0 = this.t4v_1;
      var tmp_1 = rootSize_0(this);
      tmp.t4v_1 = pushBuffersIncreasingHeightIfNeeded(this, tmp_0, tmp_1, isArray(buffers) ? buffers : THROW_CCE());
      this.u4v_1 = copyToBuffer(this, mutableBuffer(this), 0, elementsIterator);
      this.v4v_1 = this.v4v_1 + elements.n1() | 0;
    }
    return true;
  };
  protoOf(PersistentVectorBuilder).g3 = function (index, element) {
    ListImplementation_instance.m4v(index, this.v4v_1);
    if (index === this.v4v_1) {
      this.j1(element);
      return Unit_instance;
    }
    this.p4_1 = this.p4_1 + 1 | 0;
    var rootSize = rootSize_0(this);
    if (index >= rootSize) {
      insertIntoTail_0(this, this.t4v_1, index - rootSize | 0, element);
      return Unit_instance;
    }
    var elementCarry = new ObjectRef(null);
    var newRest = insertIntoRoot_0(this, ensureNotNull(this.t4v_1), this.r4v_1, index, element, elementCarry);
    insertIntoTail_0(this, newRest, 0, elementCarry.l4v_1);
  };
  protoOf(PersistentVectorBuilder).e3 = function (index, elements) {
    ListImplementation_instance.m4v(index, this.v4v_1);
    if (index === this.v4v_1) {
      return this.o1(elements);
    }
    if (elements.r()) {
      return false;
    }
    this.p4_1 = this.p4_1 + 1 | 0;
    var unaffectedElementsCount = index >> 5 << 5;
    var buffersSize = (((this.v4v_1 - unaffectedElementsCount | 0) + elements.n1() | 0) - 1 | 0) / 32 | 0;
    if (buffersSize === 0) {
      assert(index >= rootSize_0(this));
      var startIndex = index & 31;
      var endIndex = ((index + elements.n1() | 0) - 1 | 0) & 31;
      var tmp0 = this.u4v_1;
      var tmp2 = makeMutable(this, this.u4v_1);
      var tmp4 = endIndex + 1 | 0;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex_0 = tailSize_0(this);
      arrayCopy(tmp0, tmp2, tmp4, startIndex, endIndex_0);
      var newTail = tmp2;
      copyToBuffer(this, newTail, startIndex, elements.t());
      this.u4v_1 = newTail;
      this.v4v_1 = this.v4v_1 + elements.n1() | 0;
      return true;
    }
    // Inline function 'kotlin.arrayOfNulls' call
    var buffers = Array(buffersSize);
    var tailSize_1 = tailSize_0(this);
    var newTailSize = tailSize(this, this.v4v_1 + elements.n1() | 0);
    var newTail_0;
    if (index >= rootSize_0(this)) {
      newTail_0 = mutableBuffer(this);
      splitToBuffers(this, elements, index, this.u4v_1, tailSize_1, buffers, buffersSize, newTail_0);
    } else if (newTailSize > tailSize_1) {
      var rightShift = newTailSize - tailSize_1 | 0;
      newTail_0 = makeMutableShiftingRight(this, this.u4v_1, rightShift);
      insertIntoRoot_1(this, elements, index, rightShift, buffers, buffersSize, newTail_0);
    } else {
      var tmp0_0 = this.u4v_1;
      var tmp2_0 = mutableBuffer(this);
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex_0 = tailSize_1 - newTailSize | 0;
      arrayCopy(tmp0_0, tmp2_0, 0, startIndex_0, tailSize_1);
      newTail_0 = tmp2_0;
      var rightShift_0 = 32 - (tailSize_1 - newTailSize | 0) | 0;
      var lastBuffer = makeMutableShiftingRight(this, this.u4v_1, rightShift_0);
      buffers[buffersSize - 1 | 0] = lastBuffer;
      insertIntoRoot_1(this, elements, index, rightShift_0, buffers, buffersSize - 1 | 0, lastBuffer);
    }
    var tmp = this;
    var tmp_0 = this.t4v_1;
    tmp.t4v_1 = pushBuffersIncreasingHeightIfNeeded(this, tmp_0, unaffectedElementsCount, isArray(buffers) ? buffers : THROW_CCE());
    this.u4v_1 = newTail_0;
    this.v4v_1 = this.v4v_1 + elements.n1() | 0;
    return true;
  };
  protoOf(PersistentVectorBuilder).l1 = function (index) {
    ListImplementation_instance.r4u(index, this.v4v_1);
    var buffer = bufferFor_0(this, index);
    return buffer[index & 31];
  };
  protoOf(PersistentVectorBuilder).h3 = function (index) {
    ListImplementation_instance.r4u(index, this.v4v_1);
    this.p4_1 = this.p4_1 + 1 | 0;
    var rootSize = rootSize_0(this);
    if (index >= rootSize) {
      return removeFromTailAt_0(this, this.t4v_1, rootSize, this.r4v_1, index - rootSize | 0);
    }
    var elementCarry = new ObjectRef(this.u4v_1[0]);
    var newRoot = removeFromRootAt_0(this, ensureNotNull(this.t4v_1), this.r4v_1, index, elementCarry);
    removeFromTailAt_0(this, newRoot, rootSize, this.r4v_1, 0);
    return elementCarry.l4v_1;
  };
  protoOf(PersistentVectorBuilder).f3 = function (index, element) {
    ListImplementation_instance.r4u(index, this.v4v_1);
    if (rootSize_0(this) <= index) {
      var mutableTail = makeMutable(this, this.u4v_1);
      if (!(mutableTail === this.u4v_1)) {
        this.p4_1 = this.p4_1 + 1 | 0;
      }
      var tailIndex = index & 31;
      var oldElement = mutableTail[tailIndex];
      mutableTail[tailIndex] = element;
      this.u4v_1 = mutableTail;
      return oldElement;
    }
    var oldElementCarry = new ObjectRef(null);
    this.t4v_1 = setInRoot_0(this, ensureNotNull(this.t4v_1), this.r4v_1, index, element, oldElementCarry);
    return oldElementCarry.l4v_1;
  };
  protoOf(PersistentVectorBuilder).t = function () {
    return this.s2();
  };
  protoOf(PersistentVectorBuilder).s2 = function () {
    return this.p1(0);
  };
  protoOf(PersistentVectorBuilder).p1 = function (index) {
    ListImplementation_instance.m4v(index, this.v4v_1);
    return new PersistentVectorMutableIterator(this, index);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_PersistentVectorIterator$stable;
  function PersistentVectorIterator(root, tail, index, size, trieHeight) {
    AbstractListIterator.call(this, index, size);
    this.z4v_1 = tail;
    var trieSize = rootSize_1(size);
    var trieIndex = coerceAtMost(index, trieSize);
    this.a4w_1 = new TrieIterator(root, trieIndex, trieSize, trieHeight);
  }
  protoOf(PersistentVectorIterator).v = function () {
    this.b4v();
    if (this.a4w_1.u()) {
      this.z4u_1 = this.z4u_1 + 1 | 0;
      return this.a4w_1.v();
    }
    var _unary__edvuaz = this.z4u_1;
    this.z4u_1 = _unary__edvuaz + 1 | 0;
    return this.z4v_1[_unary__edvuaz - this.a4w_1.a4v_1 | 0];
  };
  protoOf(PersistentVectorIterator).x4 = function () {
    this.c4v();
    if (this.z4u_1 > this.a4w_1.a4v_1) {
      this.z4u_1 = this.z4u_1 - 1 | 0;
      return this.z4v_1[this.z4u_1 - this.a4w_1.a4v_1 | 0];
    }
    this.z4u_1 = this.z4u_1 - 1 | 0;
    return this.a4w_1.x4();
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_PersistentVectorMutableIterator$stable;
  function reset($this) {
    $this.a4v_1 = $this.i4w_1.v4v_1;
    $this.j4w_1 = $this.i4w_1.w4v();
    $this.l4w_1 = -1;
    setupTrieIterator($this);
  }
  function setupTrieIterator($this) {
    var root = $this.i4w_1.t4v_1;
    if (root == null) {
      $this.k4w_1 = null;
      return Unit_instance;
    }
    var trieSize = rootSize_1($this.i4w_1.v4v_1);
    var trieIndex = coerceAtMost($this.z4u_1, trieSize);
    var trieHeight = ($this.i4w_1.r4v_1 / 5 | 0) + 1 | 0;
    if ($this.k4w_1 == null) {
      $this.k4w_1 = new TrieIterator(root, trieIndex, trieSize, trieHeight);
    } else {
      ensureNotNull($this.k4w_1).m4w(root, trieIndex, trieSize, trieHeight);
    }
  }
  function checkForComodification($this) {
    if (!($this.j4w_1 === $this.i4w_1.w4v()))
      throw ConcurrentModificationException_init_$Create$();
  }
  function checkHasIterated($this) {
    if ($this.l4w_1 === -1)
      throw IllegalStateException_init_$Create$_0();
  }
  function PersistentVectorMutableIterator(builder, index) {
    AbstractListIterator.call(this, index, builder.v4v_1);
    this.i4w_1 = builder;
    this.j4w_1 = this.i4w_1.w4v();
    this.k4w_1 = null;
    this.l4w_1 = -1;
    setupTrieIterator(this);
  }
  protoOf(PersistentVectorMutableIterator).x4 = function () {
    checkForComodification(this);
    this.c4v();
    this.l4w_1 = this.z4u_1 - 1 | 0;
    var tmp0_elvis_lhs = this.k4w_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0 = this.i4w_1.u4v_1;
      this.z4u_1 = this.z4u_1 - 1 | 0;
      return tmp_0[this.z4u_1];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var trieIterator = tmp;
    if (this.z4u_1 > trieIterator.a4v_1) {
      var tmp_1 = this.i4w_1.u4v_1;
      this.z4u_1 = this.z4u_1 - 1 | 0;
      return tmp_1[this.z4u_1 - trieIterator.a4v_1 | 0];
    }
    this.z4u_1 = this.z4u_1 - 1 | 0;
    return trieIterator.x4();
  };
  protoOf(PersistentVectorMutableIterator).v = function () {
    checkForComodification(this);
    this.b4v();
    this.l4w_1 = this.z4u_1;
    var tmp0_elvis_lhs = this.k4w_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0 = this.i4w_1.u4v_1;
      var _unary__edvuaz = this.z4u_1;
      this.z4u_1 = _unary__edvuaz + 1 | 0;
      return tmp_0[_unary__edvuaz];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var trieIterator = tmp;
    if (trieIterator.u()) {
      this.z4u_1 = this.z4u_1 + 1 | 0;
      return trieIterator.v();
    }
    var tmp_1 = this.i4w_1.u4v_1;
    var _unary__edvuaz_0 = this.z4u_1;
    this.z4u_1 = _unary__edvuaz_0 + 1 | 0;
    return tmp_1[_unary__edvuaz_0 - trieIterator.a4v_1 | 0];
  };
  protoOf(PersistentVectorMutableIterator).l4 = function () {
    checkForComodification(this);
    checkHasIterated(this);
    this.i4w_1.h3(this.l4w_1);
    if (this.l4w_1 < this.z4u_1)
      this.z4u_1 = this.l4w_1;
    reset(this);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_SmallPersistentVector$stable;
  function bufferOfSize($this, size) {
    // Inline function 'kotlin.arrayOfNulls' call
    return Array(size);
  }
  function Companion_12() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    tmp.n4w_1 = new SmallPersistentVector(tmp$ret$0);
  }
  var Companion_instance_13;
  function Companion_getInstance_12() {
    if (Companion_instance_13 == null)
      new Companion_12();
    return Companion_instance_13;
  }
  function SmallPersistentVector(buffer) {
    Companion_getInstance_12();
    AbstractPersistentList.call(this);
    this.o4w_1 = buffer;
    assert(this.o4w_1.length <= 32);
  }
  protoOf(SmallPersistentVector).n1 = function () {
    return this.o4w_1.length;
  };
  protoOf(SmallPersistentVector).j1 = function (element) {
    if (this.n1() < 32) {
      var newBuffer = copyOf_1(this.o4w_1, this.n1() + 1 | 0);
      newBuffer[this.n1()] = element;
      return new SmallPersistentVector(newBuffer);
    }
    var tail = presizedBufferWith(element);
    return new PersistentVector(this.o4w_1, tail, this.n1() + 1 | 0, 0);
  };
  protoOf(SmallPersistentVector).o1 = function (elements) {
    if ((this.n1() + elements.n1() | 0) <= 32) {
      var newBuffer = copyOf_1(this.o4w_1, this.n1() + elements.n1() | 0);
      var index = this.n1();
      var _iterator__ex2g4s = elements.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        newBuffer[_unary__edvuaz] = element;
      }
      return new SmallPersistentVector(newBuffer);
    }
    // Inline function 'androidx.compose.runtime.external.kotlinx.collections.immutable.mutate' call
    // Inline function 'kotlin.apply' call
    var this_0 = this.a3d();
    this_0.o1(elements);
    return this_0.g3d();
  };
  protoOf(SmallPersistentVector).d4v = function (index, element) {
    ListImplementation_instance.m4v(index, this.n1());
    if (index === this.n1()) {
      return this.j1(element);
    }
    if (this.n1() < 32) {
      var newBuffer = bufferOfSize(this, this.n1() + 1 | 0);
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = this.o4w_1;
      arrayCopy(this_0, newBuffer, 0, 0, index);
      var tmp0 = this.o4w_1;
      var tmp4 = index + 1 | 0;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = this.n1();
      arrayCopy(tmp0, newBuffer, tmp4, index, endIndex);
      newBuffer[index] = element;
      return new SmallPersistentVector(newBuffer);
    }
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var root = this.o4w_1.slice();
    var tmp0_0 = this.o4w_1;
    var tmp4_0 = index + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = this.n1() - 1 | 0;
    arrayCopy(tmp0_0, root, tmp4_0, index, endIndex_0);
    root[index] = element;
    var tail = presizedBufferWith(this.o4w_1[31]);
    return new PersistentVector(root, tail, this.n1() + 1 | 0, 0);
  };
  protoOf(SmallPersistentVector).h3 = function (index) {
    ListImplementation_instance.r4u(index, this.n1());
    if (this.n1() === 1) {
      return Companion_getInstance_12().n4w_1;
    }
    var newBuffer = copyOf_1(this.o4w_1, this.n1() - 1 | 0);
    var tmp0 = this.o4w_1;
    var tmp6 = index + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.n1();
    arrayCopy(tmp0, newBuffer, index, tmp6, endIndex);
    return new SmallPersistentVector(newBuffer);
  };
  protoOf(SmallPersistentVector).a3d = function () {
    return new PersistentVectorBuilder(this, null, this.o4w_1, 0);
  };
  protoOf(SmallPersistentVector).q1 = function (element) {
    return indexOf(this.o4w_1, element);
  };
  protoOf(SmallPersistentVector).p1 = function (index) {
    ListImplementation_instance.m4v(index, this.n1());
    var tmp = this.o4w_1;
    return new BufferIterator(isArray(tmp) ? tmp : THROW_CCE(), index, this.n1());
  };
  protoOf(SmallPersistentVector).l1 = function (index) {
    ListImplementation_instance.r4u(index, this.n1());
    return this.o4w_1[index];
  };
  protoOf(SmallPersistentVector).f3 = function (index, element) {
    ListImplementation_instance.r4u(index, this.n1());
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var newBuffer = this.o4w_1.slice();
    newBuffer[index] = element;
    return new SmallPersistentVector(newBuffer);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_TrieIterator$stable;
  function fillPath($this, index, startLevel) {
    var shift = imul($this.d4w_1 - startLevel | 0, 5);
    var i = startLevel;
    while (i < $this.d4w_1) {
      var tmp = $this.e4w_1;
      var tmp_0 = i;
      var tmp_1 = $this.e4w_1[i - 1 | 0];
      tmp[tmp_0] = ((!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : THROW_CCE())[indexSegment(index, shift)];
      shift = shift - 5 | 0;
      i = i + 1 | 0;
    }
  }
  function fillPathIfNeeded($this, indexPredicate) {
    var shift = 0;
    while (indexSegment($this.z4u_1, shift) === indexPredicate) {
      shift = shift + 5 | 0;
    }
    if (shift > 0) {
      var level = ($this.d4w_1 - 1 | 0) - (shift / 5 | 0) | 0;
      fillPath($this, $this.z4u_1, level + 1 | 0);
    }
  }
  function elementAtCurrentIndex($this) {
    var leafBufferIndex = $this.z4u_1 & 31;
    var tmp = $this.e4w_1[$this.d4w_1 - 1 | 0];
    return ((!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE())[leafBufferIndex];
  }
  function TrieIterator(root, index, size, height) {
    AbstractListIterator.call(this, index, size);
    this.d4w_1 = height;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size_0 = this.d4w_1;
    tmp.e4w_1 = Array(size_0);
    this.f4w_1 = index === size;
    this.e4w_1[0] = root;
    fillPath(this, index - (this.f4w_1 ? 1 : 0) | 0, 1);
  }
  protoOf(TrieIterator).m4w = function (root, index, size, height) {
    this.z4u_1 = index;
    this.a4v_1 = size;
    this.d4w_1 = height;
    if (this.e4w_1.length < height) {
      var tmp = this;
      // Inline function 'kotlin.arrayOfNulls' call
      tmp.e4w_1 = Array(height);
    }
    this.e4w_1[0] = root;
    this.f4w_1 = index === size;
    fillPath(this, index - (this.f4w_1 ? 1 : 0) | 0, 1);
  };
  protoOf(TrieIterator).v = function () {
    if (!this.u()) {
      throw NoSuchElementException_init_$Create$_0();
    }
    var result = elementAtCurrentIndex(this);
    this.z4u_1 = this.z4u_1 + 1 | 0;
    if (this.z4u_1 === this.a4v_1) {
      this.f4w_1 = true;
      return result;
    }
    fillPathIfNeeded(this, 0);
    return result;
  };
  protoOf(TrieIterator).x4 = function () {
    if (!this.v4()) {
      throw NoSuchElementException_init_$Create$_0();
    }
    this.z4u_1 = this.z4u_1 - 1 | 0;
    if (this.f4w_1) {
      this.f4w_1 = false;
      return elementAtCurrentIndex(this);
    }
    fillPathIfNeeded(this, 31);
    return elementAtCurrentIndex(this);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_ObjectRef$stable;
  function persistentVectorOf() {
    return Companion_getInstance_12().n4w_1;
  }
  function presizedBufferWith(element) {
    // Inline function 'kotlin.arrayOfNulls' call
    var buffer = Array(32);
    buffer[0] = element;
    return buffer;
  }
  function rootSize_1(vectorSize) {
    return (vectorSize - 1 | 0) & -32;
  }
  function indexSegment(index, shift) {
    return index >> shift & 31;
  }
  function ObjectRef(value) {
    this.l4v_1 = value;
  }
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMap$stable;
  function createEntries($this) {
    return new PersistentHashMapEntries($this);
  }
  function Companion_13() {
    Companion_instance_14 = this;
    this.u4u_1 = new PersistentHashMap(Companion_getInstance_14().p4w_1, 0);
  }
  protoOf(Companion_13).v4u = function () {
    var tmp = this.u4u_1;
    return tmp instanceof PersistentHashMap ? tmp : THROW_CCE();
  };
  var Companion_instance_14;
  function Companion_getInstance_13() {
    if (Companion_instance_14 == null)
      new Companion_13();
    return Companion_instance_14;
  }
  function PersistentHashMap(node, size) {
    Companion_getInstance_13();
    AbstractMap.call(this);
    this.s4w_1 = node;
    this.t4w_1 = size;
  }
  protoOf(PersistentHashMap).n1 = function () {
    return this.t4w_1;
  };
  protoOf(PersistentHashMap).x2 = function () {
    return new PersistentHashMapKeys(this);
  };
  protoOf(PersistentHashMap).y2 = function () {
    return new PersistentHashMapValues(this);
  };
  protoOf(PersistentHashMap).s1 = function () {
    return createEntries(this);
  };
  protoOf(PersistentHashMap).u2 = function (key) {
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return this.s4w_1.y4w(tmp$ret$0, key, 0);
  };
  protoOf(PersistentHashMap).w2 = function (key) {
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return this.s4w_1.z4w(tmp$ret$0, key, 0);
  };
  protoOf(PersistentHashMap).z2 = function (key, value) {
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp0_elvis_lhs = this.s4w_1.a4x(tmp$ret$0, key, value, 0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newNodeResult = tmp;
    return new PersistentHashMap(newNodeResult.b4x_1, this.n1() + newNodeResult.c4x_1 | 0);
  };
  protoOf(PersistentHashMap).a3 = function (key) {
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var newNode = this.s4w_1.d4x(tmp$ret$0, key, 0);
    if (this.s4w_1 === newNode) {
      return this;
    }
    if (newNode == null) {
      return Companion_getInstance_13().v4u();
    }
    return new PersistentHashMap(newNode, this.n1() - 1 | 0);
  };
  protoOf(PersistentHashMap).a3d = function () {
    return new PersistentHashMapBuilder(this);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilder$stable;
  function PersistentHashMapBuilder(map) {
    AbstractMutableMap.call(this);
    this.i4x_1 = map;
    this.j4x_1 = new MutabilityOwnership();
    this.k4x_1 = this.i4x_1.s4w_1;
    this.l4x_1 = null;
    this.m4x_1 = 0;
    this.n4x_1 = this.i4x_1.n1();
  }
  protoOf(PersistentHashMapBuilder).o4x = function (value) {
    this.n4x_1 = value;
    this.m4x_1 = this.m4x_1 + 1 | 0;
  };
  protoOf(PersistentHashMapBuilder).n1 = function () {
    return this.n4x_1;
  };
  protoOf(PersistentHashMapBuilder).g3d = function () {
    var tmp = this;
    var tmp_0;
    if (this.k4x_1 === this.i4x_1.s4w_1) {
      tmp_0 = this.i4x_1;
    } else {
      this.j4x_1 = new MutabilityOwnership();
      tmp_0 = new PersistentHashMap(this.k4x_1, this.n1());
    }
    tmp.i4x_1 = tmp_0;
    return this.i4x_1;
  };
  protoOf(PersistentHashMapBuilder).s1 = function () {
    return new PersistentHashMapBuilderEntries(this);
  };
  protoOf(PersistentHashMapBuilder).x2 = function () {
    return new PersistentHashMapBuilderKeys(this);
  };
  protoOf(PersistentHashMapBuilder).y2 = function () {
    return new PersistentHashMapBuilderValues(this);
  };
  protoOf(PersistentHashMapBuilder).u2 = function (key) {
    var tmp = this.k4x_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return tmp.y4w(tmp$ret$0, key, 0);
  };
  protoOf(PersistentHashMapBuilder).w2 = function (key) {
    var tmp = this.k4x_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return tmp.z4w(tmp$ret$0, key, 0);
  };
  protoOf(PersistentHashMapBuilder).z2 = function (key, value) {
    this.l4x_1 = null;
    var tmp = this;
    var tmp_0 = this.k4x_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.k4x_1 = tmp_0.p4x(tmp$ret$0, key, value, 0, this);
    return this.l4x_1;
  };
  protoOf(PersistentHashMapBuilder).b3 = function (from) {
    var tmp0_elvis_lhs = from instanceof PersistentHashMap ? from : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = from instanceof PersistentHashMapBuilder ? from : null;
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g3d();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var map = tmp;
    if (!(map == null)) {
      var intersectionCounter = new DeltaCounter();
      var oldSize = this.n1();
      var tmp_0 = this;
      var tmp_1 = this.k4x_1;
      var tmp_2 = map.s4w_1;
      tmp_0.k4x_1 = tmp_1.q4x(tmp_2 instanceof TrieNode ? tmp_2 : THROW_CCE(), 0, intersectionCounter, this);
      var newSize = (oldSize + map.n1() | 0) - intersectionCounter.r4x_1 | 0;
      if (!(oldSize === newSize)) {
        this.o4x(newSize);
      }
    } else {
      protoOf(AbstractMutableMap).b3.call(this, from);
    }
  };
  protoOf(PersistentHashMapBuilder).a3 = function (key) {
    this.l4x_1 = null;
    var tmp = this;
    var tmp_0 = this.k4x_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp0_elvis_lhs = tmp_0.s4x(tmp$ret$0, key, 0, this);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      var tmp_2 = Companion_getInstance_14().p4w_1;
      tmp_1 = tmp_2 instanceof TrieNode ? tmp_2 : THROW_CCE();
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    tmp.k4x_1 = tmp_1;
    return this.l4x_1;
  };
  protoOf(PersistentHashMapBuilder).t4x = function (key, value) {
    var oldSize = this.n1();
    var tmp = this;
    var tmp_0 = this.k4x_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp0_elvis_lhs = tmp_0.u4x(tmp$ret$0, key, value, 0, this);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      var tmp_2 = Companion_getInstance_14().p4w_1;
      tmp_1 = tmp_2 instanceof TrieNode ? tmp_2 : THROW_CCE();
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    tmp.k4x_1 = tmp_1;
    return !(oldSize === this.n1());
  };
  protoOf(PersistentHashMapBuilder).c3 = function () {
    var tmp = this;
    var tmp_0 = Companion_getInstance_14().p4w_1;
    tmp.k4x_1 = tmp_0 instanceof TrieNode ? tmp_0 : THROW_CCE();
    this.o4x(0);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeMutableEntriesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderBaseIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderEntriesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderKeysIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderValuesIterator$stable;
  function PersistentHashMapBuilderEntriesIterator(builder) {
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(8);
    while (tmp_0 < 8) {
      tmp_1[tmp_0] = new TrieNodeMutableEntriesIterator(this);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.v4x_1 = new PersistentHashMapBuilderBaseIterator(builder, tmp_1);
  }
  protoOf(PersistentHashMapBuilderEntriesIterator).u = function () {
    return this.v4x_1.u();
  };
  protoOf(PersistentHashMapBuilderEntriesIterator).v = function () {
    return this.v4x_1.v();
  };
  protoOf(PersistentHashMapBuilderEntriesIterator).l4 = function () {
    return this.v4x_1.l4();
  };
  function PersistentHashMapBuilderKeysIterator(builder) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeKeysIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBuilderBaseIterator.call(this, builder, tmp_0);
  }
  function PersistentHashMapBuilderValuesIterator(builder) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeValuesIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBuilderBaseIterator.call(this, builder, tmp_0);
  }
  function resetPath($this, keyHash, node, key, pathIndex) {
    var shift = imul(pathIndex, 5);
    if (shift > 30) {
      $this.w4x_1[pathIndex].k4y(node.x4w_1, node.x4w_1.length, 0);
      while (!equals($this.w4x_1[pathIndex].g4y(), key)) {
        $this.w4x_1[pathIndex].l4y();
      }
      $this.x4x_1 = pathIndex;
      return Unit_instance;
    }
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (node.o4y(keyPositionMask)) {
      var keyIndex = node.m4y(keyPositionMask);
      $this.w4x_1[pathIndex].k4y(node.x4w_1, imul(2, node.n4y()), keyIndex);
      $this.x4x_1 = pathIndex;
      return Unit_instance;
    }
    var nodeIndex = node.p4y(keyPositionMask);
    var targetNode = node.q4y(nodeIndex);
    $this.w4x_1[pathIndex].k4y(node.x4w_1, imul(2, node.n4y()), nodeIndex);
    resetPath($this, keyHash, targetNode, key, pathIndex + 1 | 0);
  }
  function checkNextWasInvoked($this) {
    if (!$this.e4y_1)
      throw IllegalStateException_init_$Create$_0();
  }
  function checkForComodification_0($this) {
    if (!($this.c4y_1.m4x_1 === $this.f4y_1))
      throw ConcurrentModificationException_init_$Create$();
  }
  function PersistentHashMapBuilderBaseIterator(builder, path) {
    PersistentHashMapBaseIterator.call(this, builder.k4x_1, path);
    this.c4y_1 = builder;
    this.d4y_1 = null;
    this.e4y_1 = false;
    this.f4y_1 = this.c4y_1.m4x_1;
  }
  protoOf(PersistentHashMapBuilderBaseIterator).v = function () {
    checkForComodification_0(this);
    this.d4y_1 = this.g4y();
    this.e4y_1 = true;
    return protoOf(PersistentHashMapBaseIterator).v.call(this);
  };
  protoOf(PersistentHashMapBuilderBaseIterator).l4 = function () {
    checkNextWasInvoked(this);
    if (this.u()) {
      var currentKey = this.g4y();
      var tmp0 = this.c4y_1;
      // Inline function 'kotlin.collections.remove' call
      var key = this.d4y_1;
      (isInterface(tmp0, KtMutableMap) ? tmp0 : THROW_CCE()).a3(key);
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs = currentKey == null ? null : hashCode(currentKey);
      var tmp$ret$1 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      resetPath(this, tmp$ret$1, this.c4y_1.k4x_1, currentKey, 0);
    } else {
      var tmp0_0 = this.c4y_1;
      // Inline function 'kotlin.collections.remove' call
      var key_0 = this.d4y_1;
      (isInterface(tmp0_0, KtMutableMap) ? tmp0_0 : THROW_CCE()).a3(key_0);
    }
    this.d4y_1 = null;
    this.e4y_1 = false;
    this.f4y_1 = this.c4y_1.m4x_1;
  };
  function TrieNodeMutableEntriesIterator(parentIterator) {
    TrieNodeBaseIterator.call(this);
    this.u4y_1 = parentIterator;
  }
  protoOf(TrieNodeMutableEntriesIterator).v = function () {
    assert(this.v4y());
    this.j4y_1 = this.j4y_1 + 2 | 0;
    return new MutableMapEntry(this.u4y_1, this.h4y_1[this.j4y_1 - 2 | 0], this.h4y_1[this.j4y_1 - 1 | 0]);
  };
  function MutableMapEntry(parentIterator, key, value) {
    MapEntry.call(this, key, value);
    this.c4z_1 = parentIterator;
    this.d4z_1 = value;
  }
  protoOf(MutableMapEntry).u1 = function () {
    return this.d4z_1;
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_AbstractMapBuilderEntries$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderEntries$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderKeys$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderValues$stable;
  function PersistentHashMapBuilderEntries(builder) {
    AbstractMapBuilderEntries.call(this);
    this.g4z_1 = builder;
  }
  protoOf(PersistentHashMapBuilderEntries).h4z = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(PersistentHashMapBuilderEntries).j1 = function (element) {
    return this.h4z((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(PersistentHashMapBuilderEntries).c3 = function () {
    this.g4z_1.c3();
  };
  protoOf(PersistentHashMapBuilderEntries).t = function () {
    return new PersistentHashMapBuilderEntriesIterator(this.g4z_1);
  };
  protoOf(PersistentHashMapBuilderEntries).w6 = function (element) {
    return this.g4z_1.t4x(element.t1(), element.u1());
  };
  protoOf(PersistentHashMapBuilderEntries).n1 = function () {
    return this.g4z_1.n1();
  };
  protoOf(PersistentHashMapBuilderEntries).v6 = function (element) {
    var tmp0_safe_receiver = this.g4z_1.w2(element.t1());
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = equals(tmp0_safe_receiver, element.u1());
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? element.u1() == null && this.g4z_1.u2(element.t1()) : tmp1_elvis_lhs;
  };
  function PersistentHashMapBuilderKeys(builder) {
    AbstractMutableSet.call(this);
    this.i4z_1 = builder;
  }
  protoOf(PersistentHashMapBuilderKeys).a7 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(PersistentHashMapBuilderKeys).j1 = function (element) {
    return this.a7(element);
  };
  protoOf(PersistentHashMapBuilderKeys).c3 = function () {
    this.i4z_1.c3();
  };
  protoOf(PersistentHashMapBuilderKeys).t = function () {
    return new PersistentHashMapBuilderKeysIterator(this.i4z_1);
  };
  protoOf(PersistentHashMapBuilderKeys).a3 = function (element) {
    if (this.i4z_1.u2(element)) {
      this.i4z_1.a3(element);
      return true;
    }
    return false;
  };
  protoOf(PersistentHashMapBuilderKeys).d3 = function (element) {
    if (!true)
      return false;
    return this.a3(element);
  };
  protoOf(PersistentHashMapBuilderKeys).n1 = function () {
    return this.i4z_1.n1();
  };
  protoOf(PersistentHashMapBuilderKeys).d6 = function (element) {
    return this.i4z_1.u2(element);
  };
  protoOf(PersistentHashMapBuilderKeys).m1 = function (element) {
    if (!true)
      return false;
    return this.d6(element);
  };
  function PersistentHashMapBuilderValues(builder) {
    AbstractMutableCollection.call(this);
    this.j4z_1 = builder;
  }
  protoOf(PersistentHashMapBuilderValues).n1 = function () {
    return this.j4z_1.n1();
  };
  protoOf(PersistentHashMapBuilderValues).j6 = function (element) {
    return this.j4z_1.v2(element);
  };
  protoOf(PersistentHashMapBuilderValues).m1 = function (element) {
    if (!true)
      return false;
    return this.j6(element);
  };
  protoOf(PersistentHashMapBuilderValues).k6 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(PersistentHashMapBuilderValues).j1 = function (element) {
    return this.k6(element);
  };
  protoOf(PersistentHashMapBuilderValues).c3 = function () {
    this.j4z_1.c3();
  };
  protoOf(PersistentHashMapBuilderValues).t = function () {
    return new PersistentHashMapBuilderValuesIterator(this.j4z_1);
  };
  function AbstractMapBuilderEntries() {
    AbstractMutableSet.call(this);
  }
  protoOf(AbstractMapBuilderEntries).s6 = function (element) {
    var tmp = !(element == null) ? element : null;
    if (!(!(tmp == null) ? isInterface(tmp, Entry) : false))
      return false;
    return this.v6(element);
  };
  protoOf(AbstractMapBuilderEntries).m1 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.s6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(AbstractMapBuilderEntries).u6 = function (element) {
    var tmp = !(element == null) ? element : null;
    if (!(!(tmp == null) ? isInterface(tmp, Entry) : false))
      return false;
    return this.w6(element);
  };
  protoOf(AbstractMapBuilderEntries).d3 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.u6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeBaseIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeKeysIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeValuesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeEntriesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_MapEntry$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBaseIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapEntriesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapKeysIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapValuesIterator$stable;
  function PersistentHashMapKeysIterator(node) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeKeysIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBaseIterator.call(this, node, tmp_0);
  }
  function PersistentHashMapValuesIterator(node) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeValuesIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBaseIterator.call(this, node, tmp_0);
  }
  function PersistentHashMapEntriesIterator(node) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeEntriesIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBaseIterator.call(this, node, tmp_0);
  }
  function moveToNextNodeWithData($this, pathIndex) {
    if ($this.w4x_1[pathIndex].v4y()) {
      return pathIndex;
    }
    if ($this.w4x_1[pathIndex].x4y()) {
      var node = $this.w4x_1[pathIndex].y4y();
      if (pathIndex === 6) {
        $this.w4x_1[pathIndex + 1 | 0].w4y(node.x4w_1, node.x4w_1.length);
      } else {
        $this.w4x_1[pathIndex + 1 | 0].w4y(node.x4w_1, imul(2, node.n4y()));
      }
      return moveToNextNodeWithData($this, pathIndex + 1 | 0);
    }
    return -1;
  }
  function ensureNextEntryIsReady($this) {
    if ($this.w4x_1[$this.x4x_1].v4y()) {
      return Unit_instance;
    }
    var inductionVariable = $this.x4x_1;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var result = moveToNextNodeWithData($this, i);
        if (result === -1 && $this.w4x_1[i].x4y()) {
          $this.w4x_1[i].z4y();
          result = moveToNextNodeWithData($this, i);
        }
        if (!(result === -1)) {
          $this.x4x_1 = result;
          return Unit_instance;
        }
        if (i > 0) {
          $this.w4x_1[i - 1 | 0].z4y();
        }
        $this.w4x_1[i].w4y(Companion_getInstance_14().p4w_1.x4w_1, 0);
      }
       while (0 <= inductionVariable);
    $this.y4x_1 = false;
  }
  function checkHasNext($this) {
    if (!$this.u())
      throw NoSuchElementException_init_$Create$_0();
  }
  function PersistentHashMapBaseIterator(node, path) {
    this.w4x_1 = path;
    this.x4x_1 = 0;
    this.y4x_1 = true;
    this.w4x_1[0].w4y(node.x4w_1, imul(2, node.n4y()));
    this.x4x_1 = 0;
    ensureNextEntryIsReady(this);
  }
  protoOf(PersistentHashMapBaseIterator).g4y = function () {
    checkHasNext(this);
    return this.w4x_1[this.x4x_1].g4y();
  };
  protoOf(PersistentHashMapBaseIterator).u = function () {
    return this.y4x_1;
  };
  protoOf(PersistentHashMapBaseIterator).v = function () {
    checkHasNext(this);
    var result = this.w4x_1[this.x4x_1].v();
    ensureNextEntryIsReady(this);
    return result;
  };
  function TrieNodeBaseIterator() {
    this.h4y_1 = Companion_getInstance_14().p4w_1.x4w_1;
    this.i4y_1 = 0;
    this.j4y_1 = 0;
  }
  protoOf(TrieNodeBaseIterator).k4y = function (buffer, dataSize, index) {
    this.h4y_1 = buffer;
    this.i4y_1 = dataSize;
    this.j4y_1 = index;
  };
  protoOf(TrieNodeBaseIterator).w4y = function (buffer, dataSize) {
    this.k4y(buffer, dataSize, 0);
  };
  protoOf(TrieNodeBaseIterator).v4y = function () {
    return this.j4y_1 < this.i4y_1;
  };
  protoOf(TrieNodeBaseIterator).g4y = function () {
    assert(this.v4y());
    return this.h4y_1[this.j4y_1];
  };
  protoOf(TrieNodeBaseIterator).l4y = function () {
    assert(this.v4y());
    this.j4y_1 = this.j4y_1 + 2 | 0;
  };
  protoOf(TrieNodeBaseIterator).x4y = function () {
    assert(this.j4y_1 >= this.i4y_1);
    return this.j4y_1 < this.h4y_1.length;
  };
  protoOf(TrieNodeBaseIterator).y4y = function () {
    assert(this.x4y());
    var tmp = this.h4y_1[this.j4y_1];
    return tmp instanceof TrieNode ? tmp : THROW_CCE();
  };
  protoOf(TrieNodeBaseIterator).z4y = function () {
    assert(this.x4y());
    this.j4y_1 = this.j4y_1 + 1 | 0;
  };
  protoOf(TrieNodeBaseIterator).u = function () {
    return this.v4y();
  };
  function TrieNodeKeysIterator() {
    TrieNodeBaseIterator.call(this);
  }
  protoOf(TrieNodeKeysIterator).v = function () {
    assert(this.v4y());
    this.j4y_1 = this.j4y_1 + 2 | 0;
    return this.h4y_1[this.j4y_1 - 2 | 0];
  };
  function TrieNodeValuesIterator() {
    TrieNodeBaseIterator.call(this);
  }
  protoOf(TrieNodeValuesIterator).v = function () {
    assert(this.v4y());
    this.j4y_1 = this.j4y_1 + 2 | 0;
    return this.h4y_1[this.j4y_1 - 1 | 0];
  };
  function TrieNodeEntriesIterator() {
    TrieNodeBaseIterator.call(this);
  }
  protoOf(TrieNodeEntriesIterator).v = function () {
    assert(this.v4y());
    this.j4y_1 = this.j4y_1 + 2 | 0;
    return new MapEntry(this.h4y_1[this.j4y_1 - 2 | 0], this.h4y_1[this.j4y_1 - 1 | 0]);
  };
  function MapEntry(key, value) {
    this.e4z_1 = key;
    this.f4z_1 = value;
  }
  protoOf(MapEntry).t1 = function () {
    return this.e4z_1;
  };
  protoOf(MapEntry).u1 = function () {
    return this.f4z_1;
  };
  protoOf(MapEntry).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.t1();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.u1();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
  };
  protoOf(MapEntry).equals = function (other) {
    var tmp0_safe_receiver = (!(other == null) ? isInterface(other, Entry) : false) ? other : null;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = (equals(tmp0_safe_receiver.t1(), this.t1()) && equals(tmp0_safe_receiver.u1(), this.u1()));
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(MapEntry).toString = function () {
    return toString_0(this.t1()) + '=' + toString_0(this.u1());
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapEntries$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapKeys$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapValues$stable;
  function PersistentHashMapKeys(map) {
    AbstractSet.call(this);
    this.t4z_1 = map;
  }
  protoOf(PersistentHashMapKeys).n1 = function () {
    return this.t4z_1.n1();
  };
  protoOf(PersistentHashMapKeys).d6 = function (element) {
    return this.t4z_1.u2(element);
  };
  protoOf(PersistentHashMapKeys).m1 = function (element) {
    if (!true)
      return false;
    return this.d6(element);
  };
  protoOf(PersistentHashMapKeys).t = function () {
    return new PersistentHashMapKeysIterator(this.t4z_1.s4w_1);
  };
  function PersistentHashMapValues(map) {
    AbstractCollection.call(this);
    this.u4z_1 = map;
  }
  protoOf(PersistentHashMapValues).n1 = function () {
    return this.u4z_1.n1();
  };
  protoOf(PersistentHashMapValues).j6 = function (element) {
    return this.u4z_1.v2(element);
  };
  protoOf(PersistentHashMapValues).m1 = function (element) {
    if (!true)
      return false;
    return this.j6(element);
  };
  protoOf(PersistentHashMapValues).t = function () {
    return new PersistentHashMapValuesIterator(this.u4z_1.s4w_1);
  };
  function PersistentHashMapEntries(map) {
    AbstractSet.call(this);
    this.v4z_1 = map;
  }
  protoOf(PersistentHashMapEntries).n1 = function () {
    return this.v4z_1.n1();
  };
  protoOf(PersistentHashMapEntries).m14 = function (element) {
    var tmp = !(element == null) ? element : THROW_CCE();
    if (!(!(tmp == null) ? isInterface(tmp, Entry) : false))
      return false;
    var tmp0_safe_receiver = this.v4z_1.w2(element.t1());
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = equals(tmp0_safe_receiver, element.u1());
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? element.u1() == null && this.v4z_1.u2(element.t1()) : tmp1_elvis_lhs;
  };
  protoOf(PersistentHashMapEntries).m1 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.m14((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(PersistentHashMapEntries).t = function () {
    return new PersistentHashMapEntriesIterator(this.v4z_1.s4w_1);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNode_ModificationResult$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNode$stable;
  function TrieNode_init_$Init$(dataMap, nodeMap, buffer, $this) {
    TrieNode.call($this, dataMap, nodeMap, buffer, null);
    return $this;
  }
  function TrieNode_init_$Create$(dataMap, nodeMap, buffer) {
    return TrieNode_init_$Init$(dataMap, nodeMap, buffer, objectCreate(protoOf(TrieNode)));
  }
  function ModificationResult(node, sizeDelta) {
    this.b4x_1 = node;
    this.c4x_1 = sizeDelta;
  }
  function asInsertResult($this) {
    return new ModificationResult($this, 1);
  }
  function asUpdateResult($this) {
    return new ModificationResult($this, 0);
  }
  function hasNodeAt($this, positionMask) {
    return !(($this.v4w_1 & positionMask) === 0);
  }
  function keyAtIndex($this, keyIndex) {
    return $this.x4w_1[keyIndex];
  }
  function valueAtKeyIndex($this, keyIndex) {
    return $this.x4w_1[keyIndex + 1 | 0];
  }
  function insertEntryAt($this, positionMask, key, value) {
    var keyIndex = $this.m4y(positionMask);
    var newBuffer = insertEntryAtIndex($this.x4w_1, keyIndex, key, value);
    return TrieNode_init_$Create$($this.u4w_1 | positionMask, $this.v4w_1, newBuffer);
  }
  function mutableInsertEntryAt($this, positionMask, key, value, owner) {
    var keyIndex = $this.m4y(positionMask);
    if ($this.w4w_1 === owner) {
      $this.x4w_1 = insertEntryAtIndex($this.x4w_1, keyIndex, key, value);
      $this.u4w_1 = $this.u4w_1 | positionMask;
      return $this;
    }
    var newBuffer = insertEntryAtIndex($this.x4w_1, keyIndex, key, value);
    return new TrieNode($this.u4w_1 | positionMask, $this.v4w_1, newBuffer, owner);
  }
  function updateValueAtIndex($this, keyIndex, value) {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var newBuffer = $this.x4w_1.slice();
    newBuffer[keyIndex + 1 | 0] = value;
    return TrieNode_init_$Create$($this.u4w_1, $this.v4w_1, newBuffer);
  }
  function mutableUpdateValueAtIndex($this, keyIndex, value, mutator) {
    if ($this.w4w_1 === mutator.j4x_1) {
      $this.x4w_1[keyIndex + 1 | 0] = value;
      return $this;
    }
    mutator.m4x_1 = mutator.m4x_1 + 1 | 0;
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var newBuffer = $this.x4w_1.slice();
    newBuffer[keyIndex + 1 | 0] = value;
    return new TrieNode($this.u4w_1, $this.v4w_1, newBuffer, mutator.j4x_1);
  }
  function updateNodeAtIndex($this, nodeIndex, positionMask, newNode) {
    var newNodeBuffer = newNode.x4w_1;
    if (newNodeBuffer.length === 2 && newNode.v4w_1 === 0) {
      if ($this.x4w_1.length === 1) {
        newNode.u4w_1 = $this.v4w_1;
        return newNode;
      }
      var keyIndex = $this.m4y(positionMask);
      var newBuffer = replaceNodeWithEntry($this.x4w_1, nodeIndex, keyIndex, newNodeBuffer[0], newNodeBuffer[1]);
      return TrieNode_init_$Create$($this.u4w_1 ^ positionMask, $this.v4w_1 ^ positionMask, newBuffer);
    }
    var newBuffer_0 = copyOf_1($this.x4w_1, $this.x4w_1.length);
    newBuffer_0[nodeIndex] = newNode;
    return TrieNode_init_$Create$($this.u4w_1, $this.v4w_1, newBuffer_0);
  }
  function mutableUpdateNodeAtIndex($this, nodeIndex, newNode, owner) {
    if ($this.x4w_1.length === 1 && newNode.x4w_1.length === 2 && newNode.v4w_1 === 0) {
      newNode.u4w_1 = $this.v4w_1;
      return newNode;
    }
    if ($this.w4w_1 === owner) {
      $this.x4w_1[nodeIndex] = newNode;
      return $this;
    }
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var newBuffer = $this.x4w_1.slice();
    newBuffer[nodeIndex] = newNode;
    return new TrieNode($this.u4w_1, $this.v4w_1, newBuffer, owner);
  }
  function removeNodeAtIndex($this, nodeIndex, positionMask) {
    if ($this.x4w_1.length === 1)
      return null;
    var newBuffer = removeNodeAtIndex_0($this.x4w_1, nodeIndex);
    return TrieNode_init_$Create$($this.u4w_1, $this.v4w_1 ^ positionMask, newBuffer);
  }
  function mutableRemoveNodeAtIndex($this, nodeIndex, positionMask, owner) {
    if ($this.x4w_1.length === 1)
      return null;
    if ($this.w4w_1 === owner) {
      $this.x4w_1 = removeNodeAtIndex_0($this.x4w_1, nodeIndex);
      $this.v4w_1 = $this.v4w_1 ^ positionMask;
      return $this;
    }
    var newBuffer = removeNodeAtIndex_0($this.x4w_1, nodeIndex);
    return new TrieNode($this.u4w_1, $this.v4w_1 ^ positionMask, newBuffer, owner);
  }
  function bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner) {
    var storedKey = keyAtIndex($this, keyIndex);
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = storedKey == null ? null : hashCode(storedKey);
    var storedKeyHash = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var storedValue = valueAtKeyIndex($this, keyIndex);
    var newNode = makeNode($this, storedKeyHash, storedKey, storedValue, newKeyHash, newKey, newValue, shift + 5 | 0, owner);
    var nodeIndex = $this.p4y(positionMask) + 1 | 0;
    return replaceEntryWithNode($this.x4w_1, keyIndex, nodeIndex, newNode);
  }
  function moveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift) {
    var newBuffer = bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, null);
    return TrieNode_init_$Create$($this.u4w_1 ^ positionMask, $this.v4w_1 | positionMask, newBuffer);
  }
  function mutableMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner) {
    if ($this.w4w_1 === owner) {
      $this.x4w_1 = bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner);
      $this.u4w_1 = $this.u4w_1 ^ positionMask;
      $this.v4w_1 = $this.v4w_1 | positionMask;
      return $this;
    }
    var newBuffer = bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner);
    return new TrieNode($this.u4w_1 ^ positionMask, $this.v4w_1 | positionMask, newBuffer, owner);
  }
  function makeNode($this, keyHash1, key1, value1, keyHash2, key2, value2, shift, owner) {
    if (shift > 30) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = [key1, value1, key2, value2];
      return new TrieNode(0, 0, tmp$ret$0, owner);
    }
    var setBit1 = indexSegment_0(keyHash1, shift);
    var setBit2 = indexSegment_0(keyHash2, shift);
    if (!(setBit1 === setBit2)) {
      var tmp;
      if (setBit1 < setBit2) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = [key1, value1, key2, value2];
      } else {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = [key2, value2, key1, value1];
      }
      var nodeBuffer = tmp;
      return new TrieNode(1 << setBit1 | 1 << setBit2, 0, nodeBuffer, owner);
    }
    var node = makeNode($this, keyHash1, key1, value1, keyHash2, key2, value2, shift + 5 | 0, owner);
    var tmp_0 = 1 << setBit1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [node];
    return new TrieNode(0, tmp_0, tmp$ret$9, owner);
  }
  function removeEntryAtIndex($this, keyIndex, positionMask) {
    if ($this.x4w_1.length === 2)
      return null;
    var newBuffer = removeEntryAtIndex_0($this.x4w_1, keyIndex);
    return TrieNode_init_$Create$($this.u4w_1 ^ positionMask, $this.v4w_1, newBuffer);
  }
  function mutableRemoveEntryAtIndex($this, keyIndex, positionMask, mutator) {
    var _unary__edvuaz = mutator.n1();
    mutator.o4x(_unary__edvuaz - 1 | 0);
    mutator.l4x_1 = valueAtKeyIndex($this, keyIndex);
    if ($this.x4w_1.length === 2)
      return null;
    if ($this.w4w_1 === mutator.j4x_1) {
      $this.x4w_1 = removeEntryAtIndex_0($this.x4w_1, keyIndex);
      $this.u4w_1 = $this.u4w_1 ^ positionMask;
      return $this;
    }
    var newBuffer = removeEntryAtIndex_0($this.x4w_1, keyIndex);
    return new TrieNode($this.u4w_1 ^ positionMask, $this.v4w_1, newBuffer, mutator.j4x_1);
  }
  function collisionRemoveEntryAtIndex($this, i) {
    if ($this.x4w_1.length === 2)
      return null;
    var newBuffer = removeEntryAtIndex_0($this.x4w_1, i);
    return TrieNode_init_$Create$(0, 0, newBuffer);
  }
  function mutableCollisionRemoveEntryAtIndex($this, i, mutator) {
    var _unary__edvuaz = mutator.n1();
    mutator.o4x(_unary__edvuaz - 1 | 0);
    mutator.l4x_1 = valueAtKeyIndex($this, i);
    if ($this.x4w_1.length === 2)
      return null;
    if ($this.w4w_1 === mutator.j4x_1) {
      $this.x4w_1 = removeEntryAtIndex_0($this.x4w_1, i);
      return $this;
    }
    var newBuffer = removeEntryAtIndex_0($this.x4w_1, i);
    return new TrieNode(0, 0, newBuffer, mutator.j4x_1);
  }
  function collisionContainsKey($this, key) {
    var progression = step(until(0, $this.x4w_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key, $this.x4w_1[i]))
          return true;
      }
       while (!(i === last));
    return false;
  }
  function collisionGet($this, key) {
    var progression = step(until(0, $this.x4w_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key, keyAtIndex($this, i))) {
          return valueAtKeyIndex($this, i);
        }
      }
       while (!(i === last));
    return null;
  }
  function collisionPut($this, key, value) {
    var progression = step(until(0, $this.x4w_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key, keyAtIndex($this, i))) {
          if (value === valueAtKeyIndex($this, i)) {
            return null;
          }
          // Inline function 'kotlin.collections.copyOf' call
          // Inline function 'kotlin.js.asDynamic' call
          var newBuffer = $this.x4w_1.slice();
          newBuffer[i + 1 | 0] = value;
          return asUpdateResult(TrieNode_init_$Create$(0, 0, newBuffer));
        }
      }
       while (!(i === last));
    var newBuffer_0 = insertEntryAtIndex($this.x4w_1, 0, key, value);
    return asInsertResult(TrieNode_init_$Create$(0, 0, newBuffer_0));
  }
  function mutableCollisionPut($this, key, value, mutator) {
    var progression = step(until(0, $this.x4w_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key, keyAtIndex($this, i))) {
          mutator.l4x_1 = valueAtKeyIndex($this, i);
          if ($this.w4w_1 === mutator.j4x_1) {
            $this.x4w_1[i + 1 | 0] = value;
            return $this;
          }
          mutator.m4x_1 = mutator.m4x_1 + 1 | 0;
          // Inline function 'kotlin.collections.copyOf' call
          // Inline function 'kotlin.js.asDynamic' call
          var newBuffer = $this.x4w_1.slice();
          newBuffer[i + 1 | 0] = value;
          return new TrieNode(0, 0, newBuffer, mutator.j4x_1);
        }
      }
       while (!(i === last));
    var _unary__edvuaz = mutator.n1();
    mutator.o4x(_unary__edvuaz + 1 | 0);
    var newBuffer_0 = insertEntryAtIndex($this.x4w_1, 0, key, value);
    return new TrieNode(0, 0, newBuffer_0, mutator.j4x_1);
  }
  function collisionRemove($this, key) {
    var progression = step(until(0, $this.x4w_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key, keyAtIndex($this, i))) {
          return collisionRemoveEntryAtIndex($this, i);
        }
      }
       while (!(i === last));
    return $this;
  }
  function mutableCollisionRemove($this, key, mutator) {
    var progression = step(until(0, $this.x4w_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key, keyAtIndex($this, i))) {
          return mutableCollisionRemoveEntryAtIndex($this, i, mutator);
        }
      }
       while (!(i === last));
    return $this;
  }
  function mutableCollisionRemove_0($this, key, value, mutator) {
    var progression = step(until(0, $this.x4w_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key, keyAtIndex($this, i)) && equals(value, valueAtKeyIndex($this, i))) {
          return mutableCollisionRemoveEntryAtIndex($this, i, mutator);
        }
      }
       while (!(i === last));
    return $this;
  }
  function mutableCollisionPutAll($this, otherNode, intersectionCounter, owner) {
    assert($this.v4w_1 === 0);
    assert($this.u4w_1 === 0);
    assert(otherNode.v4w_1 === 0);
    assert(otherNode.u4w_1 === 0);
    var tempBuffer = copyOf_1($this.x4w_1, $this.x4w_1.length + otherNode.x4w_1.length | 0);
    var i = $this.x4w_1.length;
    var progression = step(until(0, otherNode.x4w_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (!collisionContainsKey($this, otherNode.x4w_1[j])) {
          tempBuffer[i] = otherNode.x4w_1[j];
          tempBuffer[i + 1 | 0] = otherNode.x4w_1[j + 1 | 0];
          i = i + 2 | 0;
        } else {
          intersectionCounter.r4x_1 = intersectionCounter.r4x_1 + 1 | 0;
        }
      }
       while (!(j === last));
    var newSize = i;
    return newSize === $this.x4w_1.length ? $this : newSize === otherNode.x4w_1.length ? otherNode : newSize === tempBuffer.length ? new TrieNode(0, 0, tempBuffer, owner) : new TrieNode(0, 0, copyOf_1(tempBuffer, newSize), owner);
  }
  function mutablePutAllFromOtherNodeCell($this, otherNode, positionMask, shift, intersectionCounter, mutator) {
    var tmp;
    if (hasNodeAt($this, positionMask)) {
      var targetNode = $this.q4y($this.p4y(positionMask));
      var tmp_0;
      if (hasNodeAt(otherNode, positionMask)) {
        var otherTargetNode = otherNode.q4y(otherNode.p4y(positionMask));
        tmp_0 = targetNode.q4x(otherTargetNode, shift + 5 | 0, intersectionCounter, mutator);
      } else if (otherNode.o4y(positionMask)) {
        var keyIndex = otherNode.m4y(positionMask);
        var key = keyAtIndex(otherNode, keyIndex);
        var value = valueAtKeyIndex(otherNode, keyIndex);
        var oldSize = mutator.n1();
        // Inline function 'kotlin.hashCode' call
        var tmp1_elvis_lhs = key == null ? null : hashCode(key);
        var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.also' call
        var this_0 = targetNode.p4x(tmp$ret$0, key, value, shift + 5 | 0, mutator);
        if (mutator.n1() === oldSize) {
          intersectionCounter.r4x_1 = intersectionCounter.r4x_1 + 1 | 0;
        }
        tmp_0 = this_0;
      } else {
        tmp_0 = targetNode;
      }
      tmp = tmp_0;
    } else if (hasNodeAt(otherNode, positionMask)) {
      var otherTargetNode_0 = otherNode.q4y(otherNode.p4y(positionMask));
      var tmp_1;
      if ($this.o4y(positionMask)) {
        var keyIndex_0 = $this.m4y(positionMask);
        var key_0 = keyAtIndex($this, keyIndex_0);
        var tmp_2;
        // Inline function 'kotlin.hashCode' call
        var tmp1_elvis_lhs_0 = key_0 == null ? null : hashCode(key_0);
        var tmp$ret$3 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
        if (otherTargetNode_0.y4w(tmp$ret$3, key_0, shift + 5 | 0)) {
          intersectionCounter.r4x_1 = intersectionCounter.r4x_1 + 1 | 0;
          tmp_2 = otherTargetNode_0;
        } else {
          var value_0 = valueAtKeyIndex($this, keyIndex_0);
          // Inline function 'kotlin.hashCode' call
          var tmp1_elvis_lhs_1 = key_0 == null ? null : hashCode(key_0);
          var tmp$ret$4 = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
          tmp_2 = otherTargetNode_0.p4x(tmp$ret$4, key_0, value_0, shift + 5 | 0, mutator);
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = otherTargetNode_0;
      }
      tmp = tmp_1;
    } else {
      var thisKeyIndex = $this.m4y(positionMask);
      var thisKey = keyAtIndex($this, thisKeyIndex);
      var thisValue = valueAtKeyIndex($this, thisKeyIndex);
      var otherKeyIndex = otherNode.m4y(positionMask);
      var otherKey = keyAtIndex(otherNode, otherKeyIndex);
      var otherValue = valueAtKeyIndex(otherNode, otherKeyIndex);
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs_2 = thisKey == null ? null : hashCode(thisKey);
      var tmp_3 = tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2;
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs_3 = otherKey == null ? null : hashCode(otherKey);
      var tmp$ret$6 = tmp1_elvis_lhs_3 == null ? 0 : tmp1_elvis_lhs_3;
      tmp = makeNode($this, tmp_3, thisKey, thisValue, tmp$ret$6, otherKey, otherValue, shift + 5 | 0, mutator.j4x_1);
    }
    return tmp;
  }
  function calculateSize($this) {
    if ($this.v4w_1 === 0)
      return $this.x4w_1.length / 2 | 0;
    var numValues = countOneBits($this.u4w_1);
    var result = numValues;
    var inductionVariable = imul(numValues, 2);
    var last = $this.x4w_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + calculateSize($this.q4y(i)) | 0;
      }
       while (inductionVariable < last);
    return result;
  }
  function elementsIdentityEquals($this, otherNode) {
    if ($this === otherNode)
      return true;
    if (!($this.v4w_1 === otherNode.v4w_1))
      return false;
    if (!($this.u4w_1 === otherNode.u4w_1))
      return false;
    var inductionVariable = 0;
    var last = $this.x4w_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!($this.x4w_1[i] === otherNode.x4w_1[i]))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  function replaceNode($this, targetNode, newNode, nodeIndex, positionMask) {
    return newNode == null ? removeNodeAtIndex($this, nodeIndex, positionMask) : !(targetNode === newNode) ? updateNodeAtIndex($this, nodeIndex, positionMask, newNode) : $this;
  }
  function mutableReplaceNode($this, targetNode, newNode, nodeIndex, positionMask, owner) {
    return newNode == null ? mutableRemoveNodeAtIndex($this, nodeIndex, positionMask, owner) : $this.w4w_1 === owner || !(targetNode === newNode) ? mutableUpdateNodeAtIndex($this, nodeIndex, newNode, owner) : $this;
  }
  function Companion_14() {
    Companion_instance_15 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    tmp.p4w_1 = TrieNode_init_$Create$(0, 0, tmp$ret$0);
  }
  var Companion_instance_15;
  function Companion_getInstance_14() {
    if (Companion_instance_15 == null)
      new Companion_14();
    return Companion_instance_15;
  }
  function TrieNode(dataMap, nodeMap, buffer, ownedBy) {
    Companion_getInstance_14();
    this.u4w_1 = dataMap;
    this.v4w_1 = nodeMap;
    this.w4w_1 = ownedBy;
    this.x4w_1 = buffer;
  }
  protoOf(TrieNode).n4y = function () {
    return countOneBits(this.u4w_1);
  };
  protoOf(TrieNode).o4y = function (positionMask) {
    return !((this.u4w_1 & positionMask) === 0);
  };
  protoOf(TrieNode).m4y = function (positionMask) {
    return imul(2, countOneBits(this.u4w_1 & (positionMask - 1 | 0)));
  };
  protoOf(TrieNode).p4y = function (positionMask) {
    return (this.x4w_1.length - 1 | 0) - countOneBits(this.v4w_1 & (positionMask - 1 | 0)) | 0;
  };
  protoOf(TrieNode).q4y = function (nodeIndex) {
    var tmp = this.x4w_1[nodeIndex];
    return tmp instanceof TrieNode ? tmp : THROW_CCE();
  };
  protoOf(TrieNode).y4w = function (keyHash, key, shift) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.o4y(keyPositionMask)) {
      return equals(key, keyAtIndex(this, this.m4y(keyPositionMask)));
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var targetNode = this.q4y(this.p4y(keyPositionMask));
      if (shift === 30) {
        return collisionContainsKey(targetNode, key);
      }
      return targetNode.y4w(keyHash, key, shift + 5 | 0);
    }
    return false;
  };
  protoOf(TrieNode).z4w = function (keyHash, key, shift) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.o4y(keyPositionMask)) {
      var keyIndex = this.m4y(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        return valueAtKeyIndex(this, keyIndex);
      }
      return null;
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var targetNode = this.q4y(this.p4y(keyPositionMask));
      if (shift === 30) {
        return collisionGet(targetNode, key);
      }
      return targetNode.z4w(keyHash, key, shift + 5 | 0);
    }
    return null;
  };
  protoOf(TrieNode).q4x = function (otherNode, shift, intersectionCounter, mutator) {
    if (this === otherNode) {
      intersectionCounter.w4z(calculateSize(this));
      return this;
    }
    if (shift > 30) {
      return mutableCollisionPutAll(this, otherNode, intersectionCounter, mutator.j4x_1);
    }
    var newNodeMap = this.v4w_1 | otherNode.v4w_1;
    var newDataMap = (this.u4w_1 ^ otherNode.u4w_1) & ~newNodeMap;
    // Inline function 'androidx.compose.runtime.external.kotlinx.collections.immutable.internal.forEachOneBit' call
    var mask = this.u4w_1 & otherNode.u4w_1;
    var index = 0;
    while (!(mask === 0)) {
      var bit = takeLowestOneBit(mask);
      var leftKey = keyAtIndex(this, this.m4y(bit));
      var rightKey = keyAtIndex(otherNode, otherNode.m4y(bit));
      if (equals(leftKey, rightKey))
        newDataMap = newDataMap | bit;
      else
        newNodeMap = newNodeMap | bit;
      index = index + 1 | 0;
      mask = mask ^ bit;
    }
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!((newNodeMap & newDataMap) === 0)) {
      throwIllegalStateException('Check failed.');
    }
    var tmp;
    if (equals(this.w4w_1, mutator.j4x_1) && this.u4w_1 === newDataMap && this.v4w_1 === newNodeMap) {
      tmp = this;
    } else {
      // Inline function 'kotlin.arrayOfNulls' call
      var size = imul(countOneBits(newDataMap), 2) + countOneBits(newNodeMap) | 0;
      var newBuffer = Array(size);
      tmp = TrieNode_init_$Create$(newDataMap, newNodeMap, newBuffer);
    }
    var mutableNode = tmp;
    // Inline function 'androidx.compose.runtime.external.kotlinx.collections.immutable.internal.forEachOneBit' call
    var mask_0 = newNodeMap;
    var index_0 = 0;
    while (!(mask_0 === 0)) {
      var bit_0 = takeLowestOneBit(mask_0);
      var index_1 = index_0;
      var newNodeIndex = (mutableNode.x4w_1.length - 1 | 0) - index_1 | 0;
      mutableNode.x4w_1[newNodeIndex] = mutablePutAllFromOtherNodeCell(this, otherNode, bit_0, shift, intersectionCounter, mutator);
      index_0 = index_0 + 1 | 0;
      mask_0 = mask_0 ^ bit_0;
    }
    // Inline function 'androidx.compose.runtime.external.kotlinx.collections.immutable.internal.forEachOneBit' call
    var mask_1 = newDataMap;
    var index_2 = 0;
    while (!(mask_1 === 0)) {
      var bit_1 = takeLowestOneBit(mask_1);
      var index_3 = index_2;
      var newKeyIndex = imul(index_3, 2);
      if (!otherNode.o4y(bit_1)) {
        var oldKeyIndex = this.m4y(bit_1);
        mutableNode.x4w_1[newKeyIndex] = keyAtIndex(this, oldKeyIndex);
        mutableNode.x4w_1[newKeyIndex + 1 | 0] = valueAtKeyIndex(this, oldKeyIndex);
      } else {
        var oldKeyIndex_0 = otherNode.m4y(bit_1);
        mutableNode.x4w_1[newKeyIndex] = keyAtIndex(otherNode, oldKeyIndex_0);
        mutableNode.x4w_1[newKeyIndex + 1 | 0] = valueAtKeyIndex(otherNode, oldKeyIndex_0);
        if (this.o4y(bit_1)) {
          intersectionCounter.r4x_1 = intersectionCounter.r4x_1 + 1 | 0;
        }
      }
      index_2 = index_2 + 1 | 0;
      mask_1 = mask_1 ^ bit_1;
    }
    return elementsIdentityEquals(this, mutableNode) ? this : elementsIdentityEquals(otherNode, mutableNode) ? otherNode : mutableNode;
  };
  protoOf(TrieNode).a4x = function (keyHash, key, value, shift) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.o4y(keyPositionMask)) {
      var keyIndex = this.m4y(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        if (valueAtKeyIndex(this, keyIndex) === value)
          return null;
        return asUpdateResult(updateValueAtIndex(this, keyIndex, value));
      }
      return asInsertResult(moveEntryToNode(this, keyIndex, keyPositionMask, keyHash, key, value, shift));
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.p4y(keyPositionMask);
      var targetNode = this.q4y(nodeIndex);
      var tmp;
      if (shift === 30) {
        var tmp0_elvis_lhs = collisionPut(targetNode, key, value);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } else {
        var tmp1_elvis_lhs = targetNode.a4x(keyHash, key, value, shift + 5 | 0);
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          return null;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp = tmp_1;
      }
      var putResult = tmp;
      // Inline function 'androidx.compose.runtime.external.kotlinx.collections.immutable.implementations.immutableMap.ModificationResult.replaceNode' call
      // Inline function 'kotlin.apply' call
      var tmp_2 = putResult;
      var node = putResult.b4x_1;
      tmp_2.b4x_1 = updateNodeAtIndex(this, nodeIndex, keyPositionMask, node);
      return putResult;
    }
    return asInsertResult(insertEntryAt(this, keyPositionMask, key, value));
  };
  protoOf(TrieNode).p4x = function (keyHash, key, value, shift, mutator) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.o4y(keyPositionMask)) {
      var keyIndex = this.m4y(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        mutator.l4x_1 = valueAtKeyIndex(this, keyIndex);
        if (valueAtKeyIndex(this, keyIndex) === value) {
          return this;
        }
        return mutableUpdateValueAtIndex(this, keyIndex, value, mutator);
      }
      var _unary__edvuaz = mutator.n1();
      mutator.o4x(_unary__edvuaz + 1 | 0);
      return mutableMoveEntryToNode(this, keyIndex, keyPositionMask, keyHash, key, value, shift, mutator.j4x_1);
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.p4y(keyPositionMask);
      var targetNode = this.q4y(nodeIndex);
      var tmp;
      if (shift === 30) {
        tmp = mutableCollisionPut(targetNode, key, value, mutator);
      } else {
        tmp = targetNode.p4x(keyHash, key, value, shift + 5 | 0, mutator);
      }
      var newNode = tmp;
      if (targetNode === newNode) {
        return this;
      }
      return mutableUpdateNodeAtIndex(this, nodeIndex, newNode, mutator.j4x_1);
    }
    var _unary__edvuaz_0 = mutator.n1();
    mutator.o4x(_unary__edvuaz_0 + 1 | 0);
    return mutableInsertEntryAt(this, keyPositionMask, key, value, mutator.j4x_1);
  };
  protoOf(TrieNode).d4x = function (keyHash, key, shift) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.o4y(keyPositionMask)) {
      var keyIndex = this.m4y(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        return removeEntryAtIndex(this, keyIndex, keyPositionMask);
      }
      return this;
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.p4y(keyPositionMask);
      var targetNode = this.q4y(nodeIndex);
      var tmp;
      if (shift === 30) {
        tmp = collisionRemove(targetNode, key);
      } else {
        tmp = targetNode.d4x(keyHash, key, shift + 5 | 0);
      }
      var newNode = tmp;
      return replaceNode(this, targetNode, newNode, nodeIndex, keyPositionMask);
    }
    return this;
  };
  protoOf(TrieNode).s4x = function (keyHash, key, shift, mutator) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.o4y(keyPositionMask)) {
      var keyIndex = this.m4y(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        return mutableRemoveEntryAtIndex(this, keyIndex, keyPositionMask, mutator);
      }
      return this;
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.p4y(keyPositionMask);
      var targetNode = this.q4y(nodeIndex);
      var tmp;
      if (shift === 30) {
        tmp = mutableCollisionRemove(targetNode, key, mutator);
      } else {
        tmp = targetNode.s4x(keyHash, key, shift + 5 | 0, mutator);
      }
      var newNode = tmp;
      return mutableReplaceNode(this, targetNode, newNode, nodeIndex, keyPositionMask, mutator.j4x_1);
    }
    return this;
  };
  protoOf(TrieNode).u4x = function (keyHash, key, value, shift, mutator) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.o4y(keyPositionMask)) {
      var keyIndex = this.m4y(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex)) && equals(value, valueAtKeyIndex(this, keyIndex))) {
        return mutableRemoveEntryAtIndex(this, keyIndex, keyPositionMask, mutator);
      }
      return this;
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.p4y(keyPositionMask);
      var targetNode = this.q4y(nodeIndex);
      var tmp;
      if (shift === 30) {
        tmp = mutableCollisionRemove_0(targetNode, key, value, mutator);
      } else {
        tmp = targetNode.u4x(keyHash, key, value, shift + 5 | 0, mutator);
      }
      var newNode = tmp;
      return mutableReplaceNode(this, targetNode, newNode, nodeIndex, keyPositionMask, mutator.j4x_1);
    }
    return this;
  };
  function insertEntryAtIndex(_this__u8e3s4, keyIndex, key, value) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = _this__u8e3s4.length + 2 | 0;
    var newBuffer = Array(size);
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(_this__u8e3s4, newBuffer, 0, 0, keyIndex);
    var tmp4 = keyIndex + 2 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(_this__u8e3s4, newBuffer, tmp4, keyIndex, endIndex);
    newBuffer[keyIndex] = key;
    newBuffer[keyIndex + 1 | 0] = value;
    return newBuffer;
  }
  function replaceNodeWithEntry(_this__u8e3s4, nodeIndex, keyIndex, key, value) {
    var newBuffer = copyOf_1(_this__u8e3s4, _this__u8e3s4.length + 1 | 0);
    var tmp4 = nodeIndex + 2 | 0;
    var tmp6 = nodeIndex + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(newBuffer, newBuffer, tmp4, tmp6, endIndex);
    // Inline function 'kotlin.collections.copyInto' call
    var destinationOffset = keyIndex + 2 | 0;
    arrayCopy(newBuffer, newBuffer, destinationOffset, keyIndex, nodeIndex);
    newBuffer[keyIndex] = key;
    newBuffer[keyIndex + 1 | 0] = value;
    return newBuffer;
  }
  function removeNodeAtIndex_0(_this__u8e3s4, nodeIndex) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = _this__u8e3s4.length - 1 | 0;
    var newBuffer = Array(size);
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(_this__u8e3s4, newBuffer, 0, 0, nodeIndex);
    var tmp6 = nodeIndex + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(_this__u8e3s4, newBuffer, nodeIndex, tmp6, endIndex);
    return newBuffer;
  }
  function replaceEntryWithNode(_this__u8e3s4, keyIndex, nodeIndex, newNode) {
    var newNodeIndex = nodeIndex - 2 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = (_this__u8e3s4.length - 2 | 0) + 1 | 0;
    var newBuffer = Array(size);
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(_this__u8e3s4, newBuffer, 0, 0, keyIndex);
    // Inline function 'kotlin.collections.copyInto' call
    var startIndex = keyIndex + 2 | 0;
    arrayCopy(_this__u8e3s4, newBuffer, keyIndex, startIndex, nodeIndex);
    newBuffer[newNodeIndex] = newNode;
    var tmp4 = newNodeIndex + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(_this__u8e3s4, newBuffer, tmp4, nodeIndex, endIndex);
    return newBuffer;
  }
  function indexSegment_0(index, shift) {
    return index >> shift & 31;
  }
  function removeEntryAtIndex_0(_this__u8e3s4, keyIndex) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = _this__u8e3s4.length - 2 | 0;
    var newBuffer = Array(size);
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(_this__u8e3s4, newBuffer, 0, 0, keyIndex);
    var tmp6 = keyIndex + 2 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(_this__u8e3s4, newBuffer, keyIndex, tmp6, endIndex);
    return newBuffer;
  }
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_PersistentHashSet$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_PersistentHashSetBuilder$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_PersistentHashSetIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_TrieNodeIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_PersistentHashSetMutableIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_TrieNode$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_LinkedValue$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMap$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilder$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderLinksIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderEntriesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderKeysIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderValuesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderEntries$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderKeys$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderValues$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapLinksIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapEntriesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapKeysIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapValuesIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapEntries$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapKeys$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapValues$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_Links$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_PersistentOrderedSet$stable;
  function Companion_15() {
    Companion_instance_16 = this;
    this.s4u_1 = new PersistentOrderedSet(EndOfChain_instance, EndOfChain_instance, Companion_getInstance_13().v4u());
  }
  protoOf(Companion_15).t4u = function () {
    return this.s4u_1;
  };
  var Companion_instance_16;
  function Companion_getInstance_15() {
    if (Companion_instance_16 == null)
      new Companion_15();
    return Companion_instance_16;
  }
  function PersistentOrderedSet(firstElement, lastElement, hashMap) {
    Companion_getInstance_15();
    AbstractSet.call(this);
    this.x4z_1 = firstElement;
    this.y4z_1 = lastElement;
    this.z4z_1 = hashMap;
  }
  protoOf(PersistentOrderedSet).n1 = function () {
    return this.z4z_1.n1();
  };
  protoOf(PersistentOrderedSet).m1 = function (element) {
    return this.z4z_1.u2(element);
  };
  protoOf(PersistentOrderedSet).j1 = function (element) {
    if (this.z4z_1.u2(element)) {
      return this;
    }
    if (this.r()) {
      var newMap = this.z4z_1.z2(element, Links_init_$Create$());
      return new PersistentOrderedSet(element, element, newMap);
    }
    var lastElement = this.y4z_1;
    var lastLinks = ensureNotNull(this.z4z_1.w2(lastElement));
    var newMap_0 = this.z4z_1.z2(lastElement, lastLinks.c50(element)).z2(element, Links_init_$Create$_0(lastElement));
    return new PersistentOrderedSet(this.x4z_1, element, newMap_0);
  };
  protoOf(PersistentOrderedSet).d3 = function (element) {
    var tmp0_elvis_lhs = this.z4z_1.w2(element);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var links = tmp;
    var newMap = this.z4z_1.a3(element);
    if (links.d50()) {
      var tmp0 = newMap;
      // Inline function 'kotlin.collections.get' call
      var key = links.a50_1;
      var tmp$ret$0 = (isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).w2(key);
      var previousLinks = ensureNotNull(tmp$ret$0);
      newMap = newMap.z2(links.a50_1, previousLinks.c50(links.b50_1));
    }
    if (links.f50()) {
      var tmp0_0 = newMap;
      // Inline function 'kotlin.collections.get' call
      var key_0 = links.b50_1;
      var tmp$ret$1 = (isInterface(tmp0_0, KtMap) ? tmp0_0 : THROW_CCE()).w2(key_0);
      var nextLinks = ensureNotNull(tmp$ret$1);
      newMap = newMap.z2(links.b50_1, nextLinks.e50(links.a50_1));
    }
    var newFirstElement = !links.d50() ? links.b50_1 : this.x4z_1;
    var newLastElement = !links.f50() ? links.a50_1 : this.y4z_1;
    return new PersistentOrderedSet(newFirstElement, newLastElement, newMap);
  };
  protoOf(PersistentOrderedSet).t = function () {
    return new PersistentOrderedSetIterator(this.x4z_1, this.z4z_1);
  };
  function Links_init_$Init$($this) {
    Links.call($this, EndOfChain_instance, EndOfChain_instance);
    return $this;
  }
  function Links_init_$Create$() {
    return Links_init_$Init$(objectCreate(protoOf(Links)));
  }
  function Links_init_$Init$_0(previous, $this) {
    Links.call($this, previous, EndOfChain_instance);
    return $this;
  }
  function Links_init_$Create$_0(previous) {
    return Links_init_$Init$_0(previous, objectCreate(protoOf(Links)));
  }
  function Links(previous, next) {
    this.a50_1 = previous;
    this.b50_1 = next;
  }
  protoOf(Links).c50 = function (newNext) {
    return new Links(this.a50_1, newNext);
  };
  protoOf(Links).e50 = function (newPrevious) {
    return new Links(newPrevious, this.b50_1);
  };
  protoOf(Links).f50 = function () {
    return !(this.b50_1 === EndOfChain_instance);
  };
  protoOf(Links).d50 = function () {
    return !(this.a50_1 === EndOfChain_instance);
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_PersistentOrderedSetBuilder$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_PersistentOrderedSetIterator$stable;
  function checkHasNext_0($this) {
    if (!$this.u())
      throw NoSuchElementException_init_$Create$_0();
  }
  function PersistentOrderedSetIterator(nextElement, map) {
    this.g50_1 = nextElement;
    this.h50_1 = map;
    this.i50_1 = 0;
  }
  protoOf(PersistentOrderedSetIterator).u = function () {
    return this.i50_1 < this.h50_1.n1();
  };
  protoOf(PersistentOrderedSetIterator).v = function () {
    checkHasNext_0(this);
    var result = this.g50_1;
    this.i50_1 = this.i50_1 + 1 | 0;
    var tmp = this;
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.h50_1.w2(result);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw ConcurrentModificationException_init_$Create$_0('Hash code of an element (' + toString_0(result) + ') has changed after it was added to the persistent set.');
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.g50_1 = tmp_0.b50_1;
    return result;
  };
  var androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_PersistentOrderedSetMutableIterator$stable;
  var androidx_compose_runtime_external_kotlinx_collections_immutable_internal_EndOfChain$stable;
  function EndOfChain() {
  }
  var EndOfChain_instance;
  function EndOfChain_getInstance() {
    return EndOfChain_instance;
  }
  var androidx_compose_runtime_external_kotlinx_collections_immutable_internal_ListImplementation$stable;
  function ListImplementation() {
  }
  protoOf(ListImplementation).r4u = function (index, size) {
    if (index < 0 || index >= size) {
      throw IndexOutOfBoundsException_init_$Create$('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(ListImplementation).m4v = function (index, size) {
    if (index < 0 || index > size) {
      throw IndexOutOfBoundsException_init_$Create$('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(ListImplementation).q4u = function (fromIndex, toIndex, size) {
    if (fromIndex < 0 || toIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
    }
    if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }
  };
  var ListImplementation_instance;
  function ListImplementation_getInstance() {
    return ListImplementation_instance;
  }
  var androidx_compose_runtime_external_kotlinx_collections_immutable_internal_MutabilityOwnership$stable;
  function MutabilityOwnership() {
  }
  var androidx_compose_runtime_external_kotlinx_collections_immutable_internal_DeltaCounter$stable;
  function DeltaCounter(count) {
    count = count === VOID ? 0 : count;
    this.r4x_1 = count;
  }
  protoOf(DeltaCounter).w4z = function (that) {
    this.r4x_1 = this.r4x_1 + that | 0;
  };
  protoOf(DeltaCounter).toString = function () {
    return 'DeltaCounter(count=' + this.r4x_1 + ')';
  };
  protoOf(DeltaCounter).hashCode = function () {
    return this.r4x_1;
  };
  protoOf(DeltaCounter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeltaCounter))
      return false;
    if (!(this.r4x_1 === other.r4x_1))
      return false;
    return true;
  };
  function assert(condition) {
  }
  function _AtomicBoolean___init__impl__fuqz3w(wrapped) {
    wrapped = wrapped === VOID ? new AtomicInt(0) : wrapped;
    return wrapped;
  }
  function _get_wrapped__s2ip8($this) {
    return $this;
  }
  function _AtomicBoolean___init__impl__fuqz3w_0(value) {
    return _AtomicBoolean___init__impl__fuqz3w(new AtomicInt(value ? 1 : 0));
  }
  function AtomicBoolean__get_impl_fnomyc($this) {
    return !(_get_wrapped__s2ip8($this).f1i() === 0);
  }
  function AtomicBoolean__set_impl_6dm1t4($this, value) {
    return _get_wrapped__s2ip8($this).k50(value ? 1 : 0);
  }
  function AtomicBoolean__getAndSet_impl_r4bp2h($this, newValue) {
    return _get_wrapped__s2ip8($this).l50(1, newValue ? 1 : 0);
  }
  var androidx_compose_runtime_internal_AwaiterQueue_Awaiter$stable;
  var androidx_compose_runtime_internal_AwaiterQueue$stable;
  function Awaiter() {
  }
  function AwaiterQueue$addAwaiter$lambda($awaiter, this$0, $awaitersVersion) {
    return function () {
      $awaiter.e2z();
      var tmp0 = this$0.m2z_1;
      // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.decrementCount' call
      var version = $awaitersVersion._v;
      // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.update' call
      var oldValue;
      var newValue;
      do {
        oldValue = _get_value__a43j40(tmp0).f1i();
        var value = oldValue;
        var tmp;
        // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.version' call
        if (((value >>> 27 | 0) & 15) === version) {
          tmp = value - 1 | 0;
        } else {
          tmp = value;
        }
        newValue = tmp;
      }
       while (!_get_value__a43j40(tmp0).l50(oldValue, newValue));
      return Unit_instance;
    };
  }
  function AwaiterQueue() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
    tmp.k2z_1 = null == null ? new Object() : null;
    this.l2z_1 = null;
    this.m2z_1 = _AtomicAwaitersCount___init__impl__r5knjv_0();
    var tmp_0 = this;
    // Inline function 'androidx.collection.mutableObjectListOf' call
    tmp_0.n2z_1 = new MutableObjectList();
    var tmp_1 = this;
    // Inline function 'androidx.collection.mutableObjectListOf' call
    tmp_1.o2z_1 = new MutableObjectList();
  }
  protoOf(AwaiterQueue).j2z = function () {
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.hasAwaiters' call
    var this_0 = this.m2z_1;
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.count' call
    return (_get_value__a43j40(this_0).f1i() & 134217727) > 0;
  };
  protoOf(AwaiterQueue).s2z = function (awaiter, onFirstAwaiter) {
    var awaitersVersion = {_v: -1};
    var hasNewAwaiters = false;
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.k2z_1;
    var cause = this.l2z_1;
    if (!(cause == null)) {
      awaiter.f2z(cause);
      return Companion_getInstance().u2z_1;
    }
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.incrementCountAndGetVersion' call
    var this_0 = this.m2z_1;
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.update' call
    var oldValue;
    var newValue;
    do {
      oldValue = _get_value__a43j40(this_0).f1i();
      newValue = oldValue + 1 | 0;
    }
     while (!_get_value__a43j40(this_0).l50(oldValue, newValue));
    var newValue_0 = newValue;
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.count' call
    if ((newValue_0 & 134217727) === 1) {
      hasNewAwaiters = true;
    }
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.version' call
    awaitersVersion._v = (newValue_0 >>> 27 | 0) & 15;
    this.n2z_1.j1(awaiter);
    if (hasNewAwaiters && !(onFirstAwaiter == null)) {
      try {
        onFirstAwaiter();
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          this.m50(t);
        } else {
          throw $p;
        }
      }
    }
    return new OneShotCancellationHandle(AwaiterQueue$addAwaiter$lambda(awaiter, this, awaitersVersion));
  };
  protoOf(AwaiterQueue).q2z = function (resume) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.k2z_1;
    var toResume = this.n2z_1;
    this.n2z_1 = this.o2z_1;
    this.o2z_1 = toResume;
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.incrementVersionAndResetCount' call
    var this_0 = this.m2z_1;
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.update' call
    var oldValue;
    var newValue;
    do {
      oldValue = _get_value__a43j40(this_0).f1i();
      // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.version' call
      var tmp$ret$5 = (oldValue >>> 27 | 0) & 15;
      newValue = pack(this_0, tmp$ret$5 + 1 | 0, 0);
    }
     while (!_get_value__a43j40(this_0).l50(oldValue, newValue));
    var inductionVariable = 0;
    var last = toResume.n1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        resume(toResume.l1(i));
      }
       while (inductionVariable < last);
    toResume.c3();
  };
  protoOf(AwaiterQueue).m50 = function (cause) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.k2z_1;
    if (!(this.l2z_1 == null))
      return Unit_instance;
    this.l2z_1 = cause;
    // Inline function 'androidx.collection.ObjectList.forEach' call
    var this_0 = this.n2z_1;
    // Inline function 'kotlin.contracts.contract' call
    var content = this_0.sz_1;
    var inductionVariable = 0;
    var last = this_0.tz_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        content[i].f2z(cause);
      }
       while (inductionVariable < last);
    this.n2z_1.c3();
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.incrementVersionAndResetCount' call
    var this_1 = this.m2z_1;
    // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.update' call
    var oldValue;
    var newValue;
    do {
      oldValue = _get_value__a43j40(this_1).f1i();
      // Inline function 'androidx.compose.runtime.internal.AtomicAwaitersCount.version' call
      var tmp$ret$8 = (oldValue >>> 27 | 0) & 15;
      newValue = pack(this_1, tmp$ret$8 + 1 | 0, 0);
    }
     while (!_get_value__a43j40(this_1).l50(oldValue, newValue));
  };
  function _AtomicAwaitersCount___init__impl__r5knjv(value) {
    return value;
  }
  function _get_value__a43j40($this) {
    return $this;
  }
  function _AtomicAwaitersCount___init__impl__r5knjv_0() {
    return _AtomicAwaitersCount___init__impl__r5knjv(new AtomicInt(0));
  }
  function pack($this, version, count) {
    var versionComponent = (version & 15) << 27;
    var countComponent = count & 134217727;
    return versionComponent | countComponent;
  }
  var lambdaKey;
  var androidx_compose_runtime_internal_ComposableLambdaImpl$stable;
  function rememberComposableLambda(key, tracked, block, $composer, $changed) {
    _init_properties_ComposableLambda_kt__wilkc();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_0().f30_1) {
      var value = new ComposableLambdaImpl(key, tracked, block);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    // Inline function 'kotlin.also' call
    var this_0 = tmp;
    this_0.s50(block);
    return this_0;
  }
  function composableLambdaInstance(key, tracked, block) {
    _init_properties_ComposableLambda_kt__wilkc();
    return new ComposableLambdaImpl(key, tracked, block);
  }
  function trackWrite($this) {
    if ($this.o50_1) {
      var scope = $this.q50_1;
      if (!(scope == null)) {
        scope.m40();
        $this.q50_1 = null;
      }
      var scopes = $this.r50_1;
      if (!(scopes == null)) {
        var inductionVariable = 0;
        var last = scopes.n1();
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = scopes.l1(index);
            item.m40();
          }
           while (inductionVariable < last);
        scopes.c3();
      }
    }
  }
  function trackRead($this, composer) {
    if ($this.o50_1) {
      var scope = composer.x2z();
      if (!(scope == null)) {
        composer.y2z(scope);
        var lastScope = $this.q50_1;
        if (replacableWith(lastScope, scope)) {
          $this.q50_1 = scope;
        } else {
          var lastScopes = $this.r50_1;
          if (lastScopes == null) {
            // Inline function 'kotlin.collections.mutableListOf' call
            var newScopes = ArrayList_init_$Create$();
            $this.r50_1 = newScopes;
            newScopes.j1(scope);
          } else {
            var inductionVariable = 0;
            var last = lastScopes.n1();
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var scopeAtIndex = lastScopes.l1(index);
                if (replacableWith(scopeAtIndex, scope)) {
                  lastScopes.f3(index, scope);
                  return Unit_instance;
                }
              }
               while (inductionVariable < last);
            lastScopes.j1(scope);
          }
        }
      }
    }
  }
  function ComposableLambdaImpl$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 8, 16, VOID, [p0]);
  }
  function ComposableLambdaImpl$invoke$lambda(this$0, $p1, $changed) {
    return function (nc, _unused_var__etf5q3) {
      this$0.u50($p1, nc, updateChangedFlags($changed) | 1);
      return Unit_instance;
    };
  }
  function ComposableLambdaImpl$invoke$lambda_0(this$0, $p1, $p2, $changed) {
    return function (nc, _unused_var__etf5q3) {
      this$0.v50($p1, $p2, nc, updateChangedFlags($changed) | 1);
      return Unit_instance;
    };
  }
  function ComposableLambdaImpl$invoke$lambda_1(this$0, $p1, $p2, $p3, $changed) {
    return function (nc, _unused_var__etf5q3) {
      this$0.w50($p1, $p2, $p3, nc, updateChangedFlags($changed) | 1);
      return Unit_instance;
    };
  }
  function ComposableLambdaImpl$invoke$lambda_2(this$0, $p1, $p2, $p3, $p4, $p5, $p6, $changed) {
    return function (nc, _unused_var__etf5q3) {
      this$0.x50($p1, $p2, $p3, $p4, $p5, $p6, nc, updateChangedFlags($changed) | 1);
      return Unit_instance;
    };
  }
  function ComposableLambdaImpl(key, tracked, block) {
    this.n50_1 = key;
    this.o50_1 = tracked;
    this.p50_1 = block;
    this.q50_1 = null;
    this.r50_1 = null;
  }
  protoOf(ComposableLambdaImpl).s50 = function (block) {
    if (!equals(this.p50_1, block)) {
      var oldBlockNull = this.p50_1 == null;
      this.p50_1 = block;
      if (!oldBlockNull) {
        trackWrite(this);
      }
    }
  };
  protoOf(ComposableLambdaImpl).t50 = function (c, changed) {
    var c_0 = c.s30(this.n50_1);
    trackRead(this, c_0);
    var dirty = changed | (c_0.k31(this) ? differentBits(0) : sameBits(0));
    var tmp = this.p50_1;
    var result = ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(c_0, dirty);
    var tmp0_safe_receiver = c_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ComposableLambdaImpl$invoke$ref(this));
    }
    return result;
  };
  protoOf(ComposableLambdaImpl).u50 = function (p1, c, changed) {
    var c_0 = c.s30(this.n50_1);
    trackRead(this, c_0);
    var dirty = changed | (c_0.k31(this) ? differentBits(1) : sameBits(1));
    var tmp = this.p50_1;
    var result = ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(p1, c_0, dirty);
    var tmp0_safe_receiver = c_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ComposableLambdaImpl$invoke$lambda(this, p1, changed));
    }
    return result;
  };
  protoOf(ComposableLambdaImpl).v50 = function (p1, p2, c, changed) {
    var c_0 = c.s30(this.n50_1);
    trackRead(this, c_0);
    var dirty = changed | (c_0.k31(this) ? differentBits(2) : sameBits(2));
    var tmp = this.p50_1;
    var result = ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(p1, p2, c_0, dirty);
    var tmp0_safe_receiver = c_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ComposableLambdaImpl$invoke$lambda_0(this, p1, p2, changed));
    }
    return result;
  };
  protoOf(ComposableLambdaImpl).w50 = function (p1, p2, p3, c, changed) {
    var c_0 = c.s30(this.n50_1);
    trackRead(this, c_0);
    var dirty = changed | (c_0.k31(this) ? differentBits(3) : sameBits(3));
    var tmp = this.p50_1;
    var result = ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(p1, p2, p3, c_0, dirty);
    var tmp0_safe_receiver = c_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ComposableLambdaImpl$invoke$lambda_1(this, p1, p2, p3, changed));
    }
    return result;
  };
  protoOf(ComposableLambdaImpl).x50 = function (p1, p2, p3, p4, p5, p6, c, changed) {
    var c_0 = c.s30(this.n50_1);
    trackRead(this, c_0);
    var dirty = changed | (c_0.k31(this) ? differentBits(6) : sameBits(6));
    var tmp = this.p50_1;
    var result = ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(p1, p2, p3, p4, p5, p6, c_0, dirty);
    var tmp0_safe_receiver = c_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ComposableLambdaImpl$invoke$lambda_2(this, p1, p2, p3, p4, p5, p6, changed));
    }
    return result;
  };
  function replacableWith(_this__u8e3s4, other) {
    _init_properties_ComposableLambda_kt__wilkc();
    var tmp;
    if (_this__u8e3s4 == null) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (_this__u8e3s4 instanceof RecomposeScopeImpl) {
        tmp_1 = other instanceof RecomposeScopeImpl;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = !_this__u8e3s4.d2y() || equals(_this__u8e3s4, other) || equals(_this__u8e3s4.m35_1, other.m35_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function differentBits(slot) {
    _init_properties_ComposableLambda_kt__wilkc();
    return bitsForSlot(2, slot);
  }
  function sameBits(slot) {
    _init_properties_ComposableLambda_kt__wilkc();
    return bitsForSlot(1, slot);
  }
  function bitsForSlot(bits, slot) {
    _init_properties_ComposableLambda_kt__wilkc();
    var realSlot = slot % 10 | 0;
    return bits << (imul(realSlot, 3) + 1 | 0);
  }
  var properties_initialized_ComposableLambda_kt_u87f2i;
  function _init_properties_ComposableLambda_kt__wilkc() {
    if (!properties_initialized_ComposableLambda_kt_u87f2i) {
      properties_initialized_ComposableLambda_kt_u87f2i = true;
      lambdaKey = new Object();
      androidx_compose_runtime_internal_ComposableLambdaImpl$stable = 0;
    }
  }
  var androidx_compose_runtime_internal_IntRef$stable;
  function IntRef(element) {
    element = element === VOID ? 0 : element;
    this.s3e_1 = element;
  }
  protoOf(IntRef).toString = function () {
    return 'IntRef(element = ' + this.s3e_1 + ')@' + toString_1(hashCode(this), 16);
  };
  var androidx_compose_runtime_internal_PersistentCompositionLocalHashMap_Builder$stable;
  var androidx_compose_runtime_internal_PersistentCompositionLocalHashMap$stable;
  function Builder(map) {
    PersistentHashMapBuilder.call(this, map);
    this.i51_1 = map;
  }
  protoOf(Builder).g3d = function () {
    var tmp = this;
    var tmp_0;
    if (this.k4x_1 === this.i51_1.s4w_1) {
      tmp_0 = this.i51_1;
    } else {
      this.j4x_1 = new MutabilityOwnership();
      tmp_0 = new PersistentCompositionLocalHashMap(this.k4x_1, this.n1());
    }
    tmp.i51_1 = tmp_0;
    return this.i51_1;
  };
  function Companion_16() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_14().p4w_1;
    tmp.j51_1 = new PersistentCompositionLocalHashMap(tmp_0 instanceof TrieNode ? tmp_0 : THROW_CCE(), 0);
  }
  var Companion_instance_17;
  function Companion_getInstance_16() {
    if (Companion_instance_17 == null)
      new Companion_16();
    return Companion_instance_17;
  }
  function PersistentCompositionLocalHashMap(node, size) {
    Companion_getInstance_16();
    PersistentHashMap.call(this, node, size);
  }
  protoOf(PersistentCompositionLocalHashMap).s1 = function () {
    return protoOf(PersistentHashMap).s1.call(this);
  };
  protoOf(PersistentCompositionLocalHashMap).k51 = function (key) {
    return read(this, key);
  };
  protoOf(PersistentCompositionLocalHashMap).y3c = function (key, value) {
    var tmp0_elvis_lhs = this.s4w_1.a4x(hashCode(key), key, value, 0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newNodeResult = tmp;
    return new PersistentCompositionLocalHashMap(newNodeResult.b4x_1, this.n1() + newNodeResult.c4x_1 | 0);
  };
  protoOf(PersistentCompositionLocalHashMap).a3d = function () {
    return new Builder(this);
  };
  function persistentCompositionLocalHashMapOf() {
    return Companion_getInstance_16().j51_1;
  }
  var androidx_compose_runtime_internal_PausedCompositionRemembers$stable;
  var androidx_compose_runtime_internal_RememberEventDispatcher$stable;
  function dispatchRememberList($this, list) {
    var tmp0_elvis_lhs = $this.t37_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var abandoning = tmp;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var i = 0;
    var tmp_0 = list.b3e_1;
    var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    var size = list.d3e_1;
    while (i < size) {
      var instance = content[i];
      var wrapped = instance.h33();
      abandoning.d3(wrapped);
      // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.withComposeStackTrace' call
      try {
        wrapped.g3f();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.also' call
          var tmp0_safe_receiver = $this.u37_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.apply' call
            tmp0_safe_receiver.k3f(e, instance);
          }
          throw e;
        } else {
          throw $p;
        }
      }
      i = i + 1 | 0;
    }
  }
  function recordLeaving($this, instance) {
    $this.y37_1.zz(instance);
  }
  function forgetting$removeFrom($instance, vector) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var i = 0;
    var tmp = vector.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = vector.d3e_1;
    while (i < size) {
      var nested = content[i].h33();
      if (nested instanceof PausedCompositionRemembers) {
        var remembers = nested.m51_1;
        if (remembers.g10($instance))
          return true;
        if (forgetting$removeFrom($instance, remembers))
          return true;
      }
      i = i + 1 | 0;
    }
    return false;
  }
  function RememberEventDispatcher() {
    this.t37_1 = null;
    this.u37_1 = null;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.v37_1 = new MutableVector(tmp$ret$2, 0);
    this.w37_1 = mutableScatterSetOf();
    this.x37_1 = this.v37_1;
    var tmp_0 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$5 = Array(16);
    tmp_0.y37_1 = new MutableVector(tmp$ret$5, 0);
    var tmp_1 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$8 = Array(16);
    tmp_1.z37_1 = new MutableVector(tmp$ret$8, 0);
    this.a38_1 = null;
    this.b38_1 = null;
    this.c38_1 = null;
    this.d38_1 = null;
  }
  protoOf(RememberEventDispatcher).e38 = function (abandoning, traceContext) {
    this.c3();
    this.t37_1 = abandoning;
    this.u37_1 = traceContext;
  };
  protoOf(RememberEventDispatcher).c3 = function () {
    this.t37_1 = null;
    this.u37_1 = null;
    this.v37_1.c3();
    this.w37_1.c3();
    this.x37_1 = this.v37_1;
    this.y37_1.c3();
    this.z37_1.c3();
    this.a38_1 = null;
    this.b38_1 = null;
    this.c38_1 = null;
  };
  protoOf(RememberEventDispatcher).o4b = function (instance) {
    this.x37_1.zz(instance);
    this.w37_1.j1(instance);
  };
  protoOf(RememberEventDispatcher).f36 = function (instance) {
    if (this.w37_1.m1(instance)) {
      this.w37_1.d3(instance);
      var removed = this.x37_1.g10(instance) || this.v37_1.g10(instance);
      if (!removed) {
        var result = forgetting$removeFrom(instance, this.v37_1);
        // Inline function 'androidx.compose.runtime.debugRuntimeCheck' call
        if (false && !result) {
          var tmp$ret$1 = 'The instance ' + toString(instance) + '(' + toString(instance.h33()) + ' is in the current remember set ' + ' but it could not be found to be removed';
          composeImmediateRuntimeError(tmp$ret$1);
        }
      }
      var tmp0_elvis_lhs = this.t37_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var abandoning = tmp;
      abandoning.j1(instance.h33());
    } else {
      var ignoreSet = this.d38_1;
      if (ignoreSet == null || !ignoreSet.m1(instance)) {
        recordLeaving(this, instance);
      }
    }
  };
  protoOf(RememberEventDispatcher).i3o = function (effect) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.z37_1.zz(effect);
  };
  protoOf(RememberEventDispatcher).o3p = function (instance) {
    recordLeaving(this, instance);
  };
  protoOf(RememberEventDispatcher).e36 = function (instance) {
    var tmp0_elvis_lhs = this.a38_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = mutableScatterSetOf();
      this.a38_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var releasing = tmp;
    releasing.i11(instance);
    recordLeaving(this, instance);
  };
  protoOf(RememberEventDispatcher).q3o = function (scope) {
    var tmp0_elvis_lhs = this.t37_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var abandoning = tmp;
    var pausedPlaceholder = new PausedCompositionRemembers(abandoning);
    var tmp1_elvis_lhs = this.b38_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = mutableScatterMapOf();
      this.b38_1 = this_0;
      tmp_0 = this_0;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    tmp_0.h13(scope, pausedPlaceholder);
    var tmp_1 = this.x37_1;
    var tmp_2;
    if (ComposeRuntimeFlags_instance.e30_1) {
      tmp_2 = new LinkRememberObserverHolder(pausedPlaceholder, get_NullAnchor());
    } else {
      tmp_2 = new GapRememberObserverHolder(pausedPlaceholder, -1);
    }
    tmp_1.zz(tmp_2);
  };
  protoOf(RememberEventDispatcher).j3m = function (scope) {
    var tmp0_safe_receiver = this.b38_1;
    var placeholder = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w2(scope);
    if (!(placeholder == null)) {
      var tmp1_elvis_lhs = this.c38_1;
      var tmp;
      var tmp_0 = tmp1_elvis_lhs;
      if ((tmp_0 == null ? null : new Stack(tmp_0)) == null) {
        // Inline function 'kotlin.also' call
        var this_0 = new Stack(_Stack___init__impl__tvpfn5());
        this.c38_1 = this_0.k3o_1;
        tmp = this_0.k3o_1;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      Stack__push_impl_s8r905(tmp, this.x37_1);
      this.x37_1 = placeholder.m51_1;
    }
  };
  protoOf(RememberEventDispatcher).v3o = function (scope) {
    var pausedPlaceholders = this.b38_1;
    if (!(pausedPlaceholders == null)) {
      var placeholder = pausedPlaceholders.w2(scope);
      if (!(placeholder == null)) {
        var tmp0_safe_receiver = this.c38_1;
        var tmp;
        var tmp_0 = tmp0_safe_receiver;
        if ((tmp_0 == null ? null : new Stack(tmp_0)) == null) {
          tmp = null;
        } else {
          tmp = Stack__pop_impl_8s4za4(tmp0_safe_receiver);
        }
        var tmp1_safe_receiver = tmp;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.x37_1 = tmp1_safe_receiver;
        }
        pausedPlaceholders.a3(scope);
      }
    }
  };
  protoOf(RememberEventDispatcher).u38 = function () {
    var tmp0_elvis_lhs = this.t37_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var abandoning = tmp;
    this.d38_1 = null;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
    if (!(this.y37_1.d3e_1 === 0)) {
      var tmp0 = 'Compose:onForgotten';
      $l$block: {
        // Inline function 'androidx.compose.runtime.internal.trace' call
        var token = Trace_instance.r38(tmp0);
        try {
          var releasing = this.a38_1;
          var inductionVariable = this.y37_1.d3e_1 - 1 | 0;
          if (0 <= inductionVariable)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + -1 | 0;
              // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
              var instance = this.y37_1.b3e_1[i];
              // Inline function 'androidx.compose.runtime.internal.RememberEventDispatcher.withComposeStackTrace' call
              try {
                if (isInterface(instance, RememberObserverHolder)) {
                  var wrapped = instance.h33();
                  abandoning.d3(wrapped);
                  wrapped.h3f();
                }
                if (isInterface(instance, ComposeNodeLifecycleCallback)) {
                  if (!(releasing == null) && releasing.m1(instance)) {
                    instance.d30();
                  } else {
                    instance.c30();
                  }
                }
              } catch ($p) {
                if ($p instanceof Error) {
                  var e = $p;
                  // Inline function 'kotlin.also' call
                  var tmp0_safe_receiver = this.u37_1;
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    // Inline function 'kotlin.apply' call
                    tmp0_safe_receiver.k3f(e, instance);
                  }
                  throw e;
                } else {
                  throw $p;
                }
              }
            }
             while (0 <= inductionVariable);
          break $l$block;
        }finally {
          Trace_instance.t38(token);
        }
      }
    }
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
    if (!(this.v37_1.d3e_1 === 0)) {
      var tmp0_0 = 'Compose:onRemembered';
      $l$block_0: {
        // Inline function 'androidx.compose.runtime.internal.trace' call
        var token_0 = Trace_instance.r38(tmp0_0);
        try {
          dispatchRememberList(this, this.v37_1);
          break $l$block_0;
        }finally {
          Trace_instance.t38(token_0);
        }
      }
    }
  };
  protoOf(RememberEventDispatcher).u3y = function (instance) {
    var removed = this.y37_1.g10(instance);
    if (removed) {
      instance.c30();
    }
  };
  protoOf(RememberEventDispatcher).p39 = function (ignoreSet) {
    this.d38_1 = ignoreSet;
  };
  protoOf(RememberEventDispatcher).j3y = function () {
    var tmp;
    if (this.w37_1.fv()) {
      // Inline function 'kotlin.also' call
      var this_0 = this.w37_1;
      this.w37_1 = mutableScatterSetOf();
      this.v37_1.c3();
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(RememberEventDispatcher).v38 = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
    if (!(this.z37_1.d3e_1 === 0)) {
      var tmp0 = 'Compose:sideeffects';
      $l$block: {
        // Inline function 'androidx.compose.runtime.internal.trace' call
        var token = Trace_instance.r38(tmp0);
        try {
          // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
          var this_0 = this.z37_1;
          var i = 0;
          var tmp = this_0.b3e_1;
          var content = isArray(tmp) ? tmp : THROW_CCE();
          var size = this_0.d3e_1;
          while (i < size) {
            content[i]();
            i = i + 1 | 0;
          }
          this.z37_1.c3();
          break $l$block;
        }finally {
          Trace_instance.t38(token);
        }
      }
    }
  };
  protoOf(RememberEventDispatcher).w38 = function () {
    var tmp0_elvis_lhs = this.t37_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var abandoning = tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!abandoning.r()) {
      var tmp0 = 'Compose:abandons';
      $l$block: {
        // Inline function 'androidx.compose.runtime.internal.trace' call
        var token = Trace_instance.r38(tmp0);
        try {
          var iterator = abandoning.t();
          while (iterator.u()) {
            var instance = iterator.v();
            iterator.l4();
            instance.i3f();
          }
          break $l$block;
        }finally {
          Trace_instance.t38(token);
        }
      }
    }
  };
  function PausedCompositionRemembers(abandoning) {
    this.l51_1 = abandoning;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.m51_1 = new MutableVector(tmp$ret$2, 0);
  }
  protoOf(PausedCompositionRemembers).g3f = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.m51_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var wrapped = content[i].h33();
      this.l51_1.d3(wrapped);
      wrapped.g3f();
      i = i + 1 | 0;
    }
  };
  protoOf(PausedCompositionRemembers).h3f = function () {
  };
  protoOf(PausedCompositionRemembers).i3f = function () {
  };
  function get_emptyThreadMap() {
    _init_properties_SnapshotThreadLocal_kt__57olpn();
    return emptyThreadMap;
  }
  var emptyThreadMap;
  var androidx_compose_runtime_internal_SnapshotThreadLocal$stable;
  var androidx_compose_runtime_internal_ThreadMap$stable;
  function SnapshotThreadLocal() {
    this.o3e_1 = new AtomicReference(get_emptyThreadMap());
    var tmp = this;
    // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
    tmp.p3e_1 = null == null ? new Object() : null;
    this.q3e_1 = null;
  }
  protoOf(SnapshotThreadLocal).f1i = function () {
    var threadId = currentThreadId();
    var tmp;
    if (equalsLong(threadId, get_MainThreadId())) {
      tmp = this.q3e_1;
    } else {
      tmp = this.o3e_1.f1i().lx(threadId);
    }
    return tmp;
  };
  protoOf(SnapshotThreadLocal).r3e = function (value) {
    var key = currentThreadId();
    if (equalsLong(key, get_MainThreadId())) {
      this.q3e_1 = value;
    } else {
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this.p3e_1;
      var current = this.o3e_1.f1i();
      if (current.q51(key, value))
        return Unit_instance;
      this.o3e_1.k2p(current.r51(key, value));
    }
  };
  function find_0($this, key) {
    var high = $this.n51_1 - 1 | 0;
    var tmp0_subject = high;
    if (tmp0_subject === -1)
      return -1;
    else if (tmp0_subject === 0)
      return equalsLong($this.o51_1[0], key) ? 0 : compare($this.o51_1[0], key) > 0 ? -2 : -1;
    var low = 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1 | 0;
      var midVal = $this.o51_1[mid];
      var comparison = subtract(midVal, key);
      if (compare(comparison, new Long(0, 0)) < 0)
        low = mid + 1 | 0;
      else if (compare(comparison, new Long(0, 0)) > 0)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function ThreadMap(size, keys, values) {
    this.n51_1 = size;
    this.o51_1 = keys;
    this.p51_1 = values;
  }
  protoOf(ThreadMap).lx = function (key) {
    var index = find_0(this, key);
    return index >= 0 ? this.p51_1[index] : null;
  };
  protoOf(ThreadMap).q51 = function (key, value) {
    var index = find_0(this, key);
    if (index < 0)
      return false;
    this.p51_1[index] = value;
    return true;
  };
  protoOf(ThreadMap).r51 = function (key, value) {
    var size = this.n51_1;
    // Inline function 'kotlin.collections.count' call
    var count = 0;
    var indexedObject = this.p51_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (!(element == null)) {
        count = count + 1 | 0;
      }
    }
    var newSize = count + 1 | 0;
    var newKeys = longArray(newSize);
    // Inline function 'kotlin.arrayOfNulls' call
    var newValues = Array(newSize);
    if (newSize > 1) {
      var dest = 0;
      var source = 0;
      $l$loop: while (dest < newSize && source < size) {
        var oldKey = this.o51_1[source];
        var oldValue = this.p51_1[source];
        if (compare(oldKey, key) > 0) {
          newKeys[dest] = key;
          newValues[dest] = value;
          dest = dest + 1 | 0;
          break $l$loop;
        }
        if (!(oldValue == null)) {
          newKeys[dest] = oldKey;
          newValues[dest] = oldValue;
          dest = dest + 1 | 0;
        }
        source = source + 1 | 0;
      }
      if (source === size) {
        newKeys[newSize - 1 | 0] = key;
        newValues[newSize - 1 | 0] = value;
      } else {
        while (dest < newSize) {
          var oldKey_0 = this.o51_1[source];
          var oldValue_0 = this.p51_1[source];
          if (!(oldValue_0 == null)) {
            newKeys[dest] = oldKey_0;
            newValues[dest] = oldValue_0;
            dest = dest + 1 | 0;
          }
          source = source + 1 | 0;
        }
      }
    } else {
      newKeys[0] = key;
      newValues[0] = value;
    }
    return new ThreadMap(newSize, newKeys, newValues);
  };
  var properties_initialized_SnapshotThreadLocal_kt_4q3rql;
  function _init_properties_SnapshotThreadLocal_kt__57olpn() {
    if (!properties_initialized_SnapshotThreadLocal_kt_4q3rql) {
      properties_initialized_SnapshotThreadLocal_kt_4q3rql = true;
      var tmp = longArray(0);
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$0 = [];
      emptyThreadMap = new ThreadMap(0, tmp, tmp$ret$0);
      androidx_compose_runtime_internal_SnapshotThreadLocal$stable = 8;
      androidx_compose_runtime_internal_ThreadMap$stable = 8;
    }
  }
  function fastToSet(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    var this_0 = HashSet_init_$Create$_0(_this__u8e3s4.n1());
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = _this__u8e3s4.l1(index);
        this_0.j1(item);
      }
       while (inductionVariable <= last);
    return this_0;
  }
  function fastJoinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    return fastJoinTo(_this__u8e3s4, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function fastJoinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    buffer.k1(prefix);
    var count = 0;
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = _this__u8e3s4.l1(index);
        count = count + 1 | 0;
        if (count > 1) {
          buffer.k1(separator);
        }
        if (limit < 0 || count <= limit) {
          appendElement(buffer, element, transform);
        } else
          break $l$loop;
      }
       while (inductionVariable <= last);
    if (limit >= 0 && count > limit) {
      buffer.k1(truncated);
    }
    buffer.k1(postfix);
    return buffer;
  }
  function appendElement(_this__u8e3s4, element, transform) {
    if (!(transform == null))
      _this__u8e3s4.k1(transform(element));
    else {
      if (element == null ? true : isCharSequence(element))
        _this__u8e3s4.k1(element);
      else {
        if (element instanceof Char)
          _this__u8e3s4.s(element.f2_1);
        else {
          _this__u8e3s4.k1(toString(element));
        }
      }
    }
  }
  function get_emptyLambda() {
    _init_properties_Snapshot_kt__l6n1ng();
    return emptyLambda;
  }
  var emptyLambda;
  function get_INVALID_SNAPSHOT() {
    _init_properties_Snapshot_kt__l6n1ng();
    return INVALID_SNAPSHOT;
  }
  var INVALID_SNAPSHOT;
  function get_threadSnapshot() {
    _init_properties_Snapshot_kt__l6n1ng();
    return threadSnapshot;
  }
  var threadSnapshot;
  function get_lock() {
    _init_properties_Snapshot_kt__l6n1ng();
    return lock;
  }
  var lock;
  function set_openSnapshots(_set____db54di) {
    _init_properties_Snapshot_kt__l6n1ng();
    openSnapshots = _set____db54di;
  }
  function get_openSnapshots() {
    _init_properties_Snapshot_kt__l6n1ng();
    return openSnapshots;
  }
  var openSnapshots;
  function set_nextSnapshotId(_set____db54di) {
    _init_properties_Snapshot_kt__l6n1ng();
    nextSnapshotId = _set____db54di;
  }
  function get_nextSnapshotId() {
    _init_properties_Snapshot_kt__l6n1ng();
    return nextSnapshotId;
  }
  var nextSnapshotId;
  function get_pinningTable() {
    _init_properties_Snapshot_kt__l6n1ng();
    return pinningTable;
  }
  var pinningTable;
  function get_extraStateObjects() {
    _init_properties_Snapshot_kt__l6n1ng();
    return extraStateObjects;
  }
  var extraStateObjects;
  function set_applyObservers(_set____db54di) {
    _init_properties_Snapshot_kt__l6n1ng();
    applyObservers = _set____db54di;
  }
  function get_applyObservers() {
    _init_properties_Snapshot_kt__l6n1ng();
    return applyObservers;
  }
  var applyObservers;
  function set_globalWriteObservers(_set____db54di) {
    _init_properties_Snapshot_kt__l6n1ng();
    globalWriteObservers = _set____db54di;
  }
  function get_globalWriteObservers() {
    _init_properties_Snapshot_kt__l6n1ng();
    return globalWriteObservers;
  }
  var globalWriteObservers;
  function get_globalSnapshot() {
    _init_properties_Snapshot_kt__l6n1ng();
    return globalSnapshot;
  }
  var globalSnapshot;
  var snapshotInitializer;
  function get_pendingApplyObserverCount() {
    _init_properties_Snapshot_kt__l6n1ng();
    return pendingApplyObserverCount;
  }
  var pendingApplyObserverCount;
  var androidx_compose_runtime_snapshots_Snapshot$stable;
  var androidx_compose_runtime_snapshots_MutableSnapshot$stable;
  var androidx_compose_runtime_snapshots_SnapshotApplyResult_Success$stable;
  var androidx_compose_runtime_snapshots_SnapshotApplyResult_Failure$stable;
  var androidx_compose_runtime_snapshots_SnapshotApplyResult$stable;
  var androidx_compose_runtime_snapshots_SnapshotApplyConflictException$stable;
  var androidx_compose_runtime_snapshots_StateRecord$stable;
  var androidx_compose_runtime_snapshots_ReadonlySnapshot$stable;
  var androidx_compose_runtime_snapshots_NestedReadonlySnapshot$stable;
  var androidx_compose_runtime_snapshots_GlobalSnapshot$stable;
  var androidx_compose_runtime_snapshots_NestedMutableSnapshot$stable;
  var androidx_compose_runtime_snapshots_TransparentObserverMutableSnapshot$stable;
  var androidx_compose_runtime_snapshots_TransparentObserverSnapshot$stable;
  function sam$androidx_compose_runtime_snapshots_ObserverHandle$0(function_0) {
    this.s51_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_snapshots_ObserverHandle$0).s1d = function () {
    return this.s51_1();
  };
  protoOf(sam$androidx_compose_runtime_snapshots_ObserverHandle$0).q3 = function () {
    return this.s51_1;
  };
  protoOf(sam$androidx_compose_runtime_snapshots_ObserverHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ObserverHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_snapshots_ObserverHandle$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_runtime_snapshots_ObserverHandle$0_0(function_0) {
    this.t51_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_snapshots_ObserverHandle$0_0).s1d = function () {
    return this.t51_1();
  };
  protoOf(sam$androidx_compose_runtime_snapshots_ObserverHandle$0_0).q3 = function () {
    return this.t51_1;
  };
  protoOf(sam$androidx_compose_runtime_snapshots_ObserverHandle$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ObserverHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_snapshots_ObserverHandle$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function Snapshot$Companion$registerApplyObserver$lambda($observer) {
    return function () {
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      set_applyObservers(minus(get_applyObservers(), $observer));
      return Unit_instance;
    };
  }
  function Snapshot$Companion$registerGlobalWriteObserver$lambda($observer) {
    return function () {
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      set_globalWriteObservers(minus(get_globalWriteObservers(), $observer));
      advanceGlobalSnapshot_0();
      return Unit_instance;
    };
  }
  function Companion_17() {
    this.u3e_1 = 1;
  }
  protoOf(Companion_17).e2y = function () {
    return currentSnapshot();
  };
  protoOf(Companion_17).f46 = function (readObserver) {
    return currentSnapshot().u51(readObserver);
  };
  protoOf(Companion_17).z42 = function (readObserver, writeObserver) {
    var tmp = currentSnapshot();
    var tmp0_safe_receiver = tmp instanceof MutableSnapshot ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v51(readObserver, writeObserver);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Cannot create a mutable snapshot of an read-only snapshot';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(Companion_17).v3e = function (readObserver, writeObserver, block) {
    var tmp$ret$0;
    $l$block_3: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.observeInternal' call
      if (readObserver == null && writeObserver == null) {
        tmp$ret$0 = block();
        break $l$block_3;
      }
      var previous = access$_get_threadSnapshot_$tSnapshotKt_cpt6u2().f1i();
      var tmp;
      if (previous instanceof TransparentObserverMutableSnapshot) {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.canBeReused' call
        tmp = equalsLong(previous.o52_1, currentThreadId());
      } else {
        tmp = false;
      }
      if (tmp) {
        var previousReadObserver = previous.m52_1;
        var previousWriteObserver = previous.n52_1;
        try {
          previous.m52_1 = mergedReadObserver(readObserver, previousReadObserver);
          previous.n52_1 = mergedWriteObserver(writeObserver, previousWriteObserver);
          tmp$ret$0 = block();
          break $l$block_3;
        }finally {
          previous.m52_1 = previousReadObserver;
          previous.n52_1 = previousWriteObserver;
        }
      } else {
        var tmp_0;
        var tmp_1;
        if (previous == null) {
          tmp_1 = true;
        } else {
          tmp_1 = previous instanceof MutableSnapshot;
        }
        if (tmp_1) {
          tmp_0 = new TransparentObserverMutableSnapshot(previous instanceof MutableSnapshot ? previous : null, readObserver, writeObserver, true, false);
        } else {
          if (readObserver == null) {
            tmp$ret$0 = block();
            break $l$block_3;
          } else {
            tmp_0 = previous.u51(readObserver);
          }
        }
        var snapshot = tmp_0;
        try {
          var tmp$ret$2;
          $l$block_2: {
            // Inline function 'androidx.compose.runtime.snapshots.Snapshot.enter' call
            var previous_0 = snapshot.y41();
            try {
              tmp$ret$2 = block();
              break $l$block_2;
            }finally {
              snapshot.z41(previous_0);
            }
          }
          tmp$ret$0 = tmp$ret$2;
          break $l$block_3;
        }finally {
          snapshot.s1d();
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(Companion_17).p52 = function () {
    return get_threadSnapshot().f1i();
  };
  protoOf(Companion_17).q52 = function (previous) {
    var tmp;
    var tmp_0;
    if (previous instanceof TransparentObserverMutableSnapshot) {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.canBeReused' call
      tmp_0 = equalsLong(previous.o52_1, currentThreadId());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      previous.m52_1 = null;
      tmp = previous;
    } else {
      var tmp_1;
      if (previous instanceof TransparentObserverSnapshot) {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.canBeReused' call
        tmp_1 = equalsLong(previous.a53_1, currentThreadId());
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        previous.y52_1 = null;
        tmp = previous;
      } else {
        var snapshot = createTransparentSnapshotWithNoParentReadObserver(previous);
        snapshot.y41();
        tmp = snapshot;
      }
    }
    return tmp;
  };
  protoOf(Companion_17).c53 = function (previous, nonObservable, observer) {
    if (previous === nonObservable) {
      if (previous instanceof TransparentObserverMutableSnapshot) {
        previous.m52_1 = observer;
      } else {
        if (previous instanceof TransparentObserverSnapshot) {
          previous.y52_1 = observer;
        } else {
          // Inline function 'kotlin.error' call
          var message = 'Non-transparent snapshot was reused: ' + toString(previous);
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
    } else {
      nonObservable.z41(previous);
      nonObservable.s1d();
    }
  };
  protoOf(Companion_17).e45 = function (observer) {
    advanceGlobalSnapshot(get_emptyLambda());
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    set_applyObservers(plus_1(get_applyObservers(), observer));
    var tmp = Snapshot$Companion$registerApplyObserver$lambda(observer);
    return new sam$androidx_compose_runtime_snapshots_ObserverHandle$0(tmp);
  };
  protoOf(Companion_17).d53 = function (observer) {
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    set_globalWriteObservers(plus_1(get_globalWriteObservers(), observer));
    advanceGlobalSnapshot_0();
    var tmp = Snapshot$Companion$registerGlobalWriteObserver$lambda(observer);
    return new sam$androidx_compose_runtime_snapshots_ObserverHandle$0_0(tmp);
  };
  protoOf(Companion_17).x3e = function () {
    return currentSnapshot().e53();
  };
  protoOf(Companion_17).w41 = function () {
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    var changes = get_globalSnapshot().f53();
    if (changes) {
      advanceGlobalSnapshot_0();
    }
  };
  var Companion_instance_18;
  function Companion_getInstance_17() {
    return Companion_instance_18;
  }
  function access$_get_pinningTrackingHandle__7vwthz($this) {
    return $this.v3d_1;
  }
  function Snapshot(snapshotId, invalid) {
    this.s3d_1 = invalid;
    this.t3d_1 = snapshotId;
    this.u3d_1 = false;
    this.v3d_1 = !equals(snapshotId, get_INVALID_SNAPSHOT()) ? trackPinning(snapshotId, this.g53()) : -1;
  }
  protoOf(Snapshot).h53 = function (_set____db54di) {
    this.s3d_1 = _set____db54di;
  };
  protoOf(Snapshot).g53 = function () {
    return this.s3d_1;
  };
  protoOf(Snapshot).i53 = function (_set____db54di) {
    this.t3d_1 = _set____db54di;
  };
  protoOf(Snapshot).w3d = function () {
    return this.t3d_1;
  };
  protoOf(Snapshot).j53 = function (value) {
    // Inline function 'kotlin.error' call
    var message = 'Updating write count is not supported for this snapshot';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(Snapshot).z3d = function () {
    return 0;
  };
  protoOf(Snapshot).s1d = function () {
    this.u3d_1 = true;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    this.l53();
  };
  protoOf(Snapshot).y41 = function () {
    var previous = get_threadSnapshot().f1i();
    get_threadSnapshot().r3e(this);
    return previous;
  };
  protoOf(Snapshot).z41 = function (snapshot) {
    get_threadSnapshot().r3e(snapshot);
  };
  protoOf(Snapshot).q53 = function () {
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    this.r53();
    this.s53();
  };
  protoOf(Snapshot).r53 = function () {
    set_openSnapshots(get_openSnapshots().x53(this.w3d()));
  };
  protoOf(Snapshot).s53 = function () {
    this.l53();
  };
  protoOf(Snapshot).y53 = function () {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!!this.u3d_1) {
      var tmp$ret$1 = 'Cannot use a disposed snapshot';
      throwIllegalArgumentException(tmp$ret$1);
    }
  };
  protoOf(Snapshot).l53 = function () {
    if (this.v3d_1 >= 0) {
      releasePinningLocked(this.v3d_1);
      this.v3d_1 = -1;
    }
  };
  protoOf(Snapshot).z53 = function () {
    // Inline function 'kotlin.also' call
    var this_0 = this.v3d_1;
    this.v3d_1 = -1;
    return this_0;
  };
  function StateObject() {
  }
  function StateRecord(snapshotId) {
    this.l3e_1 = snapshotId;
    this.m3e_1 = null;
  }
  protoOf(StateRecord).x3d = function (snapshotId) {
    // Inline function 'kotlin.also' call
    var this_0 = this.r3d();
    this_0.l3e_1 = snapshotId;
    return this_0;
  };
  function currentSnapshot() {
    _init_properties_Snapshot_kt__l6n1ng();
    var tmp0_elvis_lhs = get_threadSnapshot().f1i();
    return tmp0_elvis_lhs == null ? get_globalSnapshot() : tmp0_elvis_lhs;
  }
  function current(r, snapshot) {
    _init_properties_Snapshot_kt__l6n1ng();
    var tmp0_elvis_lhs = readable(r, snapshot.w3d(), snapshot.g53());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      tmp = readable(r, snapshot.w3d(), snapshot.g53());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      readError();
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  function newWritableRecord(_this__u8e3s4, state, snapshot) {
    _init_properties_Snapshot_kt__l6n1ng();
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    return newWritableRecordLocked(_this__u8e3s4, state, snapshot);
  }
  function validateNotApplied($this) {
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!!$this.t43_1) {
      var tmp$ret$1 = 'Unsupported operation on a snapshot that has been applied';
      throwIllegalStateException(tmp$ret$1);
    }
  }
  function validateNotAppliedOrPinned($this) {
    var tmp;
    if (!$this.t43_1) {
      tmp = true;
    } else {
      // Inline function 'androidx.compose.runtime.snapshots.Snapshot.isPinned' call
      tmp = access$_get_pinningTrackingHandle__7vwthz($this) >= 0;
    }
    // Inline function 'androidx.compose.runtime.checkPrecondition' call
    if (!tmp) {
      var tmp$ret$2 = 'Unsupported operation on a disposed or applied snapshot';
      throwIllegalStateException(tmp$ret$2);
    }
  }
  function abandon($this) {
    var modified = $this.a54();
    if (!(modified == null)) {
      validateNotApplied($this);
      $this.b54(null);
      var id = $this.w3d();
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var elements = modified.k16_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = modified.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_0 = slot;
            var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var current = elements[index].f3e();
                    while (!(current == null)) {
                      if (equals(current.l3e_1, id) || contains($this.q43_1, current.l3e_1)) {
                        current.l3e_1 = get_INVALID_SNAPSHOT();
                      }
                      current = current.m3e_1;
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
    $this.q53();
  }
  function releasePreviouslyPinnedSnapshotsLocked($this) {
    var inductionVariable = 0;
    var last = $this.r43_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        releasePinningLocked($this.r43_1[index]);
      }
       while (inductionVariable <= last);
  }
  function Companion_18() {
    Companion_instance_19 = this;
    this.c54_1 = new Int32Array(0);
  }
  var Companion_instance_19;
  function Companion_getInstance_18() {
    if (Companion_instance_19 == null)
      new Companion_18();
    return Companion_instance_19;
  }
  function MutableSnapshot(snapshotId, invalid, readObserver, writeObserver) {
    Companion_getInstance_18();
    Snapshot.call(this, snapshotId, invalid);
    this.l43_1 = readObserver;
    this.m43_1 = writeObserver;
    this.n43_1 = 0;
    this.o43_1 = null;
    this.p43_1 = null;
    this.q43_1 = Companion_getInstance_19().d54_1;
    this.r43_1 = Companion_getInstance_18().c54_1;
    this.s43_1 = 1;
    this.t43_1 = false;
  }
  protoOf(MutableSnapshot).t3e = function () {
    return this.l43_1;
  };
  protoOf(MutableSnapshot).m53 = function () {
    return this.m43_1;
  };
  protoOf(MutableSnapshot).f53 = function () {
    var tmp0_safe_receiver = this.a54();
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fv()) === true;
  };
  protoOf(MutableSnapshot).v51 = function (readObserver, writeObserver) {
    this.y53();
    validateNotAppliedOrPinned(this);
    // Inline function 'androidx.compose.runtime.snapshots.tooling.creatingSnapshot' call
    var observerMap = null;
    var observers = access$_get_observers_$tSnapshotObserverKt_23v7jt();
    var actualReadObserver = readObserver;
    var actualWriteObserver = writeObserver;
    if (!(observers == null)) {
      var result = mergeObservers(observers, this, false, readObserver, writeObserver);
      var mappedObservers = result.xh_1;
      actualReadObserver = mappedObservers.e54_1;
      actualWriteObserver = mappedObservers.f54_1;
      observerMap = result.yh_1;
    }
    var tmp0 = actualReadObserver;
    var actualWriteObserver_0 = actualWriteObserver;
    // Inline function 'androidx.compose.runtime.snapshots.MutableSnapshot.advance' call
    this.g54(this.w3d());
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    var newId = get_nextSnapshotId();
    // Inline function 'androidx.compose.runtime.snapshots.plus' call
    var tmp$ret$7 = get_nextSnapshotId() + toNumber(fromInt(1));
    set_nextSnapshotId(tmp$ret$7);
    set_openSnapshots(get_openSnapshots().h54(newId));
    var currentInvalid = this.g53();
    this.h53(currentInvalid.h54(newId));
    // Inline function 'androidx.compose.runtime.snapshots.plus' call
    var tmp$ret$8 = this.w3d() + toNumber(fromInt(1));
    // Inline function 'kotlin.also' call
    var this_0 = new NestedMutableSnapshot(newId, addRange(currentInvalid, tmp$ret$8, newId), mergedReadObserver(tmp0, this.t3e()), mergedWriteObserver(actualWriteObserver_0, this.m53()), this);
    if (!this.t43_1 && !this.u3d_1) {
      var previousId = this.w3d();
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      // Inline function 'kotlin.also' call
      var this_1 = access$_get_nextSnapshotId_$tSnapshotKt_vxgvey();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$16 = access$_get_nextSnapshotId_$tSnapshotKt_vxgvey() + toNumber(fromInt(1));
      access$_set_nextSnapshotId_$tSnapshotKt_xcaltq(tmp$ret$16);
      this.i53(this_1);
      access$_set_openSnapshots_$tSnapshotKt_9lk9nh(access$_get_openSnapshots_$tSnapshotKt_7cpqp5().h54(this.w3d()));
      var tmp = this.g53();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$17 = previousId + toNumber(fromInt(1));
      this.h53(addRange(tmp, tmp$ret$17, this.w3d()));
    }
    var result_0 = this_0;
    if (observers == null)
      null;
    else {
      dispatchCreatedObservers(observers, this, result_0, observerMap);
    }
    return result_0;
  };
  protoOf(MutableSnapshot).u43 = function () {
    var modified = this.a54();
    var tmp;
    if (!(modified == null)) {
      var globalSnapshot = get_globalSnapshot();
      tmp = optimisticMerges(globalSnapshot.w3d(), this, get_openSnapshots().x53(globalSnapshot.w3d()));
    } else {
      tmp = null;
    }
    var optimisticMerges_0 = tmp;
    var observers = emptyList();
    var globalModified = null;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    validateOpen(this);
    if (modified == null || modified.n1() === 0) {
      this.r53();
      var globalSnapshot_0 = get_globalSnapshot();
      var previousModified = globalSnapshot_0.a54();
      resetGlobalSnapshotLocked(globalSnapshot_0, get_emptyLambda());
      if (!(previousModified == null) && previousModified.fv()) {
        observers = get_applyObservers();
        globalModified = previousModified;
      }
    } else {
      var globalSnapshot_1 = get_globalSnapshot();
      var result = this.i54(get_nextSnapshotId(), modified, optimisticMerges_0, get_openSnapshots().x53(globalSnapshot_1.w3d()));
      if (!equals(result, Success_getInstance()))
        return result;
      this.r53();
      var previousModified_0 = globalSnapshot_1.a54();
      resetGlobalSnapshotLocked(globalSnapshot_1, get_emptyLambda());
      this.b54(null);
      globalSnapshot_1.b54(null);
      observers = get_applyObservers();
      globalModified = previousModified_0;
    }
    this.t43_1 = true;
    if (!(globalModified == null)) {
      var nonNullGlobalModified = wrapIntoSet(ensureNotNull(globalModified));
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!nonNullGlobalModified.r()) {
        // Inline function 'androidx.compose.runtime.tooling.verboseTrace' call
        var name = 'Compose:applyObservers';
        if (ComposeToolingFlags_instance.f3f_1) {
          $l$block: {
            // Inline function 'androidx.compose.runtime.internal.trace' call
            var token = Trace_instance.r38(name);
            try {
              // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
              var this_0 = observers;
              var inductionVariable = 0;
              var last = this_0.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = this_0.l1(index);
                  item(nonNullGlobalModified, this);
                }
                 while (inductionVariable <= last);
              break $l$block;
            }finally {
              Trace_instance.t38(token);
            }
          }
        } else {
          // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
          var this_1 = observers;
          var inductionVariable_0 = 0;
          var last_0 = this_1.n1() - 1 | 0;
          if (inductionVariable_0 <= last_0)
            do {
              var index_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var item_0 = this_1.l1(index_0);
              item_0(nonNullGlobalModified, this);
            }
             while (inductionVariable_0 <= last_0);
        }
      }
    }
    if (!(modified == null) && modified.fv()) {
      var modifiedSet = wrapIntoSet(modified);
      // Inline function 'androidx.compose.runtime.tooling.verboseTrace' call
      var name_0 = 'Compose:applyObservers';
      if (ComposeToolingFlags_instance.f3f_1) {
        $l$block_0: {
          // Inline function 'androidx.compose.runtime.internal.trace' call
          var token_0 = Trace_instance.r38(name_0);
          try {
            // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
            var this_2 = observers;
            var inductionVariable_1 = 0;
            var last_1 = this_2.n1() - 1 | 0;
            if (inductionVariable_1 <= last_1)
              do {
                var index_1 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var item_1 = this_2.l1(index_1);
                item_1(modifiedSet, this);
              }
               while (inductionVariable_1 <= last_1);
            break $l$block_0;
          }finally {
            Trace_instance.t38(token_0);
          }
        }
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
        var this_3 = observers;
        var inductionVariable_2 = 0;
        var last_2 = this_3.n1() - 1 | 0;
        if (inductionVariable_2 <= last_2)
          do {
            var index_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var item_2 = this_3.l1(index_2);
            item_2(modifiedSet, this);
          }
           while (inductionVariable_2 <= last_2);
      }
    }
    dispatchObserverOnApplied(this, modified);
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    this.s53();
    checkAndOverwriteUnusedRecordsLocked();
    var tmp0_safe_receiver = globalModified;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var elements = tmp0_safe_receiver.k16_1;
      $l$block_1: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = tmp0_safe_receiver.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable_3 = 0;
        if (inductionVariable_3 <= lastIndex)
          do {
            var i = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_4 = slot;
            var tmp$ret$27 = bitwiseAnd(bitwiseAnd(this_4, shiftLeft(invert(this_4), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$27, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < bitCount)
                do {
                  var j = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index_3 = (i << 3) + j | 0;
                    var it = elements[index_3];
                    processForUnusedRecordsLocked(it);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_4 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_1;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
    if (modified == null)
      null;
    else {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var elements_0 = modified.k16_1;
      $l$block_2: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m_0 = modified.j16_1;
        var lastIndex_0 = m_0.length - 2 | 0;
        var inductionVariable_5 = 0;
        if (inductionVariable_5 <= lastIndex_0)
          do {
            var i_0 = inductionVariable_5;
            inductionVariable_5 = inductionVariable_5 + 1 | 0;
            var slot_0 = m_0[i_0];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_5 = slot_0;
            var tmp$ret$35 = bitwiseAnd(bitwiseAnd(this_5, shiftLeft(invert(this_5), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$35, new Long(-2139062144, -2139062144))) {
              var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
              var inductionVariable_6 = 0;
              if (inductionVariable_6 < bitCount_0)
                do {
                  var j_0 = inductionVariable_6;
                  inductionVariable_6 = inductionVariable_6 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                  if (compare(value_0, new Long(128, 0)) < 0) {
                    var index_4 = (i_0 << 3) + j_0 | 0;
                    var it_0 = elements_0[index_4];
                    processForUnusedRecordsLocked(it_0);
                  }
                  slot_0 = shiftRight(slot_0, 8);
                }
                 while (inductionVariable_6 < bitCount_0);
              if (!(bitCount_0 === 8)) {
                break $l$block_2;
              }
            }
          }
           while (!(i_0 === lastIndex_0));
      }
    }
    var tmp2_safe_receiver = this.p43_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable_7 = 0;
      var last_3 = tmp2_safe_receiver.n1() - 1 | 0;
      if (inductionVariable_7 <= last_3)
        do {
          var index_5 = inductionVariable_7;
          inductionVariable_7 = inductionVariable_7 + 1 | 0;
          var item_3 = tmp2_safe_receiver.l1(index_5);
          processForUnusedRecordsLocked(item_3);
        }
         while (inductionVariable_7 <= last_3);
    }
    this.p43_1 = null;
    return Success_getInstance();
  };
  protoOf(MutableSnapshot).k53 = function () {
    return false;
  };
  protoOf(MutableSnapshot).s1d = function () {
    if (!this.u3d_1) {
      protoOf(Snapshot).s1d.call(this);
      this.o53(this);
      dispatchObserverOnPreDispose(this);
    }
  };
  protoOf(MutableSnapshot).u51 = function (readObserver) {
    this.y53();
    validateNotAppliedOrPinned(this);
    var previousId = this.w3d();
    var tmp;
    if (this instanceof GlobalSnapshot) {
      tmp = null;
    } else {
      tmp = this;
    }
    // Inline function 'androidx.compose.runtime.snapshots.tooling.creatingSnapshot' call
    var parent = tmp;
    var observerMap = null;
    var observers = access$_get_observers_$tSnapshotObserverKt_23v7jt();
    var actualReadObserver = readObserver;
    var actualWriteObserver = null;
    if (!(observers == null)) {
      var result = mergeObservers(observers, parent, true, readObserver, null);
      var mappedObservers = result.xh_1;
      actualReadObserver = mappedObservers.e54_1;
      actualWriteObserver = mappedObservers.f54_1;
      observerMap = result.yh_1;
    }
    var tmp0 = actualReadObserver;
    // Inline function 'androidx.compose.runtime.snapshots.MutableSnapshot.advance' call
    this.g54(this.w3d());
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    // Inline function 'kotlin.also' call
    var this_0 = get_nextSnapshotId();
    // Inline function 'androidx.compose.runtime.snapshots.plus' call
    var tmp$ret$9 = get_nextSnapshotId() + toNumber(fromInt(1));
    set_nextSnapshotId(tmp$ret$9);
    var readonlyId = this_0;
    set_openSnapshots(get_openSnapshots().h54(readonlyId));
    var tmp_0 = this.g53();
    // Inline function 'androidx.compose.runtime.snapshots.plus' call
    var tmp$ret$10 = previousId + toNumber(fromInt(1));
    // Inline function 'kotlin.also' call
    var this_1 = new NestedReadonlySnapshot(readonlyId, addRange(tmp_0, tmp$ret$10, readonlyId), mergedReadObserver(tmp0, this.t3e()), this);
    if (!this.t43_1 && !this.u3d_1) {
      var previousId_0 = this.w3d();
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      // Inline function 'kotlin.also' call
      var this_2 = access$_get_nextSnapshotId_$tSnapshotKt_vxgvey();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$18 = access$_get_nextSnapshotId_$tSnapshotKt_vxgvey() + toNumber(fromInt(1));
      access$_set_nextSnapshotId_$tSnapshotKt_xcaltq(tmp$ret$18);
      this.i53(this_2);
      access$_set_openSnapshots_$tSnapshotKt_9lk9nh(access$_get_openSnapshots_$tSnapshotKt_7cpqp5().h54(this.w3d()));
      var tmp_1 = this.g53();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$19 = previousId_0 + toNumber(fromInt(1));
      this.h53(addRange(tmp_1, tmp$ret$19, this.w3d()));
    }
    var result_0 = this_1;
    if (observers == null)
      null;
    else {
      dispatchCreatedObservers(observers, parent, result_0, observerMap);
    }
    return result_0;
  };
  protoOf(MutableSnapshot).n53 = function (snapshot) {
    this.s43_1 = this.s43_1 + 1 | 0;
  };
  protoOf(MutableSnapshot).o53 = function (snapshot) {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!(this.s43_1 > 0)) {
      var tmp$ret$1 = 'no pending nested snapshots';
      throwIllegalArgumentException(tmp$ret$1);
    }
    this.s43_1 = this.s43_1 - 1 | 0;
    if (this.s43_1 === 0) {
      if (!this.t43_1) {
        abandon(this);
      }
    }
  };
  protoOf(MutableSnapshot).e53 = function () {
    if (this.t43_1 || this.u3d_1)
      return Unit_instance;
    this.j54();
  };
  protoOf(MutableSnapshot).r53 = function () {
    set_openSnapshots(get_openSnapshots().x53(this.w3d()).k54(this.q43_1));
  };
  protoOf(MutableSnapshot).s53 = function () {
    releasePreviouslyPinnedSnapshotsLocked(this);
    protoOf(Snapshot).s53.call(this);
  };
  protoOf(MutableSnapshot).i54 = function (nextId, modified, optimisticMerges, invalidSnapshots) {
    var mergedRecords = null;
    var start = this.g53().h54(this.w3d()).l54(this.q43_1);
    var statesToRemove = null;
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    // Inline function 'kotlin.contracts.contract' call
    var elements = modified.k16_1;
    $l$block_2: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m = modified.j16_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_0 = slot;
          var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = elements[index];
                  $l$block_1: {
                    var first = tmp0.f3e();
                    var tmp0_elvis_lhs = readable(first, nextId, invalidSnapshots);
                    var tmp;
                    if (tmp0_elvis_lhs == null) {
                      break $l$block_1;
                    } else {
                      tmp = tmp0_elvis_lhs;
                    }
                    var current = tmp;
                    var tmp1_elvis_lhs = readable(first, this.w3d(), start);
                    var tmp_0;
                    if (tmp1_elvis_lhs == null) {
                      break $l$block_1;
                    } else {
                      tmp_0 = tmp1_elvis_lhs;
                    }
                    var previous = tmp_0;
                    if (equals(previous.l3e_1, toSnapshotId(1))) {
                      break $l$block_1;
                    }
                    if (!equals(current, previous)) {
                      var tmp2_elvis_lhs = readable(first, this.w3d(), this.g53());
                      var tmp_1;
                      if (tmp2_elvis_lhs == null) {
                        readError();
                      } else {
                        tmp_1 = tmp2_elvis_lhs;
                      }
                      var applied = tmp_1;
                      var tmp4_elvis_lhs = optimisticMerges == null ? null : optimisticMerges.w2(current);
                      var tmp_2;
                      if (tmp4_elvis_lhs == null) {
                        // Inline function 'kotlin.run' call
                        tmp_2 = tmp0.a3f(previous, current, applied);
                      } else {
                        tmp_2 = tmp4_elvis_lhs;
                      }
                      var merged = tmp_2;
                      if (merged == null)
                        return new Failure(this);
                      else if (!equals(merged, applied))
                        if (equals(merged, current)) {
                          var tmp6_elvis_lhs = mergedRecords;
                          var tmp_3;
                          if (tmp6_elvis_lhs == null) {
                            // Inline function 'kotlin.collections.mutableListOf' call
                            // Inline function 'kotlin.also' call
                            var this_1 = ArrayList_init_$Create$();
                            mergedRecords = this_1;
                            tmp_3 = this_1;
                          } else {
                            tmp_3 = tmp6_elvis_lhs;
                          }
                          tmp_3.j1(to(tmp0, current.x3d(this.w3d())));
                          var tmp7_elvis_lhs = statesToRemove;
                          var tmp_4;
                          if (tmp7_elvis_lhs == null) {
                            // Inline function 'kotlin.collections.mutableListOf' call
                            // Inline function 'kotlin.also' call
                            var this_2 = ArrayList_init_$Create$();
                            statesToRemove = this_2;
                            tmp_4 = this_2;
                          } else {
                            tmp_4 = tmp7_elvis_lhs;
                          }
                          tmp_4.j1(tmp0);
                        } else {
                          var tmp8_elvis_lhs = mergedRecords;
                          var tmp_5;
                          if (tmp8_elvis_lhs == null) {
                            // Inline function 'kotlin.collections.mutableListOf' call
                            // Inline function 'kotlin.also' call
                            var this_3 = ArrayList_init_$Create$();
                            mergedRecords = this_3;
                            tmp_5 = this_3;
                          } else {
                            tmp_5 = tmp8_elvis_lhs;
                          }
                          tmp_5.j1(!equals(merged, previous) ? to(tmp0, merged) : to(tmp0, previous.x3d(this.w3d())));
                        }
                    }
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block_2;
            }
          }
        }
         while (!(i === lastIndex));
    }
    var tmp0_safe_receiver = mergedRecords;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.j54();
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable_1 = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable_1 <= last)
        do {
          var index_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var item = tmp0_safe_receiver.l1(index_0);
          var state = item.zh();
          var stateRecord = item.ai();
          stateRecord.l3e_1 = nextId;
          // Inline function 'androidx.compose.runtime.snapshots.sync' call
          // Inline function 'androidx.compose.runtime.platform.synchronized' call
          get_lock();
          stateRecord.m3e_1 = state.f3e();
          state.y3e(stateRecord);
        }
         while (inductionVariable_1 <= last);
    }
    var tmp1_safe_receiver = statesToRemove;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable_2 = 0;
      var last_0 = tmp1_safe_receiver.n1() - 1 | 0;
      if (inductionVariable_2 <= last_0)
        do {
          var index_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var item_0 = tmp1_safe_receiver.l1(index_1);
          modified.d3(item_0);
        }
         while (inductionVariable_2 <= last_0);
      var mergedList = this.p43_1;
      this.p43_1 = mergedList == null ? tmp1_safe_receiver : plus_0(mergedList, tmp1_safe_receiver);
    }
    return Success_getInstance();
  };
  protoOf(MutableSnapshot).j54 = function () {
    // Inline function 'androidx.compose.runtime.snapshots.MutableSnapshot.advance' call
    this.g54(this.w3d());
    // Inline function 'kotlin.also' call
    if (!this.t43_1 && !this.u3d_1) {
      var previousId = this.w3d();
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      // Inline function 'kotlin.also' call
      var this_0 = access$_get_nextSnapshotId_$tSnapshotKt_vxgvey();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$9 = access$_get_nextSnapshotId_$tSnapshotKt_vxgvey() + toNumber(fromInt(1));
      access$_set_nextSnapshotId_$tSnapshotKt_xcaltq(tmp$ret$9);
      this.i53(this_0);
      access$_set_openSnapshots_$tSnapshotKt_9lk9nh(access$_get_openSnapshots_$tSnapshotKt_7cpqp5().h54(this.w3d()));
      var tmp = this.g53();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$10 = previousId + toNumber(fromInt(1));
      this.h53(addRange(tmp, tmp$ret$10, this.w3d()));
    }
    return Unit_instance;
  };
  protoOf(MutableSnapshot).g54 = function (id) {
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    this.q43_1 = this.q43_1.h54(id);
  };
  protoOf(MutableSnapshot).m54 = function (id) {
    if (id >= 0) {
      var tmp = this;
      // Inline function 'kotlin.collections.plus' call
      var tmp0 = this.r43_1;
      // Inline function 'kotlin.intArrayOf' call
      // Inline function 'kotlin.collections.plus' call
      var elements = new Int32Array([id]);
      tmp.r43_1 = primitiveArrayConcat([tmp0, elements]);
    }
  };
  protoOf(MutableSnapshot).n54 = function (handles) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (handles.length === 0)
      return Unit_instance;
    var pinned = this.r43_1;
    var tmp = this;
    var tmp_0;
    // Inline function 'kotlin.collections.isEmpty' call
    if (pinned.length === 0) {
      tmp_0 = handles;
    } else {
      // Inline function 'kotlin.collections.plus' call
      tmp_0 = primitiveArrayConcat([pinned, handles]);
    }
    tmp.r43_1 = tmp_0;
  };
  protoOf(MutableSnapshot).o54 = function (snapshots) {
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    this.q43_1 = this.q43_1.l54(snapshots);
  };
  protoOf(MutableSnapshot).p53 = function (state) {
    var tmp0_elvis_lhs = this.a54();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = mutableScatterSetOf();
      this.b54(this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    tmp.j1(state);
  };
  protoOf(MutableSnapshot).j53 = function (_set____db54di) {
    this.n43_1 = _set____db54di;
  };
  protoOf(MutableSnapshot).z3d = function () {
    return this.n43_1;
  };
  protoOf(MutableSnapshot).b54 = function (_set____db54di) {
    this.o43_1 = _set____db54di;
  };
  protoOf(MutableSnapshot).a54 = function () {
    return this.o43_1;
  };
  function _get_currentSnapshot__9vker0($this) {
    var tmp0_elvis_lhs = $this.j52_1;
    return tmp0_elvis_lhs == null ? get_globalSnapshot() : tmp0_elvis_lhs;
  }
  function TransparentObserverMutableSnapshot(parentSnapshot, specifiedReadObserver, specifiedWriteObserver, mergeParentObservers, ownsParentSnapshot) {
    var tmp = get_INVALID_SNAPSHOT();
    var tmp_0 = Companion_getInstance_19().d54_1;
    var tmp1_elvis_lhs = parentSnapshot == null ? null : parentSnapshot.t3e();
    var tmp_1 = mergedReadObserver(specifiedReadObserver, tmp1_elvis_lhs == null ? get_globalSnapshot().t3e() : tmp1_elvis_lhs, mergeParentObservers);
    var tmp3_elvis_lhs = parentSnapshot == null ? null : parentSnapshot.m53();
    MutableSnapshot.call(this, tmp, tmp_0, tmp_1, mergedWriteObserver(specifiedWriteObserver, tmp3_elvis_lhs == null ? get_globalSnapshot().m53() : tmp3_elvis_lhs));
    this.j52_1 = parentSnapshot;
    this.k52_1 = mergeParentObservers;
    this.l52_1 = ownsParentSnapshot;
    this.m52_1 = protoOf(MutableSnapshot).t3e.call(this);
    this.n52_1 = protoOf(MutableSnapshot).m53.call(this);
    this.o52_1 = currentThreadId();
  }
  protoOf(TransparentObserverMutableSnapshot).t3e = function () {
    return this.m52_1;
  };
  protoOf(TransparentObserverMutableSnapshot).m53 = function () {
    return this.n52_1;
  };
  protoOf(TransparentObserverMutableSnapshot).s1d = function () {
    this.u3d_1 = true;
    if (this.l52_1) {
      var tmp0_safe_receiver = this.j52_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.s1d();
      }
    }
  };
  protoOf(TransparentObserverMutableSnapshot).i53 = function (value) {
    unsupported();
  };
  protoOf(TransparentObserverMutableSnapshot).w3d = function () {
    return _get_currentSnapshot__9vker0(this).w3d();
  };
  protoOf(TransparentObserverMutableSnapshot).h53 = function (value) {
    unsupported();
  };
  protoOf(TransparentObserverMutableSnapshot).g53 = function () {
    return _get_currentSnapshot__9vker0(this).g53();
  };
  protoOf(TransparentObserverMutableSnapshot).b54 = function (value) {
    unsupported();
  };
  protoOf(TransparentObserverMutableSnapshot).a54 = function () {
    return _get_currentSnapshot__9vker0(this).a54();
  };
  protoOf(TransparentObserverMutableSnapshot).j53 = function (value) {
    _get_currentSnapshot__9vker0(this).j53(value);
  };
  protoOf(TransparentObserverMutableSnapshot).z3d = function () {
    return _get_currentSnapshot__9vker0(this).z3d();
  };
  protoOf(TransparentObserverMutableSnapshot).k53 = function () {
    return _get_currentSnapshot__9vker0(this).k53();
  };
  protoOf(TransparentObserverMutableSnapshot).u43 = function () {
    return _get_currentSnapshot__9vker0(this).u43();
  };
  protoOf(TransparentObserverMutableSnapshot).p53 = function (state) {
    return _get_currentSnapshot__9vker0(this).p53(state);
  };
  protoOf(TransparentObserverMutableSnapshot).u51 = function (readObserver) {
    var mergedReadObserver_0 = mergedReadObserver(readObserver, this.m52_1);
    var tmp;
    if (!this.k52_1) {
      tmp = createTransparentSnapshotWithNoParentReadObserver(_get_currentSnapshot__9vker0(this).u51(null), mergedReadObserver_0, true);
    } else {
      tmp = _get_currentSnapshot__9vker0(this).u51(mergedReadObserver_0);
    }
    return tmp;
  };
  protoOf(TransparentObserverMutableSnapshot).v51 = function (readObserver, writeObserver) {
    var mergedReadObserver_0 = mergedReadObserver(readObserver, this.m52_1);
    var mergedWriteObserver_0 = mergedWriteObserver(writeObserver, this.n52_1);
    var tmp;
    if (!this.k52_1) {
      var nestedSnapshot = _get_currentSnapshot__9vker0(this).v51(null, mergedWriteObserver_0);
      tmp = new TransparentObserverMutableSnapshot(nestedSnapshot, mergedReadObserver_0, mergedWriteObserver_0, false, true);
    } else {
      tmp = _get_currentSnapshot__9vker0(this).v51(mergedReadObserver_0, mergedWriteObserver_0);
    }
    return tmp;
  };
  protoOf(TransparentObserverMutableSnapshot).e53 = function () {
    return _get_currentSnapshot__9vker0(this).e53();
  };
  protoOf(TransparentObserverMutableSnapshot).p54 = function (snapshot) {
    unsupported();
  };
  protoOf(TransparentObserverMutableSnapshot).n53 = function (snapshot) {
    return this.p54(snapshot);
  };
  protoOf(TransparentObserverMutableSnapshot).q54 = function (snapshot) {
    unsupported();
  };
  protoOf(TransparentObserverMutableSnapshot).o53 = function (snapshot) {
    return this.q54(snapshot);
  };
  function _get_currentSnapshot__9vker0_0($this) {
    var tmp0_elvis_lhs = $this.v52_1;
    return tmp0_elvis_lhs == null ? get_globalSnapshot() : tmp0_elvis_lhs;
  }
  function TransparentObserverSnapshot(parentSnapshot, specifiedReadObserver, mergeParentObservers, ownsParentSnapshot) {
    Snapshot.call(this, get_INVALID_SNAPSHOT(), Companion_getInstance_19().d54_1);
    this.v52_1 = parentSnapshot;
    this.w52_1 = mergeParentObservers;
    this.x52_1 = ownsParentSnapshot;
    var tmp = this;
    var tmp0_safe_receiver = this.v52_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t3e();
    tmp.y52_1 = mergedReadObserver(specifiedReadObserver, tmp1_elvis_lhs == null ? get_globalSnapshot().t3e() : tmp1_elvis_lhs, this.w52_1);
    this.z52_1 = null;
    this.a53_1 = currentThreadId();
    this.b53_1 = this;
  }
  protoOf(TransparentObserverSnapshot).t3e = function () {
    return this.y52_1;
  };
  protoOf(TransparentObserverSnapshot).m53 = function () {
    return this.z52_1;
  };
  protoOf(TransparentObserverSnapshot).s1d = function () {
    this.u3d_1 = true;
    if (this.x52_1) {
      var tmp0_safe_receiver = this.v52_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.s1d();
      }
    }
  };
  protoOf(TransparentObserverSnapshot).w3d = function () {
    return _get_currentSnapshot__9vker0_0(this).w3d();
  };
  protoOf(TransparentObserverSnapshot).g53 = function () {
    return _get_currentSnapshot__9vker0_0(this).g53();
  };
  protoOf(TransparentObserverSnapshot).k53 = function () {
    return _get_currentSnapshot__9vker0_0(this).k53();
  };
  protoOf(TransparentObserverSnapshot).p53 = function (state) {
    return _get_currentSnapshot__9vker0_0(this).p53(state);
  };
  protoOf(TransparentObserverSnapshot).u51 = function (readObserver) {
    var mergedReadObserver_0 = mergedReadObserver(readObserver, this.y52_1);
    var tmp;
    if (!this.w52_1) {
      tmp = createTransparentSnapshotWithNoParentReadObserver(_get_currentSnapshot__9vker0_0(this).u51(null), mergedReadObserver_0, true);
    } else {
      tmp = _get_currentSnapshot__9vker0_0(this).u51(mergedReadObserver_0);
    }
    return tmp;
  };
  protoOf(TransparentObserverSnapshot).e53 = function () {
    return _get_currentSnapshot__9vker0_0(this).e53();
  };
  protoOf(TransparentObserverSnapshot).p54 = function (snapshot) {
    unsupported();
  };
  protoOf(TransparentObserverSnapshot).n53 = function (snapshot) {
    return this.p54(snapshot);
  };
  protoOf(TransparentObserverSnapshot).q54 = function (snapshot) {
    unsupported();
  };
  protoOf(TransparentObserverSnapshot).o53 = function (snapshot) {
    return this.q54(snapshot);
  };
  function ObserverHandle() {
  }
  function Success() {
    Success_instance = this;
    SnapshotApplyResult.call(this);
  }
  var Success_instance;
  function Success_getInstance() {
    if (Success_instance == null)
      new Success();
    return Success_instance;
  }
  function Failure(snapshot) {
    SnapshotApplyResult.call(this);
    this.r54_1 = snapshot;
  }
  function SnapshotApplyResult() {
  }
  function GlobalSnapshot$_init_$lambda_36kgl8(state) {
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var this_0 = get_globalWriteObservers();
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item(state);
      }
       while (inductionVariable <= last);
    return Unit_instance;
  }
  function GlobalSnapshot$takeNestedSnapshot$lambda($actualReadObserver) {
    return function (invalid) {
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      // Inline function 'kotlin.also' call
      var this_0 = get_nextSnapshotId();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$5 = get_nextSnapshotId() + toNumber(fromInt(1));
      set_nextSnapshotId(tmp$ret$5);
      return new ReadonlySnapshot(this_0, invalid, $actualReadObserver);
    };
  }
  function GlobalSnapshot$takeNestedMutableSnapshot$lambda($actualReadObserver, $actualWriteObserver) {
    return function (invalid) {
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      // Inline function 'kotlin.also' call
      var this_0 = get_nextSnapshotId();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$5 = get_nextSnapshotId() + toNumber(fromInt(1));
      set_nextSnapshotId(tmp$ret$5);
      return new MutableSnapshot(this_0, invalid, $actualReadObserver, $actualWriteObserver);
    };
  }
  function GlobalSnapshot(snapshotId, invalid) {
    MutableSnapshot.call(this, snapshotId, invalid, null, GlobalSnapshot$_init_$lambda_36kgl8);
  }
  protoOf(GlobalSnapshot).u51 = function (readObserver) {
    // Inline function 'androidx.compose.runtime.snapshots.tooling.creatingSnapshot' call
    var observerMap = null;
    var observers = access$_get_observers_$tSnapshotObserverKt_23v7jt();
    var actualReadObserver = readObserver;
    var actualWriteObserver = null;
    if (!(observers == null)) {
      var result = mergeObservers(observers, null, true, readObserver, null);
      var mappedObservers = result.xh_1;
      actualReadObserver = mappedObservers.e54_1;
      actualWriteObserver = mappedObservers.f54_1;
      observerMap = result.yh_1;
    }
    var tmp0 = actualReadObserver;
    var result_0 = takeNewSnapshot(GlobalSnapshot$takeNestedSnapshot$lambda(tmp0));
    if (observers == null)
      null;
    else {
      dispatchCreatedObservers(observers, null, result_0, observerMap);
    }
    return result_0;
  };
  protoOf(GlobalSnapshot).v51 = function (readObserver, writeObserver) {
    // Inline function 'androidx.compose.runtime.snapshots.tooling.creatingSnapshot' call
    var observerMap = null;
    var observers = access$_get_observers_$tSnapshotObserverKt_23v7jt();
    var actualReadObserver = readObserver;
    var actualWriteObserver = writeObserver;
    if (!(observers == null)) {
      var result = mergeObservers(observers, null, false, readObserver, writeObserver);
      var mappedObservers = result.xh_1;
      actualReadObserver = mappedObservers.e54_1;
      actualWriteObserver = mappedObservers.f54_1;
      observerMap = result.yh_1;
    }
    var tmp0 = actualReadObserver;
    var actualWriteObserver_0 = actualWriteObserver;
    var result_0 = takeNewSnapshot(GlobalSnapshot$takeNestedMutableSnapshot$lambda(tmp0, actualWriteObserver_0));
    if (observers == null)
      null;
    else {
      dispatchCreatedObservers(observers, null, result_0, observerMap);
    }
    return result_0;
  };
  protoOf(GlobalSnapshot).e53 = function () {
    advanceGlobalSnapshot_0();
  };
  protoOf(GlobalSnapshot).q54 = function (snapshot) {
    unsupported();
  };
  protoOf(GlobalSnapshot).o53 = function (snapshot) {
    return this.q54(snapshot);
  };
  protoOf(GlobalSnapshot).p54 = function (snapshot) {
    unsupported();
  };
  protoOf(GlobalSnapshot).n53 = function (snapshot) {
    return this.p54(snapshot);
  };
  protoOf(GlobalSnapshot).u43 = function () {
    // Inline function 'kotlin.error' call
    var message = 'Cannot apply the global snapshot directly. Call Snapshot.advanceGlobalSnapshot';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(GlobalSnapshot).s1d = function () {
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    this.l53();
  };
  function trackPinning(snapshotId, invalid) {
    _init_properties_Snapshot_kt__l6n1ng();
    var pinned = invalid.f55(snapshotId);
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    return get_pinningTable().rt(pinned);
  }
  function releasePinningLocked(handle) {
    _init_properties_Snapshot_kt__l6n1ng();
    get_pinningTable().av(handle);
  }
  function mergedReadObserver(readObserver, parentObserver, mergeReadObserver) {
    mergeReadObserver = mergeReadObserver === VOID ? true : mergeReadObserver;
    _init_properties_Snapshot_kt__l6n1ng();
    var parentObserver_0 = mergeReadObserver ? parentObserver : null;
    var tmp;
    if (!(readObserver == null) && !(parentObserver_0 == null) && !(readObserver === parentObserver_0)) {
      tmp = mergedReadObserver$lambda(readObserver, parentObserver_0);
    } else {
      tmp = readObserver == null ? parentObserver_0 : readObserver;
    }
    return tmp;
  }
  function mergedWriteObserver(writeObserver, parentObserver) {
    _init_properties_Snapshot_kt__l6n1ng();
    var tmp;
    if (!(writeObserver == null) && !(parentObserver == null) && !(writeObserver === parentObserver)) {
      tmp = mergedWriteObserver$lambda(writeObserver, parentObserver);
    } else {
      tmp = writeObserver == null ? parentObserver : writeObserver;
    }
    return tmp;
  }
  function createTransparentSnapshotWithNoParentReadObserver(previousSnapshot, readObserver, ownsPreviousSnapshot) {
    readObserver = readObserver === VOID ? null : readObserver;
    ownsPreviousSnapshot = ownsPreviousSnapshot === VOID ? false : ownsPreviousSnapshot;
    _init_properties_Snapshot_kt__l6n1ng();
    var tmp;
    var tmp_0;
    if (previousSnapshot instanceof MutableSnapshot) {
      tmp_0 = true;
    } else {
      tmp_0 = previousSnapshot == null;
    }
    if (tmp_0) {
      tmp = new TransparentObserverMutableSnapshot(previousSnapshot instanceof MutableSnapshot ? previousSnapshot : null, readObserver, null, false, ownsPreviousSnapshot);
    } else {
      tmp = new TransparentObserverSnapshot(previousSnapshot, readObserver, false, ownsPreviousSnapshot);
    }
    return tmp;
  }
  function advanceGlobalSnapshot(block) {
    _init_properties_Snapshot_kt__l6n1ng();
    var globalSnapshot = get_globalSnapshot();
    var modified;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    modified = globalSnapshot.a54();
    if (!(modified == null)) {
      get_pendingApplyObserverCount().pv(1);
    }
    var result = resetGlobalSnapshotLocked(globalSnapshot, block);
    if (modified == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      try {
        var observers = get_applyObservers();
        var modifiedSet = wrapIntoSet(modified);
        // Inline function 'androidx.compose.runtime.tooling.verboseTrace' call
        var name = 'Compose:applyObservers';
        if (ComposeToolingFlags_instance.f3f_1) {
          $l$block: {
            // Inline function 'androidx.compose.runtime.internal.trace' call
            var token = Trace_instance.r38(name);
            try {
              // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
              var inductionVariable = 0;
              var last = observers.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = observers.l1(index);
                  item(modifiedSet, globalSnapshot);
                }
                 while (inductionVariable <= last);
              break $l$block;
            }finally {
              Trace_instance.t38(token);
            }
          }
        } else {
          // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
          var inductionVariable_0 = 0;
          var last_0 = observers.n1() - 1 | 0;
          if (inductionVariable_0 <= last_0)
            do {
              var index_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var item_0 = observers.l1(index_0);
              item_0(modifiedSet, globalSnapshot);
            }
             while (inductionVariable_0 <= last_0);
        }
      }finally {
        get_pendingApplyObserverCount().pv(-1);
      }
    }
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    checkAndOverwriteUnusedRecordsLocked();
    var tmp;
    if (modified == null) {
      tmp = null;
    } else {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var elements = modified.k16_1;
      $l$block_0: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = modified.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= lastIndex)
          do {
            var i = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_0 = slot;
            var tmp$ret$20 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$20, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < bitCount)
                do {
                  var j = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index_1 = (i << 3) + j | 0;
                    var it = elements[index_1];
                    processForUnusedRecordsLocked(it);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_2 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i === lastIndex));
      }
      tmp = Unit_instance;
    }
    return result;
  }
  function advanceGlobalSnapshot_0() {
    _init_properties_Snapshot_kt__l6n1ng();
    return advanceGlobalSnapshot(get_emptyLambda());
  }
  function current_0(r) {
    _init_properties_Snapshot_kt__l6n1ng();
    // Inline function 'kotlin.let' call
    var snapshot = Companion_instance_18.e2y();
    var tmp0_elvis_lhs = readable(r, snapshot.w3d(), snapshot.g53());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      // Inline function 'kotlin.let' call
      var syncSnapshot = Companion_instance_18.e2y();
      tmp = readable(r, syncSnapshot.w3d(), syncSnapshot.g53());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      readError();
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  function writableRecord(_this__u8e3s4, state, snapshot) {
    _init_properties_Snapshot_kt__l6n1ng();
    if (snapshot.k53()) {
      snapshot.p53(state);
    }
    var id = snapshot.w3d();
    var tmp0_elvis_lhs = readable(_this__u8e3s4, id, snapshot.g53());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      readError();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var readData = tmp;
    if (equals(readData.l3e_1, snapshot.w3d()))
      return readData;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    var tmp0_elvis_lhs_0 = readable(state.f3e(), id, snapshot.g53());
    var tmp_0;
    if (tmp0_elvis_lhs_0 == null) {
      readError();
    } else {
      tmp_0 = tmp0_elvis_lhs_0;
    }
    var newReadData = tmp_0;
    var tmp_1 = equals(newReadData.l3e_1, id) ? newReadData : newWritableRecordLocked(newReadData, state, snapshot);
    var newData = tmp_1 instanceof StateRecord ? tmp_1 : THROW_CCE();
    if (!equals(readData.l3e_1, toSnapshotId(1))) {
      snapshot.p53(state);
    }
    return newData;
  }
  function notifyWrite(snapshot, state) {
    _init_properties_Snapshot_kt__l6n1ng();
    snapshot.j53(snapshot.z3d() + 1 | 0);
    var tmp0_safe_receiver = snapshot.m53();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(state);
  }
  function readable(r, id, invalid) {
    _init_properties_Snapshot_kt__l6n1ng();
    var current = r;
    var candidate = null;
    while (!(current == null)) {
      if (valid(current, id, invalid)) {
        var tmp;
        if (candidate == null) {
          tmp = current;
        } else {
          var tmp0 = candidate.l3e_1;
          // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
          var other = current.l3e_1;
          if (compareTo(tmp0, other) < 0) {
            tmp = current;
          } else {
            tmp = candidate;
          }
        }
        candidate = tmp;
      }
      current = current.m3e_1;
    }
    if (!(candidate == null)) {
      return candidate instanceof StateRecord ? candidate : THROW_CCE();
    }
    return null;
  }
  function readError() {
    _init_properties_Snapshot_kt__l6n1ng();
    // Inline function 'kotlin.error' call
    var message = 'Reading a state that was created after the snapshot was taken or in a snapshot that has not yet been applied';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function newWritableRecordLocked(_this__u8e3s4, state, snapshot) {
    _init_properties_Snapshot_kt__l6n1ng();
    var newData = newOverwritableRecordLocked(_this__u8e3s4, state);
    newData.q3d(_this__u8e3s4);
    newData.l3e_1 = snapshot.w3d();
    return newData;
  }
  function deactivate($this) {
    if (!$this.z55_1) {
      $this.z55_1 = true;
      $this.y55_1.o53($this);
    }
  }
  function NestedMutableSnapshot(snapshotId, invalid, readObserver, writeObserver, parent) {
    MutableSnapshot.call(this, snapshotId, invalid, readObserver, writeObserver);
    this.y55_1 = parent;
    this.z55_1 = false;
    this.y55_1.n53(this);
  }
  protoOf(NestedMutableSnapshot).s1d = function () {
    if (!this.u3d_1) {
      protoOf(MutableSnapshot).s1d.call(this);
      deactivate(this);
    }
  };
  protoOf(NestedMutableSnapshot).u43 = function () {
    if (this.y55_1.t43_1 || this.y55_1.u3d_1)
      return new Failure(this);
    var modified = this.a54();
    var id = this.w3d();
    var optimisticMerges_0 = !(modified == null) ? optimisticMerges(this.y55_1.w3d(), this, this.y55_1.g53()) : null;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    validateOpen(this);
    if (modified == null || modified.n1() === 0) {
      this.q53();
    } else {
      var result = this.i54(this.y55_1.w3d(), modified, optimisticMerges_0, this.y55_1.g53());
      if (!equals(result, Success_getInstance()))
        return result;
      var tmp0_safe_receiver = this.y55_1.a54();
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.apply' call
        tmp0_safe_receiver.s16(modified);
        tmp = tmp0_safe_receiver;
      }
      if (tmp == null) {
        // Inline function 'kotlin.also' call
        this.y55_1.b54(modified);
        this.b54(null);
      }
    }
    // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
    var this_0 = this.y55_1.w3d();
    if (compareTo(this_0, id) < 0) {
      this.y55_1.j54();
    }
    this.y55_1.h53(this.y55_1.g53().x53(id).k54(this.q43_1));
    this.y55_1.g54(id);
    this.y55_1.m54(this.z53());
    this.y55_1.o54(this.q43_1);
    this.y55_1.n54(this.r43_1);
    this.t43_1 = true;
    deactivate(this);
    dispatchObserverOnApplied(this, modified);
    return Success_getInstance();
  };
  function addRange(_this__u8e3s4, from, until) {
    _init_properties_Snapshot_kt__l6n1ng();
    var result = _this__u8e3s4;
    var invalidId = from;
    $l$loop: while (true) {
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      var this_0 = invalidId;
      if (!(compareTo(this_0, until) < 0)) {
        break $l$loop;
      }
      result = result.h54(invalidId);
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      invalidId = invalidId + toNumber(fromInt(1));
    }
    return result;
  }
  function optimisticMerges(currentSnapshotId, applyingSnapshot, invalidSnapshots) {
    _init_properties_Snapshot_kt__l6n1ng();
    var modified = applyingSnapshot.a54();
    if (modified == null)
      return null;
    var applyingSnapshotId = applyingSnapshot.w3d();
    var start = applyingSnapshot.g53().h54(applyingSnapshotId).l54(applyingSnapshot.q43_1);
    var result = null;
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    // Inline function 'kotlin.contracts.contract' call
    var elements = modified.k16_1;
    $l$block_1: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m = modified.j16_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_0 = slot;
          var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = elements[index];
                  $l$block_0: {
                    var first = tmp0.f3e();
                    var tmp0_elvis_lhs = readable(first, currentSnapshotId, invalidSnapshots);
                    var tmp;
                    if (tmp0_elvis_lhs == null) {
                      break $l$block_0;
                    } else {
                      tmp = tmp0_elvis_lhs;
                    }
                    var current = tmp;
                    var tmp1_elvis_lhs = readable(first, applyingSnapshotId, start);
                    var tmp_0;
                    if (tmp1_elvis_lhs == null) {
                      break $l$block_0;
                    } else {
                      tmp_0 = tmp1_elvis_lhs;
                    }
                    var previous = tmp_0;
                    if (!equals(current, previous)) {
                      var tmp2_elvis_lhs = readable(first, applyingSnapshotId, applyingSnapshot.g53());
                      var tmp_1;
                      if (tmp2_elvis_lhs == null) {
                        readError();
                      } else {
                        tmp_1 = tmp2_elvis_lhs;
                      }
                      var applied = tmp_1;
                      var merged = tmp0.a3f(previous, current, applied);
                      if (!(merged == null)) {
                        var tmp3_elvis_lhs = result;
                        var tmp_2;
                        if (tmp3_elvis_lhs == null) {
                          // Inline function 'kotlin.collections.hashMapOf' call
                          // Inline function 'kotlin.also' call
                          var this_1 = HashMap_init_$Create$_0();
                          result = this_1;
                          tmp_2 = this_1;
                        } else {
                          tmp_2 = tmp3_elvis_lhs;
                        }
                        // Inline function 'kotlin.collections.set' call
                        tmp_2.z2(current, merged);
                      } else {
                        return null;
                      }
                    }
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block_1;
            }
          }
        }
         while (!(i === lastIndex));
    }
    return result;
  }
  function validateOpen(snapshot) {
    _init_properties_Snapshot_kt__l6n1ng();
    var openSnapshots = get_openSnapshots();
    if (!openSnapshots.b56(snapshot.w3d())) {
      var tmp = snapshot.w3d();
      var tmp_0 = snapshot.u3d_1;
      var tmp0_safe_receiver = snapshot instanceof MutableSnapshot ? snapshot : null;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t43_1;
      var tmp_1 = toString(tmp1_elvis_lhs == null ? 'read-only' : tmp1_elvis_lhs);
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      // Inline function 'kotlin.error' call
      var message = 'Snapshot is not open: snapshotId=' + tmp + ', disposed=' + tmp_0 + ', applied=' + tmp_1 + ', lowestPin=' + get_pinningTable().a56(-1.0);
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function resetGlobalSnapshotLocked(globalSnapshot, block) {
    _init_properties_Snapshot_kt__l6n1ng();
    var snapshotId = globalSnapshot.w3d();
    var result = block(get_openSnapshots().x53(snapshotId));
    var nextGlobalSnapshotId = get_nextSnapshotId();
    // Inline function 'androidx.compose.runtime.snapshots.plus' call
    var tmp$ret$0 = get_nextSnapshotId() + toNumber(fromInt(1));
    set_nextSnapshotId(tmp$ret$0);
    set_openSnapshots(get_openSnapshots().x53(snapshotId));
    globalSnapshot.i53(nextGlobalSnapshotId);
    globalSnapshot.h53(get_openSnapshots());
    globalSnapshot.j53(0);
    globalSnapshot.b54(null);
    globalSnapshot.l53();
    set_openSnapshots(get_openSnapshots().h54(nextGlobalSnapshotId));
    return result;
  }
  function checkAndOverwriteUnusedRecordsLocked() {
    _init_properties_Snapshot_kt__l6n1ng();
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotWeakSet.removeIf' call
    var this_0 = get_extraStateObjects();
    var size = this_0.c56_1;
    var currentUsed = 0;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var entry = this_0.e56_1[i];
        var value = entry == null ? null : entry.f1i();
        var tmp;
        if (!(value == null)) {
          tmp = !!overwriteUnusedRecordsLocked(value);
        } else {
          tmp = false;
        }
        if (tmp) {
          if (!(currentUsed === i)) {
            this_0.e56_1[currentUsed] = entry;
            this_0.d56_1[currentUsed] = this_0.d56_1[i];
          }
          currentUsed = currentUsed + 1 | 0;
        }
      }
       while (inductionVariable < size);
    var inductionVariable_0 = currentUsed;
    if (inductionVariable_0 < size)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0.e56_1[i_0] = null;
        this_0.d56_1[i_0] = 0;
      }
       while (inductionVariable_0 < size);
    if (!(currentUsed === size)) {
      this_0.c56_1 = currentUsed;
    }
  }
  function processForUnusedRecordsLocked(state) {
    _init_properties_Snapshot_kt__l6n1ng();
    if (overwriteUnusedRecordsLocked(state)) {
      get_extraStateObjects().g56(state);
    }
  }
  function NestedReadonlySnapshot(snapshotId, invalid, readObserver, parent) {
    Snapshot.call(this, snapshotId, invalid);
    this.l56_1 = readObserver;
    this.m56_1 = parent;
    this.m56_1.n53(this);
  }
  protoOf(NestedReadonlySnapshot).t3e = function () {
    return this.l56_1;
  };
  protoOf(NestedReadonlySnapshot).k53 = function () {
    return true;
  };
  protoOf(NestedReadonlySnapshot).u51 = function (readObserver) {
    // Inline function 'androidx.compose.runtime.snapshots.tooling.creatingSnapshot' call
    var observerMap = null;
    var observers = access$_get_observers_$tSnapshotObserverKt_23v7jt();
    var actualReadObserver = readObserver;
    var actualWriteObserver = null;
    if (!(observers == null)) {
      var result = mergeObservers(observers, this, true, readObserver, null);
      var mappedObservers = result.xh_1;
      actualReadObserver = mappedObservers.e54_1;
      actualWriteObserver = mappedObservers.f54_1;
      observerMap = result.yh_1;
    }
    var tmp0 = actualReadObserver;
    var result_0 = new NestedReadonlySnapshot(this.w3d(), this.g53(), mergedReadObserver(tmp0, this.l56_1), this.m56_1);
    if (observers == null)
      null;
    else {
      dispatchCreatedObservers(observers, this, result_0, observerMap);
    }
    return result_0;
  };
  protoOf(NestedReadonlySnapshot).e53 = function () {
  };
  protoOf(NestedReadonlySnapshot).s1d = function () {
    if (!this.u3d_1) {
      if (!equals(this.w3d(), this.m56_1.w3d())) {
        this.q53();
      }
      this.m56_1.o53(this);
      protoOf(Snapshot).s1d.call(this);
      dispatchObserverOnPreDispose(this);
    }
  };
  protoOf(NestedReadonlySnapshot).m53 = function () {
    return null;
  };
  protoOf(NestedReadonlySnapshot).n56 = function (state) {
    reportReadonlySnapshotWrite();
  };
  protoOf(NestedReadonlySnapshot).p53 = function (state) {
    return this.n56(state);
  };
  protoOf(NestedReadonlySnapshot).q54 = function (snapshot) {
    unsupported();
  };
  protoOf(NestedReadonlySnapshot).o53 = function (snapshot) {
    return this.q54(snapshot);
  };
  protoOf(NestedReadonlySnapshot).p54 = function (snapshot) {
    unsupported();
  };
  protoOf(NestedReadonlySnapshot).n53 = function (snapshot) {
    return this.p54(snapshot);
  };
  function ReadonlySnapshot(snapshotId, invalid, readObserver) {
    Snapshot.call(this, snapshotId, invalid);
    this.s56_1 = readObserver;
    this.t56_1 = 1;
  }
  protoOf(ReadonlySnapshot).t3e = function () {
    return this.s56_1;
  };
  protoOf(ReadonlySnapshot).k53 = function () {
    return true;
  };
  protoOf(ReadonlySnapshot).m53 = function () {
    return null;
  };
  protoOf(ReadonlySnapshot).u51 = function (readObserver) {
    validateOpen(this);
    // Inline function 'androidx.compose.runtime.snapshots.tooling.creatingSnapshot' call
    var observerMap = null;
    var observers = access$_get_observers_$tSnapshotObserverKt_23v7jt();
    var actualReadObserver = readObserver;
    var actualWriteObserver = null;
    if (!(observers == null)) {
      var result = mergeObservers(observers, this, true, readObserver, null);
      var mappedObservers = result.xh_1;
      actualReadObserver = mappedObservers.e54_1;
      actualWriteObserver = mappedObservers.f54_1;
      observerMap = result.yh_1;
    }
    var tmp0 = actualReadObserver;
    var result_0 = new NestedReadonlySnapshot(this.w3d(), this.g53(), mergedReadObserver(tmp0, this.s56_1), this);
    if (observers == null)
      null;
    else {
      dispatchCreatedObservers(observers, this, result_0, observerMap);
    }
    return result_0;
  };
  protoOf(ReadonlySnapshot).e53 = function () {
  };
  protoOf(ReadonlySnapshot).s1d = function () {
    if (!this.u3d_1) {
      this.o53(this);
      protoOf(Snapshot).s1d.call(this);
      dispatchObserverOnPreDispose(this);
    }
  };
  protoOf(ReadonlySnapshot).n53 = function (snapshot) {
    this.t56_1 = this.t56_1 + 1 | 0;
  };
  protoOf(ReadonlySnapshot).o53 = function (snapshot) {
    this.t56_1 = this.t56_1 - 1 | 0;
    if (this.t56_1 === 0) {
      this.q53();
    }
  };
  protoOf(ReadonlySnapshot).p53 = function (state) {
    reportReadonlySnapshotWrite();
  };
  function takeNewSnapshot(block) {
    _init_properties_Snapshot_kt__l6n1ng();
    return advanceGlobalSnapshot(takeNewSnapshot$lambda(block));
  }
  function valid(data, snapshot, invalid) {
    _init_properties_Snapshot_kt__l6n1ng();
    return valid_0(snapshot, data.l3e_1, invalid);
  }
  function newOverwritableRecordLocked(_this__u8e3s4, state) {
    _init_properties_Snapshot_kt__l6n1ng();
    var tmp = usedLocked(state);
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof StateRecord) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.apply' call
      tmp0_safe_receiver.l3e_1 = 1.7976931348623157E308;
      tmp_0 = tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.apply' call
      var this_0 = _this__u8e3s4.x3d(1.7976931348623157E308);
      this_0.m3e_1 = state.f3e();
      state.y3e(this_0 instanceof StateRecord ? this_0 : THROW_CCE());
      var tmp_2 = this_0;
      tmp_1 = tmp_2 instanceof StateRecord ? tmp_2 : THROW_CCE();
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function overwriteUnusedRecordsLocked(state) {
    _init_properties_Snapshot_kt__l6n1ng();
    var current = state.f3e();
    var overwriteRecord = null;
    var validRecord = null;
    var reuseLimit = get_pinningTable().a56(get_nextSnapshotId());
    var retainedRecords = 0;
    while (!(current == null)) {
      var currentId = current.l3e_1;
      if (!equals(currentId, get_INVALID_SNAPSHOT())) {
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        if (compareTo(currentId, reuseLimit) < 0) {
          if (validRecord == null) {
            validRecord = current;
            retainedRecords = retainedRecords + 1 | 0;
          } else {
            var tmp;
            var tmp0 = current.l3e_1;
            // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
            var other = validRecord.l3e_1;
            if (compareTo(tmp0, other) < 0) {
              tmp = current;
            } else {
              var result = validRecord;
              validRecord = current;
              tmp = result;
            }
            var recordToOverwrite = tmp;
            if (overwriteRecord == null) {
              var tmp0_0 = state.f3e();
              var tmp$ret$2;
              $l$block: {
                // Inline function 'androidx.compose.runtime.snapshots.findYoungestOr' call
                var current_0 = tmp0_0;
                var youngest = tmp0_0;
                while (!(current_0 == null)) {
                  // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
                  var this_0 = current_0.l3e_1;
                  if (compareTo(this_0, reuseLimit) >= 0) {
                    tmp$ret$2 = current_0;
                    break $l$block;
                  }
                  var tmp0_1 = youngest.l3e_1;
                  // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
                  var other_0 = current_0.l3e_1;
                  if (compareTo(tmp0_1, other_0) < 0)
                    youngest = current_0;
                  current_0 = current_0.m3e_1;
                }
                tmp$ret$2 = youngest;
              }
              overwriteRecord = tmp$ret$2;
            }
            recordToOverwrite.l3e_1 = get_INVALID_SNAPSHOT();
            recordToOverwrite.q3d(overwriteRecord);
          }
        } else {
          retainedRecords = retainedRecords + 1 | 0;
        }
      }
      current = current.m3e_1;
    }
    return retainedRecords > 1;
  }
  function reportReadonlySnapshotWrite() {
    _init_properties_Snapshot_kt__l6n1ng();
    // Inline function 'kotlin.error' call
    var message = 'Cannot modify a state object in a read-only snapshot';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function valid_0(currentSnapshot, candidateSnapshot, invalid) {
    _init_properties_Snapshot_kt__l6n1ng();
    var tmp;
    var tmp_0;
    if (!equals(candidateSnapshot, get_INVALID_SNAPSHOT())) {
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      tmp_0 = compareTo(candidateSnapshot, currentSnapshot) <= 0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !invalid.b56(candidateSnapshot);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function usedLocked(state) {
    _init_properties_Snapshot_kt__l6n1ng();
    var current = state.f3e();
    var validRecord = null;
    // Inline function 'androidx.compose.runtime.snapshots.minus' call
    var reuseLimit = get_pinningTable().a56(get_nextSnapshotId()) - toNumber(fromInt(1));
    var invalid = Companion_getInstance_19().d54_1;
    while (!(current == null)) {
      var currentId = current.l3e_1;
      if (equals(currentId, get_INVALID_SNAPSHOT())) {
        return current;
      }
      if (valid(current, reuseLimit, invalid)) {
        if (validRecord == null) {
          validRecord = current;
        } else {
          var tmp;
          var tmp0 = current.l3e_1;
          // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
          var other = validRecord.l3e_1;
          if (compareTo(tmp0, other) < 0) {
            tmp = current;
          } else {
            tmp = validRecord;
          }
          return tmp;
        }
      }
      current = current.m3e_1;
    }
    return null;
  }
  function readable_0(_this__u8e3s4, state) {
    _init_properties_Snapshot_kt__l6n1ng();
    var snapshot = Companion_instance_18.e2y();
    var tmp0_safe_receiver = snapshot.t3e();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(state);
    var tmp1_elvis_lhs = readable(_this__u8e3s4, snapshot.w3d(), snapshot.g53());
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      var syncSnapshot = Companion_instance_18.e2y();
      var tmp_0 = state.f3e();
      var tmp0_elvis_lhs = readable(tmp_0 instanceof StateRecord ? tmp_0 : THROW_CCE(), syncSnapshot.w3d(), syncSnapshot.g53());
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        readError();
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp = tmp_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function overwritableRecord(_this__u8e3s4, state, snapshot, candidate) {
    _init_properties_Snapshot_kt__l6n1ng();
    if (snapshot.k53()) {
      snapshot.p53(state);
    }
    var id = snapshot.w3d();
    if (equals(candidate.l3e_1, id))
      return candidate;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    var newData = newOverwritableRecordLocked(_this__u8e3s4, state);
    newData.l3e_1 = id;
    if (!equals(candidate.l3e_1, toSnapshotId(1))) {
      snapshot.p53(state);
    }
    return newData;
  }
  function access$_get_threadSnapshot_$tSnapshotKt_cpt6u2() {
    return get_threadSnapshot();
  }
  function access$_get_openSnapshots_$tSnapshotKt_7cpqp5() {
    return get_openSnapshots();
  }
  function access$_set_openSnapshots_$tSnapshotKt_9lk9nh(_set____db54di) {
    return set_openSnapshots(_set____db54di);
  }
  function access$_get_nextSnapshotId_$tSnapshotKt_vxgvey() {
    return get_nextSnapshotId();
  }
  function access$_set_nextSnapshotId_$tSnapshotKt_xcaltq(_set____db54di) {
    return set_nextSnapshotId(_set____db54di);
  }
  function emptyLambda$lambda(it) {
    _init_properties_Snapshot_kt__l6n1ng();
    return Unit_instance;
  }
  function mergedReadObserver$lambda($readObserver, $parentObserver) {
    return function (state) {
      $readObserver(state);
      $parentObserver(state);
      return Unit_instance;
    };
  }
  function mergedWriteObserver$lambda($writeObserver, $parentObserver) {
    return function (state) {
      $writeObserver(state);
      $parentObserver(state);
      return Unit_instance;
    };
  }
  function takeNewSnapshot$lambda($block) {
    return function (invalid) {
      var result = $block(invalid);
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      set_openSnapshots(get_openSnapshots().h54(result.w3d()));
      return result;
    };
  }
  var properties_initialized_Snapshot_kt_2vlcoq;
  function _init_properties_Snapshot_kt__l6n1ng() {
    if (!properties_initialized_Snapshot_kt_2vlcoq) {
      properties_initialized_Snapshot_kt_2vlcoq = true;
      emptyLambda = emptyLambda$lambda;
      INVALID_SNAPSHOT = 0.0;
      threadSnapshot = new SnapshotThreadLocal();
      // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
      lock = null == null ? new Object() : null;
      openSnapshots = Companion_getInstance_19().d54_1;
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      nextSnapshotId = toSnapshotId(1) + toNumber(fromInt(1));
      pinningTable = new SnapshotDoubleIndexHeap();
      extraStateObjects = new SnapshotWeakSet();
      applyObservers = emptyList();
      globalWriteObservers = emptyList();
      // Inline function 'kotlin.also' call
      var this_0 = get_nextSnapshotId();
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp$ret$2 = get_nextSnapshotId() + toNumber(fromInt(1));
      set_nextSnapshotId(tmp$ret$2);
      // Inline function 'kotlin.also' call
      var this_1 = new GlobalSnapshot(this_0, Companion_getInstance_19().d54_1);
      set_openSnapshots(get_openSnapshots().h54(this_1.w3d()));
      globalSnapshot = this_1;
      snapshotInitializer = get_globalSnapshot();
      pendingApplyObserverCount = new AtomicInt(0);
      androidx_compose_runtime_snapshots_Snapshot$stable = 8;
      androidx_compose_runtime_snapshots_MutableSnapshot$stable = 8;
      androidx_compose_runtime_snapshots_SnapshotApplyResult_Success$stable = 0;
      androidx_compose_runtime_snapshots_SnapshotApplyResult_Failure$stable = 8;
      androidx_compose_runtime_snapshots_SnapshotApplyResult$stable = 0;
      androidx_compose_runtime_snapshots_SnapshotApplyConflictException$stable = 8;
      androidx_compose_runtime_snapshots_StateRecord$stable = 8;
      androidx_compose_runtime_snapshots_ReadonlySnapshot$stable = 8;
      androidx_compose_runtime_snapshots_NestedReadonlySnapshot$stable = 8;
      androidx_compose_runtime_snapshots_GlobalSnapshot$stable = 8;
      androidx_compose_runtime_snapshots_NestedMutableSnapshot$stable = 8;
      androidx_compose_runtime_snapshots_TransparentObserverMutableSnapshot$stable = 8;
      androidx_compose_runtime_snapshots_TransparentObserverSnapshot$stable = 8;
    }
  }
  var androidx_compose_runtime_snapshots_SnapshotDoubleIndexHeap$stable;
  function shiftUp($this, index) {
    var values = $this.h55_1;
    // Inline function 'androidx.compose.runtime.snapshots.get' call
    var value = values[index];
    var current = index;
    $l$loop: while (current > 0) {
      var parent = ((current + 1 | 0) >> 1) - 1 | 0;
      // Inline function 'androidx.compose.runtime.snapshots.get' call
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      var this_0 = values[parent];
      if (compareTo(this_0, value) > 0) {
        swap($this, parent, current);
        current = parent;
        continue $l$loop;
      }
      break $l$loop;
    }
  }
  function shiftDown($this, index) {
    var values = $this.h55_1;
    var half = $this.g55_1 >> 1;
    var current = index;
    while (current < half) {
      var right = (current + 1 | 0) << 1;
      var left = right - 1 | 0;
      var tmp;
      if (right < $this.g55_1) {
        // Inline function 'androidx.compose.runtime.snapshots.get' call
        var tmp0 = values[right];
        // Inline function 'androidx.compose.runtime.snapshots.get' call
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        var other = values[left];
        tmp = compareTo(tmp0, other) < 0;
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'androidx.compose.runtime.snapshots.get' call
        var tmp0_0 = values[right];
        // Inline function 'androidx.compose.runtime.snapshots.get' call
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        var other_0 = values[current];
        if (compareTo(tmp0_0, other_0) < 0) {
          swap($this, right, current);
          current = right;
        } else {
          return Unit_instance;
        }
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.get' call
        var tmp0_1 = values[left];
        // Inline function 'androidx.compose.runtime.snapshots.get' call
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        var other_1 = values[current];
        if (compareTo(tmp0_1, other_1) < 0) {
          swap($this, left, current);
          current = left;
        } else {
          return Unit_instance;
        }
      }
    }
  }
  function swap($this, a, b) {
    var values = $this.h55_1;
    var index = $this.i55_1;
    var handles = $this.j55_1;
    // Inline function 'androidx.compose.runtime.snapshots.get' call
    var t = values[a];
    // Inline function 'androidx.compose.runtime.snapshots.get' call
    // Inline function 'androidx.compose.runtime.snapshots.set' call
    values[a] = values[b];
    // Inline function 'androidx.compose.runtime.snapshots.set' call
    values[b] = t;
    var ia = index[a];
    var ib = index[b];
    index[a] = ib;
    index[b] = ia;
    handles[ib] = a;
    handles[ia] = b;
  }
  function ensure($this, atLeast) {
    // Inline function 'androidx.compose.runtime.snapshots.size' call
    var capacity = $this.h55_1.length;
    if (atLeast <= capacity)
      return Unit_instance;
    var newCapacity = imul(capacity, 2);
    var newValues = snapshotIdArrayWithCapacity(newCapacity);
    var newIndex = new Int32Array(newCapacity);
    // Inline function 'androidx.compose.runtime.snapshots.copyInto' call
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = $this.h55_1;
    var endIndex = this_0.length;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newValues, 0, 0, endIndex);
    // Inline function 'kotlin.collections.copyInto' call
    var this_1 = $this.i55_1;
    var endIndex_0 = this_1.length;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = this_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp_0, newIndex, 0, 0, endIndex_0);
    $this.h55_1 = newValues;
    $this.i55_1 = newIndex;
  }
  function allocateHandle($this) {
    var capacity = $this.j55_1.length;
    if ($this.k55_1 >= capacity) {
      var tmp = 0;
      var tmp_0 = imul(capacity, 2);
      var tmp_1 = new Int32Array(tmp_0);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = tmp_2 + 1 | 0;
        tmp = tmp + 1 | 0;
      }
      var newHandles = tmp_1;
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = $this.j55_1;
      var endIndex = this_0.length;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_3 = this_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_3, newHandles, 0, 0, endIndex);
      $this.j55_1 = newHandles;
    }
    var handle = $this.k55_1;
    $this.k55_1 = $this.j55_1[$this.k55_1];
    return handle;
  }
  function freeHandle($this, handle) {
    $this.j55_1[handle] = $this.k55_1;
    $this.k55_1 = handle;
  }
  function SnapshotDoubleIndexHeap() {
    this.g55_1 = 0;
    this.h55_1 = snapshotIdArrayWithCapacity(16);
    this.i55_1 = new Int32Array(16);
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(16);
    while (tmp_0 < 16) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = tmp_2 + 1 | 0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.j55_1 = tmp_1;
    this.k55_1 = 0;
  }
  protoOf(SnapshotDoubleIndexHeap).a56 = function (default_0) {
    var tmp;
    if (this.g55_1 > 0) {
      // Inline function 'androidx.compose.runtime.snapshots.get' call
      tmp = this.h55_1[0];
    } else {
      tmp = default_0;
    }
    return tmp;
  };
  protoOf(SnapshotDoubleIndexHeap).rt = function (value) {
    ensure(this, this.g55_1 + 1 | 0);
    var _unary__edvuaz = this.g55_1;
    this.g55_1 = _unary__edvuaz + 1 | 0;
    var i = _unary__edvuaz;
    var handle = allocateHandle(this);
    // Inline function 'androidx.compose.runtime.snapshots.set' call
    this.h55_1[i] = value;
    this.i55_1[i] = handle;
    this.j55_1[handle] = i;
    shiftUp(this, i);
    return handle;
  };
  protoOf(SnapshotDoubleIndexHeap).av = function (handle) {
    var i = this.j55_1[handle];
    swap(this, i, this.g55_1 - 1 | 0);
    this.g55_1 = this.g55_1 - 1 | 0;
    shiftUp(this, i);
    shiftDown(this, i);
    freeHandle(this, handle);
  };
  var androidx_compose_runtime_snapshots_SnapshotIdSet$stable;
  function Companion_19() {
    Companion_instance_20 = this;
    this.d54_1 = new SnapshotIdSet(new Long(0, 0), new Long(0, 0), 0.0, null);
  }
  var Companion_instance_20;
  function Companion_getInstance_19() {
    if (Companion_instance_20 == null)
      new Companion_19();
    return Companion_instance_20;
  }
  function access$_get_upperSet__2kurhn($this) {
    return $this.t53_1;
  }
  function access$_get_lowerSet__9mjss6($this) {
    return $this.u53_1;
  }
  function access$_get_lowerBound__ou44uq($this) {
    return $this.v53_1;
  }
  function access$_get_belowBound__uc78e($this) {
    return $this.w53_1;
  }
  function SnapshotIdSet$iterator$slambda(this$0, resultContinuation) {
    this.c57_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SnapshotIdSet$iterator$slambda).i57 = function ($this$sequence, $completion) {
    var tmp = this.j57($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SnapshotIdSet$iterator$slambda).ja = function (p1, $completion) {
    return this.i57(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SnapshotIdSet$iterator$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 15;
            var tmp0_safe_receiver = this.c57_1.w53_1;
            if (tmp0_safe_receiver == null) {
              this.g57_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              this.h57_1 = doubleArrayIterator(tmp0_safe_receiver);
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            if (!this.h57_1.u()) {
              this.n9_1 = 3;
              continue $sm;
            }

            var value = this.h57_1.v();
            this.n9_1 = 2;
            suspendResult = this.d57_1.oi(value, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            this.g57_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            if (!equalsLong(this.c57_1.u53_1, new Long(0, 0))) {
              this.f57_1 = until(0, 64).t();
              this.n9_1 = 5;
              continue $sm;
            } else {
              this.n9_1 = 9;
              continue $sm;
            }

          case 5:
            if (!this.f57_1.u()) {
              this.n9_1 = 8;
              continue $sm;
            }

            var index = this.f57_1.v();
            if (!equalsLong(bitwiseAnd(this.c57_1.u53_1, shiftLeft(new Long(1, 0), index)), new Long(0, 0))) {
              this.n9_1 = 6;
              var this_0 = this.c57_1.v53_1;
              suspendResult = this.d57_1.oi(this_0 + toNumber(fromInt(index)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 6:
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.n9_1 = 5;
            continue $sm;
          case 8:
            this.n9_1 = 9;
            continue $sm;
          case 9:
            if (!equalsLong(this.c57_1.t53_1, new Long(0, 0))) {
              this.e57_1 = until(0, 64).t();
              this.n9_1 = 10;
              continue $sm;
            } else {
              this.n9_1 = 14;
              continue $sm;
            }

          case 10:
            if (!this.e57_1.u()) {
              this.n9_1 = 13;
              continue $sm;
            }

            var index_0 = this.e57_1.v();
            if (!equalsLong(bitwiseAnd(this.c57_1.t53_1, shiftLeft(new Long(1, 0), index_0)), new Long(0, 0))) {
              this.n9_1 = 11;
              var this_1 = this.c57_1.v53_1 + toNumber(fromInt(index_0));
              suspendResult = this.d57_1.oi(this_1 + toNumber(fromInt(64)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 12;
              continue $sm;
            }

          case 11:
            this.n9_1 = 12;
            continue $sm;
          case 12:
            this.n9_1 = 10;
            continue $sm;
          case 13:
            this.n9_1 = 14;
            continue $sm;
          case 14:
            return Unit_instance;
          case 15:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 15) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SnapshotIdSet$iterator$slambda).j57 = function ($this$sequence, completion) {
    var i = new SnapshotIdSet$iterator$slambda(this.c57_1, completion);
    i.d57_1 = $this$sequence;
    return i;
  };
  function SnapshotIdSet$iterator$slambda_0(this$0, resultContinuation) {
    var i = new SnapshotIdSet$iterator$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.i57($this$sequence, $completion);
    }, 1);
  }
  function SnapshotIdSet(upperSet, lowerSet, lowerBound, belowBound) {
    Companion_getInstance_19();
    this.t53_1 = upperSet;
    this.u53_1 = lowerSet;
    this.v53_1 = lowerBound;
    this.w53_1 = belowBound;
  }
  protoOf(SnapshotIdSet).b56 = function (id) {
    // Inline function 'androidx.compose.runtime.snapshots.minus' call
    var offset = id - this.v53_1;
    var tmp;
    var tmp_0;
    // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
    if (compareTo(offset, fromInt(0)) >= 0) {
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      tmp_0 = compareTo(offset, fromInt(64)) < 0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_1 = new Long(1, 0);
      // Inline function 'androidx.compose.runtime.snapshots.toInt' call
      var tmp$ret$3 = numberToInt(offset);
      tmp = !equalsLong(bitwiseAnd(shiftLeft(tmp_1, tmp$ret$3), this.u53_1), new Long(0, 0));
    } else {
      var tmp_2;
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      if (compareTo(offset, fromInt(64)) >= 0) {
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        tmp_2 = compareTo(offset, fromInt(128)) < 0;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        var tmp_3 = new Long(1, 0);
        // Inline function 'androidx.compose.runtime.snapshots.toInt' call
        var tmp$ret$6 = numberToInt(offset);
        tmp = !equalsLong(bitwiseAnd(shiftLeft(tmp_3, tmp$ret$6 - 64 | 0), this.t53_1), new Long(0, 0));
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        if (compareTo(offset, fromInt(0)) > 0) {
          tmp = false;
        } else {
          var tmp0_safe_receiver = this.w53_1;
          var tmp_4;
          if (tmp0_safe_receiver == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_4 = binarySearch(tmp0_safe_receiver, id) >= 0;
          }
          var tmp1_elvis_lhs = tmp_4;
          tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        }
      }
    }
    return tmp;
  };
  protoOf(SnapshotIdSet).h54 = function (id) {
    // Inline function 'androidx.compose.runtime.snapshots.minus' call
    var offset = id - this.v53_1;
    var tmp;
    // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
    if (compareTo(offset, fromInt(0)) >= 0) {
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      tmp = compareTo(offset, fromInt(64)) < 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_0 = new Long(1, 0);
      // Inline function 'androidx.compose.runtime.snapshots.toInt' call
      var tmp$ret$3 = numberToInt(offset);
      var mask = shiftLeft(tmp_0, tmp$ret$3);
      if (equalsLong(bitwiseAnd(this.u53_1, mask), new Long(0, 0))) {
        return new SnapshotIdSet(this.t53_1, bitwiseOr(this.u53_1, mask), this.v53_1, this.w53_1);
      }
    } else {
      var tmp_1;
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      if (compareTo(offset, fromInt(64)) >= 0) {
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        tmp_1 = compareTo(offset, fromInt(128)) < 0;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp_2 = new Long(1, 0);
        // Inline function 'androidx.compose.runtime.snapshots.toInt' call
        var tmp$ret$6 = numberToInt(offset);
        var mask_0 = shiftLeft(tmp_2, tmp$ret$6 - 64 | 0);
        if (equalsLong(bitwiseAnd(this.t53_1, mask_0), new Long(0, 0))) {
          return new SnapshotIdSet(bitwiseOr(this.t53_1, mask_0), this.u53_1, this.v53_1, this.w53_1);
        }
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        if (compareTo(offset, fromInt(128)) >= 0) {
          if (!this.b56(id)) {
            var newUpperSet = this.t53_1;
            var newLowerSet = this.u53_1;
            var newLowerBound = this.v53_1;
            var newBelowBound = null;
            // Inline function 'androidx.compose.runtime.snapshots.plus' call
            // Inline function 'androidx.compose.runtime.snapshots.div' call
            // Inline function 'androidx.compose.runtime.snapshots.times' call
            // Inline function 'kotlin.let' call
            var it = (id + toNumber(fromInt(1))) / toNumber(fromInt(64)) * toNumber(fromInt(64));
            var tmp_3;
            // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
            if (compareTo(it, fromInt(0)) < 0) {
              // Inline function 'androidx.compose.runtime.snapshots.minus' call
              // Inline function 'androidx.compose.runtime.snapshots.plus' call
              tmp_3 = 1.7976931348623157E308 - toNumber(fromInt(128)) + toNumber(fromInt(1));
            } else {
              tmp_3 = it;
            }
            var targetLowerBound = tmp_3;
            $l$loop_0: while (true) {
              // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
              var this_0 = newLowerBound;
              if (!(compareTo(this_0, targetLowerBound) < 0)) {
                break $l$loop_0;
              }
              if (!equalsLong(newLowerSet, new Long(0, 0))) {
                if (newBelowBound == null)
                  newBelowBound = new SnapshotIdArrayBuilder(this.w53_1);
                // Inline function 'kotlin.repeat' call
                var inductionVariable = 0;
                if (inductionVariable < 64)
                  do {
                    var index = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    if (!equalsLong(bitwiseAnd(newLowerSet, shiftLeft(new Long(1, 0), index)), new Long(0, 0))) {
                      var tmp_4 = newBelowBound;
                      // Inline function 'androidx.compose.runtime.snapshots.plus' call
                      var tmp$ret$19 = newLowerBound + toNumber(fromInt(index));
                      tmp_4.l57(tmp$ret$19);
                    }
                  }
                   while (inductionVariable < 64);
              }
              if (equalsLong(newUpperSet, new Long(0, 0))) {
                newLowerBound = targetLowerBound;
                newLowerSet = new Long(0, 0);
                break $l$loop_0;
              }
              newLowerSet = newUpperSet;
              newUpperSet = new Long(0, 0);
              // Inline function 'androidx.compose.runtime.snapshots.plus' call
              newLowerBound = newLowerBound + toNumber(fromInt(64));
            }
            var tmp_5 = newUpperSet;
            var tmp_6 = newLowerSet;
            var tmp_7 = newLowerBound;
            var tmp0_safe_receiver = newBelowBound;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w5();
            return (new SnapshotIdSet(tmp_5, tmp_6, tmp_7, tmp1_elvis_lhs == null ? this.w53_1 : tmp1_elvis_lhs)).h54(id);
          }
        } else {
          var tmp2_elvis_lhs = this.w53_1;
          var tmp_8;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'androidx.compose.runtime.snapshots.snapshotIdArrayOf' call
            // Inline function 'kotlin.doubleArrayOf' call
            var tmp$ret$21 = new Float64Array([id]);
            return new SnapshotIdSet(this.t53_1, this.u53_1, this.v53_1, tmp$ret$21);
          } else {
            tmp_8 = tmp2_elvis_lhs;
          }
          var array = tmp_8;
          var location = binarySearch(array, id);
          if (location < 0) {
            var insertLocation = -(location + 1 | 0) | 0;
            var newBelowBound_0 = withIdInsertedAt(array, insertLocation, id);
            return new SnapshotIdSet(this.t53_1, this.u53_1, this.v53_1, newBelowBound_0);
          }
        }
      }
    }
    return this;
  };
  protoOf(SnapshotIdSet).x53 = function (id) {
    // Inline function 'androidx.compose.runtime.snapshots.minus' call
    var offset = id - this.v53_1;
    var tmp;
    // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
    if (compareTo(offset, fromInt(0)) >= 0) {
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      tmp = compareTo(offset, fromInt(64)) < 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_0 = new Long(1, 0);
      // Inline function 'androidx.compose.runtime.snapshots.toInt' call
      var tmp$ret$3 = numberToInt(offset);
      var mask = shiftLeft(tmp_0, tmp$ret$3);
      if (!equalsLong(bitwiseAnd(this.u53_1, mask), new Long(0, 0))) {
        return new SnapshotIdSet(this.t53_1, bitwiseAnd(this.u53_1, invert(mask)), this.v53_1, this.w53_1);
      }
    } else {
      var tmp_1;
      // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
      if (compareTo(offset, fromInt(64)) >= 0) {
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        tmp_1 = compareTo(offset, fromInt(128)) < 0;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp_2 = new Long(1, 0);
        // Inline function 'androidx.compose.runtime.snapshots.toInt' call
        var tmp$ret$6 = numberToInt(offset);
        var mask_0 = shiftLeft(tmp_2, tmp$ret$6 - 64 | 0);
        if (!equalsLong(bitwiseAnd(this.t53_1, mask_0), new Long(0, 0))) {
          return new SnapshotIdSet(bitwiseAnd(this.t53_1, invert(mask_0)), this.u53_1, this.v53_1, this.w53_1);
        }
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.compareTo' call
        if (compareTo(offset, fromInt(0)) < 0) {
          var array = this.w53_1;
          if (!(array == null)) {
            var location = binarySearch(array, id);
            if (location >= 0) {
              return new SnapshotIdSet(this.t53_1, this.u53_1, this.v53_1, withIdRemovedAt(array, location));
            }
          }
        }
      }
    }
    return this;
  };
  protoOf(SnapshotIdSet).k54 = function (ids) {
    if (ids === Companion_getInstance_19().d54_1)
      return this;
    if (this === Companion_getInstance_19().d54_1)
      return Companion_getInstance_19().d54_1;
    var tmp;
    if (equals(ids.v53_1, this.v53_1) && ids.w53_1 === this.w53_1) {
      tmp = new SnapshotIdSet(bitwiseAnd(this.t53_1, invert(ids.t53_1)), bitwiseAnd(this.u53_1, invert(ids.u53_1)), this.v53_1, this.w53_1);
    } else {
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotIdSet.fastFold' call
      var accumulator = this;
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotIdSet.fastForEach' call
      var tmp0_safe_receiver = access$_get_belowBound__uc78e(ids);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'androidx.compose.runtime.snapshots.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var value = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          accumulator = accumulator.x53(value);
        }
      }
      if (!equalsLong(access$_get_lowerSet__9mjss6(ids), new Long(0, 0))) {
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 64)
          do {
            var index = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!equalsLong(bitwiseAnd(access$_get_lowerSet__9mjss6(ids), shiftLeft(new Long(1, 0), index)), new Long(0, 0))) {
              // Inline function 'androidx.compose.runtime.snapshots.plus' call
              var element = access$_get_lowerBound__ou44uq(ids) + toNumber(fromInt(index));
              accumulator = accumulator.x53(element);
            }
          }
           while (inductionVariable_0 < 64);
      }
      if (!equalsLong(access$_get_upperSet__2kurhn(ids), new Long(0, 0))) {
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 64)
          do {
            var index_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            if (!equalsLong(bitwiseAnd(access$_get_upperSet__2kurhn(ids), shiftLeft(new Long(1, 0), index_0)), new Long(0, 0))) {
              // Inline function 'androidx.compose.runtime.snapshots.plus' call
              // Inline function 'androidx.compose.runtime.snapshots.plus' call
              var element_0 = access$_get_lowerBound__ou44uq(ids) + toNumber(fromInt(index_0)) + toNumber(fromInt(64));
              accumulator = accumulator.x53(element_0);
            }
          }
           while (inductionVariable_1 < 64);
      }
      tmp = accumulator;
    }
    return tmp;
  };
  protoOf(SnapshotIdSet).l54 = function (bits) {
    if (bits === Companion_getInstance_19().d54_1)
      return this;
    if (this === Companion_getInstance_19().d54_1)
      return bits;
    var tmp;
    if (equals(bits.v53_1, this.v53_1) && bits.w53_1 === this.w53_1) {
      tmp = new SnapshotIdSet(bitwiseOr(this.t53_1, bits.t53_1), bitwiseOr(this.u53_1, bits.u53_1), this.v53_1, this.w53_1);
    } else {
      var tmp_0;
      if (this.w53_1 == null) {
        // Inline function 'androidx.compose.runtime.snapshots.SnapshotIdSet.fastFold' call
        var accumulator = bits;
        // Inline function 'androidx.compose.runtime.snapshots.SnapshotIdSet.fastForEach' call
        var tmp0_safe_receiver = access$_get_belowBound__uc78e(this);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'androidx.compose.runtime.snapshots.forEach' call
          var inductionVariable = 0;
          var last = tmp0_safe_receiver.length;
          while (inductionVariable < last) {
            var value = tmp0_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            accumulator = accumulator.h54(value);
          }
        }
        if (!equalsLong(access$_get_lowerSet__9mjss6(this), new Long(0, 0))) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < 64)
            do {
              var index = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (!equalsLong(bitwiseAnd(access$_get_lowerSet__9mjss6(this), shiftLeft(new Long(1, 0), index)), new Long(0, 0))) {
                // Inline function 'androidx.compose.runtime.snapshots.plus' call
                var element = access$_get_lowerBound__ou44uq(this) + toNumber(fromInt(index));
                accumulator = accumulator.h54(element);
              }
            }
             while (inductionVariable_0 < 64);
        }
        if (!equalsLong(access$_get_upperSet__2kurhn(this), new Long(0, 0))) {
          var inductionVariable_1 = 0;
          if (inductionVariable_1 < 64)
            do {
              var index_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              if (!equalsLong(bitwiseAnd(access$_get_upperSet__2kurhn(this), shiftLeft(new Long(1, 0), index_0)), new Long(0, 0))) {
                // Inline function 'androidx.compose.runtime.snapshots.plus' call
                // Inline function 'androidx.compose.runtime.snapshots.plus' call
                var element_0 = access$_get_lowerBound__ou44uq(this) + toNumber(fromInt(index_0)) + toNumber(fromInt(64));
                accumulator = accumulator.h54(element_0);
              }
            }
             while (inductionVariable_1 < 64);
        }
        tmp_0 = accumulator;
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.SnapshotIdSet.fastFold' call
        var accumulator_0 = this;
        // Inline function 'androidx.compose.runtime.snapshots.SnapshotIdSet.fastForEach' call
        var tmp0_safe_receiver_0 = access$_get_belowBound__uc78e(bits);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'androidx.compose.runtime.snapshots.forEach' call
          var inductionVariable_2 = 0;
          var last_0 = tmp0_safe_receiver_0.length;
          while (inductionVariable_2 < last_0) {
            var value_0 = tmp0_safe_receiver_0[inductionVariable_2];
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            accumulator_0 = accumulator_0.h54(value_0);
          }
        }
        if (!equalsLong(access$_get_lowerSet__9mjss6(bits), new Long(0, 0))) {
          var inductionVariable_3 = 0;
          if (inductionVariable_3 < 64)
            do {
              var index_1 = inductionVariable_3;
              inductionVariable_3 = inductionVariable_3 + 1 | 0;
              if (!equalsLong(bitwiseAnd(access$_get_lowerSet__9mjss6(bits), shiftLeft(new Long(1, 0), index_1)), new Long(0, 0))) {
                // Inline function 'androidx.compose.runtime.snapshots.plus' call
                var element_1 = access$_get_lowerBound__ou44uq(bits) + toNumber(fromInt(index_1));
                accumulator_0 = accumulator_0.h54(element_1);
              }
            }
             while (inductionVariable_3 < 64);
        }
        if (!equalsLong(access$_get_upperSet__2kurhn(bits), new Long(0, 0))) {
          var inductionVariable_4 = 0;
          if (inductionVariable_4 < 64)
            do {
              var index_2 = inductionVariable_4;
              inductionVariable_4 = inductionVariable_4 + 1 | 0;
              if (!equalsLong(bitwiseAnd(access$_get_upperSet__2kurhn(bits), shiftLeft(new Long(1, 0), index_2)), new Long(0, 0))) {
                // Inline function 'androidx.compose.runtime.snapshots.plus' call
                // Inline function 'androidx.compose.runtime.snapshots.plus' call
                var element_2 = access$_get_lowerBound__ou44uq(bits) + toNumber(fromInt(index_2)) + toNumber(fromInt(64));
                accumulator_0 = accumulator_0.h54(element_2);
              }
            }
             while (inductionVariable_4 < 64);
        }
        tmp_0 = accumulator_0;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(SnapshotIdSet).t = function () {
    return sequence(SnapshotIdSet$iterator$slambda_0(this, null)).t();
  };
  protoOf(SnapshotIdSet).f55 = function (default_0) {
    var belowBound = this.w53_1;
    if (!(belowBound == null)) {
      // Inline function 'androidx.compose.runtime.snapshots.first' call
      return belowBound[0];
    }
    if (!equalsLong(this.u53_1, new Long(0, 0))) {
      var tmp0 = this.v53_1;
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var other = countTrailingZeroBits(this.u53_1);
      return tmp0 + toNumber(fromInt(other));
    }
    if (!equalsLong(this.t53_1, new Long(0, 0))) {
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var tmp0_0 = this.v53_1 + toNumber(fromInt(64));
      // Inline function 'androidx.compose.runtime.snapshots.plus' call
      var other_0 = countTrailingZeroBits(this.t53_1);
      return tmp0_0 + toNumber(fromInt(other_0));
    }
    return default_0;
  };
  protoOf(SnapshotIdSet).toString = function () {
    var tmp = anyToString(this);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this, 10));
    var _iterator__ex2g4s = this.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = item.toString();
      destination.j1(tmp$ret$2);
    }
    return tmp + ' [' + fastJoinToString(destination) + ']';
  };
  function SnapshotMutableState() {
  }
  function get_sync() {
    _init_properties_SnapshotStateList_kt__mu1ud5();
    return sync;
  }
  var sync;
  var androidx_compose_runtime_snapshots_StateListStateRecord$stable;
  var androidx_compose_runtime_snapshots_StateListIterator$stable;
  var androidx_compose_runtime_snapshots_SubList$stable;
  function stateRecordWith(_this__u8e3s4, list) {
    _init_properties_SnapshotStateList_kt__mu1ud5();
    var snapshot = currentSnapshot();
    // Inline function 'kotlin.also' call
    var this_0 = new StateListStateRecord(snapshot.w3d(), list);
    if (!(snapshot instanceof GlobalSnapshot)) {
      this_0.m3e_1 = new StateListStateRecord(toSnapshotId(1), list);
    }
    return this_0;
  }
  function StateListStateRecord(snapshotId, list) {
    StateRecord.call(this, snapshotId);
    this.o57_1 = list;
    this.p57_1 = 0;
    this.q57_1 = 0;
  }
  protoOf(StateListStateRecord).q3d = function (value) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_sync();
    var tmp = this;
    tmp.o57_1 = (value instanceof StateListStateRecord ? value : THROW_CCE()).o57_1;
    this.p57_1 = value.p57_1;
    this.q57_1 = value.q57_1;
  };
  protoOf(StateListStateRecord).r3d = function () {
    return this.x3d(currentSnapshot().w3d());
  };
  protoOf(StateListStateRecord).x3d = function (snapshotId) {
    return new StateListStateRecord(snapshotId, this.o57_1);
  };
  function get_readable(_this__u8e3s4) {
    _init_properties_SnapshotStateList_kt__mu1ud5();
    var tmp = _this__u8e3s4.r49_1;
    return readable_0(tmp instanceof StateListStateRecord ? tmp : THROW_CCE(), _this__u8e3s4);
  }
  function validateModification($this) {
    if (!(get_structure($this.r57_1) === $this.u57_1)) {
      throw ConcurrentModificationException_init_$Create$();
    }
  }
  function StateListIterator(list, offset) {
    this.r57_1 = list;
    this.s57_1 = offset - 1 | 0;
    this.t57_1 = -1;
    this.u57_1 = get_structure(this.r57_1);
  }
  protoOf(StateListIterator).v4 = function () {
    return this.s57_1 >= 0;
  };
  protoOf(StateListIterator).w4 = function () {
    return this.s57_1 + 1 | 0;
  };
  protoOf(StateListIterator).x4 = function () {
    validateModification(this);
    validateRange(this.s57_1, this.r57_1.n1());
    this.t57_1 = this.s57_1;
    // Inline function 'kotlin.also' call
    var this_0 = this.r57_1.l1(this.s57_1);
    this.s57_1 = this.s57_1 - 1 | 0;
    return this_0;
  };
  protoOf(StateListIterator).y4 = function () {
    return this.s57_1;
  };
  protoOf(StateListIterator).u = function () {
    return this.s57_1 < (this.r57_1.n1() - 1 | 0);
  };
  protoOf(StateListIterator).v = function () {
    validateModification(this);
    var newIndex = this.s57_1 + 1 | 0;
    this.t57_1 = newIndex;
    validateRange(newIndex, this.r57_1.n1());
    // Inline function 'kotlin.also' call
    var this_0 = this.r57_1.l1(newIndex);
    this.s57_1 = newIndex;
    return this_0;
  };
  protoOf(StateListIterator).l4 = function () {
    validateModification(this);
    this.r57_1.h3(this.t57_1);
    this.s57_1 = this.s57_1 - 1 | 0;
    this.t57_1 = -1;
    this.u57_1 = get_structure(this.r57_1);
  };
  function validateModification_0($this) {
    if (!(get_structure($this.v57_1) === $this.x57_1)) {
      throw ConcurrentModificationException_init_$Create$();
    }
  }
  function SubList$listIterator$1($current, this$0) {
    this.z57_1 = $current;
    this.a58_1 = this$0;
  }
  protoOf(SubList$listIterator$1).v4 = function () {
    return this.z57_1._v >= 0;
  };
  protoOf(SubList$listIterator$1).w4 = function () {
    return this.z57_1._v + 1 | 0;
  };
  protoOf(SubList$listIterator$1).x4 = function () {
    var oldCurrent = this.z57_1._v;
    validateRange(oldCurrent, this.a58_1.y57_1);
    this.z57_1._v = oldCurrent - 1 | 0;
    return this.a58_1.l1(oldCurrent);
  };
  protoOf(SubList$listIterator$1).y4 = function () {
    return this.z57_1._v;
  };
  protoOf(SubList$listIterator$1).u = function () {
    return this.z57_1._v < (this.a58_1.y57_1 - 1 | 0);
  };
  protoOf(SubList$listIterator$1).v = function () {
    var newCurrent = this.z57_1._v + 1 | 0;
    validateRange(newCurrent, this.a58_1.y57_1);
    this.z57_1._v = newCurrent;
    return this.a58_1.l1(newCurrent);
  };
  protoOf(SubList$listIterator$1).h1g = function () {
    modificationError();
  };
  protoOf(SubList$listIterator$1).l4 = function () {
    return this.h1g();
  };
  function SubList_1(parentList, fromIndex, toIndex) {
    this.v57_1 = parentList;
    this.w57_1 = fromIndex;
    this.x57_1 = get_structure(this.v57_1);
    this.y57_1 = toIndex - fromIndex | 0;
  }
  protoOf(SubList_1).n1 = function () {
    return this.y57_1;
  };
  protoOf(SubList_1).lh = function (element) {
    return this.yz(element) >= 0;
  };
  protoOf(SubList_1).m1 = function (element) {
    if (!true)
      return false;
    return this.lh(element);
  };
  protoOf(SubList_1).mh = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!this.lh(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SubList_1).r2 = function (elements) {
    return this.mh(elements);
  };
  protoOf(SubList_1).l1 = function (index) {
    validateModification_0(this);
    validateRange(index, this.y57_1);
    return this.v57_1.l1(this.w57_1 + index | 0);
  };
  protoOf(SubList_1).yz = function (element) {
    validateModification_0(this);
    // Inline function 'kotlin.collections.forEach' call
    var progression = until(this.w57_1, this.w57_1 + this.y57_1 | 0);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    if (inductionVariable <= last)
      do {
        var element_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = element_0;
        if (equals(element, this.v57_1.l1(it)))
          return it - this.w57_1 | 0;
      }
       while (!(element_0 === last));
    return -1;
  };
  protoOf(SubList_1).q1 = function (element) {
    if (!true)
      return -1;
    return this.yz(element);
  };
  protoOf(SubList_1).r = function () {
    return this.y57_1 === 0;
  };
  protoOf(SubList_1).t = function () {
    return this.s2();
  };
  protoOf(SubList_1).zz = function (element) {
    validateModification_0(this);
    this.v57_1.ni(this.w57_1 + this.y57_1 | 0, element);
    this.y57_1 = this.y57_1 + 1 | 0;
    this.x57_1 = get_structure(this.v57_1);
    return true;
  };
  protoOf(SubList_1).j1 = function (element) {
    return this.zz(element);
  };
  protoOf(SubList_1).ni = function (index, element) {
    validateModification_0(this);
    this.v57_1.ni(this.w57_1 + index | 0, element);
    this.y57_1 = this.y57_1 + 1 | 0;
    this.x57_1 = get_structure(this.v57_1);
  };
  protoOf(SubList_1).g3 = function (index, element) {
    return this.ni(index, element);
  };
  protoOf(SubList_1).d10 = function (index, elements) {
    validateModification_0(this);
    var result = this.v57_1.d10(index + this.w57_1 | 0, elements);
    if (result) {
      this.y57_1 = this.y57_1 + elements.n1() | 0;
      this.x57_1 = get_structure(this.v57_1);
    }
    return result;
  };
  protoOf(SubList_1).e3 = function (index, elements) {
    return this.d10(index, elements);
  };
  protoOf(SubList_1).e10 = function (elements) {
    return this.d10(this.y57_1, elements);
  };
  protoOf(SubList_1).o1 = function (elements) {
    return this.e10(elements);
  };
  protoOf(SubList_1).c3 = function () {
    if (this.y57_1 > 0) {
      validateModification_0(this);
      this.v57_1.e5(this.w57_1, this.w57_1 + this.y57_1 | 0);
      this.y57_1 = 0;
      this.x57_1 = get_structure(this.v57_1);
    }
  };
  protoOf(SubList_1).s2 = function () {
    return this.p1(0);
  };
  protoOf(SubList_1).p1 = function (index) {
    validateModification_0(this);
    var current = {_v: index - 1 | 0};
    return new SubList$listIterator$1(current, this);
  };
  protoOf(SubList_1).g10 = function (element) {
    var index = this.yz(element);
    var tmp;
    if (index >= 0) {
      this.h3(index);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SubList_1).d3 = function (element) {
    if (!true)
      return false;
    return this.g10(element);
  };
  protoOf(SubList_1).h3 = function (index) {
    validateModification_0(this);
    // Inline function 'kotlin.also' call
    var this_0 = this.v57_1.h3(this.w57_1 + index | 0);
    this.y57_1 = this.y57_1 - 1 | 0;
    this.x57_1 = get_structure(this.v57_1);
    return this_0;
  };
  protoOf(SubList_1).mi = function (index, element) {
    validateRange(index, this.y57_1);
    validateModification_0(this);
    var result = this.v57_1.mi(index + this.w57_1 | 0, element);
    this.x57_1 = get_structure(this.v57_1);
    return result;
  };
  protoOf(SubList_1).f3 = function (index, element) {
    return this.mi(index, element);
  };
  protoOf(SubList_1).t2 = function (fromIndex, toIndex) {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!((0 <= fromIndex ? fromIndex <= toIndex : false) && toIndex <= this.y57_1)) {
      var tmp$ret$1 = 'fromIndex or toIndex are out of bounds';
      throwIllegalArgumentException(tmp$ret$1);
    }
    validateModification_0(this);
    return new SubList_1(this.v57_1, fromIndex + this.w57_1 | 0, toIndex + this.w57_1 | 0);
  };
  function mutateBoolean(_this__u8e3s4, block) {
    _init_properties_SnapshotStateList_kt__mu1ud5();
    // Inline function 'androidx.compose.runtime.snapshots.mutate' call
    var result;
    $l$loop: while (true) {
      var oldList = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      access$_get_sync_$tSnapshotStateListKt_vydypg();
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var tmp = _this__u8e3s4.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      currentModification = current.p57_1;
      oldList = current.o57_1;
      var builder = ensureNotNull(oldList).a3d();
      result = block(builder);
      var newList = builder.g3d();
      var tmp_0;
      if (equals(newList, oldList)) {
        tmp_0 = true;
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.writable' call
        var tmp_1 = _this__u8e3s4.r49_1;
        // Inline function 'androidx.compose.runtime.snapshots.writable' call
        var this_1 = tmp_1 instanceof StateListStateRecord ? tmp_1 : THROW_CCE();
        var snapshot;
        // Inline function 'androidx.compose.runtime.snapshots.sync' call
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        get_lock();
        snapshot = Companion_instance_18.e2y();
        var $this$writable = writableRecord(this_1, _this__u8e3s4, snapshot);
        // Inline function 'kotlin.also' call
        var this_2 = attemptUpdate($this$writable, currentModification, newList, true);
        notifyWrite(snapshot, _this__u8e3s4);
        tmp_0 = this_2;
      }
      if (tmp_0)
        break $l$loop;
    }
    return result;
  }
  function get_structure(_this__u8e3s4) {
    _init_properties_SnapshotStateList_kt__mu1ud5();
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var tmp = _this__u8e3s4.r49_1;
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    return current_0(this_0).q57_1;
  }
  function validateRange(index, size) {
    _init_properties_SnapshotStateList_kt__mu1ud5();
    if (!(0 <= index ? index < size : false)) {
      throw IndexOutOfBoundsException_init_$Create$('index (' + index + ') is out of bound of [0, ' + size + ')');
    }
  }
  function modificationError() {
    _init_properties_SnapshotStateList_kt__mu1ud5();
    // Inline function 'kotlin.error' call
    var message = 'Cannot modify a state list through an iterator';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function attemptUpdate(_this__u8e3s4, currentModification, newList, structural) {
    _init_properties_SnapshotStateList_kt__mu1ud5();
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_sync();
    var tmp;
    if (_this__u8e3s4.p57_1 === currentModification) {
      _this__u8e3s4.o57_1 = newList;
      if (structural) {
        _this__u8e3s4.q57_1 = _this__u8e3s4.q57_1 + 1 | 0;
      }
      _this__u8e3s4.p57_1 = _this__u8e3s4.p57_1 + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function access$_get_sync_$tSnapshotStateListKt_vydypg() {
    return get_sync();
  }
  var properties_initialized_SnapshotStateList_kt_lcuarf;
  function _init_properties_SnapshotStateList_kt__mu1ud5() {
    if (!properties_initialized_SnapshotStateList_kt_lcuarf) {
      properties_initialized_SnapshotStateList_kt_lcuarf = true;
      // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
      sync = null == null ? new Object() : null;
      androidx_compose_runtime_snapshots_StateListStateRecord$stable = 8;
      androidx_compose_runtime_snapshots_StateListIterator$stable = 8;
      androidx_compose_runtime_snapshots_SubList$stable = 8;
    }
  }
  function get_sync_0() {
    _init_properties_SnapshotStateMap_kt__p43o8h();
    return sync_0;
  }
  var sync_0;
  var androidx_compose_runtime_snapshots_SnapshotStateMap_StateMapStateRecord$stable;
  var androidx_compose_runtime_snapshots_SnapshotStateMap$stable;
  function attemptUpdate_0($this, $receiver, currentModification, newMap) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_sync_0();
    var tmp;
    if ($receiver.e58_1 === currentModification) {
      $receiver.d58_1 = newMap;
      $receiver.e58_1 = $receiver.e58_1 + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function commitUpdate($this, $receiver, newMap) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_sync_0();
    $receiver.d58_1 = newMap;
    var _unary__edvuaz = $receiver.e58_1;
    $receiver.e58_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  function StateMapStateRecord(snapshotId, map) {
    StateRecord.call(this, snapshotId);
    this.d58_1 = map;
    this.e58_1 = 0;
  }
  protoOf(StateMapStateRecord).q3d = function (value) {
    var other = value instanceof StateMapStateRecord ? value : THROW_CCE();
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_sync_0();
    this.d58_1 = other.d58_1;
    this.e58_1 = other.e58_1;
  };
  protoOf(StateMapStateRecord).r3d = function () {
    return new StateMapStateRecord(currentSnapshot().w3d(), this.d58_1);
  };
  protoOf(StateMapStateRecord).x3d = function (snapshotId) {
    return new StateMapStateRecord(snapshotId, this.d58_1);
  };
  function SnapshotStateMap() {
    var tmp = this;
    // Inline function 'kotlin.let' call
    var map = persistentHashMapOf();
    var snapshot = currentSnapshot();
    // Inline function 'kotlin.also' call
    var this_0 = new StateMapStateRecord(snapshot.w3d(), map);
    if (!(snapshot instanceof GlobalSnapshot)) {
      this_0.m3e_1 = new StateMapStateRecord(toSnapshotId(1), map);
    }
    tmp.f58_1 = this_0;
    this.g58_1 = new SnapshotMapEntrySet(this);
    this.h58_1 = new SnapshotMapKeySet(this);
    this.i58_1 = new SnapshotMapValueSet(this);
  }
  protoOf(SnapshotStateMap).f3e = function () {
    return this.f58_1;
  };
  protoOf(SnapshotStateMap).y3e = function (value) {
    var tmp = this;
    tmp.f58_1 = value instanceof StateMapStateRecord ? value : THROW_CCE();
  };
  protoOf(SnapshotStateMap).n1 = function () {
    return this.j58().d58_1.n1();
  };
  protoOf(SnapshotStateMap).u2 = function (key) {
    return this.j58().d58_1.u2(key);
  };
  protoOf(SnapshotStateMap).v2 = function (value) {
    return this.j58().d58_1.v2(value);
  };
  protoOf(SnapshotStateMap).w2 = function (key) {
    return this.j58().d58_1.w2(key);
  };
  protoOf(SnapshotStateMap).r = function () {
    return this.j58().d58_1.r();
  };
  protoOf(SnapshotStateMap).s1 = function () {
    return this.g58_1;
  };
  protoOf(SnapshotStateMap).x2 = function () {
    return this.h58_1;
  };
  protoOf(SnapshotStateMap).y2 = function () {
    return this.i58_1;
  };
  protoOf(SnapshotStateMap).toString = function () {
    var tmp = this.f58_1;
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = tmp instanceof StateMapStateRecord ? tmp : THROW_CCE();
    var it = current_0(this_0);
    return 'SnapshotStateMap(value=' + toString(it.d58_1) + ')@' + hashCode(this);
  };
  protoOf(SnapshotStateMap).c3 = function () {
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.update' call
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.withCurrent' call
    var tmp = this.f58_1;
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = tmp instanceof StateMapStateRecord ? tmp : THROW_CCE();
    var $this$withCurrent = current_0(this_0);
    $this$withCurrent.d58_1;
    var newMap = persistentHashMapOf();
    if (!(newMap === $this$withCurrent.d58_1)) {
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.writable' call
      var tmp_0 = this.f58_1;
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var this_1 = tmp_0 instanceof StateMapStateRecord ? tmp_0 : THROW_CCE();
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      var $this$writable = writableRecord(this_1, this, snapshot);
      // Inline function 'kotlin.also' call
      commitUpdate(this, $this$writable, newMap);
      notifyWrite(snapshot, this);
    }
    return Unit_instance;
  };
  protoOf(SnapshotStateMap).z2 = function (key, value) {
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.mutate' call
    var result;
    $l$loop: while (true) {
      var oldMap = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_sync_0();
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.withCurrent' call
      var tmp = this.f58_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateMapStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      oldMap = current.d58_1;
      currentModification = current.e58_1;
      var builder = ensureNotNull(oldMap).a3d();
      result = builder.z2(key, value);
      var newMap = builder.g3d();
      var tmp_0;
      if (equals(newMap, oldMap)) {
        tmp_0 = true;
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.writable' call
        var tmp_1 = this.f58_1;
        // Inline function 'androidx.compose.runtime.snapshots.writable' call
        var this_1 = tmp_1 instanceof StateMapStateRecord ? tmp_1 : THROW_CCE();
        var snapshot;
        // Inline function 'androidx.compose.runtime.snapshots.sync' call
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        get_lock();
        snapshot = Companion_instance_18.e2y();
        var $this$writable = writableRecord(this_1, this, snapshot);
        // Inline function 'kotlin.also' call
        var this_2 = attemptUpdate_0(this, $this$writable, currentModification, newMap);
        notifyWrite(snapshot, this);
        tmp_0 = this_2;
      }
      if (tmp_0)
        break $l$loop;
    }
    return result;
  };
  protoOf(SnapshotStateMap).b3 = function (from) {
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.mutate' call
    var result;
    $l$loop: while (true) {
      var oldMap = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_sync_0();
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.withCurrent' call
      var tmp = this.f58_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateMapStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      oldMap = current.d58_1;
      currentModification = current.e58_1;
      var builder = ensureNotNull(oldMap).a3d();
      builder.b3(from);
      result = Unit_instance;
      var newMap = builder.g3d();
      var tmp_0;
      if (equals(newMap, oldMap)) {
        tmp_0 = true;
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.writable' call
        var tmp_1 = this.f58_1;
        // Inline function 'androidx.compose.runtime.snapshots.writable' call
        var this_1 = tmp_1 instanceof StateMapStateRecord ? tmp_1 : THROW_CCE();
        var snapshot;
        // Inline function 'androidx.compose.runtime.snapshots.sync' call
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        get_lock();
        snapshot = Companion_instance_18.e2y();
        var $this$writable = writableRecord(this_1, this, snapshot);
        // Inline function 'kotlin.also' call
        var this_2 = attemptUpdate_0(this, $this$writable, currentModification, newMap);
        notifyWrite(snapshot, this);
        tmp_0 = this_2;
      }
      if (tmp_0)
        break $l$loop;
    }
    return Unit_instance;
  };
  protoOf(SnapshotStateMap).a3 = function (key) {
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.mutate' call
    var result;
    $l$loop: while (true) {
      var oldMap = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_sync_0();
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.withCurrent' call
      var tmp = this.f58_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateMapStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      oldMap = current.d58_1;
      currentModification = current.e58_1;
      var builder = ensureNotNull(oldMap).a3d();
      result = builder.a3(key);
      var newMap = builder.g3d();
      var tmp_0;
      if (equals(newMap, oldMap)) {
        tmp_0 = true;
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateMap.writable' call
        var tmp_1 = this.f58_1;
        // Inline function 'androidx.compose.runtime.snapshots.writable' call
        var this_1 = tmp_1 instanceof StateMapStateRecord ? tmp_1 : THROW_CCE();
        var snapshot;
        // Inline function 'androidx.compose.runtime.snapshots.sync' call
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        get_lock();
        snapshot = Companion_instance_18.e2y();
        var $this$writable = writableRecord(this_1, this, snapshot);
        // Inline function 'kotlin.also' call
        var this_2 = attemptUpdate_0(this, $this$writable, currentModification, newMap);
        notifyWrite(snapshot, this);
        tmp_0 = this_2;
      }
      if (tmp_0)
        break $l$loop;
    }
    return result;
  };
  protoOf(SnapshotStateMap).k58 = function () {
    return this.j58().e58_1;
  };
  protoOf(SnapshotStateMap).l58 = function (value) {
    var tmp0 = this.g58_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (equals(element.u1(), value)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      this.a3(tmp0_safe_receiver.t1());
      tmp = true;
    }
    return tmp === true;
  };
  protoOf(SnapshotStateMap).j58 = function () {
    var tmp = this.f58_1;
    return readable_0(tmp instanceof StateMapStateRecord ? tmp : THROW_CCE(), this);
  };
  function unsupported() {
    _init_properties_SnapshotStateMap_kt__p43o8h();
    throw UnsupportedOperationException_init_$Create$();
  }
  function SnapshotMapEntrySet(map) {
    SnapshotMapSet.call(this, map);
  }
  protoOf(SnapshotMapEntrySet).h4z = function (element) {
    unsupported();
  };
  protoOf(SnapshotMapEntrySet).j1 = function (element) {
    return this.h4z((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(SnapshotMapEntrySet).n58 = function (elements) {
    unsupported();
  };
  protoOf(SnapshotMapEntrySet).o1 = function (elements) {
    return this.n58(elements);
  };
  protoOf(SnapshotMapEntrySet).t = function () {
    return new StateMapMutableEntriesIterator(this.o58_1, this.o58_1.j58().d58_1.s1().t());
  };
  protoOf(SnapshotMapEntrySet).p58 = function (element) {
    return !(this.o58_1.a3(element.t1()) == null);
  };
  protoOf(SnapshotMapEntrySet).d3 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    return this.p58((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(SnapshotMapEntrySet).q58 = function (element) {
    return equals(this.o58_1.w2(element.t1()), element.u1());
  };
  protoOf(SnapshotMapEntrySet).m1 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    return this.q58((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(SnapshotMapEntrySet).r58 = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!this.q58(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SnapshotMapEntrySet).r2 = function (elements) {
    return this.r58(elements);
  };
  function SnapshotMapKeySet(map) {
    SnapshotMapSet.call(this, map);
  }
  protoOf(SnapshotMapKeySet).a7 = function (element) {
    unsupported();
  };
  protoOf(SnapshotMapKeySet).j1 = function (element) {
    return this.a7(element);
  };
  protoOf(SnapshotMapKeySet).t58 = function (elements) {
    unsupported();
  };
  protoOf(SnapshotMapKeySet).o1 = function (elements) {
    return this.t58(elements);
  };
  protoOf(SnapshotMapKeySet).t = function () {
    return new StateMapMutableKeysIterator(this.o58_1, this.o58_1.j58().d58_1.s1().t());
  };
  protoOf(SnapshotMapKeySet).a3 = function (element) {
    return !(this.o58_1.a3(element) == null);
  };
  protoOf(SnapshotMapKeySet).d3 = function (element) {
    if (!true)
      return false;
    return this.a3(element);
  };
  protoOf(SnapshotMapKeySet).d6 = function (element) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.o58_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(element);
  };
  protoOf(SnapshotMapKeySet).m1 = function (element) {
    if (!true)
      return false;
    return this.d6(element);
  };
  protoOf(SnapshotMapKeySet).j15 = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_0 = this.o58_1;
        if (!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SnapshotMapKeySet).r2 = function (elements) {
    return this.j15(elements);
  };
  function SnapshotMapValueSet(map) {
    SnapshotMapSet.call(this, map);
  }
  protoOf(SnapshotMapValueSet).k6 = function (element) {
    unsupported();
  };
  protoOf(SnapshotMapValueSet).j1 = function (element) {
    return this.k6(element);
  };
  protoOf(SnapshotMapValueSet).l6 = function (elements) {
    unsupported();
  };
  protoOf(SnapshotMapValueSet).o1 = function (elements) {
    return this.l6(elements);
  };
  protoOf(SnapshotMapValueSet).t = function () {
    return new StateMapMutableValuesIterator(this.o58_1, this.o58_1.j58().d58_1.s1().t());
  };
  protoOf(SnapshotMapValueSet).n6 = function (element) {
    return this.o58_1.l58(element);
  };
  protoOf(SnapshotMapValueSet).d3 = function (element) {
    if (!true)
      return false;
    return this.n6(element);
  };
  protoOf(SnapshotMapValueSet).j6 = function (element) {
    return this.o58_1.v2(element);
  };
  protoOf(SnapshotMapValueSet).m1 = function (element) {
    if (!true)
      return false;
    return this.j6(element);
  };
  protoOf(SnapshotMapValueSet).g16 = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!this.o58_1.v2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SnapshotMapValueSet).r2 = function (elements) {
    return this.g16(elements);
  };
  function SnapshotMapSet(map) {
    this.o58_1 = map;
  }
  protoOf(SnapshotMapSet).n1 = function () {
    return this.o58_1.n1();
  };
  protoOf(SnapshotMapSet).c3 = function () {
    return this.o58_1.c3();
  };
  protoOf(SnapshotMapSet).r = function () {
    return this.o58_1.r();
  };
  function StateMapMutableEntriesIterator$next$1(this$0) {
    this.x58_1 = this$0;
    this.v58_1 = ensureNotNull(this$0.b59_1).t1();
    this.w58_1 = ensureNotNull(this$0.b59_1).u1();
  }
  protoOf(StateMapMutableEntriesIterator$next$1).t1 = function () {
    return this.v58_1;
  };
  protoOf(StateMapMutableEntriesIterator$next$1).u1 = function () {
    return this.w58_1;
  };
  function StateMapMutableEntriesIterator(map, iterator) {
    StateMapMutableIterator.call(this, map, iterator);
  }
  protoOf(StateMapMutableEntriesIterator).v = function () {
    this.i59();
    if (!(this.b59_1 == null)) {
      return new StateMapMutableEntriesIterator$next$1(this);
    } else {
      throw IllegalStateException_init_$Create$_0();
    }
  };
  function StateMapMutableKeysIterator(map, iterator) {
    StateMapMutableIterator.call(this, map, iterator);
  }
  protoOf(StateMapMutableKeysIterator).v = function () {
    var tmp0_elvis_lhs = this.c59_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    this.i59();
    return result.t1();
  };
  function StateMapMutableValuesIterator(map, iterator) {
    StateMapMutableIterator.call(this, map, iterator);
  }
  protoOf(StateMapMutableValuesIterator).v = function () {
    var tmp0_elvis_lhs = this.c59_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    this.i59();
    return result.u1();
  };
  function StateMapMutableIterator(map, iterator) {
    this.y58_1 = map;
    this.z58_1 = iterator;
    this.a59_1 = this.y58_1.k58();
    this.b59_1 = null;
    this.c59_1 = null;
    this.i59();
  }
  protoOf(StateMapMutableIterator).l4 = function () {
    // Inline function 'androidx.compose.runtime.snapshots.StateMapMutableIterator.modify' call
    if (!(this.y58_1.k58() === this.a59_1)) {
      throw ConcurrentModificationException_init_$Create$();
    }
    var value = this.b59_1;
    if (!(value == null)) {
      this.y58_1.a3(value.t1());
      this.b59_1 = null;
    } else {
      throw IllegalStateException_init_$Create$_0();
    }
    // Inline function 'kotlin.also' call
    this.a59_1 = this.y58_1.k58();
    return Unit_instance;
  };
  protoOf(StateMapMutableIterator).u = function () {
    return !(this.c59_1 == null);
  };
  protoOf(StateMapMutableIterator).i59 = function () {
    this.b59_1 = this.c59_1;
    this.c59_1 = this.z58_1.u() ? this.z58_1.v() : null;
  };
  var properties_initialized_SnapshotStateMap_kt_9i73ip;
  function _init_properties_SnapshotStateMap_kt__p43o8h() {
    if (!properties_initialized_SnapshotStateMap_kt_9i73ip) {
      properties_initialized_SnapshotStateMap_kt_9i73ip = true;
      // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
      sync_0 = null == null ? new Object() : null;
      androidx_compose_runtime_snapshots_SnapshotStateMap_StateMapStateRecord$stable = 8;
      androidx_compose_runtime_snapshots_SnapshotStateMap$stable = 0;
    }
  }
  var androidx_compose_runtime_snapshots_SnapshotStateObserver$stable;
  function recordRead($this, value, currentToken, currentScope, recordedValues) {
    if ($this.d5a_1 > 0) {
      return Unit_instance;
    }
    var previousToken = recordedValues.pz(value, currentToken, -1);
    var tmp;
    if (isInterface(value, DerivedState)) {
      tmp = !(previousToken === currentToken);
    } else {
      tmp = false;
    }
    if (tmp) {
      var record = value.g3a();
      var tmp0 = $this.f5a_1;
      // Inline function 'kotlin.collections.set' call
      var value_0 = record.i3a();
      tmp0.z2(value, value_0);
      var dependencies = record.h3a();
      var dependencyToDerivedStates = $this.e5a_1;
      ScopeMap__removeScope_impl_8k6ux1(dependencyToDerivedStates, value);
      // Inline function 'androidx.collection.ObjectIntMap.forEachKey' call
      var k = dependencies.ez_1;
      $l$block: {
        // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
        var m = dependencies.dz_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_0 = slot;
            var tmp$ret$3 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$3, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_1 = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value_1, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var dependency = k[index];
                    if (dependency instanceof StateObjectImpl) {
                      // Inline function 'androidx.compose.runtime.snapshots.Companion.SnapshotStateObserver' call
                      var tmp$ret$7 = _ReaderKind___init__impl__jqeebu(2);
                      dependency.f3a(tmp$ret$7);
                    }
                    ScopeMap__add_impl_n8b3uc(dependencyToDerivedStates, dependency, value);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
    if (previousToken === -1) {
      if (value instanceof StateObjectImpl) {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.SnapshotStateObserver' call
        var tmp$ret$8 = _ReaderKind___init__impl__jqeebu(2);
        value.f3a(tmp$ret$8);
      }
      ScopeMap__add_impl_n8b3uc($this.x59_1, value, currentScope);
    }
  }
  function clearObsoleteStateReads($this, scope) {
    var currentToken = $this.w59_1;
    var tmp0_safe_receiver = $this.v59_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.collection.MutableObjectIntMap.removeIf' call
      $l$block: {
        // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
        var m = tmp0_safe_receiver.dz_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_0 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var tmp0 = tmp0_safe_receiver.ez_1[index];
                    // Inline function 'kotlin.also' call
                    var this_1 = !(tmp0_safe_receiver.fz_1[index] === currentToken);
                    if (this_1) {
                      removeObservation($this, scope, tmp0);
                    }
                    if (this_1) {
                      tmp0_safe_receiver.cv(index);
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
  }
  function removeObservation($this, scope, value) {
    ScopeMap__remove_impl_ocu4rj_0($this.x59_1, value, scope);
    var tmp;
    if (isInterface(value, DerivedState)) {
      tmp = !ScopeMap__contains_impl_6qp7s6($this.x59_1, value);
    } else {
      tmp = false;
    }
    if (tmp) {
      ScopeMap__removeScope_impl_8k6ux1($this.e5a_1, value);
      $this.f5a_1.a3(value);
    }
  }
  function SnapshotStateObserver$ObservedScopeMap$derivedStateObserver$1(this$0) {
    this.g5a_1 = this$0;
  }
  protoOf(SnapshotStateObserver$ObservedScopeMap$derivedStateObserver$1).e3e = function (derivedState) {
    var _unary__edvuaz = this.g5a_1.d5a_1;
    this.g5a_1.d5a_1 = _unary__edvuaz + 1 | 0;
  };
  protoOf(SnapshotStateObserver$ObservedScopeMap$derivedStateObserver$1).n3e = function (derivedState) {
    var _unary__edvuaz = this.g5a_1.d5a_1;
    this.g5a_1.d5a_1 = _unary__edvuaz - 1 | 0;
  };
  function drainChanges($this) {
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    $this.n5a_1;
    if ($this.j5a_1)
      return false;
    var hasValues = false;
    while (true) {
      var tmp0_elvis_lhs = removeChanges($this);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return hasValues;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var notifications = tmp;
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateObserver.forEachScopeMap' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      $this.n5a_1;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_0 = $this.m5a_1;
      var i = 0;
      var tmp_0 = this_0.b3e_1;
      var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
      var size = this_0.d3e_1;
      while (i < size) {
        hasValues = content[i].s5a(notifications) || hasValues;
        i = i + 1 | 0;
      }
    }
  }
  function sendNotifications($this) {
    $this.h5a_1(SnapshotStateObserver$sendNotifications$lambda($this));
  }
  function addChanges($this, set) {
    $l$loop: while (true) {
      var old = $this.i5a_1.f1i();
      var tmp;
      if (old == null) {
        tmp = set;
      } else {
        if (isInterface(old, KtSet)) {
          tmp = listOf_0([old, set]);
        } else {
          if (isInterface(old, KtList)) {
            tmp = plus_0(old, listOf(set));
          } else {
            report($this);
          }
        }
      }
      var new_0 = tmp;
      if ($this.i5a_1.w21(old, new_0))
        break $l$loop;
    }
  }
  function removeChanges($this) {
    while (true) {
      var old = $this.i5a_1.f1i();
      var result;
      var new_0;
      if (old == null)
        return null;
      else {
        if (isInterface(old, KtSet)) {
          result = isInterface(old, KtSet) ? old : THROW_CCE();
          new_0 = null;
        } else {
          if (isInterface(old, KtList)) {
            var tmp = old.l1(0);
            result = (tmp == null ? true : isInterface(tmp, KtSet)) ? tmp : THROW_CCE();
            new_0 = old.n1() === 2 ? old.l1(1) : old.n1() > 2 ? old.t2(1, old.n1()) : null;
          } else {
            report($this);
          }
        }
      }
      if ($this.i5a_1.w21(old, new_0)) {
        return result;
      }
    }
  }
  function report($this) {
    composeRuntimeError('Unexpected notification');
  }
  function ensureMap($this, onChanged) {
    var tmp0 = $this.m5a_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.firstOrNull' call
      var tmp = tmp0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = tmp0.d3e_1;
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = content[i];
          if (item.t59_1 === onChanged) {
            tmp$ret$0 = item;
            break $l$block;
          }
        }
         while (inductionVariable < size);
      tmp$ret$0 = null;
    }
    var scopeMap = tmp$ret$0;
    if (scopeMap == null) {
      var map = new ObservedScopeMap(typeof onChanged === 'function' ? onChanged : THROW_CCE());
      // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
      $this.m5a_1.zz(map);
      return map;
    }
    return scopeMap;
  }
  function ObservedScopeMap(onChanged) {
    this.t59_1 = onChanged;
    this.u59_1 = null;
    this.v59_1 = null;
    this.w59_1 = -1;
    this.x59_1 = _ScopeMap___init__impl__52wntz();
    this.y59_1 = new MutableScatterMap();
    this.z59_1 = new MutableScatterSet();
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.a5a_1 = new MutableVector(tmp$ret$2, 0);
    var tmp_0 = this;
    tmp_0.b5a_1 = new SnapshotStateObserver$ObservedScopeMap$derivedStateObserver$1(this);
    this.c5a_1 = false;
    this.d5a_1 = 0;
    this.e5a_1 = _ScopeMap___init__impl__52wntz();
    this.f5a_1 = HashMap_init_$Create$_0();
  }
  protoOf(ObservedScopeMap).t5a = function (value) {
    var scope = ensureNotNull(this.u59_1);
    var tmp = this.w59_1;
    var tmp0_elvis_lhs = this.v59_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new MutableObjectIntMap();
      this.v59_1 = this_0;
      this.y59_1.h13(scope, this_0);
      tmp_0 = this_0;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    recordRead(this, value, tmp, scope, tmp_0);
  };
  protoOf(ObservedScopeMap).u5a = function (scope) {
    var tmp0_elvis_lhs = this.y59_1.a3(scope);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var recordedValues = tmp;
    // Inline function 'androidx.collection.ObjectIntMap.forEach' call
    var k = recordedValues.ez_1;
    var v = recordedValues.fz_1;
    $l$block: {
      // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
      var m = recordedValues.dz_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_0 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = k[index];
                  v[index];
                  removeObservation(this, scope, tmp0);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  };
  protoOf(ObservedScopeMap).v5a = function (predicate) {
    // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
    var this_0 = this.y59_1;
    $l$block_0: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = this_0.x12_1[index];
                  var valueSet = this_0.y12_1[index];
                  // Inline function 'kotlin.also' call
                  var this_2 = predicate(tmp0);
                  if (this_2) {
                    // Inline function 'androidx.collection.ObjectIntMap.forEach' call
                    var k = valueSet.ez_1;
                    var v = valueSet.fz_1;
                    $l$block: {
                      // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
                      var m_0 = valueSet.dz_1;
                      var lastIndex_0 = m_0.length - 2 | 0;
                      var inductionVariable_1 = 0;
                      if (inductionVariable_1 <= lastIndex_0)
                        do {
                          var i_0 = inductionVariable_1;
                          inductionVariable_1 = inductionVariable_1 + 1 | 0;
                          var slot_0 = m_0[i_0];
                          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                          var this_3 = slot_0;
                          var tmp$ret$10 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
                          if (!equalsLong(tmp$ret$10, new Long(-2139062144, -2139062144))) {
                            var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                            var inductionVariable_2 = 0;
                            if (inductionVariable_2 < bitCount_0)
                              do {
                                var j_0 = inductionVariable_2;
                                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                // Inline function 'androidx.collection.isFull' call
                                var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                                if (compare(value_0, new Long(128, 0)) < 0) {
                                  var index_0 = (i_0 << 3) + j_0 | 0;
                                  var tmp0_0 = k[index_0];
                                  v[index_0];
                                  removeObservation(this, tmp0, tmp0_0);
                                }
                                slot_0 = shiftRight(slot_0, 8);
                              }
                               while (inductionVariable_2 < bitCount_0);
                            if (!(bitCount_0 === 8)) {
                              break $l$block;
                            }
                          }
                        }
                         while (!(i_0 === lastIndex_0));
                    }
                  }
                  if (this_2) {
                    this_0.hw(index);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i === lastIndex));
    }
  };
  protoOf(ObservedScopeMap).w5a = function () {
    return this.y59_1.fv();
  };
  protoOf(ObservedScopeMap).c3 = function () {
    ScopeMap__clear_impl_2jofm0(this.x59_1);
    this.y59_1.c3();
    ScopeMap__clear_impl_2jofm0(this.e5a_1);
    this.f5a_1.c3();
  };
  protoOf(ObservedScopeMap).s5a = function (changes) {
    var hasValues = false;
    var dependencyToDerivedStates = this.e5a_1;
    var recordedDerivedStateValues = this.f5a_1;
    var valueToScopes = this.x59_1;
    var invalidated = this.z59_1;
    // Inline function 'androidx.compose.runtime.collection.fastForEach' call
    var tmp;
    if (changes instanceof ScatterSetWrapper) {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      var this_0 = changes.s37_1;
      // Inline function 'kotlin.contracts.contract' call
      var elements = this_0.k16_1;
      $l$block_4: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = this_0.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var tmp0 = elements[index];
                    $l$block: {
                      var tmp_0;
                      if (tmp0 instanceof StateObjectImpl) {
                        // Inline function 'androidx.compose.runtime.snapshots.Companion.SnapshotStateObserver' call
                        var tmp$ret$9 = _ReaderKind___init__impl__jqeebu(2);
                        tmp_0 = !tmp0.z3e(tmp$ret$9);
                      } else {
                        tmp_0 = false;
                      }
                      if (tmp_0) {
                        break $l$block;
                      }
                      if (!this.c5a_1 && ScopeMap__contains_impl_6qp7s6(dependencyToDerivedStates, tmp0)) {
                        this.c5a_1 = true;
                        try {
                          // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
                          var value_0 = _ScopeMap___get_map__impl__vxhazm(dependencyToDerivedStates).w2(tmp0);
                          if (value_0 != null) {
                            if (value_0 instanceof MutableScatterSet) {
                              // Inline function 'androidx.collection.ScatterSet.forEach' call
                              var this_2 = value_0 instanceof MutableScatterSet ? value_0 : THROW_CCE();
                              // Inline function 'kotlin.contracts.contract' call
                              var elements_0 = this_2.k16_1;
                              $l$block_1: {
                                // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                                // Inline function 'kotlin.contracts.contract' call
                                var m_0 = this_2.j16_1;
                                var lastIndex_0 = m_0.length - 2 | 0;
                                var inductionVariable_1 = 0;
                                if (inductionVariable_1 <= lastIndex_0)
                                  do {
                                    var i_0 = inductionVariable_1;
                                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                                    var slot_0 = m_0[i_0];
                                    // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                                    var this_3 = slot_0;
                                    var tmp$ret$15 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
                                    if (!equalsLong(tmp$ret$15, new Long(-2139062144, -2139062144))) {
                                      var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                                      var inductionVariable_2 = 0;
                                      if (inductionVariable_2 < bitCount_0)
                                        do {
                                          var j_0 = inductionVariable_2;
                                          inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                          // Inline function 'androidx.collection.isFull' call
                                          var value_1 = bitwiseAnd(slot_0, new Long(255, 0));
                                          if (compare(value_1, new Long(128, 0)) < 0) {
                                            var index_0 = (i_0 << 3) + j_0 | 0;
                                            var derivedState = elements_0[index_0];
                                            if (!isInterface(derivedState, DerivedState))
                                              THROW_CCE();
                                            var previousValue = recordedDerivedStateValues.w2(derivedState);
                                            var tmp0_elvis_lhs = derivedState.h3d();
                                            var policy = tmp0_elvis_lhs == null ? structuralEqualityPolicy() : tmp0_elvis_lhs;
                                            if (!policy.w3e(derivedState.g3a().i3a(), previousValue)) {
                                              // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
                                              var value_2 = _ScopeMap___get_map__impl__vxhazm(valueToScopes).w2(derivedState);
                                              if (value_2 != null) {
                                                if (value_2 instanceof MutableScatterSet) {
                                                  // Inline function 'androidx.collection.ScatterSet.forEach' call
                                                  var this_4 = value_2 instanceof MutableScatterSet ? value_2 : THROW_CCE();
                                                  // Inline function 'kotlin.contracts.contract' call
                                                  var elements_1 = this_4.k16_1;
                                                  $l$block_0: {
                                                    // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                                                    // Inline function 'kotlin.contracts.contract' call
                                                    var m_1 = this_4.j16_1;
                                                    var lastIndex_1 = m_1.length - 2 | 0;
                                                    var inductionVariable_3 = 0;
                                                    if (inductionVariable_3 <= lastIndex_1)
                                                      do {
                                                        var i_1 = inductionVariable_3;
                                                        inductionVariable_3 = inductionVariable_3 + 1 | 0;
                                                        var slot_1 = m_1[i_1];
                                                        // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                                                        var this_5 = slot_1;
                                                        var tmp$ret$24 = bitwiseAnd(bitwiseAnd(this_5, shiftLeft(invert(this_5), 7)), new Long(-2139062144, -2139062144));
                                                        if (!equalsLong(tmp$ret$24, new Long(-2139062144, -2139062144))) {
                                                          var bitCount_1 = 8 - (~(i_1 - lastIndex_1 | 0) >>> 31 | 0) | 0;
                                                          var inductionVariable_4 = 0;
                                                          if (inductionVariable_4 < bitCount_1)
                                                            do {
                                                              var j_1 = inductionVariable_4;
                                                              inductionVariable_4 = inductionVariable_4 + 1 | 0;
                                                              // Inline function 'androidx.collection.isFull' call
                                                              var value_3 = bitwiseAnd(slot_1, new Long(255, 0));
                                                              if (compare(value_3, new Long(128, 0)) < 0) {
                                                                var index_1 = (i_1 << 3) + j_1 | 0;
                                                                var scope = elements_1[index_1];
                                                                invalidated.j1(scope);
                                                                hasValues = true;
                                                              }
                                                              slot_1 = shiftRight(slot_1, 8);
                                                            }
                                                             while (inductionVariable_4 < bitCount_1);
                                                          if (!(bitCount_1 === 8)) {
                                                            break $l$block_0;
                                                          }
                                                        }
                                                      }
                                                       while (!(i_1 === lastIndex_1));
                                                  }
                                                } else {
                                                  var scope_0 = !(value_2 == null) ? value_2 : THROW_CCE();
                                                  invalidated.j1(scope_0);
                                                  hasValues = true;
                                                }
                                              }
                                            } else {
                                              this.a5a_1.zz(derivedState);
                                            }
                                          }
                                          slot_0 = shiftRight(slot_0, 8);
                                        }
                                         while (inductionVariable_2 < bitCount_0);
                                      if (!(bitCount_0 === 8)) {
                                        break $l$block_1;
                                      }
                                    }
                                  }
                                   while (!(i_0 === lastIndex_0));
                              }
                            } else {
                              var derivedState_0 = !(value_0 == null) ? value_0 : THROW_CCE();
                              if (!isInterface(derivedState_0, DerivedState))
                                THROW_CCE();
                              var previousValue_0 = recordedDerivedStateValues.w2(derivedState_0);
                              var tmp0_elvis_lhs_0 = derivedState_0.h3d();
                              var policy_0 = tmp0_elvis_lhs_0 == null ? structuralEqualityPolicy() : tmp0_elvis_lhs_0;
                              if (!policy_0.w3e(derivedState_0.g3a().i3a(), previousValue_0)) {
                                // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
                                var value_4 = _ScopeMap___get_map__impl__vxhazm(valueToScopes).w2(derivedState_0);
                                if (value_4 != null) {
                                  if (value_4 instanceof MutableScatterSet) {
                                    // Inline function 'androidx.collection.ScatterSet.forEach' call
                                    var this_6 = value_4 instanceof MutableScatterSet ? value_4 : THROW_CCE();
                                    // Inline function 'kotlin.contracts.contract' call
                                    var elements_2 = this_6.k16_1;
                                    $l$block_2: {
                                      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                                      // Inline function 'kotlin.contracts.contract' call
                                      var m_2 = this_6.j16_1;
                                      var lastIndex_2 = m_2.length - 2 | 0;
                                      var inductionVariable_5 = 0;
                                      if (inductionVariable_5 <= lastIndex_2)
                                        do {
                                          var i_2 = inductionVariable_5;
                                          inductionVariable_5 = inductionVariable_5 + 1 | 0;
                                          var slot_2 = m_2[i_2];
                                          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                                          var this_7 = slot_2;
                                          var tmp$ret$35 = bitwiseAnd(bitwiseAnd(this_7, shiftLeft(invert(this_7), 7)), new Long(-2139062144, -2139062144));
                                          if (!equalsLong(tmp$ret$35, new Long(-2139062144, -2139062144))) {
                                            var bitCount_2 = 8 - (~(i_2 - lastIndex_2 | 0) >>> 31 | 0) | 0;
                                            var inductionVariable_6 = 0;
                                            if (inductionVariable_6 < bitCount_2)
                                              do {
                                                var j_2 = inductionVariable_6;
                                                inductionVariable_6 = inductionVariable_6 + 1 | 0;
                                                // Inline function 'androidx.collection.isFull' call
                                                var value_5 = bitwiseAnd(slot_2, new Long(255, 0));
                                                if (compare(value_5, new Long(128, 0)) < 0) {
                                                  var index_2 = (i_2 << 3) + j_2 | 0;
                                                  var scope_1 = elements_2[index_2];
                                                  invalidated.j1(scope_1);
                                                  hasValues = true;
                                                }
                                                slot_2 = shiftRight(slot_2, 8);
                                              }
                                               while (inductionVariable_6 < bitCount_2);
                                            if (!(bitCount_2 === 8)) {
                                              break $l$block_2;
                                            }
                                          }
                                        }
                                         while (!(i_2 === lastIndex_2));
                                    }
                                  } else {
                                    var scope_2 = !(value_4 == null) ? value_4 : THROW_CCE();
                                    invalidated.j1(scope_2);
                                    hasValues = true;
                                  }
                                }
                              } else {
                                this.a5a_1.zz(derivedState_0);
                              }
                            }
                          }
                        }finally {
                          this.c5a_1 = false;
                        }
                      }
                      // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
                      var value_6 = _ScopeMap___get_map__impl__vxhazm(valueToScopes).w2(tmp0);
                      if (value_6 != null) {
                        if (value_6 instanceof MutableScatterSet) {
                          // Inline function 'androidx.collection.ScatterSet.forEach' call
                          var this_8 = value_6 instanceof MutableScatterSet ? value_6 : THROW_CCE();
                          // Inline function 'kotlin.contracts.contract' call
                          var elements_3 = this_8.k16_1;
                          $l$block_3: {
                            // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                            // Inline function 'kotlin.contracts.contract' call
                            var m_3 = this_8.j16_1;
                            var lastIndex_3 = m_3.length - 2 | 0;
                            var inductionVariable_7 = 0;
                            if (inductionVariable_7 <= lastIndex_3)
                              do {
                                var i_3 = inductionVariable_7;
                                inductionVariable_7 = inductionVariable_7 + 1 | 0;
                                var slot_3 = m_3[i_3];
                                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                                var this_9 = slot_3;
                                var tmp$ret$45 = bitwiseAnd(bitwiseAnd(this_9, shiftLeft(invert(this_9), 7)), new Long(-2139062144, -2139062144));
                                if (!equalsLong(tmp$ret$45, new Long(-2139062144, -2139062144))) {
                                  var bitCount_3 = 8 - (~(i_3 - lastIndex_3 | 0) >>> 31 | 0) | 0;
                                  var inductionVariable_8 = 0;
                                  if (inductionVariable_8 < bitCount_3)
                                    do {
                                      var j_3 = inductionVariable_8;
                                      inductionVariable_8 = inductionVariable_8 + 1 | 0;
                                      // Inline function 'androidx.collection.isFull' call
                                      var value_7 = bitwiseAnd(slot_3, new Long(255, 0));
                                      if (compare(value_7, new Long(128, 0)) < 0) {
                                        var index_3 = (i_3 << 3) + j_3 | 0;
                                        var scope_3 = elements_3[index_3];
                                        invalidated.j1(scope_3);
                                        hasValues = true;
                                      }
                                      slot_3 = shiftRight(slot_3, 8);
                                    }
                                     while (inductionVariable_8 < bitCount_3);
                                  if (!(bitCount_3 === 8)) {
                                    break $l$block_3;
                                  }
                                }
                              }
                               while (!(i_3 === lastIndex_3));
                          }
                        } else {
                          var scope_4 = !(value_6 == null) ? value_6 : THROW_CCE();
                          invalidated.j1(scope_4);
                          hasValues = true;
                        }
                      }
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_4;
              }
            }
          }
           while (!(i === lastIndex));
      }
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = changes.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        $l$block_5: {
          var tmp_1;
          if (element instanceof StateObjectImpl) {
            // Inline function 'androidx.compose.runtime.snapshots.Companion.SnapshotStateObserver' call
            var tmp$ret$52 = _ReaderKind___init__impl__jqeebu(2);
            tmp_1 = !element.z3e(tmp$ret$52);
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            break $l$block_5;
          }
          if (!this.c5a_1 && ScopeMap__contains_impl_6qp7s6(dependencyToDerivedStates, element)) {
            this.c5a_1 = true;
            try {
              // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
              var value_8 = _ScopeMap___get_map__impl__vxhazm(dependencyToDerivedStates).w2(element);
              if (value_8 != null) {
                if (value_8 instanceof MutableScatterSet) {
                  // Inline function 'androidx.collection.ScatterSet.forEach' call
                  var this_10 = value_8 instanceof MutableScatterSet ? value_8 : THROW_CCE();
                  // Inline function 'kotlin.contracts.contract' call
                  var elements_4 = this_10.k16_1;
                  $l$block_7: {
                    // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                    // Inline function 'kotlin.contracts.contract' call
                    var m_4 = this_10.j16_1;
                    var lastIndex_4 = m_4.length - 2 | 0;
                    var inductionVariable_9 = 0;
                    if (inductionVariable_9 <= lastIndex_4)
                      do {
                        var i_4 = inductionVariable_9;
                        inductionVariable_9 = inductionVariable_9 + 1 | 0;
                        var slot_4 = m_4[i_4];
                        // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                        var this_11 = slot_4;
                        var tmp$ret$58 = bitwiseAnd(bitwiseAnd(this_11, shiftLeft(invert(this_11), 7)), new Long(-2139062144, -2139062144));
                        if (!equalsLong(tmp$ret$58, new Long(-2139062144, -2139062144))) {
                          var bitCount_4 = 8 - (~(i_4 - lastIndex_4 | 0) >>> 31 | 0) | 0;
                          var inductionVariable_10 = 0;
                          if (inductionVariable_10 < bitCount_4)
                            do {
                              var j_4 = inductionVariable_10;
                              inductionVariable_10 = inductionVariable_10 + 1 | 0;
                              // Inline function 'androidx.collection.isFull' call
                              var value_9 = bitwiseAnd(slot_4, new Long(255, 0));
                              if (compare(value_9, new Long(128, 0)) < 0) {
                                var index_4 = (i_4 << 3) + j_4 | 0;
                                var derivedState_1 = elements_4[index_4];
                                if (!isInterface(derivedState_1, DerivedState))
                                  THROW_CCE();
                                var previousValue_1 = recordedDerivedStateValues.w2(derivedState_1);
                                var tmp0_elvis_lhs_1 = derivedState_1.h3d();
                                var policy_1 = tmp0_elvis_lhs_1 == null ? structuralEqualityPolicy() : tmp0_elvis_lhs_1;
                                if (!policy_1.w3e(derivedState_1.g3a().i3a(), previousValue_1)) {
                                  // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
                                  var value_10 = _ScopeMap___get_map__impl__vxhazm(valueToScopes).w2(derivedState_1);
                                  if (value_10 != null) {
                                    if (value_10 instanceof MutableScatterSet) {
                                      // Inline function 'androidx.collection.ScatterSet.forEach' call
                                      var this_12 = value_10 instanceof MutableScatterSet ? value_10 : THROW_CCE();
                                      // Inline function 'kotlin.contracts.contract' call
                                      var elements_5 = this_12.k16_1;
                                      $l$block_6: {
                                        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                                        // Inline function 'kotlin.contracts.contract' call
                                        var m_5 = this_12.j16_1;
                                        var lastIndex_5 = m_5.length - 2 | 0;
                                        var inductionVariable_11 = 0;
                                        if (inductionVariable_11 <= lastIndex_5)
                                          do {
                                            var i_5 = inductionVariable_11;
                                            inductionVariable_11 = inductionVariable_11 + 1 | 0;
                                            var slot_5 = m_5[i_5];
                                            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                                            var this_13 = slot_5;
                                            var tmp$ret$67 = bitwiseAnd(bitwiseAnd(this_13, shiftLeft(invert(this_13), 7)), new Long(-2139062144, -2139062144));
                                            if (!equalsLong(tmp$ret$67, new Long(-2139062144, -2139062144))) {
                                              var bitCount_5 = 8 - (~(i_5 - lastIndex_5 | 0) >>> 31 | 0) | 0;
                                              var inductionVariable_12 = 0;
                                              if (inductionVariable_12 < bitCount_5)
                                                do {
                                                  var j_5 = inductionVariable_12;
                                                  inductionVariable_12 = inductionVariable_12 + 1 | 0;
                                                  // Inline function 'androidx.collection.isFull' call
                                                  var value_11 = bitwiseAnd(slot_5, new Long(255, 0));
                                                  if (compare(value_11, new Long(128, 0)) < 0) {
                                                    var index_5 = (i_5 << 3) + j_5 | 0;
                                                    var scope_5 = elements_5[index_5];
                                                    invalidated.j1(scope_5);
                                                    hasValues = true;
                                                  }
                                                  slot_5 = shiftRight(slot_5, 8);
                                                }
                                                 while (inductionVariable_12 < bitCount_5);
                                              if (!(bitCount_5 === 8)) {
                                                break $l$block_6;
                                              }
                                            }
                                          }
                                           while (!(i_5 === lastIndex_5));
                                      }
                                    } else {
                                      var scope_6 = !(value_10 == null) ? value_10 : THROW_CCE();
                                      invalidated.j1(scope_6);
                                      hasValues = true;
                                    }
                                  }
                                } else {
                                  this.a5a_1.zz(derivedState_1);
                                }
                              }
                              slot_4 = shiftRight(slot_4, 8);
                            }
                             while (inductionVariable_10 < bitCount_4);
                          if (!(bitCount_4 === 8)) {
                            break $l$block_7;
                          }
                        }
                      }
                       while (!(i_4 === lastIndex_4));
                  }
                } else {
                  var derivedState_2 = !(value_8 == null) ? value_8 : THROW_CCE();
                  if (!isInterface(derivedState_2, DerivedState))
                    THROW_CCE();
                  var previousValue_2 = recordedDerivedStateValues.w2(derivedState_2);
                  var tmp0_elvis_lhs_2 = derivedState_2.h3d();
                  var policy_2 = tmp0_elvis_lhs_2 == null ? structuralEqualityPolicy() : tmp0_elvis_lhs_2;
                  if (!policy_2.w3e(derivedState_2.g3a().i3a(), previousValue_2)) {
                    // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
                    var value_12 = _ScopeMap___get_map__impl__vxhazm(valueToScopes).w2(derivedState_2);
                    if (value_12 != null) {
                      if (value_12 instanceof MutableScatterSet) {
                        // Inline function 'androidx.collection.ScatterSet.forEach' call
                        var this_14 = value_12 instanceof MutableScatterSet ? value_12 : THROW_CCE();
                        // Inline function 'kotlin.contracts.contract' call
                        var elements_6 = this_14.k16_1;
                        $l$block_8: {
                          // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                          // Inline function 'kotlin.contracts.contract' call
                          var m_6 = this_14.j16_1;
                          var lastIndex_6 = m_6.length - 2 | 0;
                          var inductionVariable_13 = 0;
                          if (inductionVariable_13 <= lastIndex_6)
                            do {
                              var i_6 = inductionVariable_13;
                              inductionVariable_13 = inductionVariable_13 + 1 | 0;
                              var slot_6 = m_6[i_6];
                              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                              var this_15 = slot_6;
                              var tmp$ret$78 = bitwiseAnd(bitwiseAnd(this_15, shiftLeft(invert(this_15), 7)), new Long(-2139062144, -2139062144));
                              if (!equalsLong(tmp$ret$78, new Long(-2139062144, -2139062144))) {
                                var bitCount_6 = 8 - (~(i_6 - lastIndex_6 | 0) >>> 31 | 0) | 0;
                                var inductionVariable_14 = 0;
                                if (inductionVariable_14 < bitCount_6)
                                  do {
                                    var j_6 = inductionVariable_14;
                                    inductionVariable_14 = inductionVariable_14 + 1 | 0;
                                    // Inline function 'androidx.collection.isFull' call
                                    var value_13 = bitwiseAnd(slot_6, new Long(255, 0));
                                    if (compare(value_13, new Long(128, 0)) < 0) {
                                      var index_6 = (i_6 << 3) + j_6 | 0;
                                      var scope_7 = elements_6[index_6];
                                      invalidated.j1(scope_7);
                                      hasValues = true;
                                    }
                                    slot_6 = shiftRight(slot_6, 8);
                                  }
                                   while (inductionVariable_14 < bitCount_6);
                                if (!(bitCount_6 === 8)) {
                                  break $l$block_8;
                                }
                              }
                            }
                             while (!(i_6 === lastIndex_6));
                        }
                      } else {
                        var scope_8 = !(value_12 == null) ? value_12 : THROW_CCE();
                        invalidated.j1(scope_8);
                        hasValues = true;
                      }
                    }
                  } else {
                    this.a5a_1.zz(derivedState_2);
                  }
                }
              }
            }finally {
              this.c5a_1 = false;
            }
          }
          // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
          var value_14 = _ScopeMap___get_map__impl__vxhazm(valueToScopes).w2(element);
          if (value_14 != null) {
            if (value_14 instanceof MutableScatterSet) {
              // Inline function 'androidx.collection.ScatterSet.forEach' call
              var this_16 = value_14 instanceof MutableScatterSet ? value_14 : THROW_CCE();
              // Inline function 'kotlin.contracts.contract' call
              var elements_7 = this_16.k16_1;
              $l$block_9: {
                // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                // Inline function 'kotlin.contracts.contract' call
                var m_7 = this_16.j16_1;
                var lastIndex_7 = m_7.length - 2 | 0;
                var inductionVariable_15 = 0;
                if (inductionVariable_15 <= lastIndex_7)
                  do {
                    var i_7 = inductionVariable_15;
                    inductionVariable_15 = inductionVariable_15 + 1 | 0;
                    var slot_7 = m_7[i_7];
                    // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                    var this_17 = slot_7;
                    var tmp$ret$88 = bitwiseAnd(bitwiseAnd(this_17, shiftLeft(invert(this_17), 7)), new Long(-2139062144, -2139062144));
                    if (!equalsLong(tmp$ret$88, new Long(-2139062144, -2139062144))) {
                      var bitCount_7 = 8 - (~(i_7 - lastIndex_7 | 0) >>> 31 | 0) | 0;
                      var inductionVariable_16 = 0;
                      if (inductionVariable_16 < bitCount_7)
                        do {
                          var j_7 = inductionVariable_16;
                          inductionVariable_16 = inductionVariable_16 + 1 | 0;
                          // Inline function 'androidx.collection.isFull' call
                          var value_15 = bitwiseAnd(slot_7, new Long(255, 0));
                          if (compare(value_15, new Long(128, 0)) < 0) {
                            var index_7 = (i_7 << 3) + j_7 | 0;
                            var scope_9 = elements_7[index_7];
                            invalidated.j1(scope_9);
                            hasValues = true;
                          }
                          slot_7 = shiftRight(slot_7, 8);
                        }
                         while (inductionVariable_16 < bitCount_7);
                      if (!(bitCount_7 === 8)) {
                        break $l$block_9;
                      }
                    }
                  }
                   while (!(i_7 === lastIndex_7));
              }
            } else {
              var scope_10 = !(value_14 == null) ? value_14 : THROW_CCE();
              invalidated.j1(scope_10);
              hasValues = true;
            }
          }
        }
      }
      tmp = Unit_instance;
    }
    var tmp_2;
    if (!this.c5a_1) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      tmp_2 = !(this.a5a_1.d3e_1 === 0);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_18 = this.a5a_1;
      var i_8 = 0;
      var tmp_3 = this_18.b3e_1;
      var content = isArray(tmp_3) ? tmp_3 : THROW_CCE();
      var size = this_18.d3e_1;
      while (i_8 < size) {
        var it = content[i_8];
        this.x5a(it);
        i_8 = i_8 + 1 | 0;
      }
      this.a5a_1.c3();
    }
    return hasValues;
  };
  protoOf(ObservedScopeMap).x5a = function (derivedState) {
    var scopeToValues = this.y59_1;
    var token = getNumberHashCode(currentSnapshot().w3d());
    // Inline function 'androidx.compose.runtime.collection.ScopeMap.forEachScopeOf' call
    var this_0 = this.x59_1;
    var value = _ScopeMap___get_map__impl__vxhazm(this_0).w2(derivedState);
    if (value != null) {
      if (value instanceof MutableScatterSet) {
        // Inline function 'androidx.collection.ScatterSet.forEach' call
        var this_1 = value instanceof MutableScatterSet ? value : THROW_CCE();
        // Inline function 'kotlin.contracts.contract' call
        var elements = this_1.k16_1;
        $l$block: {
          // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
          // Inline function 'kotlin.contracts.contract' call
          var m = this_1.j16_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_2 = slot;
              var tmp$ret$5 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$5, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value_0 = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value_0, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var scope = elements[index];
                      var tmp0_elvis_lhs = scopeToValues.w2(scope);
                      var tmp;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'kotlin.also' call
                        var this_3 = new MutableObjectIntMap();
                        scopeToValues.h13(scope, this_3);
                        tmp = this_3;
                      } else {
                        tmp = tmp0_elvis_lhs;
                      }
                      recordRead(this, derivedState, token, scope, tmp);
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
      } else {
        var scope_0 = !(value == null) ? value : THROW_CCE();
        var tmp0_elvis_lhs_0 = scopeToValues.w2(scope_0);
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          // Inline function 'kotlin.also' call
          var this_4 = new MutableObjectIntMap();
          scopeToValues.h13(scope_0, this_4);
          tmp_0 = this_4;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        recordRead(this, derivedState, token, scope_0, tmp_0);
      }
    }
  };
  protoOf(ObservedScopeMap).y5a = function () {
    var invalidated = this.z59_1;
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    var block = this.t59_1;
    // Inline function 'kotlin.contracts.contract' call
    var elements = invalidated.k16_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m = invalidated.j16_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_0 = slot;
          var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  block(elements[index]);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    invalidated.c3();
  };
  function SnapshotStateObserver$applyObserver$lambda(this$0) {
    return function (applied, _unused_var__etf5q3) {
      addChanges(this$0, applied);
      var tmp;
      if (drainChanges(this$0)) {
        sendNotifications(this$0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SnapshotStateObserver$sendNotifications$lambda(this$0) {
    return function () {
      $l$loop: while (true) {
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        this$0.n5a_1;
        if (!this$0.j5a_1) {
          this$0.j5a_1 = true;
          try {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
            var this_0 = this$0.m5a_1;
            var i = 0;
            var tmp = this_0.b3e_1;
            var content = isArray(tmp) ? tmp : THROW_CCE();
            var size = this_0.d3e_1;
            while (i < size) {
              content[i].y5a();
              i = i + 1 | 0;
            }
          }finally {
            this$0.j5a_1 = false;
          }
        }
        if (!drainChanges(this$0))
          break $l$loop;
      }
      return Unit_instance;
    };
  }
  function SnapshotStateObserver$readObserver$lambda(this$0) {
    return function (state) {
      var tmp;
      if (!this$0.p5a_1) {
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        this$0.n5a_1;
        ensureNotNull(this$0.q5a_1).t5a(state);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SnapshotStateObserver(onChangedExecutor) {
    this.h5a_1 = onChangedExecutor;
    this.i5a_1 = new AtomicReference(null);
    this.j5a_1 = false;
    var tmp = this;
    tmp.k5a_1 = SnapshotStateObserver$applyObserver$lambda(this);
    var tmp_0 = this;
    tmp_0.l5a_1 = SnapshotStateObserver$readObserver$lambda(this);
    var tmp_1 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp_1.m5a_1 = new MutableVector(tmp$ret$2, 0);
    var tmp_2 = this;
    // Inline function 'androidx.compose.runtime.platform.makeSynchronizedObject' call
    tmp_2.n5a_1 = null == null ? new Object() : null;
    this.o5a_1 = null;
    this.p5a_1 = false;
    this.q5a_1 = null;
    this.r5a_1 = new Long(-1, -1);
  }
  protoOf(SnapshotStateObserver).z5a = function (scope, onValueChangedForScope, block) {
    var scopeMap;
    var oldPaused;
    var oldMap;
    var oldThreadId;
    var currentThreadId_0 = currentThreadId();
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateObserver.withScopeMapLock' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.n5a_1;
    scopeMap = ensureMap(this, onValueChangedForScope);
    oldPaused = this.p5a_1;
    oldMap = this.q5a_1;
    oldThreadId = this.r5a_1;
    if (!equalsLong(oldThreadId, new Long(-1, -1))) {
      // Inline function 'androidx.compose.runtime.requirePrecondition' call
      if (!equalsLong(oldThreadId, currentThreadId_0)) {
        var tmp$ret$4 = 'Detected multithreaded access to SnapshotStateObserver: ' + ('previousThreadId=' + oldThreadId.toString() + '), ') + ('currentThread={id=' + currentThreadId_0.toString() + ', name=' + currentThreadName() + '}. ') + 'Note that observation on multiple threads in layout/draw is not supported. Make sure your measure/layout/draw for each Owner (AndroidComposeView) is executed on the same thread.';
        throwIllegalArgumentException(tmp$ret$4);
      }
    }
    try {
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateObserver.withScopeMapLock' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this.n5a_1;
      this.p5a_1 = false;
      this.q5a_1 = scopeMap;
      this.r5a_1 = currentThreadId_0;
      // Inline function 'androidx.compose.runtime.snapshots.ObservedScopeMap.observe' call
      var readObserver = this.l5a_1;
      var previousScope = scopeMap.u59_1;
      var previousReads = scopeMap.v59_1;
      var previousToken = scopeMap.w59_1;
      scopeMap.u59_1 = scope;
      scopeMap.v59_1 = scopeMap.y59_1.w2(scope);
      if (scopeMap.w59_1 === -1) {
        scopeMap.w59_1 = getNumberHashCode(currentSnapshot().w3d());
      }
      // Inline function 'androidx.compose.runtime.observeDerivedStateRecalculations' call
      var observer = scopeMap.b5a_1;
      var observers = derivedStateObservers_0();
      try {
        observers.zz(observer);
        $l$block_3: {
          // Inline function 'androidx.compose.runtime.snapshots.Companion.observeInternal' call
          if (readObserver == null && null == null) {
            block();
            break $l$block_3;
          }
          var previous = access$_get_threadSnapshot_$tSnapshotKt_cpt6u2().f1i();
          var tmp;
          if (previous instanceof TransparentObserverMutableSnapshot) {
            tmp = equalsLong(previous.o52_1, currentThreadId());
          } else {
            tmp = false;
          }
          if (tmp) {
            var previousReadObserver = previous.m52_1;
            var previousWriteObserver = previous.n52_1;
            try {
              previous.m52_1 = mergedReadObserver(readObserver, previousReadObserver);
              previous.n52_1 = mergedWriteObserver(null, previousWriteObserver);
              block();
              break $l$block_3;
            }finally {
              previous.m52_1 = previousReadObserver;
              previous.n52_1 = previousWriteObserver;
            }
          } else {
            var tmp_0;
            var tmp_1;
            if (previous == null) {
              tmp_1 = true;
            } else {
              tmp_1 = previous instanceof MutableSnapshot;
            }
            if (tmp_1) {
              tmp_0 = new TransparentObserverMutableSnapshot(previous instanceof MutableSnapshot ? previous : null, readObserver, null, true, false);
            } else {
              if (readObserver == null) {
                block();
                break $l$block_3;
              } else {
                tmp_0 = previous.u51(readObserver);
              }
            }
            var snapshot = tmp_0;
            try {
              $l$block_2: {
                // Inline function 'androidx.compose.runtime.snapshots.Snapshot.enter' call
                var previous_0 = snapshot.y41();
                try {
                  block();
                  break $l$block_2;
                }finally {
                  snapshot.z41(previous_0);
                }
              }
              break $l$block_3;
            }finally {
              snapshot.s1d();
            }
          }
        }
      }finally {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
        var tmp$ret$14 = observers.d3e_1 - 1 | 0;
        observers.h3(tmp$ret$14);
      }
      clearObsoleteStateReads(scopeMap, ensureNotNull(scopeMap.u59_1));
      scopeMap.u59_1 = previousScope;
      scopeMap.v59_1 = previousReads;
      scopeMap.w59_1 = previousToken;
    }finally {
      // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateObserver.withScopeMapLock' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      this.n5a_1;
      this.q5a_1 = oldMap;
      this.p5a_1 = oldPaused;
      this.r5a_1 = oldThreadId;
    }
  };
  protoOf(SnapshotStateObserver).a5b = function (scope) {
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateObserver.removeScopeMapIf' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.n5a_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.removeIf' call
    var this_0 = this.m5a_1;
    var gap = 0;
    var size = this_0.d3e_1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = this_0.b3e_1[i];
        it.u5a(scope);
        if (!it.w5a()) {
          gap = gap + 1 | 0;
          continue $l$loop;
        }
        if (gap > 0) {
          this_0.b3e_1[i - gap | 0] = this_0.b3e_1[i];
        }
      }
       while (inductionVariable < size);
    fill_0(this_0.b3e_1, null, size - gap | 0, size);
    this_0.x41(size - gap | 0);
  };
  protoOf(SnapshotStateObserver).b5b = function (predicate) {
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateObserver.removeScopeMapIf' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.n5a_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.removeIf' call
    var this_0 = this.m5a_1;
    var gap = 0;
    var size = this_0.d3e_1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var scopeMap = this_0.b3e_1[i];
        scopeMap.v5a(predicate);
        if (!scopeMap.w5a()) {
          gap = gap + 1 | 0;
          continue $l$loop;
        }
        if (gap > 0) {
          this_0.b3e_1[i - gap | 0] = this_0.b3e_1[i];
        }
      }
       while (inductionVariable < size);
    fill_0(this_0.b3e_1, null, size - gap | 0, size);
    this_0.x41(size - gap | 0);
  };
  protoOf(SnapshotStateObserver).c5b = function () {
    this.o5a_1 = Companion_instance_18.e45(this.k5a_1);
  };
  protoOf(SnapshotStateObserver).d5b = function () {
    var tmp0_safe_receiver = this.o5a_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s1d();
    }
  };
  protoOf(SnapshotStateObserver).c3 = function () {
    // Inline function 'androidx.compose.runtime.snapshots.SnapshotStateObserver.forEachScopeMap' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    this.n5a_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.m5a_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].c3();
      i = i + 1 | 0;
    }
  };
  var androidx_compose_runtime_snapshots_SnapshotWeakSet$stable;
  function find_1($this, value, hash) {
    var low = 0;
    var high = $this.c56_1 - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1 | 0;
      var midHash = $this.d56_1[mid];
      if (midHash < hash)
        low = mid + 1 | 0;
      else if (midHash > hash)
        high = mid - 1 | 0;
      else {
        var tmp0_safe_receiver = $this.e56_1[mid];
        var midVal = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f1i();
        if (value === midVal)
          return mid;
        return findExactIndex($this, mid, value, hash);
      }
    }
    return -(low + 1 | 0) | 0;
  }
  function findExactIndex($this, midIndex, value, valueHash) {
    var inductionVariable = midIndex - 1 | 0;
    if (0 <= inductionVariable)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (!($this.d56_1[i] === valueHash)) {
          break $l$loop;
        }
        var tmp0_safe_receiver = $this.e56_1[i];
        var v = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f1i();
        if (v === value) {
          return i;
        }
      }
       while (0 <= inductionVariable);
    var inductionVariable_0 = midIndex + 1 | 0;
    var last = $this.c56_1;
    if (inductionVariable_0 < last)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (!($this.d56_1[i_0] === valueHash)) {
          return -(i_0 + 1 | 0) | 0;
        }
        var tmp1_safe_receiver = $this.e56_1[i_0];
        var v_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f1i();
        if (v_0 === value) {
          return i_0;
        }
      }
       while (inductionVariable_0 < last);
    return -($this.c56_1 + 1 | 0) | 0;
  }
  function SnapshotWeakSet() {
    this.c56_1 = 0;
    this.d56_1 = new Int32Array(16);
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.e56_1 = Array(16);
  }
  protoOf(SnapshotWeakSet).g56 = function (value) {
    var index;
    var size = this.c56_1;
    var hash = identityHashCode_0(value);
    if (size > 0) {
      index = find_1(this, value, hash);
      if (index >= 0) {
        return false;
      }
    } else {
      index = -1;
    }
    var insertIndex = -(index + 1 | 0) | 0;
    var capacity = this.e56_1.length;
    if (size === capacity) {
      var newCapacity = imul(capacity, 2);
      // Inline function 'kotlin.arrayOfNulls' call
      var newValues = Array(newCapacity);
      var newHashes = new Int32Array(newCapacity);
      var tmp0 = this.e56_1;
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset = insertIndex + 1 | 0;
      arrayCopy(tmp0, newValues, destinationOffset, insertIndex, size);
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = this.e56_1;
      arrayCopy(this_0, newValues, 0, 0, insertIndex);
      var tmp0_0 = this.d56_1;
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset_0 = insertIndex + 1 | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, newHashes, destinationOffset_0, insertIndex, size);
      // Inline function 'kotlin.collections.copyInto' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = this.d56_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_0, newHashes, 0, 0, insertIndex);
      this.e56_1 = newValues;
      this.d56_1 = newHashes;
    } else {
      var tmp0_1 = this.e56_1;
      var tmp2 = this.e56_1;
      // Inline function 'androidx.compose.runtime.collection.fastCopyInto' call
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset_1 = insertIndex + 1 | 0;
      arrayCopy(tmp0_1, tmp2, destinationOffset_1, insertIndex, size);
      var tmp0_2 = this.d56_1;
      var tmp2_0 = this.d56_1;
      // Inline function 'kotlin.collections.copyInto' call
      var destinationOffset_2 = insertIndex + 1 | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_1 = tmp0_2;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_1, tmp2_0, destinationOffset_2, insertIndex, size);
    }
    this.e56_1[insertIndex] = new WeakReference(value);
    this.d56_1[insertIndex] = hash;
    this.c56_1 = this.c56_1 + 1 | 0;
    return true;
  };
  var androidx_compose_runtime_snapshots_StateObjectImpl$stable;
  function StateObjectImpl() {
    this.e3a_1 = new AtomicInt(0);
  }
  protoOf(StateObjectImpl).f3a = function (reader) {
    do {
      var old = _ReaderKind___init__impl__jqeebu(this.e3a_1.f1i());
      // Inline function 'androidx.compose.runtime.snapshots.ReaderKind.isReadIn' call
      var this_0 = old;
      if (!((_ReaderKind___get_mask__impl__gmhzqb(this_0) & _ReaderKind___get_mask__impl__gmhzqb(reader)) === 0))
        return Unit_instance;
      // Inline function 'androidx.compose.runtime.snapshots.ReaderKind.withReadIn' call
      var this_1 = old;
      var new_0 = _ReaderKind___init__impl__jqeebu(_ReaderKind___get_mask__impl__gmhzqb(this_1) | _ReaderKind___get_mask__impl__gmhzqb(reader));
    }
     while (!this.e3a_1.l50(_ReaderKind___get_mask__impl__gmhzqb(old), _ReaderKind___get_mask__impl__gmhzqb(new_0)));
  };
  protoOf(StateObjectImpl).z3e = function (reader) {
    // Inline function 'androidx.compose.runtime.snapshots.ReaderKind.isReadIn' call
    var this_0 = _ReaderKind___init__impl__jqeebu(this.e3a_1.f1i());
    return !((_ReaderKind___get_mask__impl__gmhzqb(this_0) & _ReaderKind___get_mask__impl__gmhzqb(reader)) === 0);
  };
  function _ReaderKind___init__impl__jqeebu(mask) {
    mask = mask === VOID ? 0 : mask;
    return mask;
  }
  function _ReaderKind___get_mask__impl__gmhzqb($this) {
    return $this;
  }
  function Companion_20() {
  }
  var Companion_instance_21;
  function Companion_getInstance_20() {
    return Companion_instance_21;
  }
  var observers;
  var androidx_compose_runtime_snapshots_tooling_SnapshotInstanceObservers$stable;
  function dispatchObserverOnApplied(snapshot, changes) {
    var observers_0 = observers;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(observers_0 == null || observers_0.r())) {
      var tmp1_elvis_lhs = changes == null ? null : wrapIntoSet(changes);
      var wrappedChanges = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = observers_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = observers_0.l1(index);
          item.e5b(snapshot, wrappedChanges);
        }
         while (inductionVariable <= last);
    }
  }
  function dispatchObserverOnPreDispose(snapshot) {
    var tmp0_safe_receiver = observers;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0_safe_receiver.l1(index);
          item.f5b(snapshot);
        }
         while (inductionVariable <= last);
    }
  }
  function SnapshotObserver() {
  }
  function SnapshotInstanceObservers(readObserver, writeObserver) {
    readObserver = readObserver === VOID ? null : readObserver;
    writeObserver = writeObserver === VOID ? null : writeObserver;
    this.e54_1 = readObserver;
    this.f54_1 = writeObserver;
  }
  function mergeObservers(_this__u8e3s4, parent, readonly, readObserver, writeObserver) {
    var currentReadObserver = readObserver;
    var currentWriteObserver = writeObserver;
    var observerMap = null;
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = _this__u8e3s4.l1(index);
        var instance = item.g5b(parent, readonly);
        if (!(instance == null)) {
          currentReadObserver = mergeObservers_0(instance.e54_1, currentReadObserver);
          currentWriteObserver = mergeObservers_0(instance.f54_1, currentWriteObserver);
          var tmp0_elvis_lhs = observerMap;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.collections.mutableMapOf' call
            var newMap = LinkedHashMap_init_$Create$();
            observerMap = newMap;
            tmp = newMap;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          // Inline function 'kotlin.collections.set' call
          tmp.z2(item, instance);
        }
      }
       while (inductionVariable <= last);
    return to(new SnapshotInstanceObservers(currentReadObserver, currentWriteObserver), observerMap);
  }
  function dispatchCreatedObservers(_this__u8e3s4, parent, result, observerMap) {
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = _this__u8e3s4.l1(index);
        var instance = observerMap == null ? null : observerMap.w2(item);
        item.h5b(result, parent, instance);
      }
       while (inductionVariable <= last);
  }
  function mergeObservers_0(a, b) {
    var tmp;
    if (!(a == null) && !(b == null)) {
      tmp = mergeObservers$lambda(a, b);
    } else {
      tmp = a == null ? b : a;
    }
    return tmp;
  }
  function access$_get_observers_$tSnapshotObserverKt_23v7jt() {
    return observers;
  }
  function mergeObservers$lambda($a, $b) {
    return function (it) {
      $a(it);
      $b(it);
      return Unit_instance;
    };
  }
  var androidx_compose_runtime_tooling_ComposeStackTrace$stable;
  var androidx_compose_runtime_tooling_ComposeStackTraceFrame$stable;
  function _ComposeStackTraceMode___init__impl__kg6849(value) {
    return value;
  }
  function Companion_21() {
    Companion_instance_22 = this;
    this.l36_1 = _ComposeStackTraceMode___init__impl__kg6849(0);
    this.m36_1 = _ComposeStackTraceMode___init__impl__kg6849(1);
    this.n36_1 = _ComposeStackTraceMode___init__impl__kg6849(2);
    this.o36_1 = false;
  }
  var Companion_instance_22;
  function Companion_getInstance_21() {
    if (Companion_instance_22 == null)
      new Companion_21();
    return Companion_instance_22;
  }
  function attachComposeStackTrace_1(_this__u8e3s4, trace) {
    // Inline function 'kotlin.apply' call
    tryAttachComposeStackTrace(_this__u8e3s4, trace);
    return _this__u8e3s4;
  }
  function ComposeStackTrace(frames, hasSourceInformation) {
    this.i5b_1 = frames;
    this.j5b_1 = hasSourceInformation;
  }
  function ComposeStackTraceFrame(groupKey, sourceInfo, groupOffset) {
    this.p4j_1 = groupKey;
    this.q4j_1 = sourceInfo;
    this.r4j_1 = groupOffset;
  }
  protoOf(ComposeStackTraceFrame).k5b = function (groupKey, sourceInfo, groupOffset) {
    return new ComposeStackTraceFrame(groupKey, sourceInfo, groupOffset);
  };
  protoOf(ComposeStackTraceFrame).s4j = function (groupKey, sourceInfo, groupOffset, $super) {
    groupKey = groupKey === VOID ? this.p4j_1 : groupKey;
    sourceInfo = sourceInfo === VOID ? this.q4j_1 : sourceInfo;
    groupOffset = groupOffset === VOID ? this.r4j_1 : groupOffset;
    return $super === VOID ? this.k5b(groupKey, sourceInfo, groupOffset) : $super.k5b.call(this, groupKey, sourceInfo, groupOffset);
  };
  protoOf(ComposeStackTraceFrame).toString = function () {
    return 'ComposeStackTraceFrame(groupKey=' + this.p4j_1 + ', sourceInfo=' + toString_0(this.q4j_1) + ', groupOffset=' + this.r4j_1 + ')';
  };
  protoOf(ComposeStackTraceFrame).hashCode = function () {
    var result = this.p4j_1;
    result = imul(result, 31) + (this.q4j_1 == null ? 0 : hashCode(this.q4j_1)) | 0;
    result = imul(result, 31) + (this.r4j_1 == null ? 0 : this.r4j_1) | 0;
    return result;
  };
  protoOf(ComposeStackTraceFrame).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ComposeStackTraceFrame))
      return false;
    if (!(this.p4j_1 === other.p4j_1))
      return false;
    if (!equals(this.q4j_1, other.q4j_1))
      return false;
    if (!(this.r4j_1 == other.r4j_1))
      return false;
    return true;
  };
  function tryAttachComposeStackTrace(_this__u8e3s4, trace) {
    var result = false;
    var tmp0 = get_suppressedExceptions(_this__u8e3s4);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.fastNone' call
      // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item instanceof DiagnosticComposeException) {
            tmp$ret$0 = false;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      var tmp;
      try {
        var stackTrace = trace();
        var tmp_0;
        if (!(stackTrace == null)) {
          var tmp_1;
          if (stackTrace.j5b_1) {
            var tmp0_0 = stackTrace.i5b_1;
            var tmp$ret$4;
            $l$block_0: {
              // Inline function 'androidx.compose.runtime.snapshots.fastAny' call
              // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
              var inductionVariable_0 = 0;
              var last_0 = tmp0_0.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = tmp0_0.l1(index_0);
                  if (!(item_0.q4j_1 == null)) {
                    tmp$ret$4 = true;
                    break $l$block_0;
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp$ret$4 = false;
            }
            tmp_1 = tmp$ret$4;
          } else {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp_1 = !stackTrace.i5b_1.r();
          }
          tmp_0 = tmp_1;
        } else {
          tmp_0 = false;
        }
        result = tmp_0;
        tmp = result ? new DiagnosticComposeException(ensureNotNull(stackTrace)) : null;
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var e = $p;
          tmp_2 = e;
        } else {
          throw $p;
        }
        tmp = tmp_2;
      }
      var traceException = tmp;
      if (!(traceException == null)) {
        addSuppressed(_this__u8e3s4, traceException);
      }
    }
    return result;
  }
  function appendStackTrace(_this__u8e3s4, trace) {
    if (trace.j5b_1) {
      appendSourceInformationStackTrace(_this__u8e3s4, trace);
    } else {
      appendGroupKeyStackTrace(_this__u8e3s4, trace);
    }
  }
  function appendSourceInformationStackTrace(_this__u8e3s4, trace) {
    var currentFunction = null;
    var currentFile = null;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var this_1 = asReversed(trace.i5b_1);
    var inductionVariable = 0;
    var last = this_1.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_1.l1(index);
        $l$block: {
          var sourceInfo = item.q4j_1;
          if (sourceInfo == null) {
            break $l$block;
          }
          var tmp0_elvis_lhs = sourceInfo.n5b_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.takeIf' call
            var this_2 = '<lambda>';
            var tmp_0;
            if (sourceInfo.l5b_1) {
              tmp_0 = this_2;
            } else {
              tmp_0 = null;
            }
            tmp = tmp_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var tmp1_elvis_lhs = tmp;
          var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? currentFunction : tmp1_elvis_lhs;
          var functionName = tmp2_elvis_lhs == null ? '<unknown function>' : tmp2_elvis_lhs;
          var tmp3_elvis_lhs = sourceInfo.o5b_1;
          var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? currentFile : tmp3_elvis_lhs;
          var fileName = tmp4_elvis_lhs == null ? '<unknown file>' : tmp4_elvis_lhs;
          var lineNumbers = sourceInfo.r5b_1;
          var tmp_1;
          if (!(item.r4j_1 == null) && item.r4j_1 < lineNumbers.n1()) {
            tmp_1 = lineNumbers.l1(item.r4j_1).t5b_1.toString();
          } else {
            var tmp_2;
            if (false) {
              // Inline function 'kotlin.collections.map' call
              // Inline function 'kotlin.collections.mapTo' call
              var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(lineNumbers, 10));
              var _iterator__ex2g4s = lineNumbers.t();
              while (_iterator__ex2g4s.u()) {
                var item_0 = _iterator__ex2g4s.v();
                var tmp$ret$10 = item_0.t5b_1;
                destination.j1(tmp$ret$10);
              }
              tmp_2 = '<no offset ' + item.r4j_1 + ' in ' + toString(destination) + '>';
            } else {
              tmp_2 = '<unknown line>';
            }
            tmp_1 = tmp_2;
          }
          var resolvedLine = tmp_1;
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_3 = StringBuilder_init_$Create$();
          this_3.q(functionName);
          this_3.s(_Char___init__impl__6a9atx(40));
          this_3.q(fileName);
          this_3.s(_Char___init__impl__6a9atx(58));
          this_3.q(resolvedLine);
          this_3.s(_Char___init__impl__6a9atx(41));
          if (false) {
            this_3.q(', parsed from ');
            this_3.q(sourceInfo.s5b_1);
            this_3.q(', group offset: ');
            this_3.w(item.r4j_1);
          }
          var traceLine = this_3.toString();
          if (!sourceInfo.l5b_1) {
            var line = removeLastOrNull(this_0);
            if (false) {
              this_0.j1('' + line + ' (collapsed)');
            }
          }
          if (sourceInfo.n5b_1 === 'rememberCompositionContext' && sourceInfo.q5b_1 === '9igjgp') {
            if (false) {
              this_0.j1(traceLine + ' (ignored)');
            }
          } else {
            this_0.j1(traceLine);
          }
          currentFunction = functionName;
          currentFile = fileName;
        }
      }
       while (inductionVariable <= last);
    var lines = this_0.t5();
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var this_4 = asReversed(lines);
    var inductionVariable_0 = 0;
    var last_0 = this_4.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_1 = this_4.l1(index_0);
        _this__u8e3s4.q('\tat ');
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        _this__u8e3s4.q(item_1).s(_Char___init__impl__6a9atx(10));
      }
       while (inductionVariable_0 <= last_0);
  }
  function appendGroupKeyStackTrace(_this__u8e3s4, trace) {
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var this_0 = filterInternalFramesByGroupKey(trace);
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        _this__u8e3s4.q('\tat $$compose.m$');
        _this__u8e3s4.ed(item.p4j_1);
        _this__u8e3s4.q('(SourceFile:1)');
        // Inline function 'kotlin.text.appendLine' call
        _this__u8e3s4.s(_Char___init__impl__6a9atx(10));
      }
       while (inductionVariable <= last);
  }
  function filterInternalFramesByGroupKey(_this__u8e3s4) {
    // Inline function 'kotlin.intArrayOf' call
    var knownKeys = new Int32Array([201, 202, 204, 206, 207, 125, -127, 126665345, 200]);
    var i = 0;
    var fCount = _this__u8e3s4.i5b_1.n1();
    // Inline function 'kotlin.collections.mutableListOf' call
    var filteredFrames = ArrayList_init_$Create$();
    $l$loop_1: while (i < fCount) {
      var _unary__edvuaz = i;
      i = _unary__edvuaz + 1 | 0;
      var frame = _this__u8e3s4.i5b_1.l1(_unary__edvuaz);
      if (contains_0(knownKeys, frame.p4j_1))
        continue $l$loop_1;
      if (frame.p4j_1 === 100) {
        if ((i + 1 | 0) < fCount && _this__u8e3s4.i5b_1.l1(i + 1 | 0).p4j_1 === 1000) {
          break $l$loop_1;
        } else {
          removeLastOrNull(filteredFrames);
          continue $l$loop_1;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      filteredFrames.j1(frame);
    }
    return filteredFrames;
  }
  var androidx_compose_runtime_tooling_WriterTraceBuilder$stable;
  var androidx_compose_runtime_tooling_ReaderTraceBuilder$stable;
  var androidx_compose_runtime_tooling_ComposeStackTraceBuilder$stable;
  var androidx_compose_runtime_tooling_ObjectLocation$stable;
  function ObjectLocation(group, dataOffset) {
    this.b3p_1 = group;
    this.c3p_1 = dataOffset;
  }
  protoOf(ObjectLocation).zh = function () {
    return this.b3p_1;
  };
  protoOf(ObjectLocation).ai = function () {
    return this.c3p_1;
  };
  protoOf(ObjectLocation).toString = function () {
    return 'ObjectLocation(group=' + this.b3p_1 + ', dataOffset=' + this.c3p_1 + ')';
  };
  protoOf(ObjectLocation).hashCode = function () {
    var result = this.b3p_1;
    result = imul(result, 31) + (this.c3p_1 == null ? 0 : this.c3p_1) | 0;
    return result;
  };
  protoOf(ObjectLocation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ObjectLocation))
      return false;
    if (!(this.b3p_1 === other.b3p_1))
      return false;
    if (!(this.c3p_1 == other.c3p_1))
      return false;
    return true;
  };
  function findLocation_1(_this__u8e3s4, filter) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
    // Inline function 'kotlin.let' call
    var reader = _this__u8e3s4.d3i();
    var tmp;
    try {
      var current = 0;
      while (current < _this__u8e3s4.j34_1) {
        if (reader.x34(current) && filter(reader.z34(current))) {
          return new ObjectLocation(current, null);
        }
        // Inline function 'kotlin.repeat' call
        var times = reader.x4b(current);
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = reader.o3n(current, index);
            if (filter(slot)) {
              return new ObjectLocation(current, index);
            }
          }
           while (inductionVariable < times);
        current = current + 1 | 0;
      }
      tmp = Unit_instance;
    }finally {
      reader.j4();
    }
    return null;
  }
  function buildTrace_3(_this__u8e3s4, child, group, parent) {
    child = child === VOID ? null : child;
    group = group === VOID ? _this__u8e3s4.b34_1 : group;
    parent = parent === VOID ? null : parent;
    var writer = _this__u8e3s4;
    if (!writer.e34_1 && !(writer.f4c() === 0)) {
      var traceBuilder = new WriterTraceBuilder(writer);
      var currentGroup = group;
      var parentGroup = parent == null ? writer.d34_1 < 0 ? writer.y34(currentGroup) : writer.d34_1 : parent;
      var childData = child == null ? writer.l4c(currentGroup) : child;
      var tmp;
      if (writer.p4c(currentGroup)) {
        tmp = writer.t3j(currentGroup);
      } else {
        currentGroup = parentGroup;
        if (currentGroup >= 0) {
          parentGroup = writer.y34(currentGroup);
        }
        tmp = writer.t3j(currentGroup);
      }
      var groupKey = tmp;
      while (currentGroup >= 0) {
        var tmp_0;
        if (writer.b3m(currentGroup)) {
          tmp_0 = writer.u3j(currentGroup);
        } else {
          tmp_0 = Companion_getInstance_0().f30_1;
        }
        var objectKey = tmp_0;
        traceBuilder.w4m(groupKey, objectKey, writer.g4c(currentGroup), childData);
        childData = writer.o3k(currentGroup);
        currentGroup = parentGroup;
        if (currentGroup >= 0) {
          parentGroup = writer.y34(currentGroup);
          groupKey = writer.t3j(currentGroup);
        }
      }
      return traceBuilder.x4m();
    }
    return emptyList();
  }
  function buildTrace_4(_this__u8e3s4) {
    var reader = _this__u8e3s4;
    if (!reader.b3j_1 && !(reader.n1() === 0)) {
      var traceBuilder = new ReaderTraceBuilder_0(reader);
      var currentGroup = reader.e3j_1;
      var childAnchor = reader.v4b();
      while (currentGroup >= 0) {
        var tmp;
        if (reader.b3m(currentGroup)) {
          tmp = reader.u3j(currentGroup);
        } else {
          tmp = Companion_getInstance_0().f30_1;
        }
        var objectKey = tmp;
        traceBuilder.w4m(reader.t3j(currentGroup), objectKey, reader.v3i_1.t4b(currentGroup), childAnchor);
        childAnchor = reader.o3k(currentGroup);
        var parentGroup = reader.y34(currentGroup);
        currentGroup = parentGroup;
      }
      return traceBuilder.x4m();
    }
    return emptyList();
  }
  function traceForGroup_0(_this__u8e3s4, group, child) {
    var reader = _this__u8e3s4;
    var traceBuilder = new ReaderTraceBuilder_0(reader);
    var currentGroup = group;
    var parentGroup = reader.y34(group);
    var parentAnchor = reader.o3k(currentGroup);
    var childAnchor = child;
    while (currentGroup >= 0) {
      var tmp;
      if (reader.b3m(currentGroup)) {
        tmp = reader.u3j(currentGroup);
      } else {
        tmp = Companion_getInstance_0().f30_1;
      }
      var objectKey = tmp;
      traceBuilder.w4m(reader.t3j(currentGroup), objectKey, reader.v3i_1.t4b(currentGroup), childAnchor);
      currentGroup = parentGroup;
      childAnchor = parentAnchor;
      if (currentGroup >= 0) {
        parentAnchor = reader.o3k(parentGroup);
        parentGroup = reader.y34(parentGroup);
      }
    }
    return traceBuilder.x4m();
  }
  function findSubcompositionContextGroup_0(_this__u8e3s4, context) {
    // Inline function 'androidx.compose.runtime.composer.gapbuffer.SlotTable.read' call
    // Inline function 'kotlin.let' call
    var reader = _this__u8e3s4.d3i();
    var tmp;
    try {
      return findSubcompositionContextGroup$scanGroup(context, reader, 0, reader.n1());
    }finally {
      reader.j4();
    }
  }
  function appendTraceFrame($this, groupKey, groupSourceInformation, child) {
    var frame = extractTraceFrame($this, groupKey, groupSourceInformation, child);
    if (!(frame == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      $this.v4m_1.j1(frame);
    }
  }
  function extractTraceFrame($this, groupKey, groupSourceInformation, targetChild) {
    var tmp1_safe_receiver = groupSourceInformation == null ? null : groupSourceInformation.n4b();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = parseSourceInformation(tmp1_safe_receiver);
    }
    var parsed = tmp;
    if (!(parsed == null)) {
      if (targetChild == null) {
        return new ComposeStackTraceFrame(groupKey, parsed, null);
      }
      var callCount = 0;
      var children = groupSourceInformation.ie();
      if (!(children == null)) {
        var inductionVariable = 0;
        var last = children.n1() - 1 | 0;
        if (inductionVariable <= last)
          $l$loop: do {
            var childIndex = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var child = children.l1(childIndex);
            if (equals(child, targetChild))
              break $l$loop;
            var sourceInfo = sourceInformationOf($this, child);
            var tmp_0;
            if (!(sourceInfo == null)) {
              var tmp_1;
              if (sourceInfo.t1() === -127) {
                tmp_1 = true;
              } else {
                var tmp_2;
                var tmp_3;
                if (sourceInfo.t1() === 0) {
                  tmp_3 = isInterface(child, Anchor);
                } else {
                  tmp_3 = false;
                }
                if (tmp_3) {
                  tmp_2 = $this.e4n(child) === -127;
                } else {
                  tmp_2 = false;
                }
                tmp_1 = tmp_2;
              }
              tmp_0 = tmp_1;
            } else {
              tmp_0 = false;
            }
            var isDefaultGroup = tmp_0;
            var tmp_4;
            if (isDefaultGroup) {
              tmp_4 = (sourceInfo == null ? null : sourceInfo.n4b()) == null;
            } else {
              tmp_4 = false;
            }
            if (tmp_4) {
              var tmp3_safe_receiver = sourceInfo == null ? null : sourceInfo.ie();
              if (tmp3_safe_receiver == null)
                null;
              else {
                // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
                var inductionVariable_0 = 0;
                var last_0 = tmp3_safe_receiver.n1() - 1 | 0;
                if (inductionVariable_0 <= last_0)
                  do {
                    var index = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var item = tmp3_safe_receiver.l1(index);
                    var tmp0_safe_receiver = sourceInformationOf($this, item);
                    if ((tmp0_safe_receiver == null ? null : isCall($this, tmp0_safe_receiver)) === true) {
                      callCount = callCount + 1 | 0;
                    }
                  }
                   while (inductionVariable_0 <= last_0);
              }
            } else {
              if ((sourceInfo == null ? null : isCall($this, sourceInfo)) === true) {
                callCount = callCount + 1 | 0;
              }
            }
          }
           while (inductionVariable <= last);
      }
      return new ComposeStackTraceFrame(groupKey, parsed, callCount);
    }
    return new ComposeStackTraceFrame(groupKey, null, null);
  }
  function sourceInformationOf($this, group) {
    var tmp;
    if (isInterface(group, Anchor)) {
      tmp = $this.d4n(group);
    } else {
      if (isInterface(group, GroupSourceInformation)) {
        tmp = group;
      } else {
        // Inline function 'kotlin.error' call
        var message = 'Unexpected child source info ' + toString(group);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    return tmp;
  }
  function isCall($this, $receiver) {
    var tmp0_safe_receiver = $receiver.n4b();
    return (tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, 'C')) === true;
  }
  function appendGroupSourceInformation($this, groupKey, sourceInformation, target) {
    var children = sourceInformation.ie();
    if (children == null) {
      if (!sourceInformation.k4b()) {
        appendTraceFrame($this, groupKey, sourceInformation, null);
        return true;
      }
      var slotStart = sourceInformation.m4b();
      var slotEnd = sourceInformation.l4b();
      if (typeof target === 'number') {
        var tmp;
        if (slotStart <= target ? target < slotEnd : false) {
          tmp = true;
        } else {
          tmp = (slotStart === slotEnd && equals(slotStart, target));
        }
        var found = tmp;
        if (found) {
          appendTraceFrame($this, sourceInformation.t1(), sourceInformation, null);
        }
        return found;
      }
      return false;
    }
    // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
    var inductionVariable = 0;
    var last = children.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = children.l1(index);
        if (isInterface(item, Anchor)) {
          if (equals(item, target)) {
            appendTraceFrame($this, sourceInformation.t1(), sourceInformation, item);
            return true;
          }
        } else {
          if (isInterface(item, GroupSourceInformation)) {
            var found_0 = appendGroupSourceInformation($this, groupKey, item, target);
            if (found_0) {
              appendTraceFrame($this, sourceInformation.t1(), sourceInformation, item);
              return true;
            }
          } else {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected child source info ' + toString(item);
            throw IllegalStateException_init_$Create$(toString(message));
          }
        }
      }
       while (inductionVariable <= last);
    return false;
  }
  function ComposeStackTraceBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.v4m_1 = ArrayList_init_$Create$();
  }
  protoOf(ComposeStackTraceBuilder).x4m = function () {
    return this.v4m_1;
  };
  protoOf(ComposeStackTraceBuilder).w4m = function (groupKey, objectKey, sourceInformation, childData) {
    if (sourceInformation == null && !equals(objectKey, Companion_getInstance_0().f30_1)) {
      return Unit_instance;
    } else if (childData == null || sourceInformation == null) {
      appendTraceFrame(this, groupKey, sourceInformation, null);
    } else {
      var found = appendGroupSourceInformation(this, groupKey, sourceInformation, childData);
      if (!found && !sourceInformation.k4b()) {
        appendTraceFrame(this, groupKey, sourceInformation, childData);
      }
    }
  };
  function WriterTraceBuilder(writer) {
    ComposeStackTraceBuilder.call(this);
    this.y5b_1 = writer;
  }
  protoOf(WriterTraceBuilder).d4n = function (anchor) {
    return this.y5b_1.g4c(this.y5b_1.q3m(asGapAnchor(anchor)));
  };
  protoOf(WriterTraceBuilder).e4n = function (anchor) {
    return this.y5b_1.t3j(this.y5b_1.q3m(asGapAnchor(anchor)));
  };
  function ReaderTraceBuilder_0(reader) {
    ComposeStackTraceBuilder.call(this);
    this.a5c_1 = reader;
  }
  protoOf(ReaderTraceBuilder_0).d4n = function (anchor) {
    return this.a5c_1.v3i_1.t4b(this.a5c_1.v3i_1.q3m(asGapAnchor(anchor)));
  };
  protoOf(ReaderTraceBuilder_0).e4n = function (anchor) {
    return this.a5c_1.t3j(this.a5c_1.v3i_1.q3m(asGapAnchor(anchor)));
  };
  function findSubcompositionContextGroup$scanGroup($context, $reader, group, end) {
    var current = group;
    while (current < end) {
      var next = current + $reader.a35(current) | 0;
      if ($reader.n3n(current) && $reader.t3j(current) === 206 && equals($reader.u3j(current), get_reference())) {
        var tmp = $reader.o3n(current, 0);
        var observerHolder = (!(tmp == null) ? isInterface(tmp, RememberObserverHolder) : false) ? tmp : null;
        var tmp_0 = observerHolder == null ? null : observerHolder.h33();
        var contextHolder = tmp_0 instanceof CompositionContextHolder ? tmp_0 : null;
        if (!(contextHolder == null) && equals(contextHolder.i3n_1, $context)) {
          return current;
        }
      }
      if ($reader.m3n(current)) {
        var tmp1_safe_receiver = findSubcompositionContextGroup$scanGroup($context, $reader, current + 1 | 0, next);
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp1_safe_receiver;
        }
      }
      current = next;
    }
    return null;
  }
  var androidx_compose_runtime_tooling_ComposeToolingFlags$stable;
  function ComposeToolingFlags() {
    this.f3f_1 = false;
  }
  var ComposeToolingFlags_instance;
  function ComposeToolingFlags_getInstance() {
    return ComposeToolingFlags_instance;
  }
  function get_LocalCompositionErrorContext() {
    _init_properties_CompositionErrorContext_kt__cykq73();
    return LocalCompositionErrorContext;
  }
  var LocalCompositionErrorContext;
  var androidx_compose_runtime_tooling_CompositionErrorContextImpl$stable;
  function Key_1() {
  }
  protoOf(Key_1).toString = function () {
    return 'CompositionErrorContext';
  };
  var Key_instance_3;
  function Key_getInstance_1() {
    return Key_instance_3;
  }
  function CompositionErrorContextImpl$attachComposeStackTrace$lambda(this$0, $composeNode) {
    return function () {
      return this$0.j3f_1.a33($composeNode);
    };
  }
  function CompositionErrorContextImpl(composer) {
    this.j3f_1 = composer;
  }
  protoOf(CompositionErrorContextImpl).k3f = function (_this__u8e3s4, composeNode) {
    return tryAttachComposeStackTrace(_this__u8e3s4, CompositionErrorContextImpl$attachComposeStackTrace$lambda(this, composeNode));
  };
  protoOf(CompositionErrorContextImpl).n4j = function (currentOffset) {
    return this.j3f_1.b33();
  };
  protoOf(CompositionErrorContextImpl).o4j = function () {
    return this.j3f_1.u32();
  };
  protoOf(CompositionErrorContextImpl).t1 = function () {
    return Key_instance_3;
  };
  function LocalCompositionErrorContext$lambda() {
    _init_properties_CompositionErrorContext_kt__cykq73();
    return null;
  }
  var properties_initialized_CompositionErrorContext_kt_dpy0kh;
  function _init_properties_CompositionErrorContext_kt__cykq73() {
    if (!properties_initialized_CompositionErrorContext_kt_dpy0kh) {
      properties_initialized_CompositionErrorContext_kt_dpy0kh = true;
      LocalCompositionErrorContext = staticCompositionLocalOf(LocalCompositionErrorContext$lambda);
      androidx_compose_runtime_tooling_CompositionErrorContextImpl$stable = 0;
    }
  }
  function ObservableComposition() {
  }
  function get_LocalInspectionTables() {
    _init_properties_InspectionTables_kt__ovfk2v();
    return LocalInspectionTables;
  }
  var LocalInspectionTables;
  function LocalInspectionTables$lambda() {
    _init_properties_InspectionTables_kt__ovfk2v();
    return null;
  }
  var properties_initialized_InspectionTables_kt_tgdbmt;
  function _init_properties_InspectionTables_kt__ovfk2v() {
    if (!properties_initialized_InspectionTables_kt_tgdbmt) {
      properties_initialized_InspectionTables_kt_tgdbmt = true;
      LocalInspectionTables = staticCompositionLocalOf(LocalInspectionTables$lambda);
    }
  }
  var androidx_compose_runtime_tooling_SourceInformation$stable;
  var androidx_compose_runtime_tooling_ParameterSourceInformation$stable;
  var androidx_compose_runtime_tooling_LocationSourceInformation$stable;
  function SourceInformation(isCall, isInline, functionName, sourceFile, parameters, packageHash, locations, rawData) {
    this.l5b_1 = isCall;
    this.m5b_1 = isInline;
    this.n5b_1 = functionName;
    this.o5b_1 = sourceFile;
    this.p5b_1 = parameters;
    this.q5b_1 = packageHash;
    this.r5b_1 = locations;
    this.s5b_1 = rawData;
  }
  function parseSourceInformation(data) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(data) === 0) {
      return null;
    }
    var tmp;
    try {
      tmp = parseSourceInformationInternal(data);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ParseException) {
        var e = $p;
        logError(e.b5c_1, e);
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function ParameterSourceInformation(sortedIndex, name, inlineClass) {
    name = name === VOID ? null : name;
    inlineClass = inlineClass === VOID ? null : inlineClass;
    this.c5c_1 = sortedIndex;
    this.d5c_1 = name;
    this.e5c_1 = inlineClass;
  }
  function LocationSourceInformation(lineNumber, offset, length, isRepeatable) {
    this.t5b_1 = lineNumber;
    this.u5b_1 = offset;
    this.v5b_1 = length;
    this.w5b_1 = isRepeatable;
  }
  function parseSourceInformationInternal(data) {
    var isCall = false;
    var isInline = false;
    var functionName = null;
    var p = new SourceInfoParserState(data);
    if (p.i5c(_Char___init__impl__6a9atx(67))) {
      isCall = true;
      p.h5c();
      if (p.i5c(_Char___init__impl__6a9atx(67))) {
        isInline = true;
        p.h5c();
      }
      if (p.i5c(_Char___init__impl__6a9atx(40))) {
        p.h5c();
        functionName = p.j5c(')');
        p.k5c(_Char___init__impl__6a9atx(41));
        p.h5c();
      }
    }
    var parameters = emptyList();
    while (hasSection(p)) {
      var sectionType = p.l5c();
      if (sectionType === _Char___init__impl__6a9atx(80)) {
        parameters = parseParameterIndex(p);
      } else if (sectionType === _Char___init__impl__6a9atx(78)) {
        parameters = parseParameterNames(p);
      } else {
        var count = 0;
        p.m5c(2);
        while (count > 0 || !p.i5c(_Char___init__impl__6a9atx(41))) {
          if (p.o5c()) {
            p.n5c('unexpected end');
          }
          if (p.i5c(_Char___init__impl__6a9atx(40))) {
            count = count + 1 | 0;
          } else if (p.i5c(_Char___init__impl__6a9atx(41))) {
            count = count - 1 | 0;
          }
          p.h5c();
        }
        p.k5c(_Char___init__impl__6a9atx(41));
        p.h5c();
      }
    }
    var locations = emptyList();
    if (!p.i5c(_Char___init__impl__6a9atx(58))) {
      locations = parseLocations(p);
    } else {
      p.h5c();
    }
    // Inline function 'kotlin.takeIf' call
    var this_0 = p.j5c('#');
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_0) > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var fileName = tmp;
    var packageHash = null;
    if (p.i5c(_Char___init__impl__6a9atx(35))) {
      p.h5c();
      packageHash = p.p5c();
    }
    return new SourceInformation(isCall, isInline, functionName, fileName, parameters, packageHash, locations, data);
  }
  function ParseException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, ParseException);
    this.b5c_1 = message;
    delete this.message;
  }
  protoOf(ParseException).e = function () {
    return this.b5c_1;
  };
  function SourceInfoParserState(data) {
    this.f5c_1 = data;
    this.g5c_1 = 0;
  }
  protoOf(SourceInfoParserState).k5c = function (char) {
    if (!this.i5c(char)) {
      this.n5c('expected ' + toString_2(char));
    }
  };
  protoOf(SourceInfoParserState).n5c = function (message) {
    var tmp0 = this.g5c_1;
    // Inline function 'kotlin.math.min' call
    var b = this.f5c_1.length;
    var end = Math.min(tmp0, b);
    throw new ParseException('Error while parsing source information: ' + message + ' at ' + (substring(this.f5c_1, 0, end) + '|' + substring_0(this.f5c_1, end)));
  };
  protoOf(SourceInfoParserState).i5c = function (char) {
    return this.g5c_1 < this.f5c_1.length && charCodeAt(this.f5c_1, this.g5c_1) === char;
  };
  protoOf(SourceInfoParserState).q5c = function (separator) {
    var int = toIntOrNull(this.j5c(separator));
    var tmp;
    if (int == null) {
      this.n5c('expected int');
    } else {
      tmp = int;
    }
    return tmp;
  };
  protoOf(SourceInfoParserState).j5c = function (separator) {
    var start = this.g5c_1;
    this.r5c(separator);
    return this.g5c_1 > start ? substring(this.f5c_1, start, this.g5c_1) : '';
  };
  protoOf(SourceInfoParserState).p5c = function () {
    return substring(this.f5c_1, this.g5c_1, this.f5c_1.length);
  };
  protoOf(SourceInfoParserState).r5c = function (separator) {
    while (this.g5c_1 < this.f5c_1.length && !contains_1(separator, charCodeAt(this.f5c_1, this.g5c_1))) {
      this.g5c_1 = this.g5c_1 + 1 | 0;
    }
  };
  protoOf(SourceInfoParserState).m5c = function (count) {
    this.g5c_1 = this.g5c_1 + count | 0;
  };
  protoOf(SourceInfoParserState).h5c = function (count, $super) {
    count = count === VOID ? 1 : count;
    var tmp;
    if ($super === VOID) {
      this.m5c(count);
      tmp = Unit_instance;
    } else {
      tmp = $super.m5c.call(this, count);
    }
    return tmp;
  };
  protoOf(SourceInfoParserState).l5c = function () {
    return charCodeAt(this.f5c_1, this.g5c_1);
  };
  protoOf(SourceInfoParserState).o5c = function () {
    return this.g5c_1 >= this.f5c_1.length;
  };
  function parseParameterIndex(_this__u8e3s4) {
    _this__u8e3s4.m5c(2);
    // Inline function 'kotlin.collections.mutableListOf' call
    var parameters = ArrayList_init_$Create$();
    var pendingRun = false;
    while (!_this__u8e3s4.o5c() && !_this__u8e3s4.i5c(_Char___init__impl__6a9atx(41))) {
      if (_this__u8e3s4.i5c(_Char___init__impl__6a9atx(33))) {
        _this__u8e3s4.h5c();
        var countString = _this__u8e3s4.j5c('!,)');
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(countString) === 0) {
          pendingRun = true;
        } else {
          var count = toInt(countString);
          var nextIndex = 0;
          $l$loop: while (count > 0) {
            var tmp$ret$2;
            $l$block: {
              // Inline function 'androidx.compose.runtime.snapshots.fastAny' call
              // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
              var inductionVariable = 0;
              var last = parameters.n1() - 1 | 0;
              if (inductionVariable <= last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var item = parameters.l1(index);
                  if (item.c5c_1 === nextIndex) {
                    tmp$ret$2 = true;
                    break $l$block;
                  }
                }
                 while (inductionVariable <= last);
              tmp$ret$2 = false;
            }
            if (tmp$ret$2) {
              nextIndex = nextIndex + 1 | 0;
              continue $l$loop;
            }
            parameters.j1(new ParameterSourceInformation(nextIndex));
            count = count - 1 | 0;
          }
        }
      } else {
        var index_0 = _this__u8e3s4.q5c('!:,)');
        var inlineClass = null;
        if (_this__u8e3s4.i5c(_Char___init__impl__6a9atx(58))) {
          _this__u8e3s4.h5c();
          inlineClass = replaceComposePrefix(_this__u8e3s4.j5c('!,)'));
        }
        if (pendingRun) {
          var nextIndex_0 = 0;
          var maxIndex = index_0;
          $l$loop_0: while (nextIndex_0 < maxIndex) {
            var tmp$ret$6;
            $l$block_0: {
              // Inline function 'androidx.compose.runtime.snapshots.fastAny' call
              // Inline function 'androidx.compose.runtime.snapshots.fastForEach' call
              var inductionVariable_0 = 0;
              var last_0 = parameters.n1() - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_1 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item_0 = parameters.l1(index_1);
                  if (item_0.c5c_1 === nextIndex_0) {
                    tmp$ret$6 = true;
                    break $l$block_0;
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp$ret$6 = false;
            }
            if (tmp$ret$6) {
              nextIndex_0 = nextIndex_0 + 1 | 0;
              continue $l$loop_0;
            }
            parameters.j1(new ParameterSourceInformation(nextIndex_0));
          }
          pendingRun = false;
        }
        parameters.j1(new ParameterSourceInformation(index_0, VOID, inlineClass));
      }
      if (_this__u8e3s4.i5c(_Char___init__impl__6a9atx(44))) {
        _this__u8e3s4.h5c();
      }
    }
    _this__u8e3s4.k5c(_Char___init__impl__6a9atx(41));
    _this__u8e3s4.h5c();
    return parameters;
  }
  function parseParameterNames(_this__u8e3s4) {
    _this__u8e3s4.m5c(2);
    // Inline function 'kotlin.collections.mutableListOf' call
    var parameters = ArrayList_init_$Create$();
    while (!_this__u8e3s4.o5c() && !_this__u8e3s4.i5c(_Char___init__impl__6a9atx(41))) {
      var name = _this__u8e3s4.j5c(':,)');
      var inlineClass = null;
      if (_this__u8e3s4.i5c(_Char___init__impl__6a9atx(58))) {
        _this__u8e3s4.h5c();
        inlineClass = replaceComposePrefix(_this__u8e3s4.j5c(',)'));
      }
      var tmp0_sortedIndex = parameters.n1();
      var tmp1_inlineClass = inlineClass;
      parameters.j1(new ParameterSourceInformation(tmp0_sortedIndex, name, tmp1_inlineClass));
      if (_this__u8e3s4.i5c(_Char___init__impl__6a9atx(44))) {
        _this__u8e3s4.h5c();
      }
    }
    _this__u8e3s4.k5c(_Char___init__impl__6a9atx(41));
    _this__u8e3s4.h5c();
    return parameters;
  }
  function hasSection(_this__u8e3s4) {
    return _this__u8e3s4.g5c_1 < (_this__u8e3s4.f5c_1.length - 1 | 0) && isLetter(charCodeAt(_this__u8e3s4.f5c_1, _this__u8e3s4.g5c_1)) && charCodeAt(_this__u8e3s4.f5c_1, _this__u8e3s4.g5c_1 + 1 | 0) === _Char___init__impl__6a9atx(40);
  }
  function parseLocations(_this__u8e3s4) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var locations = ArrayList_init_$Create$();
    while (!_this__u8e3s4.o5c() && !_this__u8e3s4.i5c(_Char___init__impl__6a9atx(58))) {
      var repeatable = false;
      if (_this__u8e3s4.i5c(_Char___init__impl__6a9atx(42))) {
        repeatable = true;
        _this__u8e3s4.h5c();
      }
      var lineNumber = null;
      if (!_this__u8e3s4.i5c(_Char___init__impl__6a9atx(64))) {
        lineNumber = _this__u8e3s4.q5c('@') + 1 | 0;
      }
      _this__u8e3s4.h5c();
      var offset = _this__u8e3s4.q5c('L,:');
      var length = null;
      if (_this__u8e3s4.i5c(_Char___init__impl__6a9atx(76))) {
        _this__u8e3s4.h5c();
        length = _this__u8e3s4.q5c(',:');
      }
      var tmp0_elvis_lhs = lineNumber;
      var tmp = tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = length;
      locations.j1(new LocationSourceInformation(tmp, offset, tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs, repeatable));
      if (_this__u8e3s4.i5c(_Char___init__impl__6a9atx(44))) {
        _this__u8e3s4.h5c();
      }
    }
    _this__u8e3s4.h5c();
    return locations;
  }
  function replaceComposePrefix(_this__u8e3s4) {
    return replaceFirst(_this__u8e3s4, 'c#', 'androidx.compose.');
  }
  function identityHashCode(instance) {
    return identityHashCode_0(instance);
  }
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function ComposableLambda$invoke$ref_0(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ComposableLambda$invoke$ref_1(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function set_nextHash(_set____db54di) {
    _init_properties_System_js_kt__dn51u2();
    nextHash = _set____db54di;
  }
  function get_nextHash() {
    _init_properties_System_js_kt__dn51u2();
    return nextHash;
  }
  var nextHash;
  function get_weakMap() {
    _init_properties_System_js_kt__dn51u2();
    return weakMap;
  }
  var weakMap;
  function identityHashCode_0(instance) {
    _init_properties_System_js_kt__dn51u2();
    if (instance == null) {
      return 0;
    }
    var tmp0_elvis_lhs = get_weakMap().get(instance);
    return tmp0_elvis_lhs == null ? memoizeIdentityHashCode(instance) : tmp0_elvis_lhs;
  }
  function memoizeIdentityHashCode(instance) {
    _init_properties_System_js_kt__dn51u2();
    var _unary__edvuaz = get_nextHash();
    set_nextHash(_unary__edvuaz + 1 | 0);
    var value = _unary__edvuaz;
    get_weakMap().set(instance, value);
    return value;
  }
  var properties_initialized_System_js_kt_4jrb3c;
  function _init_properties_System_js_kt__dn51u2() {
    if (!properties_initialized_System_js_kt_4jrb3c) {
      properties_initialized_System_js_kt_4jrb3c = true;
      nextHash = 1;
      weakMap = new WeakMap();
    }
  }
  var androidx_compose_runtime_internal_WeakReference$stable;
  function WeakReference(reference) {
    this.f56_1 = new WeakRef(reference);
  }
  protoOf(WeakReference).f1i = function () {
    var tmp0_safe_receiver = this.f56_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.deref();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp1_safe_receiver;
    }
    return tmp;
  };
  var androidx_compose_runtime_snapshots_SnapshotIdArrayBuilder$stable;
  function toSnapshotId(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  function snapshotIdArrayWithCapacity(capacity) {
    return new Float64Array(capacity);
  }
  function binarySearch(_this__u8e3s4, id) {
    var low = 0;
    var high = _this__u8e3s4.length - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1 | 0;
      var midVal = _this__u8e3s4[mid];
      if (id > midVal)
        low = mid + 1 | 0;
      else if (id < midVal)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function SnapshotIdArrayBuilder(array) {
    var tmp = this;
    var tmp_0;
    if (array == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'androidx.collection.mutableDoubleListOf' call
      var elements = array.slice();
      // Inline function 'kotlin.apply' call
      var this_0 = new MutableDoubleList(elements.length);
      // Inline function 'androidx.collection.MutableDoubleList.plusAssign' call
      this_0.ut(this_0.tt_1, elements);
      tmp_0 = this_0;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'androidx.collection.mutableDoubleListOf' call
      tmp_1 = new MutableDoubleList();
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    tmp.k57_1 = tmp_1;
  }
  protoOf(SnapshotIdArrayBuilder).l57 = function (id) {
    this.k57_1.rt(id);
  };
  protoOf(SnapshotIdArrayBuilder).w5 = function () {
    // Inline function 'androidx.collection.DoubleList.size' call
    var size = this.k57_1.tt_1;
    if (size === 0)
      return null;
    var result = new Float64Array(size);
    // Inline function 'androidx.collection.DoubleList.forEachIndexed' call
    var this_0 = this.k57_1;
    // Inline function 'kotlin.contracts.contract' call
    var content = this_0.st_1;
    var inductionVariable = 0;
    var last = this_0.tt_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result[i] = content[i];
      }
       while (inductionVariable < last);
    return result;
  };
  function withIdInsertedAt(_this__u8e3s4, index, id) {
    var newSize = _this__u8e3s4.length + 1 | 0;
    var newArray = new Float64Array(newSize);
    // Inline function 'kotlin.collections.copyInto' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = _this__u8e3s4;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newArray, 0, 0, index);
    var tmp4 = index + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = newSize - 1 | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = _this__u8e3s4;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp_0, newArray, tmp4, index, endIndex);
    newArray[index] = id;
    return newArray;
  }
  function withIdRemovedAt(_this__u8e3s4, index) {
    var newSize = _this__u8e3s4.length - 1 | 0;
    if (newSize === 0) {
      return null;
    }
    var newArray = new Float64Array(newSize);
    if (index > 0) {
      // Inline function 'kotlin.collections.copyInto' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = _this__u8e3s4;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, newArray, 0, 0, index);
    }
    if (index < newSize) {
      var tmp6 = index + 1 | 0;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = newSize + 1 | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = _this__u8e3s4;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_0, newArray, index, tmp6, endIndex);
    }
    return newArray;
  }
  function createSnapshotMutableFloatState(value) {
    return new SnapshotMutableFloatStateImpl(value);
  }
  function createSnapshotMutableIntState(value) {
    return new SnapshotMutableIntStateImpl(value);
  }
  function createSnapshotMutableLongState(value) {
    return new SnapshotMutableLongStateImpl(value);
  }
  function createSnapshotMutableState(value, policy) {
    return new SnapshotMutableStateImpl(value, policy);
  }
  function get_MainThreadId() {
    return MainThreadId;
  }
  var MainThreadId;
  var androidx_compose_runtime_internal_Trace$stable;
  function Trace() {
  }
  protoOf(Trace).r38 = function (name) {
    return null;
  };
  protoOf(Trace).t38 = function (token) {
  };
  var Trace_instance;
  function Trace_getInstance() {
    return Trace_instance;
  }
  var androidx_compose_runtime_snapshots_SnapshotStateList$stable;
  function SnapshotStateList_init_$Init$($this) {
    SnapshotStateList.call($this, persistentListOf());
    return $this;
  }
  function SnapshotStateList_init_$Create$() {
    return SnapshotStateList_init_$Init$(objectCreate(protoOf(SnapshotStateList)));
  }
  function SnapshotStateList$addAll$lambda($index, $elements) {
    return function (it) {
      return it.e3($index, $elements);
    };
  }
  function SnapshotStateList(persistentList) {
    this.r49_1 = stateRecordWith(this, persistentList);
  }
  protoOf(SnapshotStateList).f3e = function () {
    return this.r49_1;
  };
  protoOf(SnapshotStateList).y3e = function (value) {
    value.m3e_1 = this.r49_1;
    var tmp = this;
    tmp.r49_1 = value instanceof StateListStateRecord ? value : THROW_CCE();
  };
  protoOf(SnapshotStateList).s5c = function () {
    return get_readable(this).o57_1;
  };
  protoOf(SnapshotStateList).n1 = function () {
    return get_readable(this).o57_1.n1();
  };
  protoOf(SnapshotStateList).lh = function (element) {
    return get_readable(this).o57_1.m1(element);
  };
  protoOf(SnapshotStateList).m1 = function (element) {
    if (!true)
      return false;
    return this.lh(element);
  };
  protoOf(SnapshotStateList).mh = function (elements) {
    return get_readable(this).o57_1.r2(elements);
  };
  protoOf(SnapshotStateList).r2 = function (elements) {
    return this.mh(elements);
  };
  protoOf(SnapshotStateList).l1 = function (index) {
    return get_readable(this).o57_1.l1(index);
  };
  protoOf(SnapshotStateList).yz = function (element) {
    return get_readable(this).o57_1.q1(element);
  };
  protoOf(SnapshotStateList).q1 = function (element) {
    if (!true)
      return -1;
    return this.yz(element);
  };
  protoOf(SnapshotStateList).r = function () {
    return get_readable(this).o57_1.r();
  };
  protoOf(SnapshotStateList).t = function () {
    return this.s2();
  };
  protoOf(SnapshotStateList).s2 = function () {
    return new StateListIterator(this, 0);
  };
  protoOf(SnapshotStateList).p1 = function (index) {
    return new StateListIterator(this, index);
  };
  protoOf(SnapshotStateList).t2 = function (fromIndex, toIndex) {
    // Inline function 'androidx.compose.runtime.requirePrecondition' call
    if (!((0 <= fromIndex ? fromIndex <= toIndex : false) && toIndex <= this.n1())) {
      var tmp$ret$1 = 'fromIndex or toIndex are out of bounds';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return new SubList_1(this, fromIndex, toIndex);
  };
  protoOf(SnapshotStateList).toString = function () {
    var tmp = this.r49_1;
    // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
    var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var it = current_0(this_0);
    return 'SnapshotStateList(value=' + toString(it.o57_1) + ')@' + hashCode(this);
  };
  protoOf(SnapshotStateList).zz = function (element) {
    // Inline function 'androidx.compose.runtime.snapshots.conditionalUpdate' call
    // Inline function 'kotlin.run' call
    var result;
    $l$loop_0: while (true) {
      var oldList = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      access$_get_sync_$tSnapshotStateListKt_vydypg();
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var tmp = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      currentModification = current.p57_1;
      oldList = current.o57_1;
      var newList = ensureNotNull(oldList).j1(element);
      if (equals(newList, oldList)) {
        result = false;
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var tmp_0 = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var this_1 = tmp_0 instanceof StateListStateRecord ? tmp_0 : THROW_CCE();
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      var $this$writable = writableRecord(this_1, this, snapshot);
      // Inline function 'kotlin.also' call
      var this_2 = attemptUpdate($this$writable, currentModification, newList, true);
      notifyWrite(snapshot, this);
      if (this_2) {
        result = true;
        break $l$loop_0;
      }
    }
    return result;
  };
  protoOf(SnapshotStateList).j1 = function (element) {
    return this.zz(element);
  };
  protoOf(SnapshotStateList).ni = function (index, element) {
    // Inline function 'androidx.compose.runtime.snapshots.update' call
    // Inline function 'androidx.compose.runtime.snapshots.conditionalUpdate' call
    // Inline function 'kotlin.run' call
    var result;
    $l$loop_0: while (true) {
      var oldList = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      access$_get_sync_$tSnapshotStateListKt_vydypg();
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var tmp = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      currentModification = current.p57_1;
      oldList = current.o57_1;
      var newList = ensureNotNull(oldList).d4v(index, element);
      if (equals(newList, oldList)) {
        result = false;
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var tmp_0 = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var this_1 = tmp_0 instanceof StateListStateRecord ? tmp_0 : THROW_CCE();
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      var $this$writable = writableRecord(this_1, this, snapshot);
      // Inline function 'kotlin.also' call
      var this_2 = attemptUpdate($this$writable, currentModification, newList, true);
      notifyWrite(snapshot, this);
      if (this_2) {
        result = true;
        break $l$loop_0;
      }
    }
    return Unit_instance;
  };
  protoOf(SnapshotStateList).g3 = function (index, element) {
    return this.ni(index, element);
  };
  protoOf(SnapshotStateList).d10 = function (index, elements) {
    return mutateBoolean(this, SnapshotStateList$addAll$lambda(index, elements));
  };
  protoOf(SnapshotStateList).e3 = function (index, elements) {
    return this.d10(index, elements);
  };
  protoOf(SnapshotStateList).e10 = function (elements) {
    // Inline function 'androidx.compose.runtime.snapshots.conditionalUpdate' call
    // Inline function 'kotlin.run' call
    var result;
    $l$loop_0: while (true) {
      var oldList = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      access$_get_sync_$tSnapshotStateListKt_vydypg();
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var tmp = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      currentModification = current.p57_1;
      oldList = current.o57_1;
      var newList = ensureNotNull(oldList).o1(elements);
      if (equals(newList, oldList)) {
        result = false;
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var tmp_0 = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var this_1 = tmp_0 instanceof StateListStateRecord ? tmp_0 : THROW_CCE();
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      var $this$writable = writableRecord(this_1, this, snapshot);
      // Inline function 'kotlin.also' call
      var this_2 = attemptUpdate($this$writable, currentModification, newList, true);
      notifyWrite(snapshot, this);
      if (this_2) {
        result = true;
        break $l$loop_0;
      }
    }
    return result;
  };
  protoOf(SnapshotStateList).o1 = function (elements) {
    return this.e10(elements);
  };
  protoOf(SnapshotStateList).c3 = function () {
    // Inline function 'androidx.compose.runtime.snapshots.clearImpl' call
    // Inline function 'androidx.compose.runtime.snapshots.writable' call
    var tmp = this.r49_1;
    // Inline function 'androidx.compose.runtime.snapshots.writable' call
    var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var snapshot;
    // Inline function 'androidx.compose.runtime.snapshots.sync' call
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    get_lock();
    snapshot = Companion_instance_18.e2y();
    var $this$writable = writableRecord(this_0, this, snapshot);
    // Inline function 'androidx.compose.runtime.platform.synchronized' call
    access$_get_sync_$tSnapshotStateListKt_vydypg();
    $this$writable.o57_1 = persistentListOf();
    $this$writable.p57_1 = $this$writable.p57_1 + 1 | 0;
    $this$writable.q57_1 = $this$writable.q57_1 + 1 | 0;
    // Inline function 'kotlin.also' call
    notifyWrite(snapshot, this);
    return Unit_instance;
  };
  protoOf(SnapshotStateList).g10 = function (element) {
    // Inline function 'androidx.compose.runtime.snapshots.conditionalUpdate' call
    // Inline function 'kotlin.run' call
    var result;
    $l$loop_0: while (true) {
      var oldList = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      access$_get_sync_$tSnapshotStateListKt_vydypg();
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var tmp = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      currentModification = current.p57_1;
      oldList = current.o57_1;
      var newList = ensureNotNull(oldList).d3(element);
      if (equals(newList, oldList)) {
        result = false;
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var tmp_0 = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var this_1 = tmp_0 instanceof StateListStateRecord ? tmp_0 : THROW_CCE();
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      var $this$writable = writableRecord(this_1, this, snapshot);
      // Inline function 'kotlin.also' call
      var this_2 = attemptUpdate($this$writable, currentModification, newList, true);
      notifyWrite(snapshot, this);
      if (this_2) {
        result = true;
        break $l$loop_0;
      }
    }
    return result;
  };
  protoOf(SnapshotStateList).d3 = function (element) {
    if (!true)
      return false;
    return this.g10(element);
  };
  protoOf(SnapshotStateList).h3 = function (index) {
    // Inline function 'kotlin.also' call
    var this_0 = this.l1(index);
    // Inline function 'androidx.compose.runtime.snapshots.update' call
    // Inline function 'androidx.compose.runtime.snapshots.conditionalUpdate' call
    // Inline function 'kotlin.run' call
    var result;
    $l$loop_0: while (true) {
      var oldList = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      access$_get_sync_$tSnapshotStateListKt_vydypg();
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var tmp = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_1 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_1);
      currentModification = current.p57_1;
      oldList = current.o57_1;
      var newList = ensureNotNull(oldList).h3(index);
      if (equals(newList, oldList)) {
        result = false;
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var tmp_0 = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var this_2 = tmp_0 instanceof StateListStateRecord ? tmp_0 : THROW_CCE();
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      var $this$writable = writableRecord(this_2, this, snapshot);
      // Inline function 'kotlin.also' call
      var this_3 = attemptUpdate($this$writable, currentModification, newList, true);
      notifyWrite(snapshot, this);
      if (this_3) {
        result = true;
        break $l$loop_0;
      }
    }
    return this_0;
  };
  protoOf(SnapshotStateList).mi = function (index, element) {
    // Inline function 'kotlin.also' call
    var this_0 = this.l1(index);
    // Inline function 'androidx.compose.runtime.snapshots.update' call
    // Inline function 'androidx.compose.runtime.snapshots.conditionalUpdate' call
    // Inline function 'kotlin.run' call
    var result;
    $l$loop_0: while (true) {
      var oldList = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      access$_get_sync_$tSnapshotStateListKt_vydypg();
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var tmp = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_1 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_1);
      currentModification = current.p57_1;
      oldList = current.o57_1;
      var newList = ensureNotNull(oldList).f3(index, element);
      if (equals(newList, oldList)) {
        result = false;
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var tmp_0 = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.writable' call
      var this_2 = tmp_0 instanceof StateListStateRecord ? tmp_0 : THROW_CCE();
      var snapshot;
      // Inline function 'androidx.compose.runtime.snapshots.sync' call
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      get_lock();
      snapshot = Companion_instance_18.e2y();
      var $this$writable = writableRecord(this_2, this, snapshot);
      // Inline function 'kotlin.also' call
      var this_3 = attemptUpdate($this$writable, currentModification, newList, false);
      notifyWrite(snapshot, this);
      if (this_3) {
        result = true;
        break $l$loop_0;
      }
    }
    return this_0;
  };
  protoOf(SnapshotStateList).f3 = function (index, element) {
    return this.mi(index, element);
  };
  protoOf(SnapshotStateList).e5 = function (fromIndex, toIndex) {
    // Inline function 'androidx.compose.runtime.snapshots.mutate' call
    var result;
    $l$loop: while (true) {
      var oldList = null;
      var currentModification = 0;
      // Inline function 'androidx.compose.runtime.platform.synchronized' call
      access$_get_sync_$tSnapshotStateListKt_vydypg();
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var tmp = this.r49_1;
      // Inline function 'androidx.compose.runtime.snapshots.withCurrent' call
      var this_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
      var current = current_0(this_0);
      currentModification = current.p57_1;
      oldList = current.o57_1;
      var builder = ensureNotNull(oldList).a3d();
      builder.t2(fromIndex, toIndex).c3();
      result = Unit_instance;
      var newList = builder.g3d();
      var tmp_0;
      if (equals(newList, oldList)) {
        tmp_0 = true;
      } else {
        // Inline function 'androidx.compose.runtime.snapshots.writable' call
        var tmp_1 = this.r49_1;
        // Inline function 'androidx.compose.runtime.snapshots.writable' call
        var this_1 = tmp_1 instanceof StateListStateRecord ? tmp_1 : THROW_CCE();
        var snapshot;
        // Inline function 'androidx.compose.runtime.snapshots.sync' call
        // Inline function 'androidx.compose.runtime.platform.synchronized' call
        get_lock();
        snapshot = Companion_instance_18.e2y();
        var $this$writable = writableRecord(this_1, this, snapshot);
        // Inline function 'kotlin.also' call
        var this_2 = attemptUpdate($this$writable, currentModification, newList, true);
        notifyWrite(snapshot, this);
        tmp_0 = this_2;
      }
      if (tmp_0)
        break $l$loop;
    }
  };
  var androidx_compose_runtime_snapshots_SnapshotStateSet$stable;
  var androidx_compose_runtime_TracingContext$stable;
  function Key_2() {
  }
  var Key_instance_4;
  function Key_getInstance_2() {
    return Key_instance_4;
  }
  function TracingContext(name) {
    this.n3f_1 = name;
  }
  protoOf(TracingContext).t1 = function () {
    return Key_instance_4;
  };
  var androidx_compose_runtime_internal_AtomicReference$stable;
  var androidx_compose_runtime_internal_AtomicInt$stable;
  function AtomicReference(value) {
    this.p37_1 = atomic$ref$1(value);
  }
  protoOf(AtomicReference).f1i = function () {
    return this.p37_1.kotlinx$atomicfu$value;
  };
  protoOf(AtomicReference).k2p = function (value) {
    this.p37_1.kotlinx$atomicfu$value = value;
  };
  protoOf(AtomicReference).x21 = function (value) {
    return this.p37_1.atomicfu$getAndSet(value);
  };
  protoOf(AtomicReference).w21 = function (expect, newValue) {
    return this.p37_1.atomicfu$compareAndSet(expect, newValue);
  };
  function AtomicInt(value) {
    this.j50_1 = atomic$int$1(value);
  }
  protoOf(AtomicInt).f1i = function () {
    return this.j50_1.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).k50 = function (value) {
    this.j50_1.kotlinx$atomicfu$value = value;
  };
  protoOf(AtomicInt).pv = function (amount) {
    return this.j50_1.atomicfu$addAndGet(amount);
  };
  protoOf(AtomicInt).l50 = function (expect, newValue) {
    return this.j50_1.atomicfu$compareAndSet(expect, newValue);
  };
  var androidx_compose_runtime_internal_PlatformOptimizedCancellationException$stable;
  function PlatformOptimizedCancellationException(message) {
    message = message === VOID ? null : message;
    CancellationException_init_$Init$(message, this);
    captureStack(this, PlatformOptimizedCancellationException);
  }
  function invokeComposable(composer, composable) {
    var realFn = typeof composable === 'function' ? composable : THROW_CCE();
    realFn(composer, 1);
  }
  function logError(message, e) {
    println(message);
    println(stackTraceToString(e));
  }
  var androidx_compose_runtime_snapshots_SnapshotContextElementImpl$stable;
  var androidx_compose_runtime_tooling_DiagnosticComposeException$stable;
  function DiagnosticComposeException(trace) {
    RuntimeException_init_$Init$_0(this);
    captureStack(this, DiagnosticComposeException);
    this.t5c_1 = trace;
    delete this.message;
  }
  protoOf(DiagnosticComposeException).e = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.text.appendLine' call
    var value = 'Composition stack when thrown:';
    // Inline function 'kotlin.text.appendLine' call
    this_0.q(value).s(_Char___init__impl__6a9atx(10));
    appendStackTrace(this_0, this.t5c_1);
    return this_0.toString();
  };
  function currentThreadId() {
    return new Long(0, 0);
  }
  function currentThreadName() {
    return 'main';
  }
  //region block: post-declaration
  protoOf(AbstractApplier).f2y = onBeginChanges;
  protoOf(AbstractApplier).g2y = onEndChanges;
  protoOf(AbstractApplier).n2y = apply;
  protoOf(AbstractApplier).o2y = reuse;
  protoOf(ThrowingApplierStub).f2y = onBeginChanges;
  protoOf(ThrowingApplierStub).g2y = onEndChanges;
  protoOf(ThrowingApplierStub).n2y = apply;
  protoOf(ThrowingApplierStub).o2y = reuse;
  protoOf(OffsetApplier).f2y = onBeginChanges;
  protoOf(OffsetApplier).g2y = onEndChanges;
  protoOf(BroadcastFrameClock).t1 = get_key;
  protoOf(BroadcastFrameClock).aa = get;
  protoOf(BroadcastFrameClock).wj = fold;
  protoOf(BroadcastFrameClock).vj = minusKey;
  protoOf(BroadcastFrameClock).xj = plus;
  defineProp(protoOf(ComposeRuntimeError), 'message', function () {
    return this.e();
  });
  protoOf(InternalComposer).l31 = changed;
  protoOf(InternalComposer).m31 = changed_0;
  protoOf(InternalComposer).n31 = changed_1;
  protoOf(InternalComposer).o31 = changed_2;
  protoOf(InternalComposer).p31 = changed_3;
  protoOf(InternalComposer).q31 = changedInstance;
  protoOf(StateObjectImpl).a3f = mergeRecords;
  protoOf(LaunchedEffectImpl).aa = get;
  protoOf(LaunchedEffectImpl).wj = fold;
  protoOf(LaunchedEffectImpl).vj = minusKey;
  protoOf(LaunchedEffectImpl).xj = plus;
  protoOf(TracingContext).aa = get;
  protoOf(TracingContext).wj = fold;
  protoOf(TracingContext).vj = minusKey;
  protoOf(TracingContext).xj = plus;
  protoOf(CancelledCoroutineContext).aa = get;
  protoOf(CancelledCoroutineContext).wj = fold;
  protoOf(CancelledCoroutineContext).vj = minusKey;
  protoOf(CancelledCoroutineContext).xj = plus;
  protoOf(RecordingApplier).f2y = onBeginChanges;
  protoOf(RecordingApplier).g2y = onEndChanges;
  defineProp(protoOf(ComposePausableCompositionException), 'message', function () {
    return this.e();
  });
  protoOf(SnapshotMutableFloatStateImpl).h45 = set_value;
  protoOf(SnapshotMutableFloatStateImpl).u1 = get_value;
  protoOf(SnapshotMutableIntStateImpl).z48 = set_value_0;
  protoOf(SnapshotMutableIntStateImpl).u1 = get_value_0;
  protoOf(SnapshotMutableLongStateImpl).h49 = set_value_1;
  protoOf(SnapshotMutableLongStateImpl).u1 = get_value_1;
  protoOf(StructuralEqualityPolicy).p49 = merge;
  protoOf(NeverEqualPolicy).p49 = merge;
  protoOf(ReferentialEqualityPolicy).p49 = merge;
  protoOf(PersistentCompositionLocalHashMap).z3c = get_currentValue;
  protoOf(SnapshotStateMap).a3f = mergeRecords;
  protoOf(CompositionErrorContextImpl).aa = get;
  protoOf(CompositionErrorContextImpl).wj = fold;
  protoOf(CompositionErrorContextImpl).vj = minusKey;
  protoOf(CompositionErrorContextImpl).xj = plus;
  defineProp(protoOf(ParseException), 'message', function () {
    return this.e();
  });
  protoOf(SnapshotStateList).a3f = mergeRecords;
  defineProp(protoOf(DiagnosticComposeException), 'message', function () {
    return this.e();
  });
  //endregion
  //region block: init
  androidx_compose_runtime_AbstractApplier$stable = 8;
  androidx_compose_runtime_OffsetApplier$stable = 8;
  androidx_compose_runtime_ThrowingApplierStub$stable = 0;
  ThrowingApplierStub_instance = new ThrowingApplierStub();
  androidx_compose_runtime_BroadcastFrameClock$stable = 8;
  androidx_compose_runtime_OneShotCancellationHandle$stable = 8;
  androidx_compose_runtime_ComposeRuntimeFlags$stable = 8;
  ComposeRuntimeFlags_instance = new ComposeRuntimeFlags();
  androidx_compose_runtime_ComposeVersion$stable = 0;
  ScopeInvalidated_instance = new ScopeInvalidated();
  androidx_compose_runtime_CompositionLocal$stable = 0;
  androidx_compose_runtime_ProvidableCompositionLocal$stable = 0;
  androidx_compose_runtime_DynamicProvidableCompositionLocal$stable = 0;
  androidx_compose_runtime_StaticProvidableCompositionLocal$stable = 0;
  androidx_compose_runtime_ComputedProvidableCompositionLocal$stable = 0;
  androidx_compose_runtime_CompositionLocalContext$stable = 0;
  Key_instance_1 = new Key();
  androidx_compose_runtime_JoinedKey$stable = 8;
  androidx_compose_runtime_Latch$stable = 8;
  androidx_compose_runtime_LinkComposer_CompositionContextHolder$stable = 8;
  androidx_compose_runtime_LinkComposer$stable = 8;
  androidx_compose_runtime_LinkRememberObserverHolder$stable = 8;
  androidx_compose_runtime_ReusableLinkRememberObserverHolder$stable = 8;
  androidx_compose_runtime_LinkCompositionDataImpl$stable = 8;
  Key_instance_2 = new Key_0();
  androidx_compose_runtime_MovableContent$stable = 0;
  androidx_compose_runtime_MovableContentStateReference$stable = 8;
  androidx_compose_runtime_MovableContentState$stable = 0;
  androidx_compose_runtime_NextFrameEndCallbackQueue$stable = 8;
  androidx_compose_runtime_OpaqueKey$stable = 0;
  androidx_compose_runtime_PausedCompositionImpl$stable = 8;
  androidx_compose_runtime_RecordingApplier$stable = 8;
  Companion_instance_5 = new Companion_4();
  androidx_compose_runtime_PausableMonotonicFrameClock$stable = 8;
  androidx_compose_runtime_RecomposeScopeImpl$stable = 8;
  Companion_instance_6 = new Companion_5();
  androidx_compose_runtime_SnapshotMutableDoubleStateImpl$stable = 0;
  androidx_compose_runtime_SnapshotMutableFloatStateImpl$stable = 0;
  androidx_compose_runtime_SnapshotFlowManager$stable = 8;
  androidx_compose_runtime_SnapshotFlowManagerImpl$stable = 8;
  androidx_compose_runtime_SnapshotMutableIntStateImpl$stable = 0;
  androidx_compose_runtime_SnapshotMutableLongStateImpl$stable = 0;
  StructuralEqualityPolicy_instance = new StructuralEqualityPolicy();
  NeverEqualPolicy_instance = new NeverEqualPolicy();
  ReferentialEqualityPolicy_instance = new ReferentialEqualityPolicy();
  androidx_compose_runtime_SnapshotMutableStateImpl$stable = 0;
  androidx_compose_runtime_UnboxedIntState$stable = 0;
  androidx_compose_runtime_UnboxedLongState$stable = 0;
  androidx_compose_runtime_UnboxedFloatState$stable = 0;
  androidx_compose_runtime_UnboxedDoubleState$stable = 0;
  androidx_compose_runtime_IntStack$stable = 8;
  androidx_compose_runtime_StaticValueHolder$stable = 0;
  androidx_compose_runtime_LazyValueHolder$stable = 8;
  androidx_compose_runtime_ComputedValueHolder$stable = 0;
  androidx_compose_runtime_DynamicValueHolder$stable = 0;
  androidx_compose_runtime_collection_MutableVector$stable = 8;
  androidx_compose_runtime_collection_ScatterSetWrapper$stable = 8;
  androidx_compose_runtime_composer_DebugStringFormattable$stable = 0;
  androidx_compose_runtime_composer_GroupInfo$stable = 8;
  androidx_compose_runtime_composer_ThrowingRememberManagerStub$stable = 0;
  ThrowingRememberManagerStub_instance = new ThrowingRememberManagerStub();
  androidx_compose_runtime_composer_gapbuffer_GapAnchor$stable = 8;
  Companion_instance_9 = new Companion_8();
  androidx_compose_runtime_composer_gapbuffer_changelist_ChangeList$stable = 8;
  androidx_compose_runtime_composer_gapbuffer_changelist_ComposerChangeListWriter$stable = 8;
  Companion_instance_10 = new Companion_9();
  androidx_compose_runtime_composer_gapbuffer_changelist_FixupList$stable = 8;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_Ups$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_Downs$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_AdvanceSlotsBy$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_SideEffect$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_Remember$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_RememberPausingScope$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_StartResumingScope$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EndResumingScope$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_AppendValue$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_TrimParentValues$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UpdateValue$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UpdateAnchoredValue$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UpdateAuxData$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EnsureRootGroupStarted$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EnsureGroupStarted$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_RemoveCurrentGroup$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_MoveCurrentGroup$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EndCurrentGroup$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_SkipToEndOfCurrentGroup$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EndCompositionScope$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UseCurrentNode$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_UpdateNode$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_RemoveNode$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_MoveNode$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_InsertSlots$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_InsertSlotsWithFixups$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_InsertNodeFixup$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_PostInsertNodeFixup$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_DeactivateCurrentGroup$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_ResetSlots$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_DetermineMovableContentNodeIndex$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_CopyNodesToNewAnchorLocation$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_CopySlotTableToAnchorLocation$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_EndMovableContentPlacement$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_ReleaseMovableGroupAtCurrent$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_ApplyChangeList$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation_TestOperation$stable = 8;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operation$stable = 0;
  androidx_compose_runtime_composer_gapbuffer_changelist_Operations$stable = 8;
  androidx_compose_runtime_composer_gapbuffer_changelist_OperationsDebugStringFormattable$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_GroupFlagsSpec$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_KeyInfo$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_LinkGroupSourceInformation$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_SlotTable$stable = 8;
  Companion_instance_11 = new Companion_10();
  androidx_compose_runtime_composer_linkbuffer_SlotTableBuilder$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_BuilderTraceBuilder$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_SlotTableEditor$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_EditorTraceBuilder$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_SlotTableReader$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_ReaderTraceBuilder$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_changelist_ChangeList$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_changelist_ComposerChangeListWriter$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_changelist_FixupList$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_Ups$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_Downs$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_SeekToAnchor$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_SeekToGroupHandle$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_StartGroup$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_SkipGroup$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_SideEffect$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_Remember$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_RememberPausingScope$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_StartResumingScope$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_EndResumingScope$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_AppendValue$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_RemoveTailGroupsAndValues$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateValue$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateRememberObserverHolderOrdering$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateValueRelative$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateAuxData$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_RemoveGroup$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_MoveGroup$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_ClearAllRecompositionRequired$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_EndCompositionScope$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UseCurrentNode$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_UpdateNode$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_RemoveNode$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_MoveNode$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_InsertSlots$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_InsertSlotsWithFixups$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_InsertNodeFixup$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_InsertNodeFixupByAnchor$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_PostInsertNodeFixup$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_PostInsertNodeFixupByAnchor$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_DeactivateGroup$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_ResetSlots$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_DetermineMovableContentNodeIndex$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_CopyNodesToNewAnchorLocation$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_EndMovableContentPlacement$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_CopySlotTableToHandleLocation$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_ReleaseMovableGroup$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_DisposeMovableContentState$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_ApplyChangeList$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation_TestOperation$stable = 8;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operation$stable = 0;
  androidx_compose_runtime_composer_linkbuffer_changelist_Operations$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_adapters_ImmutableCollectionAdapter$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_adapters_ImmutableListAdapter$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_adapters_ImmutableSetAdapter$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_adapters_ImmutableMapAdapter$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_AbstractListIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_SingleElementListIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_AbstractPersistentList$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_BufferIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_PersistentVector$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_PersistentVectorBuilder$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_PersistentVectorIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_PersistentVectorMutableIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_SmallPersistentVector$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_TrieIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableList_ObjectRef$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMap$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilder$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeMutableEntriesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderBaseIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderEntriesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderKeysIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderValuesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_AbstractMapBuilderEntries$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderEntries$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderKeys$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBuilderValues$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeBaseIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeKeysIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeValuesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNodeEntriesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_MapEntry$stable = 0;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapBaseIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapEntriesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapKeysIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapValuesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapEntries$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapKeys$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_PersistentHashMapValues$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNode_ModificationResult$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableMap_TrieNode$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_PersistentHashSet$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_PersistentHashSetBuilder$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_PersistentHashSetIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_TrieNodeIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_PersistentHashSetMutableIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_immutableSet_TrieNode$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_LinkedValue$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMap$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilder$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderLinksIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderEntriesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderKeysIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderValuesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderEntries$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderKeys$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapBuilderValues$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapLinksIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapEntriesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapKeysIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapValuesIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapEntries$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapKeys$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedMap_PersistentOrderedMapValues$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_Links$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_PersistentOrderedSet$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_PersistentOrderedSetBuilder$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_PersistentOrderedSetIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_implementations_persistentOrderedSet_PersistentOrderedSetMutableIterator$stable = 8;
  androidx_compose_runtime_external_kotlinx_collections_immutable_internal_EndOfChain$stable = 0;
  EndOfChain_instance = new EndOfChain();
  androidx_compose_runtime_external_kotlinx_collections_immutable_internal_ListImplementation$stable = 0;
  ListImplementation_instance = new ListImplementation();
  androidx_compose_runtime_external_kotlinx_collections_immutable_internal_MutabilityOwnership$stable = 0;
  androidx_compose_runtime_external_kotlinx_collections_immutable_internal_DeltaCounter$stable = 8;
  androidx_compose_runtime_internal_AwaiterQueue_Awaiter$stable = 0;
  androidx_compose_runtime_internal_AwaiterQueue$stable = 8;
  androidx_compose_runtime_internal_IntRef$stable = 8;
  androidx_compose_runtime_internal_PersistentCompositionLocalHashMap_Builder$stable = 8;
  androidx_compose_runtime_internal_PersistentCompositionLocalHashMap$stable = 8;
  androidx_compose_runtime_internal_PausedCompositionRemembers$stable = 8;
  androidx_compose_runtime_internal_RememberEventDispatcher$stable = 8;
  Companion_instance_18 = new Companion_17();
  androidx_compose_runtime_snapshots_SnapshotDoubleIndexHeap$stable = 8;
  androidx_compose_runtime_snapshots_SnapshotIdSet$stable = 0;
  androidx_compose_runtime_snapshots_SnapshotStateObserver$stable = 8;
  androidx_compose_runtime_snapshots_SnapshotWeakSet$stable = 8;
  androidx_compose_runtime_snapshots_StateObjectImpl$stable = 8;
  Companion_instance_21 = new Companion_20();
  observers = null;
  androidx_compose_runtime_snapshots_tooling_SnapshotInstanceObservers$stable = 0;
  androidx_compose_runtime_tooling_ComposeStackTrace$stable = 8;
  androidx_compose_runtime_tooling_ComposeStackTraceFrame$stable = 8;
  androidx_compose_runtime_tooling_WriterTraceBuilder$stable = 8;
  androidx_compose_runtime_tooling_ReaderTraceBuilder$stable = 8;
  androidx_compose_runtime_tooling_ComposeStackTraceBuilder$stable = 8;
  androidx_compose_runtime_tooling_ObjectLocation$stable = 0;
  androidx_compose_runtime_tooling_ComposeToolingFlags$stable = 8;
  ComposeToolingFlags_instance = new ComposeToolingFlags();
  Key_instance_3 = new Key_1();
  androidx_compose_runtime_tooling_SourceInformation$stable = 8;
  androidx_compose_runtime_tooling_ParameterSourceInformation$stable = 0;
  androidx_compose_runtime_tooling_LocationSourceInformation$stable = 0;
  androidx_compose_runtime_internal_WeakReference$stable = 8;
  androidx_compose_runtime_snapshots_SnapshotIdArrayBuilder$stable = 8;
  MainThreadId = new Long(-1, -1);
  androidx_compose_runtime_internal_Trace$stable = 0;
  Trace_instance = new Trace();
  androidx_compose_runtime_snapshots_SnapshotStateList$stable = 0;
  androidx_compose_runtime_snapshots_SnapshotStateSet$stable = 0;
  androidx_compose_runtime_TracingContext$stable = 0;
  Key_instance_4 = new Key_2();
  androidx_compose_runtime_internal_AtomicReference$stable = 8;
  androidx_compose_runtime_internal_AtomicInt$stable = 8;
  androidx_compose_runtime_internal_PlatformOptimizedCancellationException$stable = 8;
  androidx_compose_runtime_snapshots_SnapshotContextElementImpl$stable = 0;
  androidx_compose_runtime_tooling_DiagnosticComposeException$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = MutableVector;
  _.$_$.b = composableLambdaInstance;
  _.$_$.c = rememberComposableLambda;
  _.$_$.d = SnapshotMutableState;
  _.$_$.e = SnapshotStateObserver;
  _.$_$.f = get_LocalCompositionErrorContext;
  _.$_$.g = AbstractApplier;
  _.$_$.h = Applier;
  _.$_$.i = BroadcastFrameClock;
  _.$_$.j = ComposeNodeLifecycleCallback;
  _.$_$.k = CompositionLocalProvider_0;
  _.$_$.l = CompositionLocalProvider;
  _.$_$.m = CompositionLocalProvider_1;
  _.$_$.n = Composition;
  _.$_$.o = DisposableEffect_1;
  _.$_$.p = DisposableEffect;
  _.$_$.q = DisposableEffect_0;
  _.$_$.r = LaunchedEffect;
  _.$_$.s = LaunchedEffect_0;
  _.$_$.t = LaunchedEffect_1;
  _.$_$.u = get_LocalHostDefaultProvider;
  _.$_$.v = MutableState;
  _.$_$.w = PausableComposition_0;
  _.$_$.x = PausableComposition;
  _.$_$.y = ProduceStateScope;
  _.$_$.z = Recomposer;
  _.$_$.a1 = RememberObserver;
  _.$_$.b1 = ReusableComposition;
  _.$_$.c1 = ShouldPauseCallback;
  _.$_$.d1 = SideEffect;
  _.$_$.e1 = SnapshotMutationPolicy;
  _.$_$.f1 = androidx_compose_runtime_ProvidedValue$stableprop_getter;
  _.$_$.g1 = collectAsState_0;
  _.$_$.h1 = collectAsState;
  _.$_$.i1 = compositionLocalOf;
  _.$_$.j1 = compositionLocalWithComputedDefaultOf;
  _.$_$.k1 = createCompositionCoroutineScope;
  _.$_$.l1 = get_currentCompositeKeyHashCode;
  _.$_$.m1 = get_currentCompositionLocalContext;
  _.$_$.n1 = get_currentRecomposeScope;
  _.$_$.o1 = derivedStateOf_0;
  _.$_$.p1 = derivedStateOf;
  _.$_$.q1 = identityHashCode;
  _.$_$.r1 = invalidApplier;
  _.$_$.s1 = isTraceInProgress;
  _.$_$.t1 = movableContentOf;
  _.$_$.u1 = movableContentOf_0;
  _.$_$.v1 = mutableFloatStateOf;
  _.$_$.w1 = mutableIntStateOf;
  _.$_$.x1 = mutableLongStateOf;
  _.$_$.y1 = mutableStateListOf;
  _.$_$.z1 = mutableStateListOf_0;
  _.$_$.a2 = mutableStateMapOf;
  _.$_$.b2 = mutableStateOf;
  _.$_$.c2 = neverEqualPolicy;
  _.$_$.d2 = produceState;
  _.$_$.e2 = referentialEqualityPolicy;
  _.$_$.f2 = rememberCompositionContext;
  _.$_$.g2 = rememberUpdatedState;
  _.$_$.h2 = snapshotFlow;
  _.$_$.i2 = sourceInformationMarkerEnd;
  _.$_$.j2 = sourceInformationMarkerStart;
  _.$_$.k2 = sourceInformation;
  _.$_$.l2 = staticCompositionLocalOf;
  _.$_$.m2 = structuralEqualityPolicy;
  _.$_$.n2 = toMutableStateList;
  _.$_$.o2 = traceEventEnd;
  _.$_$.p2 = traceEventStart;
  _.$_$.q2 = updateChangedFlags;
  _.$_$.r2 = _Updater___init__impl__rbfxm8;
  _.$_$.s2 = Updater__reconcile_impl_1mfi6g;
  _.$_$.t2 = Updater__set_impl_v7kwss;
  _.$_$.u2 = Companion_instance_18;
  _.$_$.v2 = ComposeToolingFlags_instance;
  _.$_$.w2 = Companion_getInstance_0;
  _.$_$.x2 = Companion_getInstance_1;
  _.$_$.y2 = withFrameMillis;
  _.$_$.z2 = withFrameNanos;
  _.$_$.a3 = SnapshotStateList_init_$Create$;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-compose-runtime-runtime.js.map
